(function() {
    'use strict';
    angular
        .module('strefaKlienta', [
            'ngSanitize',
            'restangular',
            'ui.router',
            'angular-jwt',
            'ngTable',
            'angular-storage',
            'ngFileUpload',
            'ui.bootstrap',
            'ngAnimate',
            '720kb.tooltips',
            'ngclipboard',
            'ngCookies',
            'com.2fdevs.videogular',
            'com.2fdevs.videogular.plugins.controls',
            'com.2fdevs.videogular.plugins.overlayplay',
            'googlechart'
        ]);
})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('duplikatModal', duplikatModal);

    duplikatModal.$inject = ['$uibModal'];

    /* @ngInject */
    function duplikatModal($uibModal) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(numerFaktury, jestDostep){
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/directives/konto/faktury/duplikatModal.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa, uprawnieniaSubUsera, $timeout,
                                      $state) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.uzytkownik = null;
                    vm.numerFaktury = numerFaktury;
                    vm.klient = null;
                    vm.odpowiedziSerwera = [];
                    vm.jestDostep = jestDostep;
                    vm.pola = {
                        typ: 'Zamówienie',
                        tytul: 'Prośba o duplikat faktury',
                        opis: 'Klient prosi o duplikat faktury: ' + numerFaktury,
                        modul: 'STREFA',
                        wersjaEZN: '',
                        wersjaUpdPack: '',
                        idLokalizacji: null,
                        nazwaLokalizacji: '',
                        klientId: null,
                        klientNazwa: '',
                        klientTelefon: '',
                        klientEmail: '',
                        osDoKontaktuNazwa: null,
                        osDoKontaktuTelefon: null,
                        osDoKontaktuEmail: null,
                        status: 'Zgłoszone',
                        nazwaKlienta: '',
                        kodKlienta: null,
                        symbolWydruku: '',
                        klientPlecMezczyzna: '',
                        idPod: null,
                        grupa: null,
                        poradaKrotka: null,
                        dotAplMobilna: false
                    };

                    vm.init = init;
                    vm.modalOk = modalOk;
                    vm.modalClose = modalClose;

                    function init() {
                        uprawnieniaSubUsera.getInfo().then(function(result){
                            vm.klient = result.imie + ' ' + result.nazwisko;
                            vm.uzytkownik = result;
                            vm.pola.klientId = result.id;
                            vm.pola.klientNazwa = result.imie + ' ' + result.nazwisko;
                            vm.pola.klientEmail = result.email;
                            vm.pola.klientTelefon = result.Telefon;
                            vm.pola.klientPlecMezczyzna = result.CzyMezczyzna;

                            vm.pola.osDoKontaktuNazwa = result.imie + ' ' + result.nazwisko;
                            vm.pola.osDoKontaktuEmail = result.email;
                            vm.pola.osDoKontaktuTelefon = result.Telefon;

                            vm.pola.idLokalizacji = result.IdLok;
                        });

                        Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                            if (angular.isDefined(result[0])) {
                                vm.pola.nazwaKlienta = result[0].NazwaKr;
                                vm.pola.kodKlienta = result[0].Kod;
                                vm.pola.idPod = result[0].IdPod;
                            }
                        });
                    }

                    function modalOk() {
                        if(vm.jestDostep === true) {
                            vm.pola.osDoKontaktuNazwa = vm.klient;
                            Restangular.all('zgloszenia/zgloszenia/').post(vm.pola).then(function (result) {
                                vm.wyslano = true;
                                vm.odpowiedziSerwera.push({
                                    typ: 'S',
                                    tekst: 'Prośba o duplikat faktury została wysłana'
                                });

                            }, function (error) {
                                vm.odpowiedziSerwera.push({
                                    typ: 'E',
                                    tekst: 'Nie udało się wysłać prośby o duplikat faktury'
                                });
                            }).then(function () {
                                $timeout(function () {
                                    $uibModalInstance.dismiss('ok');
                                }, 2000);
                            });
                        } else {
                            $state.go('home.subMain.konta_pracownikow');
                            $uibModalInstance.dismiss('cancel');
                        }
                    }

                    function modalClose(result) {
                        $uibModalInstance.dismiss('cancel');
                    }

                },
                controllerAs: 'vmModal',
                size: 'md'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('UmowyUPPDOController', UmowyUPPDOController);

    /** @ngInject */
    function UmowyUPPDOController(lokalizacjaAPI, bootstrapKlasa, $timeout, UmowyResource, Restangular,
                                  uprawnieniaSubUsera, PDFGenUPPDO, daneSubUsera, $q, $state) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.pliki = [];
        vm.dzisiaj = new Date();
        vm.danePodstawowe = {};
        vm.wysylanie = false;
        vm.daneSubUsera = daneSubUsera;
        vm.zalogowany = {};
        vm.ip = null;
        vm.umowaBlob = null;
        vm.najwyzszaZakladka = 1;

        vm.statusy = {
            brak: 'Brak podpisanej umowy',
            wymagaAktualizacji: 'Umowa wymaga aktualizacji',
            aktualna: 'Umowa aktualna',
            zawarta: 'Umowa zawarta',

        };
        vm.umowy = [
            {
                nazwa: 'Umowa powierzenia przetwarzania danych osobowych',
                status: 'Brak podpisanej umowy',

            }
        ];
        vm.schowajZakladki = false;
        vm.zakladka = 1;
        vm.form = {
            klauzulaPDO: false,
            pelnomocnik: null,
            akceptacjaUmowy: false,
            czyUpowazniony: false,
            czyIOD: true,
            potwierdzam: true,
            poprawnoscDanych: false
        };
        vm.iodDane = {
            widoczny: false,
            imie: '',
            nazwisko: '',
            email: ''
        };
        vm.osobaUprawnionaDane = {
            widoczny: false,
            imie: '',
            nazwisko: '',
            email: ''
        };
        vm.pelnomocnik = {
            imie: daneSubUsera.imie,
            nazwisko: daneSubUsera.nazwisko
        };
        vm.validateEmail = validateEmail;
        vm.getStatus = getStatus;
        vm.zmienZakladke = zmienZakladke;
        vm.zmienZakladkeBreadcrumbs = zmienZakladkeBreadcrumbs;
        vm.generujPDF = generujPDF;
        vm.wyslij = wyslij;
        vm.pobierzUmowe = pobierzUmowe;
        vm.wyslijUmowe = wyslijUmowe;
        vm.wyslijDaneKontaktowe = wyslijDaneKontaktowe;
        vm.wyslijUpowaznienie = wyslijUpowaznienie;
        vm.wyslijPDF = wyslijPDF;
        vm.pobiezPlik = pobiezPlik;
        vm.init = init;

        init();

        function init() {
            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                vm.danePodstawowe = result[0];
            });
            uprawnieniaSubUsera.getInfo().then(function (result) {
                vm.zalogowany = result;
            });
            UmowyResource.dajIP().then(function (result) {
                vm.ip = result;
            });

        }

        function validateEmail(email) {
            var re = /^[\w.!#$%&'*+/=?^_`{|}~-]+@[\w.-]+\.\w{2,5}$/;
            return re.test(email);
        }

        function getStatus() {
            return vm.statusy.brak;
        }

        function zmienZakladke(zakladka) {
            vm.schowajZakladki = true;
            if (zakladka === 4) {
                vm.generujPDF();
            }
            $timeout(function () {
                vm.najwyzszaZakladka = zakladka;
                vm.zakladka = zakladka;
                vm.schowajZakladki = false;
            }, 100);

        }

        function zmienZakladkeBreadcrumbs(zakladka) {
            if (zakladka <= vm.najwyzszaZakladka) {
                vm.zmienZakladke(zakladka);
            }
        }

        function generujPDF() {
            vm.pdf = PDFGenUPPDO.generujPDF({
                dzisiaj: vm.dzisiaj, danePodstawowe: vm.danePodstawowe, zalogowany: vm.zalogowany,
                iodDane: vm.iodDane, osobaUprawnionaDane: vm.osobaUprawnionaDane, ip: vm.ip,
                pelnomocnik: vm.pelnomocnik
            });
            vm.pdf.getBlob(function (blob) {
                vm.umowaBlob = blob;
                var file = window.URL.createObjectURL(blob);
                document.getElementById('umowa-preview').src = file;
            });
        }

        function wyslij() {
            vm.wysylanie = true;
            vm.wyslijUmowe().then(function () {
                vm.pobierzUmowe().then(function (umowa) {
                    return $q.all([vm.wyslijDaneKontaktowe(umowa.IdUmow),
                        vm.wyslijUpowaznienie(umowa.IdUmow),
                        vm.wyslijPDF(umowa.IdUmow)])
                }).then(function () {
                    $state.go('home.subMain.umowy', {}, {reload: true});
                }, function () {
                    vm.wysylanie = false;
                });
            }, function () {
                vm.wysylanie = false;
            });
        }

        function pobierzUmowe() {
            return UmowyResource.pobierzUmowy({IdRodzUm: 8}).then(function (result) {
                if (result.length > 0) {
                    return result[0];
                }
                return $timeout(vm.pobierzUmowe(), 1000);
            });
        }

        function wyslijUmowe() {
            return UmowyResource.dodajUmowe({IdRodzUm: 8, IdPrac: 7075});
        }

        function wyslijDaneKontaktowe(idUmow) {
            var params = {IdUmow: idUmow};
            Object.assign(params, {
                PelnomocnikImie: vm.pelnomocnik.imie,
                PelnomocnikNazwisko: vm.pelnomocnik.nazwisko
            });
            if (vm.iodDane.widoczny) {
                Object.assign(params, {
                    IODImie: vm.iodDane.imie,
                    IODNazwisko: vm.iodDane.nazwisko,
                    IODEmail: vm.iodDane.email
                });
            }
            if (vm.osobaUprawnionaDane.widoczny) {
                Object.assign(params, {
                    OsDoKontaktuImie: vm.osobaUprawnionaDane.imie,
                    OsDoKontaktuNazwisko: vm.osobaUprawnionaDane.nazwisko,
                    OsDoKontaktuEmail: vm.osobaUprawnionaDane.email
                });
            }
            Object.assign(params, {
                    IdPod: vm.danePodstawowe.IdPod,
                    Kod: vm.danePodstawowe.Kod,
                    Nazwa: vm.danePodstawowe.Nazwa
                });
            return UmowyResource.dodajDaneKontaktowe(params);
        }

        function wyslijUpowaznienie(idUmow) {
            return UmowyResource.dodajUpowaznienie(vm.pliki, idUmow);
        }

        function wyslijPDF(idUmow) {
            return UmowyResource.dodajPDFUmowy(vm.umowaBlob, idUmow);
        }

        function pobiezPlik() {
            Restangular.all('/umowy/umowyUpowaznienie/1/get_file').getList();
        }

    }
})();
(function () {
  'use strict';
  angular.module('strefaKlienta')
    .controller('PlatnosciOnlineEKVisaController', PlatnosciOnlineEKVisaController);

  /** @ngInject */
  function PlatnosciOnlineEKVisaController() {
  }
})();
(function () {
  'use strict';
  angular.module('strefaKlienta')
    .controller('PlatnosciOnlineEKPytaniaController', PlatnosciOnlineEKPytaniaController);

  /** @ngInject */
  function PlatnosciOnlineEKPytaniaController($http) {
    var vm = this;

    vm.pytania = [];

    init();

    function init() {
      vm.pytania = $http.get('./assets/platnosciOnlineEKPytania').then(function (result) {
        vm.pytania = result.data;
      })
    }
  }
})();
(function () {
  'use strict';
  angular.module('strefaKlienta')
    .controller('PlatnosciOnlineEKDlaczegoWartoController', PlatnosciOnlineEKDlaczegoWartoController);

  /** @ngInject */
  function PlatnosciOnlineEKDlaczegoWartoController() {
  }
})();
(function () {
  'use strict';
  angular.module('strefaKlienta')
    .controller('PlatnosciOnlineEKInstrukcjaController', PlatnosciOnlineEKInstrukcjaController);

  /** @ngInject */
  function PlatnosciOnlineEKInstrukcjaController($sce, lokalizacjaAPI, $location) {
    var vm = this;
    vm.lektorWlaczony = false;
    vm.videogularApi = null;
    vm.lokalizacjaApi = (lokalizacjaAPI === '/api' && $location.host() !== '192.168.1.183') ? 'https://www.mieszczanin.pl' : 'http://192.168.1.183:1443';
    vm.config = {
      preload: "none",
      sources: getVideoSource(),
      tracks: [
        {
          src: "http://www.videogular.com/assets/subs/pale-blue-dot.vtt",
          kind: "subtitles",
          srclang: "pl",
          label: "Polish",
          default: ""
        }
      ],
      theme: {url: "https://unpkg.com/videogular@2.1.2/dist/themes/default/videogular.css"}
    };

    vm.changeSource = changeSource;
    vm.vgPlayerReady = vgPlayerReady;

    function changeSource(lektor) {
      vm.videogularApi.stop();
      vm.lektorWlaczony = lektor;
      vm.config.sources = getVideoSource();
    }

    function getVideoSource() {
      var nazwaFilmu = "Płatnosci online na e-kartoteka.pl " + (vm.lektorWlaczony ? 'lektor' : 'bez lektora') + '.mp4';

      return [
        {src: $sce.trustAsResourceUrl(vm.lokalizacjaApi + "/assets/files/" + nazwaFilmu), type: "video/mp4"}
      ];
    }

    function vgPlayerReady(API) {
      vm.videogularApi = API;
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('strefaKlienta')
    .filter('trustAsHtml', trustAsHtml);

  /** @ngInject */
  function trustAsHtml($sce) {

    return function (data) {
      return $sce.trustAsHtml(data);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .directive('reklamacjeHistoria', reklamacjeHistoria);

  /** @ngInject */
  function reklamacjeHistoria() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/directives/zgloszenia/reklamacjeHistoria.html',
      scope: {
        idRek: "@"
      },
      controller: ReklamacjeHistoriaController,
      controllerAs: 'vmReklHist',
      bindToController: true
    };

    return directive;


    /** @ngInject */
    function ReklamacjeHistoriaController($scope, zgloszeniaService) {
      var vm = this;
      vm.api = 'reklamacje/szczegoly/';
      vm.requestParams = {
        id_rek: vm.idRek
      };
      //data komentarz status
      vm.columns = [
        {
          fieldName: "DataZmiany",
          title: "Data",
          class: "table-cell-15-width",
          colTemplate: '<span>{{row.DataZmiany | date : "dd.MM.yyyy HH:mm"}}</span>',
          show: true
        },
        {
          fieldName: "Status",
          title: "Status",
          class: "table-cell-10-width",
          colTemplate: '<span style="width: 100%" class="{{vm.runExtFunction(\'status2klasa\',row.Status)}}" ' +
          'ng-bind="vm.runExtFunction(\'liczba2status\',row.Status)"></span>',
          show: true
        },
        {
          fieldName: "Wykonawca",
          title: "Wykonawca",
          class: "table-cell-15-width",
          show: true
        },
        {
          fieldName: "Komentarz",
          title: "Komentarz",
          show: true
        }
      ];
      vm.selectedItem = null;
      vm.liczba2status = zgloszeniaService.liczba2status;
      vm.status2klasa = zgloszeniaService.status2klasa;

    }
  }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .directive('orderZgloszenia', orderZgloszenia);

    /** @ngInject */
    function orderZgloszenia() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/directives/zgloszenia/orderZgloszenia.html',
            scope: {
                pole: "=",
                idLok: "=",
                sortowanie: "=",
                onSelect: "&"
            },
            controller: orderZgloszeniaController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;


        /** @ngInject */
        function orderZgloszeniaController($scope) {
            var vm = this;

            vm.select = select;

            function select() {
              vm.onSelect({IdLok: vm.idLok, pole: vm.pole});
            }
        }
    }
})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('UzupelnienieInformacjiPodKliModal', UzupelnienieInformacjiPodKliModal);

    UzupelnienieInformacjiPodKliModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa', 'potencjalnyKlient'];

    /* @ngInject */
    function UzupelnienieInformacjiPodKliModal($uibModal, Restangular, bootstrapKlasa, zapytanieOfertoweService) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(tokenLink) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/directives/zapytanieOfertowe/uzupelnienieInformacji.modal.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa, security, potencjalnyKlient) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.klient = null;
                    vm.ladowanie = true;
                    vm.zapisywanie = false;

                    vm.zapisz = zapisz;
                    vm.anuluj = anuluj;

                    init();

                    function init() {
                        potencjalnyKlient.dajInformacjeOKliencie(tokenLink).then(function (res) {
                            vm.klient = (res.length > 0) ? Object.assign(res[0], {
                                email_kontakt_handlowy: res[0].email_kontakt_handlowy === null ? res[0].email : res[0].email_kontakt_handlowy,
                                email_powiadomienia_systemowe: res[0].email_powiadomienia_systemowe === null ? res[0].email : res[0].email_powiadomienia_systemowe
                            }) : null;
                            vm.ladowanie = false;
                        });
                    }

                    function zapisz() {
                        vm.zapisywanie = true;

                        var dane = Object.assign(vm.klient,
                            {
                                potwierdzono_dane: true,
                                kor_ulica: vm.klient.adres_kor_taki_jak_siedziby ? vm.klient.ulica : vm.klient.kor_ulica,
                                kor_nr_budynku: vm.klient.adres_kor_taki_jak_siedziby ? vm.klient.nr_budynku : vm.klient.kor_nr_budynku,
                                kor_kod_pocztowy: vm.klient.adres_kor_taki_jak_siedziby ? vm.klient.kod_pocztowy : vm.klient.kor_kod_pocztowy,
                                kor_miejscowosc: vm.klient.adres_kor_taki_jak_siedziby ? vm.klient.miejscowosc : vm.klient.kor_miejscowosc,
                            });
                        potencjalnyKlient.uzupelnijInformacjeOKliencie(tokenLink, dane).then(function (res) {
                            return $uibModalInstance.close(res);
                        });

                    }

                    function anuluj() {
                        return $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'lg'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('PodgladOfertyModal', PodgladOfertyModal);

    PodgladOfertyModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa', 'zapytanieOfertoweService', 'potencjalnyKlient'];

    /* @ngInject */
    function PodgladOfertyModal($uibModal, Restangular, bootstrapKlasa, zapytanieOfertoweService) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(oferta, uzytkownikLubToken, akceptacjaOferty) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/directives/zapytanieOfertowe/podgladOferty.modal.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa, zapytanieOfertoweService,
                                      security, potencjalnyKlient, UzupelnienieInformacjiPodKliModal) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.oferta = oferta;
                    vm.akceptacjaOferty = akceptacjaOferty;
                    vm.zapisywanie = false;
                    vm.potKli = null;
                    vm.security = security;

                    vm.init = init;

                    function init() {
                        if (!security.isLogin()) {
                            potencjalnyKlient.dajInformacjeOKliencie(uzytkownikLubToken).then(function (res) {
                                vm.potKli = (res.length > 0) ? res[0] : null;
                            });
                        }
                    }

                    vm.modalClose = modalClose;
                    vm.zaakceptujOferte = zaakceptujOferte;
                    vm.odrzucOferte = odrzucOferte;
                    vm.uzupelnijDanePotKli = uzupelnijDanePotKli;

                    function zaakceptujOferte() {
                        vm.zapisywanie = true;
                        if (security.isLogin()) {
                            return zapytanieOfertoweService.zaakceptujOferte(oferta.id, uzytkownikLubToken).then(function (res) {
                                return $uibModalInstance.close(res);
                            });
                        } else {
                            potencjalnyKlient.zaakceptujOferte(uzytkownikLubToken, oferta.id).then(function (res) {
                                return $uibModalInstance.close(res);
                            });
                        }
                    }

                    function odrzucOferte() {
                        vm.zapisywanie = true;
                        if (security.isLogin()) {
                            return zapytanieOfertoweService.odrzucOferte(oferta.id, uzytkownikLubToken).then(function (res) {
                                return $uibModalInstance.close(res);
                            });
                        } else {
                            potencjalnyKlient.odrzucOferte(uzytkownikLubToken, oferta.id).then(function (res) {
                                return $uibModalInstance.close(res);
                            });
                        }
                    }
                    function uzupelnijDanePotKli() {
                        UzupelnienieInformacjiPodKliModal.wyswietlModal(uzytkownikLubToken).then(
                            function(res) {
                                init();
                            }
                        );
                    }

                    function modalClose() {
                        return $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'lg'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
  'use strict';

  angular
    .module('strefaKlienta')
    .directive('ofertaPrezentacja', ofertaPrezentacja);

  /** @ngInject */
  function ofertaPrezentacja() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/directives/zapytanieOfertowe/ofertaPrezentacja.html',
      scope: {
        params: "=",
        koszyk: "="
      },
      controller: OfertaPrezentacjaController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function OfertaPrezentacjaController(zapytanieOfertoweService, $state, regulaminyResource) {
      var vm = this;
      vm.kategorie = [
        {nazwa: "Nowy moduł", kategoria: "nowy-modul"},
        {nazwa: "Zmiana limitów", kategoria: "zmiana-limitow"},
        {nazwa: "Aktualizacja", kategoria: "aktualizacja"},
        {nazwa: "Usługi", kategoria: "pakiety-i-uslugi"},
      ];
      vm.kategorieDict = {};
      vm.dajWartosc = dajWartosc;
      vm.pobierzPlik = regulaminyResource.pobierzPlikPoSlugu;

      init();

      function init() {
        angular.forEach(vm.kategorie, function (kategoria) {
          vm.kategorieDict[kategoria.kategoria] = kategoria.nazwa;
        });
      }

      function dajWartosc(el) {
        if (el === 'True' || el === true) {
          return 'Tak';
        }else if(el === 'None' || el === null) {
          return '?';
        } else if(el === 'False' || el === false  ) {
          return 'Nie';
        } else {
          return  el;
        }
      }

    }
  }

})();

/**
 * Created by dp on 15.09.16.
 */
(function () {

    'use strict';

    angular.module('strefaKlienta').factory('ZmienStatusSzkoleniaPopup', zmienStatusSzkoleniaPopup);

    zmienStatusSzkoleniaPopup.$inject = ['$uibModal', 'Restangular', 'anchorScrollSmooth'];

    /* @ngInject */
    function zmienStatusSzkoleniaPopup($uibModal, Restangular, anchorScrollSmooth, bootstrapKlasa) {

        var service = {
            wyswietlInfo: wyswietlInfo
        };

        function wyswietlInfo(zapis) {

            return $uibModal.open({
                templateUrl: 'app/components/directives/szkolenia/zmienStatusPopup.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa) {
                    var vm = this;
                    vm.zapis = zapis;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.wybranyStatus = null;
                    vm.wyslacPowiadomienie = true;
                    vm.statusy = [
                        'niezakwalifikowane',
                        'odwołane',
                        'zrezygnowano',
                        'zaakceptowane',
                        'wpłynęło'
                    ];
                    vm.zamknij = zamknij;
                    vm.zapisz = zapisz;

                    init();

                    function init() {

                    }

                    function zapisz() {
                        return Restangular.one('seminaria/zapisy/'+zapis.id+'/zmien_status').customPOST({
                            status: vm.wybranyStatus,
                            wyslacPowiadomienie: vm.wyslacPowiadomienie
                        }).then(function (result) {
                            zapis.status = vm.wybranyStatus;
                            zapis.wyslano_powiadomienie = vm.wyslacPowiadomienie;
                            return $uibModalInstance.close(result);
                        });
                    }

                    function zamknij() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'md'
            });
        }

        return service;
    }
})();

/**
 * Created by dp on 15.09.16.
 */
(function () {

    'use strict';

    angular.module('strefaKlienta').factory('PrzeniesZapisPopup', przeniesZapisPopup);

    przeniesZapisPopup.$inject = ['$uibModal', 'Restangular', 'anchorScrollSmooth'];

    /* @ngInject */
    function przeniesZapisPopup($uibModal, Restangular, anchorScrollSmooth, bootstrapKlasa) {

        var service = {
            wyswietlInfo: wyswietlInfo
        };

        function wyswietlInfo(zapis) {

            return $uibModal.open({
                templateUrl: 'app/components/directives/szkolenia/przeniesZapisPopup.html',
                controller: function ($uibModalInstance, Restangular) {
                    var vm = this;
                    vm.zapis = zapis;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.dostepneSzkolenia = null;
                    vm.wybraneSzkolenie = null;
                    vm.dzisiaj = new Date();
                    vm.zamknij = zamknij;
                    vm.zapisz = zapisz;
                    vm.zmiana = zmiana;

                    function zmiana() {
                        console.o()
                    }

                    init();

                    function init() {
                        console.log(vm.zapis);
                        Restangular.all('seminaria/szkolenia').getList({
                            dataSzkolenia__gt: vm.dzisiaj,
                            pageSize: 100
                        }).then(function (result) {
                            vm.dostepneSzkolenia = result.filter(function(el) {
                                return el.id !== zapis.daneSzkolenia.id;
                            });
                        });
                    }

                    function zapisz() {
                        return Restangular.one('seminaria/zapisy/'+zapis.id+'/zmien_szkolenie').customPOST({
                            szkolenie: vm.wybraneSzkolenie.id
                        }).then(function (result) {
                            return $uibModalInstance.close(result);
                        });
                    }

                    function zamknij() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'md'
            });
        }

        return service;
    }
})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('UslugiPasywneHasloModal', UslugiPasywneHasloModal);

    UslugiPasywneHasloModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa' ];

    /* @ngInject */
    function UslugiPasywneHasloModal($uibModal, Restangular, bootstrapKlasa ) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(){
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/directives/uslugiPasywne/konto.uslugiPasywne.zmienHaslo.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.haslo = "";
                    vm.powt_haslo = "";
                    vm.modalOk = modalOk;
                    vm.modalClose = modalClose;


                    function modalOk(result) {
                        if(vm.haslo === vm.powt_haslo) {
                            return Restangular.all('/uslugiPasywne/uslugiPasywne/zmien_haslo/').post({haslo:vm.haslo}).then(
                                function(result) {
                                    return $uibModalInstance.dismiss('Hasło zostało zmienione');
                                }, function(err) {

                                })
                        }
                    }

                    function modalClose(result) {
                        return $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'md'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('promocjeSkorzystajModal', promocjeSkorzystajModal);

    promocjeSkorzystajModal.$inject = ['$uibModal', 'bootstrapKlasa' ];

    /* @ngInject */
    function promocjeSkorzystajModal($uibModal, bootstrapKlasa ) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(typ, tresc){
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/directives/promocje/promocje.skorzystaj.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.typ = typ;
                    vm.tresc = tresc;
                    
                    vm.modalOk = modalOk;

                    function modalOk() {
                      return $uibModalInstance.close();
                    }
                },
                controllerAs: 'vmModal',
                size: 'md'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .directive('promocjeDropdown', promocjeDropdown);

    /** @ngInject */
    function promocjeDropdown() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/directives/promocje/promocje.dropdown.html',
            scope: {
                opcja: "=",
                wersje: "=",
            },
            controller: promocjeDropdownController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;


        /** @ngInject */
        function promocjeDropdownController() {
            var vm = this;

            vm.wersja = null;
            vm.zaznaczone = vm.opcja.wartosc;
            vm.opcjeSelect = [
                {tekst: '-', wartosc: null},
                {tekst: 'Dla klientów nie posiadających ' + (vm.opcja.ezn ? 'program' : 'usługi'), wartosc: 0},
                {tekst: 'Dla klientów posiadających ' + (vm.opcja.ezn ? 'program' : 'usługę'), wartosc: 1},
                {tekst: 'Dla klientów posiadających program w konkretnej wersji', wartosc: 11, disabled: !vm.opcja.ezn}];

            vm.select = select;
            vm.init = init;
            vm.selectWersja = selectWersja;

            init();

            function init() {
                if (vm.opcja.wartosc !== null && vm.opcja.wartosc !== 0 && vm.opcja.wartosc !== 1){
                    vm.zaznaczone = 11;
                    vm.wersja = vm.opcja.wartosc;
                }
            }


            function select() {
                vm.opcja.wartosc = vm.zaznaczone;
                vm.wersja = null;
            }

            function selectWersja() {
                vm.opcja.wartosc = vm.wersja;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .directive('prezentacjaPowiadomien', prezentacjaPowiadomien);

    /** @ngInject */
    function prezentacjaPowiadomien() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/directives/powiadomienia/prezentacjaPowiadomien.html',
            scope: {
                typyObiektow: "="
            },
            controller: prezentacjaPowiadomienController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;


        /** @ngInject */
        function prezentacjaPowiadomienController($scope, $state, security, PowiadomieniaResource) {
            var vm = this;
            vm.czyAdmin = security.jestPracownikiemMieszczanin() === true;
            vm.powiadomienia = [];

            vm.usunPowiadomienie = usunPowiadomienie;


            init();

            function init() {
                PowiadomieniaResource.pobierzPowiadomienia(
                    {obiekt: vm.typyObiektow !== null && vm.typyObiektow !== undefined ? vm.typyObiektow.join(',') : null}).then(
                        function (result) {
                    vm.powiadomienia = result;
                });
            }

            function usunPowiadomienie(id) {
                PowiadomieniaResource.usunPowiadomienie(id).then(function () {
                    $state.reload();
                });
            }
        }
    }
})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('NowePowiadomienieModal', NowePowiadomienieModal);

    NowePowiadomienieModal.$inject = ['$uibModal'];

    /* @ngInject */
    function NowePowiadomienieModal($uibModal) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(obiekt) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/directives/powiadomienia/nowePowiadomienie.modal.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa, PowiadomieniaResource) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.wiadomosc = "";
                    vm.tytul = "Uwaga";

                    vm.zamknijModal = zamknijModal;
                    vm.dodajWiadomosc = dodajWiadomosc;

                    function dodajWiadomosc() {
                        vm.zapisywanie = true;
                        return PowiadomieniaResource.dodajPowiadomienie({
                            wiadomosc: vm.wiadomosc && vm.wiadomosc.length > 0 ? vm.wiadomosc : null,
                            obiekt: obiekt,
                            tytul: vm.tytul && vm.tytul.length > 0 ? vm.tytul : 'Uwaga'
                        }).then(function (res) {
                            return $uibModalInstance.close(res);
                        });
                    }

                    function zamknijModal() {
                        return $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'lg'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {

  angular.module('strefaKlienta').factory('pobieraniePlikow', pobieraniePlikow);

  pobieraniePlikow.$inject = ['$uibModal', 'security', '$http', '$window', 'lokalizacjaAPI', 'bootstrapKlasa' ];

  /* @ngInject */
  function pobieraniePlikow($uibModal, security, $http, $window, lokalizacjaAPI, bootstrapKlasa ) {

    var service = {
      wyswietlModal: wyswietlModal
    };

    function wyswietlModal(api, item){
      if(item.nazwaPliku.match(/.(jpg|jpeg|png|gif)$/i)) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/components/directives/pobieraniePlikow/pobieraniePlikow.html',
          controller: function ($uibModalInstance, $http, $window, lokalizacjaAPI, bootstrapKlasa) {
            var vm = this;
            vm.item = item;
            vm.bootstrapKlasa = bootstrapKlasa;
            vm.imgURL = '';
            vm.item.konsultantNazwa = null;
            vm.uzytkownicy = [];
            vm.pracownik = null;
            vm.komentarzWew = null;
            vm.modalOk = modalOk;
            vm.modalClose = modalClose;
            vm.init = init;
            vm.download = download;

            function init() {
              $http({
                method: 'GET',
                url: lokalizacjaAPI + api + vm.item.id + '/file/',
                responseType: "blob"
              }).success(function(result) {
                var blob = new Blob([result],
                  {type: 'image/jpeg'});
                vm.imgURL = URL.createObjectURL(blob);
              });
            }
            function modalOk(result) {
              $uibModalInstance.close(result);
            }

            function modalClose(result) {
              $uibModalInstance.dismiss('cancel');
            }
            function download() {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                $http({
                    method: 'GET',
                    url: lokalizacjaAPI + api + item.id + '/file/',
                    responseType: "blob"
                }).success(function(result) {
                    var blob = new Blob([result],
                        { type: 'octet/stream'});
                    var url = URL.createObjectURL(blob);
                    a.href = url;
                    a.download = item.nazwaPliku;
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            }
          },
          controllerAs: 'vmModal',
          size: 'md'
        });

        return modalInstance.result;
      } else {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          $http({
              method: 'GET',
              url: lokalizacjaAPI + api + item.id + '/file/',
              responseType: "blob"
          }).success(function(result) {
              var blob = new Blob([result],
                  { type: 'octet/stream'});
              var url = URL.createObjectURL(blob);
              a.href = url;
              a.download = item.nazwaPliku;
              a.click();
              navigator.msSaveBlob(blob, item.nazwaPliku);
              window.URL.revokeObjectURL(url);
          });
      }
    }

    return service;
  }
})();

(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .directive('pdfPrezentacja', pdfPrezentacja);

    /** @ngInject */
    function pdfPrezentacja() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/directives/pdfPrezentacja/pdfPrezentacja.html',
            scope: {
                plik: "=",
                downloadUrl: "=",
            },
            controller: PDFPrezentacjaController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function PDFPrezentacjaController(pobieraniePlikow, lokalizacjaAPI, viewerPDFService) {
            var vm = this;
            vm.lokalizacjaAPI = lokalizacjaAPI;
            vm.viewer = viewerPDFService.Instance("viewer");
            vm.pokazOferte = false;
            vm.pobierz = pobierz;
            vm.nextPage = nextPage;
            vm.prevPage = prevPage;
            vm.pageLoadProgress = pageLoadProgress;
            vm.pageLoaded = pageLoaded;

            function pobierz() {
                pobieraniePlikow.wyswietlModal(vm.downloadUrl, vm.plik);
            }

            function nextPage() {
                return vm.viewer.nextPage();
            }

            function prevPage() {
                return vm.viewer.prevPage();
            }

            function pageLoadProgress(state, loaded, total) {
                if (state === 'error') {
                    pobierz();
                    vm.plik.progress = 0;
                }
                if (state === 'loading') {
                    vm.plik.progress = loaded / total * 100;
                }
                if (state === 'finished') {
                    vm.plik.progress = 0;
                }
                return state;
            }

            function pageLoaded(curPage, totalPages) {
                vm.plik.currentPage = curPage;
                vm.plik.totalPages = totalPages;
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .directive('ocenaGwiazdki', ocenaGwiazdki);

    /** @ngInject */
    function ocenaGwiazdki() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/directives/ocenaGwiazdki/ocenaGwiazdki.html',
            scope: {
                ocena: "=",
                onChange: "&"
            },
            controller: ocenaGwiazdkiController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;


        /** @ngInject */
        function ocenaGwiazdkiController() {
            var vm = this;
            vm.oceny = [1,2,3,4,5,6];
            vm.hover = 0;

            vm.zaznacz = zaznacz;

            function zaznacz(zaznaczonaOcena) {
                vm.ocena = zaznaczonaOcena;
                if(vm.onChange) {
                    vm.onChange({zaznaczonaOcena: zaznaczonaOcena});
                }
            }
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("strefaKlienta")
    .factory("lokalizacjeResource", lokalizacjeResource);

  /* @ngInject */
  function lokalizacjeResource(Restangular, $q, security) {
    var lokalizacjeInfo = {
      lokalizacje: [],
      sumaDoWyceny: 0,
      liczbaZarzadzanychLokali: 0,
    };

    var resource = {
      lokalizacjeInfo: lokalizacjeInfo,
      pobierzLokalizacje: pobierzLokalizacje,
      czySaLokaleIBlokady: czySaLokaleIBlokady,
    };

    function pobierzLokalizacje() {
      return Restangular.all("lokalizacje/lokalizacje/")
        .getList({ pageSize: 100, page: 1, idUsr: security.getIdUsr() })
        .then(function (result) {
          lokalizacjeInfo.lokalizacje = result;
          lokalizacjeInfo.sumaDoWyceny = result.reduce(function (sum, el) {
            return sum + el.do_wyceny;
          }, 0);
          lokalizacjeInfo.liczbaZarzadzanychLokali = result.reduce(function (
            sum,
            el
          ) {
            return el.LiczbaLokKth ? sum + el.LiczbaLokKth : sum;
          },
          0);
        });
    }

    function czySaLokaleIBlokady() {
      return Restangular.all("lokalizacje/lokaleIBlokady/")
        .getList({ pageSize: 100, page: 1, idUsr: security.getIdUsr() })
        .then(function (result) {
          return result[0];
        });
    }

    return resource;
  }
})();

(function () {
  'use strict';
  angular.module('strefaKlienta').factory('kontoPowiadomienModal', kontoPowiadomienModal);

  kontoPowiadomienModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa' ];

  /* @ngInject */
  function kontoPowiadomienModal($uibModal, Restangular, bootstrapKlasa ) {

    var service = {
      wyswietlModal: wyswietlModal
    };

    function wyswietlModal(kontoPowiadomien, start, naglowek, liczbaMaili){
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/directives/kontoPowiadomien/konto.kontoPowiadomien.html',
        controller: function ($uibModalInstance, Restangular, bootstrapKlasa) {
          var vm = this;
          vm.liczbaMaili = (liczbaMaili>0) ? liczbaMaili : 0;
          vm.kontoPowiadomien = kontoPowiadomien;
          vm.bootstrapKlasa = bootstrapKlasa;
          vm.bledy = [];
          vm.start = start;
          vm.naglowek = naglowek;
          vm.kontoPowiadomien = kontoPowiadomien || {
            Adres: '',
            Imie: '',
            Nazwisko: ''
          };
          vm.modalOk = modalOk;
          vm.modalClose = modalClose;
          vm.usunKontoPowiadomien = usunKontoPowiadomien;
          init();

          function init() {
            //Jak nie ma żadnego maila weż domyślnie z głownej lokalizacji
            if (!vm.kontoPowiadomien.Adres && start) {
              Restangular.all('licencje/lokalizacje/').getList().then(
                function(results) {
                  angular.forEach(results, function (lokalizacja) {
                    if (lokalizacja.NrLok === 0) {
                      vm.kontoPowiadomien.Adres = lokalizacja.AdresEmail
                    }
                  })
                } ,
                function(error) {
                });
            }
          }

          function modalOk(result) {
            return $uibModalInstance.close(result);
          }

          function usunKontoPowiadomien(result) {
            result.usun = true;
            return $uibModalInstance.close(result);
          }

          function modalClose() {
            return $uibModalInstance.dismiss('cancel');
          }
        },
        controllerAs: 'vmModal',
        size: 'md'
      });

      return modalInstance.result;
    }

    return service;
  }
})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('legendaUprawnienPracownikowModal', legendaUprawnienPracownikowModal);

    legendaUprawnienPracownikowModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa' ];

    /* @ngInject */
    function legendaUprawnienPracownikowModal($uibModal, Restangular, bootstrapKlasa ) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(){
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/directives/kontaPracownikow/legendaUprawnien.html',
                controller: function ($uibModalInstance, bootstrapKlasa) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;

                    vm.modalClose = modalClose;

                    function modalClose(result) {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'md'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('kontaPracownikowModal', kontaPracownikowModal);

    kontaPracownikowModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa' ];

    /* @ngInject */
    function kontaPracownikowModal($uibModal, Restangular, bootstrapKlasa ) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(konto, uzytkownik, lokalizacje){
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/directives/kontaPracownikow/konto.kontaPracownikow.nowe.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa) {
                    var vm = this;
                    vm.konto = konto;
                    vm.uzytkownik = uzytkownik;
                    vm.lokalizacje = lokalizacje;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.bledy = [];
                    vm.subUser = {
                        nazwa: '',
                        login: '',
                        Telefon: '',
                        depId: uzytkownik.IdPod,
                        email: '',
                        imie: '',
                        nazwisko: '',
                        status: 'Aktywny',
                        typ: 'pracownik',
                        CzyMezczyzna: null,
                        IdLok: null,
                        haslo:null,
                        haslo2:null,
                        Ident:null
                    };
                    vm.init = init;
                    vm.modalOk = modalOk;
                    vm.modalClose = modalClose;

                    function init() {
                      if(angular.isDefined(konto)) {
                          konto.nazwa = konto.nazwa.match(/([^@]+)/g)[0];
                          vm.subUser = Restangular.copy(konto);
                          vm.subUser.login = konto.nazwa.replace('@' + vm.uzytkownik.Skrot.toLowerCase(), '');
                      } else {
                          vm.subUser.IdLok = lokalizacje[0].IdLok;

                      }
                    }

                    function modalOk(result) {
                      if(vm.subUser.haslo === vm.subUser.haslo2) {
                        if(konto == null) {
                            vm.subUser.nazwa = vm.subUser.login + '@' + vm.uzytkownik.Skrot.toLowerCase();  //login subUsera
                            return Restangular.all('/subUser/subUser/').post(vm.subUser).then(function (result) {
                                return $uibModalInstance.close(result);
                            }, function (error) {
                                vm.bledy.push({
                                    typ: 'E',
                                    tekst: 'Podano niepoprawne dane.'
                                });
                            });
                        } else {
                            vm.subUser.nazwa = vm.subUser.nazwa + '@' + vm.uzytkownik.Skrot.toLowerCase();  //login subUsera
                            return vm.subUser.put().then(function (result) {
                              return $uibModalInstance.close(result);
                            });
                        }
                      }
                    }

                    function modalClose(result) {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'md'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
  "use strict";
  angular
    .module("strefaKlienta")
    .factory("szczegolyCenyModal", szczegolyCenyModal);

  szczegolyCenyModal.$inject = [
    "$uibModal",
    "lokalizacjeResource",
    "bootstrapKlasa",
  ];

  /* @ngInject */
  function szczegolyCenyModal($uibModal, lokalizacjeResource, bootstrapKlasa) {
    var service = {
      wyswietlModal: wyswietlModal,
    };

    function wyswietlModal(lokalizacje, blokady) {
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/components/directives/cennikEKIEM/szczegolyLiczbyLokali.modal.html",
        controller: function (
          $uibModalInstance,
          lokalizacjeResource,
          bootstrapKlasa
        ) {
          var vm = this;
          vm.bootstrapKlasa = bootstrapKlasa;
          vm.blokady = blokady;
          vm.lokalizacje = lokalizacje;
          vm.init = init;
          vm.modalClose = modalClose;
          vm.sumaDoWyceny = lokalizacjeResource.lokalizacjeInfo.sumaDoWyceny;

          function init() {}

          function modalClose(result) {
            $uibModalInstance.dismiss("cancel");
          }
        },
        controllerAs: "vm",
        size: "lg",
      });

      return modalInstance.result;
    }

    return service;
  }
})();

(function () {
    "use strict";
  
    angular
      .module("strefaKlienta")
      .directive("opcjaEkiem", opcjaEkiem);
  
    /** @ngInject */
    function opcjaEkiem() {
      var directive = {
        restrict: "EA",
        templateUrl:
          "app/components/directives/cennikEKIEM/opcja.html",
        scope: {
          zaznaczenie: "=",
          id: "=",
          label: "=",
          dodatkowaInformacja: "=",
          disabled: "=",
          onChange: "&",
        },
        controller: opcjaEkiemController,
        controllerAs: "vm",
        bindToController: true,
      };
  
      return directive;
  
      /** @ngInject */
      function opcjaEkiemController($scope) {
        var vm = this;

      }
    }
  })();
  
(function () {
  "use strict";

  angular
    .module("strefaKlienta")
    .directive("liczbaLokaliDropdown", liczbaLokaliDropdown);

  /** @ngInject */
  function liczbaLokaliDropdown() {
    var directive = {
      restrict: "EA",
      templateUrl:
        "app/components/directives/cennikEKIEM/liczbaLokaliDropdown.html",
      scope: {
        slownikCenLimitowLokali: "=",
        zaznaczone: "=",
        onChange: "&",
        disabled: "="
      },
      controller: liczbaLokaliDropdownController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function liczbaLokaliDropdownController(cennikiResource) {
      var vm = this;
      vm.init = init;
      vm.liczbyLokali = [];

      init();
      function init() {
        vm.liczbyLokali = Object.keys(vm.slownikCenLimitowLokali).reduce(
          function (acc, next) {
            if (parseInt(next) >= parseInt(vm.zaznaczone)) {
              acc.push({
                nazwa: "do " + next,
                wartosc: parseInt(next),
                kolejnosc: parseInt(next),
              });
            }
            return acc;
          },
          [
            {
              nazwa: "Powyżej 50.000",
              wartosc: "more50k",
              kolejnosc: 50001,
            },
          ]
        );
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("strefaKlienta").factory("cennikiResource", cennikiResource);

  /* @ngInject */
  function cennikiResource(Restangular, $q) {
    var liczbyOCR = [0, 500, 1000, 2000, 3000, 4000, 5000];
    var liczbySMS = [0, 500, 1000, 2000, 3000, 4000, 5000, 10000];

    function parusjUdzialProcentowyOpcji(opcje) {
      return opcje.map(function (el) {
        if (el.UdzProc !== null) {
          if (el.UdzProc.includes(",")) {
            el.UdzProc = el.UdzProc.split(",").map(function (udz) {
              return parseInt(udz);
            });
          } else {
            el.UdzProc = parseInt(el.UdzProc);
          }
        }
        return el;
      });
    }

    function przygotujObiektOpcji(opcje, aktualneOpcje) {
      return opcje
        .map(function (opcja) {
          var tmp = {};
          tmp[opcja.IdGrupy] = opcja;
          tmp[opcja.IdGrupy].posiadana = dajIdGrupyAktualnychOpcji(
            aktualneOpcje
          ).has(opcja.IdGrupy);
          return tmp;
        })
        .reduce(function (prev, next) {
          return Object.assign(prev, next);
        }, {});
    }

    function pobierzOpcjeEK() {
      return Restangular.all("licencje/opcjeEK")
        .getList({ pageSize: 100 })
        .then(function (opcjeEK) {
          return pobierzAktualneOpcjeEK().then(function (aktualneOpcjeEK) {
            return przygotujObiektOpcji(
              parusjUdzialProcentowyOpcji(opcjeEK),
              aktualneOpcjeEK
            );
          });
        });
    }

    function pobierzOpcjeEM() {
      return Restangular.all("licencje/opcjeEM")
        .getList({ pageSize: 100 })
        .then(function (opcjeEM) {
          return pobierzAktualneOpcjeEM().then(function (aktualneOpcjeEM) {
            return przygotujObiektOpcji(
              parusjUdzialProcentowyOpcji(opcjeEM),
              aktualneOpcjeEM
            );
          });
        });
    }

    function pobierzAktualneOpcjeEK() {
      return Restangular.all("licencje/opcjeKlientaEK")
        .getList({ pageSize: 100 })
        .then(function (result) {
          return result;
        });
    }

    function pobierzAktualneOpcjeEM() {
      return Restangular.all("licencje/opcjeKlientaEM")
        .getList({ pageSize: 100 })
        .then(function (result) {
          return result;
        });
    }

    function dajIdGrupyAktualnychOpcji(opcje) {
      return opcje.reduce(function (acc, opcja) {
        acc.add(opcja.IdGrupy);
        return acc;
      }, new Set());
    }

    function dajGromadzenieDanychKsiegowych() {
      return Restangular.all("licencje/opcjeKlientaEK")
        .getList({ pageSize: 100 })
        .then(function (result) {
          var gd = result.filter(function (opcja) {
            if (opcja.IdGrupy === 13) {
              return opcja;
            }
          });
          return gd.length > 0 ? gd[0].IleLatWstecz || 0 : 0;
        });
    }

    function pobierzLimityLokali() {
      return Restangular.all("licencje/limityLokali")
        .getList({ pageSize: 100 })
        .then(function (result) {
          return result;
        });
    }
    function pobierzLimityLokaliKlienta() {
      return Restangular.all("licencje/limityLokaliKlienta")
        .getList({ pageSize: 100 })
        .then(function (result) {
          return result.reduce(
            function (acc, next) {
              if (
                next.Ograniczenie !== null &&
                next.Ograniczenie !== undefined &&
                next.Ograniczenie > 0
              ) {
                return {
                  LimitLokali: acc.LimitLokali + next.Ograniczenie,
                  KwotaBaz: acc.KwotaBaz + next.KwotaBaz,
                };
              }
              return acc;
            },
            { LimitLokali: 0, KwotaBaz: 0 }
          );
        });
    }

    function dajSlownikCenDlaLimitowLokali() {
      return $q
        .all([pobierzLimityLokali(), pobierzLimityLokaliKlienta()])
        .then(function (limity) {
          var ret = Object.assign(
            {},
            limity[0].reduce(function (acc, next) {
              var tmp = {};
              tmp[next.LimitLokali] = next.KwotaBaz;
              return Object.assign(acc, tmp);
            }, {}),
            (function () {
              var tmp = {};
              tmp[limity[1].LimitLokali] = limity[1].KwotaBaz;
              return tmp;
            })()
          );
          return ret;
        });
    }

    function dajModyfikatorGromadzeniaDanychKsiegowych(
      daneKsiegowe,
      modyfikatoryCen
    ) {
      switch (daneKsiegowe) {
        case 3:
          return modyfikatoryCen[0];
          break;
        case 5:
          return modyfikatoryCen[1];
          break;
        case "bez ograniczeń":
          return modyfikatoryCen[2];
          break;
        default:
          return 0;
      }
    }

    function wyliczCeneOpcjiEk(
      cenaBazowa,
      opcjeEk,
      gromadzenieDanychKsiegowych
    ) {
      return Object.keys(opcjeEk).reduce(function (acc, IdGrupy) {
        if (
          opcjeEk[IdGrupy].Opcja === "D" &&
          opcjeEk[IdGrupy].UdzProc !== null &&
          opcjeEk[IdGrupy].posiadana === true
        ) {
          if (IdGrupy == "13") {
            acc +=
              (cenaBazowa *
                dajModyfikatorGromadzeniaDanychKsiegowych(
                  gromadzenieDanychKsiegowych,
                  opcjeEk[IdGrupy].UdzProc
                )) /
              100;
          } else {
            acc += (cenaBazowa * opcjeEk[IdGrupy].UdzProc) / 100;
          }
        }
        return acc;
      }, 0);
    }
    function wyliczCeneOpcjiEm(cenaBazowa, opcjeEm, dodatkoweOpcjeEm) {
      return Object.keys(opcjeEm).reduce(function (acc, IdGrupy) {
        if (
          opcjeEm[IdGrupy].Opcja === "D" &&
          opcjeEm[IdGrupy].UdzProc !== null &&
          opcjeEm[IdGrupy].posiadana === true
        ) {
          acc += (cenaBazowa * opcjeEm[IdGrupy].UdzProc) / 100;
        }
        return acc;
      }, 0);
    }

    function checkedHtml() {
      return '<i class="fa fa-check-square" aria-hidden="true"></i>';
    }

    function uncheckedHtml() {
      return '<i class="fa fa-square-o" aria-hidden="true" ></i>';
    }

    function arrowRight() {
      return '<i class="fa fa-long-arrow-right" aria-hidden="true"></i>';
    }

    function zaznaczenie(pole) {
      return pole ? checkedHtml() : uncheckedHtml();
    }

    function zmianaZaznaczenia(przed, po) {
      if (przed !== po) {
        if (po) {
          return uncheckedHtml() + " " + arrowRight() + " " + checkedHtml();
        }
        return checkedHtml() + " " + arrowRight() + " " + uncheckedHtml();
      }
      return przed + " " + arrowRight() + " " + po;
    }

    function joinOpis(tablica, bezKoncaLinii) {
      return bezKoncaLinii ? tablica.join(" ") : tablica.join(" ") + "<br>";
    }

    function opisDanychPlatnika(danePlatnika, uzupelnioneDanePlatnika) {
      var opis = joinOpis([
        "<b>Dane płatnika uzupełnione automatycznie:</b><br>",
        joinOpis(["Firma:", danePlatnika.Nazwa]),
        joinOpis([
          "Miejscowość:",
          danePlatnika.KodPocztowy,
          danePlatnika.Miasto,
        ]),
        joinOpis(["ulica:", danePlatnika.Ulica]),
        joinOpis(["nr. budynku:", danePlatnika.Numer]),
        joinOpis(["NIP:", danePlatnika.Nip]),
        danePlatnika.Regon ? joinOpis(["REGON:", danePlatnika.Regon]) : "",
        "<br><b>Dane płatnika uzupełnione przez klienta:</b><br>",
        joinOpis(["Firma:", uzupelnioneDanePlatnika.nazwaFirmy]),
        joinOpis([
          "Miejscowość:",
          uzupelnioneDanePlatnika.kodPocztowy,
          uzupelnioneDanePlatnika.miejscowosc,
        ]),
        joinOpis(["ulica:", uzupelnioneDanePlatnika.ulica]),
        joinOpis(["nr. budynku:", uzupelnioneDanePlatnika.nrBudynku]),
        uzupelnioneDanePlatnika.nrLokalu !== null
          ? joinOpis(["nr. lokalu:", uzupelnioneDanePlatnika.nrLokalu])
          : "",
        joinOpis(["NIP:", uzupelnioneDanePlatnika.NIP]),
        uzupelnioneDanePlatnika.REGON
          ? joinOpis(["REGON:", uzupelnioneDanePlatnika.REGON])
          : "",
      ]);
      return opis;
    }

    function opisIlosciLokali(aktualneLokale, noweLokale, czyZarzadzaLokalami) {
      if (!czyZarzadzaLokalami) {
        return "<b>Lokale:</b> " + "Nie zarządza lokalami" + "<br>";
      }
      if (aktualneLokale !== noweLokale) {
        return joinOpis([
          "<b>Lokale:</b> ",
          aktualneLokale,
          arrowRight(),
          noweLokale,
        ]);
      }
      return "<b>Lokale:</b> " + noweLokale + "<br>";
    }

    function opisOpcjiEK(opcjeEK, dodatkoweOpcjeEK, czyZarzadzaLokalami) {
      if (!czyZarzadzaLokalami) {
        return "";
      }

      return Object.keys(opcjeEK).reduce(function (acc, IdGrupy) {
        if (IdGrupy == "13") {
          if (opcjeEK[IdGrupy].posiadana && dodatkoweOpcjeEK.daneKsiegowe) {
            return joinOpis([
              acc,
              zaznaczenie(opcjeEK[IdGrupy].posiadana),
              opcjeEK[IdGrupy].Nazwa + ":",
              dodatkoweOpcjeEK.daneKsiegowe,
              [0, 3, 5, "3", "5", "0"].indexOf(
                dodatkoweOpcjeEK.daneKsiegowe
              ) !== -1
                ? "lat"
                : "",
            ]);
          }
        }
        if (
          opcjeEK[IdGrupy].Opcja === "D" &&
          opcjeEK[IdGrupy].UdzProc !== null
        ) {
          return joinOpis([
            acc,
            zaznaczenie(opcjeEK[IdGrupy].posiadana),
            opcjeEK[IdGrupy].Nazwa,
          ]);
        }
        return acc;
      }, "<br><b>Opcje e-kartoteki:</b><br>");
    }

    function opisZmianOpcjiEK(
      posiadaneOpcjeEK,
      wybraneOpcjeEK,
      dodatkoweOpcjeEK,
      czyZarzadzaLokalami
    ) {
      function czasGromadzeniaDanychKsiegowych(czas) {
        return [0, 3, 5, "3", "5", "0"].indexOf(czas) !== -1
          ? czas + " lat"
          : czas;
      }

      if (!czyZarzadzaLokalami) {
        return "";
      }
      return Object.keys(wybraneOpcjeEK).reduce(function (acc, IdGrupy) {
        if (IdGrupy == "13") {
          if (
            wybraneOpcjeEK[IdGrupy].posiadana &&
            dodatkoweOpcjeEK.daneKsiegowe !==
              dodatkoweOpcjeEK.posiadaneDaneKsiegowe
          ) {
            return joinOpis([
              acc,
              czasGromadzeniaDanychKsiegowych(
                dodatkoweOpcjeEK.posiadaneDaneKsiegowe
              ),
              arrowRight(),
              czasGromadzeniaDanychKsiegowych(dodatkoweOpcjeEK.daneKsiegowe),
              wybraneOpcjeEK[IdGrupy].Nazwa,
            ]);
          }
        }
        if (
          wybraneOpcjeEK[IdGrupy].Opcja === "D" &&
          wybraneOpcjeEK[IdGrupy].UdzProc !== null &&
          wybraneOpcjeEK[IdGrupy].posiadana !==
            posiadaneOpcjeEK[IdGrupy].posiadana
        ) {
          return joinOpis([
            acc,
            zmianaZaznaczenia(
              posiadaneOpcjeEK[IdGrupy].posiadana,
              wybraneOpcjeEK[IdGrupy].posiadana
            ),
            wybraneOpcjeEK[IdGrupy].Nazwa,
          ]);
        }
        return acc;
      }, "<br><b>Zmiany w e-kartotece:</b><br>");
    }

    function opisOpcjiEM(opcjeEM, dodatkoweOpcjeEM) {
      return Object.keys(opcjeEM).reduce(function (acc, IdGrupy) {
        if (
          opcjeEM[IdGrupy].Opcja === "D" &&
          opcjeEM[IdGrupy].UdzProc !== null
        ) {
          acc = joinOpis([
            acc,
            zaznaczenie(opcjeEM[IdGrupy].posiadana),
            opcjeEM[IdGrupy].Nazwa,
          ]);

          if (IdGrupy == "50" && dodatkoweOpcjeEM.sms) {
            acc = joinOpis([
              acc,
              checkedHtml(),
              "Wysyłanie SMS"
            ]);
          }
          if (IdGrupy == "43" && dodatkoweOpcjeEM.ocr) {
            acc = joinOpis([
              acc,
              checkedHtml(),
              "OCR"
            ]);
          }
          return acc;
        }
        return acc;
      }, "<br><b>Opcje systemu e-Mieszczanin:</b><br>");
    }

    function opisZmianOpcjiEM(
      posiadaneOpcjeEM,
      wybraneOpcjeEM,
      dodatkoweOpcjeEM
    ) {
      return Object.keys(wybraneOpcjeEM).reduce(function (acc, IdGrupy) {
        if (
          wybraneOpcjeEM[IdGrupy].Opcja === "D" &&
          wybraneOpcjeEM[IdGrupy].UdzProc !== null &&
          wybraneOpcjeEM[IdGrupy].posiadana !==
            posiadaneOpcjeEM[IdGrupy].posiadana
        ) {
          acc += joinOpis([
            zmianaZaznaczenia(
              posiadaneOpcjeEM[IdGrupy].posiadana,
              wybraneOpcjeEM[IdGrupy].posiadana
            ),
            wybraneOpcjeEM[IdGrupy].Nazwa,
          ]);
        }
        if (IdGrupy == "50") {
          if (
            wybraneOpcjeEM[IdGrupy].posiadana &&
            dodatkoweOpcjeEM.sms
          ) {
            acc += joinOpis([
              checkedHtml(),
              "Wysyłanie SMS"
            ]);
          }
        }
        if (IdGrupy == "43") {
          if (
            wybraneOpcjeEM[IdGrupy].posiadana &&
            dodatkoweOpcjeEM.ocr
          ) {
            acc += joinOpis([
              checkedHtml(),
              "OCR",
            ]);
          }
        }
        return acc;
      }, "<br><b>Zmiany w systemie e-Mieszczanin:</b><br>");
    }

    function opisCen(cenaBazowa, cenaEK, cenaEM) {
      return joinOpis([
        "<br><b>Ceny składowe netto</b>: <br>",
        joinOpis(["Cena bazowa:", cenaBazowa, "zł"]),
        joinOpis(["Opcje e-kartoteki:", cenaEK, "zł"]),
        joinOpis(["Opcje e-mieszczanina:", cenaEM, "zł"]),
        joinOpis(["<b>Razem:</b>", cenaBazowa + cenaEK + cenaEM, "zł"]),
      ]);
    }

    function opisCenEM(cenaBazowa, cenaEM) {
      return joinOpis([
        "<br><b>Ceny składowe netto</b>: <br>",
        joinOpis(["Cena bazowa:", cenaBazowa, "zł"]),
        joinOpis(["Opcje e-mieszczanina:", cenaEM, "zł"]),
        joinOpis(["<b>Razem:</b>", cenaBazowa + cenaEM, "zł"]),
      ]);
    }

    function wyslijZamowienie(
      czyZarzadzaLokalami,
      lokalizacja,
      danePodstawowe,
      daneSubUsera,
      uzupelnioneDanePlatnika,
      posiadaneLokale,
      wybraneLokale,
      posiadaneOpcjeEK,
      wybraneOpcjeEK,
      dodatkoweOpcjeEK,
      posiadaneOpcjeEM,
      wybraneOpcjeEM,
      dodatkoweOpcjeEM,
      cenaBazowa,
      cenaEK,
      cenaEM
    ) {
      var opis = czyZarzadzaLokalami
        ? joinOpis([
            opisDanychPlatnika(danePodstawowe, uzupelnioneDanePlatnika),
            opisIlosciLokali(
              posiadaneLokale,
              wybraneLokale,
              czyZarzadzaLokalami
            ),
            opisOpcjiEK(wybraneOpcjeEK, dodatkoweOpcjeEK, czyZarzadzaLokalami),
            opisZmianOpcjiEK(
              posiadaneOpcjeEK,
              wybraneOpcjeEK,
              dodatkoweOpcjeEK,
              czyZarzadzaLokalami
            ),
            opisOpcjiEM(wybraneOpcjeEM, dodatkoweOpcjeEM),
            opisZmianOpcjiEM(
              posiadaneOpcjeEM,
              wybraneOpcjeEM,
              dodatkoweOpcjeEM
            ),
            opisCen(cenaBazowa, cenaEK, cenaEM),
          ])
        : joinOpis([
            opisDanychPlatnika(danePodstawowe, uzupelnioneDanePlatnika),
            opisIlosciLokali(
              posiadaneLokale,
              wybraneLokale,
              czyZarzadzaLokalami
            ),
            opisOpcjiEM(wybraneOpcjeEM, dodatkoweOpcjeEM),
            opisZmianOpcjiEM(
              posiadaneOpcjeEM,
              wybraneOpcjeEM,
              dodatkoweOpcjeEM
            ),
            opisCenEM(cenaBazowa, cenaEM),
          ]);

      var pola = {
        typ: "Zamówienie",
        tytul: czyZarzadzaLokalami
          ? "Zamówienie e-kartoteki i systemu e-Mieszczanin"
          : "zamówienie systemu e-Mieszczanin",
        opis: opis,
        modul: czyZarzadzaLokalami ? "E-KARTOTEKA" : "EMI",
        idLokalizacji: daneSubUsera.IdLok,
        nazwaLokalizacji: lokalizacja.NazwaLok,
        klientId: daneSubUsera.id,
        klientNazwa: daneSubUsera.imie + " " + daneSubUsera.nazwisko,
        klientTelefon: daneSubUsera.Telefon,
        klientEmail: daneSubUsera.email,
        osDoKontaktuNazwa:
          uzupelnioneDanePlatnika.imie + " " + uzupelnioneDanePlatnika.nazwisko,
        osDoKontaktuTelefon: uzupelnioneDanePlatnika.telefonKontaktowy,
        osDoKontaktuEmail: uzupelnioneDanePlatnika.email,
        status: "Zgłoszone",
        nazwaKlienta: danePodstawowe.Nazwa,
        kodKlienta: danePodstawowe.Kod,
        klientPlecMezczyzna: daneSubUsera.CzyMezczyzna,
        idPod: danePodstawowe.IdPod,
        dotAplMobilna: false,
        wyslaneZCennikaEKiEM: true
      };
      return Restangular.all("zgloszenia/zgloszenia/").post(pola);
    }

    var resource = {
      liczbyOCR: liczbyOCR,
      liczbySMS: liczbySMS,
      wyslijZamowienie: wyslijZamowienie,
      pobierzOpcjeEM: pobierzOpcjeEM,
      pobierzOpcjeEK: pobierzOpcjeEK,
      pobierzAktualneOpcjeEK: pobierzAktualneOpcjeEK,
      pobierzAktualneOpcjeEM: pobierzAktualneOpcjeEM,
      dajIdGrupyAktualnychOpcji: dajIdGrupyAktualnychOpcji,
      dajGromadzenieDanychKsiegowych: dajGromadzenieDanychKsiegowych,
      pobierzLimityLokali: pobierzLimityLokali,
      pobierzLimityLokaliKlienta: pobierzLimityLokaliKlienta,
      dajSlownikCenDlaLimitowLokali: dajSlownikCenDlaLimitowLokali,
      wyliczCeneOpcjiEk: wyliczCeneOpcjiEk,
      wyliczCeneOpcjiEm: wyliczCeneOpcjiEm,
    };

    return resource;
  }
})();

(function(){
    angular.module('strefaKlienta')
        .directive('aplikacjaMobilnaEKNavbar',function(){
            return{
                restrict:'E',
                templateUrl:'app/components/directives/aplikacjaMobilnaEK/navbar.aplikacjaMobilnaEK.html',
                controller: AplikacjaMobilnaEKNavbarController,
                controllerAs: "vm",
                bindToController: true
            }
        });

    function AplikacjaMobilnaEKNavbarController($state, $interval){
        var vm = this;
        vm.state = $state;
        vm.stick = false;

        $interval(function() {
            vm.stick = this.pageYOffset >236;
        }, 50)
    }
})();

(function () {
  "use strict";

  angular.module("strefaKlienta").factory("raportBazowy", raportBazowy);

  raportBazowy.$inject = ["$filter", "$q", "security"];

  function raportBazowy($filter, $q, security) {
    var promises = [];
    var docDefinitions = {};
    var service = {
      start: start,
      convertImgToBase64: convertImgToBase64,
      dajNaglowekStopka: dajNaglowekStopka,
    };

    return service;

    function start() {
      promises = [];
      przygotujNaglowekStopke();
      docDefinitions = dajNaglowekStopka();
      return $q.all(promises).then(function () {
        return docDefinitions;
      });
    }

    function dajNaglowekStopka() {
      return {
        pageSize: "A4",
        pageMargins: [60, 80, 60, 60],
        header: function (currentPage, pageCount) {
          return [
            {
              alignment: "left",
              fit: [206, 56],
              margin: [44, 28, 0, 0],
              image: "naglowek",
            },
            {
              table: {
                widths: ["*"],
                body: [[" "], [" "]],
              },
              layout: {
                hLineWidth: function (i, node) {
                  return i === 0 ? 1 : 0;
                },
                vLineWidth: function (i, node) {
                  return 0;
                },
                paddingLeft: function (i) {
                  return 20;
                },
                hLineColor: function (i, node) {
                  return "#002c34";
                },
              },
              margin: [58, 2, 58, 0],
            },
          ];
        },
        footer: function (currentPage, pageCount) {
          return {
            table: {
              widths: ["*", 120, 120],
              body: [
                [
                  { text: " ", fontSize: 1 },
                  { text: " ", fontSize: 1 },
                  { text: " ", fontSize: 1 },
                ],
                [
                  {
                    text: "MIESZCZANIN INFORMATYKA Sp. z o.o.",
                    fontSize: 8,
                    bold: true,
                  },
                  {
                    text: "ul. Modrzewskiego 42",
                    fontSize: 8,
                    alignment: "right",
                  },
                  {
                    text: "tel. +48 32 316 24 65",
                    fontSize: 8,
                    alignment: "right",
                  },
                ],
                [
                  { text: "KRS 0000908468 NIP 2220895448", fontSize: 8 },
                  { text: "41-400 Mysłowice", fontSize: 8, alignment: "right" },
                  {
                    text: "www.mieszczanin.pl",
                    fontSize: 8,
                    alignment: "right",
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return 0;
              },
              paddingLeft: function (i) {
                return 0;
              },
              paddingRight: function (i) {
                return 0;
              },
              hLineColor: function (i, node) {
                return "#002c34";
              },
              vLineColor: function (i, node) {
                return "#002c34";
              },
            },
            margin: [58, 0, 58, 0],
          };
        },
        images: [],
      };
    }

    function przygotujNaglowekStopke() {
      promises.push(
        convertImgToBase64("/assets/images/mlogozpolem.png").then(function (
          obrazek
        ) {
          docDefinitions.images["naglowek"] = obrazek;
        })
      );
      promises.push(
        convertImgToBase64("/assets/images/raportObrazki/stopka.png").then(
          function (obrazek) {
            docDefinitions.images["stopka"] = obrazek;
          }
        )
      );
    }

    function convertImgToBase64(url, outputFormat) {
      var deferred = $q.defer();
      var canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        var dataURL;
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        dataURL = canvas.toDataURL(outputFormat);
        canvas = null;
        deferred.resolve(dataURL);
      };
      img.src = url;
      return deferred.promise;
    }
  }
})();

(function() {

    'use strict';

    angular.module('strefaKlienta').factory('ZgloszenieNaSzkolenieRaport', ZgloszenieNaSzkolenieRaport);


    ZgloszenieNaSzkolenieRaport.$inject = ['$filter', '$q', 'security', 'raportBazowy', 'SzkoleniaResource'];
    /**
     * @param {SzkoleniaResource} SzkoleniaResource
     */
    function ZgloszenieNaSzkolenieRaport($filter, $q, security, raportBazowy, SzkoleniaResource) {
        var service = {
            generujRaport: generujRaport
        };

        return service;

        function generujRaport(szkolenie) {
            var content = przygotujRaport(szkolenie);
            return raportBazowy.start().then(function(res) {
                res = _.assign({}, res, content);
                return res;
            })

        }

        function przygotujRaport(szkolenie) {
            var daty = (szkolenie.dataKoncaSzkolenia!==null && !SzkoleniaResource.czyJednodniowe(szkolenie.dataSzkolenia, szkolenie.dataKoncaSzkolenia))
              ? samaData(szkolenie.dataSzkolenia) + " - " + samaData(szkolenie.dataKoncaSzkolenia)
              : samaData(szkolenie.dataSzkolenia);
            return {
                content: [
                    {text: 'Zgłoszenie na szkolenie', style: 'header',alignment:'center', margin:[0,40,0,20]},
                    {
                        table: {
                            widths: [160, '*'],
                            body: [
                                [{text: 'Temat', margin:[0,10,0,10]}, {text: szkolenie.temat, margin:[0,10,0,10]}],
                                [{text: 'Miejsce', margin:[0,10,0,10]}, {text: szkolenie.miejsce, margin:[0,10,0,10]}],
                                [{text: 'Cena na osobę (bez rabatów)', margin:[0,10,0,10]}, {text: szkolenie.cenaNaOs +' zł netto', margin:[0,10,0,10]}],
                                [{text: 'Data szkolenia', margin:[0,10,0,10]}, {text: daty, margin:[0,10,0,10]}],
                                [{text: 'Termin zapisów', margin:[0,10,0,10]}, {text: samaData(szkolenie.zapisDo), margin:[0,10,0,10]}]
                            ]

                        },
                        layout: {
                            hLineWidth: function(i, node) { return (i === 0 || i === node.table.body.length) ? 0 : 1;},
                            vLineWidth: function(i, node) { return (i === 0 || i === node.table.widths.length) ? 0 : 0; },
                            hLineColor: function(i, node) { return (i === 0 || i === node.table.body.length) ?'grey' :'lightgrey'; },
                            vLineColor: function(i, node) { return (i === 0 || i === node.table.widths.length) ?'grey' :'lightgrey'}
                        }
                    }
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        color: '#2c7880'
                    },
                }
            }
        }

        function samaData(data){
          return $filter('date')(data, 'dd-MM-yyyy')
        }
    }
})();
(function () {

    angular.module('strefaKlienta').factory('listaModulow', listaModulow);

    /* @ngInject */
    function listaModulow() {
        var vm = this;
        vm.moduly = [
            { nazwa: 'Banki - System Płatności Masowych', kod: 'BAN' },
            { nazwa: 'Centrala', kod: 'CEN' },
            { nazwa: 'e-kartoteka', kod: 'E-KARTOTEKA' },
            { nazwa: 'e-mieszczanin', kod: 'EMI' },
            { nazwa: 'System Łatwej Obsługi nieruchomości', kod: 'WSM' },
            { nazwa: 'System Sprzedaży', kod: 'FAK' },
            { nazwa: 'Finanse i Księgowość', kod: 'FIK' },
            { nazwa: 'Kasa', kod: 'KAS' },
            { nazwa: 'Kadry i Płace', kod: 'KIP' },
            { nazwa: 'Magazyn', kod: 'MAG' },
            { nazwa: 'Środki Trwałe', kod: 'SRT' },
            { nazwa: 'System Sprzedaży Wody', kod: 'SSW' },
            { nazwa: 'Nieruchomości - Członkowie - Wkłady', kod: 'WKL' },
            { nazwa: 'Techniczna Obsługa Nieruchomości', kod: 'ZNI' },
            { nazwa: 'Zarządzanie Obiegiem Dokumentów', kod: 'ZWO' },
        ];

        var service = {
            moduly: vm.moduly
        };

        return service;
    }
})();

(function(){
    'use strict';
    angular.module('strefaKlienta')
        .controller('AplikacjaMobilnaEKPomocController', AplikacjaMobilnaEKPomocController);

    /** @ngInject */
    function AplikacjaMobilnaEKPomocController() {
        var vm = this;
    }
})();
(function(){
    'use strict';
    angular.module('strefaKlienta')
        .controller('AplikacjaMobilnaEKJakZaczacController', AplikacjaMobilnaEKJakZaczacController);

    /** @ngInject */
    function AplikacjaMobilnaEKJakZaczacController() {
        var vm = this;
    }
})();
(function(){
    'use strict';
    angular.module('strefaKlienta')
        .controller('AplikacjaMobilnaEKInstrukcjaController', AplikacjaMobilnaEKInstrukcjaController);

    /** @ngInject */
    function AplikacjaMobilnaEKInstrukcjaController() {
        var vm = this;
    }
})();
(function () {
  'use strict';
  angular.module('strefaKlienta')
    .controller('AplikacjaMobilnaEKFAQController', AplikacjaMobilnaEKFAQController);

  /** @ngInject */
  function AplikacjaMobilnaEKFAQController($http) {
    var vm = this;

    vm.pytania = [];

    init();

    function init() {
      vm.pytania = $http.get('./assets/aplikacjaMobilnaEKPytania').then(function (result) {
        vm.pytania = result.data;
      })
    }
  }
})();
(function(){
    'use strict';
    angular.module('strefaKlienta')
        .controller('AplikacjaMobilnaEKDlaMieszkancaController', AplikacjaMobilnaEKDlaMieszkancaController);

    /** @ngInject */
    function AplikacjaMobilnaEKDlaMieszkancaController() {
        var vm = this;
    }
})();
(function(){
    'use strict';
    angular.module('strefaKlienta')
        .controller('AplikacjaMobilnaEKController', AplikacjaMobilnaEKController);

    /** @ngInject */
    function AplikacjaMobilnaEKController($location,$anchorScroll, $sce, lokalizacjaAPI) {
        var vm = this;
        $anchorScroll.yOffset = 140;
        vm.film = 'aplikacja mobilna e-kartoteka video.mp4';
        vm.filmZNapisami = 'aplikacja mobilna e-kartoteka z napisami.mp4';
        vm.lokalizacjaApi = (lokalizacjaAPI === '/api') ? 'https://www.mieszczanin.pl' : 'http://192.168.1.153:9000';
        vm.czyZNapisami = false;
        vm.sourceZNapisami = [
                {
                    src: $sce.trustAsResourceUrl(vm.lokalizacjaApi + "/assets/files/" + vm.filmZNapisami),
                    type: "video/mp4"
                }
            ];
        vm.config = {
            preload: "none",
            sources: [
                {
                    src: $sce.trustAsResourceUrl(vm.lokalizacjaApi + "/assets/files/" + vm.film),
                    type: "video/mp4"
                }
            ],
            tracks: [
                {
                    src: "http://www.videogular.com/assets/subs/pale-blue-dot.vtt",
                    kind: "subtitles",
                    srclang: "en",
                    label: "English",
                    default: ""
                }
            ],
            theme: {
                url: "https://unpkg.com/videogular@2.1.2/dist/themes/default/videogular.css"
            }
        };


        vm.scrollToId = scrollToId;

        function scrollToId(id) {
            $location.hash(id);
            $anchorScroll();
        }

    }
})();
(function () {

        'use strict';

        angular.module('strefaKlienta').factory('zapytanieOfertoweService', zapytanieOfertoweService);

        zapytanieOfertoweService.$inject = ['store', '$rootScope', 'jwtHelper', 'Restangular', '$state', '$q', '$window', '$http', 'lokalizacjaAPI'];

        /* @ngInject */
        function zapytanieOfertoweService(store, $rootScope, jwtHelper, Restangular, $state, $q, $window, $http, lokalizacjaAPI, $scope) {

            var service = {
                slownikKategorii: slownikKategorii,
                dodajDoKoszyka: dodajDoKoszyka,
                dajKoszyk: dajKoszyk,
                pobierzKoszyk: pobierzKoszyk,
                usunZKoszyka: usunZKoszyka,
                resetKoszyka: resetKoszyka,
                ustawLokalizacje: ustawLokalizacje,
                pobierzProdukty: pobierzProdukty,
                pobierzWartosciParametru: pobierzWartosciParametru,
                pobierzParametryProduktu: pobierzParametryProduktu,
                pobierzParametr: pobierzParametr,
                pobierzLicencjeLokalizacji: pobierzLicencjeLokalizacji,
                pobierzOgraniczeniaLicencji: pobierzOgraniczeniaLicencji,
                pobierzLicencjeZOgraniczeniami: pobierzLicencjeZOgraniczeniami,
                pobierzOferte: pobierzOferte,
                zaakceptujOferte: zaakceptujOferte,
                odrzucOferte: odrzucOferte
            };
            var slownikKategorii = {
                'zmiana-limitow': 'zmiana limitów',
                'nowy-modul': 'nowy moduł',
                'pakiety-i-uslugi': 'usługi',
                'aktualizacja': 'aktualizacja'
            };

            function ustawKlientaKoszyka() {
                var koszyk = dajKoszyk();
                Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                    if (angular.isDefined(result[0])) {
                        koszyk.klient = {
                            Nazwa: result[0].NazwaKr,
                            Kod: result[0].Kod,
                            IDPod: result[0].IdPod
                        };
                        store.set('PZKoszyk', JSON.stringify(koszyk));
                    }
                });
            }

            function resetKoszyka() {
                var koszyk = {
                    klient: null,
                    lokalizacja: null,
                    lokalizacje: [],
                    produkty: []
                };
                store.set('PZKoszyk', JSON.stringify(koszyk));
                ustawKlientaKoszyka();
                $rootScope.$broadcast('$aktualizujKoszyk');
                return koszyk;
            }

            function ustawLokalizacje(lok) {
                var koszyk = dajKoszyk();
                koszyk.lokalizacja = lok;
                store.set('PZKoszyk', JSON.stringify(koszyk));
                return koszyk;
            }

            function dajKoszyk() {
                var koszyk = store.get('PZKoszyk');
                if (koszyk) {
                    koszyk = JSON.parse(koszyk);
                } else {
                    koszyk = resetKoszyka();
                }
                Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                    if (angular.isDefined(result[0])) {
                        koszyk.klient = {
                            Nazwa: result[0].NazwaKr,
                            Kod: result[0].Kod,
                            IDPod: result[0].IdPod
                        };
                        store.set('PZKoszyk', JSON.stringify(koszyk));
                    }
                });
                return koszyk;
            }

            function dodajDoKoszyka(form) {
                var koszyk = dajKoszyk();
                koszyk.produkty = koszyk.produkty.filter(
                    function (p) {
                        return (
                            p.lokalizacja.IdLok !== form.lokalizacja.IdLok ||
                            form.produkt.id !== p.produkt.id ||
                            form.kategoria !== p.kategoria
                        );
                    }
                );
                koszyk.produkty.push(form);
                var lokids = koszyk.lokalizacje.map(function (lok) {
                    return lok.IdLok;
                });
                if (lokids.indexOf(form.lokalizacja.IdLok) === -1) {
                    koszyk.lokalizacje.push(form.lokalizacja);
                }

                store.set('PZKoszyk', JSON.stringify(koszyk));
                $rootScope.$broadcast('$aktualizujKoszyk');
                return koszyk;
            }

            function usunZKoszyka(produkt) {
                var koszyk = dajKoszyk();

                koszyk.produkty = koszyk.produkty.filter(
                    function (p) {
                        return (
                            p.lokalizacja.IdLok !== produkt.lokalizacja.IdLok ||
                            produkt.produkt.id !== p.produkt.id ||
                            produkt.kategoria !== p.kategoria
                        );
                    }
                );
                koszyk.lokalizacje = [];
                angular.forEach(koszyk.produkty, function (prod) {
                    var lokids = koszyk.lokalizacje.map(function (lok) {
                        return lok.IdLok;
                    });
                    if (lokids.indexOf(prod.lokalizacja.IdLok) === -1) {
                        koszyk.lokalizacje.push(prod.lokalizacja);
                    }
                });

                store.set('PZKoszyk', JSON.stringify(koszyk));
                $rootScope.$broadcast('$aktualizujKoszyk');
                return koszyk;
            }

            function pobierzKoszyk(id_lok) {
                var koszyk = store.get('koszyk');
                if (koszyk) {
                    koszyk = JSON.parse(koszyk);
                } else {
                    koszyk = {};
                }
                if (id_lok) {
                    if (koszyk[id_lok] === undefined || koszyk[id_lok] === null) {
                        koszyk[id_lok] = {
                            'nowy-modul': {},
                            'zmiana-limitow': {},
                            'aktualizacja': {},
                            'pakiety-i-uslugi': {},
                            'inne-zapytanie': {}
                        };
                        koszyk.keys = Object.keys(koszyk).filter(function (el) {
                            return el !== 'keys';
                        });
                        koszyk[id_lok].keys = Object.keys(koszyk[id_lok]).filter(function (el) {
                            return el !== 'keys';
                        });
                    }
                }
                return koszyk;
            }


            // function dodajDoKoszyka(kategoria, lokalizacja, obiekt) {
            //     var koszyk = pobierzKoszyk(lokalizacja);
            //     koszyk[lokalizacja][kategoria][obiekt.produkt.id] = obiekt;
            //     koszyk[lokalizacja][kategoria].keys = Object.keys(koszyk[lokalizacja][kategoria]).filter(function (el) {
            //         return el !== 'keys';
            //     });
            //     koszyk[lokalizacja][kategoria][obiekt.produkt.id].parametry.keys = Object.keys(koszyk[lokalizacja][kategoria][obiekt.produkt.id].parametry).filter(function (el) {
            //         return el !== 'keys';
            //     });
            //     store.set('koszyk', JSON.stringify(koszyk));
            //     console.log(koszyk);
            //     return koszyk;
            // }
            //
            // function usunZKoszyka(lokalizacja, kategoria, obiekt) {
            //     var koszyk = pobierzKoszyk(lokalizacja);
            //     delete koszyk[lokalizacja][kategoria][obiekt];
            //     koszyk[lokalizacja][kategoria].keys = Object.keys(koszyk[lokalizacja][kategoria]).filter(function (el) {
            //         return el !== 'keys';
            //     });
            //     var del_lok = true;
            //     angular.forEach(Object.keys(koszyk[lokalizacja]).filter(function (el) {
            //         return el !== 'keys';
            //     }), function (kat) {
            //         console.log('s', Object.keys(koszyk[lokalizacja][kat]).filter(function (el) {
            //             return el !== 'keys';
            //         }).length);
            //         if (Object.keys(koszyk[lokalizacja][kat]).filter(function (el) {
            //             return el !== 'keys';
            //         }).length > 0) {
            //             del_lok = false;
            //         }
            //     });
            //     if (del_lok) {
            //         console.log('usuwanieLok');
            //         delete koszyk[lokalizacja];
            //         koszyk.keys = Object.keys(koszyk).filter(function (el) {
            //             return el !== 'keys';
            //         });
            //     }
            //     store.set('koszyk', JSON.stringify(koszyk));
            //     return koszyk;
            //
            // }

            function pobierzProdukty(kategoria) {
                return Restangular.all('/zapytanie-ofertowe/produkt').getList({kategoria: kategoria}).then(
                    function (res) {
                        return res;
                    }
                );
            }

            function pobierzParametryProduktu(id_produktu) {
                return Restangular.all('/zapytanie-ofertowe/parametr').getList({produkt: id_produktu}).then(
                    function (res) {
                        return res;
                    }
                );
            }

            function pobierzParametr(idParametru) {
                return Restangular.all('/zapytanie-ofertowe/parametr').get(idParametru).then(
                    function (res) {
                        return res;
                    }
                );
            }

            function pobierzWartosciParametru(idParametru) {
                return Restangular.all('/zapytanie-ofertowe/parametr').getList(idParametru).then(
                    function (res) {
                        return res;
                    }
                );
            }

            function pobierzLicencjeLokalizacji(id_lok) {
                return Restangular.all('licencje/licencjelokalizacji/').getList({id_lok: id_lok, pageSize: 200}).then(
                    function (res) {
                        var licencje = {};
                        angular.forEach(res, function (licencja) {
                            licencje[licencja.Nazwa] = {
                                nazwa: licencja.Nazwa,
                                id_sys_lok: licencja.id_sys_lok,
                                ograniczenia: []
                            };
                        });
                        return licencje;
                    });
            }


            function pobierzOgraniczeniaLicencji(id_sys_lok, licencja_nazwa) {
                return Restangular.all('licencje/dodatkowe_ograniczenia/').getList({id_sys_lok: id_sys_lok}).then(
                    function (res) {
                        var ograniczenia = [];
                        angular.forEach(res, function (ograniczenie) {
                            ograniczenia.push({
                                licencja_nazwa: licencja_nazwa, id_sys_lok: id_sys_lok,
                                nazwa: ograniczenie.Nazwa, ograniczenie: ograniczenie.Ograniczenie
                            });
                        });
                        return ograniczenia;
                    });
            }

            function pobierzLicencjeZOgraniczeniami(id_lok) {
                return pobierzLicencjeLokalizacji(id_lok).then(function (licencje) {
                    var licencjeZOgraniczeniami = licencje;
                    var ograniczenia_promises = [];
                    angular.forEach(Object.keys(licencje), function (licencja_key) {
                        ograniczenia_promises.push(pobierzOgraniczeniaLicencji(licencje[licencja_key].id_sys_lok, licencja_key));

                    });
                    return $q.all(ograniczenia_promises).then(function (responses) {

                        angular.forEach(responses, function (resp) {
                            if (resp.length > 0) {
                                licencjeZOgraniczeniami[resp[0].licencja_nazwa].ograniczenia = resp;
                            }
                        });

                        return licencjeZOgraniczeniami;
                    })
                });
            }

            function pobierzOferte(idZgl) {
                return Restangular.all('/zapytanie-ofertowe/oferta').getList({zgloszenie: idZgl}).then(
                    function (res) {
                        return res;
                    }
                );
            }

            function zaakceptujOferte(idOferty, uzytkownik) {
                return Restangular.one('/zapytanie-ofertowe/oferta/' + idOferty + '/zaakceptuj').customPOST({uzytkownikNazwa: uzytkownik}).then(
                    function (res) {
                        return res;
                    }
                );
            }

            function odrzucOferte(idOferty, uzytkownik) {
                return Restangular.one('/zapytanie-ofertowe/oferta/' + idOferty + '/odrzuc').customPOST({uzytkownikNazwa: uzytkownik}).then(
                    function (res) {
                        return res;
                    }
                );
            }

            return service;
        }
    }

)();

(function () {

    'use strict';
    angular.module('strefaKlienta').factory('UmowyResource', UmowyResource);

    /** @ngInject */
    function UmowyResource(Restangular, wyslijPliki) {

        var resource = {
            pobierzUmowy: pobierzUmowy,
            dodajUmowe: dodajUmowe,
            dodajUpowaznienie: dodajUpowaznienie,
            pobierzDaneKontaktowe: pobierzDaneKontaktowe,
            dodajDaneKontaktowe: dodajDaneKontaktowe,
            pobierzUpowaznienie: pobierzUpowaznienie,
            dodajPDFUmowy: dodajPDFUmowy,
            pobierzPDFUmowyInfo: pobierzPDFUmowyInfo,
            pobierzPDFUmowy: pobierzPDFUmowy,
            dajIP: dajIP,
        };

        /**
         * @name UmowyResource#pobierzUmowy
         * @param {obj} requestParams [IdRodzUm]
         * @return {Array}
         */
        function pobierzUmowy(requestParams) {
            return Restangular.all('/umowy/umowa/').getList(requestParams).then(
                function (result) {
                    return result;
                }
            );
        }


        function pobierzUpowaznienie(requestParams) {
            return Restangular.all('/umowy/umowaUpowaznienie/').getList(requestParams).then(
                function (result) {
                    return result;
                }
            );
        }

        function pobierzPDFUmowyInfo(requestParams) {
            return Restangular.all('/umowy/umowaPDF/').getList(requestParams).then(
                function (result) {
                    return result;
                }
            );
        }

        function pobierzPDFUmowy(requestParams) {
            return Restangular.all('/umowy/umowaPDF/get_file/').getList(requestParams).then(
                function (result) {
                    return result;
                }
            );
        }

        function dodajUmowe(requestParams) {
            return Restangular.all('/umowy/umowa/').post(requestParams).then(function (result) {
                return result;
            });
        }

        function dodajUpowaznienie(pliki, idUmow) {
            return wyslijPliki.wyslij('/umowy/umowaUpowaznienie/', pliki, {IdUmow: idUmow}).then(function () {
                Restangular.all('/umowy/umowaUpowaznienie/').getList();
            });
        }

        function pobierzDaneKontaktowe(requestParams) {
            return Restangular.all('/umowy/umowaDaneKontaktowe').getList(requestParams);
        }

       function dodajDaneKontaktowe(requestParams) {
            return Restangular.all('/umowy/umowaDaneKontaktowe').post(requestParams);
       }

        function dodajPDFUmowy(blob, idUmow) {
            var umowaFile = new File([blob], 'UPPDO.pdf',
                {lastModified: new Date(), type: blob.type});
            umowaFile.nazwaPliku = 'UPPDO.pdf';
            return wyslijPliki.wyslij('/umowy/umowaPDF/', [umowaFile], {IdUmow: idUmow}).then(function () {
                Restangular.all('/umowy/umowaPDF/').getList();
            });
        }

        function dajIP() {
            return Restangular.all('/umowy/ip/').getList().then(function (result) {
                return result[0]['ip'];
            });
        }


        return resource;
    }
})();

(function () {
  "use strict";
  angular.module("strefaKlienta").factory("PDFGenUPPDO", PDFGenUPPDO);

  /** @ngInject */
  function PDFGenUPPDO(Restangular, $filter) {
    var resource = {
      generujPDF: generujPDF,
    };

    function bold(text) {
      return { text: text, bold: true };
    }

    function paragrafHeader(paragraf, text) {
      return [
        {
          text: "§ " + paragraf,
          bold: true,
          alignment: "center",
          marginTop: 20,
        },
        {
          text: text,
          bold: true,
          alignment: "center",
          marginBottom: 15,
        },
      ];
    }

    function ol(arr, type, separator) {
      return {
        type: type || "",
        separator: separator || ".",
        ol: arr,
        margin: [10, 5],
      };
    }

    /**
     * @name PDFGenUPPDO#generujPDF
     * @param {obj} params [dzisiaj, danePodstawowe, zalogowany, iodDane, osobaUprawnionaDane, ip]
     * @return {Array}
     */
    function generujPDF(params) {
      var dd = {
        content: [
          naglowek(),
          paragraf0(params),
          paragraf1(),
          paragraf2(),
          paragraf3(),
          paragraf4(),
          paragraf5(),
          paragraf6(),
          paragraf7(params),
        ],
        styles: {
          header: {
            fontSize: 11,
            bold: true,
            lineHeight: 1.25,
          },
          anotherStyle: {
            italics: true,
            alignment: "right",
          },
        },
        defaultStyle: {
          fontSize: 11,
          lineHeight: 1.4,
        },
      };

      return pdfMake.createPdf(dd);
    }

    function naglowek() {
      return {
        text: "UMOWA POWIERZENIA PRZETWARZANIA DANYCH OSOBOWYCH",
        style: ["header"],
        alignment: "center",
      };
    }

    function paragraf0(params) {
      function nip() {
        return params.danePodstawowe.Nip
          ? {
              text: [
                ", posiadającą/ym numer NIP ",
                bold(params.danePodstawowe.Nip),
              ],
            }
          : "";
      }

      return [
        {
          text:
            "\n\nzawarta w Mysłowicach w dniu " +
            $filter("date")(params.dzisiaj, "dd.MM.yyyy") +
            "r. pomiędzy: \n",
          marginBottom: 25,
        },
        {
          text: [
            bold(params.danePodstawowe.Nazwa),
            " z siedzibą w ",
            bold(params.danePodstawowe.Miasto),
            bold(" Ul. " + params.danePodstawowe.Ulica),
            " ",
            bold(params.danePodstawowe.Numer),
            " zarejestrowaną/ym w ",
            bold(params.danePodstawowe.Miasto),
            bold(" Ul. " + params.danePodstawowe.Ulica),
            " pod numerem ",
            bold(params.danePodstawowe.Numer),
            nip(),
            ", reprezentowaną/ym przez: \n",
          ],
        },
        ol([params.pelnomocnik.imie + " " + params.pelnomocnik.nazwisko]),
        {
          text: [
            "zwaną/ym dalej ",
            bold("Zleceniodawcą,"),
            "\na\n",
            bold("MIESZCZANIN INFORMATYKA sp. z o.o."),
            ", ul. Modrzewskiego 42, 41-400 Mysłowice, KRS 0000908468, NIP 2220895448 - " +
              "działająca pod nazwą handlową MIESZCZANIN, reprezentowaną przez:\n",
          ],
        },
        ol([
          "Mateusza Mieszczanina - prezesa zarządu,",
          "Michała Mieszczanina - członka zarządu,",
        ]),
        {
          text: [
            "zwaną dalej ",
            bold("Zleceniobiorcą.\n\n"),
            "Zleceniodawca i Zleceniobiorca zwani są dalej łącznie ",
            bold("Stronami"),
            ", a każda z nich z osobna ",
            bold("Stroną"),
            ".\n\n",
            "Strony, celem uregulowania zasad przetwarzania danych osobowych zgodnie z obowiązującymi przepisami prawa, zawierają umowę następującej treści:\n",
          ],
        },
      ];
    }

    function paragraf1() {
      return [
        paragrafHeader(1, "Cel i zakres"),
        ol([
          "Celem niniejszej umowy jest zapewnienie przestrzegania, art. 28 ust. 3 i 4 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych w związku z zawarciem i realizacją przez Strony Umowy Głównej, o której mowa w § 2 ust. 4 pkt 4.",
          "Celem powierzenia przetwarzania  jest wykonywanie Umowy Głównej, o której mowa w § 2 ust. 4 pkt 4. ",
          [
            "Niniejsza umowa ma zastosowanie do przetwarzania następującego zakresu danych osobowych: ",
            ol(
              [
                [
                  "Kategorie osób, których dane osobowe są przetwarzane:",
                  ol(
                    [
                      "pracownicy i współpracownicy Zleceniodawcy (bez względu na formę ich zatrudnienia) lub podmiotów powierzających dane Zleceniodawcy,",
                      "osoby powiązane z zasobami lokalowymi Zleceniodawcy lub powierzonych Zleceniodawcy przez administratora i podmiot powierzający, w szczególności: właściciele, współwłaściciele, najemcy, lokatorzy, mieszkańcy, inne osoby posiadające prawo do lokalu lub zajmujące lokal bez tytułu prawnego,",
                      "reprezentanci podmiotów: pełnomocnicy, członkowie zarządów wspólnot mieszkaniowych, członkowie organów samorządowych w spółdzielniach mieszkaniowych,",
                      "użytkownicy usługi e-kartoteka,",
                      "użytkownicy usługi e-Mieszczanin,",
                      "uczestnicy szkoleń,",
                      "kontrahenci oraz usługodawcy realizujący dla Zleceniodawcy usługi, których dane wynikiem działania Zleceniodawcy, trafiły do oprogramowania i usług dostarczanych przez Zleceniobiorcę.",
                    ],
                    "lower-alpha",
                    ")"
                  ),
                ],
                [
                  "Rodzaj i zakres przetwarzanych danych osobowych:",
                  ol(
                    [
                      "w zakresie danych pracowników i współpracowników: dane zwykłe (dane kontaktowe, dane niezbędne do realizacji usług serwisowych, loginy do usług i oprogramowania); szczególne kategorie danych (dane dotyczące zdrowia w zakresie informacji o L4 - wyłącznie w przypadku korzystania z modułu Kadry i Płace i zasilania go tymi danymi),",
                      "w zakresie danych osób powiązanych z zasobami lokalowymi: dane zwykłe (imię, nazwisko, dane kontaktowe: adres e-mail, telefon, adres lokalu, adres korespondencyjny, dane dotyczące rozliczeń, windykacji, charakterystyk lokalowych), ",
                      "w zakresie reprezentantów podmiotów: dane zwykłe (imię, nazwisko, stanowisko, nr telefonu),",
                      "w zakresie użytkowników usługi e-kartoteka: dane zwykłe (login, e-mail, adres, nr konta, nr telefonu, dane lokalu, dane dotyczące rozliczeń),",
                      "w zakresie użytkowników usługi e-Mieszczanin: dane zwykłe (login, e-mail, adres, nr konta, nr telefonu, dane lokalu, dane dotyczące rozliczeń),",
                      "w zakresie uczestników szkoleń: dane zwykłe (imię, nazwisko, e-mail, nr telefonu, zakres pozyskanych kwalifikacji),",
                      "w zakresie kontrahentów i usługodawców: dane zwykłe (dane rejestrowe, dane kontaktowe, dane dotyczące rozliczeń).",
                    ],
                    "lower-alpha",
                    ")"
                  ),
                ],
                "Zakres powierzonych danych osobowych obejmuje wszystkie dane umieszczone w programach i usługach informatycznych dostarczanych Zleceniodawcy przez Zleceniobiorcę oraz infrastrukturze IT będącej w dyspozycji Zleceniodawcy, do której udzielił dostępu Zleceniobiorcy na podstawie Umowy Głównej oraz dane przekazane Zleceniodawcy w każdej innej formie w związku z realizacją Umowy Głównej. Zakres danych powierzonych obejmuje zarówno dane wprowadzone do programów i usług przez Zleceniodawcę, dane  wprowadzane przez osoby przez Zleceniodawcę upoważnione poprzez przydzielenie dostępu, jakimi są zarówno pracownicy i współpracownicy Zleceniodawcy, jak i użytkownicy końcowi usług, jak i dane, które trafiły do systemu informatycznego od podmiotu zewnętrznego w wyniku działania Zleceniodawcy lub osób przez zleceniodawcę upoważnionych w oprogramowaniu i usługach dostarczanych Zleceniodawcy przez Zleceniobiorcę. ",
                "Charakter przetwarzania danych osobowych w zakresie i celu określonym w Umowie obejmuje przetwarzanie w szczególności w postaci elektronicznej, zwłaszcza w systemach informatycznych i usługach internetowych oraz narzędziach i rozwiązaniach AI dla zapewnienia inteligentnej funkcjonalności oprogramowania dostarczanego Zleceniodawcy, w postaci papierowej, przesłanie drogą elektroniczna, przekazywanie na nośnikach danych, czy też przekazywanie do wglądu Zleceniobiorcy w trakcie połączenia zdalnego za pośrednictwem końcowych urządzeń telekomunikacyjnych jak i udostępnionych do wglądu  w trakcie osobistych konsultacji poprzez operacje: zbierania, utrwalania, organizowania, porządkowania, przechowywania, adaptowania lub  modyfikowania, pobierania, przeglądania, wykorzystywania, ujawniania przez przesłanie, rozpowszechnianie lub innego rodzaju udostępniania, dopasowywania lub łączenia, ograniczania, usuwania lub niszczenia.",
              ],
              "",
              ")"
            ),
          ],
          "Niniejsza umowa pozostaje bez uszczerbku dla obowiązków, którym podlega Zleceniodawca danych na mocy rozporządzenia (UE) 2016/679 lub rozporządzenia (UE) 2018/1725.",
        ]),
      ];
    }

    function paragraf2() {
      return [
        paragrafHeader(2, "Wykładnia"),
        ol([
          "Jeżeli w  niniejszej umowie użyto terminów zdefiniowanych odpowiednio w rozporządzeniu (UE) 2016/679 lub rozporządzeniu (UE) 2018/1725, terminy te mają takie samo znaczenie jak w tych rozporządzeniach.",
          "Niniejszą umowę odczytuje się i interpretuje w świetle odpowiednio przepisów rozporządzenia (UE) 2016/679.",
          "Zapisów niniejszej umowy nie interpretuje się w sposób sprzeczny z prawami i obowiązkami przewidzianymi w rozporządzeniu (UE) 2016/679 lub rozporządzeniu (UE) 2018/1725 ani w sposób naruszający podstawowe prawa lub wolności osób, których dane dotyczą.",
          [
            "Strony zgodnie postanawiają, iż niżej podane terminy będą miały następujące znaczenie:",
            ol(
              [
                [
                  "Podmiot powierzający dane, zwany dalej Zleceniodawcą rozumiany jako:",
                  ol(
                    [
                      "administrator - w przypadku powierzania Zleceniobiorcy danych, których jest administratorem; ",
                      "podmiot przetwarzający - w przypadku powierzania Zleceniobiorcy danych, które przetwarza w imieniu podmiotu, będącego administratorem tych danych lub za zgodą tego podmiotu na ich powierzenie Zleceniobiorcy; ",
                      "dalszy podmiot przetwarzający - w przypadku podpowierzania Zleceniobiorcy danych, które przetwarza za zgodą podmiotu przetwarzającego, uprawnionego przez administratora do dalszego powierzania tych danych,",
                      "przy czym Zleceniodawca w stosunku do danych, jakie powierza Zleceniobiorcy może występować jako każdy z wymienionych jednocześnie; ",
                    ],
                    "lower-alpha",
                    ")"
                  ),
                ],
                [
                  "Podmiot przyjmujący dane w powierzenie, zwany dalej Zleceniobiorcą - podmiot, któremu Zleceniodawca powierza przetwarzanie danych osobowych na mocy niniejszej umowy powierzenia, rozumiany jako: ",
                  ol(
                    [
                      "podmiot przetwarzający w odniesieniu do danych powierzonych przez podmiot powierzający, będący administratorem danych powierzanych,",
                      "dalszy podmiot przetwarzający w odniesieniu do danych powierzonych przez podmiot powierzający z upoważnienia administratora danych powierzanych,",
                      "podmiot przetwarzający i jednocześnie dalszy podmiot powierzający, jeśli podmiot powierzający odpowiednio pełni rolę administratora i podmiotu przetwarzającego w stosunku do powierzanych Zleceniobiorcy danych;",
                    ],
                    "lower-alpha",
                    ")"
                  ),
                ],
                "Rozporządzenie - Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych);",
                [
                  "Umowa Główna - wszystkie łączące Strony aktualne i przyszłe umowy licencyjne, umowy sprzedaży i umowy o świadczenie usług, niezbędne do realizacji określonych w niniejszej umowie celów, w związku z którymi zawierana jest niniejsza umowa, a w szczególności:",
                  ol(
                    [
                      "umowa na dostawę licencji na oprogramowanie Zleceniobiorcy,",
                      "umowa na dostawę licencji na oprogramowanie i wdrożenie oprogramowania Zleceniobiorcy,",
                      "umowa na dzierżawę licencji na oprogramowanie Zleceniobiorcy,",
                      "Umowa Stałej Aktualizacji,",
                      "Umowa na świadczenie usług serwisowych (w formie serwisu na żądanie, serwisu doraźnego, umowy serwisowej lub innej umowy serwisowej zawartej przez Strony),",
                      "umowa na świadczenie usługi e-kartoteka,",
                      "umowa na świadczenie usługi e-Mieszczanin,",
                      "umowa na świadczenie usługi Chmura Mieszczanin,",
                      "umowa na świadczenie usługi SMS,",
                      "umowa usług pasywnych,",
                      "umowa administracji serwerem sieci,",
                      "umowa administracji siecią,",
                      "umowa archiwizacji i aktualizacji programu Mieszczanin,",
                      "umowa konserwacji rozwiązania dedykowanego,",
                      "umowa na świadczenie usługi OCR,",
                      "umowa na usługi szkoleniowe,",
                      "inne umowy o treści indywidualnej ustalonej ze Zleceniodawcą, których realizacja związana jest z powierzeniem danych osobowych;",
                    ],
                    "lower-alpha",
                    ")"
                  ),
                ],
                "Umowa powierzenia, Umowa - niniejsza umowa powierzenia przetwarzania danych osobowych.",
              ],
              "",
              ")"
            ),
          ],
        ]),
      ];
    }

    function paragraf3() {
      return [
        paragrafHeader(3, "Obowiązki Stron"),
        ol(
          [
            [
              "Polecenia.",
              ol(
                [
                  "Zleceniobiorca przetwarza dane osobowe wyłącznie na udokumentowane polecenie Zleceniodawcy, chyba że obowiązek taki nakłada na niego prawo Unii lub prawo państwa członkowskiego, któremu podlega Zleceniobiorca. W takim przypadku przed rozpoczęciem przetwarzania Zleceniobiorca informuje Zleceniodawcę o tym obowiązku prawnym, o ile prawo nie zabrania udzielenia takiej informacji z uwagi na ważny interes publiczny. Zleceniodawca może wydawać kolejne polecenia w sposób udokumentowany przez cały okres przetwarzania danych osobowych. Za udokumentowane polecenie Zleceniodawcy strony traktują treść Umowy Głównej, treść Umowy, polecenia wydane za pośrednictwem Systemu Zgłoszeń oraz w trakcje realizacji konsultacji, polecenia przekazane drogą mailową lub w inny udokumentowany sposób;",
                  "Zleceniobiorca bezzwłocznie powiadamia Zleceniodawcę, jeżeli w opinii Zleceniobiorcy polecenie wydane przez Zleceniodawcę narusza Rozporządzenie lub obowiązujące przepisy Unii lub państwa członkowskiego o ochronie danych;",
                  "Zleceniodawca oświadcza, że w przypadku gdy nie jest administratorem danych powierzanych Zleceniobiorcy, posiada ogólną lub szczegółową zgodę administratora lub podmiotu przetwarzającego powierzającego dane za zgodą administratora na dalsze ich powierzenie.  Zleceniodawca gwarantuje że dane osobowe są przetwarzane w celach zgodnych z prawem oraz, że nie przetwarza więcej danych osobowych, niż jest to wymagane do spełnienia tych celów, a także oświadcza, że przetwarzanie przez niego danych powierzanych Zleceniobiorcy na podstawie Umowy oraz w ramach Umowy Głównej nie narusza Rozporządzenia oraz innych przepisów powszechnie obowiązujących, w szczególności oświadcza, że przestrzega zasad dotyczących przetwarzania danych osobowych wskazanych w art. 5 Rozporządzenia oraz posiada stosowne podstawy prawne do przetwarzania powierzanych danych i do ich powierzenia Zleceniobiorcy.",
                ],
                "",
                ")"
              ),
            ],
            [
              "Ograniczenie celu.",
              "Zleceniobiorca przetwarza dane osobowe wyłącznie w konkretnym celu lub celach przetwarzania, określonych w § 1 Umowy, chyba że otrzyma dalsze polecenia od Zleceniodawcy.",
            ],
            [
              "Czas trwania przetwarzania danych osobowych.",
              "Przetwarzanie danych przez Zleceniobiorcę odbywa się przez czas obowiązywania Umowy Głównej w zakresie niezbędnym do wykonania trwających umów wchodzących w jej skład zgodnie § 2 ust. 4 pkt 4. Zleceniobiorca zapewnia przestrzeganie postanowień Umowy do czasu usunięcia lub zwrotu danych, o których mowa w § 6 ust. 5.",
            ],
            [
              "Bezpieczeństwo przetwarzania.",
              ol(
                [
                  [
                    "W celu zapewnienia bezpieczeństwa danych osobowych Zleceniobiorca wdraża co najmniej następujące środki techniczne i organizacyjne:",
                    ol(
                      [
                        "anonimizację i szyfrowanie danych osobowych,",
                        "zdolność do ciągłego zapewnienia poufności, integralności, dostępności i odporności systemów i usług przetwarzania,",
                        "zdolność do szybkiego przywrócenia dostępności danych osobowych i dostępu do nich w razie incydentu fizycznego lub technicznego,",
                        "regularne testowanie, mierzenie i ocenianie skuteczności środków technicznych i organizacyjnych mających zapewnić bezpieczeństwo przetwarzania.",
                      ],
                      "lower-alpha",
                      ")"
                    ),
                  ],
                  [
                    "W zakresie środków określonych w ust. 4 powyżej Zleceniobiorca deklaruje iż wdrożył między innymi następujące środki:",
                    ol(
                      [
                        "środki umożliwiające szyfrowanie danych osobowych,",
                        "środki zapewniające zdolność do ciągłego zapewnienia poufności, integralności, dostępności i odporności systemów i usług przetwarzania,",
                        "środki zapewniające zdolność do szybkiego przywrócenia dostępności danych osobowych i dostępu do nich w razie incydentu fizycznego lub technicznego,",
                        "procesy umożliwiające regularne testowanie, mierzenie i ocenianie skuteczności środków technicznych i organizacyjnych mających zapewnić bezpieczeństwo przetwarzania,",
                        "środki umożliwiające identyfikację i autoryzację użytkowników,",
                        "środki zapewniające ochronę danych w czasie ich przekazywania,",
                        "środki zapewniające ochronę danych w czasie ich przechowywania,",
                        "środki służące zapewnieniu bezpieczeństwa fizycznego miejsc, w których przetwarzane są dane osobowe,",
                        "środki umożliwiające rejestrowanie zdarzeń,",
                        "środki dotyczące zarządzania wewnętrznym systemem IT i bezpieczeństwem IT,",
                        "środki zapewniające minimalizację danych,",
                        "środki zapewniające odpowiednią jakość danych,",
                        "środki zapewniające ograniczone zatrzymywanie danych,",
                        "środki zapewniające rozliczalność,",
                        "środki umożliwiające przenoszenie danych i zapewnienie ich usuwania;",
                      ],
                      "lower-alpha",
                      ")"
                    ),
                  ],
                  "Zapewnienie bezpieczeństwa danych obejmuje ochronę danych przed naruszeniem bezpieczeństwa prowadzącym do przypadkowego lub niezgodnego z prawem zniszczenia, utracenia, zmodyfikowania, nieuprawnionego ujawnienia lub nieuprawnionego dostępu do danych (naruszenie ochrony danych osobowych). Oceniając odpowiedni poziom bezpieczeństwa, Strony należycie uwzględniają stan wiedzy technicznej, koszty wdrażania, charakter, zakres, kontekst i cele przetwarzania oraz związane z tym ryzyko dla osób, których dane dotyczą;",
                  "Zleceniobiorca udziela członkom swojego personelu dostępu do danych osobowych podlegających przetwarzaniu jedynie w zakresie bezwzględnie niezbędnym do wykonania umowy, zarządzania nią i jej monitorowania. Zleceniobiorca zapewnia, by osoby upoważnione do przetwarzania otrzymanych danych osobowych zobowiązały się do zachowania poufności lub by podlegały odpowiedniemu ustawowemu obowiązkowi zachowania poufności.",
                ],
                "",
                ")"
              ),
            ],

            [
              "Dokumentacja i zgodność.",
              ol(
                [
                  "Strony są w stanie wykazać zgodność z Umową;",
                  "Zleceniobiorca niezwłocznie i odpowiednio rozpatruje zapytania Zleceniodawcy dotyczące przetwarzania danych zgodnie z Umową; ",
                  "Zleceniobiorca udostępnia Zleceniodawcy wszelkie informacje niezbędne do wykazania spełnienia obowiązków, które są określone w Umowie i wynikają bezpośrednio z Rozporządzenia. Na wniosek Zleceniodawcy Zleceniobiorca zezwala również na audyty czynności przetwarzania objętych Umową i uczestniczy w tych audytach. Audyty te przeprowadza się w rozsądnych odstępach czasu lub jeżeli istnieją przesłanki wskazujące na niezgodność. Podejmując decyzję w sprawie przeglądu lub audytu, Zleceniodawca może wziąć pod uwagę odpowiednie certyfikaty, jakie ma Zleceniobiorca;",
                  "Zleceniodawca może przeprowadzić audyt samodzielnie lub upoważnić do jego przeprowadzenia niezależnego audytora. Audyty mogą również obejmować inspekcje w pomieszczeniach lub obiektach fizycznych Zleceniobiorcy. Audyty te przeprowadza się, informując o nich, w stosownych przypadkach, z miesięcznym wyprzedzeniem, po zaakceptowaniu terminu przez Zleceniobiorcę. W przypadku braku akceptacji terminu zaproponowanego przez Zleceniodawcę, Strony ustalają możliwie zbliżony termin przeprowadzenia audytu w czasie nie dalszym niż 21 dni od zaproponowanego przez Zleceniodawcę terminu;",
                  "Na wniosek właściwego organu nadzorczego Strony udostępniają mu informacje, o których mowa w Umowie, w tym wyniki wszelkich audytów;",
                  "Zleceniodawca ponosi wszelkie koszty związane z audytami przeprowadzonymi na żądanie Zleceniodawcy, w tym również koszty wynagrodzenia dla Zleceniobiorcy za rozsądny czas spędzony przez niego i jego pracowników, którzy uczestniczą w audycie wewnętrznym. Zleceniobiorca ponosi jednak koszty audytu, jeżeli kontrola wykaże niezgodność przetwarzania danych osobowych z Umową lub prawodawstwem w zakresie ochrony danych.",
                ],
                "",
                ")"
              ),
            ],
            [
              "Korzystanie z usług podmiotów podprzetwarzających.",
              ol(
                [
                  "Zleceniodawca wyraża zgodę szczegółową na korzystanie przez Zleceniobiorcę z usług podmiotów podprzetwarzających wpisanych do uzgodnionego wykazu oraz zgodę ogólną Zleceniodawcy na korzystanie z innych podmiotów podprzetwarzających poprzez dodanie ich do wykazu z zastrzeżeniem pkt. 2.;",
                  "Za uzgodniony wykaz Strony uznają wykaz opublikowany w Strefie Klienta na witrynie Zleceniobiorcy www.mieszczanin.pl (zakładka Twoje konto > Informacje dedykowane). Zleceniobiorca informuje Zleceniodawcę drogą mailową na adres określony w §7 ust. 3 o wszelkich zamierzonych zmianach w tym wykazie, polegających na dodaniu lub zastąpieniu podmiotów podprzetwarzających, z wyprzedzeniem co najmniej 7 dni przed rozpoczęciem przetwarzania, dając tym samym Zleceniodawcy wystarczająco dużo czasu na wyrażenie sprzeciwu wobec takich zmian przed rozpoczęciem korzystania z usług danego podmiotu podprzetwarzającego (podmiotów podprzetwarzających). Zleceniobiorca przekazuje Zleceniodawcy niezbędne informacje umożliwiające mu skorzystanie z prawa sprzeciwu;",
                  "Jeżeli Zleceniobiorca korzysta z usług podmiotu podprzetwarzającego w celu przeprowadzenia określonych czynności przetwarzania (w imieniu Zleceniodawcy), dokonuje tego w drodze umowy powierzenia przetwarzania danych, która nakłada na podmiot podprzetwarzający zasadniczo takie same obowiązki w zakresie ochrony danych jak obowiązki nałożone na podmiot przetwarzający dane zgodnie z Umową. Zleceniobiorca zapewnia, aby podmiot podprzetwarzający wypełniał obowiązki, którym podlega Zleceniobiorca na mocy Umowy oraz Rozporządzenia;",
                  "Zleceniobiorca pozostaje w pełni odpowiedzialny przed Zleceniodawcą za wykonanie obowiązków podmiotu podprzetwarzającego zgodnie z jego umową z podmiotem przetwarzającym. Zleceniobiorca powiadamia Zleceniodawcę o każdym przypadku niewywiązania się przez podmiot podprzetwarzający z jego zobowiązań umownych zawartych w umowie powierzenia.",
                ],
                "",
                ")"
              ),
            ],
            [
              "Międzynarodowe przekazywanie danych.",
              ol(
                [
                  "Wszelkie przekazywanie danych do państwa trzeciego lub organizacji międzynarodowej przez Zleceniobiorcę odbywa się wyłącznie na udokumentowane polecenie Zleceniodawcy lub w celu spełnienia szczególnego wymogu na mocy prawa Unii lub prawa państwa członkowskiego, któremu podlega Zleceniobiorca i odbywa się zgodnie z rozdziałem V Rozporządzenia;",
                  "Jeżeli Zleceniobiorca korzysta z usług podmiotu podprzetwarzającego w celu przeprowadzenia określonych czynności przetwarzania (w imieniu Zleceniodawcy), które wiążą się z przekazywaniem danych osobowych w rozumieniu rozdziału V Rozporządzenia, Zleceniodawca wyraża zgodę na to, by podmioty te mogły zapewnić zgodność z rozdziałem V Rozporządzenia za pomocą standardowych klauzul umownych przyjętych przez Komisję zgodnie z art. 46 ust. 2 Rozporządzenia, pod warunkiem że spełnione są warunki stosowania tych standardowych klauzul umownych.",
                ],
                "",
                ")"
              ),
            ],
          ],
          "",
          "."
        ),
      ];
    }

    function paragraf4() {
      return [
        paragrafHeader(4, "Pomoc dla Zleceniodawcy"),
        ol([
          "Zleceniobiorca niezwłocznie zawiadamia Zleceniodawcę o każdym wniosku otrzymanym od osoby, której dane powierzone dotyczą. Zleceniobiorca, poza udzieleniem informacji określonej w § 4. ust. 4 pkt 2) nie odpowiada na taki wniosek samodzielnie, chyba że Zleceniodawca wyraził na to zgodę.",
          "Zleceniobiorca pomaga Zleceniodawcy w wypełnianiu jego obowiązków dotyczących udzielania odpowiedzi na wnioski osób, których dane dotyczą, o skorzystanie z przysługujących im praw, z uwzględnieniem charakteru przetwarzania. Wypełniając swoje obowiązki zgodnie z § 4 ust. 2 i § 4 ust. 3 Zleceniobiorca stosuje się do udokumentowanych poleceń Zleceniodawcy w zakresie określonym w § 4 ust. 4.",
          [
            "Oprócz spoczywającego na Zleceniobiorcy obowiązku pomagania Zleceniodawcy Zleceniobiorca pomaga mu ponadto w zapewnieniu wypełniania następujących obowiązków, z uwzględnieniem charakteru przetwarzania danych oraz informacji, którymi dysponuje Zleceniobiorca:",
            ol(
              [
                "obowiązek przeprowadzenia oceny wpływu planowanych operacji przetwarzania na ochronę danych osobowych („ocena skutków dla ochrony danych”), jeżeli dany rodzaj przetwarzania może powodować wysokie ryzyko naruszenia praw i wolności osób fizycznych;",
                "obowiązek skonsultowania się z właściwym organem nadzorczym przed rozpoczęciem przetwarzania, jeżeli ocena skutków dla ochrony danych wskaże, że przetwarzanie powodowałoby wysokie ryzyko, gdyby Zleceniodawca nie zastosował środków w celu jego ograniczenia;",
                "obowiązek zapewnienia prawidłowości i aktualności danych osobowych poprzez niezwłoczne poinformowanie Zleceniodawcy, jeżeli Zleceniobiorca stwierdzi, że przetwarzane przez niego dane osobowe są nieprawidłowe lub nieaktualne;",
                "obowiązki określone w art. 32 Rozporządzenia.",
              ],
              "",
              ")"
            ),
          ],
          [
            "Zakres pomocy, o której mowa w ust. 2 i 3 obejmuje:",
            ol(
              [
                "niezwłoczne dostarczenie na żądanie Zleceniodawcy informacji niezbędnych do wypełnienia jego obowiązków określonych w § 4 ust. 2 i § 4 ust. 3, o ile nie są one mu dostępne bez udziału Zleceniobiorcy;",
                "w odniesieniu do żądań, wniosków czy zapytań osób, których dane powierzone dotyczą: niezwłoczne poinformowanie osoby, której dane dotyczą o przekazaniu jej wniosku/żądania/zapytania do Zleceniodawcy wraz z uzasadnieniem oraz niezwłoczne przekazanie wniosku/żądania/zapytania do Zleceniodawcy;",
                "zawiadomienie mailowe Zleceniodawcy w przypadku stwierdzenia nieprawidłowości lub nieaktualności danych powierzonych ze wskazaniem danych, których ta informacja dotyczy.",
              ],
              "",
              ")"
            ),
          ],
          "W żadnym wypadku zakres pomocy nie obejmuje realizowania w imieniu Zamawiającego lub na jego polecenie jego obowiązków jako administratora lub podmiotu przetwarzającego, wynikających z Rozporządzenia.",
        ]),
      ];
    }

    function paragraf5() {
      return [
        paragrafHeader(5, "Zgłaszanie naruszenia ochrony danych osobowych"),
        ol([
          "W przypadku naruszenia ochrony danych osobowych Zleceniobiorca współpracuje ze Zleceniodawcą i pomaga mu w wypełnianiu jego obowiązków wynikających z art. 33 i art.  34 Rozporządzenia lub, w stosownych przypadkach, z art. 34 i art. 35 Rozporządzenia, z uwzględnieniem charakteru przetwarzania i informacji, którymi dysponuje Zleceniobiorca.",
          [
            "Naruszenie ochrony danych dotyczące danych przetwarzanych przez Zleceniodawcę w oprogramowaniu i usługach.",
            "W przypadku naruszenia ochrony danych osobowych dotyczącego danych przetwarzanych przez Zleceniodawcę w oprogramowaniu i usługach dostarczonych przez Zleceniobiorcę Zleceniobiorca wspomaga Zleceniodawcę:",
            ol(
              [
                "przy zgłaszaniu naruszenia ochrony danych osobowych właściwemu organowi nadzorczemu niezwłocznie po tym, jak Zleceniodawca dowiedział się o naruszeniu, w stosownych przypadkach (chyba że jest mało prawdopodobne, by naruszenie to skutkowało ryzykiem naruszenia praw lub wolności osób fizycznych);",
                [
                  "przy uzyskiwaniu następujących informacji, które zgodnie z art. 33 ust. 3 Rozporządzenia powinny być zawarte w zgłoszeniu administratora i obejmować co najmniej:",
                  ol(
                    [
                      "charakter danych osobowych, w tym w miarę możliwości kategorie i przybliżoną liczbę osób, których dane dotyczą, oraz kategorie i przybliżoną liczbę wpisów danych osobowych, których dotyczy naruszenie,",
                      "możliwe konsekwencje naruszenia ochrony danych osobowych,",
                      "środki zastosowane lub proponowane przez administratora w celu zaradzenia naruszeniu ochrony danych osobowych, w tym w stosownych przypadkach środki w celu zminimalizowania jego ewentualnych negatywnych skutków;",
                    ],
                    "lower-alpha",
                    ")"
                  ),
                ],
                "przy wypełnianiu na podstawie art. 34 Rozporządzenia obowiązku zawiadomienia bez zbędnej zwłoki osoby, której dane dotyczą, o naruszeniu ochrony danych osobowych, jeżeli naruszenie to może powodować wysokie ryzyko naruszenia praw i wolności osób fizycznych;",
                [
                  "wspomaganie Zleceniodawcy obejmuje:",
                  ol(
                    [
                      "niezwłoczne dostarczenie na żądanie informacji o których mowa w § 5 ust. 2 pkt 2) lit. a o ile nie są dostępne Zleceniodawcy bez udziału Zleceniobiorcy,",
                      "niezwłocznego udzielania odpowiedzi na zapytania o możliwe konsekwencje naruszenia o których mowa w § 5 ust. 2 pkt 2) lit. b w zakresie informacji, które nie są dostępne Zleceniodawcy bez udziału Zleceniobiorcy,",
                      "niezwłocznego udzielania odpowiedzi na zapytania dotyczące środków o których mowa w § 5 ust. 2 pkt 2) lit. c, jakie może zastosować Zleceniobiorca względem danych, a które nie są dostępne Zleceniodawcy bez udziału Zleceniobiorcy,",
                      "niezwłoczne dostarczenie na żądanie Zleceniodawcy informacji niezbędnych do zawiadomienia osoby, której dane dotyczą, o których mowa w  § 5 ust. 2 pkt 3).",
                    ],
                    "lower-alpha",
                    ")"
                  ),
                ],
                "jeżeli przekazanie wszystkich tych informacji równocześnie nie jest możliwe, pierwotne zgłoszenie zawiera informacje dostępne w danej chwili, a po uzyskaniu dostępu do dalszych informacji przekazuje się je bez zbędnej zwłoki.",
              ],
              "",
              ")"
            ),
          ],
          [
            "Naruszenie ochrony danych dotyczące danych przetwarzanych przez Zleceniobiorcę.",
            "W przypadku naruszenia ochrony danych osobowych dotyczącego danych przetwarzanych przez Zleceniobiorcę, Zleceniobiorca zgłasza naruszenie Zleceniodawcy niezwłocznie po tym, jak dowiedział się o naruszeniu. Zgłoszenie to powinno zawierać co najmniej:",
            ol(
              [
                "opis charakteru naruszenia (w tym, w miarę możliwości, kategorie i przybliżoną liczbę osób, których dane dotyczą, oraz wpisów danych, których dotyczy naruszenie);",
                "dane punktu kontaktowego, w którym można uzyskać więcej informacji na temat naruszenia ochrony danych osobowych;",
                "wskazanie prawdopodobnych konsekwencji naruszenia oraz środków, które zostały lub mają zostać wprowadzone w celu zaradzenia naruszeniu, w tym w celu zminimalizowania jego ewentualnych negatywnych skutków.",
              ],
              "",
              ")"
            ),
          ],
          "Jeżeli przekazanie wszystkich informacji równocześnie nie jest możliwe, pierwotne zgłoszenie zawiera informacje dostępne w danej chwili, a po uzyskaniu dostępu do dalszych informacji przekazuje się je bez zbędnej zwłoki.",
          "W przypadku, gdy informacja o naruszeniu wpływa do Zleceniobiorcy od Zleceniodawcy lub jego pracownika uznaje się, że Zleceniodawca posiada wiedzę o naruszeniu i Zleceniobiorca nie zgłasza tego naruszenia Zleceniodawcy.",
        ]),
      ];
    }

    function paragraf6() {
      return [
        paragrafHeader(6, "Naruszenie klauzul i rozwiązanie umowy"),
        ol([
          "Bez uszczerbku dla przepisów Rozporządzenia, w przypadku gdy Zleceniobiorca narusza swoje obowiązki wynikające z Umowy, Zleceniodawca może polecić mu, by zawiesił przetwarzanie danych osobowych do czasu, gdy Zleceniobiorca zapewni zgodność z Umową lub umowa ulega rozwiązaniu. Zleceniobiorca niezwłocznie zawiadamia Zleceniodawcę, jeżeli z jakiegokolwiek powodu nie jest w stanie zastosować się do niniejszej umowy.",
          [
            "Zleceniodawca jest uprawniony do rozwiązania Umowy, jeżeli:",
            ol(
              [
                "Zleceniodawca zawiesił przetwarzanie danych osobowych przez Zleceniobiorcę zgodnie z § 6 ust. 1 i jeżeli zgodność z Umową nie zostanie przywrócona w rozsądnym terminie, a w każdym razie w terminie jednego miesiąca od zawieszenia;",
                "Zleceniobiorca poważnie lub stale narusza Umowę lub swoje obowiązki wynikające z Rozporządzenia;",
                "Zleceniobiorca nie stosuje się do wiążącej decyzji właściwego sądu lub właściwego organu nadzorczego dotyczącej jego obowiązków wynikających z Umowy lub z Rozporządzenia;",
                "w ramach Umowy Głównej jedyną obowiązującą umową między Stronami pozostaje umowa na dostawę licencji na oprogramowanie, z zastrzeżeniem § 6 ust. 3.",
              ],
              "",
              ")"
            ),
          ],
          "Rozwiązanie Umowy przez Zleceniodawcę określone w § 6 ust. 2 pkt. 4) może skutkować brakiem możliwości realizacji wchodzących w skład Umowy Głównej usług i umów wymagających przetwarzania danych powierzonych, w szczególności usług i umów serwisowych, do czasu ponownego zawarcia przez Strony umowy powierzenia przetwarzania danych osobowych.",
          "Zleceniobiorca ma prawo rozwiązać Umowę, jeżeli po zawiadomieniu Zleceniodawcy o tym, że jego polecenie narusza obowiązujące wymogi prawne zgodnie z § 3 ust. 1 pkt 2), Zleceniodawca nalega na wypełnienie polecenia.",
          "Po rozwiązaniu Umowy Zleceniobiorca, zależnie od decyzji Zleceniodawcy, usuwa wszystkie dane osobowe przetwarzane w imieniu Zleceniodawcy i - na wniosek Zleceniodawcy - poświadcza Zleceniodawcy, że tego dokonał, lub zwraca Zleceniodawcy wszystkie dane osobowe i usuwa istniejące kopie, chyba że prawo Unii lub prawo państwa członkowskiego nakazują przechowywanie danych osobowych. Zwrot o którym mowa, dotyczy wyłącznie danych przekazanych Zleceniobiorcy przez Zleceniodawcę na nośnikach w sposób zaewidencjonowany podpisami Stron przy przekazaniu tych nośników, na dokumencie dostarczonym w dwóch kopiach przez Zleceniodawcę przy przekazaniu tych nośników. W odniesieniu do danych związanych ze zgłoszeniami serwisowymi i innymi realizowanymi usługami, które mogą być objęte roszczeniami, Zleceniobiorca usunie je po upływie terminu przedawnienia roszczeń, to jest po 2 latach od zakończenia realizacji usługi. Zleceniobiorca zapewnia przestrzeganie Umowy do czasu usunięcia lub zwrotu danych.",
        ]),
      ];
    }

    function osoba(header, osoba) {
      if (osoba.widoczny) {
        return [
          header,
          ol(
            [
              ["Imię i nazwisko: " + [osoba.imie, osoba.nazwisko].join(" ")],
              ["adres e-mail: " + osoba.email],
            ],
            "lower-alpha",
            ")"
          ),
        ];
      }
    }

    function paragraf7(params) {
      return [
        paragrafHeader(7, "Postanowienia końcowe"),
        ol([
          "Umowa zastępuje wszelkie inne dotychczasowe ustalenia dokonane pomiędzy Zleceniobiorcą, a Zleceniodawcą, dotyczące przetwarzania powierzonych Zleceniobiorcy danych osobowych, bez względu na to, czy zostały uregulowane umową, czy innym instrumentem prawnym.",
          "Jeżeli którekolwiek z postanowień Umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.",
          [
            "Ze strony Zleceniodawcy osobą do kontaktów w sprawie realizacji postanowień Umowy jest:",
            ol([
              osoba(
                "powołany przez Zleceniodawcę Inspektor Ochrony Danych:",
                params.iodDane
              ),
              osoba(
                "upoważniony do kontaktów w sprawie realizacji postanowień Umowy pracownik/współpracownik Zleceniodawcy:",
                params.osobaUprawnionaDane
              ),
            ]),
          ],
          "Ze strony Zleceniobiorcy osobą do kontaktów w sprawie realizacji Umowy jest powołany przez Zleceniobiorcę Inspektor Ochrony Danych, pan Michał Falski, adres email: iod@mieszczanin.pl.",
          [
            "Zmiana osób lub danych osób:",
            ol(
              [
                "wskazanych w § 7 ust. 3:  realizowana jest poprzez wprowadzenie nowych danych przez Zleceniodawcę w Strefie Klienta na witrynie Zleceniobiorcy www.mieszczanin.pl (Twoje Konto > Umowy);",
                "wskazanych w § 7 ust. ust. 4: realizowana jest poprzez poinformowanie Zleceniodawcy drogą elektroniczną - korespondencja e-mail na adres wskazany w § 7 ust. 3.",
              ],
              "",
              ")"
            ),
          ],
          "Umowę zawarto w sposób elektroniczny za pośrednictwem usługi Strefa Klienta w serwisie www.mieszczanin.pl z poziomu utworzonego przez Zleceniodawcę (jako administratora przydzielonego przez Zleceniobiorcę unikalnego konta klienta) imiennego konta użytkownika osoby upoważnionej do czynności zawierania umowy powierzenia przetwarzania danych. Strony zgodnie potwierdzają, że akceptują niniejszą formę zawarcia Umowy jako pełnoprawne i wiążące zobowiązanie i nie wnoszą co do tej formy  zastrzeżeń.",
        ]),
      ];
    }

    return resource;
  }
})();

(function () {

  'use strict';
  angular.module('strefaKlienta').factory('SzkoleniaResource', SzkoleniaResource);

  /** @ngInject */
  function SzkoleniaResource() {

    var resource = {
      czyJednodniowe: czyJednodniowe,
    };

    /**
     * @name SzkoleniaResource#czyJednodniowe
     * @param {string} dataSzkolenia
     * @param {string} dataKoncaSzkolenia
     * @return {boolean}
     */
    function czyJednodniowe(dataSzkolenia, dataKoncaSzkolenia) {
      var dataRozpoczeciaSzkolenia = new Date(dataSzkolenia);
      dataRozpoczeciaSzkolenia.setHours(0, 0, 0);

      var dataZakonczeniaSzkolenia = new Date(dataKoncaSzkolenia);
      dataZakonczeniaSzkolenia.setHours(0, 0, 0);

      return dataRozpoczeciaSzkolenia.getTime() === dataZakonczeniaSzkolenia.getTime();
    }

    return resource;
  }
})();

(function () {

    'use strict';

    angular.module('strefaKlienta').factory('PromocjeResource', PromocjeResource);

    /* @ngInject */
    function PromocjeResource(Restangular) {

        var service = {
            pobierzPromocje:  pobierzPromocje,
            dodajPromocje:  dodajPromocje,
            aktualizujPromocje: aktualizujPromocje,
            pobierzJednaPromocje: pobierzJednaPromocje
        };

        function pobierzPromocje(params) {
            return Restangular.all('promocje/promocje').getList(params).then(function (result) {
                return result;
            });
        }

        function pobierzJednaPromocje(id) {
            return Restangular.one('promocje/promocje', id).get().then(function (result) {
                return result;
            });
        }

        function dodajPromocje(params) {
            return Restangular.all('promocje/promocje').post(params).then(function(result) {
                return result;
            });
        }

        function aktualizujPromocje(promocja) {
            return promocja.put();
        }

        return service;
    }
})();

(function () {

    'use strict';

    angular.module('strefaKlienta').factory('AnkietyResource', AnkietyResource);

    /* @ngInject */
    function AnkietyResource(Restangular) {

        var service = {
            pobierzAnkiete:  pobierzAnkiete,
            wypelnijAnkiete:  wypelnijAnkiete,
        };

        function przygotujAnkieteDoWypelnienia(ankieta) {
            var doFormularza = {
                wypelniona: ankieta.wypelniona,
                hashid: ankieta.hashid,
                ankieta: ankieta.ankieta.id,
                odpowiedzi: ankieta.ankieta.pytania.map(function(pytanie) {
                    return {
                        odpowiedz: 0, 
                        tresc_pytania: pytanie.pytanie,
                        pytanie: pytanie.id,
                        skala: pytanie.skala,
                        ankieta: ankieta.ankieta.id
                        };
                })
            }
            
            return doFormularza;
        }

        function pobierzAnkiete(id) {
            return Restangular.one('ankiety/ankieta', id).get().then(function (result) {
                    return new Promise(function(resolve, reject) {
                        if (result.ankieta) {
                            resolve(przygotujAnkieteDoWypelnienia(result));
                        }
                        reject(null);
                    })
            });
        }

        function wypelnijAnkiete(params) {
            return Restangular.all('ankiety/wypelnij').post(params).then(function(result) {
                return result;
            });
        }

        return service;
    }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('ReklamacjeZmienController', ReklamacjeZmienController);

  /** @ngInject */
  function ReklamacjeZmienController($scope, $window, Restangular, $state, $filter, bootstrapKlasa) {
    var vm = this,
      zgloszenie = null,
      params = $state.params;

    vm.api = 'reklamacje/naglowki/';
    vm.bootstrapKlasa = bootstrapKlasa;
    vm.zmienStatus = zmienStatus;
    vm.tytulNaglowka = "Zmień status zgłoszenia";
    vm.statusy = [{id: 1, title: 'Przyjęto'}, {id: 2, title: "W realizacji"}, {id: 3, title: "W oczekiwaniu"}, {id: 4, title: 'Zrealizowano'}];
    vm.btnWyslijDisabled = false;
    vm.odpowiedziSerwera = [];
    vm.zgloszenie = null;


    var reklamacjeApi = Restangular.all(vm.api);

    init();

    function zmienStatus(){

      vm.btnWyslijDisabled = true;

      zgloszenie.customPOST({status:vm.zgloszenie.Status.id, komentarz: vm.zgloszenie.Tresc}, 'zmienstatuswiadomosci', {}, {}).then(
        function(success){
          vm.btnWyslijDisabled = false;
          vm.odpowiedziSerwera = [];
          $state.go('home.subMain.podszyciePodKlienta');
        },
        function(error){
          vm.btnWyslijDisabled = false;
          vm.odpowiedziSerwera.push({
            typ: 'E',
            tekst: 'Wystąpił błąd podczas zmiany statusu zgłoszenia. ' + error.statusText
          });
        }
      );
    }

    function init(){
      if (angular.isDefined(params.idZgl)){
        vm.idZgl = angular.fromJson(params.idZgl);
        zgloszenie = Restangular.one(vm.api, vm.idZgl);
      }

      if(vm.idZgl){
        zgloszenie.get().then(function(zgloszenie){
          vm.zgloszenie = zgloszenie;
          vm.zgloszenie.Status = $filter('filter')(vm.statusy, {id: vm.zgloszenie.Status})[0];
        });
      }
    }
  }
})();

(function () {

  angular.module('strefaKlienta').factory('zgloszeniaService', zgloszeniaService);

  zgloszeniaService.$inject = [];


  function zgloszeniaService() {

    var service = {
      liczba2typ: liczba2typ,
      status2klasa: status2klasa,
      liczba2status: liczba2status
    };

    function liczba2typ(liczba) {
      if (liczba === 0) {
        return 'Do określenia'; // do określenia
      }
      if (liczba === 1) {
        return 'Propozycje rozwoju';
      }
      if (liczba === 2) {
        return 'Jakość współpracy';
      }
      if (liczba === 3) {
        return 'Zgłoszenie reklamacji';
      }
      if (liczba === 4) {
        return 'Zapytanie ofertowe';
      }
      return '';
    }

    function status2klasa(liczba) {
      if (liczba === 0 || liczba === 3) {
        return 'label label-danger';
      }
      if (liczba === 1 || liczba === 2) {
        return 'label label-warning';
      }
      if (liczba === 4) {
        return 'label label-success';
      }
      return '';
    }

    function liczba2status(liczba) {
      if (liczba === 0) {
        return 'Zgłoszono';
      }
      if (liczba === 1) {
        return 'Przyjęto';
      }
      if (liczba === 2) {
        return 'W realizacji';
      }
      if (liczba === 3) {
        return 'W oczekiwaniu';
      }
      if (liczba === 4) {
        return 'Zrealizowano';
      }
      return '';
    }

    return service;
  }
})();
(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('ReklamacjeController', ReklamacjeController);

  /** @ngInject */
  function ReklamacjeController($state, zgloszeniaService, security, $timeout, $http) {
    var vm = this;

    vm.apiPliki = 'reklamacje/plik/';
    vm.anulujStrefaPrzypnijWiadomosc = anulujStrefaPrzypnijWiadomosc;
    vm.anulujZalatwWiadomosc = anulujZalatwWiadomosc;
    vm.globalSearch = true;
    vm.liczba2status = zgloszeniaService.liczba2status;
    vm.liczba2typ = zgloszeniaService.liczba2typ;
    vm.numerWiadomosciFormat = numerWiadomosciFormat;
    vm.odpowiedziSerwera = [];
    vm.przypnijWiadomoscInputClick = przypnijWiadomoscInputClick;
    vm.refreshGrid = false;
    vm.przypiszPracownika = przypiszPracownika;
    vm.zmienStatus = zmienStatus;
    vm.showFilter = true;
    vm.strefaPrzypnijWiadomosc = strefaPrzypnijWiadomosc;
    vm.status2klasa = zgloszeniaService.status2klasa;
    vm.zglosReklamacje = zglosReklamacje;
    vm.wybranyWiersz = null;
    vm.zalatwWiadomosc = zalatwWiadomosc;
    vm.zapiszPrzypnijWiadomosc = zapiszPrzypnijWiadomosc;
    vm.zapiszZalatwWiadomosc = zapiszZalatwWiadomosc;
    vm.zaznaczPierwszyWiersz = false;
    vm.jestZOD = false;
    vm.pokazWiadomosc = pokazWiadomosc;
    //vm.zgloszeniaService = zgloszeniaService;

    vm.api = 'reklamacje/naglowki/';
    vm.requestParams = {};
    vm.rowTemplate =  $("#rowTemplate").html();
    vm.columns = [
      {
        fieldName: "Temat",
        title: "Temat",
        sortable: "Temat",
        class: "table-cell-20-width",
        show: true
      },
      {
        fieldName: "Program",
        title: "Moduł",
        colTemplate: '<span>{{row.Modul}}&nbsp;{{row.Program}}</span>',
        class: "table-cell-15-width",
        show: true
      },
      {
        fieldName: "Typ",
        title: "Typ",
        filter: {Typ: "select"},
        class: "table-cell-15-width",
        filterData: [{title: ''},{id: 0, title: "Do określenia"}, {id: 1, title: 'Propozycje rozwoju'},
          {id: 2, title: "Jakość współpracy"}, {id: 3, title: 'Zgłoszenie reklamacji'},  {id: 4, title: 'Zapytanie ofertowe'}],
        colTemplate: '<span ng-bind="vm.runExtFunction(\'liczba2typ\',row.Typ)"></span>',
        show: true
      },
      {
        fieldName: "Status",
        title: "Status",
        class: "table-cell-5-width",
        colTemplate: '<span class="{{vm.runExtFunction(\'status2klasa\',row.Status)}}" ' +
        'ng-bind="vm.runExtFunction(\'liczba2status\',row.Status)"></span>',
        filter: {Status: "select"},
        filterData: [{title: ''},{id: 0, title: "Zgłoszono"}, {id: 1, title: 'Przyjęto'},
          {id: 2, title: "W realizacji"}, {id: 3, title: 'W oczekiwaniu'}, {id: 4, title: 'Zrealizowano'}],
        show: true
      },
      {
        fieldName: "DataMod",
        title: "Ostatnia zmiana",
        class: "table-cell-10-width",
        colTemplate: '<span>{{row.DataMod | date : "dd.MM.yyyy"}}</span>',
        sortable: "DataMod",
        show: true
      },
      {
        fieldName: "NazwaKr",
        title: "Klient",
        filter: {NazwaKr: "text"},
        sortable: "NazwaKr",
        class: "table-cell-15-width",
        show: (security.jestPracownikiemMieszczanin()) && (!security.jestDostepDoDanychKlienta())
      },
      {
        fieldName: "OsobaProwadzaca",
        title: "Operacja",
        class: "table-cell-15-width",
        colTemplate: $("#OsobaProwadzacaColTemplate").html(),
        show: true
      }
    ];

    init();

    function zglosReklamacje(){
      $state.go('home.subMain.zgloszenia_stare.nowaReklamacja')
    }

    function przypiszPracownika(paramList){
      paramList[1].stopPropagation();
      $state.go('home.subMain.zgloszenia_stare.nowaReklamacja', {przypiszOsobe: true, idZgl: paramList[0].IdRek});
    }

    function zmienStatus(paramList){
      paramList[1].stopPropagation();
      $state.go('home.subMain.zgloszenia_stare.zmienStatus', {idZgl: paramList[0].IdRek});
    }

    function strefaPrzypnijWiadomosc(row, event){
      event.stopPropagation();
      row.strefaPrzypnijWiadomosc = true;
    }

    function anulujStrefaPrzypnijWiadomosc(row, event){
      event.stopPropagation();
      row.strefaPrzypnijWiadomosc = false;
    }

    function przypnijWiadomoscInputClick(event){
      event.stopPropagation();
    }

    function numerWiadomosciFormat(numer){
      var numerStr = '' + numer;
      var wiadomosc = '\\\\Wiadomość:' + numerStr.slice(0,4) + '/' + numerStr.slice(4);
      return wiadomosc;
    }

    function zapiszPrzypnijWiadomosc(row, event){
      if(!row.id){
        row.id = row['IdRek'];
      }
      row.customPOST({NumerWiadomosci: row.NumerWiadomosci}, 'przypnijwiadomosc', {}, {}).then(
        function(success){
          vm.refreshGrid = true;
          $timeout(function(){vm.refreshGrid = false;}, 1000)
        },
        function(error){
          vm.odpowiedziSerwera.push({
            typ: 'E',
            tekst: 'Wystąpił błąd podczas przypinania numeru wiadomości.'
          });
        }
      );
      event.stopPropagation();
    }

    function zalatwWiadomosc(row, event){
      event.stopPropagation();
      row.strefaZalatwWiadomosc = true;
    }

    function anulujZalatwWiadomosc(row, event){
      event.stopPropagation();
      row.strefaZalatwWiadomosc = false;
    }

    function zapiszZalatwWiadomosc(row, event){
      event.stopPropagation();
      if(!row.id){
        row.id = row['IdRek'];
      }
      row.customPOST({}, 'zalatwwiadomosc', {}, {}).then(
        function(success){
          vm.refreshGrid = true;
          $timeout(function(){vm.refreshGrid = false;}, 1000)
        },
        function(error){
          vm.odpowiedziSerwera.push({
            typ: 'E',
            tekst: 'Wystąpił błąd podczas załatwiania wiadomości.'
          });
        }
      );
    }

    function jestZOD() {
      jQuery.ajax({type: 'GET', url : 'https://127.0.0.1:8000/datasnap/rest/TZODCliRest/JestZOD'}).then(function() {
        vm.jestZOD = true;
      }, function () {
        vm.jestZOD = false
      })
    }

    function pokazWiadomosc(idwiad) {
      jQuery.ajax({type: 'GET', url : 'https://127.0.0.1:8000/datasnap/rest/TZODCliRest/PokazWiad/'+idwiad+'/'})

    }

    function init(){
      if ($state.params.idrek) {
        if($state.params.idrek == 0){
          zglosReklamacje();
        }
        vm.zaznaczPierwszyWiersz = true;
        vm.requestParams = {
          id_rek : $state.params.idrek
        };
        vm.globalSearch = false;
        vm.showFilter = false;
      }
      jestZOD();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('ReklamacjeNowaController', ReklamacjeNowaController);

  /** @ngInject */
  function ReklamacjeNowaController($scope, $window, Restangular, $state, bootstrapKlasa) {
    var vm = this;

    var params = $state.params,
      zgloszenie = null,
      liczbaOperacji = 0,
      liczbaWykonanychOperacji = 0;


    vm.api = 'reklamacje/naglowki/';
    vm.apiPliki = 'reklamacje/plik/';
    vm.bootstrapKlasa = bootstrapKlasa;
    vm.btnWyslijDisabled = false;
    vm.edytuj = false;
    vm.email = '';
    vm.idZgl = null;
    vm.lokalizacje = [];
    vm.lokalizacja = null;
    vm.licencje = [];
    vm.licencja = null;
    vm.formatOpcjeLicencji = formatOpcjeLicencji;
    vm.pracownicy = [];
    vm.pracownik = null;
    vm.raport = null;
    vm.raportChbox = false;
    vm.numerLicencji = '';
    vm.odpowiedziSerwera = [];
    vm.osobaKontaktowa = '';
    vm.pobierzLicencje = pobierzLicencje;
    vm.pobierzLicencje = pobierzPracownikow;
    vm.przypiszOsobeProwadzaca = false;
    vm.przypiszOsobe = false;
    vm.telefon = '';
    vm.tresc = '';
    vm.tytulNaglowka = "Nowe zgłoszenie";
    vm.uploader = null;
    vm.wersja = null;
    vm.wersjaChbox = false;
    vm.wyslij = wyslij;
    vm.zgloszenie = null;

    var reklamacjeApi = Restangular.all(vm.api);

    init();

    $scope.$watch(function () {
      return vm.lokalizacja;
    }, wybierzLokalizacje);


    function wybierzLokalizacje(newValue, oldValue) {
      if (newValue !== oldValue){
        pobierzLicencje(newValue.IdLok);
      }
    }

    function pobierzLicencje(IdLok){
      Restangular.all('licencje/wersje/').getList({id_lok: IdLok, pageSize: 200}).then(function(result) {
        vm.licencje = result;

        //Sztuczne dodanie systemu e-kartoteka
        vm.licencje.push({'Kod':'PRW',
                          'Nazwa': 'e-kartoteka'})
        if(!vm.licencja) {
          //vm.licencja = result[0];
        }
      } , function(error) {
      })
    }

    function pobierzLokalizacje(){
      Restangular.all('licencje/lokalizacje/').getList({pageSize: 200}).then(function(result) {
        vm.lokalizacje = result;
        if(!vm.lokalizacja) {
          vm.lokalizacja = result[0];
        }
      } , function(error) {
      })
    }

    function pobierzPracownikow(){
      Restangular.all('reklamacje/pracownicy/').getList({pageSize: 200}).then(function(result) {
        vm.pracownicy = result;
        if(!vm.pracownik && vm.przypiszOsobe) {
          vm.pracownik = result[0];
        }
      } , function(error) {
      })
    }

    function pobierzRodzaje(){
      vm.rodzaje = [
        {'id' : 0, 'nazwa': 'Do określenia'},
        {'id' : 1, 'nazwa': 'Propozycja rozwoju'},
        {'id' : 2, 'nazwa': 'Jakość współpracy'},
        {'id' : 3, 'nazwa': 'Zgłoszenie reklamacji'},
        {'id' : 4, 'nazwa': 'Zapytanie ofertowe'}];
      if(!vm.rodzaj) {
        vm.rodzaj = vm.rodzaje[3];
      }
    }

    function formatOpcjeLicencji(lic) {
      return lic.Nazwa  + ' ' + lic.WersjaSys;
    }

    function wgrajPliki(id_rek){
      vm.uploader.wgrajPliki(id_rek).then(
        function(dane){
          vm.odpowiedziSerwera.push({
            typ: 'S',
            tekst: 'Pliki zostały wgrane.'
          });
          liczbaWykonanychOperacji+=1;
          if(liczbaWykonanychOperacji >= liczbaOperacji){
            zakonczWyslij();
          }
        }, function(error){
          vm.btnWyslijDisabled = false;
          zgloszenie = Restangular.one(vm.api, id_rek);
          vm.edytuj = true;
          vm.odpowiedziSerwera.push({
            typ: 'E',
            tekst: 'Wystąpił błąd podczas dodawania plików. Obecnie znajdujesz się w trybie edycji zgłoszenia.'
          });
        });
    }

    function dodajNoweZgloszenie(){
      var nowaReklamacja = {
        Zglaszajacy: vm.osobaKontaktowa,
        Telefon: vm.telefon,
        Temat: vm.temat,
        Opis: vm.tresc,
        Email: vm.email,
        Typ: vm.rodzaj.id
      };
      if(vm.rodzaj.id!==2) {
        if (vm.wersjaChbox && vm.wersja) {
          nowaReklamacja['IDWeS'] = vm.wersja.idWeS;
        }
        if (vm.licencja && vm.licencja) {
          nowaReklamacja['Kod'] = vm.licencja.Kod;
        }
        if (vm.raportChbox) {
          nowaReklamacja['Raport'] = vm.raport;
        }
      }
      reklamacjeApi.post(nowaReklamacja).then(
        function (reklamacja) {
          vm.odpowiedziSerwera.push({
            typ: 'S',
            tekst: 'Zgłoszenie zostało dodane.'
          });
          liczbaWykonanychOperacji+=1;
          wgrajPliki(reklamacja.IdRek);
          if(vm.pracownik){
            liczbaOperacji+=1;
            zgloszenie = Restangular.one(vm.api, reklamacja.IdRek);
            przypiszPracownika();
          }
          else {
            if (liczbaWykonanychOperacji >= liczbaOperacji) {
              zakonczWyslij();
            }
          }
        },
        function (e) {
          vm.odpowiedziSerwera.push({
            typ: 'E',
            tekst: 'Wystąpił błąd podczas zapisywania zgłoszenia'
          });
          vm.btnWyslijDisabled = false;
        });
    }

    function edytujZgloszenie(){
      zgloszenie.Email = vm.email;
      zgloszenie.Zglaszajacy = vm.osobaKontaktowa;
      zgloszenie.Telefon = vm.telefon;
      zgloszenie.Temat = vm.temat;
      zgloszenie.Opis = vm.tresc;
      zgloszenie.Typ = vm.rodzaj.id;
      if(vm.zgloszenie) {
        zgloszenie.IDWeS = vm.zgloszenie.IDWeS;
      }
      zgloszenie.put().then(function(zgloszenie){
        liczbaWykonanychOperacji+=1;
        wgrajPliki(zgloszenie.IdRek);
        vm.odpowiedziSerwera.push({
          typ: 'S',
          tekst: 'Zgłoszenie zostało zapisane.'
        });
      }, function(error){
        vm.odpowiedziSerwera.push({
          typ: 'E',
          tekst: 'Wystąpił błąd podczas edycji zgłoszenia'
        });
      })
    }

    function przypiszPracownika(){
      if(vm.pracownik) {
        zgloszenie.customPOST({IdPrac: vm.pracownik.IdPrac}, 'przypiszpracownika', {}, {}).then(
          function (pracownik) {
            vm.odpowiedziSerwera.push({
              typ: 'S',
              tekst: 'Pracownik został przypisany.'
            });
            liczbaWykonanychOperacji += 1;
            if (liczbaWykonanychOperacji >= liczbaOperacji) {
              zakonczWyslij();
            }
          },
          function (error) {
            vm.odpowiedziSerwera.push({
              typ: 'E',
              tekst: 'Wystąpił błąd podczas przypisywania pracownika.'
            });
            vm.btnWyslijDisabled = false;
          }
        )
      }
      else{
        vm.odpowiedziSerwera.push({
          typ: 'E',
          tekst: 'Proszę wybrać osobę prowadzącą.'
        });
        vm.btnWyslijDisabled = false;
      }
    }

    function zakonczWyslij(){
      liczbaWykonanychOperacji = 0;
      liczbaOperacji = 0;
      vm.btnWyslijDisabled = false;
      vm.odpowiedziSerwera = [];
      $state.go('home.subMain.zgloszenia.reklamacje');
    }

    function wyslij() {
      if (!vm.btnWyslijDisabled) {
        liczbaOperacji = 0;
        liczbaWykonanychOperacji = 0;
        vm.btnWyslijDisabled = true;

        if(!vm.przypiszOsobe && !vm.edytuj) {
          liczbaOperacji +=2;
          dodajNoweZgloszenie();
        }
        else{
          if(vm.edytuj){
            liczbaOperacji+=2;
            edytujZgloszenie();
          }
          if(vm.przypiszOsobe) {
            liczbaOperacji+=1;
            przypiszPracownika();
          }
        }
        //console.log('wysylam');
      }
    }

    function sprawdzCzyNieMaNumeruWiadomosci(id_wiad){
      if(id_wiad){
        zakonczWyslij();
      }
    }

    function init(){
      if (angular.isDefined(params.przypiszOsobe)){
        vm.przypiszOsobe = angular.fromJson(params.przypiszOsobe);
      }
      if (angular.isDefined(params.idZgl)){
        vm.idZgl = angular.fromJson(params.idZgl);
        zgloszenie = Restangular.one(vm.api, vm.idZgl);
      }
      pobierzLokalizacje();
      pobierzPracownikow();
      pobierzRodzaje();
      if(vm.idZgl){
        zgloszenie.get().then(function(zgloszenie){
          sprawdzCzyNieMaNumeruWiadomosci(zgloszenie.IdWiad);
          vm.zgloszenie = zgloszenie;
          vm.email = zgloszenie.Email;
          vm.pracownik = zgloszenie.pracownik;
          vm.osobaKontaktowa = zgloszenie.Zglaszajacy;
          vm.telefon = zgloszenie.Telefon;
          vm.tresc = zgloszenie.Opis;
          vm.temat = zgloszenie.Temat;
          vm.rodzaj.id = zgloszenie.Typ;

          vm.tytulNaglowka = "Przypisz osobę prowadzącą do zgłoszenia";
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('ZgloszeniaStareController', ZgloszeniaStareController);

  /** @ngInject */
  function ZgloszeniaStareController() {
    var vm = this;


  }
})();

(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('ZgloszeniaZamowieniaController', ZgloszeniaZamowieniaController);

    /** @ngInject */
    function ZgloszeniaZamowieniaController($window, bootstrapKlasa, Restangular, dostepDoBety, $state,
                                            uprawnieniaSubUsera, security) {
        var vm = this;
        vm.isFirefox = typeof InstallTrigger !== 'undefined';
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.licencje = [];
        vm.paginacjaCo = 20;
        vm.dostepDoBety = dostepDoBety;
        vm.pracownicy = [];
        vm.zgloszenia = [];
        vm.zgloszeniaPrzefiltrowane = {};
        vm.subuser = security.jestSubUserem();
        vm.lokalizacje = [];
        vm.programy = {};
        vm.filter = {page: 1, pageSize: 25};
        vm.filtryTab = {};
        vm.sortowanie = {};
        vm.ikonaTypu = {
            'Konsultacja': 'fa-headphones',
            'Zamówienie': 'fa-file-text-o',
            'Propozycja rozwoju': 'fa-lightbulb-o',
            'Problem': 'fa-bug',
            'Pomoc techniczna': 'fa-wrench'
        };
        vm.statusy = ['Zgłoszone',
            'W trakcie analizy',
            'Oczekuje na obsługę',
            'Oczekuje na klienta',
            'W trakcie analizy',
            'Oczekuje na realizację',
            'Ustalony termin',
            'Zaakceptowane',
            'Wystawiono fakturę',
            'Zamknięte',
            'Odłożone',
            'Zmieniona kategoria',
            'Przywrócone',
        ];
        vm.otwarte = ['Zgłoszone',
            'W trakcie analizy',
            'Oczekuje na obsługę',
            'Oczekuje na klienta',
            'Oczekuje na realizację',
            'Zaakceptowane',
            'Ustalony termin',
            'Przywrócone',
            'Wystawiono fakturę'
        ];
        vm.typy = ['Konsultacja', 'Zamówienie', 'Propozycja rozwoju', 'Problem', 'Pomoc techniczna'];
        vm.kolorDlaStatusu = {
            'Nowe': 'label-primary',
            'W trakcie': 'label-warning',
            'Zamknięte': 'label-success'
        };

        vm.filtry = {
            modul: null,
            status: 'Wszystkie',
            typ: 'Zamówienie',
            pasekWyszukiwania: null
        };
        vm.uzytkownik = {};
        vm.filtruj = filtruj;
        vm.filterOne = filterOne;
        vm.goToState = goToState;
        vm.init = init;
        vm.otworzZgloszenie = otworzZgloszenie;
        vm.zmienSortowanie = zmienSortowanie;

        init();

        function otworzZgloszenie(id) {
            if ((vm.uzytkownik.imie === null || vm.uzytkownik.nazwisko === null || vm.uzytkownik.email === null ||
                    angular.isDefined(vm.uzytkownik.imie) === false || angular.isDefined(vm.uzytkownik.nazwisko) === false ||
                    angular.isDefined(vm.uzytkownik.email) === false) &&
                vm.subuser === true) {
                $state.go('home.subMain.profil', {przekierowanie_zobacz: id})
            } else {
                $state.go('home.subMain.zgloszenia.kartaZgloszeniaKlienta', {zgloszenie: id})
            }
        }

        function init() {
            if (security.jestSubUserem() === true) {
                uprawnieniaSubUsera.getInfo().then(function (result) {
                    vm.uzytkownik = result;
                });
            }
            Restangular.all('oprogramowanie/moduly').getList().then(function (result) {
                angular.forEach(result, function (res) {
                    if (res.kod.toUpperCase() == 'E-KARTOTEKA') {
                        vm.programy[res.kod.toUpperCase()] = {
                            kod: res.kod.toUpperCase(),
                            ikona: 'icon-ek',
                            nazwa: res.nazwa
                        };
                    } else if (res.kod.toUpperCase() == 'EMI') {
                        vm.programy[res.kod.toUpperCase()] = {
                            kod: res.kod.toUpperCase(),
                            ikona: 'letter-em',
                            nazwa: res.nazwa
                        };
                    } else {
                        vm.programy[res.kod.toUpperCase()] = {
                            kod: res.kod.toUpperCase(),
                            ikona: res.ikona + ' letter-icon',
                            nazwa: res.nazwa
                        };
                    }
                });
            });
            Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                vm.lokalizacje = result;
                angular.forEach(result, function (lok) {
                    Restangular.all('licencje/wersje/').getList({
                        id_lok: lok.IdLok,
                        pageSize: 200
                    }).then(function (result) {
                        vm.licencje = result;
                        vm.licencje.push({'Kod': 'e-kartoteka', 'Nazwa': 'e-kartoteka'});
                        vm.licencje.push({'Kod': 'STREFA', 'Nazwa': 'Strefa klienta'});
                        vm.licencje.unshift({'Kod': 'Wszystkie', 'Nazwa': 'Wszystkie'});
                    });
                });

            });


            filtruj();

        }


        function filterOne(idLok, ordering) {
            vm.filtryTab[idLok].ordering = (ordering !== null) ? ordering : '-dataZmiany';
            if (vm.filtry.status !== null && vm.filtry.status === 'Wszystkie') {
                vm.filtryTab[idLok].status = vm.statusy.toString();
            }
            if (vm.filtry.status !== null && vm.filtry.status.indexOf('Otwarte') !== -1) {
                vm.filtryTab[idLok].status = vm.otwarte.toString();
            }
            if (vm.filtry.status !== null && ['Wszystkie', 'Otwarte'].indexOf(vm.filtry.status) === -1) {
                vm.filtryTab[idLok].status = vm.filtry.status;
            }
            if (vm.filtry.modul !== null && vm.filtry.modul !== 'Wszystkie') {
                vm.filtryTab[idLok].modul = vm.filtry.modul;
            } else {
                vm.filtryTab[idLok].modul = null;
            }

            vm.filtryTab[idLok].typ = vm.filtry.typ;

            if (vm.filtry.pasekWyszukiwania !== null && vm.filtry.pasekWyszukiwania.length > 0) {
                vm.filtryTab[idLok].search = vm.filtry.pasekWyszukiwania;
            }
            vm.filtryTab[idLok].idLokalizacji = idLok;
            Restangular.all('/zgloszenia/zgloszenia/').getList(vm.filtryTab[idLok]).then(function (result) {
                vm.zgloszeniaPrzefiltrowane[idLok] = result;
            });
        }

        function filtruj() {
            vm.filter.ordering = '-id';
            if (vm.filtry.status !== null && vm.filtry.status === 'Wszystkie') {
                vm.filter.status = vm.statusy.toString();
            }
            if (vm.filtry.status !== null && vm.filtry.status.indexOf('Otwarte') !== -1) {
                vm.filter.status = vm.otwarte.toString();
            }
            if (vm.filtry.status !== null && ['Wszystkie', 'Otwarte'].indexOf(vm.filtry.status) === -1) {
                vm.filter.status = vm.filtry.status;
            }
            if (vm.filtry.modul !== null && vm.filtry.modul !== 'Wszystkie') {
                vm.filter.modul = vm.filtry.modul.toUpperCase();
            } else {
                vm.filter.modul = null;
            }

            vm.filter.typ = vm.filtry.typ;
            if (vm.filtry.pasekWyszukiwania !== null && vm.filtry.pasekWyszukiwania.length > 0) {
                vm.filter.search = vm.filtry.pasekWyszukiwania;
            } else {
                vm.filter.search = null;
            }

            Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                vm.lokalizacje = result;
                angular.forEach(result, function (lok) {
                    vm.filter.idLokalizacji = lok.IdLok;
                    var params = vm.filter;
                    Restangular.all('/zgloszenia/zgloszenia/').getList(params).then(function (result) {
                        vm.filtryTab[lok.IdLok] = JSON.parse(JSON.stringify(vm.filter));
                        vm.zgloszeniaPrzefiltrowane[lok.IdLok] = result;
                    }).then(function () {
                        angular.forEach(vm.zgloszeniaPrzefiltrowane[lok.IdLok], function (obj) {
                            if (vm.pracownicy.indexOf(obj.klientNazwa) === -1) {
                                vm.pracownicy.push(obj.klientNazwa);
                            }
                        });
                    });
                });
            });
        }

        function goToState(state, params) {
            $state.go(state, params);
        }

        function zmienSortowanie(IdLok, pole) {
            if (angular.isDefined(vm.sortowanie[IdLok]) === false) {
                vm.sortowanie[IdLok] = {order: ''};
            }

            if (vm.sortowanie[IdLok].pole !== pole) {
                vm.sortowanie[IdLok].order = '';
            }
            vm.sortowanie[IdLok].pole = pole;
            if (vm.sortowanie[IdLok].order === '') {
                vm.sortowanie[IdLok].order = '-';
            } else {
                vm.sortowanie[IdLok].order = '';
            }
            var order = vm.sortowanie[IdLok].order + pole;
            filterOne(IdLok, order);
        }
    }
})();
(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('ZgloszeniaNoweController', ZgloszeniaNoweController);

    /** @ngInject */
    function ZgloszeniaNoweController(bootstrapKlasa, $q, security, Restangular, $stateParams, $state, $window,
                                      dostepDoBety, uprawnieniaSubUsera, wyslijPliki, $timeout) {
        var vm = this;
        vm.osobaDoKontaktu = 0;
        vm.dostepDoBety = dostepDoBety;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.typ = $stateParams.typ;
        vm.odpowiedziSerwera = [];
        vm.programy = [];
        vm.licencje = [];
        vm.wersje = [];
        vm.updPacki = [];
        vm.wersjaUpdPack = [];
        vm.lokalizacje = [];
        vm.edytuj = false;
        vm.zgloszenieDoEdycji = [];
        vm.loaded = true;
        vm.dotyczyWydruku = false;
        vm.poradaKrotka = false;
        vm.blokPoKr = true;
        vm.lokalizacja = '';
        vm.uploader = null;
        vm.statusWysylania = 'nie_wyslano';
        vm.najnowszyUpdPack = null;
        vm.brakDanychZglaszajacego = false;
        vm.brakujaceDaneZglaszajacego = [];
        vm.apiPliki = 'zgloszenia/pliki_zgloszenia/';
        vm.ikonaTypu = {
            'Zgłoś potrzebę Konsultacji': 'fa-headphones',
            'Złóż zamówienie': 'fa-file-text-o',
            'Zaproponuj zmianę': 'fa-lightbulb-o',
            'Zgłoś problem': 'fa-bug',
            'Pomoc techniczna': 'fa-wrench'
        };
        vm.modulyWebowe = ['e-kartoteka', 'STREFA', 'EMI'];
        vm.typy = {
            'Zgłoś potrzebę Konsultacji': 'Konsultacja',
            'Złóż zamówienie': 'Zamówienie',
            'Zaproponuj zmianę': 'Propozycja rozwoju',
            'Zgłoś problem': 'Problem',
            'Pomoc techniczna': 'Pomoc techniczna'
        };
        vm.klient = {};
        vm.pola = {
            typ: '',
            tytul: '',
            opis: '',
            modul: null,
            wersjaEZN: '',
            wersjaUpdPack: '',
            idLokalizacji: null,
            nazwaLokalizacji: '',
            klientId: null,
            klientNazwa: '',
            klientTelefon: '',
            klientEmail: '',
            osDoKontaktuNazwa: null,
            osDoKontaktuTelefon: null,
            osDoKontaktuEmail: null,
            status: 'Zgłoszone',
            statusWew: 'Zgłoszone',
            nazwaKlienta: '',
            kodKlienta: null,
            symbolWydruku: '',
            klientPlecMezczyzna: '',
            idPod: null,
            grupa: null,
            poradaKrotka: null,
            dotAplMobilna: false,
            dotDanychOsobowych: false,
            tel_nr_wew: null,
            typ_telefonu: null,
            dotyczyKonwersjiBazyDanych: false,
            godziny_dostepu: null,
            chronione: false
        };

        vm.walidacjaEmail = /^[\w.!#$%&'*+/=?^_`{|}~-]+@[\w.-]+\.\w{2,5}$/;

        vm.send = send;
        vm.updateWersje = updateWersje;
        vm.updateUpdPacki = updateUpdPacki;
        vm.onModulChange = onModulChange;
        vm.init = init;
        vm.przelaczZgloszenieChronione = przelaczZgloszenieChronione;

        function updateWersje() {
            vm.wersje = [];
            if (angular.isDefined(vm.lokalizacja)) {
                return Restangular.all('licencje/wersje/').getList({
                    id_lok: vm.lokalizacja.IdLok,
                    pageSize: 200
                }).then(function (result) {
                    vm.licencje = result;
                    vm.licencje.push({'Kod': 'e-kartoteka', 'Nazwa': 'e-kartoteka'});
                    vm.licencje.push({'Kod': 'STREFA', 'Nazwa': 'Strefa klienta'});
                    vm.licencje = [].concat({'Kod': null, 'Nazwa': ''}, vm.licencje);
                    vm.pola.modul = null;
                    return Restangular.all('licencje/najnowszeWersjeCentraliDlaLok/').getList({
                        pageSize: 20,
                        id_lok: vm.lokalizacja.IdLok
                    }).then(function (result) {
                        angular.forEach(result, function (wersja) {
                            vm.wersje.push(wersja.WersjaLic.toString().substr(0, 2).concat('.', wersja.WersjaLic.toString().substr(2, 2)));
                        });
                        return vm.wersje[0];
                    });
                });
            }
        }

        function onModulChange() {
            vm.pola.wersjaEZN = '';
            vm.wersjaUpdPack = null;
            vm.updPacki = [];
            vm.najnowszyUpdPack = null;
        }

        function updateUpdPacki() {
            return Restangular.all('licencje/updatepackWersji/').getList({
                modul: vm.pola.modul,
                wersja: vm.pola.wersjaEZN
            }).then(function (result) {
                vm.updPacki = result.filter(function (element) {
                    return element.UpdPack !== null;
                });
                vm.updPacki.push({UpdPack: ''});
                vm.najnowszyUpdPack = vm.updPacki.length > 1 ? vm.updPacki[0] : null;
                vm.wersjaUpdPack = null;
                return result;
            });
        }

        function init() {
            if (vm.typy[vm.typ] === 'Konsultacja') {
                Restangular.all('zgloszenia/blokadaKrotkiejPorady/').getList().then(function (result) {
                    if (result.length <= 0) {
                        vm.blokPoKr = false;
                    } else {
                        vm.blokPoKr = result[0].blokada;
                    }
                });
            }
            if (security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function (result) {
                    vm.pola.klientNazwa = result.imie + ' ' + result.nazwisko;
                    vm.pola.klientEmail = result.email;
                    vm.pola.klientId = result.id;
                    vm.pola.klientTelefon = result.Telefon;
                    vm.pola.klientPlecMezczyzna = result.CzyMezczyzna;
                    sprawdzDaneZglaszajacego(result.imie, result.nazwisko, result.email, result.Telefon);
                });
            }

            if (vm.typ === null) {
                $state.go('home.subMain.zgloszenia');
            } else {
                Restangular.all('oprogramowanie/moduly/').getList({pageSize: 200}).then(function (result) {
                    vm.programy = result;
                    //vm.pola.modul = result[0].kod;
                });


                Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                    if (angular.isDefined(result[0])) {
                        vm.pola.nazwaKlienta = result[0].NazwaKr;
                        vm.pola.kodKlienta = result[0].Kod;
                        vm.pola.idPod = result[0].IdPod;
                    }
                });

                Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                    if (result.length === 1) {
                        vm.lokalizacja = result[0];
                        updateWersje();
                    }

                    vm.lokalizacje = result;
                });
                vm.loaded = false;
            }
        }

        function send(pliki) {
            vm.statusWysylania = 'wysylanie';
            vm.pola.poradaKrotka = (vm.poradaKrotka === true) ? true : null;
            if (angular.isDefined(vm.wersjaUpdPack) && vm.wersjaUpdPack !== null) {
                vm.pola.wersjaUpdPack = vm.wersjaUpdPack.UpdPack;
            } else {
                vm.pola.wersjaUpdPack = null;
            }
            if (vm.modulyWebowe.indexOf(vm.pola.modul) !== -1 ||
                ['Złóż zamówienie', 'Pomoc techniczna'].indexOf(vm.typ) !== -1) {
                vm.pola.wersjaEZN = null;
                vm.pola.wersjaUpdPack = null;
            }
            if ('Pomoc techniczna'.indexOf(vm.typ) !== -1) {
                vm.pola.modul = null;
            }
            if (vm.edytuj) {
                vm.zgloszenieDoEdycji.customPUT(vm.pola).then(function (result) {
                    loadFiles(pliki, result.id).then(function () {
                        vm.edytuj = false;
                        $state.go('home.subMain.zgloszenia.listaKlienta');
                    });
                }, function (err) {
                    vm.statusWysylania = 'nie_wyslano';
                });
            } else {
                if (vm.noweZgloszenie.$valid) {
                    if (vm.lokalizacja !== '') {
                        vm.pola.idLokalizacji = vm.lokalizacja.IdLok;
                        vm.pola.nazwaLokalizacji = vm.lokalizacja.NazwaLok;
                    }
                    vm.pola.typ = vm.typy[vm.typ];
                    if (vm.pola.modul !== null) {
                        vm.pola.modul = (vm.pola.modul).toUpperCase();
                    }
                    Restangular.all('zgloszenia/zgloszenia/').post(vm.pola).then(function (result) {
                        loadFiles(pliki, result.id).then(function (result) {
                            $state.go('home.subMain.zgloszenia.listaKlienta');
                        });
                        vm.zgloszenieDoEdycji = result;

                    }, function (error) {
                        vm.statusWysylania = 'nie_wyslano';
                        var errorTemat = 'Wystąpił błąd. Sprawdź czy wszystkie wymagane pola są wypełnione.';
                        if (error.data && error.data.non_field_errors && error.data.non_field_errors[0]) {
                            errorTemat = 'Limit otwartych zgłoszeń. ' + error.data.non_field_errors[0];
                        }
                        vm.odpowiedziSerwera.push({
                            typ: 'E',
                            tekst: errorTemat
                        });
                    });
                } else {
                    vm.statusWysylania = 'nie_wyslano';
                }
            }
        }

        function loadFiles(pliki, idZgl) {
            var params = {idZgloszenia: idZgl, autor: vm.pola.klientNazwa};
            return wyslijPliki.wyslij('/zgloszenia/pliki_zgloszenia/', pliki, params).then(function () {
                },
                function (error) {
                    return $q.reject(error);
                });
        }

        function sprawdzDaneZglaszajacego(imie, nazwisko, email, telefon) {
            vm.brakujaceDaneZglaszajacego = [];
            if (!imie || !nazwisko) {
                vm.brakujaceDaneZglaszajacego.push('imię i nazwisko');
            }
            if (!email) {
                vm.brakujaceDaneZglaszajacego.push('adres e-mail');
            }
            if (!telefon) {
                vm.brakujaceDaneZglaszajacego.push('numer telefonu');
            }
            vm.brakDanychZglaszajacego = vm.brakujaceDaneZglaszajacego.length > 0;
        }

        function przelaczZgloszenieChronione() {
            $timeout(function() {
                if(vm.pola.chronione) {
                    vm.osobaDoKontaktu = 0;
                    vm.pola = Object.assign(vm.pola,
                        {
                            osDoKontaktuNazwa: null,
                            osDoKontaktuTelefon: null,
                            osDoKontaktuEmail: null,
                            tel_nr_wew: null,
                        }
                    )
                }
                
            },0)
            
        }
    }
})();
(function(){
    'use strict';
    angular.module('strefaKlienta')
        .controller('ZgloszeniaListaKlientaController', ZgloszeniaListaKlientaController);

    /** @ngInject */
    function ZgloszeniaListaKlientaController($window, bootstrapKlasa, Restangular, dostepDoBety, $state,
                                              uprawnieniaSubUsera, security, zgloszeniaService) {
        var vm = this;
        vm.isFirefox = typeof InstallTrigger !== 'undefined';
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.licencje = [];
        vm.paginacjaCo = 20;
        vm.dostepDoBety = dostepDoBety;
        vm.pracownicy = [];
        vm.zgloszenia = [];
        vm.zgloszeniaPrzefiltrowane = {};
        vm.subuser = security.jestSubUserem();
        vm.lokalizacje = [];
        vm.programy = {};
        vm.filter = {page:1, pageSize:25};
        vm.filtryTab = {};
        vm.sortowanie = {};
        vm.ikonaTypu = {
            'Konsultacja': 'fa-headphones',
            'Zamówienie': 'fa-file-text-o',
            'Propozycja rozwoju': 'fa-lightbulb-o',
            'Problem': 'fa-bug',
            'Pomoc techniczna': 'fa-wrench'
        };
        vm.statusy = ['Zgłoszone',
            'W trakcie analizy',
            'Oczekuje na obsługę',
            'Oczekuje na klienta',
            'W trakcie analizy',
            'Oczekuje na realizację',
            'Ustalony termin',
            'Zaakceptowane',
            'Wystawiono fakturę',
            'Zamknięte',
            'Odłożone',
            'Zmieniona kategoria',
            'Przywrócone'
        ];
        vm.otwarte = ['Zgłoszone',
            'W trakcie analizy',
            'Oczekuje na obsługę',
            'Oczekuje na klienta',
            'Oczekuje na realizację',
            'Zaakceptowane',
            'Ustalony termin',
            'Wystawiono fakturę',
            'Przywrócone'
        ];
        vm.typy = ['Konsultacja', 'Zamówienie', 'Propozycja rozwoju', 'Problem', 'Pomoc techniczna'];
        vm.kolorDlaStatusu = {
            'Nowe': 'label-primary',
            'W trakcie': 'label-warning',
            'Zamknięte': 'label-success'
        };

        vm.filtry = {
            modul: null,
            status: 'Wszystkie',
            typ: null,
            pasekWyszukiwania: null
        };
        vm.uzytkownik = {};

        vm.pokazInfoPoczekalni = pokazInfoPoczekalni;
        vm.filtruj = filtruj;
        vm.filterOne = filterOne;
        vm.goToState = goToState;
        vm.init = init;
        vm.otworzZgloszenie = otworzZgloszenie;
        vm.zmienSortowanie = zmienSortowanie;

        if(dostepDoBety.info() === false) {
            $window.history.back();
        } else {
            init();
        }
        function otworzZgloszenie(id) {
            if((vm.uzytkownik.imie === null || vm.uzytkownik.nazwisko === null || vm.uzytkownik.email === null ||
                    angular.isDefined(vm.uzytkownik.imie) === false || angular.isDefined(vm.uzytkownik.nazwisko) === false ||
                    angular.isDefined(vm.uzytkownik.email) === false) &&
                vm.subuser === true) {
                $state.go('home.subMain.profil', {przekierowanie_zobacz:id})
            } else {
                $state.go('home.subMain.zgloszenia.kartaZgloszeniaKlienta', {zgloszenie:id})
            }
        }

        function init() {
            if(security.jestSubUserem() === true) {
                uprawnieniaSubUsera.getInfo().then(function (result) {
                    vm.uzytkownik = result;
                });
            }
            Restangular.all('oprogramowanie/moduly').getList().then(function(result) {
                angular.forEach(result, function(res){
                    if(res.kod.toUpperCase() == 'E-KARTOTEKA') {
                        vm.programy[res.kod.toUpperCase()] = {kod:res.kod.toUpperCase(), ikona: 'icon-ek', nazwa: res.nazwa};
                    }
                    else if(res.kod.toUpperCase() == 'EMI') {
                        vm.programy[res.kod.toUpperCase()] = {kod:res.kod.toUpperCase(), ikona: 'letter-em', nazwa: res.nazwa};
                    }
                    else {
                         vm.programy[res.kod.toUpperCase()] = {kod:res.kod.toUpperCase(), ikona: res.ikona + ' letter-icon' , nazwa: res.nazwa};
                    }
                });
            });
            Restangular.all('licencje/lokalizacje/').getList().then(function(result) {
                vm.lokalizacje = result;
                angular.forEach(result, function (lok) {
                    Restangular.all('licencje/wersje/').getList({
                        id_lok: lok.IdLok,
                        pageSize: 200
                    }).then(function (result) {
                        vm.licencje = result;
                        vm.licencje.push({'Kod': 'e-kartoteka', 'Nazwa': 'e-kartoteka'});
                        vm.licencje.push({'Kod': 'STREFA', 'Nazwa': 'Strefa klienta'});
                        vm.licencje.unshift({'Kod':'Wszystkie', 'Nazwa': 'Wszystkie'});
                    });
                });

            });


            filtruj();

        }



        function filterOne(idLok, ordering) {
            vm.filtryTab[idLok].ordering = (ordering!==null) ? ordering : '-dataZmiany';
            if(vm.filtry.status!== null && vm.filtry.status === 'Wszystkie') {
                vm.filtryTab[idLok].status =  vm.statusy.toString();
            }
            if(vm.filtry.status!== null && vm.filtry.status.indexOf('Otwarte')!==-1) {
                vm.filtryTab[idLok].status = vm.otwarte.toString();
            }
            if(vm.filtry.status!== null && ['Wszystkie', 'Otwarte'].indexOf(vm.filtry.status)===-1) {
                vm.filtryTab[idLok].status = vm.filtry.status;
            }
            if(vm.filtry.modul!== null && vm.filtry.modul !== 'Wszystkie') {
                vm.filtryTab[idLok].modul = vm.filtry.modul;
            } else {
                vm.filtryTab[idLok].modul = null;
            }

            if(vm.filtry.typ!== null && vm.filtry.typ !== 'Wszystkie') {
                vm.filtryTab[idLok].typ = vm.filtry.typ;
            }
            if(vm.filtry.pasekWyszukiwania!== null && vm.filtry.pasekWyszukiwania.length>0) {
                vm.filtryTab[idLok].search = vm.filtry.pasekWyszukiwania;
            }
            vm.filtryTab[idLok].idLokalizacji = idLok;
            Restangular.all('/zgloszenia/zgloszenia/').getList(vm.filtryTab[idLok]).then(function(result) {
                vm.zgloszeniaPrzefiltrowane[idLok] = result;
            });
        }

        function filtruj() {
            vm.filter.ordering = '-dataZmiany';
            if(vm.filtry.status!== null && vm.filtry.status === 'Wszystkie') {
                vm.filter.status =  vm.statusy.toString();
            }
            if(vm.filtry.status!== null && vm.filtry.status.indexOf('Otwarte')!==-1) {
                vm.filter.status = vm.otwarte.toString();
            }
            if(vm.filtry.status!== null && ['Wszystkie', 'Otwarte'].indexOf(vm.filtry.status)===-1) {
                vm.filter.status = vm.filtry.status;
            }
            if(vm.filtry.modul!== null && vm.filtry.modul !== 'Wszystkie') {
                vm.filter.modul = vm.filtry.modul.toUpperCase();
            } else {
                vm.filter.modul = null;
            }
            if(vm.filtry.typ!== null && vm.filtry.typ !== 'Wszystkie') {
                vm.filter.typ = vm.filtry.typ;
            } else {
                vm.filter.typ = null;
            }
            if(vm.filtry.pasekWyszukiwania!== null && vm.filtry.pasekWyszukiwania.length>0) {
                vm.filter.search = vm.filtry.pasekWyszukiwania;
            } else {
                vm.filter.search = null;
            }

            Restangular.all('licencje/lokalizacje/').getList().then(function(result) {
                vm.lokalizacje = result;
                angular.forEach(result,function (lok) {
                    vm.filter.idLokalizacji = lok.IdLok;
                    var params = vm.filter;
                    Restangular.all('/zgloszenia/zgloszenia/').getList(params).then(function(result) {
                        vm.filtryTab[lok.IdLok] = JSON.parse(JSON.stringify(vm.filter));
                        vm.zgloszeniaPrzefiltrowane[lok.IdLok] = result;
                    }).then(function() {
                        angular.forEach(vm.zgloszeniaPrzefiltrowane[lok.IdLok], function (obj) {
                            if (vm.pracownicy.indexOf(obj.klientNazwa) === -1) {
                                vm.pracownicy.push(obj.klientNazwa);
                            }
                        });
                    });
                });
            });
        }

        function goToState(state, params) {
            $state.go(state,params);
        }

        function zmienSortowanie(IdLok, pole) {
            if (angular.isDefined(vm.sortowanie[IdLok]) === false) {
                vm.sortowanie[IdLok] = {order: ''};
            }

            if (vm.sortowanie[IdLok].pole !== pole) {
                vm.sortowanie[IdLok].order = '';
            }
            vm.sortowanie[IdLok].pole = pole;
            if (vm.sortowanie[IdLok].order === '') {
                vm.sortowanie[IdLok].order = '-';
            } else {
                vm.sortowanie[IdLok].order = '';
            }
            var order = vm.sortowanie[IdLok].order + pole;
            filterOne(IdLok, order);
        }

        function pokazInfoPoczekalni(zgloszenie) {
            if (zgloszenie.poczekalnia) {
                zgloszeniaService.pokazInfoPoczekalni();
            }
        }
    }
})();
(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('ZgloszeniaKartaKlientaController', ZgloszeniaKartaKlientaController);

    /** @ngInject */
    function ZgloszeniaKartaKlientaController(bootstrapKlasa, lokalizacjaAPI, dostepDoBety, security, uprawnieniaSubUsera,
                                              $stateParams, $sce, Restangular, $uibModal, $state, wyslijPliki, $q,
                                              zamkniete, $window, pobieraniePlikow, statusService, liczbaZgloszen,
                                              zapytanieOfertoweService, uprawnienia, PodgladOfertyModal, zgloszeniaService) {
        var vm = this;
        vm.sce = $sce;
        vm.security = security;
        vm.czySubUser = security.jestSubUserem();
        vm.statusService = statusService;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.dostepDoBety = dostepDoBety;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.numerZgloszenia = $stateParams.zgloszenie;
        vm.komentarz = "";
        vm.apiPliki = '/zgloszenia/pliki_zgloszenia/';
        vm.uploader = null;
        vm.uzytkownikId = null;
        vm.pliki = [];
        vm.wersje = [];
        vm.uzytkownik = [];
        vm.komentarze = [];
        vm.aktywnosci = [];
        vm.podswKomentarza = [];
        vm.podswAktywnosci = [];
        vm.listaPracownikow = [];
        vm.odpowiedziSerwera = [];
        vm.czyZamkniete = zamkniete;
        vm.wyslijPrzywrocText = "";
        vm.programy = {};
        vm.zgloszenie = {};
        vm.oferta = null;
        vm.akceptacjaOferty = uprawnienia !== null ? (uprawnienia.Formularze === true) : false;
        vm.oferty = {};
        vm.ladowanieOfert = true;
        vm.ofertyLista = [];
        vm.statusy = ['Nowe', 'W trakcie', 'Zamknięte'];
        vm.typy = ['Konsultacja', 'Zamówienie', 'Propozycja rozwoju', 'Problem', 'Pomoc techniczna'];
        vm.kolorDlaStatusu = {
            'Nowe': 'label-primary',
            'W trakcie': 'label-warning',
            'Zamknięte': 'label-success'
        };
        vm.ikonaTypu = {
            'Konsultacja': 'fa-headphones',
            'Zamówienie': 'fa-file-text-o',
            'Propozycja rozwoju': 'fa-lightbulb-o',
            'Problem': 'fa-bug',
            'Pomoc techniczna': 'fa-wrench'
        };
        vm.uploadPliki = null;
        vm.dodajDokumenty = false;

        vm.dodajKomentarz = dodajKomentarz;
        vm.init = init;
        vm.getfile = getfile;
        vm.aktualizujLiczbeZgloszen = aktualizujLiczbeZgloszen;
        vm.zaakceptujOferte = zaakceptujOferte;
        vm.odrzucOferte = odrzucOferte;
        vm.pokazOferte = pokazOferte;
        vm.getTrustedHtml = $sce.getTrustedHtml;
        vm.pokazInfoPoczekalni = zgloszeniaService.pokazInfoPoczekalni;

        function init() {

            if (dostepDoBety.info() === false) {
                $window.history.back();
            } else {
                odswierzDane();
                odswierzDaneUzytkownika();

                Restangular.all('oprogramowanie/oprogramowanie').getList({pageSize: 200}).then(function (result) {
                    angular.forEach(result, function (res) {
                        vm.programy[res.Kod] = {kod: res.Kod, ikona: res.Ikona, nazwa: res.Nazwa};
                    });
                });

                Restangular.all('oprogramowanie/wersjeEzn').getList({pageSize: 200}).then(function (result) {
                    angular.forEach(result, function (wersja) {
                        var w2 = wersja.Wersja % 100 === 0 ? '00' : wersja.Wersja % 100;
                        vm.wersje.push(Math.floor(wersja.Wersja / 100) + '.' + w2);
                    });
                });
            }
        }

        function getfile(item) {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, item);
        }

        function odswierzDaneUzytkownika() {
            if (security.isLogin()) {
                if (security.jestSubUserem()) {
                    dajDanePracownikaKlienta();
                } else {
                    if (security.jestDostepDoDanychKlienta()) {
                        dajDaneKlienta();
                    }
                }
            }
        }

        function dajDanePracownikaKlienta() {
            uprawnieniaSubUsera.getInfo().then(function (result) {
                vm.uzytkownik = result.imie + ' ' + result.nazwisko;
                vm.uzytkownikId = result.id;
                if (result.imie === null || result.nazwisko === null || result.email === null ||
                    angular.isDefined(result.imie) === false || angular.isDefined(result.nazwisko) === false ||
                    angular.isDefined(result.email) === false) {
                    $state.go('home.subMain.profil', {przekierowanie_zobacz: vm.zgloszenie.id})
                }
            });
        }

        function dajDaneKlienta() {
            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                if (angular.isDefined(result[0])) {
                    vm.uzytkownik = result[0].Nazwa;
                    vm.uzytkownikId = result[0].IdUsr;
                }
            }, function (error) {
            });
        }

        function odswierzDane() {
            zapytanieOfertoweService.pobierzOferte($stateParams.zgloszenie).then(function (result) {
                vm.ofertyLista = result;
                angular.forEach(result, function (oferta) {
                    vm.oferty[oferta.id] = oferta;
                });
                vm.ladowanieOfert = false;
            });
            Restangular.one('/zgloszenia/zgloszenia/', vm.numerZgloszenia).get().then(function (result) {
                vm.zgloszenie = result;
                if (zamkniete === null) {
                    vm.wyslijPrzywrocText = 'Wyślij komentarz';
                }
                if (zamkniete === false && result.bezMozliwosciPrzywrocenia === false) {
                    vm.wyslijPrzywrocText = 'Przywróć zgłoszenie';
                }
                Restangular.one('/zgloszenia/komentarze/dlaZgloszenia').get({
                    id: result.id,
                    pageSize: 200
                }).then(function (komentarze) {
                    vm.komentarze = vm.komentarze.concat.apply([], komentarze);
                });
                Restangular.one('/zgloszenia/pliki_zgloszenia/dlaZgloszenia').get({
                    id: result.id,
                    pageSize: 200
                }).then(function (pliki) {
                    vm.pliki = pliki;
                });
                if (vm.zgloszenie.modul !== null) {
                    if (vm.zgloszenie.modul.toLowerCase() !== 'e-kartoteka') {
                        vm.zgloszenie.modul = vm.zgloszenie.modul.toUpperCase();
                    } else {
                        vm.zgloszenie.modul = vm.zgloszenie.modul.toLowerCase();
                    }
                    Restangular.one('/oprogramowanie/moduly/').get({modul: vm.zgloszenie.modul}).then(function (modul) {
                        if (modul.results.length > 0) {
                            vm.zgloszenie.modul = modul.results[0];
                        } else {
                            vm.zgloszenie.modul = {nazwa: vm.zgloszenie.modul};
                        }
                    });
                }
            });
        }

        function dodajKomentarz(pliki) {
            if (vm.czyZamkniete === false && vm.zgloszenie.bezMozliwosciPrzywrocenia === false) {
                vm.czyZamkniete = null;
            } else {
                if (vm.komentarz.length > 0 && ['Odrzucone', 'Odłożone', 'Zmieniona kategoria'].indexOf(vm.zgloszenie.status) === -1) {
                    var kom = vm.komentarz;
                    vm.komentarz = '';
                    Restangular.all('/zgloszenia/komentarze/').post({
                        zgloszenie: vm.numerZgloszenia,
                        flaga: false,
                        tresc: kom,
                        uzytkownikNazwa: vm.uzytkownik
                    }).then(function (result) {
                        loadFiles(pliki, result.id).then(function() {
                            vm.dodajDokumenty = false;
                        });
                    }, function () {
                        vm.odpowiedziSerwera.push({
                            typ: 'E',
                            tekst: 'Wystąpił błąd podczas dodawania zgłoszenia.'
                        });
                    }).then(function () {
                        odswierzDane();
                        aktualizujLiczbeZgloszen();
                    });
                }
            }
        }

        function aktualizujLiczbeZgloszen() {
            Restangular.all('zgloszenia/liczbaZgloszen/').getList().then(function (result) {
                if (angular.isDefined(result)) {
                    liczbaZgloszen.liczbaZgloszen = result[0].czekajaceNaKlienta;
                }
            });
        }

        function loadFiles(pliki, idKomentarza) {
            var params = {idZgloszenia: vm.zgloszenie.id, autor: vm.uzytkownik};
            if (idKomentarza != null) params['idKomentarza'] = idKomentarza;
            return wyslijPliki.wyslij('/zgloszenia/pliki_zgloszenia/', pliki, params).then(function () {
                    // return pobierzPliki({id:zgloszenie.id})
                },
                function (error) {
                    return $q.reject(error);
                });
        }

        function zaakceptujOferte(id, uzytkownik) {
            zapytanieOfertoweService.zaakceptujOferte(id, uzytkownik).then(function () {
                odswierzDane();
            });
        }

        function odrzucOferte(id, uzytkownik) {
            zapytanieOfertoweService.odrzucOferte(id, uzytkownik).then(function () {
                odswierzDane();
            });
        }
        function pokazOferte(oferta) {
            PodgladOfertyModal.wyswietlModal(oferta, vm.uzytkownik, vm.akceptacjaOferty).then(function(res) {
                odswierzDane();
            });
        }
    }
})();
(function(){
    'use strict';
    angular.module('strefaKlienta')
        .controller('ZgloszeniaController', ZgloszeniaController);

    /** @ngInject */
    function ZgloszeniaController(bootstrapKlasa, Restangular, dostepDoBety, $state, security, liczbaZgloszen, $timeout) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.serwisZgloszen = liczbaZgloszen;
        vm.liczbaZgloszen = 0;
        vm.dostepDoBety = dostepDoBety;
        vm.czySubUser = security.jestSubUserem();
        vm.blokada = false;
        vm.init = init;
        vm.pobierz = pobierz;
        vm.przejdzDoTworzeniaZgloszenia = przejdzDoTworzeniaZgloszenia;
        if (!vm.czySubUser) {
            $timeout(function () {
                if ($state.current.name === 'home.subMain.zgloszenia') {
                    $state.go('home.subMain.zgloszenia.listaKlienta');
                }
            });
        }

        function przejdzDoTworzeniaZgloszenia(typ) {
            if (typ !== 'Złóż zamówienie') {
                $state.go('home.subMain.zgloszenia.nowe_zgloszenie', {typ: typ});
            } else {
                $state.go('home.subMain.zapytanieOfertowe');
            }
        }

        function init() {
            pobierz();
            Restangular.one('konto/danepodstawowe/').getList().then(function (result) {
                vm.blokada = result[0].Blokada;
            });
        }
        function pobierz() {
            Restangular.all('zgloszenia/liczbaZgloszen/').getList().then(function (result) {
                if (angular.isDefined(result)) {
                    liczbaZgloszen.liczbaZgloszen = result[0].czekajaceNaKlienta;
                }
            });
        }


    }
})();
(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('BlokadaKonsultacjiController', BlokadaKonsultacjiController);

    /** @ngInject */
    function BlokadaKonsultacjiController(bootstrapKlasa, $stateParams) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.blokada = $stateParams.blokada;
    }
})();
(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zarzadzaniePlikamiController', zarzadzaniePlikamiController);

    /** @ngInject */
    function zarzadzaniePlikamiController(Restangular, $stateParams, $state, security, $sce, $window, Popup, kategorie) {
        var vm = this;
        vm.window = $window;
        vm.security = security;
        vm.api = '/zarzadzaniePlikami/zarzadzaniePlikami/';
        vm.szukajTekst = '';
        vm.wybranyWiersz = null;
        vm.rowTemplate = $("#rowTemplate").html();

        vm.kategorie=[
            {id:0,nazwa:'slonie',ikona:'letter-n'},
            {id:1,nazwa:'ekartoteka',ikona:'letter-e'},
            {id:2,nazwa:'kasa',ikona:'letter-k'},
            {id:3,nazwa:'magazyn',ikona:'letter-m'},
            {id:4,nazwa:'srodki_trwale',ikona:'letter-s'},
            {id:5,nazwa:'ton',ikona:'letter-t'},
            {id:6,nazwa:'banki',ikona:'letter-b'},
            {id:7,nazwa:'wklady',ikona:'letter-w'},
            {id:8,nazwa:'kip',ikona:'letter-p'},
            {id:9,nazwa:'zod',ikona:'letter-d'},
            {id:10,nazwa:'fakturowanie_sprzedazy',ikona:'letter-v'},
            {id:11,nazwa:'fk',ikona:'letter-f'},
            {id:12,nazwa:'regulaminy'},
            {id:13,nazwa:'formularze'},
            {id:14,nazwa:'informacje_dedykowane'}
        ];
        vm.kategorie = [{title: ''}];
        vm.columns = [
            {
                fieldName: "tytul",
                title: "Nazwa",
                colTemplate: '<span>{{row.tytul}}</span>',
                sortable: "tytul",
                class: "table-cell-20-width",
                show: true
            },
            {
                fieldName: "kategoria",
                title: "Kategoria",
                colTemplate: '<span>{{row.kategoriaNazwa}}</span>',
                sortable: "kategoria",
                class: "table-cell-20-width",
                filter: {kategoria: "select"},
                filterData: vm.kategorie,
                show: true
            },
            {
                fieldName: "edycja",
                title: "",
                class: "table-cell-5-width",
                colTemplate: $("#Modyfikacja").html(),
                show: true
            }
        ];
        vm.init = init;
        vm.getFilter = getFilter;

        function init() {
            angular.forEach(kategorie, function(kategoria) {
                vm.kategorie.push({id: kategoria.id, title: kategoria.nazwa})
            })
        }

        function getFilter() {
            var filter = {};
            if (vm.szukajTekst.length > 0){
                vm.filter['search'] = vm.szukajTekst;
            }
            return filter;
        }
    }

})();
(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zarzadzaniePlikamiEdycjaController', zarzadzaniePlikamiEdycjaController);

    /** @ngInject */
    function zarzadzaniePlikamiEdycjaController(Restangular, $stateParams, $state, security, $sce, $window, Popup, plik,
                                                kategorie, wyslijPliki, bootstrapKlasa, lokalizacjaAPI, $http,
                                                $timeout, pobieraniePlikow) {
        var vm = this;
        vm.window = $window;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.security = security;
        vm.plik = plik;
        vm.kategorie = kategorie;
        vm.apiPliki = '/zarzadzaniePlikami/plikFile/';
        vm.uploader = null;
        vm.odpowiedziSerwera = [];
        vm.pokaz_upload_pliku = false;

        vm.init = init;
        vm.zapisz = zapisz;
        vm.usunPowiazanyPlik = usunPowiazanyPlik;
        vm.usunPlik = usunPlik;
        vm.getFile = getFile;

        function init() {
        }

        function zapisz(pliki) {
            plik.put().then(function(result) {
                var params = {plik: plik.id};

                wyslijPliki.wyslij('/zarzadzaniePlikami/plikFile/', pliki, params).then(function () {
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Pomyślnie dodano plik'
                    });
                    vm.pokaz_upload_pliku = false;
                    $state.reload()
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas wysyłania pliku widocznego dla wszystkich'
                    });
                });
            }, function (error) {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd podczas wysyłania danych'
                });
            })
        }

        function usunPowiazanyPlik(id) {

            Popup.wyswietlInfo('Potwierdzenie', 'Czy na pewno chcesz usunąć plik?',
                function() {
                    Restangular.all('/zarzadzaniePlikami/plikFile/').customDELETE(id).then(function() {
                        vm.odpowiedziSerwera.push({
                            typ: 'S',
                            tekst: 'Pomyślnie usunięto powiązany plik'
                        });
                        $state.reload()
                    }, function(error) {
                        vm.odpowiedziSerwera.push({
                            typ: 'E',
                            tekst: 'Nie udało się usunąć powiązanego pliku'
                        });
                    })
                },null);
        }

        function usunPlik() {
            Popup.wyswietlInfo('Potwierdzenie', 'Czy na pewno chcesz usunąć plik?',
                function() {
                    Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami/').customDELETE(vm.plik.id)
                        .then(function() {
                            vm.odpowiedziSerwera.push({
                                typ: 'S',
                                tekst: 'Pomyślnie usunięto plik'
                            });
                        }, function (e) {
                            vm.odpowiedziSerwera.push({
                                typ: 'E',
                                tekst: 'Nie udało się usunąć pliku.'
                            });
                        });
                },null);
        }

        function getFile(plik) {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, plik);
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zarzadzaniePlikamiDodajController', zarzadzaniePlikamiDodajController);

    /** @ngInject */
    function zarzadzaniePlikamiDodajController(Restangular, $stateParams, $state, security, $sce, $window, Popup,
                                                kategorie, wyslijPliki, bootstrapKlasa) {
        var vm = this;
        vm.window = $window;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.security = security;
        vm.plik = {kolejnosc: 0, tytul: ''};
        vm.kategorie = kategorie;
        vm.uploader = null;
        vm.odpowiedziSerwera = [];
        vm.pokaz_upload_pliku = false;

        vm.init = init;
        vm.zapisz = zapisz;

        function init() {
        }

        function zapisz(pliki) {
            Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami/').post(vm.plik).then(function(result) {
                var params = {plik: result.id};

                wyslijPliki.wyslij('/zarzadzaniePlikami/plikFile/', pliki, params).then(function () {
                    vm.odpowiedziSerwera.push({
                            typ: 'S',
                            tekst: 'Pomyślnie dodano plik'
                        });
                    vm.pokaz_upload_pliku = false;
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas wysyłania pliku widocznego dla wszystkich'
                    });
                });
            }, function (error) {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd podczas wysyłania danych'
                });
            })
        }
    }

})();
(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zapytanieOfertoweZmianaLimitowController', zapytanieOfertoweZmianaLimitowController);

    /** @ngInject */
    function zapytanieOfertoweZmianaLimitowController(zapytanieOfertoweService, bootstrapKlasa, Restangular,
                                                      ZmianaLimitowZOModal) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.produkty = {};
        vm.nazwyWidocznychProduktow = [];
        vm.nazwyWidocznychParametrow = {};
        vm.parametryProduktu = {};
        vm.parametryZEZN = {};
        vm.ladowanie = true;
        vm.lokalizacje = null;

        init();
        vm.getKeys = getKeys;
        vm.dodaj = dodaj;
        vm.odswiezLicencje = odswiezLicencje;

        function getKeys(obj) {
            return Object.keys(obj);
        }

        function dodaj(produkt) {
            // console.log(produkt);
            // console.log(vm.produkty[produkt.nazwa]);
            var form = {
                produkt: vm.produkty[produkt.nazwa],
                ograniczenia: {}
            };
            angular.forEach(produkt.ograniczenia, function (ograniczenie) {
                if (getKeys(vm.nazwyWidocznychParametrow[produkt.nazwa]).indexOf(ograniczenie.nazwa) !== -1) {
                    form.ograniczenia[ograniczenie.nazwa] = {
                        ograniczenie: ograniczenie.ograniczenie,
                        nazwa_ezn: ograniczenie.nazwa
                    };
                    angular.forEach(vm.produkty[produkt.nazwa].parametry, function (param) {
                        if (param.nazwa_ezn === ograniczenie.nazwa) {
                            form.ograniczenia[ograniczenie.nazwa].parametr = param;
                        }
                    });
                }
            });
            console.log(form);
            // console.log(vm.produkty);
            ZmianaLimitowZOModal.wyswietlModal(vm.lokalizacja, 'zmiana-limitow', form);
        }

        function odswiezLicencje() {
            vm.ladowanie = true;
            if (vm.lokalizacja !== null && vm.lokalizacja !== undefined) {
                zapytanieOfertoweService.ustawLokalizacje(vm.lokalizacja);
                zapytanieOfertoweService.pobierzLicencjeZOgraniczeniami(vm.lokalizacja.IdLok).then(
                    function (result) {
                        vm.ladowanie = false;
                        vm.licencjeLokalizacji = result;
                    }
                );
            } else {
                vm.ladowanie = false;
            }
        }

        function init() {
            vm.lokalizacja = zapytanieOfertoweService.dajKoszyk().lokalizacja;
            zapytanieOfertoweService.pobierzProdukty('zmiana-limitow').then(
                function (result) {
                    angular.forEach(result, function (produkt) {
                        vm.produkty[produkt.nazwa] = produkt;
                    });
                    vm.nazwyWidocznychProduktow = result.map(function (el) {
                        angular.forEach(el.parametry, function (param) {
                            if (vm.nazwyWidocznychParametrow[el.nazwa] === undefined ||
                                vm.nazwyWidocznychParametrow[el.nazwa] === null) {
                                vm.nazwyWidocznychParametrow[el.nazwa] = {};
                            }
                            vm.nazwyWidocznychParametrow[el.nazwa][param.nazwa_ezn] = param.prezentowana_nazwa;
                        });
                        return el.nazwa;
                    });

                }
            );
            Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                if (result.length === 1) {
                    vm.lokalizacja = result[0];
                }
                odswiezLicencje();

                vm.lokalizacje = result;
            });
        }


    }

})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('ZmianaLimitowZOModal', ZmianaLimitowZOModal);

    ZmianaLimitowZOModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa', 'zapytanieOfertoweService'];

    /* @ngInject */
    function ZmianaLimitowZOModal($uibModal, Restangular, bootstrapKlasa, zapytanieOfertoweService) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(lokalizacja, kategoria, produkt) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/home/zapytanieOfertowe/zmianaLimitow.modal.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa, zapytanieOfertoweService) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.lokalizacja = lokalizacja;
                    vm.produkt = produkt;
                    vm.brakZmiany = true;
                    vm.parametry = [];
                    vm.ladowanie = true;
                    vm.form = {
                        produkt: vm.produkt.produkt,
                        parametry: {},
                        kategoria: kategoria,
                        lokalizacja: lokalizacja
                    };
                    vm.init = init;
                    vm.getKeys = getKeys;
                    vm.sprawdzWartosci = sprawdzWartosci;

                    function getKeys(obj) {
                        return Object.keys(obj).filter(function (key) {
                            return key !== 'keys';
                        });
                    }

                    function sprawdzWartosci() {
                        var wartosc = true;
                        angular.forEach(vm.getKeys(vm.form.parametry), function (param) {
                            if (vm.form.parametry[param].poprzednia_wartosc !== vm.form.parametry[param].wartosc) {
                                wartosc = false;
                            }
                        });
                        vm.brakZmiany = wartosc;
                    }

                    function init() {
                        angular.forEach(vm.produkt.produkt.parametry, function (param) {
                            console.log('pp', param);
                            vm.form.parametry[param.id] = {
                                id: param.id,
                                prezentowana_nazwa: param.prezentowana_nazwa,
                                nazwa: param.prezentowana_nazwa,
                                wartosc: null,
                                sposob_pilnowania: param.sposob_pilnowania,
                            };

                            zapytanieOfertoweService.pobierzParametr(param.id).then(
                                function (res) {
                                    console.log('w', res);
                                    if (param.sposob_pilnowania === 'select') {
                                        vm.form.parametry[param.id].wartosci = res.wartosci;
                                    }
                                    vm.form.parametry[param.id].dodatkowe_informacje = res.dodatkowe_informacje;
                                });


                        });

                        console.log('p', vm.produkt.produkt.parametry)

                        angular.forEach(getKeys(produkt.ograniczenia), function (ograniczenie) {
                            vm.form.parametry[produkt.ograniczenia[ograniczenie].parametr.id] = {
                                id: produkt.ograniczenia[ograniczenie].parametr.id,
                                prezentowana_nazwa: produkt.ograniczenia[ograniczenie].parametr.prezentowana_nazwa,
                                nazwa: produkt.ograniczenia[ograniczenie].parametr.prezentowana_nazwa,
                                wartosc: produkt.ograniczenia[ograniczenie].ograniczenie,
                                poprzednia_wartosc: produkt.ograniczenia[ograniczenie].ograniczenie,
                                sposob_pilnowania: produkt.ograniczenia[ograniczenie].parametr.sposob_pilnowania
                            };
                        });
                        console.log(vm.form);
                    }

                    vm.modalOk = modalOk;
                    vm.modalClose = modalClose;


                    function modalOk(result) {
                        zapytanieOfertoweService.dodajDoKoszyka(vm.form);
                        $uibModalInstance.close('ok');
                    }

                    function modalClose(result) {
                        return $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'lg'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zapytanieOfertoweOldController', zapytanieOfertoweOldController);

    /** @ngInject */
    function zapytanieOfertoweOldController($state, $timeout, anchorScrollSmooth, Restangular, bootstrapKlasa) {
        var vm = this;
        vm.api = '/potKli/zapytanieOfertowe/';
        vm.btnWyslijDisabled = false;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.odpowiedziSerwera = [];
        vm.wyslano = false;
        vm.parametry = {
            imieINazwisko: '',
            stanowisko: '',
            telefon: '',
            email: '',
            nazwaFirmy: '',
            ulica: '',
            nrBudynkuILokalu: '',
            kodPocztowy: '',
            miejscowosc: '',
            telefonFirmowy: '',
            lokaliOgolem: '',
            dominujacyTyp: null,
            dominujacyInnyTyp: ''
        };
        vm.pracownicy = [{
            id: 0,
            imieINazwisko: '',
            stanowisko: '',
            telefon: '',
            email: '',
            osobaDoKontaktu: true
        }];

        vm.wyslij = wyslij;
        vm.dodajPracownika = dodajPracownika;
        vm.usunPracownika = usunPracownika;

        function dodajPracownika() {
            vm.pracownicy.push({
                id: Date.now(),
                imieINazwisko: '',
                stanowisko: '',
                telefon: '',
                email: '',
                osobaDoKontaktu: false
            });
        }

        function usunPracownika(id) {
            vm.pracownicy = vm.pracownicy.filter(function (pracownik) {
                if (pracownik.id !== id) {
                    return true;
                } else {
                    if (pracownik.osobaDoKontaktu === true) {
                        vm.idOsobyDoKontaktu = 0;
                    }
                    return false;
                }
            });
        }

        function filterPracownikOsDoKontaktu(pracownik){
            return pracownik.id === 0;
        }
        function wyslij() {
            var params = {
                tytul: 'Zapytanie ofertowe / Informacja',
                opis: przygotujTrescZgloszenia(),
                typ: 'Zamówienie',
                osDoKontaktuNazwa: vm.pracownicy.find(filterPracownikOsDoKontaktu).imieINazwisko,
                osDoKontaktuEmail: vm.pracownicy.find(filterPracownikOsDoKontaktu).email,
                osDoKontaktuTelefon: vm.pracownicy.find(filterPracownikOsDoKontaktu).telefon,
                telefon: (vm.parametry.telefonFirmowy.length > 3) ? vm.parametry.telefonFirmowy : vm.parametry.telefon,
                nazwaKlienta: vm.parametry.nazwaFirmy,
                ulica: vm.parametry.ulica,
                nrBudynku: vm.parametry.nrBudynkuILokalu,
                kodPocztowy: vm.parametry.kodPocztowy,
                miejscowosc: vm.parametry.miejscowosc,
            };

            Restangular.all(vm.api).post(params).then(
                function (result) {
                    vm.wyslano = true;
                    anchorScrollSmooth.scrollToTop();
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Pomyślnie wysłano zapytanie ofertowe'
                    });

                    $timeout(function () {
                        $state.go('home.stronaGlowna');
                    }, 5000);
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Nie udało się wysłać zapytania.'
                    });
                }
            );
        }

        function przygotujTrescZgloszenia() {
            var tekst = '';
            tekst += '<b>Firma</b></br>';
            tekst += 'Nazwa firmy: ' + vm.parametry.nazwaFirmy + '</br>';
            tekst += 'Ulica: ' + vm.parametry.ulica + '</br>';
            tekst += 'Nr budynku / nr lokalu: ' + vm.parametry.nrBudynkuILokalu + '</br>';
            tekst += 'Kod pocztowy: ' + vm.parametry.kodPocztowy + '</br>';
            tekst += 'Miejscowość: ' + vm.parametry.miejscowosc + '</br>';
            tekst += (vm.parametry.telefonFirmowy.length > 3) ? 'Telefon: ' + vm.parametry.telefonFirmowy + '</br>' : '';

            tekst += '</br><b>Informacje o zasobach</b></br>';
            tekst += 'Liczba lokali ogółem: ' + vm.parametry.lokaliOgolem + '</br>';
            tekst += 'Dominujący typ obsługiwanych nieruchomości: ' +
                ((vm.parametry.dominujacyTyp !== 'inny') ? vm.parametry.dominujacyTyp : vm.parametry.dominujacyInnyTyp);

            tekst += '</br></br><b>Dane kontaktowe</b></br>';

            angular.forEach(vm.pracownicy, function (pracownik) {
                tekst += 'Imię i nazwisko: ' + pracownik.imieINazwisko + '</br>';
                tekst += (pracownik.stanowisko.length > 1) ? 'Stanowisko: ' + pracownik.stanowisko + '</br>' : '';
                tekst += 'Telefon kontaktowy: ' + pracownik.telefon + '</br>';
                tekst += 'email: ' + pracownik.email + '</br></br>';
            });

            return tekst;
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zapytanieOfertoweController', zapytanieOfertoweController);

    /** @ngInject */
    function zapytanieOfertoweController($state, $timeout, anchorScrollSmooth, Restangular, InneZapytanieZOModal) {
        var vm = this;
        vm.otworzInneZapytanie = otworzInneZapytanie;

        function otworzInneZapytanie() {
            Restangular.all('/zapytanie-ofertowe/produkt').getList({nazwa: 'Inne zapytanie handlowe'}).then(
                function (res) {
                    InneZapytanieZOModal.wyswietlModal(Object.assign(res[0], {nazwa: 'Inne zapytanie handlowe / Informacja'}));
                }
            );

        }
    }

})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('UsunZKoszykaZOModal', UsunZKoszykaZOModal);

    UsunZKoszykaZOModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa', 'zapytanieOfertoweService'];

    /* @ngInject */
    function UsunZKoszykaZOModal($uibModal, Restangular, bootstrapKlasa, zapytanieOfertoweService) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(produkt) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/home/zapytanieOfertowe/usunZKoszyka.modal.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa, zapytanieOfertoweService) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.produkt = produkt;
                    vm.init = init;

                    function init() {

                    }

                    vm.modalOk = modalOk;
                    vm.modalClose = modalClose;


                    function modalOk() {
                        return $uibModalInstance.close(zapytanieOfertoweService.usunZKoszyka(produkt));
                    }

                    function modalClose() {
                        return $uibModalInstance.dismiss(null);
                    }
                },
                controllerAs: 'vmModal',
                size: 'lg'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zapytanieOfertowePakietyIUslugiController', zapytanieOfertowePakietyIUslugiController);

    /** @ngInject */
    function zapytanieOfertowePakietyIUslugiController(zapytanieOfertoweService, bootstrapKlasa, Restangular,
                                                       NowyModulZOModal, $sce) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.produkty = [];
        vm.getTrustedHtml = $sce.getTrustedHtml;
        vm.ladowanie = true;
        init();
        vm.dodaj = dodaj;
        vm.zmianaLokalizacji = zmianaLokalizacji;

        function zmianaLokalizacji() {
            zapytanieOfertoweService.ustawLokalizacje(vm.lokalizacja);
        }

        function dodaj(produkt) {
            NowyModulZOModal.wyswietlModal(vm.lokalizacja, 'pakiety-i-uslugi', produkt);
        }

        function init() {
            vm.lokalizacja = zapytanieOfertoweService.dajKoszyk().lokalizacja;

            zapytanieOfertoweService.pobierzProdukty('pakiety-i-uslugi').then(
                function (result) {
                    vm.produkty = result;
                }
            );
            Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                if (result.length === 1) {
                    vm.lokalizacja = result[0];
                }
                vm.ladowanie = false;
                vm.lokalizacje = result;
            });
        }


    }

})();

(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zapytanieOfertoweNowyModulController', zapytanieOfertoweNowyModulController);

    /** @ngInject */
    function zapytanieOfertoweNowyModulController(zapytanieOfertoweService, bootstrapKlasa, Restangular,
                                                  NowyModulZOModal, $sce) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.produkty = [];
        vm.posiadaneLicencje = [];
        vm.ladowanie = true;
        vm.getTrustedHtml = $sce.getTrustedHtml;
        init();
        vm.dodaj = dodaj;
        vm.zmienLokalizacje = zmienLokalizacje;

        function dajModulyWKoszyku(idLok) {
            return zapytanieOfertoweService.dajKoszyk().produkty.map(function (produkt) {
                if (produkt.kategoria === 'nowy-modul' && produkt.lokalizacja.IdLok === idLok) {
                    return produkt.produkt.nazwa;
                }
            });
        }

        function zmienLokalizacje() {
            vm.ladowanie = true;
            zapytanieOfertoweService.ustawLokalizacje(vm.lokalizacja);
            return zapytanieOfertoweService.pobierzLicencjeLokalizacji(vm.lokalizacja.IdLok).then(function (result) {
                vm.posiadaneLicencje = Object.keys(result).concat(dajModulyWKoszyku(vm.lokalizacja.IdLok));
                vm.ladowanie = false;
            });
        }

        function dodaj(produkt) {
            NowyModulZOModal.wyswietlModal(vm.lokalizacja, 'nowy-modul', produkt);
        }

        function init() {
            vm.lokalizacja = zapytanieOfertoweService.dajKoszyk().lokalizacja;
            Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                vm.lokalizacja = result[0];

                vm.lokalizacje = result;
                vm.ladowanie = false;
                zmienLokalizacje().then(
                    zapytanieOfertoweService.pobierzProdukty('nowy-modul').then(
                        function (r) {
                            vm.produkty = r;
                        }
                    ));
            });
        }


    }

})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('NowyModulZOModal', NowyModulZOModal);

    NowyModulZOModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa', 'zapytanieOfertoweService'];

    /* @ngInject */
    function NowyModulZOModal($uibModal, Restangular, bootstrapKlasa, zapytanieOfertoweService) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(lokalizacja, kategoria, produkt) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/home/zapytanieOfertowe/nowyModul.modal.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa, zapytanieOfertoweService) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.lokalizacja = lokalizacja;
                    vm.produkt = produkt;
                    vm.parametry = [];
                    vm.form = {
                        produkt: vm.produkt,
                        parametry: {},
                        kategoria: kategoria,
                        lokalizacja: lokalizacja
                    };
                    vm.init = init;

                    function init() {
                        zapytanieOfertoweService.pobierzParametryProduktu(produkt.id).then(
                            function (result) {
                                vm.parametry = result;
                                angular.forEach(result, function (parametr) {
                                    vm.form.parametry[parametr.id] = {
                                        id: parametr.id,
                                        nazwa: parametr.prezentowana_nazwa,
                                        kolejnosc: parametr.kolejnosc,
                                        wartosc: null
                                    };
                                });
                                vm.ladowanie = false;
                            }
                        );
                    }

                    vm.modalOk = modalOk;
                    vm.modalClose = modalClose;


                    function modalOk(result) {
                        console.log(vm.form);
                        zapytanieOfertoweService.dodajDoKoszyka(vm.form);
                        $uibModalInstance.close('ok');

                    }

                    function modalClose(result) {
                        return $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'lg'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zapytanieOfertoweKoszykController', zapytanieOfertoweKoszykController);

    /** @ngInject */
    function zapytanieOfertoweKoszykController(zapytanieOfertoweService, bootstrapKlasa, store, Restangular, lokalizacje,
                                               $state, UsunZKoszykaZOModal) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.koszyk = zapytanieOfertoweService.dajKoszyk();
        vm.lokalizacje = lokalizacje;
        vm.user = null;
        vm.osDoKontaktu = null;
        vm.kategorie = {
            'zmiana-limitow': 'zmiana limitów',
            'nowy-modul': 'nowy moduł',
            'pakiety-i-uslugi': 'usługi',
            'aktualizacja': 'aktualizacja'
        };
        vm.kategorieDict = {};
        vm.brakDanychZglaszajacego = false;
        vm.brakujaceDaneZglaszajacego = [];


        init();
        vm.getKeys = getKeys;
        vm.usunZKoszyka = usunZKoszyka;
        vm.wyslij = wyslij;
        vm.dajWartosc = dajWartosc;


        function getKeys(obj) {
            return Object.keys(obj);
        }

        function usunZKoszyka(produkt) {
            console.log(produkt);
            UsunZKoszykaZOModal.wyswietlModal(produkt).then(function (res) {
                if (res) {
                    vm.koszyk = res;
                }
            });
            // vm.koszyk = zapytanieOfertoweService.usunZKoszyka(produkt);

        }

        function init() {
            Restangular.all('/subUser/subUser').getList().then(function (result) {
                vm.user = result[0];
                vm.osDoKontaktu = Object.assign({}, result[0]);
                sprawdzDaneZglaszajacego(result[0].imie, result[0].nazwisko, result[0].email, result[0].Telefon);
            });

            angular.forEach(vm.kategorie, function (kategoria) {
                vm.kategorieDict[kategoria.kategoria] = kategoria.nazwa;
            });
        }

        function wyslij() {
            if (vm.user.imie !== vm.osDoKontaktu.imie ||
                vm.user.nazwisko !== vm.osDoKontaktu.nazwisko ||
                vm.user.Telefon !== vm.osDoKontaktu.Telefon ||
                vm.user.email !== vm.osDoKontaktu.email) {

                vm.koszyk.osoba_do_kontaktu = vm.osDoKontaktu;
            }
            vm.koszyk.zglaszajacy = {
                pelnaNazwa: (vm.user.imie + ' ' + vm.user.nazwisko),
                Telefon: vm.user.Telefon,
                email: vm.user.email
            };
            Restangular.all('/zapytanie-ofertowe/noweZapytanie').post(JSON.stringify(vm.koszyk)).then(
                function (result) {
                    zapytanieOfertoweService.resetKoszyka();
                    $state.go('home.subMain.zgloszenia.zamowienia',{},{reload:true});
                }
            );
        }
        function sprawdzDaneZglaszajacego(imie, nazwisko, email, telefon) {
            vm.brakujaceDaneZglaszajacego = [];
            if (!imie || !nazwisko) {
                vm.brakujaceDaneZglaszajacego.push('imię i nazwisko');
            }
            if (!email) {
                vm.brakujaceDaneZglaszajacego.push('adres e-mail');
            }
            if (!telefon) {
                vm.brakujaceDaneZglaszajacego.push('numer telefonu');
            }
            vm.brakDanychZglaszajacego = vm.brakujaceDaneZglaszajacego.length > 0;
        }

        function dajWartosc(el) {
        if (el === 'True' || el === true) {
          return 'Tak';
        }else if(el === 'None' || el === null) {
          return '?';
        } else if(el === 'False' || el === false  ) {
          return 'Nie';
        } else {
          return  el;
        }
      }


    }

})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('InneZapytanieZOModal', InneZapytanieZOModal);

    InneZapytanieZOModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa', 'zapytanieOfertoweService'];

    /* @ngInject */
    function InneZapytanieZOModal($uibModal, Restangular, bootstrapKlasa, zapytanieOfertoweService) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(produkt) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/home/zapytanieOfertowe/inneZapytanie.modal.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa, zapytanieOfertoweService) {
                    var vm = this;
                    vm.bootstrapKlasa = bootstrapKlasa;
                    vm.produkt = produkt;
                    vm.parametry = [{
                        id: 1,
                        nazwa: 'Treść',
                        wartosc: null
                    }];
                    vm.form = {
                        produkt: vm.produkt,
                        parametry: {
                            1: {
                                id: 1,
                                nazwa: 'Treść',
                                wartosc: null
                            }
                        },
                        kategoria: 'inne-zapytanie-handlowe',
                        lokalizacja: zapytanieOfertoweService.dajKoszyk().lokalizacja
                    };
                    vm.init = init;
                    vm.zmianaLokalizacji = zmianaLokalizacji;

                    function zmianaLokalizacji() {
                        zapytanieOfertoweService.ustawLokalizacje(vm.form.lokalizacja);
                    }

                    function init() {
                        Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                            if (result.length === 1) {
                                vm.form.lokalizacja = result[0];
                            }
                            vm.lokalizacje = result;
                        });
                    }

                    vm.modalOk = modalOk;
                    vm.modalClose = modalClose;


                    function modalOk(result) {
                        zapytanieOfertoweService.dodajDoKoszyka(vm.form);
                        $uibModalInstance.close('ok');

                    }

                    function modalClose(result) {
                        return $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'lg'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('zapytanieOfertoweAktualizacjaController', zapytanieOfertoweAktualizacjaController);

    /** @ngInject */
    function zapytanieOfertoweAktualizacjaController(zapytanieOfertoweService, bootstrapKlasa, Restangular,
                                                     NowyModulZOModal) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.wersjaOprogramowania = {};
        vm.produkty = [];
        vm.lokalizacje = [];
        vm.ladowanie = true;
        init();
        vm.dodaj = dodaj;
        vm.zmianaLokalizacji = zmianaLokalizacji;

        function zmianaLokalizacji() {
            zapytanieOfertoweService.ustawLokalizacje(vm.lokalizacja);
        }

        function dodaj(produkt) {
            NowyModulZOModal.wyswietlModal(vm.lokalizacja, 'aktualizacja', produkt);
        }

        function init() {
            vm.lokalizacja = zapytanieOfertoweService.dajKoszyk().lokalizacja;

            Restangular.all('konto/licencje/').getList().then(function (result) {
                vm.wersjaOprogramowania.wersjaAktualna = (result[0].Wersja ? result[0].Wersja / 10000 : '');
                vm.wersjaOprogramowania.wersjaNajnowsza = (result[0].WersjaSp ? result[0].WersjaSp / 10000 : '');
                vm.wersjaOprogramowania.nowsza = parseFloat((result[0].Wersja ? result[0].Wersja / 10000 : '')) < parseFloat((result[0].WersjaSp ? result[0].WersjaSp / 10000 : ''));
                vm.wersjaOprogramowania.asa = result[0].Wersja_Asa;
                vm.ladowanie = false;

            }, function (error) {
            });

            zapytanieOfertoweService.pobierzProdukty('aktualizacja').then(
                function (result) {
                    vm.produkty = result;
                }
            );
            Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                if (result.length === 1) {
                    vm.lokalizacja = result[0];
                }
                vm.lokalizacje = result;
            });

        }


    }

})();

(function () {
    'use strict';
    angular.module('strefaKlienta').factory('AktualizacjaZOModal', AktualizacjaZOModal);

    AktualizacjaZOModal.$inject = ['$uibModal', 'Restangular', 'bootstrapKlasa', 'zapytanieOfertoweService'];

    /* @ngInject */
    function AktualizacjaZOModal($uibModal, Restangular, bootstrapKlasa, zapytanieOfertoweService) {

        var service = {
            wyswietlModal: wyswietlModal
        };

        function wyswietlModal(lokalizacja, kategoria, produkt) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/home/zapytanieOfertowe/aktualizacja.modal.html',
                controller: function ($uibModalInstance, Restangular, bootstrapKlasa, zapytanieOfertoweService) {
                    var vm = this;
                                      vm.bootstrapKlasa = bootstrapKlasa;
                    vm.lokalizacja = lokalizacja;
                    vm.produkt = produkt;
                    vm.parametry = [];
                    vm.form = {
                        produkt: vm.produkt,
                        parametry: {},
                        kategoria: kategoria,
                        lokalizacja: lokalizacja
                    };
                    vm.init = init;

                    function init() {
                        zapytanieOfertoweService.pobierzParametryProduktu(produkt.id).then(
                            function (result) {
                                vm.parametry = result;
                                angular.forEach(result, function (parametr) {
                                    vm.form.parametry[parametr.id] = {
                                        id: parametr.id,
                                        nazwa: parametr.prezentowana_nazwa,
                                        wartosc: null
                                    };
                                });
                                vm.ladowanie = false;
                            }
                        );
                    }

                    vm.modalOk = modalOk;
                    vm.modalClose = modalClose;


                    function modalOk(result) {
                        console.log(vm.form);
                        zapytanieOfertoweService.dodajDoKoszyka(vm.form);
                        $uibModalInstance.close('ok');

                    }

                    function modalClose(result) {
                        return $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vmModal',
                size: 'lg'
            });

            return modalInstance.result;
        }

        return service;
    }
})();

(function(){
    'use strict';
    angular.module('strefaKlienta')
        .controller('ZapisyNaEMController', ZapisyNaEMController);

    /** @ngInject */
    function ZapisyNaEMController(Restangular, security, uprawnieniaSubUsera) {
        var vm = this;
        vm.api = '/zapisyEM/zapisyEM/';
        vm.odpowiedziSerwera = [];
        vm.pracownik = {
            imieNazwisko: '',
            telefon: '',
            email: ''
        };
        vm.zapisano = false;

        vm.init = init;
        vm.zapisz = zapisz;

        function zapisz() {
            Restangular.all(vm.api).post(vm.pracownik).then(function () {
                vm.odpowiedziSerwera.push({
                    typ: 'S',
                    tekst: 'Dziękujemy, państwa zgłoszenie zostało przyjęte'
                });
                vm.zapisano = true;
            }, function (error) {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd, podczas wysyłania zgłoszenia'
                });
            });
        }

        function init() {
            Restangular.all(vm.api).getList().then(function(result) {
                if(angular.isDefined(result[0]) === true) {
                    vm.zapisano = true;
                }
            });
            if(security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function (result) {
                    vm.pracownik.imieNazwisko = result.imie + ' ' + result.nazwisko;
                    vm.pracownik.telefon = result.Telefon;
                    vm.pracownik.email = result.email;
                })
            }
        }


    }
})();
(function () {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('wakeOnLanController', wakeOnLanController);

    /** @ngInject */
    function wakeOnLanController(Restangular, security, $state, bootstrapKlasa) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.serverResponse = [];
        vm.security = security;
        vm.pcs = '';
        vm.selectedPc = '';
        vm.addPc_Worker = '';
        vm.addPc_MAC = '';
        vm.addPc = false;
        vm.differentMac = '';
        vm.wakeOnLan = wakeOnLan;
        vm.allowAddPc = allowAddPc;
        vm.addPcToWOL = addPcToWOL;
        vm.wyslijWOL = wyslijWOL;

        if (!security.jestPracownikiemMieszczanin()) {
            $state.go('home.stronaGlowna');
        }

        Restangular.all('wol/wol/').getList({pageSize: 1000}).then(function (result) {
            vm.pcs = result;
            vm.pcs.sort(function (a, b) {
                return a.Prac.localeCompare(b.Prac);
            });
        });

        function allowAddPc() {
            vm.addPc = !vm.addPc;
            vm.selectedPc = '';
        }

        function wakeOnLan() {
            if (vm.differentMac.length > 0) {
                Restangular.all('wol/wol/wake_mac/?mac=' + vm.differentMac).post({mac: vm.differentMac}).then(function (result) {
                    vm.serverResponse.push({
                        typ: 'S',
                        tekst: 'Magiczny pakiet został wysłany poprawnie.'
                    });
                }, function () {
                    vm.serverResponse.push({
                        typ: 'E',
                        tekst: 'Wystąpił problem podczas wysyłania pakietu.'
                    });
                });
            } else {
                Restangular.all('wol/wol/' + vm.selectedPc + '/wake').post({})
                    .then(function (result) {
                        vm.serverResponse.push({
                            typ: 'S',
                            tekst: 'Magiczny pakiet został wysłany poprawnie.'
                        });
                    }, function () {
                        vm.serverResponse.push({
                            typ: 'E',
                            tekst: 'Wystąpił problem podczas wysyłania pakietu.'
                        });
                    });
            }
        }

        function addPcToWOL() {
            Restangular.all('wol/wol').post({Prac: vm.addPc_Worker, MacAddress: vm.addPc_MAC}).then(function (result) {
                vm.addPc = false;
                vm.serverResponse.push({
                    typ: 'S',
                    tekst: 'Komputer dodany poprawnie.'
                });
            }, function () {
                vm.serverResponse.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd podczas dodawania komputera.'
                });
            });
        }

        function wyslijWOL() {
            var wakeup_mac = (vm.differentMac.length > 0) ? vm.differentMac : vm.selectedPc;
            fetch("https://mieszczanin.pl/wol", {
                method: "POST",
                headers: {
                    "content-type": "application/json; charset=utf-8",
                },
                body: JSON.stringify({mac: wakeup_mac})
            }).then(function (res) {
                console.log("Odpowiedź serwera:", res);
                vm.serverResponse.push({
                    typ: 'S',
                    tekst: 'Magiczny pakiet został wysłany poprawnie.'
                });
            }, function error(err) {
                vm.serverResponse.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd podczas wysyłania polecenia.'
                });
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('updatepackController', updatepackController);

    /** @ngInject */
    function updatepackController(Restangular, $location, $sce) {
        var vm = this;
        vm.listOfUpdatePackages=[];
        vm.trustAsHTML = trustAsHTML;
        vm.none = false;
        vm.error = '';
        vm.qs = $location.search();
        if(vm.qs['modul']==undefined){vm.error='Nie podano modułu';}
        if(vm.qs['wer']==undefined){vm.error='Nie podano wersji';}
        vm.moduly = {
            'BAN': {letter:'letter-mid-b',nazwa:'Banki - płatności masowe'},
            'WKL': {letter:'letter-mid-w',nazwa:'Nieruchomości - członkowie - wkłady'},
            'WSM': {letter:'letter-mid-n',nazwa:'System łatwej obsługi nieruchomości'},
            'FAK': {letter:'letter-mid-v',nazwa:'Fakturowanie sprzedaży'},
            'SRT': {letter:'letter-mid-s',nazwa:'Środki trwałe'},
            'ZNI': {letter:'letter-mid-t',nazwa:'Techniczna obsługa nieruchomości'},
            'FIK': {letter:'letter-mid-f',nazwa:'Finanse i księgowość'},
            'KAS': {letter:'letter-mid-k',nazwa:'Kasa'},
            'KIP': {letter:'letter-mid-p',nazwa:'Kadry i płace'},
            'MAG': {letter:'letter-mid-m',nazwa:'Magazyn'},
            'PRW': {letter:'letter-mid-e',nazwa:'e-kartoteka'},
            'ZWO': {letter:'letter-mid-d',nazwa:'Zarządzanie obiegiem dokumentów'},
            'CEN': {letter:'letter-mid-c',nazwa:'Centrala'}
        };

        Restangular.all('/oprogramowanie/updatepack/').getList({
            modul: (vm.qs['modul'] != undefined ? vm.qs['modul'] : '').toString(),
            numer: (vm.qs['wer'] != undefined ? vm.qs['wer'] : '').toString()}).then(function(result){
            vm.listOfUpdatePackages = result;
            vm.none=(result.length > 0 ? false : true);
        });


        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }
    }
})();
(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('UmowyPobieranieController', UmowyPobieranieController);

    /** @ngInject */
    function UmowyPobieranieController(lokalizacjaAPI, $stateParams, bootstrapKlasa, $timeout,
                                       UmowyResource, Restangular, uprawnieniaSubUsera, security) {
        var vm = this;
        vm.idUmowy = $stateParams.idUmowy;
        vm.umowa = null;
        vm.pelnomocnictwo = null;
        vm.brakUmowy = false;
        vm.init = init;
        init();

        function init() {
            UmowyResource.pobierzPDFUmowyInfo({IdUmow: $stateParams.idUmowy}).then(
                function (res) {
                    if (res.length <= 0) {
                        vm.brakUmowy = true;
                    }
                    vm.umowa = res[0];
                    vm.umowa.downloadURL = lokalizacjaAPI + '/umowy/umowaPDF/' + $stateParams.idUmowy + '/get_file/' + '?jwt=' + security.getToken();
                }
            );
            UmowyResource.pobierzUpowaznienie({IdUmow: $stateParams.idUmowy}).then(
                function (res) {
                    vm.pelnomocnictwo = res[0];
                    vm.pelnomocnictwo.downloadURL = lokalizacjaAPI + '/umowy/umowaUpowaznienie/' + $stateParams.idUmowy + '/get_file/' + '?jwt=' + security.getToken();
                }
            );
        }

    }
})();
(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('UmowyController', UmowyController);

    /** @ngInject */
    function UmowyController($state, lokalizacjaAPI, bootstrapKlasa, UmowyResource, danePodstawowe, security,
                             PowiadomieniaResource, NowePowiadomienieModal) {
        var vm = this;
        vm.danePodstawowe = danePodstawowe;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.jestSubUserem = security.jestSubUserem() === true;
        vm.czyAdmin = security.jestPracownikiemMieszczanin() === true;
        vm.powiadomienia = null;
        vm.statusy = {
            brak: 'Brak podpisanej umowy',
            wymagaAktualizacji: 'Umowa wymaga aktualizacji',
            aktualna: 'Umowa aktualna',
            zawarta: 'Umowa zawarta',

        };
        vm.umowyStatusy = {
            'UPPDO': null
        };
        vm.umowy = [
            {
                id: 'UPPDO',
                nazwa: 'Umowa powierzenia przetwarzania danych osobowych',
                status: 'Brak podpisanej umowy',
                infoBrakUmowy: 'Nie zawarłeś z firmą Mieszczanin umowy powierzenia przetwarzania danych osobowych, która jest\n' +
                    ' niezbędna do realizacji usług wykonywanych na podstawie zawartych z nami umów. Brak podpisanej umowy\n' +
                    ' powierzenia przetwarzania może uniemożliwić nam realizację ww. usług – w tym\n' +
                    ' przyjmowania i realizacji zgłoszeń.',
                brakUmowyZalaczniki: [
                    {
                        ikony: [{typ: 'pdf', url: '/assets/files/umowy/uppdo/wzor.pdf'}],
                        nazwa: 'Zapoznaj się z przykładową treścią umowy (zawarte w niej dane są wyłącznie przykładowe)'
                    },
                ],
                brakPelnomocnictwaZalaczniki: [
                    {
                        ikony: [{typ: 'docx', url: '/assets/files/umowy/uppdo/pelnomocnictwo.docx'}, {
                            typ: 'pdf',
                            url: '/assets/files/umowy/uppdo/pelnomocnictwo.pdf'
                        }], nazwa: 'Szablon pełnomocnictwa'
                    }
                ],
                formularzUrl: 'home.subMain.umowy.uppdo',
                umowaAktualnaTemplateSrc: 'app/home/umowy/uppdo/umowaAktualna.html',
                umowaWymagaAktualizacjiTemplateSrc: 'app/home/umowy/uppdo/umowaWymagaAktualizacji.html',
                downloadURL: null,
                downloadUpowaznienieURL: null,
                dane: {}
            }
        ];
        vm.dodajPowiadomienie = dodajPowiadomienie;
        vm.getStatus = getStatus;
        vm.pobierzUmoweUrl = pobierzUmoweUrl;

        init();

        function getStatus(umowaId) {
            if (umowaId === 'UPPDO') {
                if (vm.umowy[0].dane.umowa !== null && vm.umowy[0].dane.umowa !== undefined &&
                    danePodstawowe.DostepDoUPPDO === 1) {
                    return vm.statusy.aktualna;
                } else if (danePodstawowe.DostepDoUPPDO === 2) {
                    return vm.statusy.wymagaAktualizacji;
                } else if (danePodstawowe.DostepDoUPPDO === 3) {
                    return vm.statusy.zawarta;
                }
            }
            return vm.statusy.brak;

        }

        function pobierzUmoweUrl(umowFlagaaId) {
            if (umowaId === 'UPPDO') {
                return lokalizacjaAPI + '/umowy/umowaPDF/' + vm.umowy[0].dane.PDFInfo.id + '/get_file';
            }
        }
        function init() {

            UmowyResource.pobierzUmowy({IdRodzUm: 8}).then(
                function (result) {
                    vm.umowy[0].dane.umowa = result[0];
                    if (result.length > 0) {
                        vm.umowyStatusy['UPPDO'] = vm.statusy.aktualna;
                        UmowyResource.pobierzDaneKontaktowe({IdUmow: result[0].IdUmow}).then(
                            function (res) {
                                vm.umowy[0].dane.daneKontaktowe = res[0];
                            }
                        );
                        UmowyResource.pobierzDaneKontaktowe({IdUmow: result[0].IdUmow}).then(
                            function (res) {
                                vm.umowy[0].dane.daneKontaktowe = res[0];
                            }
                        );
                        UmowyResource.pobierzPDFUmowyInfo({IdUmow: result[0].IdUmow}).then(
                            function (res) {
                                vm.umowy[0].dane.PDFInfo = res[0];
                                vm.umowy[0].downloadURL = lokalizacjaAPI + '/umowy/umowaPDF/' + result[0].IdUmow + '/get_file/' + '?jwt=' + security.getToken();
                            }
                        );
                        UmowyResource.pobierzUpowaznienie({IdUmow: result[0].IdUmow}).then(
                            function (res) {
                                if (res.length > 0) {
                                    vm.umowy[0].dane.UpowaznienieInfo = res[0];
                                    vm.umowy[0].downloadUpowaznienieURL = lokalizacjaAPI + '/umowy/umowaUpowaznienie/' + result[0].IdUmow + '/get_file/' + '?jwt=' + security.getToken();
                                }
                            }
                        );
                    } else {
                        vm.umowyStatusy['UPPDO'] = vm.statusy.brak;
                    }
                }
            );
        }

        function dodajPowiadomienie() {
            return NowePowiadomienieModal.wyswietlModal('UPPDO').then(function(res) {
                $state.reload();
            });
        }



    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('ProfilController', ProfilController);

    /** @ngInject */
    function ProfilController(Restangular, bootstrapKlasa, uprawnieniaSubUsera, $stateParams, $state) {
        var vm = this;

        vm.uzytkownik = [];
        vm.uzytkownikForm = {};
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.odpowiedziSerwera = [];
        vm.edycja = false;
        vm.przekierowanie_zobacz = $stateParams.przekierowanie_zobacz;
        vm.przekierowanie_dodaj = $stateParams.przekierowanie_dodaj;


        vm.pobierzDaneUzytkownika = pobierzDaneUzytkownika;
        vm.zapiszDane = zapiszDane;
        vm.anuluj = anuluj;
        vm.init = init;

        init();

        function init() {
            pobierzDaneUzytkownika();
        }

        function anuluj() {
            vm.edycja = false;
            pobierzDaneUzytkownika();
        }

        function pobierzDaneUzytkownika() {
            uprawnieniaSubUsera.getInfo().then(function(result){
                vm.uzytkownikForm = result;
            });
        }

        function zapiszDane() {
            if (vm.uzytkownikForm !== null && vm.uzytkownikForm.haslo == vm.uzytkownikForm.potwierdzHaslo) {
                var haslo = null;
                if (vm.uzytkownikForm.haslo != '' && vm.uzytkownikForm.haslo != null && vm.uzytkownikForm.haslo != 'undefined') {
                    haslo = vm.uzytkownikForm.haslo;
                }

                Restangular.one("subUser/subUser/" + vm.uzytkownikForm.id+'/').customPUT(vm.uzytkownikForm).then(function (res) {
                        pobierzDaneUzytkownika();
                        vm.edycja = false;
                        if(vm.przekierowanie_zobacz !== null) {
                            $state.go('home.subMain.zgloszenia.kartaZgloszeniaKlienta', {zgloszenie:vm.przekierowanie_zobacz});
                        }
                        if(vm.przekierowanie_dodaj !== null) {
                            $state.go('home.subMain.zgloszenia.nowe_zgloszenie', {typ:vm.przekierowanie_dodaj})
                        }

                    }, function (error) {
                        vm.odpowiedziSerwera.push({
                            typ: 'E',
                            tekst: 'Wystąpił błąd. Sprawdź czy pola Imię, Nazwisko i E-mail są wypełnione.'
                    });
                });
            }
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("strefaKlienta")
    .controller("PlayerController", PlayerController);

  /** @ngInject */
  function PlayerController(
    $sce,
    $scope,
    $stateParams,
    lokalizacjaAPI,
    $interval,
    Restangular
  ) {
    var vm = this;
    vm.lokalizacjaApi =
      lokalizacjaAPI === "/api"
        ? "https://strefaklienta.mieszczanin.pl"
        : "http://192.168.1.184:3453";
    vm.film = $stateParams.film;
    vm.lastTimePlayed = 0;

    function dajLokalizacjeVideo() {
      if (vm.film === "zgloszenie") {
        return vm.lokalizacjaApi + "/assets/files/SysZG_zgloszenia.mp4";
      } else if (vm.film === "ustawienia") {
        return vm.lokalizacjaApi + "/assets/files/SysZG_ustawienia.mp4";
      } else if (vm.film === "blad") {
        return vm.lokalizacjaApi + "/assets/files/SysZG_blad_z_programu.mp4";
      } else {
        return vm.lokalizacjaApi + "/media/" + vm.film;
      }
    }

    var interval = $interval(function () {
      vm.media = document.querySelector("video");
      var timePlayed = 0;
      if (vm.media) {
        for (var i = 0; i < vm.media.played.length; i++) {
          timePlayed += vm.media.played.end(i) - vm.media.played.start(i);
        }
      }
      if (vm.lastTimePlayed != timePlayed) {
        vm.lastTimePlayed = timePlayed;
        Restangular.one("mediamonitor/wt/").customPOST({
          mediaName: vm.film,
          secondsWatched: parseInt(timePlayed),
        });
      }
    }, 60000);
    $scope.$on('$destroy', function () { $interval.cancel(interval); });

    vm.config = {
      preload: "none",
      sources: [
        {
          src: $sce.trustAsResourceUrl(dajLokalizacjeVideo()),
          type: "video/mp4",
        },
      ],
      tracks: [],
      theme: {
        url: "https://unpkg.com/videogular@2.1.2/dist/themes/default/videogular.css",
      },
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('WykazKonsultacjiController', WykazKonsultacjiController);

    /** @ngInject */
    function WykazKonsultacjiController(Restangular, $sce, uprawnieniaSubUsera, security, $state) {
        var vm = this;
        var formularzApi = Restangular.all('konsultacje/wykazKonsultacji/');
        vm.security = security;
        vm.selectedRodzaj = 'Wszystkie';
        vm.pagination = 10;
        vm.lokalizacje = null;
        vm.dataStart = null;
        vm.dataKoniec = null;
        vm.sendDataStart = null;
        vm.sendDataKoniec = null;
        vm.paginatorBreaker = [];
        vm.opcje = [];
        vm.dane = [];
        vm.selected=null;
        vm.visibleDane = [];
        vm.currTab = [];
        vm.allTabs = [];
        vm.dozwoloneLok = [];
        vm.jkju = [];
        vm.systemy = {
            'BAN': {letter:'letter-b',nazwa:'Banki - płatności masowe'},
            'WKL': {letter:'letter-w',nazwa:'Nieruchomości - członkowie - wkłady'},
            'WSM': {letter:'letter-n',nazwa:'System łatwej obsługi nieruchomości'},
            'FAK': {letter:'letter-v',nazwa:'Fakturowanie sprzedaży'},
            'SRT': {letter:'letter-s',nazwa:'Środki trwałe'},
            'ZNI': {letter:'letter-t',nazwa:'Techniczna obsługa nieruchomości'},
            'FIK': {letter:'letter-f',nazwa:'Finanse i księgowość'},
            'KAS': {letter:'letter-k',nazwa:'Kasa'},
            'KIP': {letter:'letter-p',nazwa:'Kadry i płace'},
            'MAG': {letter:'letter-m',nazwa:'Magazyn'},
            'PRW': {letter:'letter-e',nazwa:'e-kartoteka'},
            'ZWO': {letter:'letter-d',nazwa:'Zarządzanie obiegiem dokumentów'},
            'CEN': {letter:'letter-c',nazwa:'Centrala'}
        };
        vm.checkClick = checkClick;
        vm.reloadKonsultacje = reloadKonsultacje;
        vm.loadKonsultacje = loadKonsultacje;
        vm.prev = prev;
        vm.next = next;
        vm.nextGroup = nextGroup;
        vm.prevGroup = prevGroup;
        vm.init = init;
        vm.sortTable = sortTables;
        vm.updateJkJu = updateJkJu;
        vm.trustAsHTML = trustAsHTML;

        //Funkcja pozwalająca na wyświetlanie zmiennych jako HTML
        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }


        //Aktualizacja sumy jednostek j.k. i j.u.
        function updateJkJu() {
            vm.jkju=[];
            angular.forEach(vm.visibleDane, function(dana){
                for(var i=0;i< Math.ceil(dana.kon.length/10);i++) {
                    var jk=0;
                    var ju=0;
                    angular.forEach(dana.kon.slice(i*10,i*10+10), function (konsultacja) {
                        jk += konsultacja.JednKonsult;
                        ju += konsultacja.JednUmSerw;
                    });
                    vm.jkju.push({id_lok:dana.id_lok, jk:jk, ju:ju, zakladka:i});
                }
            });
        }


        //sortowanie po dacie
        function sortByDate(){
            angular.forEach(vm.visibleDane,function(dana){
                dana.kon.sort(function(a,b){
                    return new Date(b.DataWpis) - new Date(a.DataWpis);
                });
            })
        }


        //Pobieranie danych po dacie
        function getSelectedByDate() {
            vm.visibleDane=[];
            if (vm.dataStart != null) {
                angular.forEach(vm.dane, function (dana) {
                    var kon = [];
                    var more = [];
                    angular.forEach(dana.kon, function (konsultacja) {
                        if (vm.dataKoniec == null) {
                            vm.dataKoniec = new Date(Date.now())
                        }
                        if (
                            new Date(konsultacja.DataWpis.substr(0, 4), konsultacja.DataWpis.substr(5, 2), konsultacja.DataWpis.substr(8, 2)) >=
                            new Date(vm.dataStart.getFullYear(), vm.dataStart.getMonth() + 1, vm.dataStart.getDate())
                            &&
                            new Date(konsultacja.DataWpis.substr(0, 4), konsultacja.DataWpis.substr(5, 2), konsultacja.DataWpis.substr(8, 2)) <=
                            new Date(vm.dataKoniec.getFullYear(), vm.dataKoniec.getMonth() + 1, vm.dataKoniec.getDate())
                        ) {
                            kon.push(konsultacja);
                            more.push(false);
                        }
                    });
                    vm.visibleDane.push({id_lok: dana.id_lok, kon: kon, more: more});
                });
            } else {
                vm.visibleDane = vm.dane;
            }
        }


        //Aktualizacja paginatora
        function updatePaginator() {
            angular.forEach(vm.lokalizacje,function(lokalizacja){
                angular.forEach(vm.visibleDane, function(dana){
                    if(dana.id_lok == lokalizacja.IdLok) {
                        var tab = [];
                        var reszta = (dana.kon.length % vm.pagination == 0) ? 0 : 1;
                        for (; tab.length < (Math.floor(dana.kon.length / vm.pagination) + reszta);) {
                            tab.push(tab.length + 1);
                        }
                        vm.allTabs[vm.lokalizacje.indexOf(lokalizacja)] = {tab: tab};
                    }
                });
            });
        }


        //Sortowanie po rodzaju konsultacji
        function sortByConsultation() {
            var temp = [];
            if (vm.selectedRodzaj != 'Wszystkie' && vm.selectedRodzaj != null) {
                angular.forEach(vm.visibleDane, function (dana) {
                    var kon = [];
                    var more = [];
                    angular.forEach(dana.kon, function (konsultacja) {
                        if(konsultacja.rodzaj_konsultacji == vm.selectedRodzaj){
                            kon.push(konsultacja);
                            more.push(false);
                        }
                    });
                    temp.push({id_lok: dana.id_lok, kon: kon, more: more})
                });
                vm.visibleDane = temp;
            }
        }


        //Sortowanie wstępne
        function sortTables() {
            sortByDate();
            sortByConsultation();
            updatePaginator();
        }


        //Paginator - poprzednia strona
        function prev(id) {
            if(vm.currTab[id] > 1)
                vm.currTab[id]--;
            vm.paginatorBreaker[id] = Math.floor(vm.currTab[id]/10);
        }


        //Paginator - następna strona
        function next(id) {
            if(vm.currTab[id] < vm.allTabs[id].tab[vm.allTabs[id].tab.length-1])
                vm.currTab[id]++;
            vm.paginatorBreaker[id] = Math.floor(vm.currTab[id]/10);
        }


        //Paginator - zwijanie - następna grupa
        function nextGroup(id){
            if(vm.paginatorBreaker[id] < Math.floor(vm.allTabs[id].tab[vm.allTabs[id].tab.length-1]/10))
                vm.paginatorBreaker[id]++;
        }

        //Paginator - zwijanie - poprzednia grupa
        function prevGroup(id) {
            if(vm.paginatorBreaker[id]>0)
                vm.paginatorBreaker[id]--;
        }

        function indeksPoczatkuStopki(tresc) {
            // szablon konsultacji różni się od szablonu serwisu - dlatego dwa sposoby na odróżnienie stopki
            var slowaKluczowe = ["Niniejsza wiadomo", "Pozdrawiam"];
            var lokalizacjaSlowaKluczowego = -1;

            slowaKluczowe.forEach(function (slowo) {
                if (lokalizacjaSlowaKluczowego === -1) {
                    lokalizacjaSlowaKluczowego = tresc.indexOf(slowo);
                }
            })
            return lokalizacjaSlowaKluczowego;
        }

        function trescBezStopki(tresc) {
            var indeks = indeksPoczatkuStopki(tresc);

            return indeks === -1
                ? tresc
                : tresc.substring(0, indeks);
        }


        //Tabela - sprawdzenie który wiersz został kliknięty
        function checkClick(element, lok) {
            if (vm.selected != element) {
                element.TrescMail = trescBezStopki(element.TrescMail);
                vm.selected = element;
            } else {
                vm.selected = null;
            }
        }


        //Tabela - odświeżenie
        function reloadKonsultacje() {
            getSelectedByDate();
            sortByConsultation();
            sortByDate();
            updatePaginator();
            updateJkJu();
        }


        //Pobranie rodzai konsultacji
        function loadKonsultacje(idlok) {
            Restangular.all('konsultacje/rodzajKonsultacji/').getList({id_lok: idlok, pageSize:10000}).then(function(result) {
                angular.forEach(result,function(value){
                    if(vm.opcje.indexOf(value.rodzaj_konsultacji) == -1) {
                        vm.opcje.push(value.rodzaj_konsultacji);
                        vm.opcje.sort();
                    }
                })
            });
        }


        //Inicjalizacja danych
        function init() {
            vm.dane = [];
            Restangular.all('licencje/lokalizacje/').getList().then(function(result) {
                vm.lokalizacje = result;
                return(result);
            } , function(error) {
            }).then(function() {
                angular.forEach(vm.lokalizacje,function(lok) {
                    Restangular.all('konsultacje/wykazKonsultacji/').getList({id_lok:lok.IdLok, pageSize:10000})
                        .then(function(result){
                            var hidden=[];
                            for(var i = 0; i < result.length; i++) { hidden.push(false); }
                            vm.dane.push({id_lok: lok.IdLok, kon: result, more: hidden});
                            vm.dane.sort();
                            loadKonsultacje(lok.IdLok);
                            vm.currTab[vm.lokalizacje.indexOf(lok)] = 1;
                            vm.paginatorBreaker[vm.lokalizacje.indexOf(lok)] = 0;
                            var reszta = (result.length % vm.pagination == 0) ? 0 : 1;
                            var tab = [];
                            for (; tab.length < (Math.floor(result.length / vm.pagination) + reszta); ) {
                                tab.push(tab.length+1);
                            }
                            vm.allTabs[vm.lokalizacje.indexOf(lok)] = { tab: tab };
                        }).then(function(){
                        vm.visibleDane = vm.dane;
                        sortTables();
                        updateJkJu();
                    });
                });
                if(security.jestSubUserem() == true) {
                    uprawnieniaSubUsera.getUprawnienia().then(function (result) {
                        vm.dozwoloneLok = [];
                        angular.forEach(result, function (info) {
                            if (info.WykazKonsultacji == true) {
                                vm.dozwoloneLok.push(info.IdLok);
                            }
                        });
                        if (vm.dozwoloneLok.length <= 0) {
                            $state.go('home.subMain.konto');
                        }
                    });
                }
            })

        }
    }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('UstawieniaMailinguController', UstawieniaMailinguController);

  /** @ngInject */
  function UstawieniaMailinguController() {
    var vm = this;

  }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('UslugiPasywneController', UslugiPasywneController);

    /**@ngInject*/
    function UslugiPasywneController(security, $state, Restangular, UslugiPasywneHasloModal, bootstrapKlasa, informacje) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.informacje = informacje;
        vm.uzytkownik = {};
        vm.myChartObject = {};
        vm.myChartObject.type = "PieChart";
        vm.init = init;
        vm.zmienHaslo = zmienHaslo;

        function init() {

            if(security.jestSubUserem() == true) {
                $state.go('home.subMain.konto');
            }
            Restangular.all('/uslugiPasywne/uslugiPasywne/').getList().then(function(result) {
                if(angular.isDefined(result)==true) {
                    if (result.length > 0) {
                        vm.uzytkownik = result[0];
                    }
                }
            }, function() {

            });
            vm.myChartObject.data = {"cols": [
                {id: "t", label: "Topping", type: "string"},
                {id: "s", label: "Slices", type: "number"}
            ], "rows": [
                {c: [
                    {v: "Wolne"},
                    {v: vm.informacje.przestrzen-vm.informacje.used},
                ]},
                {c: [
                    {v: "Zajęte"},
                    {v: vm.informacje.used}
                ]}
            ]};
            vm.myChartObject.options = {
                // 'legend': {position: 'none'},
                'colors': ['green', 'crimson']
            };



        }

        function zmienHaslo() {
            UslugiPasywneHasloModal.wyswietlModal().then(function() {
                init();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('PobierzPlyteController', PobierzPlyteController);

    /** @ngInject */
    function PobierzPlyteController(Restangular, plyta, security, uprawnieniaSubUsera, listaModulow, pobieraniePlikow,
                                    lokalizacjaAPI) {
        var vm = this;

        vm.plyta = plyta;
        vm.urlPlyty = lokalizacjaAPI + '/licencje/pobierzPlyte/?wersja=' + plyta.link + '&jwt=' + security.getToken();
        vm.odpowiedziSerwera = [];
        vm.pokazZamowPlyte = false;
        vm.wyslano = false;
        vm.moduly = listaModulow.moduly;
        vm.instrukcjaAktualizacji = null;
        vm.apiPliki = '/zarzadzaniePlikami/plikFile/';
        vm.pola = {
            typ: 'Zamówienie',
            tytul: 'Proszę o przesłanie płyty CD z najnowszą wersją programu.',
            opis: 'Proszę o przesłanie płyty CD z najnowszą wersją programu.',
            modul: 'BAN',
            wersjaEZN: '',
            wersjaUpdPack: '',
            idLokalizacji: null,
            nazwaLokalizacji: '',
            klientId: null,
            klientNazwa: '',
            klientTelefon: '',
            klientEmail: '',
            osDoKontaktuNazwa: null,
            osDoKontaktuTelefon: null,
            osDoKontaktuEmail: null,
            status: 'Zgłoszone',
            nazwaKlienta: '',
            kodKlienta: null,
            symbolWydruku: '',
            klientPlecMezczyzna: '',
            idPod: null,
            grupa: null,
            poradaKrotka: null,
            dotAplMobilna: false
        };
        vm.dostawaDo = {
            kodPocztowy: '',
            miejscowosc: '',
            ulica: '',
            nrDomu: '',
            nrLokalu: '',
        };

        vm.init = init;
        vm.wyslij = wyslij;
        vm.pobierzInstrukcjeAktualizacji = pobierzInstrukcjeAktualizacji;

        function init() {
            if (plyta.link === '') {
                vm.pola.tytul = 'Proszę o kontakt w sprawie oferty aktualizacji.';
                vm.pola.opis = 'Proszę o kontakt w sprawie oferty aktualizacji.';
            }
            if (security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function (result) {
                    console.log(result);
                    vm.uzytkownik = result;
                    vm.pola.klientId = result.id;
                    vm.pola.klientNazwa = result.imie + ' ' + result.nazwisko;
                    vm.pola.klientEmail = result.email;
                    vm.pola.klientTelefon = result.Telefon;
                    vm.pola.klientPlecMezczyzna = result.CzyMezczyzna;

                    vm.pola.osDoKontaktuNazwa = result.imie + ' ' + result.nazwisko;
                    vm.pola.osDoKontaktuEmail = result.email;
                    vm.pola.osDoKontaktuTelefon = result.Telefon;

                    vm.pola.idLokalizacji = result.IdLok;

                }).then(function () {
                    Restangular.all('licencje/lokalizacje/').getList({id_lok: vm.uzytkownik.IdLok}).then(function (result) {
                        if (result.length > 0) {
                            vm.pola.nazwaLokalizacji = result[0].NazwaLok;
                        }
                    });
                })
            }

            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                if (angular.isDefined(result[0])) {
                    vm.pola.nazwaKlienta = result[0].NazwaKr;
                    vm.pola.kodKlienta = result[0].Kod;
                    vm.pola.idPod = result[0].IdPod;
                }
            });

            Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami').getList({search: 'aktualizacja oprogramowania'}).then(
                function (result) {
                    if (angular.isDefined(result[0].file[0]) === true && result[0].file[0] !== null) {
                        vm.instrukcjaAktualizacji = result[0].file[0];
                    }
                });
        }

        function wyslij() {
            if (vm.wyslano === false) {
                vm.polaKopia = Object.assign({}, vm.pola);
                if (plyta.link !== '') {
                    vm.polaKopia.opis += '<br><br>';
                    vm.polaKopia.opis += '<b>Miejscowość</b>: ' + vm.dostawaDo.kodPocztowy + ' ' + vm.dostawaDo.miejscowosc + '<br>';
                    vm.polaKopia.opis += '<b>Ulica</b>: ' + vm.dostawaDo.ulica + ' ' + '<br>';
                    vm.polaKopia.opis += '<b>Nr. domu</b>: ' + vm.dostawaDo.nrDomu + ' ' + '<br>';
                    vm.polaKopia.opis += (vm.dostawaDo.nrLokalu.length > 0) ? '<b>Nr. lokalu</b>: ' + vm.dostawaDo.nrLokalu + ' ' + '<br>' : '';
                }
                Restangular.all('zgloszenia/zgloszenia/').post(vm.polaKopia).then(function (result) {
                    vm.wyslano = true;
                    vm.pokazZamowPlyte = false;
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Prośba o wysyłkę płyty CD została wysłana'
                    });

                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Nie udało się wysłać prośby o zmianę limitów'
                    });
                });
            }
        }

        function pobierzInstrukcjeAktualizacji() {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, vm.instrukcjaAktualizacji);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('TwojeKontoController', TwojeKontoController);

    /** @ngInject */
    function TwojeKontoController( $state, security, Restangular, dostepDoBety) {
        var vm = this;
        vm.danePodstawowe = {};
        vm.dostepFTP = null;
        vm.pokazHasla = false;
        vm.systemy = {"Nazwa":"", "NazwaSp":""};
        vm.opiekun = {"Handlowy":"", "Merytoryczny":""};

        vm.prw = true;
        vm.dr = false;

        vm.przelaczPierwsza = przelaczPierwsza;
        vm.przelaczDruga = przelaczDruga;
        vm.pobierzDane = pobierzDane;
        vm.goCoNowego = goCoNowego;
        vm.goWycenaAktualizacji = goWycenaAktualizacji;
        vm.goZmianaLimitow = goZmianaLimitow;

        function przelaczPierwsza() {
            vm.prw = true;
            vm.dr = false;
        };

        function przelaczDruga() {
            vm.prw = false;
            vm.dr = true;
        };

        function pobierzDane() {
            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                vm.danePodstawowe = result[0];
            }, function (error) {
            });

            Restangular.all('konto/licencje/').getList().then(function (result) {
                vm.systemy.Wersja = (result[0].Wersja ? result[0].Wersja / 10000 : '');
                vm.systemy.WersjaSp = (result[0].WersjaSp ? result[0].WersjaSp / 10000 : '');
            }, function (error) {
            });

            Restangular.all('konto/uzytkownicyftp/').getList().then(function (result) {
                vm.dostepFTP = result;
            }, function (error) {
            });

            Restangular.all('konto/opiekunowie/').getList().then(function (result) {
                angular.forEach(result, function (pracownik) {
                    if (pracownik.Dzial == 'DH') {
                        vm.opiekun.Handlowy = pracownik.Imie + ' ' + pracownik.Nazwisko
                    }
                    if (pracownik.Dzial == 'DW') {
                        vm.opiekun.Merytoryczny = pracownik.Imie + ' ' + pracownik.Nazwisko
                    }
                })
            }, function (error) {
            })
        };

        function goCoNowego() {
            $state.go('home.subMain.co_nowego')
        };

        function goZmianaLimitow() {
            $state.go('home.subMain.zmiana_limitow')
        };

        function goWycenaAktualizacji() {
            $state.go('home.subMain.wycena_aktualizacji')
        };

        if (security.jestDostepDoDanychKlienta()){
            vm.pobierzDane();
        } else {
            $state.go('home.subMain.podszyciePodKlienta')
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("strefaKlienta")
    .controller("LicencjeController", LicencjeController);

  /** @ngInject */
  function LicencjeController(
    Restangular,
    $state,
    plikiOperacje,
    bootstrapKlasa,
    security,
    uprawnieniaSubUsera,
    pobieraniePlikow,
    statusyUmow,
    lokalizacjeResource,
    saLokaleIBlokady,
    szczegolyCenyModal,
    slownikCenLimitowLokali,
    aktualnaLiczbaLokali,
    gromadzenieDanychKsiegowych,
    opcjeEk,
    opcjeEm,
    zaakceptowaneRegulaminy,
    regulaminyResource
  ) {
    var vm = this;
    vm.security = security;
    vm.zuzycieSMS = null;
    vm.zuzycieOCR = null;
    vm.aktualnyRok = new Date().getFullYear();
    vm.aktualnyMiesiac = new Date().getMonth();
    vm.aktualnyMiesiacNazwa = new Date().toLocaleString('pl',{month:'long'});
    vm.zaakceptowaneRegulaminy = zaakceptowaneRegulaminy;
    vm.regulaminy = regulaminyResource.dajRegulaminyDict();
    vm.pobierzRegulamin = regulaminyResource.pobierzRegulamin;
    vm.bootstrapKlasa = bootstrapKlasa;
    vm.licencjeRowTemplate = $("#licencjeRowTemplate").html();
    vm.systemy = { Nazwa: "", NazwaSp: "" };
    vm.apiPliki = "/zarzadzaniePlikami/plikFile/";
    vm.aktualnaLiczbaLokali = lokalizacjeResource.lokalizacjeInfo.sumaDoWyceny;
    vm.slownikCenLimitowLokali = slownikCenLimitowLokali;
    vm.opcjeEk = opcjeEk;
    vm.opcjeEm = opcjeEm;
    vm.opcjeEkLista = Object.values(opcjeEk);
    vm.opcjeEmLista = Object.values(opcjeEm);
    vm.aktualnyPakietLokali = aktualnaLiczbaLokali.LimitLokali;
    vm.gromadzenieDanychKsiegowych =
      [0, 3, 5].indexOf(gromadzenieDanychKsiegowych) !== -1
        ? gromadzenieDanychKsiegowych
        : "bez ograniczeń";
    vm.wersja = [];
    vm.uaktualnienie = [];
    vm.lokalizacje = [];
    vm.licencjeLokalizacji = [];
    vm.ograniczenia = [];
    vm.dodatkowe_ograniczenia = [];
    vm.instrukcjaAktualizacji = null;
    vm.statusyUmow = statusyUmow;
    vm.selectedId = 0;
    vm.subUser = {};
     vm.opcjeEKart = {
      liczbaLokali: 0, //Liczba lokali
      29: { opcja: false, wartosc: 0 }, //Analiza wybranych użytkowników lokali
      30: { opcja: false, wartosc: 0 }, //Dostęp do kartotek innych właścicieli dla członków zarządu wspólnoty
      12: { opcja: false, wartosc: 0 }, //Forum dyskusyjne
      31: { opcja: false, wartosc: 0 }, //Gromadzenie danych księgowych - za każdy miniony rok IleLatWstecz
      18: { opcja: false, wartosc: 0 }, //Opłaty za media
      9: { opcja: false, wartosc: 0 }, //Sprawozdawczość
      10: { opcja: false, wartosc: 0 }, //Tablica ogłoszeń
      35: { opcja: false, wartosc: 0 }, //Zgłoszenie usterek
      37: { opcja: false, wartosc: 0 }, //Napisz wiadomość
      40: { opcja: false, wartosc: 0 }, //Głosowanie uchwał
      61: { opcja: false, wartosc: 0 }, //Strefa zarządu wspólnoty
      /*63: {opcja: false, wartosc:0}   //Płatności on-line*/
    };

    vm.columnsProgramy = [
      {
        fieldName: "Nazwa",
        title: "Nazwa",
        colTemplate: "<span>{{row[column.fieldName]}}</span>",
        show: true,
      },
      {
        fieldName: "Wersja",
        title: "Wersja",
        colTemplate:
          "<span>{{ ((row[column.fieldName] ? row[column.fieldName]/10000 : '') | number:2)+ \" \" + (row.UpdPack!=null?row.UpdPack:'')}}</span>",
        show: true,
      },
    ];

    vm.checkClick = checkClick;
    vm.pobierzCertyfikatAuth = pobierzCertyfikatAuth;
    vm.pobierzCertyfikatProd = pobierzCertyfikatProd;
    vm.pobierzPlikLicencji = pobierzPlikLicencji;
    vm.pobierzInstrukcjeAktualizacji = pobierzInstrukcjeAktualizacji;
    vm.pokazSzczegolyCeny = pokazSzczegolyCeny;
    vm.init = init;

    vm.goPanelZakupowy = function () {
      $state.go("home.subMain.panel_zakupowy");
    };

    vm.goPobieraniePlyty = function () {
      $state.go("home.subMain.pobieranie_plyty");
    };

    vm.goCoNowego = function () {
      $state.go("home.subMain.co_nowego");
    };

    vm.goZmianaLimitow = function () {
      $state.go("home.subMain.zapytanieOfertowe.zmianaLimitow");
    };

    vm.goWycenaAktualizacji = function () {
      $state.go("home.subMain.wycena_aktualizacji");
    };

    function checkClick(id) {
      angular.forEach(vm.licencjeLokalizacji, function (v) {
        angular.forEach(v, function (val) {
          if (id === val.id_sys_lok) {
            if (vm.selectedId === val.id_sys_lok) {
              vm.selectedId = null;
            } else {
              vm.selectedId = val.id_sys_lok;
              getOgraniczeniaLicencji(val.id_sys_lok);
            }
          }
        });
      });
    }

    function init() {
      Restangular.all('faktury/aktywneUmowySMSOCR/').getList().then(
        function(result) {
          vm.aktywneUmowySMSOCR = result.map(function(el){return el.IdRodzUm});
          console.log('a',vm.aktywneUmowySMSOCR)
        });
      if (security.jestSubUserem() === true) {
        uprawnieniaSubUsera.getInfo().then(function (subUser) {
          vm.subUser = subUser;
          uprawnieniaSubUsera
            .getUprawnienia()
            .then(function (uprawnieniaSubUsera) {
              vm.subUser.dostepDoLicencji = uprawnieniaSubUsera[0].Licencje;
              if (uprawnieniaSubUsera[0].Licencje == false) {
                $state.go("home.subMain.konto");
              }
            });
        });
      }
      Restangular.all("konto/licencje/")
        .getList()
        .then(function (result) {
          vm.systemy.Wersja = result[0].Wersja ? result[0].Wersja / 10000 : "";
          vm.systemy.WersjaSp = result[0].WersjaSp
            ? result[0].WersjaSp / 10000
            : "";
        });

      Restangular.all("/licencje/wersje/")
        .getList()
        .then(function (result) {
          vm.wersja = result;
          angular.forEach(result, function (val) {
            if (val.id === vm.id) {
              vm.uaktualnienie = vm.wersja[vm.wersja.indexOf(val)];
            }
          });
        });

      Restangular.all("licencje/lokalizacje/")
        .getList()
        .then(function (result) {
          vm.lokalizacje = result;
          angular.forEach(result, function (res) {
            Restangular.all("licencje/wczytana_wersja_licencji/")
              .getList({ IdLok: res.IdLok })
              .then(function (wersja) {
                var w = null;
                if (angular.isDefined(wersja[0])) {
                  if (wersja[0].AktEZN.length < 4) {
                    w = "".concat(
                      wersja[0].AktEZN.substr(0, 1),
                      ".",
                      wersja[0].AktEZN.substr(1, 2)
                    );
                  }
                  if (wersja[0].AktEZN.length === 4) {
                    w = "".concat(
                      wersja[0].AktEZN.substr(0, 2),
                      ".",
                      wersja[0].AktEZN.substr(2, 2)
                    );
                  }
                  res.aktualnaWersja = w;
                }
              });
            Restangular.all("licencje/licencjelokalizacji/")
              .getList({ id_lok: res.IdLok, pageSize: 200 })
              .then(function (val) {
                vm.licencjeLokalizacji[vm.lokalizacje.indexOf(res)] = val;
              });
          });
          Restangular.all('faktury/zuzycieSMS/').getList({lokalizacje: result.map(function(el){return el.IdLok},[]).join(',')}).then(
            function(res) {
              vm.zuzycieSMS = przeliczZuzycie(res);
              console.log(res);
            }
          )
          Restangular.all('faktury/zuzycieOCR/').getList({lokalizacje: result.map(function(el){return el.IdLok},[]).join(',')}).then(
            function(res) {
              vm.zuzycieOCR = przeliczZuzycie(res);
            }
          )
        });

      Restangular.all("licencje/opcjeKlientaEK/")
        .getList({ pageSize: 100, page: 1 })
        .then(function (result) {
          angular.forEach(result, function (opcja) {
            if (vm.opcjeEKart[opcja.IdKrok]) {
              vm.opcjeEKart[opcja.IdKrok].opcja = true;
              vm.opcjeEKart[opcja.IdKrok].wartosc = opcja.IleLatWstecz
                ? opcja.IleLatWstecz
                : 0;
            }
          });
        });

      Restangular.all("licencje/limityLokaliKlienta/")
        .getList()
        .then(function (result) {
          vm.opcjeEKart.liczbaLokali = 0;
          angular.forEach(result, function (lokalizacja) {
            vm.opcjeEKart.liczbaLokali =
              vm.opcjeEKart.liczbaLokali + lokalizacja.Ograniczenie;
          });
          vm.opcjeEKart.liczbaLokali = vm.opcjeEKart.liczbaLokali.toString();
        });

      Restangular.all("zarzadzaniePlikami/zarzadzaniePlikami")
        .getList({ search: "aktualizacja oprogramowania" })
        .then(function (result) {
          if (
            angular.isDefined(result[0].file[0]) === true &&
            result[0].file[0] !== null
          ) {
            vm.instrukcjaAktualizacji = result[0].file[0];
          }
        });
    }

    function getOgraniczeniaLicencji(idsyslok) {
      vm.ogrnam = [];
      vm.ograniczenia = [];
      Restangular.all("licencje/dodatkowe_ograniczenia/")
        .getList({ id_sys_lok: idsyslok })
        .then(
          function (result) {
            vm.dodatkowe_ograniczenia = result;

            angular.forEach(result, function (val) {
              if (
                vm.ogrnam.indexOf(val.Nazwa) === -1 &&
                val.Nazwa !== "Wersja"
              ) {
                vm.ogrnam.push(val.Nazwa);
                switch (val.Nazwa) {
                  case "Ilosc uzytkownikow":
                    vm.ograniczenia.push({
                      Nazwa: "Ilość użytkowników",
                      Ograniczenie: val.Ograniczenie,
                    });
                    break;
                  case "Ilosc NRB":
                    vm.ograniczenia.push({
                      Nazwa: "Ilość NRB",
                      Ograniczenie: val.Ograniczenie,
                    });
                    break;
                  case "Ilosc nieruchomosci":
                    vm.ograniczenia.push({
                      Nazwa: "Ilość budynków",
                      Ograniczenie: val.Ograniczenie,
                    });
                    break;
                  case "Liczba procesorow":
                    vm.ograniczenia.push({
                      Nazwa: "Ilość procesorów",
                      Ograniczenie: val.Ograniczenie,
                    });
                    break;
                  case "Ilosc do odczytu":
                    vm.ograniczenia.push({
                      Nazwa: "Ilość do odczytu",
                      Ograniczenie: val.Ograniczenie,
                    });
                    break;
                }
              }
            });
          },
          function (error) {}
        );
    }

    function pobierzCertyfikatAuth(id) {
      return plikiOperacje.pobierzPlik(
        "/licencje/licencjelokalizacji/",
        id,
        "/certauth/"
      );
    }

    function pobierzCertyfikatProd(id) {
      return plikiOperacje.pobierzPlik(
        "/licencje/licencjelokalizacji/",
        id,
        "/certprod/"
      );
    }

    function capitalize(str) {
      return str.charAt(0).toUpperCase()+str.slice(1);
    }
    function dajOdleglaDate(data, liczba_mies) {
      let now = new Date(data)
      return new Date(new Date(now.setDate(1)).setMonth(now.getMonth() + liczba_mies))
    }

    function dajNazweMiesRok(data) {
      return capitalize(data.toLocaleString('pl',{month:'long'}) + " " + data.getFullYear());
    }

    function _dajZuzycie(data, zuzycie_array) {
      return (zuzycie_array.find(function(z){return z.rok == data.getFullYear() && z.miesiac == data.getMonth()+1})|| {liczba__sum:0}).liczba__sum
    }

    function przeliczZuzycie(zuzycie) {
      let now = new Date()
      let p1 = dajOdleglaDate(now, -1);
      let p2 = dajOdleglaDate(now, -2);
      return {
        biezacyMiesiac: {
          zuzycie: _dajZuzycie(now, zuzycie)
        }, 
        p1: {
          nazwa: dajNazweMiesRok(p1),
          zuzycie: _dajZuzycie(p1, zuzycie)
        },
        p2: {
          nazwa: dajNazweMiesRok(p2),
          zuzycie: _dajZuzycie(p2, zuzycie)
        }

      }
    }

    function pobierzPlikLicencji(IdLok) {
      return plikiOperacje.pobierzPlik(
        "/licencje/lokalizacje/",
        IdLok,
        "/pliklicencji/"
      );
    }

    function pobierzInstrukcjeAktualizacji() {
      pobieraniePlikow.wyswietlModal(vm.apiPliki, vm.instrukcjaAktualizacji);
    }
    function pokazSzczegolyCeny() {
      szczegolyCenyModal.wyswietlModal(
        lokalizacjeResource.lokalizacjeInfo.lokalizacje,
        saLokaleIBlokady
      );
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('KontaPracownikowController', KontaPracownikowController);

    /** @ngInject */
    function KontaPracownikowController(Restangular, bootstrapKlasa, $state, $sce, DaneKonta, security, Popup,
                                        kontaPracownikowModal, legendaUprawnienPracownikowModal) {
        var vm = this;
        vm.bootstrapKlasa =bootstrapKlasa;
        vm.api = 'subUser/subUser/';
        vm.pracownicy = [];
        vm.uprawnienia = [];
        vm.odpowiedziSerwera = [];
        vm.lokalizacje = [];
        vm.nazwa = '';
        vm.imie = '';
        vm.nazwisko = '';
        vm.email = '';
        vm.plec = null;
        vm.typ = 'pracownik';
        vm.status = 'Aktywny';
        vm.akcja = 'Dodaj konto pracownika';
        vm.haslo = '';
        vm.powtorzHaslo = '';
        vm.danePodstawowe = null;
        vm.paginacja = {page: 1, pageSize: 20};

        vm.init = init;
        vm.nextPage = nextPage;
        vm.deleteSelected = deleteSelected;
        vm.zmienUprawnienia = zmienUprawnienia;
        vm.kontoPracownika = kontoPracownika;
        vm.pokazLegende = pokazLegende;

        function init() {
            if(security.jestSubUserem() === true) {
                $state.go('home.subMain.konto');
            }
            vm.pracownicy = [];
            if(security.isLogin()) {
                DaneKonta.get().then(function(result){
                    vm.dane = result;
                    vm.danePodstawowe = result;
                }).then(function(){
                    Restangular.all('licencje/lokalizacje/').getList().then(function(lokalizacje) {
                        vm.lokalizacje = lokalizacje;
                    }).then(function () {
                        angular.forEach(vm.lokalizacje, function(lokalizacja) {
                            vm.paginacja.IdLok = lokalizacja.IdLok;
                            Restangular.all('subUser/subUser/').getList(vm.paginacja).then(function (users) {
                                vm.pracownicy[lokalizacja.IdLok] = users;
                                angular.forEach(users, function(user) {
                                    Restangular.all('subUser/subUserUprawnienia/').getList({UserId:user.id}).then(function (uprawnienia) {
                                        user['uprawnienia'] = uprawnienia[0];
                                    });
                                });
                            });
                        });
                    });
                });
            }
        }

        function nextPage(lokalizacja) {
            vm.paginacja.IdLok = lokalizacja;
            Restangular.all('subUser/subUser/').getList(vm.paginacja).then(function (users) {
                vm.pracownicy[lokalizacja] = users;
                angular.forEach(users, function(user) {
                    Restangular.all('subUser/subUserUprawnienia/').getList({UserId:user.id}).then(function (uprawnienia) {
                        user['uprawnienia'] = uprawnienia[0];
                    });
                });
            });
        }

        function kontoPracownika(konto) {
            kontaPracownikowModal.wyswietlModal(konto,vm.danePodstawowe, vm.lokalizacje).then(function() {
                init();
            });
        }

        function zmienUprawnienia(user, pole) {
            var pola = {
                WykazKonsultacji: false,
                Licencje: false,
                Faktury: false,
                PanelZakupowy: false,
                UserId: user.id,
                Aktualizacja: false,
                Powiadomienia: false,
                InformacjeDedykowane: false,
                Formularze: false
            };
            pola[pole] = true;
            Restangular.all('subUser/subUserUprawnienia/').getList({UserId:user.id}).then(function(result){
                if(result.meta.count > 0){
                    Restangular.one("subUser/subUserUprawnienia/" + user.id+'/').customPUT(user.uprawnienia);
                } else {
                    Restangular.all("subUser/subUserUprawnienia/").post(pola);
                    // init();
                }
            })
        }


        function deleteSelected(user){
            Popup.wyswietlInfo('Czy na pewno chcesz usunąć użytkownika?',user.imie+ ' ' + user.nazwisko,function(){
                Restangular.one("subUser/subUser/" + user.id).remove({UserId:user.id}).then(function (result) {
                }).then(function(){
                    init();
                });
            });
        }

        function pokazLegende() {
            legendaUprawnienPracownikowModal.wyswietlModal();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('KonsultacjeController', KonsultacjeController);

  /** @ngInject */
  function KonsultacjeController(Restangular, bootstrapKlasa, $state, $timeout, $q) {
    var vm = this;

    vm.api = 'konsultacje/pracownicy/';
    vm.adresyEmailDoPowiadomien = {}; //klucz IdLok
    vm.anulujNowyEmail = anulujNowyEmail;
    vm.bootstrapKlasa = bootstrapKlasa;
    vm.columns = [
      {
        fieldName: "Imie",
        title: "Imię",
        class: 'table-cell-30-width',
        show: true,
        dataType: 'text',
        isEditable: true
      },
      {
        fieldName: "Nazwisko",
        title: "Nazwisko",
        class: 'table-cell-45-width',
        show: true,
        dataType: 'text',
        isEditable: true
      },
      {
        fieldName: "IdTab",
        title: "Dostęp do konsultacji",
        class: 'table-cell-5-width',
        colTemplate: '<input type="checkbox" style="position: relative;margin-left: 25px;top: 0" ng-model="row.IdTab" ng-click="vm.save(row, $event)" ></span>',
        show: true,
        dataType: 'checkbox',
        isEditable: true
      },
      {
        title: "",
        class: 'table-cell-15-width',
        show: true,
        dataType: 'command'
      }
    ];
    vm.dodajAdres = dodajAdres;
    vm.dodajPracownika = dodajPracownika;
    vm.dodawanieNowegoPracownika = false;
    vm.idName = 'IdPrac';
    vm.errorUpdateText = 'Wystąpił błąd podczas edycji pracownika.';
    vm.errorDeleteText = 'Wystąpił błąd podczas usuwania adresu e-mail.';
    vm.lokalizacje = [];
    vm.noweAdresyEmail = {};
    vm.odpowiedziSerweraEmail = {};
    vm.potwierdzUsunEmail = potwierdzUsunEmail;
    vm.pracownicy = [];
    vm.refreshEmailGrid = false;
    vm.wszyscyMajaUprawnienia = true;
    vm.zapiszEmail = zapiszEmail;

    var emailApi = Restangular.all(vm.adresyEmailApi);
    var konsultacjeApi = Restangular.all(vm.api);

    konsultacjeApi.getList({PageSize: 1000}).then(function(result) {
      vm.pracownicy = result;
    } , function(error) {
    });

    pobierzLokalizacje();

    function pobierzLokalizacje(){
      Restangular.all('licencje/lokalizacje/').getList().then(function(result) {
        vm.lokalizacje = result;
        pobierzISprawdzUprawnienia();
        pobierzEmaile(result);
      } , function(error) {
      });
    }

    function pobierzEmaile(lokalizacje){
      for(var i=0;i<lokalizacje.length; i++){
        var lok = lokalizacje[i];
        przypiszEmaileDlaLokalizacji(lok.IdLok, lok.AdresEmail);
      }
    }

    function przypiszEmaileDlaLokalizacji(idlok, adresEmail){
      if(adresEmail) {
        var stringList = adresEmail.split(';');
        var adresy = [];
        for (var j = 0; j < stringList.length; j++) {
          adresy.push({
            adres: stringList[j],
            edycja: false
          })
        }
        vm.adresyEmailDoPowiadomien[idlok] = adresy;
      }
      else{
        vm.adresyEmailDoPowiadomien[idlok] = [];
      }
    }

    function dodajAdres(idlok){
      vm.noweAdresyEmail[idlok] = {
        Email: ''
      }
    }

    function dodajPracownika(){
      $state.go('home.subMain.nowy_pracownik', {stan: 'konsultacje'});
    }

    function potwierdzUsunEmail(idlok, email){
      var ansList = $.grep(vm.lokalizacje, function (e) {
        return e.IdLok == idlok;
      });
      var lokalizacja = ansList[0];
      var aktualnyEmail = lokalizacja.AdresEmail;
      if(aktualnyEmail && !endsWith(aktualnyEmail, ';')){
        aktualnyEmail = aktualnyEmail + '; ';
      }
      var nowyEmail = aktualnyEmail.replace(email + ';', '');
      nowyEmail = nowyEmail.trim();
      if (endsWith(nowyEmail, ';')){
        nowyEmail = nowyEmail.slice(0, -1);
      }
      lokalizacja['id'] = idlok;
      lokalizacja.AdresEmail = nowyEmail;
      lokalizacja.put().then(
        function(lokalizacjaObj){
          przypiszEmaileDlaLokalizacji(lokalizacjaObj.IdLok, lokalizacjaObj.AdresEmail);
        },
        function(error){
          vm.odpowiedziSerweraEmail[idlok].push({
            typ: 'E',
            tekst: 'Wystąpił błąd podczas zapisywania adresu e-mail.'
          });
        }
      )
    }

    function zapiszEmail(idlok){
      var ansList = $.grep(vm.lokalizacje, function (e) {
        return e.IdLok == idlok;
      });
      var lokalizacja = ansList[0];
      var aktualnyEmail = '';
      if(lokalizacja.AdresEmail) {
        aktualnyEmail = lokalizacja.AdresEmail;
      }
      if(aktualnyEmail && aktualnyEmail.indexOf('@') > -1 && !endsWith(aktualnyEmail, ';')){
        aktualnyEmail = aktualnyEmail + '; ';
      }
      var email = vm.noweAdresyEmail[idlok].Email;
      var nowyEmail = aktualnyEmail + email;
      lokalizacja['id'] = idlok;
      lokalizacja.AdresEmail = nowyEmail;
      lokalizacja.put().then(
        function(lokalizacjaObj){
          anulujNowyEmail(idlok);
          przypiszEmaileDlaLokalizacji(lokalizacjaObj.IdLok, lokalizacjaObj.AdresEmail);
        },
        function(error){
          vm.odpowiedziSerweraEmail[idlok].push({
            typ: 'E',
            tekst: 'Wystąpił błąd podczas zapisywania adresu e-mail.'
          });
        }
      )
    }

    function endsWith(str, suffix) {
      return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    function anulujNowyEmail(idlok){
      delete vm.noweAdresyEmail[idlok];
    }

    function sprawdzUprawnieniaPracownikow(pracownicy){
      for (var i=0; i< pracownicy.length; i++){
        if (pracownicy[i].IdTab){
          vm.wszyscyMajaUprawnienia = false;
          break;
        }
      }
    }

    function pobierzISprawdzUprawnienia(){
      pobierzPracownikow().then(
        function(){
          sprawdzUprawnieniaPracownikow(vm.pracownicy);
        },
        function(){
          console.log("Błąd podczas pobierania pracowników");
        }
      );
    }

    function pobierzPracownikow(){
      var promises = [];
      for (var i=0; i<vm.lokalizacje.length; i++){
        var lokalizacja = vm.lokalizacje[i];
        var response = konsultacjeApi.getList({pageSize: 1000, id_lok: lokalizacja.IdLok}).then(function(result) {
          vm.pracownicy = vm.pracownicy.concat(result);
        } , function(error) {

        });
        promises.push(response)
      }
      return $q.all(promises);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('InformacjeDedykowanePlikiController', InformacjeDedykowanePlikiController);

  /** @ngInject */
  function InformacjeDedykowanePlikiController(plikiFirmowe, $state) {
    var vm = this;

    vm.informacja = null;
    vm.listaInformacji = plikiFirmowe.informacjeDedykowane();

    var informacjaID = $state.params.informacja;

    pobierzInformacje();

    function pobierzInformacje(){
      var ansList = $.grep(vm.listaInformacji, function (e) {
        return e.id == informacjaID;
      });
      if (angular.isDefined(ansList[0])){
        vm.informacja = ansList[0];
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('InformacjeDedykowaneController', InformacjeDedykowaneController);

    /** @ngInject */
    function InformacjeDedykowaneController(plikiFirmowe, $state, Restangular, pobieraniePlikow) {
        var vm = this;

        vm.listaInformacji = plikiFirmowe.informacjeDedykowane();
        vm.apiPliki = '/zarzadzaniePlikami/plikFile/';
        vm.wybranyPlik = null;


        vm.init = pobierz;
        vm.wybierzInformacje = wybierzInformacje;
        vm.getFile = getFile;
        vm.dajKlase = dajKlase;

        function wybierzInformacje(plik){
            vm.wybranyPlik = plik;
        }


        function pobierz(){
            Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami').getList({
                kategoria__nazwa: 'informacje_dedykowane', pageSize:100}).then(function (result) {
                vm.pliki = result;
                vm.wybranyPlik = result[0];
            });
        }

        function getFile() {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, vm.wybranyPlik.file[0]);
        }

        function dajKlase() {
            var className = "download",
              file = vm.wybranyPlik ? vm.wybranyPlik.file[0].file : '';

            if (file.endsWith('.pdf'))
                className += " pdf";
            else if (file.endsWith('.doc'))
                className += " doc";
            else if (file.endsWith('.wmv'))
                className += " wmv";
            else if (file.endsWith('.ars'))
                className += " ars";
            else if (file.endsWith('.dll'))
                className += " fa fa-file-archive-o fa-lg";

            return className;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('FakturyController', FakturyController);

    /** @ngInject */
    function FakturyController(duplikatModal, Restangular, $state, plikiOperacje, security, uprawnieniaSubUsera,
                               kontoPowiadomienModal, eFaktury, $q, bootstrapKlasa, dostep) {
        var vm = this;
        vm.api = "/faktury/faktury/";
        vm.security = security;
        vm.pagination = 10;
        vm.serverResponse = [];
        vm.serverPowiadomieniaResponse = [];
        vm.eFaktury = eFaktury;
        vm.pokazKontaDoPowiadomien = false;
        vm.kontaeFaktury = [];
        vm.dostep = dostep;
        vm.zapisaneAdresyEmail = [];
        vm.konto = {};
        vm.klient = {};
        vm.liczbaMaili = 0;
        vm.listaFaktur = null;
        vm.page = 1;
        vm.indexStart = 1;
        vm.bootstrapKlasa = bootstrapKlasa;

        vm.init = init;
        vm.pobierzFakture = pobierzFakture;
        vm.przejdzNaeFaktury = przejdzNaeFaktury;
        vm.dodajKontodoeFaktury = dodajKontodoeFaktury;
        vm.poprosODuplikat = poprosODuplikat;
        vm.zmienKontoeFaktur = zmienKontoeFaktur;
        vm.pobierzFaktury = pobierzFaktury;

        function poprosODuplikat(faktura) {
            duplikatModal.wyswietlModal(faktura.Symbol, vm.dostep).then(function (result) {
                vm.serverResponse = result;
                console.log(result);
            });
        }

        function pobierzAdresyPowiadomien() {
            if (vm.eFaktury) {
                vm.zapisaneAdresyEmail = [];
                return Restangular.all('/faktury/emailDoEfaktury/').getList().then(
                    function (konta) {
                        vm.kontaeFaktury = konta;
                        vm.liczbaMaili = konta.length;
                        angular.forEach(vm.kontaeFaktury, function (konto) {
                            vm.zapisaneAdresyEmail.push(konto.Adres);
                        });
                        return vm.zapisaneAdresyEmail;
                    },
                    function () {
                        vm.serverResponse.push({
                            typ: 'E',
                            tekst: 'Wystąpił błąd podczas pobierania informacji o kontach do powiadomień'
                        });
                    })
            }

        }

        function pobierzFaktury() {
            Restangular.all('faktury/faktury/').getList({page: vm.page}).then(function (faktury) {
                console.log(faktury.meta);
                vm.listaFaktur = faktury;
                vm.indexStart = (vm.page-1)*20;
            });
        }

        function init() {
            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                if (angular.isDefined(result[0])) {
                    vm.konto = result[0];
                }
            });
            if (security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function (result) {
                    vm.klient = result;
                });
            }

            pobierzAdresyPowiadomien();
            pobierzFaktury();
        }


        function pobierzFakture(faktura) {
            return plikiOperacje.pobierzPlik(vm.api, faktura.IdWyd, '/Wydruk/');
        }


        function przejdzNaeFaktury() {
            kontoPowiadomienModal.wyswietlModal(null, true, null).then(function (kontoPowiadomien) {
                var api = Restangular.all('/faktury/zgodaNaEfakture/');
                return api.post({}).then(function () {
                    api = Restangular.all('/faktury/emailDoEfaktury/');
                    return api.post(kontoPowiadomien).then(function (wynik) {
                        dodajZgloszenieDoIntranetu('Proszę o przekazywanie faktur w wersji elektronicznej', kontoPowiadomien);
                        pobierzAdresyPowiadomien();
                        vm.eFaktury = true;
                        return wynik
                    }, function (error) {
                        vm.eFaktury = true;
                        vm.serverResponse.push({
                            typ: 'E',
                            tekst: 'Wystąpił błąd podczas dodawania konta do powiadomień'
                        });
                    }).then(function () {

                    })
                }, function (error) {
                    vm.eFaktury = false;
                    vm.serverResponse.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas dodawania zgody do powiadomień'
                    });
                })
            });
        }

        function dodajKontodoeFaktury() {
            return kontoPowiadomienModal.wyswietlModal(null, false, 'Dodaj konto powiadomień').then(function (kontoPowiadomien) {
                var api = Restangular.all('/faktury/emailDoEfaktury/');
                return pobierzAdresyPowiadomien().then(function (zapisaneAdresy) {
                    if (zapisaneAdresy.indexOf(kontoPowiadomien.Adres) === -1) {
                        return api.post(kontoPowiadomien).then(function (wynik) {
                            dodajZgloszenieDoIntranetu('Dodanie konta do e-faktur', kontoPowiadomien);
                            pobierzAdresyPowiadomien();
                            return wynik;
                        }, function (error) {
                            vm.serverPowiadomieniaResponse.push({
                                typ: 'E',
                                tekst: 'Wystąpił błąd podczas dodawania konta do powiadomień'
                            });
                        });
                    } else {
                        vm.serverPowiadomieniaResponse.push({
                            typ: 'E',
                            tekst: 'Podany adres email jest już zapisany'
                        });
                    }
                });

            })
        }

        function zmienKontoeFaktur(kontoPowiadomien) {
            return kontoPowiadomienModal.wyswietlModal(kontoPowiadomien, false, 'Zmień konto powiadomień', vm.liczbaMaili).then(function (kontoPowiadomien) {
                return pobierzAdresyPowiadomien().then(function (zapisaneAdresy) {
                    if (zapisaneAdresy.length > 1 && kontoPowiadomien.usun === true) {
                        usunKontoeFaktur(kontoPowiadomien);
                    } else {
                        if (zapisaneAdresy.indexOf(kontoPowiadomien.Adres) === -1) {
                            return Restangular.all('faktury/emailDoEfaktury/update').post(kontoPowiadomien).then(function (wynik) {
                                dodajZgloszenieDoIntranetu('Zmiana konta do e-faktur', kontoPowiadomien);
                                pobierzAdresyPowiadomien();
                                vm.serverPowiadomieniaResponse.push({
                                    typ: 'S',
                                    tekst: 'Zapisano zmainy konta do powiadomień'
                                });
                                init();
                                return wynik;
                            }, function (error) {
                                vm.serverPowiadomieniaResponse.push({
                                    typ: 'E',
                                    tekst: 'Wystąpił błąd podczas zmainy konta do powiadomień'
                                });
                            });
                        } else {
                            return Restangular.all('faktury/emailDoEfaktury/update').post(kontoPowiadomien).then(function (wynik) {
                                pobierzAdresyPowiadomien();
                                vm.serverPowiadomieniaResponse.push({
                                    typ: 'S',
                                    tekst: 'Zapisano zmainy konta do powiadomień'
                                });
                                init();
                                return wynik;
                            }, function (error) {
                                vm.serverPowiadomieniaResponse.push({
                                    typ: 'E',
                                    tekst: 'Wystąpił błąd podczas aktualizowania konta do e-faktur'
                                });
                            });
                        }
                    }
                });

            });
        }

        function usunKontoeFaktur(konto) {
            return Restangular.all('faktury/emailDoEfaktury/delete').post(konto).then(
                function (result) {
                    dodajZgloszenieDoIntranetu('Usunięcie konta z e-faktur', konto);
                    pobierzAdresyPowiadomien();
                });
        }

        function dodajZgloszenieDoIntranetu(wiadomosc, dane) {
            var opis = wiadomosc;
            if (dane) {
                opis +=
                    // '\n\nIdMail: ' + dane.IdMail +
                    // '\nIdKth: ' + dane.IdKth +
                    // '\nIdPod: ' + dane.IdPod +
                    '\nAdres: ' + dane.Adres +
                    '\nImie: ' + dane.Imie +
                    '\nNazwisko: ' + dane.Nazwisko;
            }
            var requestParams = {
                tytul: 'Zgoda na e-Faktury',
                opis: opis,
                typ: 'Zamówienie',
                modul: 'STREFA',
                status: 'Zgłoszone',
                statusWew: 'Zgłoszone',
                nazwaKlienta: vm.konto.NazwaKr,
                kodKlienta: vm.konto.Kod,
                idPod: vm.konto.IdPod
            };
            if (vm.klient) {
                requestParams.klientNazwa = vm.klient.imie + ' ' + vm.klient.nazwisko;
                requestParams.klientEmail = vm.klient.email;
                requestParams.klientId = vm.klient.id;
                requestParams.klientTelefon = vm.klient.Telefon;
                requestParams.klientPlecMezczyzna = vm.klient.CzyMezczyzna;

            }
            return Restangular.all('zgloszenia/zgloszenia/').post(requestParams);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('TwojeKontoController', TwojeKontoController);

    /** @ngInject */
    function TwojeKontoController($scope, $state, security, Restangular, lokalizacjaAPI, dostepDoBety, dostep,
                                  uprawnieniaSubUsera) {
        var vm = this;
        vm.danePodstawowe = {};
        vm.dostepFTP = null;
        vm.dostepDoZgloszen = dostep;
        vm.pokazHasla = false;
        vm.systemy = {"Nazwa":"", "NazwaSp":""};
        vm.opiekun = {"Handlowy":"", "Merytoryczny":""};
        vm.adres = {};
        vm.adresKor = {};
        vm.innyKorespondencyjny = null;
        vm.uprawnienia = {Licencje: false};

        vm.init = init;

        function init() {
            if(security.jestSubUserem()) {
                uprawnieniaSubUsera.getUprawnienia().then(function (uprawnienia) {
                    vm.uprawnienia.Licencje = uprawnienia[0].Licencje;
                });
            } else {
                vm.uprawnienia.Licencje = true;
            }
        }

        vm.pokazDostepFtp = function () {
            vm.pokazHasla = !vm.pokazHasla;
        };

        vm.pobierzDane = function () {
            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                vm.danePodstawowe = result[0];
                vm.adres.Ulica = result[0].Ulica;
                vm.adresKor.Ulica = result[0].UlicaKor;
                vm.adres.Numer = result[0].Numer;
                vm.adresKor.Numer = result[0].NumerKor;
                vm.adres.KodPocztowy = result[0].KodPocztowy;
                vm.adresKor.KodPocztowy = result[0].KodPocztowyKor;
                vm.adres.Miasto = result[0].Miasto;
                vm.adresKor.Miasto = result[0].MiastoKor;
            }, function (error) {
            }).then(function(){
                if(JSON.stringify(vm.adres) !== JSON.stringify(vm.adresKor)) {
                    console.log(JSON.stringify(vm.adres)==JSON.stringify(vm.adresKor) );
                    vm.innyKorespondencyjny = true;
                }
            });

            Restangular.all('konto/licencje/').getList().then(function (result) {
                vm.systemy.Wersja = (result[0].Wersja ? result[0].Wersja / 10000 : '');
                vm.systemy.WersjaSp = (result[0].WersjaSp ? result[0].WersjaSp / 10000 : '');
            }, function (error) {
            });

            Restangular.all('konto/uzytkownicyftp/').getList().then(function (result) {
                vm.dostepFTP = result;
            }, function (error) {
            });

            Restangular.all('konto/opiekunowie/').getList().then(function (result) {
                angular.forEach(result, function (pracownik) {
                    if (pracownik.Dzial == 'DH') {
                        vm.opiekun.Handlowy = pracownik.Imie + ' ' + pracownik.Nazwisko
                    }
                    if (pracownik.Dzial == 'DW') {
                        vm.opiekun.Merytoryczny = pracownik.Imie + ' ' + pracownik.Nazwisko
                    }
                })
            }, function (error) {
            })
        };

        vm.goCoNowego = function () {
            $state.go('home.subMain.co_nowego')
        };

        vm.goZmianaLimitow = function () {
            $state.go('home.subMain.zmiana_limitow')
        };

        vm.goWycenaAktualizacji = function () {
            $state.go('home.subMain.wycena_aktualizacji')
        };

        vm.goGenerowanieLicencji = function () {
            $state.go('home.subMain.generowanie_licencji')
        };

        if (security.jestDostepDoDanychKlienta()) {
            vm.pobierzDane();
        } else {
                $state.go('home.subMain.podszyciePodKlienta')
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('StronaGlownaController', StronaGlownaController);

    /** @ngInject */
    function StronaGlownaController($state) {
        $state.go('home.subMain.konto')
    }

})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaZapisyNowyController', SeminariaZapisyNowyController);

    /** @ngInject */
    function SeminariaZapisyNowyController($http, security, bootstrapKlasa, seminaria, $sce, lokalizacjaAPI,
                                           Restangular, $state, Popup, $filter, $timeout, SzkoleniaResource) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.Math = Math;
        vm.seminaria = seminaria;
        vm.cena = seminaria.cenaNaOs;
        vm.nazwaZglaszajacego = null;
        vm.pracownik = {Telefon: null, email: null};
        vm.rabat = 0;
        vm.rabatPoczatkowy = 0;
        vm.liczbaOsob = 1;
        vm.zwolnienieZVAT = false;
        vm.status = 'wpłynęło';
        vm.osoby = [{}];
        vm.klient = {};
        vm.init = init;
        vm.trustAsHTML = trustAsHTML;
        vm.wyslij = wyslij;
        vm.dodajUczestnika = dodajUczestnika;
        vm.usunUczestnika = usunUczestnika;
        vm.odswierzKlientow = odswierzKlientow;
        vm.wybierzKlienta = wybierzKlienta;
        vm.sprawdzCzyJednodniowe = sprawdzCzyJednodniowe;
        vm.klienci = null;

        function init() {
            odswierzKlientow();
            if(seminaria.promocjaAktywna === true) {
                vm.rabat += vm.seminaria.wartoscPromocji/100;
                vm.rabatPoczatkowy += vm.seminaria.wartoscPromocji/100;
            }
        }

        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }


        function dodajUczestnika() {
            vm.osoby.push({imie:'', nazwisko:''});
            if(vm.liczbaOsob < vm.osoby.length) {
                vm.liczbaOsob = vm.osoby.length;
            }
        }
        function usunUczestnika(index) {
            vm.osoby.splice(index,1);
        }
        function wyslij() {
            vm.params = {
                szkolenie: seminaria.id,
                idKlienta: vm.klient.IdUsr,
                idPrac: null,
                numerKontaktowy: vm.pracownik.Telefon,
                status: vm.status,
                adresEmail: vm.pracownik.email,
                nazwaZglaszajacego: vm.nazwaZglaszajacego,
                kodKlienta: vm.klient.Kod,
                nazwaKlienta: vm.klient.Nazwa,
                liczbaOsob: vm.liczbaOsob,
                zwolnienieZVAT: vm.zwolnienieZVAT
            };
            var tresc = 'Potwierdzam, że przesłanie wypełnionego formularza jest równoznaczne z zamówieniem udziału w ' +
                'szkoleniu i otrzymaniem faktury za tę usługę (z uwzględnieniem możliwości rezygnacji w wyznaczonym terminie).' +
                '<br><br> Rezygnacja możliwa do: ' +  $filter('date')(new Date(vm.seminaria.rezygnacjaDo),'dd-MM-yyyy HH:mm');
            Popup.wyswietlInfo('Potwierdzenie zapisu', tresc,
                function() {
                    Restangular.all('seminaria/zapisy').post(vm.params).then(function(result) {
                        Restangular.all('seminaria/uczestnicy/zapiszWielu').post({zapis:result.id, users:vm.osoby}).then(function(res) {
                            $state.go('home.subMain.seminariaPZ.zapisy');
                        })
                    })
                },null);
        }

        function odswierzKlientow(params) {
            if(security.jestPracownikiemMieszczanin()===true) {
                if(!params){params = {pageSize:10}}
                return Restangular.all('konto/listaKontrachentow/').getList(params).then(
                    function (result) {
                        angular.forEach(result, function (klient) {
                            klient.krotkaNazwa = klient.NazwaKr;
                            klient.pelnaNazwa = klient.Nazwa.substr(0, 50);
                        });
                        vm.klienci = result;
                        return result;
                    }
                )
            }
        }

        function wybierzKlienta(item) {
            vm.rabat = vm.rabatPoczatkowy;
            $timeout(function() {
                Restangular.all('konto/czyStalaAktualizacja').getList({idUsr: vm.klient.IdUsr}).then(function (result) {
                    if (result.length > 0) {
                        vm.stalka = result[0].StalaAktal === 1;
                        vm.rabat += 0.15;
                    }
                });
            },1000)
        }

        function sprawdzCzyJednodniowe() {
            return SzkoleniaResource.czyJednodniowe(vm.seminaria.dataSzkolenia, vm.seminaria.dataKoncaSzkolenia);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaFormularzZapisyEdycjaController', SeminariaFormularzZapisyEdycjaController);

    /** @ngInject */
    function SeminariaFormularzZapisyEdycjaController(security, bootstrapKlasa, zapis, uczestnicy, $sce, lokalizacjaAPI,
                                                      Restangular, $state, Popup, SzkoleniaResource) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.security = security;
        vm.zapis = zapis;
        vm.seminarium = zapis.daneSzkolenia;
        vm.cena = zapis.daneSzkolenia.cenaNaOs;
        vm.odpowiedziSerwera = [];
        vm.uczestnicy = uczestnicy;
        vm.uczestnicyDoUsuniecia = [];
        vm.selectedId = [];
        vm.rabat = 0;
        vm.stalka = false;
        vm.liczbaOsob = (zapis.liczbaOsob > uczestnicy.length) ? zapis.liczbaOsob : uczestnicy.length;
        vm.liczbaOsobZPromocja = zapis.liczba_osob_z_promocja;
        vm.rabatStalka = 0;
        vm.rabatPromocja = 0;
        vm.sumaRabatow = 0;
        vm.sumaKoncowa = 0;
        vm.init = init;
        vm.trustAsHTML = trustAsHTML;
        vm.zapisz = zapisz;
        vm.dodajUczestnika = dodajUczestnika;
        vm.usunUczestnika = usunUczestnika;
        vm.zrezygnuj = zrezygnuj;
        vm.przeliczPodsumowanie = przeliczPodsumowanie;
        vm.sprawdzCzyJednodniowe = sprawdzCzyJednodniowe;

        function init() {
            Restangular.all('konto/czyStalaAktualizacja').getList({idUsr: zapis.idKlienta}).then(function(result) {
                 if(result.length > 0) {
                    vm.stalka = result[0].StalaAktal === 1;
                    vm.rabatStalka = 0.15;
                }
                vm.rabatPromocja = vm.seminarium.wartoscPromocji/100;
            }).then(function() {
                vm.przeliczPodsumowanie();
            });
        }

        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }

        function dodajUczestnika() {
            vm.uczestnicy.push({imie:'', nazwisko:''});
            if(vm.liczbaOsob < vm.uczestnicy.length) {
                vm.liczbaOsob = vm.liczbaOsob + 1;
            }
            vm.przeliczPodsumowanie();
        }
        function usunUczestnika(index) {
            if(angular.isDefined(vm.uczestnicy[index].id) === true) {
                vm.uczestnicyDoUsuniecia.push(vm.uczestnicy[index]);
            }

            vm.liczbaOsob = vm.liczbaOsob - 1;
            vm.uczestnicy.splice(index,1);
            vm.przeliczPodsumowanie();
        }
        function zapisz() {
            vm.zapis.liczbaOsob = (vm.liczbaOsob > 0) ? vm.liczbaOsob : 1;
            angular.forEach(vm.uczestnicyDoUsuniecia, function(uczestnik){
                uczestnik.remove();
            });
            Restangular.all('seminaria/uczestnicy/zapiszWielu').post({zapis: vm.zapis.id, users: vm.uczestnicy})
                .then(function(res) {
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Zapis na zgłoszenie został zaktualizowany'
                    });
                }).then(function() {
                vm.zapis.put().then(function(result) {
                }, function(error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas zapisywania zmian w zapisie na seminarium'
                    });
                })
            })
        }

        function zrezygnuj() {
            Popup.wyswietlInfo('Potwierdzenie', 'Czy na pewno chcesz zrezygnować ze szkolenia?',
                function() {
                    Restangular.all('seminaria/zapisy/'+vm.zapis.id+'/zrezygnuj').post().then(function() {
                        $state.go('home.subMain.seminaria');
                    }, function (e) {
                        vm.odpowiedziSerwera.push({
                            typ: 'E',
                            tekst: 'Nie udało się zrezygnować ze szkolenia.'
                        });
                    });
                },null);
        }

        function przeliczPodsumowanie() {
            vm.sumaKoncowa = ((vm.cena * (vm.liczbaOsob - vm.liczbaOsobZPromocja)) - ((vm.cena * (vm.liczbaOsob - vm.liczbaOsobZPromocja)) * vm.rabatStalka)) +
                ((vm.cena * vm.liczbaOsobZPromocja) - ((vm.cena * vm.liczbaOsobZPromocja) * (vm.rabatStalka + vm.rabatPromocja)));
            vm.sumaRabatow = ((vm.cena * (vm.liczbaOsob - vm.liczbaOsobZPromocja)) * vm.rabatStalka) + ((vm.cena * vm.liczbaOsobZPromocja) * (vm.rabatStalka + vm.rabatPromocja));
        }

        function sprawdzCzyJednodniowe() {
            return SzkoleniaResource.czyJednodniowe(vm.seminarium.dataSzkolenia, vm.seminarium.dataKoncaSzkolenia);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaZapisyEdycjaController', SeminariaZapisyEdycjaController);

    /** @ngInject */
    function SeminariaZapisyEdycjaController($http, security, bootstrapKlasa, zapis, uczestnicy, $sce, lokalizacjaAPI,
                                             Restangular, $state, Popup) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.security = security;
        vm.zapis = zapis;
        vm.status = zapis.status.slice();
        vm.seminarium = zapis.daneSzkolenia;
        vm.cena = zapis.daneSzkolenia.cenaNaOs;
        vm.odpowiedziSerwera = [];
        vm.uczestnicy = uczestnicy;
        vm.uczestnicyDoUsuniecia = [];
        vm.selectedId = [];
        vm.stalka = false;
        vm.liczbaOsob = (zapis.liczbaOsob > uczestnicy.length) ? zapis.liczbaOsob : uczestnicy.length;
        vm.liczbaOsobZPromocja = zapis.liczba_osob_z_promocja;
        vm.rabatStalka = 0;
        vm.rabatPromocja = 0;
        vm.sumaRabatow = 0;
        vm.sumaKoncowa = 0;
        vm.init = init;
        vm.trustAsHTML = trustAsHTML;
        vm.zapisz = zapisz;
        vm.dodajUczestnika = dodajUczestnika;
        vm.usunUczestnika = usunUczestnika;
        vm.przeliczPodsumowanie = przeliczPodsumowanie;
        vm.wyslijEmail = wyslijEmail;

        function init() {
            Restangular.all('konto/czyStalaAktualizacja').getList({idUsr: zapis.idKlienta}).then(function(result) {
                if(result.length > 0) {
                    vm.stalka = result[0].StalaAktal === 1;
                    vm.rabatStalka = 0.15;
                }
                vm.rabatPromocja = vm.seminarium.wartoscPromocji/100;
            }).then(function() {
                vm.przeliczPodsumowanie();
            });
        }

        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }

        function dodajUczestnika() {
            vm.uczestnicy.push({imie:'', nazwisko:''});
            if(vm.liczbaOsob < vm.uczestnicy.length) {
                vm.liczbaOsob = vm.liczbaOsob + 1;
            }
            vm.przeliczPodsumowanie();
        }
        function usunUczestnika(index) {
            if(angular.isDefined(vm.uczestnicy[index].id) === true) {
                vm.uczestnicyDoUsuniecia.push(vm.uczestnicy[index]);
            }

            vm.liczbaOsob = vm.liczbaOsob - 1;
            vm.uczestnicy.splice(index,1);
            vm.przeliczPodsumowanie();
        }
        function zapisz() {
            vm.zapis.liczbaOsob = (vm.liczbaOsob > 0) ? vm.liczbaOsob : 1;
            angular.forEach(vm.uczestnicyDoUsuniecia, function(uczestnik){
                uczestnik.remove();
            });
            Restangular.all('seminaria/uczestnicy/zapiszWielu').post({zapis: vm.zapis.id, users: vm.uczestnicy})
                .then(function(res) {
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Zapis na zgłoszenie został zaktualizowany'
                    });
                }).then(function() {
                vm.zapis.put().then(function(result) {
                    vm.status = result.status;
                }, function(error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas zapisywania zmian w zapisie na seminarium'
                    });
                })
            })

        }

        function przeliczPodsumowanie() {
            vm.sumaKoncowa = ((vm.cena * (vm.liczbaOsob - vm.liczbaOsobZPromocja)) - ((vm.cena * (vm.liczbaOsob - vm.liczbaOsobZPromocja)) * vm.rabatStalka)) +
                ((vm.cena * vm.liczbaOsobZPromocja) - ((vm.cena * vm.liczbaOsobZPromocja) * (vm.rabatStalka + vm.rabatPromocja)));
            vm.sumaRabatow = ((vm.cena * (vm.liczbaOsob - vm.liczbaOsobZPromocja)) * vm.rabatStalka) + ((vm.cena * vm.liczbaOsobZPromocja) * (vm.rabatStalka + vm.rabatPromocja));
        }

        function wyslijEmail() {
            Popup.wyswietlInfo('Potwierdzenie', 'Czy na pewno chcesz Wysłać email o zmiania statusu na: ' + vm.status + '?',
                function () {
                    Restangular.all('seminaria/zapisy/' + vm.zapis.id + '/wyslij_powiadomienie_email').post().then(function () {
                        vm.odpowiedziSerwera.push({
                            typ: 'S',
                            tekst: 'Wysłano e-mail z informacją o zmianie statusu'
                        });
                    }, function (e) {
                        vm.odpowiedziSerwera.push({
                            typ: 'E',
                            tekst: 'Nie udało się wysłać e-maila'
                        });
                    });
                }, null);

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaZapisyController', SeminariaZapisyController);

    /** @ngInject */
    function SeminariaZapisyController($http, $state, security, bootstrapKlasa, seminaria, $sce, lokalizacjaAPI, $timeout,
                                       Restangular, PrzeniesZapisPopup, ZmienStatusSzkoleniaPopup) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.seminaria = seminaria;
        vm.wybranyWiersz = [];
        vm.uczestnicy = [];
        vm.status = 'wszystkie';
        vm.apiZapisy = 'seminaria/zapisy';
        vm.rowTemplate = $("#rowTemplate").html();
        vm.refresh = false;
        vm.getid = function (id) {
            if (vm.status != 'wszystkie') {
                vm.refresh = true;
                return {szkolenie: id, filter: {status: vm.status}};
            }
            return {szkolenie: id};
        };
        vm.columns = [
            {
                fieldName: "kodKlienta",
                title: "Kod klienta",
                colTemplate: '<span>{{row.kodKlienta}}</span>',
                sortable: "kodKlienta",
                class: "table-cell-60-width",
                filter: {kodKlienta: "text"},
                show: true
            },
            {
                fieldName: "nazwaKlienta",
                title: "Firma",
                colTemplate: '<span>{{row.nazwaKlienta}}</span>',
                sortable: "nazwaKlienta",
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "liczbaOsob",
                title: "Uczestnicy",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.liczbaOsob}}</span>',
                sortable: "liczbaOsob",
                show: true
            },
            {
                fieldName: "dataZgloszenia",
                title: "Data zgłoszenia",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.dataZgloszenia | date : "dd.MM.yyyy"}}</span>',
                sortable: "dataZgloszenia",
                show: true
            },
            {
                fieldName: "cenaCalosc",
                title: "Łączna cena",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.cenaCalosc  | currency : "" }} zł</span>',
                sortable: "dataZgloszenia",
                show: true
            },
            {
                fieldName: "status",
                title: "Status",
                class: "table-cell-17-width",
                colTemplate: '<div style="text-align: center">' +
                    '<span class="label " ng-class="{\'label-default\': ' +
                    '(row.status == \'niezakwalifikowane\' || row.status == \'odwołane\'),' +
                    '\'label-danger\': row.status == \'zrezygnowano\',' +
                    '\'label-success\': row.status == \'zaakceptowane\',' +
                    '\'label-primary\': row.status == \'wpłynęło\'}">{{row.status}}<i class="fa fa-envelope" ng-if="row.wyslano_powiadomienie === true" style="margin-left: 5px" aria-hidden="true"></i></span>' +
                    '</div>',
                sortable: "status",
                filter: {status: "select"},
                filterData: [{title: ''}, {id: 'wpłynęło', title: 'wpłynęło'},
                    {id: 'zaakceptowane', title: "zaakceptowane"},
                    {id: 'niezakwalifikowane', title: 'niezakwalifikowane'},
                    {id: 'zrezygnowano', title: "zrezygnowano"}],
                show: true
            },
            {
                fieldName: "edycja",
                title: "",
                class: "table-cell-17-width",
                colTemplate: $("#Modyfikacja").html(),
                show: true
            }
        ];
        vm.trustAsHTML = trustAsHTML;
        vm.getFile = getFile;
        vm.odswiezZapisy = odswiezZapisy;
        vm.pobierzListeZaakceptowanych = pobierzListeZaakceptowanych;
        vm.pobierzListeWszystkichZapisanych = pobierzListeWszystkichZapisanych;
        vm.przeniesZapis = przeniesZapis;
        vm.zmienStatus = zmienStatus;


        function trustAsHTML(obj) {
            return $sce.trustAsHtml(obj);
        }

        function getFile(item) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: lokalizacjaAPI + '/seminaria/pliki/' + item.id + '/file/',
                responseType: "blob"
            }).success(function (result) {
                var blob = new Blob([result],
                    {type: 'octet/stream'});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = item.nazwa;
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            });
        }

        function pobierzUczestnikow(zapis) {
            Restangular.all('seminaria/uczestnicy').getList({zapis: zapis}).then(function (result) {
                vm.uczestnicy = result;
            });
        }

        function odswiezZapisy() {
            return Restangular.all('seminaria/zapisy').getList().then(function (result) {
                return result;
            })
        }

        function pobierzListeZaakceptowanych(id_seminarium) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: vm.lokalizacjaAPI + '/seminaria/szkolenia/' + id_seminarium + '/raport/',
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers['content-type'];
                var blob = new Blob([data],
                    {type: contentType});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = 'uczestnicy_seminarium.xlsx';
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            })
        }

        function pobierzListeWszystkichZapisanych(id_seminarium) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: vm.lokalizacjaAPI + '/seminaria/szkolenia/' + id_seminarium + '/lista_wszystkich_uczestnikow/',
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers['content-type'];
                var blob = new Blob([data],
                    {type: contentType});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = 'zapisani_seminarium.xlsx';
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            })
        }

        function przeniesZapis(zapis) {
            PrzeniesZapisPopup.wyswietlInfo(zapis).result.then(function (res) {
                $state.reload();
            });
        }

        function zmienStatus(zapis) {
            ZmienStatusSzkoleniaPopup.wyswietlInfo(zapis);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaController', SeminariaController);

    /** @ngInject */
    /**
     * @param  $state
     * @param {mFunkcje} mFunkcje
     */
    function SeminariaController($http, security, bootstrapKlasa, seminaria, $sce, lokalizacjaAPI, $timeout, zapisy,
                                 Restangular, dynamicznyTekst, pliki, $state, mFunkcje) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.seminaria = seminaria;
        vm.zapisy = zapisy;
        vm.dynamicznyTekst = dynamicznyTekst;
        vm.pliki = pliki;
        vm.wybranyWierszSzkolenia = null;
        vm.wybranyWierszZapisy = null;
        vm.uczestnicy = {};
        vm.apiSzkolenia = 'seminaria/szkolenia';
        vm.apiZapisy = 'seminaria/zapisy';
        vm.rowTemplateSzkolenia = $("#rowTemplateSzkolenia").html();
        vm.rowTemplateZapisy = $("#rowTemplateZapisy").html();
        vm.dzisiaj = new Date();
        vm.seminaria.dane = _.assign({}, vm.zapisy.dane,  {dataSzkolenia__gt: vm.dzisiaj});
        vm.zapisy.dane = _.assign({}, vm.zapisy.dane,  {szkolenie__dataSzkolenia__gt: vm.dzisiaj});

        vm.columnsSzkolenia = [
            {
                fieldName: "temat",
                title: "Temat szkolenia",
                colTemplate: '<span>{{row.temat}}</span>',
                sortable: "temat",
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "dataSzkolenia",
                title: "Data szkolenia",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.dataSzkolenia | date : "dd.MM.yyyy"}}<span ng-if="(row.dataSzkolenia | date: \'dd.MM.yyyy\') != (row.dataKoncaSzkolenia | date: \'dd.MM.yyyy\') \"> - {{row.dataKoncaSzkolenia | date: "dd.MM.yyyy"}}</span></span>',
                sortable: "dataSzkolenia",
                show: true
            },
            {
                fieldName: "rozwin",
                title: "",
                class: "table-cell-16-width",
                colTemplate: $("#rozwin").html(),
                show: true
            }
        ];

        vm.columnsZapisy = [
            {
                fieldName: "temat",
                title: "Temat szkolenia",
                colTemplate: '<span>{{row.daneSzkolenia.temat}}</span>',
                sortable: false,
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "status",
                title: "Status",
                class: "table-cell-17-width",
                colTemplate: '<div style="text-align: center">' +
                '<span class="label " ng-class="{\'label-default\': row.status == \'niezakwalifikowane\',' +
                '\'label-success\': row.status == \'zaakceptowane\',' +
                '\'label-primary\': row.status == \'wpłynęło\'}">{{row.status}}</span>' +
                '</div>',
                sortable: false,
                show: true
            },
            {
                fieldName: "rozwin",
                title: "",
                class: "table-cell-16-width",
                colTemplate: $("#rozwin").html(),
                show: true
            }
        ];

        init();

        function init() {
            if ($state.params.id) {
                /** Dodane opóźnienie 1s aby cały document poprawnie się załadował */
                $timeout(function () {
                    var szoklenie = 'szoklenie' + $state.params.id;
                    mFunkcje.scrollToAnchor(szoklenie, {yOffset: 100});

                    if (document.getElementById(szoklenie))
                        document.getElementById(szoklenie).click()
                }, 1000)
            }
        }

        vm.rozwin = rozwin;
        vm.trustAsHTML = trustAsHTML;
        vm.getFile = getFile;
        vm.getFileDT = getFileDT;
        vm.zrezygnuj = zrezygnuj;

        function rozwin(idTabeli, id) {
            if(vm.selectedId[idTabeli] === null || vm.selectedId[idTabeli] !== id) {
                vm.selectedId[idTabeli] = id;
            } else {
                vm.selectedId[idTabeli] = null;

            }
            if(angular.isDefined(vm.uczestnicy[id])===false && idTabeli===1) {
                pobierzUczestnikow(id);
            }
        }

        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }

        function getFile(item) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: lokalizacjaAPI+'/seminaria/pliki/'+item.id+'/file/',
                responseType: "blob"
            }).success(function(result) {
                var blob = new Blob([result],
                    { type: 'octet/stream'});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = item.nazwa;
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            });
        }
        function getFileDT(item) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                $http({
                    method: 'GET',
                    url: lokalizacjaAPI+'/seminaria/plikiDynamicznyTekst/'+item.id+'/file/',
                    responseType: "blob"
                }).success(function(result) {
                    var blob = new Blob([result],
                        { type: 'octet-stream'});
                    var url = URL.createObjectURL(blob);
                    a.href = url;
                    a.download = item.nazwaPliku;
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
        }


        function pobierzUczestnikow(zapis) {
            Restangular.all('seminaria/uczestnicy').getList({zapis: zapis}).then(function(result) {
                vm.uczestnicy[zapis] = result;
            });
        }

        function zrezygnuj(zapis) {
            Restangular.all('seminaria/zapisy/'+zapis+'/zrezygnuj').post();
        }
    }
})();
(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('SeminariaReklamacjaController', SeminariaReklamacjaController);

    /** @ngInject */
    function SeminariaReklamacjaController(bootstrapKlasa, $q, security, Restangular, $stateParams, $state, $window,
                                           uprawnieniaSubUsera, zapis, $sce) {
        var vm = this;
        vm.zapis = zapis;
        vm.osobaDoKontaktu = 0;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.odpowiedziSerwera = [];
        vm.lokalizacje = [];
        vm.loaded = true;
        vm.dotyczyWydruku = false;
        vm.poradaKrotka = false;
        vm.blokPoKr = true;
        vm.lokalizacja = '';
        vm.wymagane = false;
        vm.statusWysylania = 'nie_wyslano';
        vm.subuser = true;

        vm.klient = {};
        vm.pola = {
            typ: 'Zamówienie',
            tytul: 'Reklamacja do szkolenia',
            opis: '',
            modul: 'STREFA',
            wersjaEZN: null,
            wersjaUpdPack: null,
            idLokalizacji: null,
            nazwaLokalizacji: '',
            klientId: null,
            klientNazwa: '',
            klientTelefon: '',
            klientEmail: '',
            osDoKontaktuNazwa: null,
            osDoKontaktuTelefon: null,
            osDoKontaktuEmail: null,
            status: 'Zgłoszone',
            statusWew: 'Zgłoszone',
            nazwaKlienta: '',
            kodKlienta: null,
            symbolWydruku: '',
            klientPlecMezczyzna: '',
            idPod: null,
            grupa: null,
            poradaKrotka: null,
            dotAplMobilna: false,
            dotDanychOsobowych: false,
            seminarium: zapis.daneSzkolenia.id,
            zapis: zapis.id
        };
        vm.send = send;
        vm.init = init;
        vm.trustAsHTML = $sce.trustAsHtml;


        function init() {
            if (security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function (result) {
                    vm.pola.klientNazwa = result.imie + ' ' + result.nazwisko;
                    vm.pola.klientEmail = result.email;
                    vm.pola.klientId = result.id;
                    vm.pola.klientTelefon = result.Telefon;
                    vm.pola.klientPlecMezczyzna = result.CzyMezczyzna;
                    if (result.imie === null || result.nazwisko === null || result.email === null ||
                        angular.isDefined(result.imie) === false || angular.isDefined(result.nazwisko) === false ||
                        angular.isDefined(result.email) === false) {
                        $state.go('home.subMain.profil', {przekierowanie_dodaj: vm.typ});
                    }
                });

            } else {
                vm.subuser = false;
                vm.osobaDoKontaktu = 1;
            }

            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                if (angular.isDefined(result[0])) {
                    vm.pola.nazwaKlienta = result[0].NazwaKr;
                    vm.pola.kodKlienta = result[0].Kod;
                    vm.pola.idPod = result[0].IdPod;
                }
            });

            vm.loaded = false;
        }

        function send() {
            vm.statusWysylania = 'wysylanie';

            Restangular.all('zgloszenia/zgloszenia/').post(vm.pola).then(function (result) {
                $state.go('home.subMain.zgloszenia.listaKlienta');

            }, function (error) {
                vm.statusWysylania = 'nie_wyslano';
                var errorTemat = 'Wystąpił błąd. Sprawdź czy wszystkie wymagane pola są wypełnione.';
                if (error.data && error.data.non_field_errors && error.data.non_field_errors[0]) {
                    errorTemat = 'Limit otwartych zgłoszeń. ' + error.data.non_field_errors[0];
                }
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: errorTemat
                });
            });

        }

    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaPanelController', SeminariaPanelController);

    /** @ngInject */
    function SeminariaPanelController($http, security, bootstrapKlasa, seminaria, $sce, lokalizacjaAPI, $timeout,
                                 Restangular, SzkoleniaResource) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.seminaria = seminaria;
        vm.wybranyWiersz = null;
        vm.odswierzTabele = false;
        vm.rozwijaj = true;
        vm.api = 'seminaria/szkolenia';
        vm.dzisiaj = new Date();
        vm.selectedId = [];
        vm.uczestnicy = [];
        vm.rowTemplate = $("#rowTemplate").html();
        vm.seminaria.dane = Object.assign({}, vm.seminaria.dane,  {dataSzkolenia__gt: vm.dzisiaj});
        vm.columns = [
            {
                fieldName: "temat",
                title: "Temat szkolenia",
                colTemplate: '<span>{{row.temat}}</span>',
                sortable: "temat",
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "dataSzkolenia",
                title: "Data szkolenia",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.dataSzkolenia | date : "dd.MM.yyyy"}}</span><span ng-if="row.dataKoncaSzkolenia !== null && !vm.runExtFunction(\'sprawdzCzyJednodniowe\', row)""> - {{row.dataKoncaSzkolenia | date: "dd.MM.yyyy"}}</span>',
                sortable: "dataSzkolenia",
                show: true
            },
            {
                fieldName: "zapisDo",
                title: "Koniec zapisów",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.zapisDo| date : "dd.MM.yyyy"}}</span>',
                sortable: "zapisDo",
                show: true
            },
            {
                fieldName: "miejsce",
                title: "Miejsce",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.miejsce}}</span>',
                sortable: "miejsce",
                show: true
            },
            {
                fieldName: "edycja",
                title: "",
                class: "table-cell-16-width",
                colTemplate: $("#Modyfikacja").html(),
                show: true
            }
        ];

        vm.rozwin = rozwin;
        vm.trustAsHTML = trustAsHTML;
        vm.getFile = getFile;
        vm.zrezygnuj = zrezygnuj;
        vm.sprawdzCzyJednodniowe = sprawdzCzyJednodniowe;

        function rozwin( id) {
            vm.uczestnicy = [];
            if(vm.selectedId === null || vm.selectedId !== id) {
                vm.selectedId = id;
            } else {
                vm.selectedId = null;
            }
        }

        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }

        function getFile(item) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: lokalizacjaAPI+'/seminaria/pliki/'+item.id+'/file/',
                responseType: "blob"
            }).success(function(result) {
                var blob = new Blob([result],
                    { type: 'octet/stream'});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = item.nazwa;
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            });
        }


        function zrezygnuj(zapis) {
            Restangular.all('seminaria/zapisy/'+zapis+'/zrezygnuj').post();
        }

        function sprawdzCzyJednodniowe(szkolenie) {
            return SzkoleniaResource.czyJednodniowe(szkolenie.dataSzkolenia, szkolenie.dataKoncaSzkolenia);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaNoweController', SeminariaNoweController);

    /** @ngInject */
    function SeminariaNoweController(security, bootstrapKlasa, lokalizacjaAPI, Restangular, $state, wyslijPliki, $filter) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.odpowiedziSerwera = [];
        vm.pola = {
            temat: '',
            zakres: '',
            miejsce: '',
            dataSzkolenia: null,
            dataKoncaSzkolenia: null,
            cenaNaOs: 0,
            wartoscPromocji: 0,
            dataKoncaPromocji: null,
            maxUczestnikow: 0,
            typSzkolenia: '',
            rezygnacjaDo: null,
            zapisDo: null,
            adresSzkolenia: '',
            webinarium: false
        };

        vm.obliczCeny = obliczCeny;
        vm.dodajSeminarium = dodajSeminarium;

        function obliczCeny() {
            vm.pola.cenaNaOsZeStal = parseFloat(vm.pola.cenaNaOsBezStal) - (parseFloat(vm.pola.cenaNaOsBezStal)*0.15)
        }

        function dodajSeminarium(pliki, plikiZapisani) {
            vm.pola_do_zapisu = JSON.parse(JSON.stringify(vm.pola));
            // vm.pola_do_zapisu.dataKoncaSzkolenia = $filter('date')(vm.pola.dataKoncaSzkolenia, 'yyyy-MM-dd');

            Restangular.all('seminaria/szkolenia').post(vm.pola_do_zapisu).then(function(result) {
                var plikiParams = {szkolenie: result.id, widocznosc:'wszyscy'};
                var plikiZapisaniParams = {szkolenie: result.id, widocznosc:'zapisani'};

                wyslijPliki.wyslij('/seminaria/pliki/', pliki, plikiParams).then(function () {
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas wysyłania pliku widocznego dla wszystkich'
                    });
                });
                wyslijPliki.wyslij('/seminaria/pliki/', plikiZapisani, plikiZapisaniParams).then(function () {
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas wysyłania pliku widocznego dla zapisanych'
                    });
                });

            }, function (error) {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd podczas wysyłania danych, sprawdź czy wymagane pola są uzupełnione'
                });
            }).then(function() {
                $state.go('home.subMain.seminariaPZ');
            })

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('FormularzZgloszeniaSeminariaController', FormularzZgloszeniaSeminariaController);

    /** @ngInject */
    function FormularzZgloszeniaSeminariaController($http, security, bootstrapKlasa, seminaria, $sce, lokalizacjaAPI,
                                                    stalka, klient, pracownik, Restangular, $state, Popup, $filter,
                                                    SzkoleniaResource) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.Math = Math;
        vm.seminaria = seminaria;
        vm.selectedId = [];
        vm.cena = seminaria.cenaNaOs;
        vm.stalka = (angular.isDefined(stalka) === true) ? stalka.StalaAktal === 1 : false;
        vm.rabat = 0;
        vm.klient = klient;
        vm.pracownik = pracownik;
        vm.zglaszajacy = (security.jestSubUserem() == true) ? pracownik.imie + ' ' + pracownik.nazwisko : 'Konto główne';
        vm.liczbaOsob = 1;
        vm.zwolnienieZVAT = false;
        vm.osoby = [{imie:pracownik.imie, nazwisko:pracownik.nazwisko, numerKontaktowy:pracownik.Telefon, adresEmail:pracownik.email}];
        vm.init = init;
        vm.trustAsHTML = trustAsHTML;
        vm.getFile = getFile;
        vm.wyslij = wyslij;
        vm.dodajUczestnika = dodajUczestnika;
        vm.usunUczestnika = usunUczestnika;
        vm.sprawdzCzyJednodniowe = sprawdzCzyJednodniowe;

        function init() {
            if(angular.isDefined(stalka) === true) {
                if (stalka.StalaAktal === 1) {
                    vm.rabat += 0.15;
                }
            }
            if(seminaria.promocjaAktywna === true) {
                vm.rabat+= vm.seminaria.wartoscPromocji/100;
            }
        }

        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }

        function getFile(item) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: lokalizacjaAPI+'/seminaria/pliki/'+item.id+'/file/',
                responseType: "blob"
            }).success(function(result) {
                var blob = new Blob([result],
                    { type: 'application/pdf'});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = item.nazwaPliku;
                a.click();
                window.URL.revokeObjectURL(url);
            });
        }

        function dodajUczestnika() {
            vm.osoby.push({imie:'', nazwisko:''});
            if(vm.liczbaOsob < vm.osoby.length) {
                vm.liczbaOsob = vm.osoby.length;
            }
        }
        function usunUczestnika(index) {
            vm.osoby.splice(index,1);
        }
        function wyslij() {
            vm.params = {
                idKlienta: klient.IdUsr,
                idPrac: pracownik.idPrac,
                numerKontaktowy: vm.pracownik.Telefon,
                adresEmail: vm.pracownik.email,
                nazwaZglaszajacego: vm.zglaszajacy,
                kodKlienta: klient.Kod,
                nazwaKlienta: klient.Nazwa,
                liczbaOsob: vm.liczbaOsob,
                zwolnienieZVAT: vm.zwolnienieZVAT,
                uczestnicy: vm.osoby
            };
            var tresc = 'Potwierdzam, że przesłanie wypełnionego formularza jest równoznaczne z zamówieniem udziału w ' +
                'szkoleniu i otrzymaniem faktury za tę usługę (z uwzględnieniem możliwości rezygnacji w wyznaczonym terminie).' +
                '<br><br> Rezygnacja możliwa do: ' +  $filter('date')(new Date(vm.seminaria.rezygnacjaDo),'dd-MM-yyyy HH:mm');
            Popup.wyswietlInfo('Potwierdzenie zapisu', tresc,
                function() {
                    Restangular.all('seminaria/szkolenia/' + seminaria.id + '/zapiszUczestnikow').post(vm.params).then(function(result) {
                        $state.go('home.subMain.seminaria');
                    })
                },null);
        }
        function sprawdzCzyJednodniowe() {
            return SzkoleniaResource.czyJednodniowe(vm.seminaria.dataSzkolenia, vm.seminaria.dataKoncaSzkolenia);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaEdycjaController', SeminariaEdycjaController);

    /** @ngInject */
    function SeminariaEdycjaController(security, bootstrapKlasa, lokalizacjaAPI, Restangular, $state, $timeout,
                                       seminarium, pobieraniePlikow, wyslijPliki, $filter) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.odpowiedziSerwera = [];
        vm.seminarium = seminarium;
        vm.ukryjPrzyciskDodaj = {wszystkie: false, zapisani:false};
        vm.apiPliki = '/seminaria/pliki/';
        vm.obliczCeny = obliczCeny;
        vm.zapiszSeminarium = zapiszSeminarium;
        vm.pobierzPlik = pobierzPlik;
        vm.usunPlik = usunPlik;

        function obliczCeny() {
            vm.seminarium.cenaNaOsZeStal = parseFloat(vm.seminarium.cenaNaOsBezStal) - (parseFloat(vm.seminarium.cenaNaOsBezStal)*0.15)
        }

        function zapiszSeminarium(pliki, plikiZapisani) {
            vm.seminarium_do_zapisu = Restangular.copy(vm.seminarium);
            // vm.seminarium_do_zapisu.dataKoncaSzkolenia = $filter('date')(vm.seminarium.dataKoncaSzkolenia, 'yyyy-MM-dd');
            var plikiParams = {szkolenie: vm.seminarium.id, widocznosc:'wszyscy'};
            var plikiZapisaniParams = {szkolenie: vm.seminarium.id, widocznosc:'zapisani'};
            vm.seminarium_do_zapisu.put().then(function (result) {
                vm.odpowiedziSerwera.push({
                    typ: 'S',
                    tekst: 'Seminarium zostało zmienione'
                });


                wyslijPliki.wyslij('/seminaria/pliki/', pliki, plikiParams).then(function () {
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas wysyłania pliku widocznego dla wszystkich'
                    });
                });
                wyslijPliki.wyslij('/seminaria/pliki/', plikiZapisani, plikiZapisaniParams).then(function () {
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas wysyłania pliku widocznego dla zapisanych'
                    });
                });

            }, function (error) {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd podczas wysyłania danych, sprawdź czy wymagane pola są uzupełnione'
                });
            }).then(function() {
                $timeout(function() {updateSeminarium();}, 1000);

            });
        }

        function pobierzPlik(plik) {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, plik);
        }

        function usunPlik(plik) {
            Restangular.one('/seminaria/pliki/', plik.id).remove().then(function () {
                vm.odpowiedziSerwera.push({
                    typ: 'S',
                    tekst: 'Plik został usunięty'
                });
            } , function(error) {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd podczas usuwania pliku'
                });
            }).then(function() {
                updateSeminarium();
            })
        }

        function updateSeminarium() {
            Restangular.one('/seminaria/szkolenia/', vm.seminarium.id).get().then(function(result) {
                result.dataSzkolenia = new Date(result.dataSzkolenia);
                result.dataKoncaSzkolenia = (result.dataKoncaSzkolenia === null)? null : new Date(result.dataKoncaSzkolenia);
                result.zapisDo = new Date(result.zapisDo);
                result.rezygnacjaDo = new Date(result.rezygnacjaDo);
                result.dataKoncaPromocji = (result.dataKoncaPromocji === null)? null : new Date(result.dataKoncaPromocji);
                vm.seminarium = result;
                vm.ukryjPrzyciskDodaj = {wszystkie: false, zapisani:false};
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('DynamicznyTekstSeminariaController', DynamicznyTekstSeminariaController);

    /** @ngInject */
    function DynamicznyTekstSeminariaController(tekst, Restangular, wyslijPliki, $q, pliki, lokalizacjaAPI, $http) {
        var vm = this;
        vm.dynamicznyTekst = Restangular.copy(tekst);
        vm.edycja = false;
        vm.dodajDokumenty = false;
        vm.odpowiedziSerwera = [];
        vm.plikiEdycja = pliki;

        vm.edytuj = edytuj;
        vm.anuluj = anuluj;
        vm.zapisz = zapisz;
        vm.usunPlik = usunPlik;
        vm.dodajPliki = dodajPliki;
        vm.getFile = getFile;

        function edytuj() {
            vm.edycja = true;
            vm.dynamicznyTekst = Restangular.copy(tekst);
        }

        function anuluj() {
            vm.edycja = false;
            vm.dodajDokumenty = false;
            vm.dynamicznyTekst = Restangular.copy(tekst);
        }

        function zapisz(pliki) {
            vm.edycja = false;
            vm.dodajDokumenty = false;
            if (pliki) {
                dodajPliki(pliki);
            }

            Restangular.all('seminaria/dynamicznyTekst/seminaria').customPUT(vm.dynamicznyTekst).then(
                function () {
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Tekst został zmieniony.'
                    });
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Nie udało się zmienić tekstu.'
                    });
                }
            );
        }

        function dodajPliki(pl) {
            wyslijPliki.wyslij('/seminaria/plikiDynamicznyTekst/', pl, {}).then(function () {
                pliki.getList().then(function (result) {
                    vm.plikiEdycja = result;
                });
            }, function (error) {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd podczas wysyłania pliku'
                });
            });
        }

        function usunPlik(plik) {
            plik.remove().then(function () {
                pliki.getList().then(function (result) {
                    vm.plikiEdycja = result;
                });
            });
        }

        function getFile(item) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: lokalizacjaAPI + '/seminaria/plikiDynamicznyTekst/' + item.id + '/file/',
                responseType: "blob"
            }).success(function (result) {
                var blob = new Blob([result],
                    {type: 'octet/stream'});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = item.nazwaPliku;
                a.click();
                window.URL.revokeObjectURL(url);
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaArchiwumZapisowController', SeminariaArchiwumZapisowController);

    /** @ngInject */
    function SeminariaArchiwumZapisowController($http, security, bootstrapKlasa, $sce, lokalizacjaAPI, $timeout, zapisy,
                                 Restangular, SzkoleniaResource, $state) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.zapisy = zapisy;
        vm.wybranyWierszSzkolenia = null;
        vm.wybranyWierszZapisy = null;
        vm.uczestnicy = {};
        vm.apiZapisy = 'seminaria/zapisy';
        vm.rowTemplateZapisy = $("#rowTemplateZapisy").html();
        vm.dzisiaj = new Date();
        vm.zapisy.dane = Object.assign({}, vm.zapisy.dane,  {szkolenie__dataSzkolenia__lt: vm.dzisiaj});

        vm.columnsZapisy = [
            {
                fieldName: "temat",
                title: "Temat szkolenia",
                colTemplate: '<span>{{row.daneSzkolenia.temat}}</span>',
                sortable: false,
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "status",
                title: "Status",
                class: "table-cell-17-width",
                colTemplate: '<div style="text-align: center">' +
                '<span class="label " ng-class="{\'label-default\': row.status == \'niezakwalifikowane\',' +
                '\'label-success\': row.status == \'zaakceptowane\',' +
                '\'label-primary\': row.status == \'wpłynęło\'}">{{row.status}}</span>' +
                '</div>',
                sortable: false,
                show: true
            },
            {
                fieldName: "rozwin",
                title: "",
                class: "table-cell-16-width",
                colTemplate: $("#rozwin").html(),
                show: true
            }
        ];
        vm.rozwin = rozwin;
        vm.trustAsHTML = trustAsHTML;
        vm.getFile = getFile;
        vm.zrezygnuj = zrezygnuj;
        vm.sprawdzCzyJednodniowe = sprawdzCzyJednodniowe;
        vm.dodajReklamacje = dodajReklamacje;

        function rozwin(idTabeli, id) {
            if(vm.selectedId[idTabeli] === null || vm.selectedId[idTabeli] !== id) {
                vm.selectedId[idTabeli] = id;
            } else {
                vm.selectedId[idTabeli] = null;

            }
            if(angular.isDefined(vm.uczestnicy[id])===false && idTabeli===1) {
                pobierzUczestnikow(id);
            }
        }

        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }

        function getFile(item) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: lokalizacjaAPI+'/seminaria/pliki/'+item.id+'/file/',
                responseType: "blob"
            }).success(function(result) {
                var blob = new Blob([result],
                    { type: 'octet/stream'});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = item.nazwa;
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            });
        }

        function pobierzUczestnikow(zapis) {
            Restangular.all('seminaria/uczestnicy').getList({zapis: zapis}).then(function(result) {
                vm.uczestnicy[zapis] = result;
            });
        }

        function zrezygnuj(zapis) {
            Restangular.all('seminaria/zapisy/'+zapis+'/zrezygnuj').post();
        }

        function sprawdzCzyJednodniowe(szkolenie) {
            return SzkoleniaResource.czyJednodniowe(szkolenie.dataSzkolenia, szkolenie.dataKoncaSzkolenia);
        }

        function dodajReklamacje(szkolenie) {
            $state.go('home.subMain.seminariaReklamacja', szkolenie.id);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaZapisyArchiwumController', SeminariaZapisyArchiwumController);

    /** @ngInject */
    function SeminariaZapisyArchiwumController($http, security, bootstrapKlasa, seminaria, $sce, lokalizacjaAPI, $timeout,
                                               Restangular, $scope) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.seminaria = seminaria;
        vm.wybranyWiersz = [];
        vm.uczestnicy = [];
        vm.status = 'wszystkie';
        vm.apiZapisy = 'seminaria/zapisy';
        vm.rowTemplate = $("#rowTemplate").html();
        vm.refresh = false;
        vm.szukajSeminaria = '';
        vm.dzisiaj = new Date();
        vm.getid = function(id) {
            if(vm.status != 'wszystkie') {
                vm.refresh = true;
                return {szkolenie: id, filter: {status: vm.status}};
            }
            return {szkolenie: id};
        };
        vm.columns = [
            {
                fieldName: "kodKlienta",
                title: "Kod klienta",
                colTemplate: '<span>{{row.kodKlienta}}</span>',
                sortable: "kodKlienta",
                class: "table-cell-60-width",
                filter: {kodKlienta: "text"},
                show: true
            },
            {
                fieldName: "nazwaKlienta",
                title: "Firma",
                colTemplate: '<span>{{row.nazwaKlienta}}</span>',
                sortable: "nazwaKlienta",
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "liczbaOsob",
                title: "Uczestnicy",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.liczbaOsob}}</span>',
                sortable: "liczbaOsob",
                show: true
            },
            {
                fieldName: "dataZgloszenia",
                title: "Data zgłoszenia",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.dataZgloszenia | date : "dd.MM.yyyy"}}</span>',
                sortable: "dataZgloszenia",
                show: true
            },
            {
                fieldName: "cenaCalosc",
                title: "Łączna cena",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.cenaCalosc  | currency : "" }} zł</span>',
                sortable: "dataZgloszenia",
                show: true
            },
            {
                fieldName: "status",
                title: "Status",
                class: "table-cell-17-width",
                colTemplate: '<div style="text-align: center">' +
                    '<span class="label " ng-class="{\'label-default\': ' +
                    '(row.status == \'niezakwalifikowane\' || row.status == \'odwołane\'),' +
                    '\'label-danger\': row.status == \'zrezygnowano\',' +
                    '\'label-success\': row.status == \'zaakceptowane\',' +
                    '\'label-primary\': row.status == \'wpłynęło\'}">{{row.status}}</span>' +
                    '</div>',
                sortable: "status",
                filter: {status: "select"},
                filterData: [{title: ''}, {id: 'wpłynęło', title: 'wpłynęło'},
                    {id: 'zaakceptowane', title: "zaakceptowane"},
                    {id: 'niezakwalifikowane', title: 'niezakwalifikowane'},
                    {id: 'zrezygnowano', title: "zrezygnowano"}],
                show: true
            },
            {
                fieldName: "edycja",
                title: "",
                class: "table-cell-16-width",
                colTemplate: $("#Modyfikacja").html(),
                show: true
            }
        ];
        vm.trustAsHTML = trustAsHTML;
        vm.getFile = getFile;
        vm.odswiezZapisy = odswiezZapisy;
        vm.szukajSeminariow = szukajSeminariow;
        vm.pobierzListeZaakceptowanych = pobierzListeZaakceptowanych;
        vm.pobierzListeWszystkichZapisanych = pobierzListeWszystkichZapisanych;

        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }

        function getFile(item) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: lokalizacjaAPI+'/seminaria/pliki/'+item.id+'/file/',
                responseType: "blob"
            }).success(function(result) {
                var blob = new Blob([result],
                    { type: 'octet/stream'});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = item.nazwa;
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            });
        }

        function pobierzUczestnikow(zapis) {
            Restangular.all('seminaria/uczestnicy').getList({zapis: zapis}).then(function(result) {
                vm.uczestnicy = result;
            });
        }

        function odswiezZapisy() {
            return Restangular.all('seminaria/zapisy').getList().then(function (result) {
                return result;
            })
        }

        function szukajSeminariow() {
            return Restangular.all('seminaria/szkolenia').getList({z_zapisami: true, dataSzkolenia__lt: vm.dzisiaj,
                search: vm.szukajSeminaria, ordering: '-dataSzkolenia'}).then(function (result) {
                    vm.seminaria = result;
                    return result;
                });
        }

        function pobierzListeZaakceptowanych(id_seminarium) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: vm.lokalizacjaAPI + '/seminaria/szkolenia/' + id_seminarium + '/raport/',
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers['content-type'];
                var blob = new Blob([data],
                    { type: contentType});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = 'uczestnicy_seminarium.xlsx';
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            })
        }

        function pobierzListeWszystkichZapisanych(id_seminarium) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: vm.lokalizacjaAPI + '/seminaria/szkolenia/' + id_seminarium + '/lista_wszystkich_uczestnikow/',
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers['content-type'];
                var blob = new Blob([data],
                    { type: contentType});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = 'zapisani_seminarium.xlsx';
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            })
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SeminariaArchiwumSeminariowController', SeminariaArchiwumSeminariowController);

    /** @ngInject */
    function SeminariaArchiwumSeminariowController($http, security, bootstrapKlasa, seminaria, $sce, lokalizacjaAPI, $timeout,
                                 Restangular, SzkoleniaResource) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.seminaria = seminaria;
        vm.wybranyWiersz = null;
        vm.odswierzTabele = false;
        vm.rozwijaj = true;
        vm.api = 'seminaria/szkolenia';
        vm.dzisiaj = new Date();
        vm.selectedId = [];
        vm.uczestnicy = [];
        vm.rowTemplate = $("#rowTemplate").html();
        vm.seminaria.dane = Object.assign({}, vm.seminaria.dane,  {dataSzkolenia__lt: vm.dzisiaj});
        vm.columns = [
            {
                fieldName: "temat",
                title: "Temat szkolenia",
                colTemplate: '<span>{{row.temat}}</span>',
                sortable: "temat",
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "dataSzkolenia",
                title: "Data szkolenia",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.dataSzkolenia | date : "dd.MM.yyyy"}}</span><span ng-if="row.dataKoncaSzkolenia !== null && !vm.runExtFunction(\'sprawdzCzyJednodniowe\', row)"> - {{row.dataKoncaSzkolenia | date: "dd.MM.yyyy"}}</span>',
                sortable: "dataSzkolenia",
                show: true
            },
            {
                fieldName: "zapisDo",
                title: "Koniec zapisów",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.zapisDo| date : "dd.MM.yyyy"}}</span>',
                sortable: "zapisDo",
                show: true
            },
            {
                fieldName: "miejsce",
                title: "Miejsce",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.miejsce}}</span>',
                sortable: "miejsce",
                show: true
            },
            {
                fieldName: "edycja",
                title: "",
                class: "table-cell-16-width",
                colTemplate: $("#Modyfikacja").html(),
                show: true
            }
        ];

        vm.rozwin = rozwin;
        vm.trustAsHTML = trustAsHTML;
        vm.getFile = getFile;
        vm.zrezygnuj = zrezygnuj;
        vm.sprawdzCzyJednodniowe = sprawdzCzyJednodniowe;

        function rozwin( id) {
            vm.uczestnicy = [];
            if(vm.selectedId === null || vm.selectedId !== id) {
                vm.selectedId = id;
            } else {
                vm.selectedId = null;
            }
        }

        function trustAsHTML (obj) {
            return $sce.trustAsHtml(obj);
        }

        function getFile(item) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            $http({
                method: 'GET',
                url: lokalizacjaAPI+'/seminaria/pliki/'+item.id+'/file/',
                responseType: "blob"
            }).success(function(result) {
                var blob = new Blob([result],
                    { type: 'octet/stream'});
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = item.nazwa;
                $timeout(function () {
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            });
        }


        function zrezygnuj(zapis) {
            Restangular.all('seminaria/zapisy/'+zapis+'/zrezygnuj').post();
        }

         function sprawdzCzyJednodniowe(szkolenie) {
            return SzkoleniaResource.czyJednodniowe(szkolenie.dataSzkolenia, szkolenie.dataKoncaSzkolenia);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('PromocjeController', PromocjeController);

    /** @ngInject */
    /**
     * @param {mFunkcje} mFunkcje
     * @param $timeout
     */
    function PromocjeController($scope, $state, security, Restangular, promocje, bootstrapKlasa, uprawnieniaSubUsera,
                                promocjeSkorzystajModal, mFunkcje, $timeout) {
        var vm = this;
        vm.promocje = promocje;
        vm.security = security;
        vm.api = 'reklamacje/naglowki/';
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.grupa = 0;
        vm.dataDo = null;
        vm.segmentacja = {
            grupa1: {opis: 'Grupa pierwsza', wartosc: 1},
            grupa2: {opis: 'Grupa druga', wartosc: 2},
            grupa3: {opis: 'Grupa trzecia', wartosc: 3},
            grupa4: {opis: 'Grupa czwarta', wartosc: 4},
            wszyscy: {opis: 'Wszyscy', wartosc: null},
            biali: {opis: 'Wszyscy bez grupy', wartosc: 99}
        };
        vm.klient = null;


        init();
        pobierzUzytkownika();

        vm.obliczCzas = obliczCzas;
        vm.skorzystajZPromocji = skorzystajZPromocji;
        vm.oznaczJakoNieaktywna = oznaczJakoNieaktywna;
        vm.edytujPromocje = edytujPromocje;
        vm.aktywuj = aktywuj;
        vm.zapisz = zapisz;

        function init() {
          if ($state.params.id) {
            $timeout(function () {
              mFunkcje.scrollToAnchor('promocja' + $state.params.id, {yOffset: 100});
            }, 250);
          }
        }

        function pobierzUzytkownika() {
            if (security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function(result) {
                    vm.klient = result.imie + ' ' + result.nazwisko;
                });
            }
        }

        function aktywuj(promocja) {
            vm.grupa = promocja.segmentacja;
            vm.dataDo = new Date(promocja.dataDo);
            promocja.edycja = true;
        }

        function zapisz(promocja) {
            promocja.edycja = false;
            promocja.segmentacja = vm.grupa;
            promocja.dataDo = vm.dataDo;
            promocja.status = 'aktywna';
            promocja.put();
        }

        function obliczCzas(czas) {
            var now = new Date();
            var until = new Date(czas);
            var days = parseInt(((until - now)/(24*3600*1000)));
            var hours = parseInt(((until - now)/(3600*1000))-(days*24));
            var minutes = parseInt(((until - now)/(60*1000)-(days*24*60)-(hours*60)));
            if (minutes < 0) {
                return 'Promocja zakończona.'
            } else {
                return days + ' dni ' + hours + ' godzin ' + minutes + ' min.';
            }
        }

        function oznaczJakoNieaktywna(promocja) {
            promocja.status = 'nieaktywna';
            promocja.put();
        }

        function edytujPromocje(promocja) {
            $state.go('home.subMain.dodajPromocje', {idPromocji: promocja.id});
        }

        function skorzystajZPromocji(promocja) {
            var nowaPromocja = {
                Zglaszajacy: vm.klient,
                Temat: 'Klient zainteresowany promocją ' + promocja.tytul + '.',
                Typ: 4  // 'Sprzedaż'
            };
            if (new Date(promocja.dataDo) > new Date()) {
                Restangular.all(vm.api).post(nowaPromocja).then(
                    function (wynik) {
                        var zgloszenie = Restangular.one(vm.api, wynik.IdRek);
                        przypiszPracownika(zgloszenie);
                    },
                    function (e) {
                        promocjeSkorzystajModal.wyswietlModal('E', 'Wystąpił błąd podczas zapisywania zgłoszenia');
                    });
            } else {
                promocjeSkorzystajModal.wyswietlModal('E', 'Niestety promocja już się zakończyła');
            }
        }

        function przypiszPracownika(zgloszenie){
            if(zgloszenie) {
                zgloszenie.customPOST({IdPrac: 3626}, 'przypiszpracownika', {}, {}).then(
                    function (wynik) {
                        promocjeSkorzystajModal.wyswietlModal('S', 'Zgłoszenie pomyślnie przekazane do działu handlowego.');
                    },
                    function (error) {
                        promocjeSkorzystajModal.wyswietlModal('E', 'Wystąpił błąd podczas zapisywania zgłoszenia');
                    }
                )
            }
        }



    }
})();
(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('DodajPromocjeController', DodajPromocjeController);

    /** @ngInject */
    function DodajPromocjeController($scope, $state, bootstrapKlasa, promocja, wersje, PromocjeResource, Restangular) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.promocja = promocja.id === 0? {id: 0, tytul: null, dataOd: new Date(), dataDo: new Date(new Date().getFullYear(), 11, 31, 18), stanPromocji: null, tresc: null, grupa: null} : promocja;
        vm.wersje = wersje;
        vm.opcje = {
            umowaEkartoteka: {opis: 'Umowa e-kartoteki', wartosc: promocja.id === 0?null:promocja.umowa_ekartoteka, id: 'eka', ided: 'eeka', ezn: false},
            umowaSms: {opis: 'Umowa sms', wartosc: promocja.id === 0?null:promocja.umowa_sms, id: 'sms', ided: 'esms', ezn: false},
            umowaStalka: {opis: 'Umowa stałej aktualizacji', wartosc: promocja.id === 0?null:promocja.umowa_stalka, id: 'sta', ided: 'esta', ezn: false},
            umowaAdmSiecia: {opis: 'Umowa administracji siecią', wartosc: promocja.id === 0?null:promocja.umowa_adm_siecia, id: 'sie', ided: 'esie', ezn: false},
            programWsm: {opis: 'System Łatwej Obsługi Nieruchomości', wartosc: promocja.id === 0?null:promocja.program_wsm, id: 'wsm', ided: 'ewsm', ezn: true},
            programEmi: {opis: 'E-mieszczanin', wartosc: promocja.id === 0?null:promocja.program_emi, id: 'emi', ided: 'eemi', ezn: false},
            programZwo: {opis: 'Zarządzanie Obiegiem Dokumentów', wartosc: promocja.id === 0?null:promocja.program_zwo, id: 'zwo', ided: 'ezwo', ezn: true},
            programZni: {opis: 'Techniczna Obsługa Nieruchomości', wartosc: promocja.id === 0?null:promocja.program_zni, id: 'zni', ided: 'ezni', ezn: true},
            programWkl: {opis: 'Nieruchomości-Członkowie-Wkłady', wartosc: promocja.id === 0?null:promocja.program_wkl, id: 'wkl', ided: 'ewkl', ezn: true},
            programSsw: {opis: 'System Sprzedaży Wody', wartosc: promocja.id === 0?null:promocja.program_ssw, id: 'ssw', ided: 'essw', ezn: true},
            programSrt: {opis: 'Środki Trwałe', wartosc: promocja.id === 0?null:promocja.program_srt, id: 'srt', ided: 'esrt', ezn: true},
            programMag: {opis: 'Magazyn', wartosc: promocja.id === 0?null:promocja.program_mag, id: 'mag', ided: 'emag', ezn: true},
            programKip: {opis: 'Kadry i Płace', wartosc: promocja.id === 0?null:promocja.program_kip, id: 'kip', ided: 'ekip', ezn: true},
            programKas: {opis: 'Kasy', wartosc: promocja.id === 0?null:promocja.program_kas, id: 'kas', ided: 'ekas', ezn: true},
            programFik: {opis: 'Finanse i Księgowość', wartosc: promocja.id === 0?null:promocja.program_fik, id: 'fik', ided: 'efik', ezn: true},
            programFak: {opis: 'System Sprzedaży', wartosc: promocja.id === 0?null:promocja.program_fak, id: 'fak', ided: 'efak', ezn: true},
            programCen: {opis: 'Centrala', wartosc: promocja.id === 0?null:promocja.program_cen, id: 'cen', ided: 'ecen', ezn: true},
            programBan: {opis: 'Banki', wartosc: promocja.id === 0?null:promocja.program_ban, id: 'ban', ided: 'eban', ezn: true}
        };
        vm.segmentacja = {
            grupa1: {opis: 'Grupa pierwsza', wartosc: 1},
            grupa2: {opis: 'Grupa druga', wartosc: 2},
            grupa3: {opis: 'Grupa trzecia', wartosc: 3},
            grupa4: {opis: 'Grupa czwarta', wartosc: 4},
            wszyscy: {opis: 'Wszyscy', wartosc: null},
            biali: {opis: 'Wszyscy bez grupy', wartosc: 99}
        };
        vm.odpowiedziSerwera = [];

        vm.init = init;
        vm.zapiszPromocje = zapiszPromocje;

        init();

        function init() {
            if (promocja.id > 0) {
                promocja.dataDo = new Date(promocja.dataDo);
                promocja.dataOd = new Date(promocja.dataOd);
            }
        }

        function zapiszPromocje() {
            if (vm.promocja.id === 0) {
                PromocjeResource.dodajPromocje({
                    tytul: vm.promocja.tytul,
                    tresc: vm.promocja.tresc,
                    dataOd: vm.promocja.dataOd,
                    dataDo: vm.promocja.dataDo,
                    status: "aktywna",
                    umowa_ekartoteka: vm.opcje.umowaEkartoteka.wartosc,
                    umowa_sms: vm.opcje.umowaSms.wartosc,
                    umowa_stalka: vm.opcje.umowaStalka.wartosc,
                    umowa_adm_siecia: vm.opcje.umowaAdmSiecia.wartosc,
                    program_wsm: vm.opcje.programWsm.wartosc,
                    program_emi: vm.opcje.programEmi.wartosc,
                    program_zwo: vm.opcje.programZwo.wartosc,
                    program_zni: vm.opcje.programZni.wartosc,
                    program_wkl: vm.opcje.programWkl.wartosc,
                    program_ssw: vm.opcje.programSsw.wartosc,
                    program_srt: vm.opcje.programSrt.wartosc,
                    program_mag: vm.opcje.programMag.wartosc,
                    program_kip: vm.opcje.programKip.wartosc,
                    program_kas: vm.opcje.programKas.wartosc,
                    program_fik: vm.opcje.programFik.wartosc,
                    program_fak: vm.opcje.programFak.wartosc,
                    program_cen: vm.opcje.programCen.wartosc,
                    program_ban: vm.opcje.programBan.wartosc
                }).then(function (result) {
                    $state.go('home.subMain.promocje');
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas dodawania promocji, upewnij się, że wszystkie pola są poprawnie uzupełnione.'
                    })
                })
            } else {
                vm.promocja.umowa_ekartoteka = vm.opcje.umowaEkartoteka.wartosc;
                vm.promocja.umowa_sms = vm.opcje.umowaSms.wartosc;
                vm.promocja.umowa_stalka = vm.opcje.umowaStalka.wartosc;
                vm.promocja.umowa_adm_siecia = vm.opcje.umowaAdmSiecia.wartosc;
                vm.promocja.program_wsm = vm.opcje.programWsm.wartosc;
                vm.promocja.program_emi = vm.opcje.programEmi.wartosc;
                vm.promocja.program_zwo = vm.opcje.programZwo.wartosc;
                vm.promocja.program_zni = vm.opcje.programZni.wartosc;
                vm.promocja.program_wkl = vm.opcje.programWkl.wartosc;
                vm.promocja.program_ssw = vm.opcje.programSsw.wartosc;
                vm.promocja.program_srt = vm.opcje.programSrt.wartosc;
                vm.promocja.program_mag = vm.opcje.programMag.wartosc;
                vm.promocja.program_kip = vm.opcje.programKip.wartosc;
                vm.promocja.program_kas = vm.opcje.programKas.wartosc;
                vm.promocja.program_fik = vm.opcje.programFik.wartosc;
                vm.promocja.program_fak = vm.opcje.programFak.wartosc;
                vm.promocja.program_cen = vm.opcje.programCen.wartosc;
                vm.promocja.program_ban = vm.opcje.programBan.wartosc;

                PromocjeResource.aktualizujPromocje(vm.promocja).then(function (result) {
                    $state.go('home.subMain.promocje');
                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas edytowania promocji, upewnij się, że wszystkie pola są poprawnie uzupełnione.'
                    })
                });
            }
        }
    }
})();
(function(){
    'use strict';
    angular.module('strefaKlienta')
        .controller('PrezentacjaZebranOnlineController', PrezentacjaZebranOnlineController);

    /** @ngInject */
    function PrezentacjaZebranOnlineController($location,$anchorScroll, $sce, lokalizacjaAPI) {
        var vm = this;
        $anchorScroll.yOffset = 140;
        vm.film = 'prezentacjaZebranOnline.mp4';
        vm.lokalizacjaApi = (lokalizacjaAPI === '/api') ? 'https://www.mieszczanin.pl' : 'http://192.168.1.153:9000';
        vm.sourceZNapisami = [
                {
                    src: $sce.trustAsResourceUrl(vm.lokalizacjaApi + "/assets/files/" + vm.filmZNapisami),
                    type: "video/mp4"
                }
            ];
        vm.config = {
            preload: "none",
            sources: [
                {
                    src: $sce.trustAsResourceUrl(vm.lokalizacjaApi + "/assets/files/" + vm.film),
                    type: "video/mp4"
                }
            ],
            tracks: [
                {
                    src: "http://www.videogular.com/assets/subs/pale-blue-dot.vtt",
                    kind: "subtitles",
                    srclang: "en",
                    label: "English",
                    default: ""
                }
            ],
            theme: {
                url: "https://unpkg.com/videogular@2.1.2/dist/themes/default/videogular.css"
            }
        };


        vm.scrollToId = scrollToId;

        function scrollToId(id) {
            $location.hash(id);
            $anchorScroll();
        }

    }
})();
(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('ZgloszeniaKartaPotencjalnegoKlientaController', ZgloszeniaKartaPotencjalnegoKlientaController);

    /** @ngInject */
    function ZgloszeniaKartaPotencjalnegoKlientaController(bootstrapKlasa, lokalizacjaAPI, dostepDoBety, security,
                                                           $stateParams, $sce, Restangular, $uibModal, $state, wyslijPliki, $q,
                                                           $window, pobieraniePlikow, statusService, liczbaZgloszen,
                                                           zapytanieOfertoweService, PodgladOfertyModal, potencjalnyKlient,
                                                           zgloszenie, $location, UzupelnienieInformacjiPodKliModal) {
        var vm = this;
        vm.sce = $sce;
        vm.tokenLink = $location.search().tokenpk;
        vm.security = security;
        vm.statusService = statusService;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.dostepDoBety = dostepDoBety;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.zgloszenie = zgloszenie;
        vm.numerZgloszenia = zgloszenie.id;
        vm.wyslijPrzywrocText = 'Wyślij komentarz';
        vm.komentarz = "";
        vm.apiPliki = '/zgloszenia/pliki_zgloszenia/';
        vm.uploader = null;
        vm.uzytkownikId = null;
        vm.pliki = [];
        vm.wersje = [];
        vm.uzytkownik = [];
        vm.komentarze = [];
        vm.aktywnosci = [];
        vm.podswKomentarza = [];
        vm.podswAktywnosci = [];
        vm.listaPracownikow = [];
        vm.odpowiedziSerwera = [];
        vm.czyZamkniete = (['Zamknięte', 'Rozwiązane', 'Odłożone'].indexOf(zgloszenie.status) !== -1 && vm.zgloszenie.bezMozliwosciPrzywrocenia === false) ? null : ['Zamknięte', 'Rozwiązane', 'Odłożone'].indexOf(zgloszenie.status) !== -1;
        vm.wyslijPrzywrocText = "";
        vm.programy = {};
        vm.oferta = null;
        vm.akceptacjaOferty = true;
        vm.oferty = {};
        vm.ladowanieOfert = true;
        vm.ofertyLista = [];
        vm.statusy = ['Nowe', 'W trakcie', 'Zamknięte'];
        vm.typy = ['Konsultacja', 'Zamówienie', 'Propozycja rozwoju', 'Problem', 'Pomoc techniczna'];
        vm.kolorDlaStatusu = {
            'Nowe': 'label-primary',
            'W trakcie': 'label-warning',
            'Zamknięte': 'label-success'
        };
        vm.ikonaTypu = {
            'Konsultacja': 'fa-headphones',
            'Zamówienie': 'fa-file-text-o',
            'Propozycja rozwoju': 'fa-lightbulb-o',
            'Problem': 'fa-bug',
            'Pomoc techniczna': 'fa-wrench'
        };
        vm.dodajDokumenty = false;
        vm.uploadPliki = null;
        vm.klient = null;

        vm.dodajKomentarz = dodajKomentarz;
        vm.init = init;
        vm.getfile = getfile;
        vm.pokazOferte = pokazOferte;
        vm.getTrustedHtml = $sce.trustAsHtml;

        function init() {
            odswierzDane();

        }

        function getfile(item) {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, item);
        }


        function odswierzDane() {
            potencjalnyKlient.dajInformacjeOKliencie(vm.tokenLink).then(function (res) {
                vm.klient = (res.length > 0) ? res[0] : null;
            });
            potencjalnyKlient.dajOferty(vm.tokenLink).then(function (result) {
                vm.ofertyLista = result;
                angular.forEach(result, function (oferta) {
                    vm.oferty[oferta.id] = oferta;
                });
                vm.ladowanieOfert = false;
            });
            potencjalnyKlient.dajKomentarzeZgloszenia(vm.tokenLink).then(function (result) {
                vm.komentarze = result;
            });
            potencjalnyKlient.dajPlikiZgloszenia(vm.tokenLink).then(function (pliki) {
                vm.pliki = pliki;
            });
        }

        function dodajKomentarz(pliki) {
            if (vm.czyZamkniete === null && vm.zgloszenie.bezMozliwosciPrzywrocenia === false) {
                vm.czyZamkniete = null;
            } else {
                if (vm.komentarz.length > 0 && ['Odrzucone', 'Odłożone', 'Zmieniona kategoria'].indexOf(vm.zgloszenie.status) === -1) {
                    var kom = vm.komentarz;
                    vm.komentarz = '';
                    Restangular.all('/zgloszenia/komentarze/').post({
                        zgloszenie: vm.numerZgloszenia,
                        tresc: kom,
                        uzytkownikNazwa: vm.zgloszenie.osDoKontaktuNazwa
                    }).then(function (result) {
                        loadFiles(pliki, result.id).then(function () {
                            vm.dodajDokumenty = false;
                        });
                    }, function () {
                        vm.odpowiedziSerwera.push({
                            typ: 'E',
                            tekst: 'Wystąpił błąd podczas dodawania zgłoszenia.'
                        });
                    }).then(function () {
                        odswierzDane();
                    });
                }
            }
        }

        function loadFiles(pliki, idKomentarza) {
            var params = {idZgloszenia: vm.zgloszenie.id, autor: vm.zgloszenie.osDoKontaktuNazwa};
            if (idKomentarza != null) params['idKomentarza'] = idKomentarza;
            return wyslijPliki.wyslij('/zgloszenia/pliki_zgloszenia/', pliki, params).then(function () {
                    // return pobierzPliki({id:zgloszenie.id})
                },
                function (error) {
                    return $q.reject(error);
                });
        }

        function pokazOferte(oferta) {
            // UzupelnienieInformacjiPodKliModal.wyswietlModal(vm.tokenLink);
            PodgladOfertyModal.wyswietlModal(oferta, vm.tokenLink, vm.akceptacjaOferty).then(function (res) {
                odswierzDane();
            });
        }
    }
})();
(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('PotKliController', PotKliController);

    /** @ngInject */
    function PotKliController() {
        var vm = this;
    }
})();
(function () {
    'use strict';
    angular.module('strefaKlienta')
        .controller('PotKliBrakDostepuController', PotKliBrakDostepuController);

    /** @ngInject */
    function PotKliBrakDostepuController(token, $state, potencjalnyKlient) {
        var vm = this;
        vm.wyslano = false;
        vm.poprosONowyToken = poprosONowyToken;

        function poprosONowyToken() {
            vm.wyslano = true;
            potencjalnyKlient.poprosONowyToken(token);
        }
        init();
        function init() {
            if (token === null) {
                $state.go('home.stronaGlowna');
            }
        }
    }
})();
/**
 * Created by dp on 31.08.16.
 */
(function(){
    angular.module('strefaKlienta')
        .controller('popupEdytorController',popupEdytorCtrl);

    function popupEdytorCtrl(Restangular,$sce, $timeout, $state, $stateParams, $window) {
        var vm = this;
        vm.idp = 0;
        vm.id = $stateParams.idp;
        vm.window = $window;
        vm.api = 'popup/popup/';
        vm.dane = [];
        vm.odpowiedziSerwera = [];
        vm.data_start = new Date();
        vm.data_koniec = new Date();
        vm.btnWyslijDisabled = false;
        vm.popupAdded = false;
        vm.popupUpdated = false;
        vm.refreshGrid = false;
        vm.popupDeleted = false;
        vm.globalSearch = true;
        vm.showFilter = true;
        vm.wybranyWiersz = null;
        vm.popupDoEdycji = null;
        vm.zaznaczPierwszyWiersz = false;

        vm.rowTemplate = $("#rowTemplate").html();

        vm.init = init;
        vm.edytujPopup = edytujPopup;
        vm.przejdzDoEdycji = przejdzDoEdycji;
        vm.wyslijPopup = wyslijPopup;

        if (vm.id==null && $state.current.name == 'home.subMain.popupEdytor.popupEdycja')
        {
            $state.go('home.subMain.popupEdytor.popupLista');
        }

        vm.columns = [
            {
                fieldName: "naglowek",
                title: "Nagłówek",
                colTemplate: '<span ng-bind-html="vm.wyswietlHTML(row.naglowek)"></span>',
                sortable: "naglowek",
                filter: {naglowek: "text"},
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "data_start",
                title: "Data rozpoczęcia",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.data_start | date : "dd.MM.yyyy"}}</span>',
                filter: {data_start: "text"},
                sortable: "data_start",
                show: true
            },
            {
                fieldName: "data_koniec",
                title: "Data zakończenia",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.data_koniec| date : "dd.MM.yyyy"}}</span>',
                filter: {data_koniec: "text"},
                sortable: "data_koniec",
                show: true
            },
            {
                fieldName: "edycja",
                title: "Operacja",
                class: "table-cell-16-width",
                colTemplate: $("#Operacja").html(),
                show: true
            }
        ];

        vm.dodaj = {
            naglowek: vm.naglowek,
            tresc: vm.tresc,
            data_start: (vm.data_start.getFullYear() + '-' + (vm.data_start.getMonth()+1) + '-' + vm.data_start.getUTCDate()),
            data_koniec: (vm.data_koniec.getFullYear() + '-' + (vm.data_koniec.getMonth()+1) + '-' + vm.data_koniec.getUTCDate())
        };

        vm.pustyPopup = {
            naglowek: vm.naglowek,
            tresc: vm.tresc,
            data_s: (vm.data_start.getFullYear() + '-' + (vm.data_start.getMonth()+1) + '-' + vm.data_start.getUTCDate()),
            data_k: (vm.data_koniec.getFullYear() + '-' + (vm.data_koniec.getMonth()+1) + '-' + vm.data_koniec.getUTCDate())
        };

        function init() {
            Restangular.all(vm.api).getList().then(function (result) {
                vm.dane = result;
                angular.forEach(result, function (val) {
                    if(val.id == vm.id) {
                        vm.popupDoEdycji = vm.dane[vm.dane.indexOf(val)];
                        vm.data_start = new Date(
                            vm.popupDoEdycji.data_start.substr(0,4),
                            vm.popupDoEdycji.data_start.substr(5,2)-1,
                            vm.popupDoEdycji.data_start.substr(8,2));
                        vm.data_koniec = new Date(
                            vm.popupDoEdycji.data_koniec.substr(0,4),
                            vm.popupDoEdycji.data_koniec.substr(5,2)-1,
                            vm.popupDoEdycji.data_koniec.substr(8,2));
                    }
                });

            }, function (error) {
                console.log("Error")
            }).then(function(){

            });
        };

        function edytujPopup(){
            vm.popupUpdated=true;
            vm.popupDoEdycji.data_start = (vm.data_start.getFullYear() + '-' + (vm.data_start.getMonth()+1) + '-' + (vm.data_start.getUTCDate()+1));
            vm.popupDoEdycji.data_koniec = (vm.data_koniec.getFullYear() + '-' + (vm.data_koniec.getMonth()+1) + '-' + (vm.data_koniec.getUTCDate()+1));
            Restangular.one(vm.api+vm.popupDoEdycji.id).customPUT(vm.popupDoEdycji).then(
                function (zgloszenie) {
                    vm.popup = Restangular.one(vm.api, zgloszenie.id);
                    zakonczWyslij();
                    $state.go('home.subMain.popupEdytor.popupLista');
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Dane zostały dodane.'
                    });
                },
                function (e) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas wysylania danych'
                    });
                    vm.btnWyslijDisabled = false;
                });
            zakonczWyslij();
        };

        function przejdzDoEdycji(idp) {
            $state.go('home.subMain.popupEdytor.popupEdycja/'+idp);
        };

        var dodajApi = Restangular.all(vm.api);

        function wyslijPopup() {
            if (!vm.btnWyslijDisabled) {
                vm.btnWyslijDisabled = true;
                //konwersja daty
                vm.dodaj.data_start = (vm.data_start.getFullYear() + '-' + (vm.data_start.getMonth() + 1) + '-' + vm.data_start.getUTCDate());
                vm.dodaj.data_koniec = (vm.data_koniec.getFullYear() + '-' + (vm.data_koniec.getMonth() + 1) + '-' + vm.data_koniec.getUTCDate());
                dodajApi.post(vm.dodaj).then(
                    function (zgloszenie) {
                        vm.popup = Restangular.one(vm.api, zgloszenie.id);
                        zakonczWyslij();
                        $state.go('home.subMain.popupEdytor.popupLista');
                        vm.odpowiedziSerwera.push({
                            typ: 'S',
                            tekst: 'Dane zostały dodane.'
                        });
                    },
                    function (e) {
                        vm.odpowiedziSerwera.push({
                            typ: 'E',
                            tekst: 'Wystąpił błąd podczas wysylania danych'
                        });
                        vm.btnWyslijDisabled = false;
                    });
            }
        };
        
        function zakonczWyslij() {
            vm.btnWyslijDisabled = false;
            vm.zaznaczPierwszyWiersz = true;
            $timeout(function(){
                $state.go('home.subMain.popupEdytor.popupLista');
            }, 2000);
            vm.globalSearch = false;
            vm.showFilter = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('PodszyciePodKlientaController', PodszyciePodKlientaController);

    /** @ngInject */
    function PodszyciePodKlientaController(Restangular, security, $state, bootstrapKlasa) {
        var vm = this;
        vm.czyPracownik = false;
        vm.searchKontrachent = '';
        vm.kontrachenci = [];
        vm.kontrachent = null;
        vm.bootstrapKlasa = bootstrapKlasa;

        vm.init = init;
        vm.odswierzKontrachentow = odswierzKontrachentow;
        vm.wybierzKontrachenta = wybierzKontrachenta;
        vm.zaloguj = zaloguj;


        function init() {
            if(security.jestPracownikiemMieszczanin()===true) {
                vm.czyPracownik = true;
            }
            odswierzKontrachentow();
        }

        function odswierzKontrachentow(params) {
            if(security.jestPracownikiemMieszczanin()===true) {
                if(!params){params = {pageSize:10}}
                return Restangular.all('konto/listaKontrachentow/').getList(params).then(
                    function (result) {
                        angular.forEach(result, function (klient) {
                            klient.krotkaNazwa = klient.NazwaKr;
                            klient.pelnaNazwa = klient.Nazwa.substr(0, 50);
                        });
                        vm.kontrachenci = result;
                        return result;
                    }
                )
            }
        }

        function wybierzKontrachenta(items) {
        }

        function zaloguj() {
            Restangular.all('pracownicy/zalogujNaKlienta/').post({IdPod:vm.kontrachent.IDPod}).then(
                function(res) {
                    security.relogExt(res.IdPod, res.SessionId);
                })
        }

    }
})();
(function () {
  'use strict';
  angular.module('strefaKlienta')
    .controller('PlatnosciOnlineEKController', PlatnosciOnlineEKController);

  /** @ngInject */
  function PlatnosciOnlineEKController() {
    var vm = this;

    vm.states = [
      platnosciOnlineEKState('home.subMain.platnosciOnline', 'Płatności online'),
      platnosciOnlineEKState('home.subMain.platnosciOnline.dlaczegoWarto', 'Dlaczego warto'),
      platnosciOnlineEKState('home.subMain.platnosciOnline.instrukcja', 'Instrukcja'),
      platnosciOnlineEKState('home.subMain.platnosciOnline.visa', 'Konkurs visa'),
      platnosciOnlineEKState('home.subMain.platnosciOnline.pytania', 'Najczęstsze pytania'),
    ];

    function platnosciOnlineEKState(state, nazwa){
      return {
        state: state,
        nazwa: nazwa
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('MapaStronyController', MapaStronyController);

  /** @ngInject */
  function MapaStronyController() {
    var vm = this;


  }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(security, $state, $stateParams, $location) {
        var vm = this;
        vm.fallbackState = 'home.subMain.konto';
        vm.nextState = null;
        vm.nextParams = null;
        vm.urlParams = $stateParams.urlParams !==null ? $stateParams.urlParams : $location.search();
        vm.blad = '';
        vm.haslo = '';
        vm.uzytkownik = '';
        vm.init = init;
        vm.zaloguj = zaloguj;
        vm.wyswietlBlad = wyswietlBlad;

        init();

        function wyswietlBlad (blad) {
            vm.blad = blad;
        }

        function zaloguj() {

            security.login(vm.uzytkownik, vm.haslo, vm.wyswietlBlad, vm.nextState ? vm.nextState : vm.fallbackState,
                vm.nextParams, $stateParams.urlParams);
        }

        function init() {
            if(security.isLogin()){$state.go('home.subMain.konto')}
            vm.nextState = $stateParams.nextState;
            vm.nextParams = $stateParams.nextParams;

            if(angular.isDefined(vm.urlParams) === true && vm.urlParams !== null) {
                if(Object.keys(vm.urlParams).length>0) {
                    security.login(vm.uzytkownik, vm.haslo, vm.wyswietlBlad, vm.nextState ? vm.nextState : vm.fallbackState,
                        vm.nextParams, vm.urlParams);
                }
            }
        }

    }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('ExtLoginController', ExtLoginController);

  /** @ngInject */
  function ExtLoginController(security, $state) {
    var vm = this;

    var params = $state.params,
      user = null,
      token = null,
      idrek = null,
      stateparams = null,
      stan = 'home.subMain.konto';
    if (angular.isDefined(params.user)){
      user = params.user;
    }
    else {
      $state.go('home.login');
    }
    if (angular.isDefined(params.token)){
      token = params.token;
    }
    else {
      $state.go('home.login');
    }
    if (angular.isDefined(params.idrek)){
      //todo obsluga przechodzenia do stanów - może jakiś serwis stworzyć?
      idrek = params.idrek;
      stateparams = { 'idrek' : idrek };
      stan = 'home.subMain.zgloszenia_stare.reklamacje';
    }

    vm.wyswietlBlad = wyswietlBlad;
    zaloguj();

    function wyswietlBlad(blad) {
      $state.go('home.login');
    }

    function zaloguj(){
      security.login(user, token, vm.wyswietlBlad, stan, stateparams);
    }


  }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('WynikiGlosowaniaController', WynikiGlosowaniaController);

    /** @ngInject */
    function WynikiGlosowaniaController($http, security, bootstrapKlasa, $sce, lokalizacjaAPI, glosowanie, $timeout,
                                        Restangular, slonie, zestawienia, inneModuly, $state, ekartoteka) {
        var vm = this;
        vm.security = security;
        vm.getTrustedHtml = $sce.getTrustedHtml;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.glosowanie = glosowanie;
        vm.slonie = slonie;
        vm.zestawienia = zestawienia;
        vm.inneModuly = inneModuly;
        vm.ekartoteka = ekartoteka;
        vm.slonieParams = { page:1, pageSize:20, glosowanie: glosowanie.id, kategoria: 'System Łatwej Obsługi Nieruchomości'};
        vm.inneModulyParams = { page:1, pageSize:20, glosowanie: glosowanie.id, kategoria: 'Inne moduły', ordering: '-wynik_procentowy_kat_skal' };
        vm.zestawieniaParams = { page:1, pageSize:20, glosowanie: glosowanie.id, kategoria: 'Zestawienia' };
        vm.ekartotekaParams = { page:1, pageSize:20, glosowanie: glosowanie.id, kategoria: 'e-kartoteka' };
        vm.apiPropozycje= 'glosowaniaPropozycje/propozycjeGlosowania';
        vm.columnsPropozycje= [
            {
                fieldName: "kolejnosc",
                title: "LP",
                colTemplate: '<span>{{$data.indexOf(row)+1}}</span>',
                class: "table-cell-20-width",
                show: true
            },
            {
                fieldName: "tytul",
                title: "Tytuł",
                class: "table-cell-17-width",
                colTemplate: '<i class="fa fa-check-square-o" ng-if="row.zrealizowane == true" aria-hidden="true" uib-tooltip="Zrealizowane" tooltip-placement="right"></i> <span>{{row.tytul}}</span> ',
                show: true
            },
            {
                fieldName: "oddano_glos",
                title: "Oddano głosów",
                class: "table-cell-100-width",
                colTemplate: '<div id="progressbar">' +
                    '<div style="width:{{(row.wynik_procentowy_kat_skal !== null) ? row.wynik_procentowy_kat_skal : 0 }}%;"' +
                    '</div><div id="progressbar-text">{{row.wynik_final}}</div></div>',
                show: true
            }
        ];

        vm.trustAsHTML = trustAsHTML;
        vm.przejdzDoPropozycji = przejdzDoPropozycji;

        function trustAsHTML (obj) {
            return $sce.getTrustedHtml(obj);
        }

        function przejdzDoPropozycji(item, index) {
            $state.go('home.subMain.propozycjaGlosowania', {id: item.id});
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('PropozycjaGlosowaniaController', PropozycjaGlosowaniaController);

    /** @ngInject */
    function PropozycjaGlosowaniaController($http, security, bootstrapKlasa, $sce, lokalizacjaAPI, propozycja,
                                            $timeout,  $state, Restangular, uprawnieniaSubUsera, zalaczniki,
                                            pobieraniePlikow) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.propozycja = propozycja;
        vm.pliki = zalaczniki;
        vm.apiPliki = '/glosowaniaPropozycje/zalaczniki/';
        vm.odpowiedziSerwera = [];
        vm.dzisiaj = new Date();
        vm.data_do = new Date(propozycja.glosowanie_data_do);
        vm.modulyPropozycji = [];
        vm.komentarz = '';
        vm.subUser = null;
        vm.klient = null;
        vm.programy = {};

        vm.init = init;
        vm.getTrustedHtml = getTrustedHtml;
        vm.przejdzDoPropozycji = przejdzDoPropozycji;
        vm.dodajKomentarz = dodajKomentarz;
        vm.zaglosuj = zaglosuj;
        vm.getFile = getFile;

        function init() {
            console.log(zalaczniki);
            vm.modulyPropozycji = vm.propozycja.modul.split(',');

            if (security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function (result) {
                    vm.subUser = result;
                });

            }

            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                if (angular.isDefined(result[0])) {
                    vm.klient = result[0];
                }

            });

            Restangular.all('oprogramowanie/moduly-admin').getList({pageSize: 200}).then(function (result) {
                angular.forEach(result, function (res) {
                    vm.programy[res.kod] = {kod: res.kod, ikona: res.ikona, nazwa: res.nazwa};
                });
            }).then(function() {
            });
        }

        function getTrustedHtml (obj) {
            return $sce.getTrustedHtml(obj);
        }

        function przejdzDoPropozycji(item, index) {
            $state.go('home.subMain.propozycjaGlosowania', {id:item.id});
        }

        function dodajKomentarz() {
            if(vm.komentarz.length > 3) {
                var params = { tresc:vm.komentarz, propozycja: vm.propozycja.id };
                Restangular.all('glosowaniaPropozycje/komentarze/').post(params).then(function() {
                    vm.komentarz = '';
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Pomyśnie dodano komentarz (jest on widoczny tylko dla naszych pracowników)'
                    });
                }, function(error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas dodawania komentarza'
                    });
                })
            } else {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Komentarz jest zbyt krótki'
                });
            }
        }

        function zaglosuj() {
            var params = {
                email_klienta: null,
                email_pracownika:vm.subUser.email,
                propozycja: vm.propozycja.id };
            Restangular.all('glosowaniaPropozycje/oddaneGlosy/').post(params).then(function() {
                vm.propozycja.oddano_glos = true;
                vm.odpowiedziSerwera.push({
                    typ: 'S',
                    tekst: 'Dziękujemy za oddanie głosu. Wyniki będą dostępne w Strefie Klienta po zakończeniu głosowania.'
                });
            }, function(error) {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Wystąpił problem podczas oddawania głosu'
                });
            })
        }

        function getFile(item) {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, item);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('GlosowanieNaPropozycjeController', GlosowanieNaPropozycjeController);

    /** @ngInject */
    function GlosowanieNaPropozycjeController($http, security, bootstrapKlasa, $sce, lokalizacjaAPI, glosowanie,
                                              $timeout,  Restangular, slonie, zestawienia, inneModuly, $state,
                                              ekartoteka) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.glosowanie = glosowanie;
        vm.slonie = slonie;
        vm.zestawienia = zestawienia;
        vm.inneModuly = inneModuly;
        vm.ekartoteka = ekartoteka;
        vm.slonieParams = { page:1, pageSize:20, glosowanie: glosowanie.id, kategoria: 'System Łatwej Obsługi Nieruchomości', ordering: 'kolejnosc'};
        vm.inneModulyParams = { page:1, pageSize:20, glosowanie: glosowanie.id, kategoria: 'Inne moduły', ordering: 'kolejnosc'};
        vm.zestawieniaParams = { page:1, pageSize:20, glosowanie: glosowanie.id, kategoria: 'Zestawienia', ordering: 'kolejnosc'};
        vm.ekartotekaParams = { page:1, pageSize:20, glosowanie: glosowanie.id, kategoria: 'e-kartoteka', ordering: 'kolejnosc'};
        vm.apiPropozycje= 'glosowaniaPropozycje/propozycjeGlosowania';
        vm.columnsPropozycje= [
            {
                fieldName: "kolejnosc",
                title: "LP",
                colTemplate: '<span>{{row.kolejnosc}}</span>',
                sortable: "kolejnosc",
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "tytul",
                title: "Tytuł",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.tytul}}</span>',
                sortable: "tytul",
                show: true
            },
            {
                fieldName: "oddano_glos",
                title: "",
                class: "table-cell-16-width",
                colTemplate: '<div style="text-align: center"><i style="font-size: 18px;" class="fa fa-thumbs-o-up" ' +
                    'aria-hidden="true" ng-if="row.oddano_glos"></i></div>',
                show: true
            }
        ];

        vm.trustAsHTML = trustAsHTML;
        vm.przejdzDoPropozycji = przejdzDoPropozycji;

        function trustAsHTML (obj) {
            return $sce.getTrustedHtml(obj);
        }

        function przejdzDoPropozycji(item, index) {
            $state.go('home.subMain.propozycjaGlosowania', {id: item.id});
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('GlosowaniaNaPropozycjeController', GlosowaniaNaPropozycjeController);

    /** @ngInject */
    function GlosowaniaNaPropozycjeController($http, security, bootstrapKlasa, $sce, lokalizacjaAPI, $state,
                                              $timeout,  Restangular, aktywneGlosowania, zakonczoneGlosowania) {
        var vm = this;
        vm.security = security;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.aktywneGlosowania = aktywneGlosowania;
        vm.aktywneGlosowaniaParams = { page:1, pageSize:20, aktywne: true, wyniki_opublikowane: false };
        vm.zakonczoneGlosowaniaParams =  { page:1, pageSize:20, wyniki_opublikowane: true };
        vm.zakonczoneGlosowania = zakonczoneGlosowania;
        vm.apiGlosowania = 'glosowaniaPropozycje/glosowania';
        vm.columnsGlosowania= [
            {
                fieldName: "tytul",
                title: "Tytuł",
                colTemplate: '<span>{{row.tytul}}</span>',
                sortable: "tytul",
                class: "table-cell-60-width",
                show: true
            },
            {
                fieldName: "data_od",
                title: "Rozpoczęcie",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.data_od | date : "dd.MM.yyyy"}}</span>',
                sortable: "data_od",
                show: true
            },
            {
                fieldName: "data_do",
                title: "Zakończenie",
                class: "table-cell-17-width",
                colTemplate: '<span>{{row.data_do| date : "dd.MM.yyyy"}}</span>',
                sortable: "data_do",
                show: true
            }
        ];

        vm.trustAsHTML = trustAsHTML;
        vm.przejdzDoGlosowania = przejdzDoGlosowania;

        function trustAsHTML (obj) {
            return $sce.getTrustedHtml(obj);
        }

        function przejdzDoGlosowania(state, item, index) {
            $state.go(state, {id: item.id});
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('ZmianaLimitowController', ZmianaLimitowController);

    /** @ngInject */
    function ZmianaLimitowController(Restangular, $state, $timeout, security, uprawnieniaSubUsera, listaModulow) {
        var vm = this;

        vm.security = security;
        vm.odpowiedziSerwera = [];
        vm.uzytkownik = {};
        vm.wyslano = false;
        vm.moduly = listaModulow.moduly;
        vm.pola = {
            typ: 'Zamówienie',
            tytul: 'Proszę o kontakt w sprawie zmiany limitów.',
            opis: 'Proszę o kontakt w sprawie zmiany limitów.',
            modul: 'BAN',
            wersjaEZN: '',
            wersjaUpdPack: '',
            idLokalizacji: null,
            nazwaLokalizacji: '',
            klientId: null,
            klientNazwa: '',
            klientTelefon: '',
            klientEmail: '',
            osDoKontaktuNazwa: null,
            osDoKontaktuTelefon: null,
            osDoKontaktuEmail: null,
            status: 'Zgłoszone',
            nazwaKlienta: '',
            kodKlienta: null,
            symbolWydruku: '',
            klientPlecMezczyzna: '',
            idPod: null,
            grupa: null,
            poradaKrotka: null,
            dotAplMobilna: false
        };

        vm.init = init;
        vm.wyslijZgloszenie = wyslijZgloszenie;

        function init() {
            if (security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function(result){
                    vm.uzytkownik = result;
                    vm.pola.klientId = result.id;
                    vm.pola.klientNazwa = result.imie + ' ' + result.nazwisko;
                    vm.pola.klientEmail = result.email;
                    vm.pola.klientTelefon = result.Telefon;
                    vm.pola.klientPlecMezczyzna = result.CzyMezczyzna;

                    vm.pola.osDoKontaktuNazwa = result.imie + ' ' + result.nazwisko;
                    vm.pola.osDoKontaktuEmail = result.email;
                    vm.pola.osDoKontaktuTelefon = result.Telefon;

                    vm.pola.idLokalizacji = result.IdLok;

                }).then(function() {
                    Restangular.all('licencje/lokalizacje/').getList({id_lok: vm.uzytkownik.IdLok}).then(function (result) {
                        if (result.length > 0) {
                            vm.pola.nazwaLokalizacji = result[0].NazwaLok;
                        }
                    });
                })
            }

            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                if (angular.isDefined(result[0])) {
                    vm.pola.nazwaKlienta = result[0].NazwaKr;
                    vm.pola.kodKlienta = result[0].Kod;
                    vm.pola.idPod = result[0].IdPod;
                }
            });
        }

        function wyslijZgloszenie() {
            if(vm.wyslano === false) {
                Restangular.all('zgloszenia/zgloszenia/').post(vm.pola).then(function (result) {
                    vm.wyslano = true;
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Prośba o zmianę limitów została wysłana'
                    });

                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Nie udało się wysłać prośby o zmianę limitów'
                    });
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('ZapytajInformatykaController', ZapytajInformatykaController);

    /** @ngInject */
    function ZapytajInformatykaController($scope, $window, Restangular, $state, bootstrapKlasa, $timeout, security, uprawnieniaSubUsera) {
        var vm = this;

        var params = $state.params,
            zgloszenie = null,
            liczbaOperacji = 0,
            liczbaWykonanychOperacji = 0;


        vm.api = 'reklamacje/naglowki/';
        vm.apiPliki = 'reklamacje/plik/';
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.btnWyslijDisabled = false;
        vm.edytuj = false;
        vm.email = '';
        vm.idZgl = null;
        vm.lokalizacje = [];
        vm.lokalizacja = null;
        vm.licencje = [];
        vm.licencja = null;
        vm.formatOpcjeLicencji = formatOpcjeLicencji;
        vm.pracownicy = [];
        vm.pracownik = {
            IdPrac: 24,
            Imie: "Anita",
            Kod: "ASZ",
            Nazwisko: "Szyba",
            Plec: "K"
        };
        vm.raport = null;
        vm.raportChbox = false;
        vm.numerLicencji = '';
        vm.odpowiedziSerwera = [];
        vm.osobaKontaktowa = '';
        vm.pobierzLicencje = pobierzLicencje;
        vm.przypiszOsobeProwadzaca = false;
        vm.telefon = '';
        vm.tresc = '';
        vm.tytulNaglowka = "Nowe zgłoszenie";
        vm.uploader = null;
        vm.wersja = null;
        vm.wersjaChbox = false;
        vm.wyslij = wyslij;
        vm.zgloszenie = null;

        var reklamacjeApi = Restangular.all(vm.api);

        init();

        $scope.$watch(function () {
            return vm.lokalizacja;
        }, wybierzLokalizacje);


        function wybierzLokalizacje(newValue, oldValue) {
            if (newValue !== oldValue){
                pobierzLicencje(newValue.IdLok);
            }
        }

        function pobierzLicencje(IdLok){
            Restangular.all('licencje/wersje/').getList({id_lok: IdLok, pageSize: 200}).then(function(result) {
                vm.licencje = result;
                vm.licencja = result[0];
                //Sztuczne dodanie systemu e-kartoteka
                vm.licencje.push({'Kod':'PRW',
                    'Nazwa': 'e-kartoteka'});
                if(!vm.licencja) {
                    //vm.licencja = result[0];
                }
            } , function(error) {
            });
        }

        function pobierzLokalizacje(){
            Restangular.all('licencje/lokalizacje/').getList({pageSize: 200}).then(function(result) {
                vm.lokalizacje = result;
                if(!vm.lokalizacja) {
                    vm.lokalizacja = result[0];
                }
            } , function(error) {
            })
        }

        function formatOpcjeLicencji(lic) {
            return lic.Nazwa  + ' ' + lic.WersjaSys;
        }

        function wgrajPliki(id_rek){
            vm.uploader.wgrajPliki(id_rek).then(
                function(dane){
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Pliki zostały wgrane.'
                    });
                    liczbaWykonanychOperacji+=1;http://192.168.1.16:7990/plugins/servlet/network/SF/sf-client
                        if(liczbaWykonanychOperacji >= liczbaOperacji){
                            zakonczWyslij();
                        }
                }, function(error){
                    vm.btnWyslijDisabled = false;
                    zgloszenie = Restangular.one(vm.api, id_rek);
                    vm.edytuj = true;
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas dodawania plików. Obecnie znajdujesz się w trybie edycji zgłoszenia.'
                    });
                });
        }

        function dodajNoweZgloszenie(){
            var nowaReklamacja = {
                Zglaszajacy: vm.osobaKontaktowa,
                Telefon: vm.telefon,
                Temat: vm.temat,
                Opis: vm.tresc,
                Email: vm.email,
                Typ: 3
            };
            if (vm.wersjaChbox && vm.wersja) {
                nowaReklamacja['IDWeS'] = vm.wersja.idWeS;
            }
            if (vm.licencja && vm.licencja) {
                nowaReklamacja['Kod'] = vm.licencja.Kod;
            }
            if (vm.raportChbox) {
                nowaReklamacja['Raport'] = vm.raport;
            }
            reklamacjeApi.post(nowaReklamacja).then(
                function (reklamacja) {
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Zgłoszenie zostało dodane.'
                    });
                    liczbaWykonanychOperacji+=1;
                    wgrajPliki(reklamacja.IdRek);
                    liczbaOperacji+=1;
                    zgloszenie = Restangular.one(vm.api, reklamacja.IdRek);
                    przypiszPracownika();
                },
                function (e) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas zapisywania zgłoszenia'
                    });
                    vm.btnWyslijDisabled = false;
                });
        }

        function edytujZgloszenie(){
            zgloszenie.Email = vm.email;
            zgloszenie.Zglaszajacy = vm.osobaKontaktowa;
            zgloszenie.Telefon = vm.telefon;
            zgloszenie.Temat = vm.temat;
            zgloszenie.Opis = vm.tresc;
            zgloszenie.Typ = 3;
            if(vm.zgloszenie) {
                zgloszenie.IDWeS = vm.zgloszenie.IDWeS;
            }
            zgloszenie.put().then(function(zgloszenie){
                liczbaWykonanychOperacji+=1;
                wgrajPliki(zgloszenie.IdRek);
                vm.odpowiedziSerwera.push({
                    typ: 'S',
                    tekst: 'Zgłoszenie zostało zapisane.'
                });
            }, function(error){
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Wystąpił błąd podczas edycji zgłoszenia'
                });
            })
        }

        function przypiszPracownika(){
            zgloszenie.customPOST({IdPrac: vm.pracownik.IdPrac}, 'przypiszpracownika', {}, {}).then(
                function (pracownik) {
                    vm.btnWyslijDisabled = false;
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Wiadomość została dostarczona do pracownika.'
                    });
                    $timeout(function(){
                        $state.go('home.subMain.konto');
                    }, 1000);
                },
                function (error) {
                    vm.btnWyslijDisabled = false;
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas doręczania wiadomości pracownikowi.'
                    });
                }
            )
        }

        function zakonczWyslij(){
            liczbaWykonanychOperacji = 0;
            liczbaOperacji = 0;
            vm.btnWyslijDisabled = false;
            vm.odpowiedziSerwera = [];
            $state.go('home.subMain.zgloszenia.listaKlienta');
        }

        function wyslij() {
            if (!vm.btnWyslijDisabled) {
                liczbaOperacji = 0;
                liczbaWykonanychOperacji = 0;
                vm.btnWyslijDisabled = true;

                if(!vm.edytuj) {
                    liczbaOperacji +=2;
                    dodajNoweZgloszenie();
                }
                else {
                    liczbaOperacji+=2;
                    edytujZgloszenie();
                    liczbaOperacji+=1;
                    przypiszPracownika();
                }
                //console.log('wysylam');
            }
        }

        function sprawdzCzyNieMaNumeruWiadomosci(id_wiad){
            if(id_wiad){
                zakonczWyslij();
            }
        }

        function init(){
            pobierzLokalizacje();
            if (security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function(result){
                    vm.osobaKontaktowa = result.imie + ' ' + result.nazwisko;
                    vm.email = result.email;
                })
            }

        }
    }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('ZamowienieUslugController', ZamowienieUslugController);

  /** @ngInject */
  function ZamowienieUslugController(Restangular, $state, $timeout, security, uprawnieniaSubUsera) {
    var vm = this;

    vm.api = 'reklamacje/naglowki/';
    vm.btnWyslijDisabled = false;
    vm.odpowiedziSerwera = [];
    vm.reklamacja = {
          osobaKontaktowa: '',
          telefon: null,
          opis: '',
          email: ''
      };
    vm.wyslijZgloszenie = wyslijZgloszenie;
    vm.init = init;

    var zgloszenieApi = Restangular.all(vm.api);

    function init() {
        $state.go('home.subMain.konto');
        if (security.jestSubUserem()) {
            uprawnieniaSubUsera.getInfo().then(function(result){
                vm.reklamacja.osobaKontaktowa = result.imie + ' ' + result.nazwisko;
                vm.reklamacja.email = result.email;
            })
        }
    }

    function przypiszPracownika(zgloszenie){
      if(zgloszenie) {
        zgloszenie.customPOST({IdPrac: 3626}, 'przypiszpracownika', {}, {}).then(
          function (wynik) {
            vm.odpowiedziSerwera.push({
              typ: 'S',
              tekst: 'Zgłoszenie zostało pomyślnie wysłane.'
            });
            $timeout(function(){
              vm.btnWyslijDisabled = false;
              $state.go('home.subMain.konto');
            }, 1000);
          },
          function (error) {
            vm.btnWyslijDisabled = false;
            vm.odpowiedziSerwera.push({
              typ: 'E',
              tekst: 'Wystąpił błąd podczas przekazywania zgłoszenia'
            });
          }
        )
      }
    }

    function wyslijZgloszenie() {
      if (!vm.btnWyslijDisabled) {
        vm.btnWyslijDisabled = true;
        var nowaReklamacja = {
          Zglaszajacy: vm.reklamacja.osobaKontaktowa,
          Telefon: vm.reklamacja.telefon,
          Temat: '[Strefa]: Zamówienie usług',
          Opis: vm.reklamacja.opis,
          Email: vm.reklamacja.email,
          Typ: 4  // 'Sprzedaż'
        };

        zgloszenieApi.post(nowaReklamacja).then(
          function (wynik) {
            var zgloszenie = Restangular.one(vm.api, wynik.IdRek);
            przypiszPracownika(zgloszenie);
          },
          function (e) {
            vm.btnWyslijDisabled = false;
            vm.odpowiedziSerwera.push({
              typ: 'E',
              tekst: 'Wystąpił błąd podczas zapisywania zgłoszenia'
            });
          });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('WycenaAktualizacjiController', WycenaAktualizacjiController);

  /** @ngInject */
  function WycenaAktualizacjiController(Restangular, $state, $timeout) {
    var vm = this;

    vm.api = 'reklamacje/naglowki/';
    vm.btnWyslijDisabled = false;
    vm.odpowiedziSerwera = [];
    vm.wyslijZgloszenie = wyslijZgloszenie;

    var zgloszenieApi = Restangular.all(vm.api);

    function przypiszPracownika(zgloszenie){
      if(zgloszenie) {
        zgloszenie.customPOST({IdPrac: 3626}, 'przypiszpracownika', {}, {}).then(
          function (wynik) {
            vm.odpowiedziSerwera.push({
              typ: 'S',
              tekst: 'Zgłoszenie zostało pomyślnie wysłane.'
            });
            $timeout(function(){
              vm.btnWyslijDisabled = false;
              $state.go('home.subMain.konto');
            }, 1000);
          },
          function (error) {
            vm.btnWyslijDisabled = false;
            vm.odpowiedziSerwera.push({
              typ: 'E',
              tekst: 'Wystąpił błąd podczas przekazywania zgłoszenia'
            });
          }
        )
      }
    }

    function wyslijZgloszenie(zgloszenie) {
      if (!vm.btnWyslijDisabled) {
        vm.btnWyslijDisabled = true;
        var noweZgloszenie = {
          Zglaszajacy: zgloszenie.osobaKontaktowa,
          Telefon: zgloszenie.telefon,
          Temat: '[Strefa]: Wycena aktualizacji',
          Opis: zgloszenie.tresc,
          Email: zgloszenie.email,
          Typ: 4  // 'Sprzedaż'
        };

        zgloszenieApi.post(nowaReklamacja).then(
          function (wynik) {
            var zgloszenie = Restangular.one(vm.api, wynik.IdRek);
            przypiszPracownika(zgloszenie);
          },
          function (e) {
            vm.btnWyslijDisabled = false;
            vm.odpowiedziSerwera.push({
              typ: 'E',
              tekst: 'Wystąpił błąd podczas zapisywania zgłoszenia'
            });
          });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('FormularzePlikiController', FormularzePlikiController);

  /** @ngInject */
  function FormularzePlikiController(plikiFirmowe, $state) {
    var vm = this;

    vm.formularz = null;
    vm.listaFormularzy = plikiFirmowe.formularze();

    var formularzID = $state.params.formularz;

    pobierzFormularz();

    function pobierzFormularz(){
      var ansList = $.grep(vm.listaFormularzy, function (e) {
        return e.id == formularzID;
      });
      if (angular.isDefined(ansList[0])){
        vm.formularz = ansList[0];
      }
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('GenerowanieLicencjiController', GenerowanieLicencjiController);

    /** @ngInject */
    function GenerowanieLicencjiController(Restangular, security, uprawnieniaSubUsera, listaModulow) {
        var vm = this;

        vm.security = security;
        vm.odpowiedziSerwera = [];
        vm.uzytkownik = {};
        vm.wyslano = false;
        vm.pola = {
            typ: 'Zamówienie',
            tytul: 'Proszę o wygenerowanie pliku licencji do najnowszej wersji oprogramowania.',
            opis: 'Proszę o wygenerowanie pliku licencji do najnowszej wersji oprogramowania.',
            modul: 'CEN',
            wersjaEZN: '',
            wersjaUpdPack: '',
            idLokalizacji: null,
            nazwaLokalizacji: '',
            klientId: null,
            klientNazwa: '',
            klientTelefon: '',
            klientEmail: '',
            osDoKontaktuNazwa: null,
            osDoKontaktuTelefon: null,
            osDoKontaktuEmail: null,
            status: 'Zgłoszone',
            nazwaKlienta: '',
            kodKlienta: null,
            symbolWydruku: '',
            klientPlecMezczyzna: '',
            idPod: null,
            grupa: null,
            poradaKrotka: null,
            dotAplMobilna: false,
            przekazaneDoZok: true
        };

        vm.moduly = listaModulow.moduly;

        vm.init = init;
        vm.wyslijZgloszenie = wyslijZgloszenie;

        function init() {
            if (security.jestSubUserem()) {
                uprawnieniaSubUsera.getInfo().then(function(result){
                    vm.uzytkownik = result;
                    vm.pola.klientId = result.id;
                    vm.pola.klientNazwa = result.imie + ' ' + result.nazwisko;
                    vm.pola.klientEmail = result.email;
                    vm.pola.klientTelefon = result.Telefon;
                    vm.pola.klientPlecMezczyzna = result.CzyMezczyzna;

                    vm.pola.osDoKontaktuNazwa = result.imie + ' ' + result.nazwisko;
                    vm.pola.osDoKontaktuEmail = result.email;
                    vm.pola.osDoKontaktuTelefon = result.Telefon;

                    vm.pola.idLokalizacji = result.IdLok;

                }).then(function() {
                    Restangular.all('licencje/lokalizacje/').getList({id_lok: vm.uzytkownik.IdLok}).then(function (result) {
                        if (result.length > 0) {
                            vm.pola.nazwaLokalizacji = result[0].NazwaLok;
                        }
                    });
                })
            }

            Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                if (angular.isDefined(result[0])) {
                    vm.pola.nazwaKlienta = result[0].NazwaKr;
                    vm.pola.kodKlienta = result[0].Kod;
                    vm.pola.idPod = result[0].IdPod;
                }
            });
            Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                    vm.lokalizacje = result;

                });
        }

        function wyslijZgloszenie() {
            if(vm.wyslano === false) {
                Restangular.all('zgloszenia/zgloszenia/').post(vm.pola).then(function (result) {
                    vm.wyslano = true;
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Prośba o wygenerowanie pliku licencyjnego została wysłana'
                    });

                }, function (error) {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Nie udało się wysłać prośby o wygenerowanie pliku licencyjnego'
                    });
                });
            }
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('FormularzeController', FormularzeController);

    /** @ngInject */
    function FormularzeController(plikiFirmowe, $state, Restangular, lokalizacjaAPI, pliki, pobieraniePlikow) {
        var vm = this;

        vm.apiPliki = '/zarzadzaniePlikami/plikFile/';
        vm.pliki = pliki;
        vm.wybranyPlik = {};
        vm.wybierzFormularz = wybierzFormularz;
        vm.getFile = getFile;

        init();

        function init(){
            wybierzFormularz(pliki[0]);
        }

        function wybierzFormularz(plik){
            vm.wybranyPlik = plik;
        }

        function getFile(plik) {
           pobieraniePlikow.wyswietlModal(vm.apiPliki, plik);

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('RegulaminyController', RegulaminyController);

    /** @ngInject */
    function RegulaminyController(Restangular, lokalizacjaAPI, pliki, pobieraniePlikow) {
        var vm = this;
        vm.pliki = pliki;
        vm.apiPliki = '/zarzadzaniePlikami/plikFile/';

        vm.init= init;
        vm.getFile = getFile;

        function init(){
        }

        function getFile(plik) {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, plik);
        }

    }
})();


(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('PytaniaIOdpowiedziController', PytaniaIOdpowiedziController);

    /** @ngInject */
    function PytaniaIOdpowiedziController(plikiFirmowe, Restangular, lokalizacjaAPI, pobieraniePlikow) {
        var vm = this;
        vm.programy = plikiFirmowe.programy();
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.apiPliki = '/zarzadzaniePlikami/plikFile/';
        vm.program = null;
        vm.pytaniaIOdpowiedzi = {};

        vm.init = init;
        vm.wybierzProgram = wybierzProgram;
        vm.getFile = getFile;

        function init() {
            wybierzProgram(vm.programy[0]);
        }


        function wybierzProgram(program){
            vm.program = program;
            if(angular.isDefined(vm.pytaniaIOdpowiedzi[program.skrot]) === false ) {
                Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami')
                    .getList({kategoria__nazwa: program.skrot, search: 'Pytania i Odpowiedzi'}).then(function (result) {
                    vm.pytaniaIOdpowiedzi[program.skrot] = result;
                });
            }
        }


        function getFile(plik) {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, plik);
        }
    }
})();

(function() {
  'use strict';

  angular
      .module('strefaKlienta')
      .controller('DokumentacjaListaPlikowController', DokumentacjaListaPlikowController);

  /** @ngInject */
  function DokumentacjaListaPlikowController($stateParams, plikiFirmowe,Restangular,lokalizacjaAPI) {
    var skrot = $stateParams.skrotProgramu;

    var vm = this;
    vm.listaPlikow = plikiFirmowe.dokumentacja(skrot);
    // vm.pliki = [];
    // vm.specFiles = [];
    // vm.apiPliki = 'zarzadzaniePlikami/plik/';
    // vm.init = pobierzLinki;

    // function pobierzLinki(){
    //
    //   Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami').getList().then(function (res) {
    //     vm.liczbaWszystkichPlikow = res.meta.count;
    //   }).then(function () {
    //     Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami').getList({page: 1, pageSize: vm.liczbaWszystkichPlikow})
    //         .then(function (result) {
    //           vm.pliki = result;
    //           vm.specFiles = [];
    //           angular.forEach(result,function(value){
    //             if(value.Kategoria == skrot || (value.Kategoria.indexOf(skrot)!=-1))
    //             {
    //               Restangular.all('zarzadzaniePlikami/plik/').get(value.Id).then(function (res) {
    //
    //                 angular.forEach(res, function (val) {
    //                   vm.specFiles.push({id:value.Id,id_dok:val.id_dok,nazwa:val.Nazwa,link:(lokalizacjaAPI+'/'+vm.apiPliki  + value.Id + '/' + val.id_dok + '/')});
    //                 });
    //
    //
    //               });
    //             }
    //           });
    //         });
    //   });
    // }
  }

})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('DokumentacjaController', DokumentacjaController);

    /** @ngInject */
    function DokumentacjaController(plikiFirmowe, $timeout, Restangular, lokalizacjaAPI, pobieraniePlikow) {
        var vm = this;
        vm.listaPlikow = [];
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.program = null;
        vm.apiPliki = '/zarzadzaniePlikami/plikFile/';
        vm.programy = plikiFirmowe.programy();
        vm.pliki = {};

        vm.init = init;
        vm.wybierzProgram = wybierzProgram;
        vm.getFile = getFile;

        function init() {
            wybierzProgram(vm.programy[0]);
        }

        function wybierzProgram(program){
            vm.program = program;
            if(angular.isDefined(vm.pliki[program.skrot]) === false ) {
                Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami')
                    .getList({kategoria__nazwa: program.skrot}).then(function (result) {
                    vm.pliki[program.skrot] = result;
                });
            }
        }

        function getFile(plik) {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, plik);
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('CoNowegoPlikiController', CoNowegoPlikiController);

  /** @ngInject */
  function CoNowegoPlikiController(plikiFirmowe, $state) {
    var vm = this;

    vm.plikiFirmowe = plikiFirmowe;
    vm.program = null;
    vm.listaProgramow = plikiFirmowe.programy();

    var programID = $state.params.program;

    pobierzProgram();

    function pobierzProgram(){
      var ansList = $.grep(vm.listaProgramow, function (e) {
        return e.id == programID;
      });
      if (angular.isDefined(ansList[0])){
        vm.program = ansList[0];
      }
    }

  }
})();
(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('CoNowegoController', CoNowegoController);

    /** @ngInject */
    function CoNowegoController(plikiFirmowe, Restangular, lokalizacjaAPI, $q, $sce, $http, $window, $timeout,
                                pobieraniePlikow, $stateParams, $location, $state) {
        var vm = this;
        vm.program = null;
        vm.modul = $stateParams.modul;
        vm.lokalizacjaAPI = lokalizacjaAPI;
        vm.programy = plikiFirmowe.programy();
        vm.apiPliki = '/coNowego/zalaczniki/';
        vm.pliki = $stateParams.pliki;
        vm.coNowego = $stateParams.coNowego;

        vm.wybierzProgram = wybierzProgram;
        vm.trustAsHTML = trustAsHTML;
        vm.init = init;
        vm.getFile = getFile;
        vm.przejdzDoProgramu = przejdzDoProgramu;

        function przejdzDoProgramu(kod) {
            $state.go('home.subMain.co_nowego', {modul: kod, coNowego: vm.coNowego, pliki: vm.pliki});
        }

        function init() {
            if (vm.modul !== null) {
                wybierzProgram(vm.programy.find(function (program) {
                    return program.kod.toUpperCase() === vm.modul.toUpperCase();
                }));
            } else {
                wybierzProgram(vm.programy[0]);
            }
        }

        function wybierzProgram(program) {
            vm.program = program;
            vm.modul = program.kod;
            if (angular.isDefined(vm.coNowego[program.skrot]) === false) {
                Restangular.all('coNowego/coNowego/').getList({kod_modulu: program.kod}).then(function (result) {
                    vm.coNowego[program.skrot] = result;
                });
            }
        }

        function trustAsHTML(obj) {
            return $sce.trustAsHtml(obj);
        }

        function getFile(plik) {
            pobieraniePlikow.wyswietlModal(vm.apiPliki, plik);
        }

    }
})();

(function(){
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('listaDemoController', listaDemoController);

    function listaDemoController(Restangular, $state, security) {
        var vm = this;
        vm.lista = [];
        vm.currTab = 1;
        vm.paginatorBreaker = 0;
        vm.allTabs = [];
        vm.pagination = 10;
        vm.workers = [];
        vm.prev = prev;
        vm.next = next;
        vm.nextGroup = nextGroup;
        vm.prevGroup = prevGroup;
        
        if(!security.jestPracownikiemMieszczanin()){
            $state.go('home.stronaGlowna');
        }
        
        Restangular.all('/demo/demo/').getList({pageSize:1000}).then(function(result){
            vm.lista = result;
            var reszta = (result.length % vm.pagination == 0) ? 0 : 1;
            for (; vm.allTabs.length < (Math.floor(result.length / vm.pagination) + reszta);) {
                vm.allTabs.push(vm.allTabs.length + 1);
            }
        });


        function prev() {
            if(vm.currTab > 1)
                vm.currTab--;
            vm.paginatorBreaker = Math.floor(vm.currTab / 10);
        }
        
        function next() {
            if(vm.currTab < vm.allTabs.length)
                vm.currTab++;
            vm.paginatorBreaker = Math.floor(vm.currTab / 10);
        }
        
        function nextGroup() {
            if(vm.paginatorBreaker < Math.floor(vm.allTabs.length / 10))
                vm.paginatorBreaker++;
        }
        
        function prevGroup() {
            if(vm.paginatorBreaker > 0)
                vm.paginatorBreaker--;
        }
    }
})();
(function(){
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('generatorDemoController', generatorDemoController);

    /** @ngInject */
    function generatorDemoController(Restangular, security, $state, bootstrapKlasa) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.company = '';
        vm.adres = "";
        vm.odpowiedziSerwera = [];
        vm.werMax=0;
        vm.software = [];
        vm.selectedAsa = 11;
        vm.softwareVersion = null;
        Restangular.all('oprogramowanie/wersjeEzn/').getList({pageSize:1000}).then(function(result) {
            angular.forEach(result,function(value){
                var wersja = (Math.floor(value.Wersja/100).toString() + ((Math.floor(value.Wersja%100)!=0)?'.'+Math.floor(value.Wersja%100).toString():'.00'));
                vm.software.push({wersja:wersja});
                vm.werMax = (vm.werMax < parseFloat(wersja)) ? parseFloat(wersja) : parseFloat(vm.werMax);
            });
        }).then(function () {
            if(vm.software[(vm.software.length)-1].wersja.length<5){
                vm.software[(vm.software.length)-1].wersja +='.00';
            }
            vm.selectedSoftware=vm.software[(vm.software.length)-1].wersja;
        });


        vm.generateDemo = generateDemo;
        if(!security.jestPracownikiemMieszczanin()) {
            $state.go('home.stronaGlowna');
        }
        
        function generateDemo() {
            if(vm.company.length > 1) {
                if(vm.selectedSoftware>=17 && vm.selectedAsa==17) {
                    vm.softwareVersion = vm.selectedSoftware +'_A17';
                }
                if(vm.selectedSoftware>=17 && vm.selectedAsa==11) {
                    vm.softwareVersion = vm.selectedSoftware +'_A11';
                }
                if(vm.selectedSoftware<17) {
                    vm.softwareVersion = vm.selectedSoftware;
                }
                Restangular.all('/demo/demo/').post({
                    Wersja: vm.softwareVersion,
                    Firma: vm.company
                }).then(function (result) {
                    vm.adres = 'https://strefaklienta.mieszczanin.pl/#/demo?lic=' + result.LinkLic;
                    vm.odpowiedziSerwera.push({
                        typ: 'S',
                        tekst: 'Link do wersji demo został wygenerowany.'
                    });
                }, function () {
                    vm.odpowiedziSerwera.push({
                        typ: 'E',
                        tekst: 'Wystąpił błąd podczas generowania linku.'
                    });
                });
            } else {
                vm.odpowiedziSerwera.push({
                    typ: 'E',
                    tekst: 'Błędna nazwa firmy.'
                });
            }
        }
    }
})();
(function(){
    'use strict';
    angular
        .module('strefaKlienta')
        .controller('demoController', demoController);

    function demoController(Restangular, $location, lokalizacjaAPI, $state) {
        var vm = this;
        vm.qs = $location.search();
        vm.company = "";
        vm.error = "";
        vm.loaded = false;
        vm.wersja = null;
        vm.lic = [];
        vm.id = 0;
        vm.download = download;
        vm.updateDownloadDate = updateDownloadDate;

        if(!vm.loaded) {
            vm.lic = Restangular.one('/demo/demo/', vm.qs['lic']).get().then(function (result) {
                vm.company = result.Firma;
                vm.wersja = result.Wersja;
                vm.loaded = true;
            }, function (e) {
                $state.go('home.stronaGlowna');
            });
        }

        function download() {
            return lokalizacjaAPI + '/demo/demo/' + vm.qs['lic'] + '/file?wersja=' + vm.wersja ;
        }
        
        function updateDownloadDate() {
            Restangular.one('/demo/demo/', vm.qs['lic']).customPUT({}, undefined, undefined, undefined);
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("strefaKlienta")
    .controller("cennikEKIEMController", cennikEKIEMController);

  /** @ngInject */
  function cennikEKIEMController(
    $state,
    Restangular,
    $timeout,
    security,
    cennikiResource,
    lokalizacjeResource,
    szczegolyCenyModal,
    danePodstawowe,
    daneSubUsera,
    saLokaleIBlokady,
    aktualnaLiczbaLokali,
    gromadzenieDanychKsiegowych,
    slownikCenLimitowLokali,
    opcjeEk,
    opcjeEm,
    regulaminyResource
  ) {
    var vm = this;
    vm.ackRegulaminEK = false;
    vm.ackRegulaminEM = false;
    vm.ackRegulaminUSLZ = false;
    vm.pobierzRegulamin = regulaminyResource.pobierzPlikPoSlugu;
    vm.security = security;
    vm.czySubUser = security.jestSubUserem();
    vm.opcjeEk = opcjeEk;
    vm.opcjeEkLista = Object.values(opcjeEk);
    vm.posiadaneOpcjeEk = JSON.parse(JSON.stringify(opcjeEk));
    vm.opcjeEm = opcjeEm;
    vm.opcjeEmLista = Object.values(opcjeEm);
    vm.posiadaneOpcjeEm = JSON.parse(JSON.stringify(opcjeEm));
    vm.slownikCenLimitowLokali = slownikCenLimitowLokali;
    vm.zablokowaneOpcje = new Set();
    vm.lokale =
      lokalizacjeResource.lokalizacjeInfo.sumaDoWyceny ||
      aktualnaLiczbaLokali.LimitLokali ||
      250;
    vm.aktualnaLiczbaLokali = lokalizacjeResource.lokalizacjeInfo.sumaDoWyceny;
    vm.posiadaLokale = czyMaBracLokalePodUwage();
    vm.saLokaleIBlokady = saLokaleIBlokady;
    vm.lokalizacjeInfo = lokalizacjeResource.lokalizacjeInfo;
    vm.czyZarzadzaLokalami = czyMaBracLokalePodUwage();
    vm.ukryjWyborZarzadzaniaLokalami =
      lokalizacjeResource.lokalizacjeInfo.liczbaZarzadzanychLokali > 0 &&
      saLokaleIBlokady.Blokada == 0 &&
      saLokaleIBlokady.SaLokale > 0;
    vm.cenaBazowa = aktualnaLiczbaLokali.KwotaBaz;
    vm.cenaEk = 0;
    vm.cenaEm = 0;
    vm.cena = 0;
    vm.liczbyOCR = cennikiResource.liczbyOCR;
    vm.liczbySMS = cennikiResource.liczbySMS;
    vm.lokalizacja = null;
    vm.blokadaWysylki = false;
    vm.komunikatyOpcji = {
      13: {
        wyswietlaj: "zawsze",
        informacja:
          "Jeżeli opcja nie zostanie wykupiona, dane z poprzedniego roku zostaną ukryte 31-go marca.",
      },
      14: {
        wyswietlaj: "po zaznaczeniu",
        informacja: "Wymaga systemu e-Mieszczanin.",
      },
      55: {
        wyswietlaj: "po zaznaczeniu",
        informacja: "Wymaga systemu e-Mieszczanin.",
      },
      46: {
        wyswietlaj: "po zaznaczeniu",
        informacja: "Wymaga także uruchomienia opcji w e-kartotece.",
      },
    };
    vm.dodatkoweOpcjeEm = {
      ocr: false,
      sms: false,
    };

    vm.dodatkoweOpcjeEk = {
      posiadaneDaneKsiegowe:
        [0, 3, 5].indexOf(gromadzenieDanychKsiegowych) !== -1
          ? gromadzenieDanychKsiegowych
          : "bez ograniczeń",
      daneKsiegowe:
        [0, 3, 5].indexOf(gromadzenieDanychKsiegowych) !== -1
          ? gromadzenieDanychKsiegowych
          : "bez ograniczeń",
    };

    vm.polaKontaktowe = security.jestSubUserem()
      ? {
          nazwaFirmy: danePodstawowe.NazwaKr,
          ulica: danePodstawowe.Ulica,
          nrBudynku: danePodstawowe.Numer,
          nrLokalu: null,
          kodPocztowy: danePodstawowe.KodPocztowy,
          miejscowosc: danePodstawowe.Miasto,
          NIP: danePodstawowe.Nip,
          REGON: danePodstawowe.Regon,
          imie: daneSubUsera.imie,
          nazwisko: daneSubUsera.nazwisko,
          telefonKontaktowy: daneSubUsera.Telefon,
          email: daneSubUsera.email,
        }
      : {};

    vm.przelicz = przelicz;
    vm.przelaczPolaczonePola = przelaczPolaczonePola;
    vm.wyslijZamowienie = wyslijZamowienie;
    vm.przelaczZarzadzanieLokalami = przelaczZarzadzanieLokalami;
    vm.pokazSzczegolyCeny = pokazSzczegolyCeny;
    vm.zaakceptujWszystkieRegulaminy = zaakceptujWszystkieRegulaminy;

    init();
    function init() {
      if (vm.slownikCenLimitowLokali[vm.lokale] === undefined) {
        vm.lokale = Math.min.apply(
          Math,
          Object.keys(vm.slownikCenLimitowLokali).filter(function (val) {
            return parseInt(val) > parseInt(vm.lokale);
          })
        );
      }
      if (security.jestSubUserem()) {
        Restangular.all("licencje/lokalizacje/")
          .getList({ id_lok: daneSubUsera.IdLok })
          .then(function (result) {
            if (result.length > 0) {
              vm.lokalizacja = result[0];
            }
          });
      }
      przelaczPolaczonePola();
    }
    function czyMaBracLokalePodUwage() {
      if (
        lokalizacjeResource.lokalizacjeInfo.liczbaZarzadzanychLokali == 0 &&
        saLokaleIBlokady.Blokada == 0 &&
        saLokaleIBlokady.SaLokale > 0
      ) {
        return false;
      }
      return true;
    }
    function przelicz() {
      $timeout(function () {
        vm.cenaEk = vm.czyZarzadzaLokalami
          ? Math.ceil(
              cennikiResource.wyliczCeneOpcjiEk(
                slownikCenLimitowLokali[vm.lokale],
                vm.opcjeEk,
                vm.dodatkoweOpcjeEk.daneKsiegowe
              )
            )
          : 0;
        vm.cenaEm = Math.ceil(
          cennikiResource.wyliczCeneOpcjiEm(
            slownikCenLimitowLokali[vm.lokale],
            vm.opcjeEm,
            vm.dodatkoweOpcjeEm
          )
        );
        vm.cenaBazowa = slownikCenLimitowLokali[vm.lokale];
        vm.cena = vm.cenaBazowa + vm.cenaEk + vm.cenaEm;
      });
    }

    function automatyczneZaznaczanie(IdGrupy) {
      if (IdGrupy == 14 || IdGrupy === undefined) {
        if (vm.opcjeEk[14] && vm.opcjeEk[14].posiadana === true) {
          if (vm.opcjeEm[45]) {
            vm.opcjeEm[45].posiadana = true;
            vm.zablokowaneOpcje.add(14);
          }
        } else {
          vm.zablokowaneOpcje.delete(14);
        }
      }
      if (IdGrupy == 45 || IdGrupy === undefined) {
        if (
          vm.opcjeEm[45] &&
          vm.opcjeEm[45].posiadana === true &&
          vm.opcjeEk[14] &&
          vm.opcjeEk[14].posiadana === true
        ) {
          vm.zablokowaneOpcje.add(14);
        } else {
          vm.zablokowaneOpcje.delete(14);
        }
      }
      if (IdGrupy == 21 || IdGrupy === undefined) {
        if (vm.opcjeEk[21] && vm.opcjeEk[21].posiadana === true) {
          if (vm.opcjeEk[11]) {
            vm.opcjeEk[11].posiadana = true;
            vm.zablokowaneOpcje.add(11);
          }
        } else {
          vm.zablokowaneOpcje.delete(11);
        }
      }
      if (IdGrupy == 46 || IdGrupy === undefined) {
        if (vm.opcjeEm[46] && vm.opcjeEm[46].posiadana === true) {
          if (vm.opcjeEk[55]) {
            vm.opcjeEk[55].posiadana = true;
            vm.zablokowaneOpcje.add(55);
          }
        } else {
          vm.zablokowaneOpcje.delete(55);
        }
      }
      if (IdGrupy == 55 || IdGrupy === undefined) {
        if (vm.opcjeEk[55] && vm.opcjeEk[55].posiadana === true) {
          if (vm.opcjeEm[46]) {
            vm.opcjeEm[46].posiadana = true;
            vm.zablokowaneOpcje.add(55);
          } else {
            vm.zablokowaneOpcje.delete(55);
          }
        }
      }
    }

    function przelaczPolaczonePola(IdGrupy) {
      $timeout(function () {
        automatyczneZaznaczanie(IdGrupy);
        przelicz();
      });
    }

    function przelaczZarzadzanieLokalami() {
      if (vm.czyZarzadzaLokalami) {
        vm.lokale = aktualnaLiczbaLokali.LimitLokali || 250;
      } else {
        vm.lokale = 1000;
      }

      $timeout(function () {
        przelicz();
      });
    }

    function wyslijZamowienie() {
      vm.blokadaWysylki = true;
      cennikiResource
        .wyslijZamowienie(
          vm.czyZarzadzaLokalami,
          vm.lokalizacja,
          danePodstawowe,
          daneSubUsera,
          vm.polaKontaktowe,
          aktualnaLiczbaLokali.LimitLokali,
          vm.lokale,
          vm.posiadaneOpcjeEk,
          vm.opcjeEk,
          vm.dodatkoweOpcjeEk,
          vm.posiadaneOpcjeEm,
          vm.opcjeEm,
          vm.dodatkoweOpcjeEm,
          vm.cenaBazowa,
          vm.cenaEk,
          vm.cenaEm
        )
        .then(function (zgloszenie) {
          if (zgloszenie && zgloszenie.id) {
            $state.go(
              "home.subMain.zgloszenia.kartaZgloszeniaKlienta",
              { zgloszenie: zgloszenie.id },
              { reload: true }
            );
          }
        });
    }

    function pokazSzczegolyCeny() {
      szczegolyCenyModal.wyswietlModal(
        lokalizacjeResource.lokalizacjeInfo.lokalizacje,
        saLokaleIBlokady
      );
    }

    $("#zaakceptuj-wszystkie").click(function (e) {
      this.checked = true;
      e.preventDefault();
      e.stopPropagation();
      return vm.ackRegulaminEK && vm.ackRegulaminEM && vm.ackRegulaminUSLZ;
    });

    function zaakceptujWszystkieRegulaminy() {
      vm.ackRegulaminEK = true;
      vm.ackRegulaminEM = true;
      vm.ackRegulaminUSLZ = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .controller('BazaWiedzyController', BazaWiedzyController);

  /** @ngInject */
  function BazaWiedzyController($scope ,Restangular, NgTableParams) {
    var vm = this;
    vm.api = 'rozrachunki/uzytkownicy/';
    vm.requestParams = {
      id_a_do: 11286
    };

    vm.controllerFunctionName = controllerFunctionName;
    vm.clickTemplate = clickTemplate;

    vm.columns = [
      {
        fieldName: "IdKli",
        title: "number",
        colTemplate: '<span style="color: red">{{row[column.fieldName]}}</span>',
        show: true
      },
      {
        fieldName: "nazwa",
        title: "Nazwa",
        sortable: "nazwa",
        filter: {'nazwa': 'text'},
        show: true
      },
      {
        fieldName: "AdresText",
        title: "Adres",
        colTemplate: '<button ng-click="vm.runExtFunction(\'controllerFunctionName\',row)" class="btn btn-primary">{{row[column.fieldName]}}</button>',
        show: true
      }
    ];
    vm.selectedItem = null;

    $scope.$watch(function () {
      return vm.selectedItem;
    }, doSomething);

    function doSomething(newValue, oldValue) {
      console.log("selected item change")
    }

    function controllerFunctionName(item){
      console.log("external function was run")
    }

    function clickTemplate(item){
      console.log("click on template (controller baza")
    }
    vm.rowTemplate =  $("#rowTemplate").html();
    //vm.rowTemplate = '<div> Podwiersz {{row.IdKli}} <button class="btn btn-danger" ng-click="vm.runExtFunction(\'clickTemplate\', row)">click</button></div>'


  }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('AnkietaController', AnkietaController);

    /** @ngInject */
   
    function AnkietaController(AnkietyResource, $state, bootstrapKlasa, ankieta) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.stan = ankieta.wypelniona ? 'wypelniona' : 'nowa'; 
        vm.ankieta = ankieta;
        vm.wysylanie = false;
        vm.zaznaczonoGwiazdke = zaznaczonoGwiazdke;
        vm.moznaWyslac = false;

        vm.zapisz = zapisz;
        vm.anuluj = anuluj;
        function zapisz() {
            vm.wysylanie = true;
            AnkietyResource.wypelnijAnkiete(vm.ankieta).then(function(result) {
                vm.stan='wyslana'
            })
        }

        function anuluj() {
            $state.go('home.subMain.konto')
        }

        function zaznaczonoGwiazdke(zaznaczonaOcena) {
            vm.moznaWyslac = true;
        }

    }
})();
(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .directive('wyswietlaniePlikow', wyswietlaniePlikow);

  /** @ngInject */
  function wyswietlaniePlikow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/directives/wyswietlaniePlikow.html',
      scope: {
        api: '@',
        id: '@',
        liczbaPlikow: '='
      },
      controller: WyswietlaniePlikowController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function WyswietlaniePlikowController(plikiOperacje, lokalizacjaAPI, $http) {
      var vm = this;

      vm.pliki = [];
      vm.plikiOperacje = plikiOperacje;

      var fullApi = lokalizacjaAPI + '/' + vm.api + vm.id + '/';


      $http({
        url: fullApi,
        method: 'GET'
      }).success(function(lista){
        vm.pliki = lista;
        if(angular.isDefined(vm.liczbaPlikow)){
          vm.liczbaPlikow = lista.length;
        }
      });
    }
  }

})();

/**
 * Created by dp on 19.07.17.
 */

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .directive('wersjaStronyInformacja', wersjaStronyInformacja);

    /** @ngInject */
    function wersjaStronyInformacja() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/directives/wersjaStronyInformacja.html',
            controller: wersjaStronyInformacjaController,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                wersjaStrony: "="
            }
        };
        return directive;

        /** @ngInject */
        function wersjaStronyInformacjaController() {
            var vm = this;
        }
    }

})();

(function () {
  'use strict';
  angular.module('strefaKlienta').factory('viewerPDFService', viewerPDFService);
  viewerPDFService.$inject = ['$rootScope'];

  function viewerPDFService($rootScope) {
    var svc = { };
    svc.nextPage = function() {
      $rootScope.$broadcast('pdfviewer.nextPage');
    };
    svc.prevPage = function() {
      $rootScope.$broadcast('pdfviewer.prevPage');
    };
    svc.Instance = function(id) {
      var instance_id = id;
      return {
        prevPage: function() {
          $rootScope.$broadcast('pdfviewer.prevPage', instance_id);
        },
        nextPage: function() {
          $rootScope.$broadcast('pdfviewer.nextPage', instance_id);
        },
      };
    };
    return svc;
  }
})();

(function () {

    angular.module('strefaKlienta').directive('viewPdf', viewPdf);

    /** @ngInject */
    function viewPdf() {
        var canvas = null;
        var rozmiar = null;
        var instance_id = null;
        return {
            restrict: "E",
            template: '<canvas style="width: 100%; height: auto;"></canvas>',
            scope: {
                onPageLoad: '&',
                loadProgress: '&',
                src: '=',
                scale: '@',
                id: '='
            },
            controller: ['$scope', 'security', function ($scope, security) {
                $scope.pageNum = 1;
                $scope.pdfDoc = null;
                $scope.documentProgress = function (progressData) {
                    if ($scope.loadProgress) {
                        $scope.loadProgress({state: "loading", loaded: progressData.loaded, total: progressData.total});
                    }
                };

                $scope.loadPDF = function (path) {
                    var loadingTask = PDFJS.getDocument({
                        url: path,
                        httpHeaders: {Authorization: "Bearer " + security.getToken()},
                    });
                    loadingTask.onProgress = $scope.documentProgress;
                    loadingTask.promise.then(function (_pdfDoc) {
                        $scope.pdfDoc = _pdfDoc;
                        $scope.renderPage($scope.pageNum, function (success) {
                            if ($scope.loadProgress) {
                                $scope.loadProgress({state: "finished", loaded: 0, total: 0});
                            }
                        });
                    }, function (message, exception) {
                        if ($scope.loadProgress) {
                            $scope.loadProgress({state: "error", loaded: 0, total: 0});
                        }
                    });
                };

                $scope.renderPage = function (num, callback) {
                    $scope.pdfDoc.getPage(num).then(function (page) {
                        var viewport = page.getViewport($scope.scale);
                        var ctx = canvas.getContext('2d');

                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        page.render({canvasContext: ctx, viewport: viewport}).then(
                            function () {
                                if (callback) {
                                    callback(true);
                                }
                                $scope.$apply(function () {
                                    $scope.onPageLoad({page: $scope.pageNum, total: $scope.pdfDoc.numPages});
                                });
                            },
                            function () {
                                if (callback) {
                                    callback(false);
                                }
                                console.log('page.render failed');
                            }
                        );
                    });
                };

                $scope.$on('pdfviewer.nextPage', function (evt, id) {
                    if (id !== instance_id) {
                        return;
                    }

                    if ($scope.pageNum < $scope.pdfDoc.numPages) {
                        $scope.pageNum++;
                        $scope.renderPage($scope.pageNum);
                    }
                });

                $scope.$on('pdfviewer.prevPage', function (evt, id) {
                    if (id !== instance_id) {
                        return;
                    }

                    if ($scope.pageNum > 1) {
                        $scope.pageNum--;
                        $scope.renderPage($scope.pageNum);
                    }
                });

                $scope.$on('pdfviewer.gotoPage', function (evt, id, page) {
                    if (id !== instance_id) {
                        return;
                    }

                    if (page >= 1 && page <= $scope.pdfDoc.numPages) {
                        $scope.pageNum = page;
                        $scope.renderPage($scope.pageNum);
                    }
                });
            }],
            link: function (scope, iElement, iAttr) {
                canvas = iElement.find('canvas')[0];
                instance_id = iAttr.id;

                scope.$watch('src', function (v) {
                    if (v !== undefined && v !== null && v !== '') {
                        scope.pageNum = 1;
                        scope.loadPDF(scope.src);
                    }
                });
            }

        };
    }
})();
(function () {
    angular.module('strefaKlienta')
        .directive('stringDatepicker', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/components/directives/stringDatepicker.html',
                scope: {
                    nazwa: '=',
                    required: '=',
                    date: '=',
                },
                controller: stringDatepickerCtrl,
                controllerAs: 'vm',
                bindToController: true
            };
        });

    function stringDatepickerCtrl(moment, $scope, $filter) {
        var vm = this;
        vm.format = 'dd.MM.yyyy';
        vm.opened = false;
        vm.dateDate = moment(vm.date).toDate();

        init();
        function init() {
            if (vm.date) {
                vm.dateDate = moment(vm.date).toDate();
            }

            vm.name = vm.nazwa || 'm_datepicker';
        }

        $scope.$watch('vm.dateDate', function (a, b) {
            if (a != b) {
                vm.date = $filter('date')(vm.dateDate, vm.format);
            }
        });

    }
})();
(function() {
    angular.module('strefaKlienta')
        .directive("scrollDetector", function ($window, scrollState) {
            return function (scope, element, attrs) {
                angular.element($window).bind("scroll", function () {
                    if (this.pageYOffset >= 150) {
                        scrollState.scrolledDown();
                    } else {
                        scrollState.scrolledUp();
                    }
                    scope.$apply();
                });
            };
        });
})();
(function () {
  angular.module('strefaKlienta')
    .directive('pytania', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/components/directives/pytania.html',
        controller: PytaniaController,
        scope:{
          items: "="
        },
        controllerAs: "vm",
        bindToController: true
      }
    });

  function PytaniaController() {
  }
})();

// (function () {
//     'use strict';
//     angular.module("strefaKlienta")
//       .controller('popupController', popupController)
//       .directive('kendoWindow', function () {
//           return {
//               restrict: 'E',
//               templateUrl: 'app/components/directives/popup.html',
//               transclude: true
//           }
//       })
//       .directive('pressEsc', function () {
//           return function (scope, element, attrs) {
//               element.bind("keydown keypress", function (event) {
//                   if(event.which === 27) {
//                       scope.$apply(function () {
//                           scope.$eval(attrs.pressEsc);
//                       });
//                   }
//               });
//           };
//       });
//     function popupController(Restangular,$filter, $sce) {
//         var vm = this;
//         vm.dane = [];
//         vm.pole = 0;
//         vm.aktualnaData = $filter('date')(new Date(), 'yyyy-MM-dd');
//         vm.init = function () {
//             Restangular.all('popup/popup/').getList().then(function (result) {
//
//                 // vm.modalVisibility = true;
//                 // vm.kendow=$("#newsPopup").kendoWindow({
//                 //     width: "380px",
//                 //     height: "auto",
//                 //     visible: false,
//                 //     resizable:false
//                 // });
//                 //
//                 // vm.kendow.data('kendoWindow').center().title("Informacja").open();
//                 angular.forEach(result, function (val) {
//                     if (val.data_start < vm.aktualnaData && val.data_koniec > vm.aktualnaData) {
//                         vm.dane.push(val);
//                     }
//                     vm.deliberatelyTrustDangerousSnippetNaglowek = function(){
//                         return $sce.trustAsHtml(vm.dane[0].naglowek);
//                     };
//                     vm.deliberatelyTrustDangerousSnippetTresc = function(){
//                         return $sce.trustAsHtml(vm.dane[0].tresc);
//                     };
//                 });
//             }, function (error) {
//             });
//         }
//
//     };
//
//
// })();
(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .directive('obslugaBledow', obslugaBledow);

  /** @ngInject */
  function obslugaBledow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/directives/obslugaBledow.html',
      scope: {
        wiadomosciTablica: '='
      },
      controller: ObslugaBledowController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function ObslugaBledowController($scope, bootstrapKlasa) {
      var vm = this;

      vm.bootstrapKlasa = bootstrapKlasa;
      vm.id = makeid();

      $scope.$watchCollection(function () {
        return vm.wiadomosciTablica;
      }, przewinNaGoreStrony);

      function przewinNaGoreStrony(newTable, oldTable){
        if(oldTable!==newTable && newTable.length > oldTable.length) {
          $('html, body').animate({
            scrollTop: $('#' + vm.id).offset().top - 150
          }, 500);
        }
      }

      function makeid()
      {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for( var i=0; i < 5; i++ )
          text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
      }

    }
  }

})();

(function() {
      'use strict';
    angular
        .module('strefaKlienta')
        .directive('ngEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if(event.which === 13) {
                    scope.$apply(function (){
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    });
});
(function () {
  angular.module('strefaKlienta')
    .directive('navbar', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/components/directives/navbar.html',
        controller: NavbarController,
        scope: {
          items: "="
        },
        controllerAs: "vm",
        bindToController: true
      }
    });

  function NavbarController($state) {
    var vm = this;
    vm.state = $state;
  }
})();

/*
 * Copyright (C) 2015  M.Informatyka Sp. z o.o. Sk.
 *
 * Wszelkie prawa zastrzeżone.
 */


(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .directive('mDropdown', mieszczaninDropdown);

  /** @ngInject */
  function mieszczaninDropdown() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/directives/mDropdown.html',
      scope: {
        refresh: "=",
        items: "=",
        selected: "=",
        width: "=",
        getData: "&",
        tryb: "@",
        // clear: "&",
        onSelect: "&"
      },
      controller: mDropdownController,
      controllerAs: 'vm',
      link: mDropdownLink,
      bindToController: true
    };

    return directive;

    /** @ngInject */

    function mDropdownController() {
      var vm = this;
      vm.search = '';
      vm.currentPage = 1;
      vm.pageSize = 10;
      vm.liczbaPaczek = 0;
      vm.endPage = 10;
      vm.startPage = 1;
      vm.pagesToPrint = 0;
      vm.fokus = false;

      vm.closeThis = closeThis;
      vm.openDropdown = openDropdown;

      vm.setCurrentPage = setCurrentPage;
      vm.nextPage = nextPage;
      vm.previousPage = previousPage;
      vm.pobierz = pobierz;
      vm.znajdz = znajdz;
      vm.wybierz = wybierz;
      vm.usunZaznaczenie = usunZaznaczenie;

      function closeThis() {
        vm.open = false;
        vm.fokus = false;
      }

      function openDropdown() {
        vm.open = !vm.open;
        vm.fokus = !vm.fokus;
      }

      function setCurrentPage(numer) {
        vm.currentPage = numer;
        pobierz();
      }

      function znajdz(keyCode) {
        if(keyCode === 13 || keyCode == null ) {
            vm.currentPage = 1;
            pobierz();
        }
      }

      function nextPage() {
        if (vm.currentPage < vm.liczbaPaczek) {
          vm.currentPage = vm.currentPage + 1;
        }
        pobierz();
      }

      function previousPage() {
        if (vm.currentPage >= 2){
          vm.currentPage = vm.currentPage - 1;
        }
        pobierz();
      }

      function pobierz(){
        vm.getData({
          params: {
            page: vm.currentPage,
            pageSize: vm.pageSize,
            search: vm.search
          }
        }).then(function (result) {
          vm.items = result;
          //vm.liczbaPaczek = Math.floor(result.meta.count / vm.pageSize) + (result.meta.count % vm.pageSize !== 0 ? 1 : 0)
          vm.liczbaPaczek = Math.ceil(result.meta.count / vm.pageSize);

          if (vm.liczbaPaczek <= 10){
            vm.startPage = 1;
            vm.endPage = vm.liczbaPaczek;
          } else {
            if (vm.currentPage <= 6){
              vm.startPage = 1;
              vm.endPage = 10;
            } else if (vm.currentPage + 4 >= vm.liczbaPaczek) {
              vm.startPage = vm.liczbaPaczek - 9;
              vm.endPage = vm.liczbaPaczek;
            } else {
              vm.startPage = vm.currentPage - 5;
              vm.endPage = vm.currentPage + 4;
            }
          }
          vm.pagesToPrint = _.range(vm.startPage, vm.endPage +1);
        });
      }

      function usunZaznaczenie() {
        wybierz(null);
        // if (vm.clear) {
        //   vm.clear();
        // }
      }

      function wybierz(item) {
        vm.selected = item;
        if (vm.onSelect) {
          vm.onSelect({item: item});
        }
        closeThis();
      }

    }

    function mDropdownLink(scope) {
      scope.$watch("vm.refresh", function (newValue) {
        if (newValue) {
          scope.vm.refresh = false;
          scope.vm.search = '';
          scope.vm.currentPage = 1;
          scope.vm.pobierz();
        }
      });
    }
  }

})();

(function () {
    angular.module('strefaKlienta')
        .directive('klientMenuBar', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/components/directives/klientMenu.html',
                scope: {
                    dostepDoBety: "="
                },
                controller: KlientMenuCtrl,
                controllerAs: 'vmKlientBar',
                bindToController: true
            }
        });

    function KlientMenuCtrl($state, $rootScope, security, uprawnieniaSubUsera, Restangular, bootstrapKlasa, liczbaZgloszen,
                            zapytanieOfertoweService, $scope) {
        var vm = this;
        vm.bootstrapKlasa = bootstrapKlasa;
        vm.liczbaZgloszen = liczbaZgloszen;
        vm.danePodstawowe = {};
        vm.state = $state;
        vm.security = security;
        vm.rozwiazania = false;
        vm.wielkoscKoszyka = zapytanieOfertoweService.dajKoszyk().produkty.length;
        vm.menustyle = '';
        vm.hideNaSkroty = false;
        vm.dostepy = {
            'Licencje': false,
            'Panel zakupowy': false,
            'Faktury': false,
            'Wykaz konsultacji': false,
            'Konta pracowników': false,
            'Usługi pasywne': false,
            'Aktualizacja': false,
            'Powiadomienia': false,
            'Informacje dedykowane': false,
            'Formularze': false,
            'Umowy': false
        };

        vm.init = init;
        vm.pobierz = pobierz;

        vm.menu = {
            'twoje_konto': [
                {
                    'nazwa': 'Licencje',
                    'state': 'home.subMain.licencje'
                },
                {
                    'nazwa': 'Umowy',
                    'state': 'home.subMain.umowy'
                },
                {
                    'nazwa': 'Panel zakupowy',
                    'state': 'home.subMain.zapytanieOfertowe'
                },
                {
                    'nazwa': 'Aktualizacja',
                    'state': 'home.subMain.pobieranie_plyty'
                },
                //todo konta_lokalizacje
                // {
                //     'nazwa': 'Konta pracowników',
                //     'state': 'home.subMain.konta_lokalizacje'
                // },
                //{
                //  'nazwa': 'Konta pracowników',
                //  'state': 'home.subMain.konta_pracownikow'
                //},
                //{
                //  'nazwa': 'Ustawienia mailingu',
                //  'state': 'home.subMain.ustawienia_mailingu'
                //},
                {
                    'nazwa': 'Powiadomienia',
                    'state': 'home.subMain.konsultacje'
                },
                {
                    'nazwa': 'Faktury',
                    'state': 'home.subMain.faktury'
                },
                {
                    'nazwa': 'Informacje dedykowane',
                    'state': 'home.subMain.informacje_dedykowane'
                },
                {
                    'nazwa': 'Konta pracowników',
                    'state': 'home.subMain.konta_pracownikow'
                },
                {
                    'nazwa': 'Wykaz konsultacji',
                    'state': 'home.subMain.wykaz_konsultacji'
                },
                {
                    'nazwa': 'Profil użytkownika',
                    'state': 'home.subMain.profil'
                }
            ],
            'dokumentacja': [
                {
                    'nazwa': 'Regulaminy',
                    'state': 'home.subMain.regulaminy'
                },
                {
                    'nazwa': 'Co nowego',
                    'state': 'home.subMain.co_nowego'
                },
                {
                    'nazwa': 'Pytania i Odpowiedzi',
                    'state': 'home.subMain.pytania_i_odpowiedzi'
                }
            ],
            'baza_wiedzy': [],
            'zgloszenia': [
                {
                    'nazwa': 'Zamówienia',
                    'state': 'home.subMain.zgloszenia.zamowienia'
                }
            ],
            'formularze': [
                {
                    'nazwa': 'Zapytanie ofertowe',
                    'state': 'home.subMain.zapytanieOfertowe'
                },
                // {
                //     'nazwa': 'Zamówienie e-kartoteki',
                //     'state': 'home.jakKupic.cennik'
                // },
                // {
                //     'nazwa': 'Zamówienie systemu e-Mieszczanin',
                //     'state': 'home.subMain.cennikEm'
                // },
                {
                    'nazwa': 'e-kartoteka & e-Mieszczanin',
                    'state': 'home.subMain.cennikEKIEM'
                },
                /*{
                    'nazwa': 'Zamówienie usług',
                    'state': 'home.subMain.zamowienie_uslug'
                },
                {
                    'nazwa': 'Zmiana limitów',
                    'state': 'home.subMain.zmiana_limitow'
                },
                {
                    'nazwa': 'Zapytaj konsultanta',
                    'state': 'home.subMain.zapytaj_informatyka'
                }*/
            ],
            'popupEdytor': [
                {
                    'state': 'home.subMain.popupEdytor.popupLista'
                }

            ],
            'demo': [
                {
                    'nazwa': 'Lista',
                    'state': 'home.subMain.listaDemo'
                }

            ],
            'mapa': []
        };


        function init() {
            Restangular.all('/uslugiPasywne/uslugiPasywne/').getList().then(function (result) {
                if (angular.isDefined(result) == true) {
                    if (result.length > 0) {
                        vm.menu['twoje_konto'].splice(1, 0, {
                            'nazwa': 'Usługi pasywne',
                            'state': 'home.subMain.uslugiPasywne'
                        });
                    }
                }
            });

            pobierz();
            Restangular.all('konto/danepodstawowe/').getList().then(function (danepodstawowe) {
                if (security.jestSubUserem() == false && security.jestDostepDoDanychKlienta()) {
                    vm.dostepy = {
                        'Licencje': true,
                        'Panel zakupowy': true,
                        'Faktury': true,
                        'Wykaz konsultacji': true,
                        'Konta pracowników': true,
                        'Profil użytkownika': false,
                        'Usługi pasywne': true,
                        'Aktualizacja': true,
                        'Powiadomienia': true,
                        'Informacje dedykowane': true,
                        'Formularze': true,
                        'Umowy': true,
                    };
                }
                if (security.jestSubUserem() == true) {
                    uprawnieniaSubUsera.getUprawnienia().then(function (result) {
                        vm.dostepy['Profil użytkownika'] = true;
                        angular.forEach(result, function (info) {
                            if (info.Licencje == true) {
                                vm.dostepy['Licencje'] = true;
                            }
                            if (info.PanelZakupowy == true) {
                                vm.dostepy['Panel zakupowy'] = true;
                            }
                            if (info.Faktury == true) {
                                vm.dostepy['Faktury'] = true;
                            }
                            if (info.WykazKonsultacji == true) {
                                vm.dostepy['Wykaz konsultacji'] = true;
                            }
                            if (info.Aktualizacja == true) {
                                vm.dostepy['Aktualizacja'] = true;
                            }
                            if (info.Powiadomienia == true) {
                                vm.dostepy['Powiadomienia'] = true;
                            }
                            if (info.InformacjeDedykowane == true) {
                                vm.dostepy['Informacje dedykowane'] = true;
                            }
                            if (info.Formularze == true) {
                                vm.dostepy['Formularze'] = true;
                                // vm.dostepy['Umowy'] = true;
                                vm.dostepy['Umowy'] = true;
                            }
                        });
                    });
                }
            });
        }


        function pobierz() {
            Restangular.all('zgloszenia/liczbaZgloszen/').getList().then(function (result) {
                if (angular.isDefined(result)) {
                    liczbaZgloszen.liczbaZgloszen = result[0].czekajaceNaKlienta;
                }
            });
        }

        $scope.$on('$aktualizujKoszyk', function () {
            vm.wielkoscKoszyka = zapytanieOfertoweService.dajKoszyk().produkty.length;
        });

    }
})();
(function() {
    'use strict';

    angular.module('strefaKlienta')
        .directive('compileTemplate', function($compile, $parse){
            return {
                link: function(scope, element, attr){
                    var parsed = $parse(attr.ngBindHtml);
                    function getStringValue() { return (parsed(scope) || '').toString(); }

                    //Recompile if the template changes
                    scope.$watch(getStringValue, function() {
                        $compile(element, null, -9999)(scope);  //The -9999 makes it skip directives so that we do not recompile ourselves
                    });
                }
            }
        });
})();




(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .directive('strefaGrid', strefaGrid);

    /** @ngInject */
    function strefaGrid() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/directives/grid-table.html',
            scope: {
                api: '@',
                requestParams: '@', //parametry do wysyłki na serwer
                columns: '=',
                selectedItem: '=',  //podpinamy zmienną do obserwacji wybranego elementu
                ctrl: '=', //controller do obsługi funkcji, które możemy przekazać w templatach
                rowExpand: '@', //ustawiamy gdy po kliknięciu wiersza ma się rozwinąć = true
                rowExpandTemplate: '@', //template do rozwinięcia wiersza
                rowExpandMultiple: '@', //ustawimy gdy można rozwinąć kilka wierszy
                showFilter: '@', //gdy true wyswietlany jest pierwszy wiersz z możliwością filtrowania wyników
                selectFirst: '@', //ustawienie na true powoduje zaznaczenie pierwszego wiersza (gdy opcja expand to również rozwinięcie)
                globalSearch: '@', //wyswietla globalny filtr z kluczem 'search'
                idName: '@', //nazwa parametru stanowiącego główny klucz - potrzebne w przypadku edycji inline
                errorUpdateText: '@', //tekst do wyświetlenia przy nieudanej edycji obiektu - potrzebne w przypadku edycji inline
                errorDeleteText: '@', //tekst do wyświetlenia przy nieudanym usuwaniu obiektu - potrzebne w przypadku edycji inline
                allowDelete: '@', //ustawienie na true pozwala na usuwanie obiektu
                allowPost: '@', //ustawienie parametru pozwala na dodawanie nowych obiektów i wysyłkę na serwer
                refresh: '@', //zmiana z wartości false na true spowoduje wczytanie na nowo danych
                addItemText: '@', //tekst do wyświetlenia w miejscu przycisku dodawania nowego obiektu
                deleteMessage: '@',
                rowClickOverride: '&'
            },
            controller: StrefaGridTableController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function StrefaGridTableController(Popup, Restangular, NgTableParams, $sce, bootstrapKlasa, $uibModal, $scope,
                                           lokalizacjaAPI, $http, ZgloszenieNaSzkolenieRaport, $state) {
            var vm = this;
            vm.state = $state;
            vm.lokalizacjaAPI = lokalizacjaAPI;
            vm.addElement = addElement;
            vm.applyGlobalSearch = applyGlobalSearch;
            vm.bootstrapKlasa = bootstrapKlasa;
            vm.cancel = cancel;
            vm.cancelRemove = cancelRemove;
            vm.confirmDelete = confirmDelete;
            vm.disableAddElement = false;
            vm.edit = edit;
            vm.fields = {};
            vm.remove = remove;
            vm.save = save;
            vm.serverResponses = [];
            vm.rowSelect = rowSelect;
            vm.addSelectedRowClass = addSelectedRowClass;
            vm.runExtFunction = runExtFunction;
            vm.wyswietlHTML = wyswietlHTML;
            vm.showLoading = true;
            vm.globalSearchTerm = '';
            vm.wyslijPostaZPotwierdzeniem = function(api, params, tytul, tresc, taknie, errMsg) {
                Popup.wyswietlInfo(tytul, tresc,
                    function() {
                        Restangular.all(api).post(params).then(function() {
                            vm.tableParams.reload();
                        }, function (e) {
                            vm.serverResponses.push({
                                typ: 'E',
                                tekst: errMsg
                            });
                        });
                    },null);

            };
            vm.generujRaportZgloszenieNaSzkolenie = function(item) {
                item.generowanie_raportu = true;
                ZgloszenieNaSzkolenieRaport.generujRaport(item).then(function(res) {
                    pdfMake.createPdf(res).download();
                }).then(function() {
                    item.generowanie_raportu = false;
                });
            };

            vm.czyJestPrzedData = function(dataDo) {
                return new Date(dataDo) > new Date();
            };

            vm.getFile = function(api, item){
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                $http({
                    method: 'GET',
                    url: lokalizacjaAPI+api+item.id+'/file/',
                    responseType: "blob"
                }).success(function(result) {
                    var blob = new Blob([result],
                        { type: 'application/pdf'});
                    var url = URL.createObjectURL(blob);
                    a.href = url;
                    a.download = item.nazwaPliku;
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
            };
            //slownik do przetrzymywania originalnych wartości w przypadku edycji
            var originalData = {};

            //ustawiamy api rest angulara
            var base = Restangular.all(vm.api);

            //sprawdzamy czy zaznaczyć pierwszy wiersz
            var selectFirst = false;
            if (angular.isDefined(vm.selectFirst)){
                if(vm.selectFirst === 'true'){
                    selectFirst = true;
                }
            }

            //wczytujemy parametry przekazane do dyrektywy + ustawiamy pageSize
            var requestParams = {};
            if(vm.requestParams && vm.requestParams != ''){
                requestParams = angular.fromJson(vm.requestParams);
            }
            requestParams['page'] = 1;

            if(!angular.isDefined(requestParams.pageSize)){
                requestParams['pageSize'] = 10;
            }

            //tworzymy parametry do ng-tables
            vm.tableParams = new NgTableParams({
                page: requestParams['page'], // show first page
                count: requestParams['pageSize'] // count per page
            }, {
                filterDelay: 300,
                counts: [],// można ustalić wielkość strony - jeżeli puste wielkość jest nie wyświetlana
                getData: function(params) {
                    vm.showLoading = true;// zmienna do wyświetlania 'trytki'
                    //todo pomyslec czy nie czyscic selected item
                    requestParams['page'] = vm.tableParams.page();
                    requestParams['pageSize'] = vm.tableParams.count();
                    //pobieramy i ustawiamy parametry do sortowania (django - ordering)
                    var sortObject = vm.tableParams.sorting();
                    setSorting(sortObject);

                    //pobieramy pamrametry do filtrowania
                    var filterObject = params.filter();

                    //laczymy paramtery głowne z parametrami do filtrowania - z uwagi na fakt że to jest słownik raczej trzeba
                    //w taki sposób
                    var requestDict = $.extend({}, requestParams, filterObject);

                    return base.getList(requestDict).then(function (items) {
                        vm.showLoading = false;
                        vm.items = items;
                        params.total(items.meta.count);//ustawienie tego parametru zapewnia wyświetlanie paginatora
                        if (selectFirst && angular.isDefined(items[0])){
                            rowSelect(items[0], 0);
                            selectFirst = false;//tylko przy pierwszym załadowaniu grida mamy zaznaczyć
                        }
                        return items
                    }, function(response){//error
                        vm.showLoading = false; //todo mozna pomyslec o unikalnej obsludze bledow
                    });
                }
            });

            function rowSelect(item, index){

                expandRow(item);
                item.rowIndex = index + (requestParams['page'] - 1) * requestParams['pageSize'];
                if (angular.isDefined(vm.selectedItem)) {
                    vm.selectedItem = item;
                }
                if(angular.isDefined(vm.rowClickOverride) == true) {
                    vm.rowClickOverride({item: item, index: index});
                }
            }

            function expandRow(item){
                if (!angular.isDefined(item.expanded)){
                    item.expanded = true;
                }
                else{
                    item.expanded = !item.expanded;
                }
                if(vm.rowExpandMultiple !== 'true') {
                    for (var i = 0; i < vm.items.length; i++) {
                        if (vm.items[i] !== item) {
                            vm.items[i].expanded = false;
                        }
                    }
                }
            }

            function addSelectedRowClass(index){
                if (vm.selectedItem) {
                    if (vm.selectedItem.rowIndex === index + (requestParams['page'] - 1) * requestParams['pageSize']) {
                        return true;
                    }
                    return false;
                }
            }

            function wyswietlHTML(string){
                var row = $sce.trustAsHtml(string);
                return row;
            }

            function setSorting(obj){
                var keys = Object.keys(obj);
                var sortList = [];
                for (var i=0; i< keys.length; i++){
                    var string = '' + keys[i];
                    if(obj[keys[i]] === 'desc'){
                        string = '-' + string;
                    }
                    sortList.push(string);
                }
                if(keys.length > 0) {
                    requestParams['ordering'] = sortList;
                }
            }

            function applyGlobalSearch(){
                var term = vm.globalSearchTerm;
                vm.tableParams.filter({ search: term });
                vm.tableParams.reload();
            }

            function runExtFunction(functionName, params){
                return vm.ctrl[functionName](params);
            }

            function edit(row, event){
                event.stopPropagation();
                originalData[row.$$hashKey] = angular.copy(row);
                row.isEditing = true;
            }

            function cancel(row, event){
                event.stopPropagation();
                row.isEditing = false;
                angular.extend(row, originalData[row.$$hashKey]);
                delete originalData[row.$$hashKey];
                if(angular.isDefined(row['newField']) && row['newField']===true){
                    vm.tableParams.data.splice(0,1);
                }
                vm.disableAddElement = false;
            }

            function sendPut(row){
                row.put(requestParams).then(
                    function(success){
                        delete originalData[row.$$hashKey];
                        row.isEditing = false;
                    },
                    function(error){
                        vm.serverResponses.push({
                            typ: 'E',
                            tekst: vm.errorUpdateText
                        });
                    })
            }

            function sendPost(row){
                base.post(row).then(
                    function(ans){
                        row.isEditing = false;
                        vm.disableAddElement = false;
                        vm.tableParams.reload();
                    },
                    function(error){
                        vm.serverResponses.push({
                            typ: 'E',
                            tekst: 'Nie udało się utworzyć obiektu.'
                        });
                    })
            }

            function save(row, event){
                event.stopPropagation();
                if(!row.id){
                    if(angular.isDefined(vm.idName) && angular.isDefined(row[vm.idName])){
                        row.id = row[vm.idName];
                    }
                }
                if(angular.isDefined(row['newField']) && row['newField']===true){
                    sendPost(row);
                }
                else{
                    sendPut(row);
                }
            }

            function cancelRemove(row, event){
                event.stopPropagation();
                row.isDeleting = false;
            }

            function confirmDelete(row, event){
                Popup.wyswietlInfo("Potwierdzenie", "Czy na pewno chcesz usunąć?",
                    function() {
                        event.stopPropagation();
                        row.remove().then(
                            function (success) {
                                delete originalData[row.$$hashKey];
                                vm.tableParams.reload();
                            },
                            function (error) {
                                vm.serverResponses.push({
                                    typ: 'E',
                                    tekst: vm.errorDeleteText
                                });
                            })
                    },null);
            }

            function remove(row, event){
                event.stopPropagation();
                if(!row.id){
                    if(angular.isDefined(vm.idName) && angular.isDefined(row[vm.idName])){
                        row.id = row[vm.idName];
                    }
                }
                row.isDeleting = true;
            }

            function reload(newV, oldV){
                if (newV !== oldV){
                    vm.tableParams.reload();
                }
            }

            function addElement(){
                if(Object.keys(vm.fields).length===0){
                    getFields();
                }
                vm.fields['isEditing'] = true;
                vm.tableParams.sorting({});
                vm.tableParams.page(1);
                vm.tableParams.reload().then(function(){
                    vm.tableParams.data.unshift(angular.copy(vm.fields));
                });
                vm.disableAddElement = true;
            }

            function getFields(){
                for (var i=0;i<vm.columns.length;i++){
                    var col = vm.columns[i];
                    vm.fields[col.fieldName] = null;
                }
                vm.fields['newField'] = true;
            }

            $scope.$watch(function () {
                return vm.refresh;
            }, reload);

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('ModalConfirmCtrl', ModalConfirmCtrl);

    /** @ngInject */
    function ModalConfirmCtrl($uibModalInstance, bootstrapKlasa) {
        var vm = this;

        vm.bootstrapKlasa = bootstrapKlasa;
        vm.cancel = cancel;
        vm.ok = ok;


        function ok() {
            $uibModalInstance.close('');
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .directive('footer', wyswietlaniePlikow);

    /** @ngInject */
    function wyswietlaniePlikow() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/directives/footer.html',
            controller: FooterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

        /** @ngInject */
        function FooterController() {
            var vm = this;
            vm.year = new Date().getFullYear();
        }
    }

})();

//przykład korzystania z dyrektywy w noweOgloszenie-controller.js
angular.module('strefaKlienta').directive('dodawaniePlikowZgloszenia', function () {
    return {
        restrict: 'E',
        templateUrl: 'app/components/directives/dodawaniePlikowZgloszenia.html',
        scope: {
            uploader: "=uploader",
            nazwaApi: "@",
            nazwaPrzycisku: "@",
            ograniczenieRodzaju: "@",
            schowaj: "=",
            dozwoloneLinki: "@",
            nazwaApiLinkow: "@",
            idZgloszenia: "@",
            pokazPowiadomienia: "@"
        },
        controller: ['$scope', 'security', 'lokalizacjaAPI', 'Upload', '$q', 'plikiOperacje',
            '$http', 'bootstrapKlasa',
            function ($scope, security, lokalizacjaAPI, Upload, $q, plikiOperacje, $http, bootstrapKlasa) {
                $scope.bootstrapKlasa = bootstrapKlasa;
                $scope.formaty = "application/octet-stream";
                if ($scope.ograniczenieRodzaju) {
                    $scope.formaty = $scope.ograniczenieRodzaju;
                }
                $scope.rozmiarMaxMB = 20;
                $scope.iloscPlikowMax = 20;
                $scope.dodajLink = dodajLink;
                $scope.errorMessage = [];
                $scope.linki = [];
                $scope.successMessage = [];
                $scope.files = {files: []};
                $scope.dodajDokumenty = false;
                $scope.plikiOperacje = plikiOperacje;
                $scope.usunLink = usunLink;
                $scope.obetnijRozszerzenie = function (string) {
                    return string.replace(/\.[^/.]+$/, "");
                };
                $scope.usun = function (index) {
                    $scope.files.files.splice(index, 1);
                };
                $scope.wyczyscWszystko = function () {
                    $scope.files.files = [];
                    $scope.linki = [];
                };
                $scope.uploader = {};
                $scope.uploader.wgrajPliki = function (id_dok, id_kom, autor) {
                    $scope.errorMessage = [];
                    $scope.successMessage = [];
                    var promises = [];
                    if (($scope.files.files && $scope.files.files.length) || $scope.linki.length > 0) {
                        for (var i = 0; i < $scope.files.files.length; i++) {
                            var file = $scope.files.files[i];
                            var fields = {'nazwaPliku': file.nazwa,
                                'idZgloszenia': id_dok,
                                'autor': autor};
                            if(id_kom){
                                fields['idKomentarza']=id_kom;
                            }
                            var response = Upload.upload({
                                url: lokalizacjaAPI + '/' + $scope.nazwaApi,
                                headers: {'Authorization': 'Bearer ' + security.getToken()},
                                fields: fields,
                                file: file
                            }).success(function (data, status, headers, config) {
                                var index = $scope.files.files.indexOf(config.file);
                                $scope.files.files.splice(index, 1);
                                $scope.successMessage.push({
                                    "wiadomosc": 'Plik' + ' ' + config.file.name.toString() +
                                    ' został dodany poprawnie. '
                                })
                            }).error(function (data, status, headers, config) {
                                $scope.blad = true;
                                var tresc = 'Wystąpił błąd podczas dodawania pliku ' +
                                    config.file.name.toString();
                                if (data && data.field && data.file[0] === 'to_big_data') {
                                    tresc = tresc + ' : ' + 'Plik przekracza dopuszczalny rozmiar.'
                                }
                                $scope.errorMessage.push({
                                    "wiadomosc": tresc
                                });
                            });
                            promises.push(response);
                        }
                        if ($scope.dozwoloneLinki) {
                            for (var i = 0; i < $scope.linki.length; i++) {
                                var link = $scope.linki[i].link;
                                var response = $http({
                                    url: lokalizacjaAPI + $scope.nazwaApiLinkow,
                                    method: 'POST',
                                    data: {
                                        id_dok: id_dok,
                                        url: link,
                                        index: i
                                    }
                                })
                                    .success(function (data, status, headers, config) {
                                        var index = config.data.index;
                                        $scope.linki.splice(index, 1);
                                        $scope.successMessage.push({
                                            "wiadomosc": 'Link' + config.data.url.toString() +
                                            ' ' + 'został dodany poprawnie'
                                        })
                                    })
                                    .error(function (data, status, headers, config) {
                                        $scope.errorMessage.push({
                                            "wiadomosc": "Wystąpił błąd podczas dodawania linku " +
                                            config.data.url.toString()
                                        });
                                    });
                                promises.push(response);
                            }
                        }
                        return $q.all(promises);
                    }
                    else {
                        return $q.all(promises);
                    }
                };

                function dodajLink() {
                    $scope.linki.push(
                        {
                            link: ""
                        }
                    )
                }

                function usunLink(index) {
                    $scope.linki.splice(index, 1);
                }

            }],
        link: function (scope, element, attrs) {
            attrs.$observe('schowaj', function (val) {
                if (val === "true") {
                    scope.dodajDokumenty = false;
                }
            });
        }
    };
});
(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .directive('dodawaniePlikowPdf', dodawaniePlikowPdf);

  /** @ngInject */
  function dodawaniePlikowPdf() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/directives/dodawaniePlikow-template.html',
      scope: {
        files: "=",
        wyczysc: "=",
        ilePlikow: "=",
        wielokrotneZaznaczanie: "="
      },
      controller: DodawaniePlikowController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function DodawaniePlikowController($scope) {
      var vm = this;

      // maksymalna liczba plików przesyłanych jednocześnie, gdy nie ma ustawionego limitu w parametrach dyrektywy
      vm.maxFiles = 99;
      vm.multiple = true;

      vm.formaty = "application/pdf";
      vm.usun = usun;
      vm.obetnijRozszerzenie = obetnijRozszerzenie;

      function obetnijRozszerzenie(string){
        return string.replace(/\.[^/.]+$/, "");
      }

      function usun(index){
        vm.files.splice(index, 1);
      }

      $scope.$watch('vm.wyczysc', function(newValue, oldValue) {
        if(newValue==true) {
          vm.files = [];
          vm.wyczysc = false;
        }
      });

    }
  }

})();

//przykład korzystania z dyrektywy w noweOgloszenie-controller.js
angular.module('strefaKlienta').directive('dodawaniePlikowBezTokena', function () {
    return {
        restrict: 'E',
        templateUrl: 'app/components/directives/dodawaniePlikowBezTokena-template.html',
        scope: {
            uploader: "=uploader",
            nazwaApi: "@",
            nazwaPrzycisku: "@",
            ograniczenieRodzaju: "@",
            schowaj: "@",
            dozwoloneLinki: "@",
            nazwaApiLinkow: "@"
        },
        controller: ['$scope', 'security', 'lokalizacjaAPI', 'Upload', '$q', 'plikiOperacje',
            '$http', 'bootstrapKlasa',
            function ($scope, security, lokalizacjaAPI, Upload, $q, plikiOperacje, $http, bootstrapKlasa) {
                $scope.bootstrapKlasa = bootstrapKlasa;
                $scope.formaty = "image/*," +
                    "application/pdf," +
                    "application/msword," +
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document," +
                    "video/x-ms-wmv," +
                    "application/docx," +
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document," +
                    "application/msword," +
                    "application/vnd.ms-powerpoint," +
                    "application/excel," +
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet," +
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation," +
                    "application/vnd.ms-excel," +
                    "application/octet-stream," +
                    "application/zip," +
                    "application/x-zip," +
                    "text/html," +
                    "text/plain";
                if ($scope.ograniczenieRodzaju) {
                    $scope.formaty = $scope.ograniczenieRodzaju;
                }
                $scope.rozmiarMaxMB = 20;
                $scope.iloscPlikowMax = 20;
                $scope.dodajLink = dodajLink;
                $scope.errorMessage = [];
                $scope.linki = [];
                $scope.successMessage = [];
                $scope.files = {files: []};
                $scope.dodajDokumenty = false;
                $scope.plikiOperacje = plikiOperacje;
                $scope.usunLink = usunLink;
                $scope.obetnijRozszerzenie = function (string) {
                    return string.replace(/\.[^/.]+$/, "");
                };
                $scope.usun = function (index) {
                    $scope.files.files.splice(index, 1);
                };
                $scope.wyczyscWszystko = function () {
                    $scope.files.files = [];
                    $scope.linki = [];
                };
                $scope.uploader = {};
                $scope.uploader.wgrajPliki = function (id_dok) {
                    $scope.errorMessage = [];
                    $scope.successMessage = [];
                    var promises = [];
                    if (($scope.files.files && $scope.files.files.length) || $scope.linki.length > 0) {
                        for (var i = 0; i < $scope.files.files.length; i++) {
                            var file = $scope.files.files[i];
                            var response = Upload.upload({
                                url: lokalizacjaAPI + '/' + $scope.nazwaApi,
                                //headers: {'Authorization': 'Bearer ' + security.getToken()},
                                fields: {
                                    'Nazwa': file.nazwa,
                                    'id_dok': id_dok
                                },
                                file: file
                            }).success(function (data, status, headers, config) {
                                var index = $scope.files.files.indexOf(config.file);
                                $scope.files.files.splice(index, 1);
                                $scope.successMessage.push({
                                    "wiadomosc": 'Plik' + ' ' + config.file.name.toString() +
                                    ' został dodany poprawnie. '
                                })
                            }).error(function (data, status, headers, config) {
                                $scope.blad = true;
                                var tresc = 'Wystąpił błąd podczas dodawania pliku ' +
                                    config.file.name.toString();
                                if (data && data.field && data.file[0] === 'to_big_data') {
                                    tresc = tresc + ' : ' + 'Plik przekracza dopuszczalny rozmiar.'
                                }
                                $scope.errorMessage.push({
                                    "wiadomosc": tresc
                                });
                            });
                            promises.push(response);
                        }
                        if ($scope.dozwoloneLinki) {
                            for (var i = 0; i < $scope.linki.length; i++) {
                                var link = $scope.linki[i].link;
                                var response = $http({
                                    url: lokalizacjaAPI + $scope.nazwaApiLinkow,
                                    method: 'POST',
                                    data: {
                                        id_dok: id_dok,
                                        url: link,
                                        index: i
                                    }
                                })
                                    .success(function (data, status, headers, config) {
                                        var index = config.data.index;
                                        $scope.linki.splice(index, 1);
                                        $scope.successMessage.push({
                                            "wiadomosc": 'Link' + config.data.url.toString() +
                                            ' ' + 'został dodany poprawnie'
                                        })
                                    })
                                    .error(function (data, status, headers, config) {
                                        $scope.errorMessage.push({
                                            "wiadomosc": "Wystąpił błąd podczas dodawania linku " +
                                            config.data.url.toString()
                                        });
                                    });
                                promises.push(response);
                            }
                        }
                        return $q.all(promises);
                    }
                    else {
                        return $q.all(promises);
                    }
                };

                function dodajLink() {
                    $scope.linki.push(
                        {
                            link: ""
                        }
                    )
                }

                function usunLink(index) {
                    $scope.linki.splice(index, 1);
                }

            }],
        link: function (scope, element, attrs) {
            attrs.$observe('schowaj', function (val) {
                if (val === "true") {
                    scope.dodajDokumenty = false;
                }
            });
        }
    };
});/**
 * Created by dp on 08.09.16.
 */

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .directive('dodawaniePlikow', dodawaniePlikow);

  /** @ngInject */
  function dodawaniePlikow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/components/directives/dodawaniePlikow-template.html',
      scope: {
        files: "=",
        wyczysc: "=",
        ilePlikow: "=",
        wielokrotneZaznaczanie: "="
      },
      controller: DodawaniePlikowController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function DodawaniePlikowController($scope) {
      var vm = this;

      // maksymalna liczba plików przesyłanych jednocześnie, gdy nie ma ustawionego limitu w parametrach dyrektywy
      vm.maxFiles = 99;
      vm.multiple = true;

      vm.formaty = "image/*," +
      "application/pdf," +
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document," +
      "application/msword," +
      "application/vnd.ms-powerpoint," +
      "application/excel," +
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet," +
      "application/vnd.openxmlformats-officedocument.presentationml.presentation," +
      "application/vnd.ms-excel," +
      "application/octet-stream," +
      "application/zip," +
      "application/x-zip," +
      "text/html," +
      "text/plain," +
      "application/x-rar-compressed," +
      "application/zip," +
      "application/x-7z-compressed," +
      "application/x-zip-compressed," +
      "multipart/x-zip";

      vm.usun = usun;
      vm.obetnijRozszerzenie = obetnijRozszerzenie;

      function obetnijRozszerzenie(string){
        return string.replace(/\.[^/.]+$/, "");
      }

      function usun(index){
        vm.files.splice(index, 1);
      }

      $scope.$watch('vm.wyczysc', function(newValue, oldValue) {
        if(newValue==true) {
          vm.files = [];
          vm.wyczysc = false;
        }
      });

    }
  }

})();

angular.module('strefaKlienta').directive('ngEnter', function () {
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if(event.which === 13) {
        scope.$apply(function (){
          scope.$eval(attrs.ngEnter);
        });

        event.preventDefault();
      }
    });
  };
});

angular.module('strefaKlienta').filter('unique', function () {

  return function (items, filterOn) {

    if (filterOn === false) {
      return items;
    }

    if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
      var hashCheck = {}, newItems = [];

      var extractValueToCompare = function (item) {
        if (angular.isObject(item) && angular.isString(filterOn)) {
          return item[filterOn];
        } else {
          return item;
        }
      };

      angular.forEach(items, function (item) {
        var valueToCheck, isDuplicate = false;

        for (var i = 0; i < newItems.length; i++) {
          if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
            isDuplicate = true;
            break;
          }
        }
        if (!isDuplicate) {
          newItems.push(item);
        }

      });
      items = newItems;
    }
    return items;
  };
});
(function() {
    angular.module('strefaKlienta')
        .directive('cookieBar', function ($cookies) {
            return {
                scope: {},
                templateUrl: 'app/components/directives/cookieBar.html',
                controller: function ($scope) {
                    var _consent = $cookies.get('consent');
                    $scope.consent = function (consent) {
                        if (consent === undefined) {
                            return _consent;
                        } else if (consent) {
                            $cookies.put('consent', true);
                            _consent = true;
                        }
                    };
                }
            };
        });
})();
(function() {
    angular.module('strefaKlienta')
        .directive('carousel', function () {
            return {
                restrict: 'E',
                transclude: true,
                templateUrl: 'app/components/directives/carousel.html',
                controller: carouselController,
                controllerAs: 'carouselCtrl',
                bindToController: true
            };
        });

    function carouselController($scope, Carousel) {
        $scope.Carousel = Carousel;
        $scope.slides = [
            {
                id: 0,
                bg: "background: url('/assets/images/top-1.jpg')!IMPORTANT",
                pad: "pl40",
                link: "home.rozwiazania.rozwiazania",
                slogan: "Informatyka",
                slogan2: "w nieruchomościach"
            },
            {
                id: 1,
                bg: "background: url('/assets/images/3.jpg')!IMPORTANT",
                pad: "pl10",
                link: "home.oNas.oNas",
                slogan: "Rozwiązania",
                slogan2: "dla nieruchomości"
            },
            {
                id: 2,
                bg: "background: url('/assets/images/7.jpg')!IMPORTANT",
                pad: "pl10",
                link: "home.oNas.naszaKadra",
                slogan: "Współpraca",
                slogan2: "z profesjonalistami"
            },
            {
                id: 3,
                bg: "background: url('/assets/images/5.jpg')!IMPORTANT",
                pad: "pl10",
                link: "home.oNas.naszaHistoria",
                slogan: "Nowoczesność",
                slogan2: "z tradycjami"
            },
            {
                id: 4,
                bg: "background: url('/assets/images/2.jpg')!IMPORTANT",
                pad: "pl10oneLine",
                link: "home.oNas.oNas",
                slogan: "Sprawdzony partner",
                slogan2: ""
            }
        ];
    }
})();
(function () {

    'use strict';

    angular.module('strefaKlienta').factory('zgloszeniaService', zgloszeniaService);

    zgloszeniaService.$inject = ['Popup'];

    /* @ngInject */
    function zgloszeniaService(Popup) {
        var service = {
            pokazInfoPoczekalni: pokazInfoPoczekalni
        };

        function pokazInfoPoczekalni() {
            Popup.wyswietlInfo('Poczekalnia',
                  'Dzień dobry,<br> ' +
                  'Zależy nam, aby państwa zgłoszenia były rozpatrywane jak najszybciej. ' +
                  'Chcemy usprawnić ten proces, dlatego przedstawiamy najważniejsze informacje, ' +
                  'które są nam potrzebne do podjęcia zgłoszenia.<br>' +
                  '<b>Kompletne zgłoszenie zawiera:</b>' +
                  '<ul class="tight">' +
                  '<li>kategorię zgłoszenia (Zamówienia oraz propozycje rozwoju nie są kierowane do konsultantów),</li>' +
                  '<li>imię i nazwisko Zgłaszającego,</li>' +
                  '<li>numer kontaktowy oraz adres mailowy,</li>' +
                  '<li>tytuł, który bezpośrednio informuje o rodzaju zgłoszenia,</li>' +
                  '<li>opis, który zawiera:' +
                  '<ul class="tight">' +
                  '<li>szczegóły dotyczące zgłaszanej sprawy (przy zgłoszeniach dotycządych e-kartoteki wraz ze wskazaniem loginu użytkownika, którego dotyczy zgłoszenie),</li>' +
                  '<li>w przypadkach dotyczących błędów także czas i częstotliwość pojawiania się problemu,</li>' +
                  '</ul>' +
                  '</li>' +
                  '<li>bardzo ważne, by zgłoszenie zawierało także:' +
                  '<ul class="tight">' +
                  '<li>zrzut ekranu i/lub nagranie które obrazuje sprawę,</li>' +
                  '<li>informację, czy baza została przesłana na serwer techniczny.</li>' +
                  '</ul>' +
                  '</li>' +
                  '</ul>',
                  function () {}, null, { akceptujTekst: 'Zamknij', ukryjAnuluj: true });
        }

        return service;
    }
})();

(function () {

  'use strict';

  angular.module('strefaKlienta').factory('wyslijPliki', wyslijPliki);

  wyslijPliki.$inject = ['$q', 'Upload', 'lokalizacjaAPI', 'security'];

  /* @ngInject */
  function wyslijPliki($q, Upload, lokalizacjaAPI, security) {


    var service = {
      wyslij                            : wyslij,
    };

    /**
     *
     * @param sciezkaAPI miejsce wysyłania plików - postaci '/usterki/usterka/15/zalaczniki/',
     * @param files
     * @param fields
     * @returns {*}
     */
    function wyslij(sciezkaAPI, files, fields) {

      var promises = [];
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          var f = JSON.parse(JSON.stringify(fields));
          f['nazwaPliku'] = file.nazwaPliku;
          var response = Upload.upload({
            url: lokalizacjaAPI + sciezkaAPI,
            headers: (security.isLogin() ? {'Authorization': 'Bearer ' + security.getToken()} : {} ),
            fields: f,
            file: file
          }).then(function (result) {
            var index = files.indexOf(result.config.file);
            files.splice(index, 1);
            return result
          }, function (error) {
            error.tekst = "Błąd podczas wysyłania pliku " + error.config.file.name.toString();
            if (error.data && error.data.file && error.data.file[0] === 'to_big_data') {
              error.tekst = error.tekst + ' : za duży rozmiar pliku';
            }
            return $q.reject(error);
          });
          promises.push(response);
        }
      }

      return $q.all(promises).then(null, function(error) {
        return $q.reject(error);
      });
    };

    return service;
  }
})();

/**
 * Created by dp on 19.07.17.
 */

(function () {

    'use strict';

    angular.module('strefaKlienta').factory('wersjaStrony', wersjaStrony);

    wersjaStrony.$inject = ['Restangular', 'store', '$interval'];

    /* @ngInject */
    function wersjaStrony(Restangular, store, $interval) {
        var vm = this;
        vm.wersja = null;
        vm.polowanie = null;
        vm.inneWersje = false;

        var service = {
            inneWersje: vm.inneWersje,
            get: get,
            startPolling: startPolling,
            stopPolling: stopPolling,
            init:init
        };

        function init() {

            return Restangular.all('wersje/wersja/').getList().then(function(result) {
                vm.wersja = result[0].version;
                if(store.get( 'wersjaStrony' ) === null) {
                    store.set('wersjaStrony', result[0].version)
                }
                if([result[0].version, null].indexOf(store.get( 'wersjaStrony' ))===-1) {
                    store.remove('wersjaStrony');
                    vm.inneWersje = true;
                }
                return result[0].version
            })
        }

        function get() {
            return Restangular.all('wersje/wersja/').getList().then(function(result) {
                vm.wersja = result[0].version;
                if([result[0].version, null].indexOf(store.get( 'wersjaStrony' ))===-1) {
                    store.remove('wersjaStrony');
                    vm.inneWersje = true;
                }
                return result[0].version
            })
        }

        function startPolling() {
            get();
            return vm.inneWersje;
        }
        function stopPolling() {
            $interval.cancel(vm.polowanie);
        }

        return service;
    }
})();

(function () {

    'use strict';

    angular.module('strefaKlienta').factory('uprawnieniaSubUsera', uprawnieniaSubUsera);

    uprawnieniaSubUsera.$inject = ['Restangular', '$q', 'security'];

    /* @ngInject */
    function uprawnieniaSubUsera(Restangular, $q, security) {
        var vm = this;
        vm.dane = null;
        vm.uprawnienia = null;
        
        
        var service = {
            getInfo: getInfo,
            getUprawnienia: getUprawnienia,
            wyczysc: wyczysc
        };

        function wyczysc() {
            vm.dane = null;
            vm.uprawnienia = null;
        }

        function getInfo() {
            vm.dane = null;
            return Restangular.one('subUser/subUser/'+security.getIdSubUser()+'/').get().then(function (result) {
                    if (angular.isDefined(result)) {
                        vm.dane = result;
                         return result;
                    }
                });
        }

        function getUprawnienia() {
            vm.uprawnienia = null;
            return Restangular.all('subUser/pracownikUprawnienia/').getList({idPrac:security.getIdPrac()}).then(function (result) {
                if (angular.isDefined(result)) {
                    vm.uprawnienia = result;
                    return result;
                }
            });
        }

        return service;
    }
})();

(function () {

    'use strict';

    angular.module('strefaKlienta').factory('statusService', statusService);

    statusService.$inject = [ 'Restangular', 'security', '$q'];

    /* @ngInject */
    function statusService(Restangular, security, $q) {
        var service = {
            dajOpis: dajOpis,
        };
        function dajOpis(komentarz, typ, powodZamkniecia) {
            if(komentarz.indexOf('Oczekuje na obsługę')!==-1) {
                if(typ == 'Konsultacja') {
                    return 'Twoje zgłoszenie zostało zarejestrowane i oczekuje na konsultanta, ' +
                        'który udzieli Ci pomocy.';
                }
                if(typ == 'Zamówienie') {
                    return 'Twoje zgłoszenie zostało zarejestrowane i oczekuje na konsultanta, ' +
                        'który omówi z Tobą szczegóły realizacji usługi.'
                }
            }

            if(komentarz.indexOf('Oczekuje na klienta')!==-1) {
                return 'Konsultant prowadzący sprawę czeka na dodatkowe informacje od Ciebie.'
            }

            if(komentarz.indexOf('Ustalony termin')!==-1) {
                return 'Termin udzielenia porady został ustalony. Oczekuj na kontakt naszego konsultanta ' +
                    'w ustalonej porze.'
            }


            if(komentarz.indexOf('Zamknięte')!==-1) {
                if (powodZamkniecia == 'Rozwiązane przez klienta') {
                    return 'Zgodnie z otrzymaną informacją sprawa została rozwiązana bez udziału naszych konsultantów'
                }
                if (powodZamkniecia =='Duplikat') {
                    return 'Twoje zgłoszenie zostało zamknięte, ponieważ ta sprawa jest prowadzona w innym zgłoszeniu.'
                }
                if(typ == 'Konsultacja') {
                    return 'Porada została udzielona. Pamiętaj, że zgodnie z łączącą nas umową masz 10 dni roboczych ' +
                        'na zgłoszenie reklamacji, jeśli uważasz, że porada nie została zrealizowana poprawnie.'
                }
                if(typ == 'Propozycja rozwoju') {
                    if (powodZamkniecia == 'Zakończone') {
                        return 'Praca nad zgłoszeniem została zakończona, zgodnie z ustaleniami zmiana nie będzie realizowana.'
                    }
                    if (powodZamkniecia == 'Przeanalizowane') {
                        return;
                    }
                    return 'Twoje zgłoszenie zostało zrealizowane – nowa funkcjonalność jest dostępna w następnej wersji ' +
                        'oprogramowania. Zachęcamy do wykonania aktualizacji i skorzystania z nowych możliwości ' +
                        'w momencie ich udostępnienia!'
                }
                if(typ == 'Problem') {
                    return 'Twoje zgłoszenie zostało zrealizowane. Pamiętaj, że zgodnie z łączącą nas umową masz 10 dni ' +
                        'roboczych na zgłoszenie reklamacji, jeśli uważasz, że usługa nie została zrealizowana ' +
                        'poprawnie.'
                }

                if(typ == 'Zamówienie') {
                    return 'Zamówienie zostało zrealizowane. Pamiętaj, że zgodnie z łączącą nas umową masz 10 dni ' +
                        'roboczych na zgłoszenie reklamacji, jeśli uważasz, że usługa nie została ' +
                        'zrealizowana poprawnie.'
                }
            }

            if(komentarz.indexOf('W trakcie analizy')!==-1) {
                return 'Twoje zgłoszenie zostało przekazane do analizy. Przyjęta przed kilkoma laty procedura analizy ' +
                    'zgłoszeń składa się z kilku etapów, zatem zgłoszenie może mieć ten status przez dłuższy czas. ' +
                    'Dopiero po zakończeniu analizy zostanie on zmieniony.'
            }

            if(komentarz.indexOf('Zaakceptowane')!==-1) {
                return 'Analiza Twojego zgłoszenia została zakończona. Zostało ono przekazane do Działu Produkcji i ' +
                    'do zadań oczekujących na realizację. Z uwagi na wieloetapowy cykl produkcji nowych wersji ' +
                    'oprogramowania oraz na zróżnicowane zapisy łączących nas z Klientami umów termin realizacji na ' +
                    'tym etapie nie jest możliwy do precyzyjnego określenia. Zmiana statusu nastąpi dopiero po ' +
                    'zakończeniu prac nad wprowadzeniem tej zmiany do nowych wersji.'
            }

            if(komentarz.indexOf('Odłożone')!==-1) {
                return 'Twoje zgłoszenie zostało poddane wnikliwej analizie przez naszych specjalistów w celu określenia ' +
                    'możliwości włączenia proponowanego rozwiązania do naszych systemów. ' +
                    'Z przykrością informujemy, że zgłoszenie nie zostało zakwalifikowane do realizacji produkcyjnej ' +
                    'dla najbliższej aktualizacji i trafi do grupy propozycji rozwoju, jakie poddawać będziemy ' +
                    'ponownej analizie przy kolejnych aktualizacjach.'
            }

            if(komentarz.indexOf('W trakcie analizy')!==-1) {
                return 'Twoje zgłoszenie zostało zarejestrowane i oczekuje na zakończenie analizy.'
            }
            if(komentarz.indexOf('Oczekuje na realizację')!==-1) {
                return 'Twoje zgłoszenie po zakończonej diagnostyce zostało przekazane do poprawy. ' +
                    'Zostaniesz poinformowany o rozwiązaniu bezpośrednio po zakończeniu prac ' +
                    'nad Twoim zgłoszeniem.'
            }

            if(komentarz.indexOf('Zmieniona kategoria')!==-1) {
                return 'Twoje zgłoszenie zostało poddane wnikliwej analizie, która wykazała, że nie spełnia ono ' +
                    'kryteriów opisanych w Warunkach Gwarancji i nie może zostać uznane za błąd. ' +
                    'O szczegółach opowie Ci bezpośrednio nasz konsultant.'
            }

        }




        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .factory('smallSliderImageChanger',smallSliderImageChanger);

    function smallSliderImageChanger($rootScope) {
        var vm = this;
        vm.smallSliderImage = ["0", "200", "400"];
        vm.style = '0px 400px';
        return {
            changeImage: function () {
                vm.style = '0px ' + vm.smallSliderImage[Math.round(Math.random() * 3)] + 'px';
                $rootScope.$broadcast("updateSmallSliderImage");
            },
            getStyle: function () {
                return vm.style;
            }
        }
    }
})();

(function () {
  "use strict";

  angular.module("strefaKlienta").factory("security", security);

  security.$inject = [
    "store",
    "$rootScope",
    "jwtHelper",
    "$state",
    "$q",
    "$window",
    "$http",
    "lokalizacjaAPI",
  ];

  /* @ngInject */
  function security(
    store,
    $rootScope,
    jwtHelper,
    $state,
    $q,
    $window,
    $http,
    lokalizacjaAPI
  ) {
    var odswiezamToken = false,
      jwt_token = null,
      czasOdswiezenia = 15,
      tokenZweryfikowany = false;

    var service = {
      isLogin: isLogin,
      logout: logout,
      login: login,
      getTypUsr: getTypUsr,
      getIdPrac: getIdPrac,
      getIdUsr: getIdUsr,
      getIdSubUser: getIdSubUser,
      jestSubUserem: jestSubUserem,
      jestPracownikiemMieszczanin: jestPracownikiemMieszczanin,
      jestDostepDoDanychKlienta: jestDostepDoDanychKlienta,
      sprawdzCzyOdswiezycToken: sprawdzCzyOdswiezycToken,
      getToken: getToken,
      relogExt: relogExt,
      loginToken: loginToken,
      zalogowanyJakoPracownikMieszczanin: zalogowanyJakoPracownikMieszczanin
    };

    function login(
      uzytkownik,
      haslo,
      wyswietlBlad,
      stan,
      stateparams,
      urlParams
    ) {
      if (urlParams == null || Object.keys(urlParams).length == 0) {
        $http({
          url: lokalizacjaAPI + "/api-token-auth/",
          method: "POST",
          timeout: 15000,
          data: {
            username: uzytkownik,
            password: haslo,
          },
        })
          .success(function (response) {
            store.set("jwt", response.token);
            $state.go(stan, stateparams);
            $rootScope.$emit("login");

          })
          .error(function (data, status, headers, config, statusText) {
            if (
              status === 0 ||
              status === 500 ||
              status === 502 ||
              status === 404 ||
              status === -1
            ) {
              wyswietlBlad(
                "Wystąpił błąd komunikacji z serwerem. Prosimy spróbować później."
              );
            } else {
              wyswietlBlad("Niewłaściwy użytkownik lub hasło.");
            }
          });
      } else {
        try {
          if (angular.isDefined(urlParams.token) == true) {
            if (urlParams.token.split(".").length == 3) {
              store.set("jwt", urlParams.token);
              $state.go(stan, stateparams);
              $rootScope.$emit("login");
            }
          }
        } catch (err) {
          $rootScope.$emit("logout");
          store.remove("jwt");
        } finally {
        }
      }
    }

    function isLogin() {
      if (!tokenZweryfikowany && store.get("jwt")) {
        verifyToken(store.get("jwt"))
          .success(function (data) {
            tokenZweryfikowany = true;
          })
          .error(function (error) {
            logout();
            tokenZweryfikowany = true;
          });
      }
      return store.get("jwt") && !jwtHelper.isTokenExpired(store.get("jwt"));
    }

    function logout() {
      $state.go("home.stronaGlowna");
      $rootScope.$emit("logout");
      store.remove("jwt");
    }

    function relogExt(id_pod, token) {
      $rootScope.$emit("logout");
      store.remove("jwt");
      $state.go("extlogin", { user: id_pod, token: token });
    }

    function getToken() {
      return store.get("jwt");
    }

    function sprawdzCzyOdswiezycToken() {
      //zabezpieczenie potrzebne bo inaczej, gdy token trzeba było odświeżyć rzucał same OPTIONS
      if (!odswiezamToken) {
        odswiezamToken = true;
        jwt_token = store.get("jwt");
        if (jwt_token) {
          var ms = jwtHelper.getTokenExpirationDate(jwt_token);
          var diff = Math.round(
            (((ms - new Date()) % 86400000) % 3600000) / 60000
          ); //roznica czasu w minutach
          if (diff < czasOdswiezenia) {
            $http({
              url: lokalizacjaAPI + "/api-token-refresh/",
              method: "POST",
              timeout: 10000,
              data: {
                token: jwt_token,
              },
            })
              .success(function (data) {
                store.set("jwt", data.token);
                jwt_token = data.token;
                odswiezamToken = false;
              })
              .error(function (error) {
                logout();
                odswiezamToken = false;
              });
          } else {
            odswiezamToken = false;
          }
        } else {
          odswiezamToken = false;
        }
      }
    }

    function getIdPrac() {
      var decodeToken = jwtHelper.decodeToken(store.get("jwt"));
      var info = decodeToken.username.split("_");
      if (info && parseInt(info[0]) == 3) {
        return info[2];
      }
    }

    function getIdUsr() {
      var decodeToken = jwtHelper.decodeToken(store.get("jwt"));
      var info = decodeToken.username.split("_");
      return info[1];
    }

    function getIdSubUser() {
      var decodeToken = jwtHelper.decodeToken(store.get("jwt"));
      var info = decodeToken.username.split("_");
      if (info && parseInt(info[0]) == 3) {
        return info[3];
      }
    }

    function jestSubUserem() {
      if (isLogin()) {
        var typ = getTypUsr();
        return typ == 3;
      }
    }

    function getTypUsr() {
      //Typ - 1-uzytkownik, 2-uzytkownik czasowy, 3-pracownik zarzadcy, 5-pracownik Mieszczanin, 6- tymczasowy dostęp do danych dla pracownika Mieszczanin
      var decodeToken = jwtHelper.decodeToken(store.get("jwt"));
      var info = decodeToken.username.split("_");
      if (info && parseInt(info[0]) > 0) {
        return info[0];
      }
    }

    function jestPracownikiemMieszczanin() {
      if (isLogin() == true) {
        var typ = getTypUsr();
        return typ == 5 || typ == 6;
      }
    }

    function zalogowanyJakoPracownikMieszczanin() {
      if (isLogin() == true) {
        var typ = getTypUsr();
        return typ == 5;
      }
    }

    function jestDostepDoDanychKlienta() {
      if (isLogin() == true) {
        var typ = getTypUsr();
        return typ == 1 || typ == 2 || typ == 3 || typ == 6;
      }
    }

    function verifyToken(token) {
      return $http({
        url: lokalizacjaAPI + "/api-token-verify/",
        method: "POST",
        timeout: 10000,
        data: {
          token: token,
        },
      });
    }

    function loginToken(token, stan, stateParams) {
      return verifyToken(token)
        .success(function (data) {
          jwt_token = data.token;
          tokenZweryfikowany = true;
          store.set("jwt", data.token);
          if (stan) {
            $state.go(stan, stateParams);
          }
          $rootScope.$emit("login");
        })
        .error(function (error) {
          logout();
          tokenZweryfikowany = true;
        });
    }

    return service;
  }
})();

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .factory('scrollState',smallSliderImageChanger);

    function smallSliderImageChanger($rootScope) {
        var vm = this;
        vm.scrolled = false;
        return {
            scrolledDown: function () {
                vm.scrolled = true;
                $rootScope.$broadcast("scrollState");
            },
            scrolledUp: function () {
                vm.scrolled = false;
                $rootScope.$broadcast("scrollState");
            },
            getState: function () {
                return vm.scrolled;
            }
        }
    }
})();

(function () {

    'use strict';

    angular.module('strefaKlienta').factory('potencjalnyKlient', potencjalnyKlient);

    potencjalnyKlient.$inject = ['Restangular', 'security', 'store', '$q'];

    /* @ngInject */
    function potencjalnyKlient(Restangular, security, store, $q) {
        var service = {
            login: login,
            dajZgloszenie: dajZgloszenie,
            dajKomentarzeZgloszenia: dajKomentarzeZgloszenia,
            dajPlikiZgloszenia: dajPlikiZgloszenia,
            dajOferty: dajOferty,
            zaakceptujOferte: zaakceptujOferte,
            odrzucOferte: odrzucOferte,
            poprosONowyToken: poprosONowyToken,
            dajInformacjeOKliencie: dajInformacjeOKliencie,
            uzupelnijInformacjeOKliencie: uzupelnijInformacjeOKliencie,
        };

        function login(tokenLink, tokenAccess) {
            return Restangular.all('/potKli/token/login/').post({
                tokenLink: tokenLink,
                tokenAccess: tokenAccess
            }).then(function (result) {
                console.log(result);
                if (result.token_access !== undefined && result.token_access !== null) {
                    store.set(tokenLink, result.token_access);
                }
                return result;
            }, function (error) {
                return $q.reject(error);
            });
        }

        function dajZgloszenie(tokenLink) {
            return Restangular.all('/potKli/zgloszenie/').getList({
                tokenLink: tokenLink,
                tokenAccess: store.get(tokenLink)
            }).then(function (result) {
                return result[0];
            });
        }

        function dajKomentarzeZgloszenia(tokenLink) {
            return Restangular.all('/potKli/zgloszenieKomentarze/').getList({
                tokenLink: tokenLink,
                tokenAccess: store.get(tokenLink)
            });
        }

        function dajPlikiZgloszenia(tokenLink) {
            return Restangular.all('/potKli/zgloszeniePliki/').getList({
                tokenLink: tokenLink,
                tokenAccess: store.get(tokenLink)
            });
        }

        function dajOferty(tokenLink) {
            return Restangular.all('/potKli/oferty/').getList({
                tokenLink: tokenLink,
                tokenAccess: store.get(tokenLink)
            });
        }

        function zaakceptujOferte(tokenLink, idOferty) {
            return Restangular.one('/potKli/oferty/' + idOferty + '/zaakceptuj').customPOST(
                {
                    tokenLink: tokenLink,
                    tokenAccess: store.get(tokenLink)
                }).then(
                function (res) {
                    return res;
                }
            );
        }

        function odrzucOferte(tokenLink, idOferty) {
            return Restangular.one('/potKli/oferty/' + idOferty + '/odrzuc').customPOST(
                {
                    tokenLink: tokenLink,
                    tokenAccess: store.get(tokenLink)
                }).then(
                function (res) {
                    return res;
                }
            );
        }

        function poprosONowyToken(tokenLink) {
            return Restangular.one('/potKli/zgloszenie/prosba_o_token').customPOST({tokenLink: tokenLink}).then(
                function (res) {
                    return res;
                }
            );
        }

        function dajInformacjeOKliencie(tokenLink) {
            return Restangular.all('/potKli/klientInfo/').getList({
                tokenLink: tokenLink,
                tokenAccess: store.get(tokenLink)
            });
        }

        function uzupelnijInformacjeOKliencie(tokenLink, informacje) {
            return Restangular.all('/potKli/klientInfo/uzupelnij').post(
                Object.assign(informacje, {
                    tokenLink: tokenLink,
                    tokenAccess: store.get(tokenLink)
                })
            );
        }


        return service;
    }
})();

/**
 * Created by dp on 15.09.16.
 */
(function () {

    'use strict';

    angular.module('strefaKlienta').factory('Popup', informacjePopup);

    informacjePopup.$inject = ['$uibModal', 'Restangular','anchorScrollSmooth'];

    /* @ngInject */
    function informacjePopup($uibModal, Restangular,anchorScrollSmooth, bootstrapKlasa) {

        var service = {
            wyswietlInfo: wyswietlInfo
        };

        function wyswietlInfo(tytul,tresc,acc,canc, params){
                var dane = [tytul,tresc];

                    return $uibModal.open({
                        templateUrl: 'app/services/popup.html',
                        controller: function ($uibModalInstance) {
                            var vm = this;
                            vm.dane = dane;
                            vm.params = params ? params : {};
                            vm.zamknij = zamknij;
                            vm.fun = acc;
                            vm.bootstrapKlasa = bootstrapKlasa;
                            vm.func=function(){
                                vm.fun();
                                $uibModalInstance.close();
                            };

                            function zamknij() {
                                if(canc!=null) {
                                    canc();
                                }
                                $uibModalInstance.close();
                                
                            }
                        },
                        controllerAs: 'vmModal',
                        size: 'lg'
                    });
        }

        return service;
    }
})();

angular.module('strefaKlienta')

    .factory('plikiOperacje', ['$http', 'lokalizacjaAPI', 'security', '$window', '$q',
        function ($http, lokalizacjaAPI, security, $window, $q) {
            String.prototype.endsWith = function (suffix) {
                return this.indexOf(suffix, this.length - suffix.length) !== -1;
            };
            var plikiOperacje = {
                ext2applicationType: ext2applicationType,
                plik2ikona: function (nazwa) {
                    nazwa = angular.lowercase(nazwa);
                    if (nazwa) {
                        if (nazwa.endsWith('.png') || nazwa.endsWith('.jpg') || nazwa.endsWith('.bmp') || nazwa.endsWith('.jpeg') || nazwa.endsWith('.gif')) {
                            return "icon_img";
                        }
                        if (nazwa.endsWith('.doc') || nazwa.endsWith('.docx')) {
                            return "icon_doc";
                        }
                        if (nazwa.endsWith('.xls') || nazwa.endsWith('.xlsx')) {
                            return "icon_xls";
                        }
                        if (nazwa.endsWith('.pdf')) {
                            return "icon_pdf";
                        }
                        if (nazwa.endsWith('.txt')) {
                            return "icon_txt";
                        }
                        if (nazwa.endsWith('.zip')) {
                            return "icon_zip";
                        }
                        if (nazwa.endsWith('.pps') || nazwa.endsWith('.ppt') || nazwa.endsWith('.ppsx') || nazwa.endsWith('.pptx')) {
                            return "icon_pps";
                        }
                    }
                },
                pobierzPlik: function (nazwaAPI, id_dok, metoda) {
                    var url = lokalizacjaAPI + nazwaAPI + id_dok + metoda + '?jwt=' + security.getToken();
                    return url;
                },
                pobierzZwyklyPlik: function (nazwaAPI, id_dok, id_zal, nazwa, sciezka) {
                    var url = lokalizacjaAPI + '/' + nazwaAPI + id_dok + '/' + id_zal + '/?jwt=' + security.getToken();
                    return url;
                },
                przejdzDoLinku: function (link) {
                    $window.open(link, '_blank');
                }
            };

            return plikiOperacje;


            function ext2applicationType(ext) {
                var nazwa = angular.lowercase(ext);
                var type = "text/html";
                switch (nazwa) {
                    case 'pdf':
                        type = "application/pdf";
                        break;
                    case 'doc':
                        type = "application/msword";
                        break;
                    case 'docx':
                        type = "application/msword";
                        break;
                    case 'xls':
                        type = "application/vnd.ms-excel";
                        break;
                    case 'xlsx':
                        type = "application/vnd.ms-excel";
                        break;
                    case 'ppt':
                        type = "application/vnd.ms-powerpoint";
                        break;
                    case 'zip':
                        type = "application/zip";
                        break;
                    case 'rar':
                        type = "application/x-rar-compressed";
                        break;
                    case '7z':
                        type = "application/x-7z-compressed";
                        break;
                    case 'bmp':
                        type = "image/x-ms-bmp";
                        break;
                    case 'jpg':
                        type = "image/jpeg";
                        break;
                    case 'jpeg':
                        type = "image/jpeg";
                        break;
                    case 'png':
                        type = "image/png";
                        break;
                    case 'gif':
                        type = "image/gif";
                        break;
                    case 'odt':
                        type = "application/vnd.oasis.opendocument.text";
                        break;
                    case 'ods':
                        type = "application/vnd.oasis.opendocument.spreadsheet";
                        break;
                }
                return type;
            }
        }]);
(function () {

  'use strict';

  angular.module('strefaKlienta').factory('plikiFirmowe', plikiFirmowe);

  plikiFirmowe.$inject = [];

  /* @ngInject */
  function plikiFirmowe() {

    var service = {
      coNowego: coNowego,
      dokumentacja: dokumentacja,
      formularze: formularze,
      informacjeDedykowane: informacjeDedykowane,
      regulaminy: regulaminy,
      programy: programy
    };

    return service;

    function programy(){
      var programyLista = [
        {
          nazwa: 'System Łatwej Obsługi Nieruchomości',
          klasa: 'icon letter-n lefticon',
          skrot: 'slonie',
          id: 1,
          kod: 'WSM',
        },
        {
          nazwa: 'e-kartoteka',
          klasa: 'icon-ek',
          skrot: 'ekartoteka',
          id: 2,
          kod: 'E-KARTOTEKA',
        },
        {
          nazwa: 'Kasa',
          klasa: 'icon letter-k lefticon',
          skrot: 'kasa',
          id: 3,
          kod: 'KAS',
        },
        {
          nazwa: 'Magazyn',
          klasa: 'icon letter-m lefticon',
          skrot: 'magazyn',
          id: 4,
          kod: 'MAG',
        },
        {
          nazwa: 'Środki trwałe',
          klasa: 'icon letter-s lefticon',
          skrot: 'srodki_trwale',
          id: 5,
          kod: 'SRT',
        },
        {
          nazwa: 'Obsługa techniczna',
          klasa: 'icon letter-t lefticon',
          skrot: 'ton',
          id: 6,
          kod: 'ZNI',
        },
        {
          nazwa: 'Banki - płatności masowe',
          klasa: 'icon letter-b lefticon',
          skrot: 'banki',
          id: 7,
          kod: 'BAN',
        },
        {
          nazwa: 'Nieruchomości - członkowie - wkłady',
          klasa: 'icon letter-w lefticon',
          skrot: 'wklady',
          id: 8,
          kod: 'WKL'
        },
        {
          nazwa: 'Kadry i płace',
          klasa: 'icon letter-p lefticon',
          skrot: 'kip',
          id: 9,
          kod: 'KIP',
        },
        {
          nazwa: 'Zarządzanie obiegiem dokumentów',
          klasa: 'icon letter-d lefticon',
          skrot: 'zod',
          id: 10,
          kod: 'ZWO',
        },
        {
          nazwa: 'Fakturowanie sprzedaży',
          klasa: 'icon letter-v lefticon',
          skrot: 'fakturowanie_sprzedazy',
          id: 11,
          kod: 'FAK',
        },
        {
          nazwa: 'Finanse i księgowość',
          klasa: 'icon letter-f lefticon',
          skrot: 'fk',
          id: 12,
          kod: 'FIK',
        }
      ];
      return programyLista;
    }

    function regulaminy(string){
      var sciezka = '../assets/files/regulaminy/';
      switch(string){
        case 'ogolne warunki sprzedazy':
          sciezka += 'Ogolne%20warunki%20sprzedazy.pdf';
          break;
        case 'warunki gwarancji':
          sciezka += 'Warunki%20gwarancji.pdf';
          break;
        case 'regulamin stalej aktualizacji':
          sciezka += 'Regulamin%20stalej%20aktualizacji%20oprogramowania.pdf';
          break;
        case 'regulamin e-kartoteki':
          sciezka = '../assets/files/dokumentacja/e-kartoteka/Regulamin%20e-kartoteka.pdf';
          break;
        case 'informacja o usludze sms':
          sciezka += 'Informacje%20o%20usludze%20sms.pdf';
          break;
        case 'regulamin uslugi sms':
          sciezka += 'Regulamin%20uslugi%20sms.pdf';
          break;
      }
      return sciezka;
    }

    function coNowego(string){
      var sciezka = '../assets/files/dokumentacja/';
      switch(string){
        case 'slonie':
          sciezka += 'slonie/Co nowego - SLONie.pdf';
          break;
        case 'ekartoteka':
          sciezka += 'e-kartoteka/Co nowego - e-kartoteka.pdf';
          break;
        case 'kasa':
          sciezka += 'kasa/Co nowego - Kasa.pdf';
          break;
        case 'magazyn':
          sciezka += 'magazyn/Co nowego - Magazyn.pdf';
          break;
        case 'srodki_trwale':
          sciezka += 'srodkitrwale/Co nowego - Srodki Trwale.pdf';
          break;
        case 'ton':
          sciezka += 'ton/Co nowego - TON.pdf';
          break;
        case 'banki':
          sciezka += 'banki/Co nowego - Banki.pdf';
          break;
        case 'wklady':
          sciezka += 'wklady/Co nowego - NCzW.pdf';
          break;
        case 'kip':
          sciezka += 'kip/Co nowego - KiP.pdf';
          break;
        case 'zod':
          sciezka += 'zod/Co nowego - ZOD.pdf';
          break;
        case 'fakturowanie_sprzedazy':
          sciezka += 'sprzedaz/Co nowego - Fakturowanie Sprzedazy.pdf';
          break;
        case 'fk':
          sciezka += 'fk/Co nowego - FiK.pdf';
          break;
      }
      return sciezka;
    }

    function dokumentacja(string){
      var sciezka = '../assets/files/dokumentacja/';
      var sciezkaprefix = '';
      var lista = [];
      switch(string){
        case 'slonie':
          sciezkaprefix = sciezka + 'slonie/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - SLONie.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Kreator ustawień początkowych',
              sciezka: sciezkaprefix + 'Kreator ustawien poczatkowych - SLONie.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - SLONie.pdf'
            },
            {
              nazwa: 'Przewodnik',
              sciezka: sciezkaprefix + 'SLONie - przewodnik krok po kroku.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - SLONie.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i Odpowiedzi - SLONie.pdf'
            },
            {
              nazwa: 'Migracja danych',
              sciezka: sciezkaprefix + 'Migracja_danych-WsmImport.pdf'
            }
          ];
          break;
        case 'ekartoteka':
          sciezkaprefix = sciezka + 'e-kartoteka/';
          lista = [
            {
              nazwa: 'Regulamin',
              sciezka: sciezkaprefix + 'Regulamin e-kartoteka.pdf'
            },
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - e-kartoteka.pdf'
            },
            //{
            //  nazwa: 'Wymagania sprzętowe',
            //  sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            //},
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - e-kartoteka.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - e-kartoteka.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'PiO-ekartoteka.pdf'
            }
          ];
          break;
        case 'kasa':
          sciezkaprefix = sciezka + 'kasa/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - Kasa.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - Kasa.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - Kasa.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i Odpowiedzi - Kasa.pdf'
            }
          ];
          break;
        case 'magazyn':
          sciezkaprefix = sciezka + 'magazyn/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - Magazyn.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Kreator ustawień początkowych',
              sciezka: sciezkaprefix + 'Kreator ustawien poczatkowych - Magazyn.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - Magazyn.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - Magazyn.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i Odpowiedzi - Magazyn.pdf'
            }
          ];
          break;
        case 'srodki_trwale':
          sciezkaprefix = sciezka + 'srodkitrwale/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - Srodki Trwale.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Kreator ustawień początkowych',
              sciezka: sciezkaprefix + 'Kreator ustawien poczatkowych - Srodki trwale.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - Srodki trwale.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - Srodki Trwale.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i odpowiedzi - Srodki trwale.pdf'
            }
          ];
          break;
        case 'ton':
          sciezkaprefix = sciezka + 'ton/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - TON.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Kreator ustawień początkowych',
              sciezka: sciezkaprefix + 'Kreator ustawien poczatkowych - TON.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - TON.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - TON.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i Odpowiedzi - TON.pdf'
            }
          ];
          break;
        case 'banki':
          sciezkaprefix = sciezka + 'banki/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - Banki.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - Banki.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - Banki.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i odpowiedzi - Banki.pdf'
            }
          ];
          break;
        case 'wklady':
          sciezkaprefix = sciezka + 'wklady/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - NCzW.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Kreator ustawień początkowych',
              sciezka: sciezkaprefix + 'Kreator ustawien poczatkowych - NCzW.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - NCzW.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - NCzW.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i Odpowiedzi - NCzW.pdf'
            }
          ];
          break;
        case 'kip':
          sciezkaprefix = sciezka + 'kip/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - KiP.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Kreator ustawień początkowych',
              sciezka: sciezkaprefix + 'Kreator ustawien poczatkowych - KiP.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - KiP.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - KiP.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i Odpowiedzi - KiP.pdf'
            }
          ];
          break;
        case 'zod':
          sciezkaprefix = sciezka + 'zod/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - ZOD.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Kreator ustawień początkowych',
              sciezka: sciezkaprefix + 'Kreator ustawien poczatkowych - ZOD.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - ZOD.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - ZOD.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i odpowiedzi - ZOD.pdf'
            }
          ];
          break;
        case 'fakturowanie_sprzedazy':
          sciezkaprefix = sciezka + 'sprzedaz/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - Fakturowanie Sprzedazy.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Kreator ustawień początkowych',
              sciezka: sciezkaprefix + 'Kreator ustawien poczatkowych - Fakturowanie Sprzedazy.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - Fakturowanie sprzedazy.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - Fakturowanie Sprzedazy.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i odpowiedzi - Fakturowanie Sprzedazy.pdf'
            }
          ];
          break;
        case 'fk':
          sciezkaprefix = sciezka + 'fk/';
          lista = [
            {
              nazwa: 'Co nowego',
              sciezka: sciezkaprefix + 'Co nowego - FiK.pdf'
            },
            {
              nazwa: 'Wymagania sprzętowe',
              sciezka: sciezka + 'Wymagania sprzetowe systemu firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi programu instalacyjnego',
              sciezka: sciezka + 'Instrukcja obslugi instalatora programow firmy Mieszczanin.pdf'
            },
            {
              nazwa: 'Klucz sprzętowy',
              sciezka: sciezka + 'Instrukcja instalacji klucza sprzetowego HASP.pdf'
            },
            {
              nazwa: 'Kreator ustawień początkowych',
              sciezka: sciezkaprefix + 'Kreator ustawien poczatkowych - FiK.pdf'
            },
            {
              nazwa: 'Instrukcja obsługi',
              sciezka: sciezkaprefix + 'Instrukcja obslugi - FiK.pdf'
            },
            {
              nazwa: 'Wykaz uprawnień',
              sciezka: sciezkaprefix + 'Wykaz uprawnien - FiK.pdf'
            },
            {
              nazwa: 'Pytania i Odpowiedzi',
              sciezka: sciezkaprefix + 'Pytania i odpowiedzi - FiK.pdf'
            }
          ];
          break;
      }
      return lista;
    }

    function informacjeDedykowane(){
      var sciezka = '../assets/files/dedykowane/';
      var lista = [
        {
          nazwa: 'Nowy wygląd okna Budynki i lokale w module SŁONie',
          id: 1,
          sciezka: sciezka + 'Nowy wyglad okna Budynki i lokale w module SLONie.wmv',
          komentarz: '',
          format: 'wmv'
        },        
        {
          nazwa: 'Wykaz zmian zestawień w module SŁONie w wersji 16.50',
          id: 2,
          sciezka: sciezka + 'Wykaz zmian zestawien w module SLONie w wersji 16.50.pdf',
          komentarz: ''
        },        
        {
          nazwa: 'Współwłaściciele lokalu w częściach ułamkowych',
          id: 3,
          sciezka: sciezka + 'Wspolwlasciele lokalu w czesciach ulamkowych.pdf',
          komentarz: ''
        },
        {
          nazwa: 'Informacje na temat systemu Windows XP',
          id: 4,
          sciezka: sciezka + 'Informacja na temat systemu Windows XP.pdf',
          komentarz: ''
        },
        {
          nazwa: 'Informacja o zmianie godzin wsparcia serwisowego i o nowym cenniku usług',
          id: 5,
          sciezka: sciezka + 'Informacja o zmianie godzin wsparcia serwisowego i o nowym cenniku uslug.pdf',
          komentarz: ''
        },
        {
          nazwa: 'Aktualizacja oprogramowania',
          id: 6,
          sciezka: sciezka + 'Aktualizacja oprogramowania.pdf',
          komentarz: 'Istrukcja instalacji aktualizacji'
        },
        {
          nazwa: 'Zmiana warunków licencji',
          id: 7,
          sciezka: sciezka + 'Zmiana warunkow licencji.pdf',
          komentarz: 'Instrukcja zmiany limitów'
        },
        {
          nazwa: 'Instalacja oprogramowania',
          id: 8,
          sciezka: sciezka + 'Instalacja oprogramowania.pdf',
          komentarz: 'Instrukcja instalacji'
        },
        {
          nazwa: 'Z demo do komercyjnej',
          id: 9,
          sciezka: sciezka + 'Z demo do komercyjnej.pdf',
          komentarz: 'Instrukcja rozszerzenia wersji demo do wersji komercyjnej'
        },
        {
          nazwa: 'Z jednostanowiskowej do sieciowej',
          id: 10,
          sciezka: sciezka + 'Zmiana wersji jednostanowiskowej na sieciowa.pdf',
          komentarz: 'Instrukcja zmiany wersji jednostanowiskowej na wersję sieciową'
        },
        {
          nazwa: 'Wyjaśnienie sposobu zmiany wskaźnika w programie Kadry i Płace',
          id: 11,
          sciezka: sciezka + 'Jak_zmienic_wartosc_wskaznika_w_programie_Kadry_i_Place.pdf',
          komentarz: 'Instrukcja zmiany obowiązującego procentu składek na ubezpieczenia ZUS dla pracodawców i pracowników.'
        },
        {
          nazwa: 'Arkusz SŁONie - badanie do VAT',
          id: 12,
          sciezka: sciezka + 'Badanie do VAT.ars',
          komentarz: 'Arkusz umożliwiający sprawdzenie, kiedy wspólnota przekroczy ustawowy limit zwalniający z VAT. \n\n' +
          'Uwaga- limit aktualny na dzień 1.09.2011r. \n\n' +
          'Aby wgrać plik należy uruchomić program SŁONie, wejść w Katalogi->definicje->bilans i ustawić się na arkuszach.Następnie z Menu Głównego proszę wybrać Arkusz - import i wskazać arkusz do wgrania',
          format: 'ars'
        },
        {
          nazwa: 'Arkusz SŁONie - badanie do VAT (szczegółowość dzienna)',
          id: 13,
          sciezka: sciezka + 'Badanie do VAT_szczegolowosc_dzienna.ars',
          komentarz: 'Arkusz umożliwiający sprawdzenie, kiedy wspólnota przekroczy ustawowy limit zwalniający z VAT. \n\n' +
          'Uwaga- limit aktualny na dzień 1.09.2011r. \n\n' +
          'Aby wgrać plik należy uruchomić program SŁONie, wejść w Katalogi->definicje->bilans i ustawić się na arkuszach.Następnie z Menu Głównego proszę wybrać Arkusz - import i wskazać arkusz do wgrania.',
          format: 'ars'
        }
      ];
      return lista;
    }

    function formularze(){
      var sciezka = '../assets/files/formularze/';
      var listaFormularzy = [
        {
          nazwa: 'Zamówienie programu komputerowego',
          id: 1,
          komentarz: 'Formularz zamówienia programu komputerowego',
          pliki: [
            {
              format: 'pdf',
              sciezka: sciezka + 'Zamowienie programu komputerowego.pdf'
            },
            {
              format: 'doc',
              sciezka: sciezka + 'Zamowienie programu komputerowego.doc'
            }
          ]
        },
        {
          nazwa: 'Zamówienie aktualizacji programu lub zmiany warunków licencji',
          id: 2,
          komentarz: 'Formularz zamówienia aktualizacji programu komputerowego lub zmiany warunków licencji',
          pliki: [
            {
              format: 'pdf',
              sciezka: sciezka + 'Zamowienie aktualizacji programu komputerowego.pdf'
            },
            {
              format: 'doc',
              sciezka: sciezka + 'Zamowienie aktualizacji programu komputerowego.doc'
            }
          ]
        },
        {
          nazwa: 'Zamówienie dostępu do usług serwisowych',
          id: 3,
          komentarz: 'Formularz zamówienia dostępu do opieki serwisowej oraz do serwisu na żądanie',
          pliki: [
            {
              format: 'pdf',
              sciezka: sciezka + 'Zamowienie dostepu do uslug serwisowych.pdf'
            },
            {
              format: 'doc',
              sciezka: sciezka + 'Zamowienie dostepu do uslug serwisowych.doc'
            }
          ]
        },
        {
          nazwa: 'Zamówienie usługi',
          id: 4,
          komentarz: 'Formularz zamówienia usługi',
          pliki: [
            {
              format: 'pdf',
              sciezka: sciezka + 'Zamowienie uslugi firmy Mieszczanin.pdf'
            },
            {
              format: 'doc',
              sciezka: sciezka + 'Zamowienie uslugi firmy Mieszczanin.doc'
            }
          ]
        },
        {
          nazwa: 'Zamówienie usługi sms',
          id: 5,
          komentarz: 'Formularz zamówienia usługi powiadamiania sms',
          pliki: [
            {
              format: 'pdf',
              sciezka: sciezka + 'Zamowienie usluga powiadomienia sms.pdf'
            },
            {
              format: 'doc',
              sciezka: sciezka + 'Zamowienie usluga powiadomienia sms.doc'
            }
          ]
        },
        {
          nazwa: 'Zgłoszenie reklamacji',
          id: 6,
          komentarz: 'Formularz zgłoszenia reklamacji',
          pliki: [
            {
              format: 'pdf',
              sciezka: sciezka + 'Zgloszenie reklamacji do firmy Mieszczanin.pdf'
            },
            {
              format: 'doc',
              sciezka: sciezka + 'Zgloszenie reklamacji do firmy Mieszczanin.doc'
            }
          ]
        }
      ];
      return listaFormularzy;
    }
  }
})();

(function () {
  'use strict';

  angular.module('strefaKlienta')
    .factory('mFunkcje', mFunkcje);

  /**
   * @param $location
   * @param $anchorScroll
   */
  function mFunkcje($location, $anchorScroll) {
    return {
      scrollToAnchor: scrollToAnchor
    };

    /**
     * @name mFunkcje#scrollToAnchor
     * @description Przejście do konkretnego miejsca na stronie.
     * @param {string} anchor
     * @param {Object} [_spec]
     */
    function scrollToAnchor(anchor, _spec) {
      var spec = Object.assign({yOffset: 0}, _spec)
      $location.hash(anchor);
      $anchorScroll.yOffset = spec.yOffset;
      $anchorScroll();
    }
  }
})();

(function () {

    'use strict';

    angular.module('strefaKlienta').factory('liczbaZgloszen', liczbaZgloszen);

    liczbaZgloszen.$inject = ['Restangular'];

    /* @ngInject */
    function liczbaZgloszen(Restangular) {
        var vm = this;
        vm.liczbaZgloszen = null;
        var service = {
            liczbaZgloszen: vm.liczbaZgloszen
        };

        return service;
    }
})();

/**
 * Created by dp on 15.09.16.
 */
(function () {

    'use strict';

    angular.module('strefaKlienta').factory('informacjePopup', informacjePopup);

    informacjePopup.$inject = ['$uibModal', 'Restangular'];

    /* @ngInject */
    function informacjePopup($uibModal, Restangular) {

        var service = {
            wyswietlInfo: wyswietlInfo
        };

        function wyswietlInfo(){

            return Restangular.all('popup/popup/').getList().then(function (result) {
                var dane = [],
                    dzisiaj = new Date();

                angular.forEach(result, function (val) {
                    if (new Date(val.data_start) <= dzisiaj && new Date(val.data_koniec) >= dzisiaj) {
                        dane.push(val);
                    }
                });

                if (dane.length !== 0) {
                    return $uibModal.open({
                        templateUrl: 'app/services/informacjePopup.html',
                        controller: function ($uibModalInstance) {
                            var vm = this;
                            vm.dane = dane;
                            vm.zamknij = zamknij;

                            function zamknij() {
                                vm.dane.splice(0, 1);
                                if (vm.dane.length === 0) {
                                    $uibModalInstance.close();
                                }
                            }
                        },
                        controllerAs: 'vmModal',
                        size: 'md'
                    });
                }
            });
        }

        return service;
    }
})();

/**
 * Created by dp on 15.09.16.
 */
(function () {

    'use strict';

    angular.module('strefaKlienta').factory('dostepDoBety', dostepDoBety);

    dostepDoBety.$inject = [ 'Restangular', 'uprawnieniaSubUsera', 'security', '$q'];

    /* @ngInject */
    function dostepDoBety(Restangular) {
        var dostep = true;
        var service = {
            setDostep: setDostep,
            info: info,
            reload: reload
        };

        function info() {
            return dostep;

        }
        function setDostep(d){
            dostep = d;
        }

        function reload() {
            // BLOKADA DOSTĘPU Z WYŁĄCZENIEM KILKU KLIENTÓW
            // return Restangular.all('zgloszenia/klienciZDostepem/kody/').getList().then(function(klienci) {
            //     return Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
            //         if (angular.isDefined(result[0])) {
            //             dostep = (klienci[0].Kody.indexOf(result[0].Kod.toString())!==-1);
            //         }
            //         return dostep;
            //     });
            // });
            return Restangular.all('konto/danepodstawowe/').getList().then(function() {
                return true;
            })

        }

        return service;
    }
})();

/**
 * @license AngularJS v1.2.0
 * (c) 2015 Lifely
 * License: MIT
 */

angular.module('strefaKlienta')

//
//  This service controls existing carousel instances
//
.factory('Carousel', function() {

    var Carousel = {};

    Carousel.instances = {};

    //
    // Add a new carousel instance
    //
    Carousel.add = function(slidesCount, name, scope, options) {

        // Check if name is specified
        name = name || false;
        if(!name) {
            return 'Error: no carousel name specified';
        }

        // Check slidesCount
        slidesCount = slidesCount || 0;

        // Check if carousel already exists
        var carouselExists = Carousel.instances[name] || false;
        if(carouselExists) {
            return 'Error: carousel instance already exists';
        }

        // Create carousel instance
        var instance = new constructor(slidesCount, scope, options);

        // Save new carousel instance
        Carousel.instances[name] = instance;

        return instance;
    };

    //
    // Get an existing carousel instance by name
    //
    Carousel.get = function(name) {
        var instance = Carousel.instances[name] || false;
        return instance ? instance : 'Error: carousel with name \'' + name + '\' does not exist';
    };

    //
    // Remove a carousel
    //
    Carousel.remove = function(name) {
        delete Carousel.instances[name];
    };

    //
    // Carousel prototype definition
    //
    var constructor = function(slidesCount, scope, options) {
        options = options || {};
        if (typeof options.looping === 'undefined') options.looping = true;

        var instance = this;

        this.slidesCount = slidesCount;
        this.currentSlide = 0;
        this.onSlideChangeCallbacks = [];

        // Operation: to specified index
        this.toIndex = function(index, wrapping) {
            wrapping = wrapping || false;
            this.currentSlide = index % this.slidesCount;

            // Own on slide change callbacks
            angular.forEach(this.onSlideChangeCallbacks, function(callback) {
                if(typeof(callback) === 'function') {
                    callback(instance.currentSlide, wrapping);
                }
            });

            // If the scope is not currently updating, trigger one update using a timeout of zero
            setTimeout(function() {
                scope.$apply();
            }, 0);
        };

        this.smartToIndex = function(index, wrapping) {

            if(this.currentSlide>(this.slidesCount)/2)
                wrapping ='right' || false;
            if(this.currentSlide<this.slidesCount/2)
                    wrapping = false;




            // Own on slide change callbacks
            if(this.currentSlide!=index) {
                this.currentSlide = index % this.slidesCount;
                angular.forEach(this.onSlideChangeCallbacks, function (callback) {
                    if (typeof(callback) === 'function') {
                        callback(instance.currentSlide, wrapping);
                    }
                });
            }
            // If the scope is not currently updating, trigger one update using a timeout of zero
            setTimeout(function() {
                scope.$apply();
            }, 0);
        };

        // Operation: to next slide
        this.next = function() {
            var nextSlide = this.currentSlide + 1,
                wrapping = false;

            if(nextSlide > this.slidesCount - 1) {
                if(options.looping){
                    nextSlide = 0;
                    wrapping = 'right';
                }
                else {
                    nextSlide = this.slidesCount - 1;
                }

            }

            this.toIndex(nextSlide, wrapping);
            return nextSlide;
        };

        // Operation: to previous slide
        this.previous = function() {
            var previousSlide = this.currentSlide - 1,
                wrapping = false;

            if(previousSlide < 0) {
                if(options.looping){
                    previousSlide = this.slidesCount - 1;
                    wrapping = 'left';
                }
                else {
                    previousSlide = 0;
                }

            }

            this.toIndex(previousSlide, wrapping);
            return previousSlide;
        };

        // Operation: on slide change
        this.onSlideChange = function(callback) {
            this.onSlideChangeCallbacks.push(callback);
            return this.onSlideChangeCallbacks.indexOf(callback);
        };

        // Operation: unbind on slide change callback
        this.unbindOnSlideChangeCallback = function(index) {
            if(typeof(this.onSlideChangeCallbacks[index]) === 'undefined') return;
            this.onSlideChangeCallbacks.splice(index, 1);
        };
    }

    return Carousel;

})

//
//  This directive makes an element with class 'ng-carousel' interactive
//  using own UI logic and HammerJS
//
.directive('ngCarousel', ['Carousel', '$compile', '$document', '$timeout', function(Carousel, $compile, $document, $timeout) {
    function isTouchDevice() {
        return 'ontouchstart' in document.documentElement;
    }

    var MOVE_TRESHOLD_PERCENTAGE = 25;

    function createEmptySlide(){
        return angular.element('<slide class="empty"></slide>');
    }

    return {
        restrict: 'AE',
        replace: true,
        scope: {
            ngCarouselWatch: '='
        },
        link: function(scope, element, attrs) {
            // Options
            var interval = false, timeoutPromise = false, random = false, name = '', looping = false;
            interval = typeof(attrs.ngCarouselTimer) !== 'undefined' && parseInt(attrs.ngCarouselTimer, 10) > 0 ? parseInt(attrs.ngCarouselTimer, 10) : false;
            random = typeof(attrs.ngCarouselRandom) !== 'undefined';
            looping = !(attrs.ngCarouselLoop === 'false');

            // Function to initialize interaction with dom (should be loaded after the dom has changed)
            var slides, currentCarousel, firstSlideCopy, lastSlideCopy, slideContainer, hammer, name;

            function copyFirstAndLastSlide() {
                firstSlideCopy = angular.element(slides[0].outerHTML);
                lastSlideCopy = angular.element(slides[slides.length - 1].outerHTML);
            }

            function makeFirstAndLastSlideEmpty() {
                firstSlideCopy = angular.element('<slide class="empty"></slide>');
                lastSlideCopy = angular.element('<slide class="empty"></slide>');
            }

            var refreshInteractionWithDom = function() {

                // Add initial classes
                element.addClass('ng-carousel');
                element.addClass(isTouchDevice() ? 'carousel-touch' : 'carousel-no-touch');

                // Find slide wrapper
                slideContainer = element.find('slidecontainer');

                // Remove old carousel
                var savedSlideIndex = false;
                var savedCallbacks = false;
                if(name) {
                    savedSlideIndex = Carousel.get(name).currentSlide;
                    savedCallbacks = Carousel.get(name).onSlideChangeCallbacks;
                    Carousel.remove(name);
                }

                // Remove old duplicated slides
                var removeOldVirtualSlides = function() {
                    var oldSlides = angular.element(element[0].querySelectorAll('.carousel-slide-copy'));
                    if(oldSlides.length > 0) oldSlides.remove();
                };

                // Find slides
                removeOldVirtualSlides();
                slides = element.find('slide');

                // Add slides before and after the current slides
                if(slides.length > 0) {

                    // Create new carousel and duplicate slides
                    name = attrs.ngCarouselName;
                    currentCarousel = Carousel.add(slides.length, attrs.ngCarouselName, scope, {
                        looping: looping
                    });
                    angular.forEach(savedCallbacks, function(savedCallback) {
                        currentCarousel.onSlideChange(savedCallback);
                        currentCarousel.unbindOnSlideChangeCallback(0);
                    });

                    // Duplicate first and last slide (for infinite effect)
                    var refreshVirtualSlides = function() {
                        removeOldVirtualSlides();
                        slides = element.find('slide');

                        if(looping) {
                            copyFirstAndLastSlide();
                        }
                        else {
                            makeFirstAndLastSlideEmpty();
                        }

                        firstSlideCopy.addClass('carousel-slide-copy');
                        lastSlideCopy.addClass('carousel-slide-copy');
                        slideContainer.append(firstSlideCopy);
                        slideContainer.prepend(lastSlideCopy);
                        slideContainer.addClass('carousel-ignore-first-slide');

                    };

                    refreshVirtualSlides();

                    // On slide change, move the slideContainer
                    var onSlideChangeCallback = function(slideIndex, wrapping) {
                        var newSlideIndex = slideIndex + 1; // because the first slide doesn't count

                        if(wrapping === 'left') {
                            newSlideIndex = 0; // first slide
                        } else if(wrapping === 'right') {
                            newSlideIndex = slides.length + 1; // last slide
                        }

                        move(newSlideIndex, true, function() {
                            if(wrapping === 'left') {
                                move(slides.length, false);
                            } else if(wrapping === 'right') {
                                move(1, false);
                            }
                        });

                        setNextSlideTimeout();
                        refreshVirtualSlides();
                    };
                    currentCarousel.onSlideChange(onSlideChangeCallback);

                    // If new slide was out of range, move to the new assigned one
                    if(savedSlideIndex !== false && currentCarousel.currentSlide !== savedSlideIndex) {
                        onSlideChangeCallback(currentCarousel.currentSlide, false);
                        currentCarousel.toIndex(savedSlideIndex);
                    }

                    // Option: random
                    if(random) {
                        var randomSlide = Math.floor(Math.random() * currentCarousel.slidesCount);
                        currentCarousel.toIndex(randomSlide);
                    }

                    // Option: interval
                    if (interval && currentCarousel.slidesCount >= 2) {
                        setNextSlideTimeout();
                    }
                } else {
                    console.log('ng-carousel error: No slides found')
                }

                // Initialize Hammer - nie działa
                // if(slideContainer[0]) {
                //     hammer = new Hammer.Manager(slideContainer[0]);
                //     hammer.add(new Hammer.Pan({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: 0 }));
                //
                //     // On pan left/right
                //     hammer.on("panleft panright", function(ev) {
                //         if(!ev.isFinal) carouselDrag(ev.deltaX);
                //     });
                // } else {
                //     console.log('ng-carousel error: No slidecontainer found')
                // }

            };

            // Reset interval function
            var setNextSlideTimeout = function() {
                if(!interval || currentCarousel.slidesCount < 2) return;
                if(timeoutPromise) $timeout.cancel(timeoutPromise);
                timeoutPromise = $timeout(function() {
                    currentCarousel.next();
                }, interval);
            };

            // UI move function
            var move = function(slideIndex, animate, transitionEndCallback) {
                if(animate) {
                    slideContainer.addClass('carousel-animate');
                } else {
                    slideContainer.removeClass('carousel-animate');
                }

                var rule = 'translate(-' + (100 * slideIndex) + '%, 0)';
                slideContainer.css({
                    '-webkit-transform': rule,
                       '-moz-transform': rule,
                        '-ms-transform': rule,
                         '-o-transform': rule,
                            'transform': rule
                });

                if(animate) {
                    slideContainer.on('transitionend oTransitionEnd webkitTransitionEnd', function() {
                        if(typeof transitionEndCallback === 'function') transitionEndCallback();
                        slideContainer.off('transitionend oTransitionEnd webkitTransitionEnd');
                        move(currentCarousel.currentSlide + 1, false);
                    });
                }
            };

            // Make the carousel draggable (either with touch or with mouse)
            var deltaXFactor = 0,
                width = 0;
            var carouselDrag = function(newDeltaX) {
                deltaXFactor = newDeltaX / width;
                deltaXFactor = deltaXFactor > 1 ? 1 : deltaXFactor < -1 ? -1 : deltaXFactor;
                move(currentCarousel.currentSlide + 1 - deltaXFactor, false);
            };
            var carouselPress = function() {
                width = slideContainer[0].offsetWidth;
            };
            var carouselRelease = function() {
                if(Math.abs(deltaXFactor) > MOVE_TRESHOLD_PERCENTAGE / 100) {
                    if(deltaXFactor > 0) {
                        currentCarousel.previous(); // user dragged right, go to previous slide
                    } else {
                        currentCarousel.next(); // user dragged left, go to next slide
                    }
                    deltaXFactor = 0;
                } else if(deltaXFactor > 0 || deltaXFactor < 0) {
                    move(currentCarousel.currentSlide + 1, true, function() {
                        deltaXFactor = 0;
                    });
                }
            };

            // On release
            var pressEvent = isTouchDevice() ? 'touchstart' : 'mousedown';
            var releaseEvent = isTouchDevice() ? 'touchend' : 'mouseup';
            $document.on(pressEvent, carouselPress);
            $document.on(releaseEvent, carouselRelease);

            //
            element.on('mouseover', function() {
                if(timeoutPromise) $timeout.cancel(timeoutPromise);
            });
            element.on('mouseout', setNextSlideTimeout);

            // Events to refresh the dom selectors
            var refreshInteractionWithDomTimer = $timeout(refreshInteractionWithDom, 0);
            if(typeof(attrs.ngCarouselWatch) !== 'undefined') {
                scope.$watch('ngCarouselWatch', function() {

                    // Wait for angular compile to complete
                    $timeout(refreshInteractionWithDom);

                }, true);
            }

            // Destroy all binded events on scope destroy
            scope.$on('$destroy', function() {
                $timeout.cancel(refreshInteractionWithDomTimer);
                element.off('mouseover mouseout');
                $document.off(pressEvent);
                $document.off(releaseEvent);
                slideContainer.off('transitionend oTransitionEnd webkitTransitionEnd');
                currentCarousel.onSlideChangeCallbacks = [];
                Carousel.remove(name);
            });

        }
    };
}]);

(function() {
    'use strict';

    angular
        .module('strefaKlienta')
        .service('anchorScrollSmooth',anchorScrollSmoothService);
    
    function anchorScrollSmoothService(){
        var sc = this;
        sc.scrollToTop = function() {

            var start = currentYPosition();
            var stop = 0;
            var timer = 0;
            var distance = stop > start ? stop - start : start - stop;
            if (distance < 100) {
                scrollTo(0, stop);
            }
            var speed = Math.round(distance / 100);
            if (speed >= 20) speed = 20;
            var step = Math.round(distance / 30);
            var leapY = stop > start ? start + step : start - step;

            for ( var i=start; i>stop; i-=step ) {
                setTimeout("window.scrollTo(0, "+leapY+")", timer * speed);
                leapY -= step; if (leapY < stop) leapY = stop; timer++;
            }

            function currentYPosition() {
                // Firefox, Chrome, Opera, Safari
                if (self.pageYOffset) return self.pageYOffset;
                // IE
                if (document.body.scrollTop) return document.body.scrollTop;
                return 0;
            }

            function elementPosition(id) {
                var element = document.getElementById(id);
                var y = element.offsetTop;
                var node = element;
                while (node.offsetParent && node.offsetParent != document.body) {
                    node = node.offsetParent;
                    y += node.offsetTop;
                } return y;
            }
        }
    }
})();

/**
 * Created by dp on 15.09.16.
 */
(function () {

    'use strict';

    angular.module('strefaKlienta').factory('DaneKonta', DaneKonta);

    DaneKonta.$inject = ['Restangular', '$q'];

    /* @ngInject */
    function DaneKonta(Restangular, $q) {
        var vm = this;
        vm.dane = null;

        vm.deferred = $q.defer();
        var service = {
            get: get
        };

        function get() {
                Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                    if (angular.isDefined(result[0])) {
                        vm.dane = result[0];
                        vm.deferred.resolve(vm.dane);
                    }
                });
            return vm.deferred.promise;
        }

        return service;
    }
})();

(function () {
  "use strict";
  angular
    .module("strefaKlienta")
    .factory("regulaminyResource", regulaminyResource);

  /** @ngInject */
  function regulaminyResource(Restangular, $http, lokalizacjaAPI, $timeout) {
    var resource = {
      pobierzZaakceptowane: pobierzZaakceptowane,
      dajRegulaminyDict: dajRegulaminyDict,
      pobierzRegulamin: pobierzRegulamin,
      pobierzPlikPoSlugu: pobierzPlikPoSlugu,
    };
    /**
     * @name RegulaminyResource#pobierzZaakceptowane
     * @return {Array[Regulamin]}
     */
    function pobierzZaakceptowane() {
      return Restangular.all("regulaminy/akceptacja/").getList();
    }

    /**
     * @name RegulaminyResource#dajRegulaminyDict
     */
    function dajRegulaminyDict() {
      return {
        REGULAMIN_E_KARTOTEKI: {
          nazwa: "Regulamin e-kartoteki",
          slug: "regulamin-e-kartoteki",
        },
        REGULAMIN_SYSTEMU_E_MIESZCZANIN: {
          nazwa: "Regulamin systemu e-Mieszczanin",
          slug: "regulamin-e-mieszczanina",
        },
        REGULAMIN_USLUG_ZINTEGROWANYCH: {
          nazwa: "Regulamin usług zintegrowanych",
          slug: "regulamin-uslug-zintegrowanych",
        },
      };
    }

    function pobierzRegulamin(id) {
      pobierzPlikPoSlugu(dajRegulaminyDict()[id].slug);
    }

    function pobierzPlikPoSlugu(slug) {
      Restangular.all("/zarzadzaniePlikami/zarzadzaniePlikami")
        .getList({ slug: slug })
        .then(function (plik) {
          if (plik.length > 0) {
            $http({
              method: "GET",
              url:
                lokalizacjaAPI +
                "/zarzadzaniePlikami/plik/" +
                slug +
                "/pobierz/",
              responseType: "blob",
            }).success(function (result) {
              var blob = new Blob([result], { type: "application/pdf" });
              var url = URL.createObjectURL(blob);
              window.open(url, '_blank');
              $timeout(function() {
              window.URL.revokeObjectURL(url);
              }, 5000)
            });
          }
        });
    }
    return resource;
  }
})();

(function () {

    'use strict';
    angular.module('strefaKlienta').factory('PowiadomieniaResource', PowiadomieniaResource);

    /** @ngInject */
    function PowiadomieniaResource(Restangular) {

        var resource = {
            pobierzPowiadomienia: pobierzPowiadomienia,
            dodajPowiadomienie: dodajPowiadomienie,
            usunPowiadomienie: usunPowiadomienie,
        };


        function pobierzPowiadomienia(requestParams) {
            return Restangular.all('/powiadomienia/wiadomosci/').getList(requestParams).then(
                function (result) {
                    return result;
                }
            );
        }

        function dodajPowiadomienie(requestParams) {
            return Restangular.all('/powiadomienia/wiadomosci/').post(requestParams).then(function (result) {
                return result;
            });
        }

        function usunPowiadomienie(id) {
            return Restangular.all('/powiadomienia/wiadomosci/').customDELETE(id);
        }

        return resource;
    }
})();

(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .controller('SubMainController', SubMainController);

    /** @ngInject */
    function SubMainController(dostep) {
        var vm = this;
        vm.dostep = dostep;
    }


})();
(function () {
  "use strict";

  angular.module("strefaKlienta").controller("MainController", MainController);

  /** @ngInject */
  function MainController(
    $state,
    Restangular,
    security,
    informacjePopup,
    $rootScope,
    $uibModal,
    scrollState,
    anchorScrollSmooth,
    smallSliderImageChanger,
    uprawnieniaSubUsera,
    dostepDoBety,
    wersjaStrony,
    bootstrapKlasa,
    $interval
  ) {
    var vm = this;
    vm.rozwiazania = false;
    vm.bootstrapKlasa = bootstrapKlasa;
    vm.logged = security.isLogin();
    vm.scrolled = scrollState.getState();
    vm.style = smallSliderImageChanger.getStyle();
    vm.state = $state;
    vm.security = security;
    vm.danePodstawowe = {};
    vm.naSkroty = false;
    vm.liczbaKlinetow = "1.000";
    vm.liczbaPracownikow = 54;
    vm.menustyle = "";
    vm.wersjaStrony = false;
    vm.init = init;
    vm.logout = function () {
      security.logout();
      vm.logged = false;
      $state.go("home.login");
    };

    init();

    function init() {
      updateSmallSlider();
      wersjaStrony.init();
      vm.sprawdzanieWersji = $interval(function () {
        vm.wersjaStrony = wersjaStrony.startPolling();
      }, 300000);
      odswierzDaneUzytkownika();
      informacjePopup.wyswietlInfo();
    }
    vm.goUp = function () {
      anchorScrollSmooth.scrollToTop();
    };

    vm.negujRozwiazania = function () {
      vm.rozwiazania = !vm.rozwiazania;
    };
    vm.rozwinRozwiazania = function () {
      vm.rozwiazania = true;
    };
    vm.zwinRozwiazania = function () {
      vm.rozwiazania = false;
    };

    function updateImageHere() {
      vm.style = smallSliderImageChanger.style;
    }

    vm.zglosSugestie = function () {
      var modalInstance = $uibModal.open({
        templateUrl: "feedbackModal.html",
        controller: "FeedbackModalCtrl",
        controllerAs: "vmFb",
        size: "md",
      });
      modalInstance.result.then(
        function (ok) {},
        function (anuluj) {}
      );
    };

    function odswierzDaneUzytkownika() {
      if (security.isLogin()) {
        if (security.jestPracownikiemMieszczanin()) {
          dajDanePracownika();
        } else if (security.jestSubUserem()) {
          dajDanePracownikaKlienta();
        } else {
          if (security.jestDostepDoDanychKlienta()) {
            dajDaneKlienta();
          }
        }
      }
    }

    function dajDanePracownika() {
      Restangular.all("/konto/danepracownika/")
        .getList()
        .then(function (result) {
          vm.danePodstawowe.Nazwa = result[0].Imie + " " + result[0].Nazwisko;
        });
    }
    function dajDanePracownikaKlienta() {
      uprawnieniaSubUsera.getInfo().then(function (result) {
        result = result;
        vm.danePodstawowe.Nazwa = result.imie + " " + result.nazwisko;
      });
    }
    function dajDaneKlienta() {
      Restangular.all("konto/danepodstawowe/")
        .getList()
        .then(
          function (result) {
            if (angular.isDefined(result[0])) {
              vm.danePodstawowe = result[0];
            }
          },
          function (error) {}
        );
    }

    function updateSmallSlider() {
      if (["home.subMain.mobilnaekartoteka", "home.subMain.cennikEKIEM"].indexOf($state.current.name) !== -1) {
        vm.style = "0px " + 200 + "px";
      } else if (["home.login","home.subMain.konto" ].indexOf($state.current.name) !== -1) {
        vm.style = "0px " + 800 + "px";
      } else if ($state.current.name.indexOf("home.subMain.zgloszenia") !== -1) {
        vm.style = "0px " + 600 + "px";
      } else {
        vm.style = smallSliderImageChanger.getStyle();
      }
    }

    $rootScope.$on("updateSmallSliderImage", function () {
      updateSmallSlider();

      vm.rozwiazania = false;
    });
    $rootScope.$on("scrollState", function () {
      vm.scrolled = scrollState.getState();
    });

    $rootScope.$on("login", function () {
      odswierzDaneUzytkownika();
      vm.logged = security.isLogin();
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("strefaKlienta")
    .controller("FeedbackModalCtrl", FeedbackModalCtrl);

  /** @ngInject */
  function FeedbackModalCtrl($uibModalInstance, bootstrapKlasa, Restangular) {
    var vm = this;

    vm.bootstrapKlasa = bootstrapKlasa;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.feedback = {
      typ: "S",
      tekst: "",
      ocena: -1,
    };
    vm.wyslijSugestie = wyslijSugestie;

    var feedbackApi = Restangular.all("feedback/oceny/");

    function ok() {
      $uibModalInstance.close("");
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }

    function wyslijSugestie() {
      var feed = {
        typ: vm.feedback.typ,
        tekst: vm.feedback.tekst,
        ocena: vm.feedback.ocena,
      };
      feedbackApi.post(feed).then(
        function () {
          ok();
        },
        function () {
          cancel();
        }
      );
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $state, security, $location,smallSliderImageChanger, anchorScrollSmooth) {

    $rootScope.$on('$stateChangeStart', function(e, toState, toParams) {
      if (toState.data && toState.data.requiresLogin) {
        if (!security.isLogin()) {
          // próba zalogowania za pomocą tokenu
          if (angular.isDefined($location.search().t) && $location.search().t !== 'null') {
            security.loginToken($location.search().t, toState, toParams);
          } else if (angular.isDefined($location.search().token) && $location.search().token !== 'null') {
            security.loginToken($location.search().token, toState, toParams);
          } else {
            e.preventDefault();
            $state.go('home.login', {nextState : toState.name, nextParams: toParams, urlParams:$location.search()});
          }
        }
      }
    });
    $rootScope.$on('$stateChangeSuccess',
        function(event, toState, toParams, fromState, fromParams, error){
          smallSliderImageChanger.changeImage();
          anchorScrollSmooth.scrollToTop();
        });
    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
      if (!security.isLogin() && $location.search().tokenpk !== null && $location.search().tokenpk !== undefined) {
        $state.go('home.pk.brakDostepu', {nextState: toState.name, nextParams:toParams, token: $location.search().tokenpk});
      } else if (!security.isLogin()) {
        $state.go('home.login', {nextState: toState.name, nextParams:toParams});
      } else {
       $state.go('home.subMain.konto');
      }
    });
  }

})();

(function () {
    'use strict';

    angular
        .module('strefaKlienta')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider

            .state('home', {
                url: '',
                abstract: true,
                templateUrl: 'app/main/main.html',
                controller: 'MainController',
                controllerAs: 'vmMain',
            })
            .state('home.subMain', {
                url: '?',
                abstract: true,
                templateUrl: 'app/main/subMain.html',
                controller: 'SubMainController',
                controllerAs: 'vmSubMain',
                data: {
                    requiresLogin: true
                },
                resolve: {
                    dostep: ['Restangular', 'dostepDoBety', '$q', function (Restangular, dostepDoBety, $q) {
                        return dostepDoBety.reload().then(
                            function (val) {
                                return val;
                            }
                        )
                    }],
                }

            })
            .state('home.login', {
                url: '/login',
                templateUrl: 'app/home/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vmLogin',
                params: {
                    nextState: null,
                    nextParams: null,
                    urlParams: null
                }

            })

            .state('home.subMain.baza', {
                url: '/baza',
                templateUrl: 'app/home/bazaWiedzy/bazaWiedzy.html',
                controller: 'BazaWiedzyController',
                controllerAs: 'vmBaza'
            })

            .state('home.stronaGlowna', {
                url: '/',
                templateUrl: 'app/home/stronaGlowna/stronaGlowna.html',
                controller: 'StronaGlownaController',
                controllerAs: 'vmStronaGl'
            })



            .state('home.subMain.cennikEKIEM', {
                url: '/ek-i-em',
                templateUrl: 'app/home/cennikEKIEM/cennik.html',
                controller: 'cennikEKIEMController',
                controllerAs: 'vmEKIEM',
                resolve: {
                    danePodstawowe: ['Restangular', function (Restangular) {
                       return Restangular.all('konto/danepodstawowe/').getList().then(function (result) {
                        return result[0];
                    });
                    }],
                    daneSubUsera: ['uprawnieniaSubUsera', '$q', 'security', function (uprawnieniaSubUsera, $q, security) {
                        if (security.jestSubUserem()) {
                            return uprawnieniaSubUsera.getInfo().then(function (result) {
                                return result;
                            })
                        } else {
                            return $q.resolve(null);
                        }
                    }],
                    uprawnienia: ['uprawnieniaSubUsera', '$q', 'security', function (uprawnieniaSubUsera, $q, security) {
                        if (security.jestSubUserem()) {
                            return uprawnieniaSubUsera.getUprawnienia().then(function (result) {
                                return result;
                            });
                        } else {
                            return $q.resolve(null);
                        }
                    }],
                    aktualnaLiczbaLokali: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.pobierzLimityLokaliKlienta().then(function (result) {
                            return result;
                        });
                    }],
                    gromadzenieDanychKsiegowych: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.dajGromadzenieDanychKsiegowych().then(function (result) {
                            return result;
                        });
                    }],
                    slownikCenLimitowLokali: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.dajSlownikCenDlaLimitowLokali().then(function (result) {
                            return result;
                        });
                    }],
                    opcjeEk: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.pobierzOpcjeEK().then(function(result) {
                            return result;
                        })
                    }],
                    opcjeEm: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.pobierzOpcjeEM().then(function(result) {
                            return result;
                        })
                    }],
                    saLokaleIBlokady: ['lokalizacjeResource','security', function (lokalizacjeResource, security) {
                        if (security.getTypUsr() == 5) {
                            return {Blokada: 0, SaLokale: 0}
                        }
                        return lokalizacjeResource.czySaLokaleIBlokady().then(function(result) {
                            return result;
                        })
                    }],
                    lokalizacje: ['lokalizacjeResource','security', function (lokalizacjeResource, security) {
                        if (security.getTypUsr() == 5) {
                            return []
                        }
                        return lokalizacjeResource.pobierzLokalizacje().then(function(result) {
                            return result;
                        })
                    }],
                }
            })

            .state('home.subMain.zapytanieOfertowe', {
                url: '/zapytanie-ofertowe',
                templateUrl: 'app/home/zapytanieOfertowe/zapytanieOfertowe.html',
                controller: 'zapytanieOfertoweController',
                controllerAs: 'vmZO',
                resolve: {
                    dostep: ['Restangular', 'security', '$q', 'uprawnieniaSubUsera',
                        function (Restangular, security, $q, uprawnieniaSubUsera) {
                            if (security.jestDostepDoDanychKlienta() === true) {
                                if (security.jestSubUserem() === true) {
                                    return uprawnieniaSubUsera.getUprawnienia().then(function (uprawnienia) {
                                        if (uprawnienia[0].Formularze === true) {
                                            return true;
                                        } else {
                                            return $q.reject();
                                        }
                                    });
                                } else {
                                    return true;
                                }
                            } else {
                                return $q.reject();
                            }
                        }]
                }
            })
            .state('home.subMain.zapytanieOfertowe.nowyModul', {
                url: '/nowy-modul',
                templateUrl: 'app/home/zapytanieOfertowe/nowyModul.zapytanieOfertowe.html',
                controller: 'zapytanieOfertoweNowyModulController',
                controllerAs: 'vmZONM'
            })
            .state('home.subMain.zapytanieOfertowe.zmianaLimitow', {
                url: '/zmiana-limitow',
                templateUrl: 'app/home/zapytanieOfertowe/zmianaLimitow.zapytanieOfertowe.html',
                controller: 'zapytanieOfertoweZmianaLimitowController',
                controllerAs: 'vmZOZL'
            })
            .state('home.subMain.zapytanieOfertowe.pakietyIUslugi', {
                url: '/pakiety-i-uslugi',
                templateUrl: 'app/home/zapytanieOfertowe/pakietyIUslugi.zapytanieOfertowe.html',
                controller: 'zapytanieOfertowePakietyIUslugiController',
                controllerAs: 'vmZOPIU'
            })
            .state('home.subMain.zapytanieOfertowe.aktualizacja', {
                url: '/aktualizacja',
                templateUrl: 'app/home/zapytanieOfertowe/aktualizacja.zapytanieOfertowe.html',
                controller: 'zapytanieOfertoweAktualizacjaController',
                controllerAs: 'vmZOA'
            })
            .state('home.subMain.zapytanieOfertowe.koszyk', {
                url: '/koszyk',
                templateUrl: 'app/home/zapytanieOfertowe/koszyk.html',
                controller: 'zapytanieOfertoweKoszykController',
                controllerAs: 'vmZOK',
                resolve: {
                    lokalizacje: ['Restangular', '$q', 'security', function (Restangular, $q, security) {
                        return Restangular.all('licencje/lokalizacje/').getList().then(function (result) {
                            var lokalizacje = {}
                            angular.forEach(result, function (lok) {
                                lokalizacje[lok.IdLok] = lok.NazwaLok;
                            });
                            return lokalizacje;
                        });

                    }],
                }
            })

            //UPDATEPACK
            .state('home.subMain.updatepack', {
                url: '/aktualizacja',
                templateUrl: 'app/home/updatepack/updatepack.html',
                controller: 'updatepackController',
                controllerAs: 'vmUpdatepack'
            })

            //DOKUMENTACJA
            .state('home.subMain.dokumentacja', {
                url: '/dokumentacja',
                templateUrl: 'app/home/dokumentacja/dokumentacja.html',
                controller: 'DokumentacjaController',
                controllerAs: 'vmDok',
                params: {modul: null}
            })
            .state('home.subMain.dokumentacja.pliki', {
                url: '/:skrotProgramu',
                templateUrl: 'app/home/dokumentacja/dokumentacja.listaPlikow.html',
                controller: 'DokumentacjaListaPlikowController',
                controllerAs: 'vmDokLi'
            })
            //---

            //REGULAMINY
            .state('home.subMain.regulaminy', {
                url: '/regulaminy',
                templateUrl: 'app/home/dokumentacja/dokumentacja.regulaminy.html',
                controller: 'RegulaminyController',
                controllerAs: 'vmReg',
                resolve: {
                    pliki: ['Restangular', function (Restangular) {
                        return Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami').getList({kategoria__nazwa: 'regulaminy'}).then(function (result) {
                            return result;
                        });
                    }]
                }
            })
            //---

            //CO NOWEGO
            .state('home.subMain.co_nowego', {
                url: '/co_nowego?modul',
                templateUrl: 'app/home/dokumentacja/dokumentacja.coNowego.html',
                controller: 'CoNowegoController',
                controllerAs: 'vmCN',
                params: {
                    modul: null,
                    coNowego: {},
                }
            })

            .state('home.subMain.pytania_i_odpowiedzi', {
                url: '/pytania_i_odpowiedzi',
                templateUrl: 'app/home/dokumentacja/dokumentacja.pytaniaIOdpowiedzi.html',
                controller: 'PytaniaIOdpowiedziController',
                controllerAs: 'vmPIO'
            })
            //---

            //FORMULARZE
            .state('home.subMain.formularze', {
                url: '/formularze',
                templateUrl: 'app/home/formularze/formularze.html',
                controller: 'FormularzeController',
                controllerAs: 'vmFR',
                resolve: {
                    pliki: ['Restangular', function (Restangular) {
                        return Restangular.all('zarzadzaniePlikami/zarzadzaniePlikami').getList({kategoria__nazwa: 'formularze'}).then(function (result) {
                            return result;
                        });
                    }]
                }
            })
            .state('home.subMain.formularze.pliki', {
                url: '/:formularz',
                templateUrl: 'app/home/formularze/formularze.pliki.html',
                controller: 'FormularzePlikiController',
                controllerAs: 'vmFRP'
            })
            .state('home.subMain.wycena_aktualizacji', {
                url: '/wycena_aktualizacji',
                templateUrl: 'app/home/formularze/formularze.wycenaAktualizacji.html',
                controller: 'WycenaAktualizacjiController',
                controllerAs: 'vmWAkt'
            })
            .state('home.subMain.generowanie_licencji', {
                url: '/generowanie_licencji',
                templateUrl: 'app/home/formularze/formularze.generowanieLicencji.html',
                controller: 'GenerowanieLicencjiController',
                controllerAs: 'vmGenLic',
                resolve: {
                    dostep: ['Restangular', 'security', '$q', 'uprawnieniaSubUsera',
                        function (Restangular, security, $q, uprawnieniaSubUsera) {
                            if (security.jestDostepDoDanychKlienta() === true) {
                                if (security.jestSubUserem() === true) {
                                    return uprawnieniaSubUsera.getUprawnienia().then(function (uprawnienia) {
                                        if (uprawnienia[0].Licencje === true && uprawnienia[0].Aktualizacja === true) {
                                            return true;
                                        } else {
                                            return $q.reject();
                                        }
                                    });
                                } else {
                                    return true;
                                }
                            } else {
                                return $q.reject();
                            }
                        }]
                }
            })
            .state('home.subMain.zamowienie_uslug', {
                url: '/zamowienie_uslug',
                // templateUrl: 'app/home/formularze/formularze.zamowienieUslug.html',
                // controller: 'ZamowienieUslugController',
                // controllerAs: 'vmZU'
                controller: function ($scope, $state) {
                    $state.go('home.subMain.konto');
                }
            })
            .state('home.subMain.zmiana_limitow', {
                url: '/zmiana_limitow',
                templateUrl: 'app/home/formularze/formularze.zmianaLimitow.html',
                controller: 'ZmianaLimitowController',
                controllerAs: 'vmZmianaLimitow',
                resolve: {
                    dostep: ['Restangular', 'security', '$q', function (Restangular, security, $q) {
                        if (security.jestDostepDoDanychKlienta() === true) {
                            return true;
                        } else {
                            return $q.reject();
                        }
                    }]
                }
            })
            .state('home.subMain.zapytaj_informatyka', {
                url: '/zapytajinformatyka',
                // templateUrl: 'app/home/formularze/formularze.zapytajInformatyka.html',
                // controller: 'ZapytajInformatykaController',
                // controllerAs: 'vmInf'
                controller: function ($scope, $state) {
                    $state.go('home.subMain.konto');
                }
            })
            //---

            //MAPA STRONY
            .state('home.subMain.mapa', {
                url: '/mapa',
                templateUrl: 'app/home/mapaStrony/mapaStrony.html',
                controller: 'MapaStronyController',
                controllerAs: 'vmMapa'
            })
            //---

            //TWOJE KONTO
            .state('home.subMain.konto', {
                url: '/konto',
                templateUrl: 'app/home/twojeKonto/konto.html',
                controller: 'TwojeKontoController',
                controllerAs: 'vmKonto',
                resolve: {
                    dostep: ['Restangular', 'dostepDoBety', '$q', function (Restangular, dostepDoBety, $q) {
                        return dostepDoBety.reload().then(
                            function (val) {
                                return $q.resolve(val);
                            });
                    }],
                }

            })
            .state('home.subMain.licencje', {
                url: '/licencje',
                templateUrl: 'app/home/twojeKonto/konto.licencje.html',
                controller: 'LicencjeController',
                controllerAs: 'vmLicencje',
                resolve: {
                    statusyUmow: ['Restangular', '$q', 'security', function (Restangular, $q, security) {
                        return Restangular.all('oprogramowanie/statusUmowyEKIEM').getList({id_usr: security.getIdUsr()})
                            .then(function (result) {
                                return result[0];
                            })
                    }],
                    saLokaleIBlokady: ['lokalizacjeResource', function (lokalizacjeResource) {
                        return lokalizacjeResource.czySaLokaleIBlokady().then(function(result) {
                            return result;
                        })
                    }],
                    lokalizacje: ['lokalizacjeResource', function (lokalizacjeResource) {
                        return lokalizacjeResource.pobierzLokalizacje().then(function(result) {
                            return result;
                        })
                    }],
                    aktualnaLiczbaLokali: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.pobierzLimityLokaliKlienta().then(function (result) {
                            return result;
                        });
                    }],
                    slownikCenLimitowLokali: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.dajSlownikCenDlaLimitowLokali().then(function (result) {
                            return result;
                        });
                    }],
                    opcjeEk: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.pobierzOpcjeEK().then(function(result) {
                            return result;
                        })
                    }],
                    opcjeEm: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.pobierzOpcjeEM().then(function(result) {
                            return result;
                        })
                    }],
                    gromadzenieDanychKsiegowych: ['cennikiResource', function (cennikiResource) {
                        return cennikiResource.dajGromadzenieDanychKsiegowych().then(function (result) {
                            return result;
                        });
                    }],
                    zaakceptowaneRegulaminy: ['regulaminyResource', function (regulaminyResource) {
                        return regulaminyResource.pobierzZaakceptowane().then(function (result) {
                            return result.flatMap(function(el){ return el.regulamin});
                        });
                    }],
                }
            })
            .state('home.subMain.pobieranie_plyty', {
                url: '/pobieranie_plyty',
                templateUrl: 'app/home/twojeKonto/konto.pobierzPlyte.html',
                controller: 'PobierzPlyteController',
                controllerAs: 'vmCD',
                resolve: {
                    plyta: ['Restangular', '$q', function (Restangular, $q) {
                        return Restangular.all('konto/licencje/').getList().then(function (result) {
                            var plyta = {};
                            plyta.wersja = (result[0].Wersja ? result[0].Wersja.toString().substr(0, 2) + '.' + result[0].Wersja.toString().substr(2, 2) : '');
                            plyta.wersjaSp = (result[0].WersjaSp ? result[0].WersjaSp.toString().substr(0, 2) + '.' + result[0].WersjaSp.toString().substr(2, 2) : '');
                            plyta.obraz = result[0].Obraz;
                            plyta.stalka = result[0].Stalka;
                            // plyta.link = 'ftp://ftp.mieszczanin.pl/.CD/EZN';
                            if (result[0].Stalka != 0) {
                                plyta.link = plyta.wersjaSp + '_A' + result[0].Wersja_Asa;
                            } else if (result[0].Obraz != 0) {
                                plyta.link = plyta.wersja + '_A' + result[0].Wersja_Asa;
                            } else {
                                plyta.link = '';
                            }
                            return $q.resolve(plyta);
                        })
                    }]
                }
            })

            .state('home.subMain.konta_pracownikow', {
                url: '/konta_pracownikow',
                templateUrl: 'app/home/twojeKonto/konto.kontaPracownikow.html',
                controller: 'KontaPracownikowController',
                controllerAs: 'konta_pracownikow',
                resolve: {
                    dostep: ['Restangular', 'dostepDoBety', '$q', function (Restangular, dostepDoBety, $q) {
                        return dostepDoBety.reload().then(
                            function (val) {
                                return val;
                            }
                        )
                    }]
                }
            })
            .state('home.subMain.profil', {
                url: '/profil',
                templateUrl: 'app/home/twojeKonto/profil.html',
                controller: 'ProfilController',
                controllerAs: 'vmProfil',
                params: {
                    przekierowanie_dodaj: null,
                    przekierowanie_zobacz: null
                }
            })
            .state('home.subMain.player', {
                url: '/player/:film',
                templateUrl: 'app/home/twojeKonto/player.html',
                controller: 'PlayerController',
                controllerAs: 'vmPlayer',
                params: {film: null}
            })
            .state('home.subMain.wykaz_konsultacji', {
                url: '/konsultacje_wykaz',
                templateUrl: 'app/home/twojeKonto/konto.wykazKonsultacji.html',
                controller: 'WykazKonsultacjiController',
                controllerAs: 'konsultacje_wykaz'
            })

            .state('home.subMain.konsultacje', {
                url: '/konsultacje',
                templateUrl: 'app/home/twojeKonto/konto.konsultacje.html',
                controller: 'KonsultacjeController',
                controllerAs: 'vmKon'
            })
 
            .state('home.subMain.zarzadzaniePlikami', {
                url: '/zarzadzanie_plikami',
                templateUrl: 'app/home/zarzadzaniePlikami/zarzadzaniePlikami.html',
                controller: 'zarzadzaniePlikamiController',
                controllerAs: 'vmZarzPlik',
                resolve: {
                    kategorie: ['Restangular', function (Restangular) {
                        return Restangular.all('/zarzadzaniePlikami/kategoriePlikow/').getList({pageSize: 200}).then(
                            function (results) {
                                return results
                            });
                    }]
                }
            })
            .state('home.subMain.zarzadzaniePlikami.edycja', {
                url: '/edycja/:id',
                templateUrl: 'app/home/zarzadzaniePlikami/edycja.zarzadzaniePlikami.html',
                controller: 'zarzadzaniePlikamiEdycjaController',
                controllerAs: 'vmZaPE',
                params: {id: null},
                resolve: {
                    plik: ['$state', '$stateParams', 'Restangular', function ($state, $stateParams, Restangular) {
                        return Restangular.one('/zarzadzaniePlikami/zarzadzaniePlikami/', $stateParams.id).get().then(
                            function (results) {
                                return results
                            });
                    }],
                    kategorie: ['Restangular', function (Restangular) {
                        return Restangular.all('/zarzadzaniePlikami/kategoriePlikow/').getList({pageSize: 200}).then(
                            function (results) {
                                return results
                            });
                    }]
                }
            })
            .state('home.subMain.zarzadzaniePlikami.dodaj', {
                url: '/dodaj',
                templateUrl: 'app/home/zarzadzaniePlikami/dodaj.zarzadzaniePlikami.html',
                controller: 'zarzadzaniePlikamiDodajController',
                controllerAs: 'vmZaPD',
                resolve: {
                    kategorie: ['Restangular', function (Restangular) {
                        return Restangular.all('/zarzadzaniePlikami/kategoriePlikow/').getList({pageSize: 200}).then(
                            function (results) {
                                return results
                            });
                    }]
                }
            })

            .state('home.subMain.ustawienia_mailingu', {
                url: '/ustawienia_mailingu',
                templateUrl: 'app/home/twojeKonto/konto.ustawieniaMailingu.html',
                controller: 'UstawieniaMailinguController',
                controllerAs: 'vmUstawienia_mailingu'
            })
            .state('home.subMain.faktury', {
                url: '/faktury',
                templateUrl: 'app/home/twojeKonto/konto.faktury.html',
                controller: 'FakturyController',
                controllerAs: 'vmFaktury',
                resolve: {
                    eFaktury: ['Restangular', '$q', function (Restangular) {
                        return Restangular.all('/faktury/zgodaNaEfakture/').getList().then(
                            function (results) {
                                return (results && results[0] && results[0].Stan)
                            },
                            function () {
                                return false
                            });
                    }],
                    dostep: ['security', '$q', 'uprawnieniaSubUsera',
                        function (security, $q, uprawnieniaSubUsera) {
                            if (security.jestDostepDoDanychKlienta() === true) {
                                if (security.jestSubUserem() === true) {
                                    return uprawnieniaSubUsera.getUprawnienia().then(function (uprawnienia) {
                                        if (uprawnienia[0].Faktury === true){
                                            return true
                                        }
                                        return $q.reject();
                                    });
                                } else {
                                    return true;
                                }
                            } else {
                                return $q.reject();
                            }
                        }]
                }
            })
            .state('home.subMain.informacje_dedykowane', {
                url: '/dedykowane',
                templateUrl: 'app/home/twojeKonto/konto.informacjeDedykowane.html',
                controller: 'InformacjeDedykowaneController',
                controllerAs: 'vmDed'
            })
            .state('home.subMain.informacje_dedykowane.pliki', {
                url: '/:informacja',
                templateUrl: 'app/home/twojeKonto/konto.informacjeDedykowane.pliki.html',
                controller: 'InformacjeDedykowanePlikiController',
                controllerAs: 'vmDedP'
            })
            .state('home.subMain.uslugiPasywne', {
                url: '/uslugi_pasywne',
                templateUrl: 'app/home/twojeKonto/konto.uslugiPasywne.html',
                controller: 'UslugiPasywneController',
                controllerAs: 'vmUP',
                resolve: {
                    informacje: ['Restangular', 'dostepDoBety', '$q', function (Restangular, dostepDoBety, $q) {
                        return Restangular.all('/uslugiPasywne/uslugiPasywne/limity/').getList().then(function (result) {
                            var informacje = {przestrzen: 0, transfer: 0, used: 0};
                            if (angular.isDefined(result) == true) {
                                if (result.length > 0) {
                                    if (result[0].bytes_in_avail !== null) {
                                        informacje.przestrzen = +(Math.round((result[0].bytes_in_avail / 1073741824) + "e+2") + "e-2");
                                        informacje.transfer = +(Math.round((result[0].bytes_in_avail / 1073741824) + "e+2") + "e-2");
                                    }
                                    if (result[0].bytes_in_used !== null) {
                                        var a = +(Math.round((result[0].bytes_in_used / 1073741824) + "e+2") + "e-2");
                                        if (Number.isNaN(a) == false) {
                                            informacje.used = +(Math.round((result[0].bytes_in_used / 1073741824) + "e+2") + "e-2");
                                        }
                                    }
                                }
                            }
                            return informacje
                        }, function () {
                        })
                    }]
                }
            })
            //---

            //REDIRECT ZGLOSZENIA BETA                              do usunięcia za rok: (12.12.2018)
            .state('home.subMain.zgloszenia_beta_redirect', {
                url: '/zgloszenia_beta/',
                resolve: ['$state', '$stateParams', '$location', function ($state, $stateParams, $location) {
                    $location.url('/zgloszenia');

                }]
            })
            .state('home.subMain.zgloszenia_beta_redirect_zgloszenie', {
                url: '/zgloszenia_beta/zgloszenie/:id',
                params: {id: null},
                resolve: ['$state', '$stateParams', '$location', function ($state, $stateParams, $location) {
                    $location.url('/zgloszenia/zgloszenie/' + $stateParams.id);
                }]
            })
            //---


            //NOWE ZGŁOSZENIA
            .state('home.subMain.blokada_konsultacji', {
                url: '/blokada-konsultacji',
                templateUrl: 'app/home/zgloszenia/blokada.html',
                controller: 'BlokadaKonsultacjiController',
                controllerAs: 'vmBK',
                params: {
                    blokada: "",
                },
                resolve: {
                    dostep: ['Restangular', '$state', '$stateParams', '$q', function (Restangular, $state, $stateParams, $q) {
                        return Restangular.one('konto/danepodstawowe/').getList().then(function (result) {
                            if (result[0].Blokada === "") {
                                $state.go('home.subMain.konto');
                                return $q.reject();
                            }
                            $stateParams.blokada = result[0].Blokada;
                            return true;
                        });
                    }]
                }
            })
            .state('home.subMain.zgloszenia', {
                url: '/zgloszenia',
                templateUrl: 'app/home/zgloszenia/zgloszenia.html',
                controller: 'ZgloszeniaController',
                controllerAs: 'vmZgloszenia',
                resolve: {
                    dostep: ['Restangular', '$state', '$q', function (Restangular, $state, $q) {
                        return Restangular.one('konto/danepodstawowe/').getList().then(function (result) {
                            if (result[0].Blokada === "") {
                                return result[0].Blokada;
                            } else {
                                $state.go('home.subMain.blokada_konsultacji');
                                return $q.reject();
                            }
                        });
                    }]
                }
            })
            .state('home.subMain.zgloszenia.nowe_zgloszenie', {
                url: '/nowe/:typ',
                templateUrl: 'app/home/zgloszenia/zgloszenia.nowe_zgloszenie.html',
                controller: 'ZgloszeniaNoweController',
                controllerAs: 'vmZglNowe',
                params: {typ: null}
            })
            .state('home.subMain.zgloszenia.listaKlienta', {
                url: '/lista',
                templateUrl: 'app/home/zgloszenia/zgloszenia.listaKlienta.html',
                controller: 'ZgloszeniaListaKlientaController',
                controllerAs: 'vmZglLisKli'
            })
            .state('home.subMain.zgloszenia.zamowienia', {
                url: '/zamowienia',
                templateUrl: 'app/home/zgloszenia/zgloszenia.zamowienia.html',
                controller: 'ZgloszeniaZamowieniaController',
                controllerAs: 'vmZglZ'
            })
            .state('home.subMain.zgloszenia_listaPracownika', {
                url: '/zgloszenia/lista/pracownik',
                templateUrl: 'app/home/zgloszenia/zgloszenia.listaPracownika.html',
                controller: 'ZgloszeniaListaPracownikaController',
                controllerAs: 'vmZglLisPra'
            })
            .state('home.subMain.zgloszenia.kartaZgloszenia', {
                url: '/zgloszenie_pracownik/:zgloszenie',
                templateUrl: 'app/home/zgloszenia/zgloszenia.kartaZgloszenia.html',
                controller: 'ZgloszeniaKartaZgloszeniaController',
                controllerAs: 'vmZglKarZgl'
            })
            .state('home.subMain.zgloszenia.kartaZgloszeniaKlienta', {
                url: '/zgloszenie/:zgloszenie',
                templateUrl: 'app/home/zgloszenia/zgloszenia.kartaZgloszeniaKlienta.html',
                controller: 'ZgloszeniaKartaKlientaController',
                controllerAs: 'vmZglKarKli',
                resolve: {
                    zamkniete: ['Restangular', 'moment', '$stateParams', function (Restangular, moment, $stateParams) {
                        var zgloszenie;
                        return Restangular.one('/zgloszenia/zgloszenia/', $stateParams.zgloszenie).get().then(function (result) {
                            zgloszenie = result;
                            var d = new Date(result.dataZmiany);
                            var diffDays = Math.round(Math.abs((new Date().getTime() - d.getTime()) / (24 * 60 * 60 * 1000)));
                            if (diffDays > 14 && ['Zamknięte', 'Odrzucone', 'Zmieniona kategoria', 'Odłożone'].indexOf(zgloszenie.status) !== -1) {
                                return true;
                            } else if (diffDays < 14 && ['Zamknięte', 'Odrzucone', 'Zmieniona kategoria', 'Odłożone'].indexOf(zgloszenie.status) !== -1) {
                                return false;
                            } else {
                                return null;
                            }
                        });
                    }],
                    uprawnienia: ['uprawnieniaSubUsera', '$stateParams', function (uprawnieniaSubUsera, $stateParams) {
                        return uprawnieniaSubUsera.getUprawnienia().then(function (result) {
                            if (result.length > 0) {
                                return result[0];
                            }
                            return null;
                        });
                    }]
                }
            })

            //STARE ZGŁOSZENIA
            .state('home.subMain.zgloszenia_stare', {
                url: '/zgloszenia_old',
                templateUrl: 'app/home/zgloszenia_stare/zgloszenia.html',
                controller: 'ZgloszeniaStareController',
                controllerAs: 'vmZgl'
            })
            .state('home.subMain.zgloszenia_stare.reklamacje', {
                url: '/reklamacje/{idrek}',
                templateUrl: 'app/home/zgloszenia_stare/zgloszenia.reklamacje.html',
                controller: 'ReklamacjeController',
                controllerAs: 'vmRek',
                resolve: {
                    zabezpieczenie: ['security', '$q', function (security, $q) {
                        if (!security.jestPracownikiemMieszczanin()) {
                            return $q.reject("Permission denied");
                        }
                    }]
                }
            })
            .state('home.subMain.zgloszenia_stare.nowaReklamacja', {
                url: '/nowe?przypiszOsobe&edytuj&idZgl',
                templateUrl: 'app/home/zgloszenia_stare/zgloszenia.nowe.html',
                controller: 'ReklamacjeNowaController',
                controllerAs: 'vmRekN'
            })
            .state('home.subMain.zgloszenia_stare.zmienStatus', {
                url: '/zmien?idZgl',
                templateUrl: 'app/home/zgloszenia_stare/zgloszenia.zmien.html',
                controller: 'ReklamacjeZmienController',
                controllerAs: 'vmRekZ'
            })

            //PROMOCJE
            .state('home.subMain.promocje', {
                url: '/promocje?id',
                templateUrl: 'app/home/promocje/promocje.html',
                controller: 'PromocjeController',
                controllerAs: 'vmPro',
                resolve: {
                    promocje: ['PromocjeResource', function (PromocjeResource) {
                        return PromocjeResource.pobierzPromocje().then(function (result) {
                            return result;
                        })
                    }]
                }
            })
            .state('home.subMain.dodajPromocje', {
                url: '/dodajPromocje',
                templateUrl: 'app/home/promocje/dodajPromocje.html',
                controller: 'DodajPromocjeController',
                controllerAs: 'vmDodPro',
                params: {idPromocji: null},
                resolve: {
                    idPromocji: ['$stateParams', function ($stateParams) {
                        return $stateParams.idPromocji;
                    }],
                    promocja: ['$stateParams', 'PromocjeResource', function ($stateParams, PromocjeResource) {
                        if ($stateParams.idPromocji) {
                            return PromocjeResource.pobierzJednaPromocje($stateParams.idPromocji)
                        } else {
                            return {id: 0}
                        }
                    }],
                    wersje: ['Restangular', function (Restangular) {
                        return Restangular.all('oprogramowanie/wersjeEzn/').getList({pageSize: 1000}).then(function (result) {
                            return result;
                        });
                    }]
                }
            })


            /// tSeminaria
            .state('home.subMain.seminaria', {
                url: '/seminaria?id',
                templateUrl: 'app/home/seminaria/seminaria.html',
                controller: 'SeminariaController',
                controllerAs: 'vmSem',
                resolve: {
                    seminaria: ['Restangular', function (Restangular) {
                        return Restangular.all('seminaria/szkolenia').getList().then(function (result) {
                            return result;
                        });
                    }],
                    zapisy: ['Restangular', function (Restangular) {
                        var dzisiaj = new Date();
                        return Restangular.all('seminaria/zapisy').getList({szkolenie__dataSzkolenia__gt: dzisiaj})
                            .then(function (result) {
                                return result;
                            });
                    }],
                    dynamicznyTekst: ['Restangular', function (Restangular) {
                        return Restangular.one('seminaria/dynamicznyTekst', 'seminaria').get().then(function (result) {
                            return result;
                        });
                    }],
                    pliki: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('seminaria/plikiDynamicznyTekst').getList({}).then(function (result) {
                            return result;
                        });
                    }]
                }
            })

            // Formularz zgloszenia
            .state('home.subMain.seminariaFZ', {
                url: '/seminaria/formularzZgloszenia/:id',
                templateUrl: 'app/home/seminaria/formularzZgloszenia.seminaria.html',
                controller: 'FormularzZgloszeniaSeminariaController',
                controllerAs: 'vmSemFZ',
                resolve: {
                    seminaria: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.one('seminaria/szkolenia', $stateParams.id).get().then(function (result) {
                            return result;
                        })
                    }],
                    stalka: ['Restangular', function (Restangular) {
                        return Restangular.all('konto/czyStalaAktualizacja').getList().then(function (result) {
                            return result[0];
                        })
                    }],
                    klient: ['Restangular', function (Restangular) {
                        return Restangular.all('konto/danepodstawowe').getList().then(function (result) {
                            return result[0];
                        })
                    }],
                    pracownik: ['Restangular', 'security', function (Restangular, security) {
                        if (security.jestSubUserem() == true) {
                            return Restangular.all('/subUser/subUser').getList().then(function (result) {
                                return result[0];

                            });
                        } else {
                            return {imie: '', nazwisko: '', Telefon: '', email: ''};
                        }
                    }]
                }
            })
            .state('home.subMain.seminariaPZ', {
                url: '/seminaria-panel',
                templateUrl: 'app/home/seminaria/panel.seminaria.html',
                controller: 'SeminariaPanelController',
                controllerAs: 'vmSemP',
                resolve: {
                    seminaria: ['Restangular', function (Restangular) {
                        var dzisiaj = new Date();
                        return Restangular.all('seminaria/szkolenia').getList({dataSzkolenia__gt: dzisiaj}).then(function (result) {
                            return result;
                        })
                    }],
                    zabezpieczenie: ['security', '$q', function (security, $q) {
                        if (!security.jestPracownikiemMieszczanin()) {
                            return $q.reject("Permission denied");
                        }
                    }]
                }
            })
            .state('home.subMain.seminariaPZ.nowe', {
                url: '/nowe',
                templateUrl: 'app/home/seminaria/nowe.panel.seminaria.html',
                controller: 'SeminariaNoweController',
                controllerAs: 'vmSemN'
            })
            .state('home.subMain.seminariaPZ.edycja', {
                url: '/edycja/:id',
                templateUrl: 'app/home/seminaria/edycja.panel.seminaria.html',
                controller: 'SeminariaEdycjaController',
                controllerAs: 'vmSemE',
                params: {
                    id: null
                },
                resolve: {
                    seminarium: ['Restangular', '$stateParams', '$q', function (Restangular, $stateParams, $q) {
                        if ($stateParams.id !== null) {
                            return Restangular.one('seminaria/szkolenia', $stateParams.id).get().then(function (result) {
                                result.dataSzkolenia = new Date(result.dataSzkolenia);
                                result.dataKoncaSzkolenia = (result.dataKoncaSzkolenia === null) ? null : new Date(result.dataKoncaSzkolenia);
                                result.zapisDo = new Date(result.zapisDo);
                                result.rezygnacjaDo = new Date(result.rezygnacjaDo);
                                result.dataKoncaPromocji = (result.dataKoncaPromocji === null) ? null : new Date(result.dataKoncaPromocji);
                                return result;
                            })
                        }
                        return $q.reject();
                    }]
                }

            })
            .state('home.subMain.seminariaPZ.zapisy', {
                url: '/zapisy',
                templateUrl: 'app/home/seminaria/zapisy.panel.seminaria.html',
                controller: 'SeminariaZapisyController',
                controllerAs: 'vmSemZ',
                resolve: {
                    seminaria: ['Restangular', function (Restangular) {
                        var dzisiaj = new Date();
                        return Restangular.all('seminaria/szkolenia').getList({
                            z_zapisami: true,
                            dataSzkolenia__gt: dzisiaj
                        }).then(function (result) {
                            return result;
                        })
                    }]
                }
            })
            .state('home.subMain.seminariaPZ.zapisyEdycja', {
                url: '/zapisy-edycja/:id',
                templateUrl: 'app/home/seminaria/zapisyEdycja.panel.seminaria.html',
                controller: 'SeminariaZapisyEdycjaController',
                controllerAs: 'vmSemZE',
                params: {
                    id: null
                },
                resolve: {
                    zapis: ['Restangular', '$stateParams', '$q', function (Restangular, $stateParams, $q) {
                        if ($stateParams.id !== null) {
                            return Restangular.one('seminaria/zapisy', $stateParams.id).get().then(function (result) {
                                return result;
                            });
                        }
                        return $q.reject();
                    }],
                    uczestnicy: ['Restangular', '$stateParams', '$q', function (Restangular, $stateParams, $q) {
                        if ($stateParams.id !== null) {
                            return Restangular.all('seminaria/uczestnicy').getList({zapis: $stateParams.id}).then(function (result) {
                                return result;
                            })
                        }
                        return $q.reject();
                    }]
                }
            })
            .state('home.subMain.seminariaPZ.zapisyNowy', {
                url: '/zapisy-nowy/:id',
                templateUrl: 'app/home/seminaria/zapisyNowy.panel.seminaria.html',
                controller: 'SeminariaZapisyNowyController',
                controllerAs: 'vmSemZN',
                params: {
                    id: null
                },
                resolve: {
                    seminaria: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.one('seminaria/szkolenia', $stateParams.id).get().then(function (result) {
                            return result;
                        })
                    }]
                }
            })
            .state('home.subMain.seminariaPZ.dynamicznyTekst', {
                url: '/edytuj-tekst',
                templateUrl: 'app/home/seminaria/dynamicznyTekst.panel.seminaria.html',
                controller: 'DynamicznyTekstSeminariaController',
                controllerAs: 'vmSemDT',
                resolve: {
                    tekst: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.one('seminaria/dynamicznyTekst', 'seminaria').get().then(function (result) {
                            return result;
                        });
                    }],
                    pliki: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('seminaria/plikiDynamicznyTekst').getList({}).then(function (result) {
                            return result;
                        });
                    }]
                }
            })
            .state('home.subMain.seminariaPZ.archiwumZapisow', {
                url: '/zapisy-archiwum',
                templateUrl: 'app/home/seminaria/archiwumZapisow.panel.seminaria.html',
                controller: 'SeminariaZapisyArchiwumController',
                controllerAs: 'vmSemZA',
                resolve: {
                    seminaria: ['Restangular', function (Restangular) {
                        var dzisiaj = new Date();
                        return Restangular.all('seminaria/szkolenia').getList({
                            z_zapisami: true,
                            dataSzkolenia__lt: dzisiaj, ordering: '-dataSzkolenia'
                        }).then(function (result) {
                            return result;
                        })
                    }]
                }
            })
            .state('home.subMain.zapisyEdycja', {
                url: '/seminaria/zapisy-edycja/:id',
                templateUrl: 'app/home/seminaria/zapisyEdycja.seminaria.html',
                controller: 'SeminariaFormularzZapisyEdycjaController',
                controllerAs: 'vmSemFZE',
                params: {
                    id: null
                },
                resolve: {
                    zapis: ['Restangular', '$stateParams', '$q', function (Restangular, $stateParams, $q) {
                        if ($stateParams.id !== null) {
                            return Restangular.one('seminaria/zapisy', $stateParams.id).get().then(function (result) {
                                return result;
                            });
                        }
                        return $q.reject();
                    }],
                    uczestnicy: ['Restangular', '$stateParams', '$q', function (Restangular, $stateParams, $q) {
                        if ($stateParams.id !== null) {
                            return Restangular.all('seminaria/uczestnicy').getList({zapis: $stateParams.id}).then(function (result) {
                                return result;
                            })
                        }
                        return $q.reject();
                    }]
                }
            })

            .state('home.subMain.seminariaArchiwumZapisow', {
                url: '/seminaria/archiwum-zapisow',
                templateUrl: 'app/home/seminaria/archiwumZapisow.seminaria.html',
                controller: 'SeminariaArchiwumZapisowController',
                controllerAs: 'vmSemZA',
                resolve: {
                    zapisy: ['Restangular', function (Restangular) {
                        var dzisiaj = new Date();
                        return Restangular.all('seminaria/zapisy').getList({szkolenie__dataSzkolenia__lt: dzisiaj})
                            .then(function (result) {
                                return result;
                            })
                    }]
                }
            })
            .state('home.subMain.seminariaReklamacja', {
                url: '/seminaria/reklamacja/:id',
                templateUrl: 'app/home/seminaria/reklamacja.seminaria.html',
                controller: 'SeminariaReklamacjaController',
                controllerAs: 'vmSemR',
                params: {
                    id: null
                },
                resolve: {
                    zapis: ['Restangular', '$stateParams', '$q', function (Restangular, $stateParams, $q) {
                        return Restangular.all('seminaria/zapisy').getList({id: $stateParams.id})
                            .then(function (result) {
                                if (result[0].dni_od_szkolenia <= 5) {
                                    return result[0];
                                }
                                return $q.reject('Nie można dodać reklamacji do tego szkolenia');
                            });
                    }]
                }
            })
            .state('home.subMain.seminariaPZ.archiwumSeminariow', {
                url: '/seminaria-archiwum',
                templateUrl: 'app/home/seminaria/archiwumSeminariow.panel.seminaria.html',
                controller: 'SeminariaArchiwumSeminariowController',
                controllerAs: 'vmSemA',
                resolve: {
                    seminaria: ['Restangular', function (Restangular) {
                        var dzisiaj = new Date();
                        return Restangular.all('seminaria/szkolenia').getList({dataSzkolenia__gt: dzisiaj}).then(function (result) {
                            return result;
                        })
                    }],
                    zabezpieczenie: ['security', '$q', function (security, $q) {
                        if (!security.jestPracownikiemMieszczanin()) {
                            return $q.reject("Permission denied");
                        }
                    }]
                }
            })

            //KONIEC



            .state('home.subMain.generatorDemo', {
                url: '/generatorDemo',
                templateUrl: 'app/home/demo/generatorDemo.html',
                controller: 'generatorDemoController',
                controllerAs: 'vmGeneratorDemo'
            })
            .state('home.subMain.listaDemo', {
                url: '/listaDemo',
                templateUrl: 'app/home/demo/listaDemo.html',
                controller: 'listaDemoController',
                controllerAs: 'vmListaDemo'
            })
            .state('home.demo', {
                url: '/demo',
                templateUrl: 'app/home/demo/demo.html',
                controller: 'demoController',
                controllerAs: 'vmDemo',
                params: {lic: null}
            })

            .state('home.subMain.wol', {
                url: '/wol',
                templateUrl: 'app/home/wol/wol.html',
                controller: 'wakeOnLanController',
                controllerAs: 'vmWOL'
            })

            //ZARZĄDZANIE POP-UPAMI
            .state('home.subMain.popupEdytor', {
                abstract: true,
                url: '/popupEdytor',
                templateUrl: 'app/home/popupEdytor/popupEdytor.html',
                controller: 'popupEdytorController',
                controllerAs: 'vmPopupEdytorCtrl'
            })
            .state('home.subMain.popupEdytor.popupLista', {
                url: '/lista',
                templateUrl: 'app/home/popupEdytor/popupLista.html',
                controller: 'popupEdytorController',
                controllerAs: 'vmPopupEdytorCtrl'
            })
            .state('home.subMain.popupEdytor.popupDodaj', {
                url: '/dodaj',
                templateUrl: 'app/home/popupEdytor/popupDodaj.html',
                controller: 'popupEdytorController',
                controllerAs: 'vmPopupEdytorCtrl',
                data: {
                    requiresLogin: true
                }
            })
            .state('home.subMain.popupEdytor.popupEdycja', {
                url: '/edytuj',
                templateUrl: 'app/home/popupEdytor/popupEdycja.html',
                controller: 'popupEdytorController',
                controllerAs: 'vmPopupEdytorCtrl',
                params: {idp: null}
            })
            //---


            // MOBILNA E_KARTOTEKA
            .state('home.subMain.mobilnaekartoteka', {
                url: '/mobilna-e-kartoteka',
                templateUrl: 'app/home/aplikacjaMobilnaEK/aplikacjaMobilnaEK.html',
                controller: 'AplikacjaMobilnaEKController',
                controllerAs: 'vmAppEK',
                resolve: {
                    zabezpieczenie: ['security', '$q', function (security, $q) {
                        if (!security.isLogin()) {
                            return $q.reject("Brak uprawnień");
                        }
                    }]
                }
            })
            .state('home.subMain.mobilnaekartoteka.pomoc', {
                url: '/pomoc',
                templateUrl: 'app/home/aplikacjaMobilnaEK/pomoc.aplikacjaMobilnaEK.html',
                controller: 'AplikacjaMobilnaEKPomocController',
                controllerAs: 'vmAppEKP'
            })
            .state('home.subMain.mobilnaekartoteka.dlamieszkanca', {
                url: '/dla-mieszkanca',
                templateUrl: 'app/home/aplikacjaMobilnaEK/dlaMieszkanca.aplikacjaMobilnaEK.html',
                controller: 'AplikacjaMobilnaEKDlaMieszkancaController',
                controllerAs: 'vmAppEKDM'
            })
            .state('home.subMain.mobilnaekartoteka.instrukcja', {
                url: '/instrukcja',
                templateUrl: 'app/home/aplikacjaMobilnaEK/instrukcja.aplikacjaMobilnaEK.html',
                controller: 'AplikacjaMobilnaEKInstrukcjaController',
                controllerAs: 'vmAppEKI'
            })
            .state('home.subMain.mobilnaekartoteka.faq', {
                url: '/faq',
                templateUrl: 'app/home/aplikacjaMobilnaEK/faq.aplikacjaMobilnaEK.html',
                controller: 'AplikacjaMobilnaEKFAQController',
                controllerAs: 'vmAppEKFAQ'
            })
            .state('home.subMain.mobilnaekartoteka.jakzaczac', {
                url: '/jak-zaczac',
                templateUrl: 'app/home/aplikacjaMobilnaEK/jakZaczac.aplikacjaMobilnaEK.html',
                controller: 'AplikacjaMobilnaEKJakZaczacController',
                controllerAs: 'vmAppEKJZ'
            })
            // ---

            // PŁATONOŚCI ONLINE E-KARTOTEKA
            .state('home.subMain.platnosciOnline', {
                url: '/platnosciOnline',
                templateUrl: 'app/home/platnosciOnlineEK/platnosciOnlineEK.html',
                controller: 'PlatnosciOnlineEKController',
                controllerAs: 'vmPlatOnlEK',
                resolve: {
                    zabezpieczenie: ['security', '$q', function (security, $q) {
                        if (!security.isLogin())
                            return $q.reject("Brak uprawnień");
                    }]
                }
            })
            .state('home.subMain.platnosciOnline.dlaczegoWarto', {
                url: '/dlaczegoWarto',
                templateUrl: 'app/home/platnosciOnlineEK/dlaczegoWarto/dlaczegoWarto.html',
                controller: 'PlatnosciOnlineEKDlaczegoWartoController',
                controllerAs: 'vmPlatOnlEKDW'
            })
            .state('home.subMain.platnosciOnline.instrukcja', {
                url: '/instrukcja',
                templateUrl: 'app/home/platnosciOnlineEK/instrukcja/instrukcja.html',
                controller: 'PlatnosciOnlineEKInstrukcjaController',
                controllerAs: 'vmPlatOnlEKInst'
            })
            .state('home.subMain.platnosciOnline.visa', {
                url: '/visa',
                templateUrl: 'app/home/platnosciOnlineEK/visa/visa.html',
                controller: 'PlatnosciOnlineEKVisaController',
                controllerAs: 'vmPlatOnlEKVisa'
            })
            .state('home.subMain.platnosciOnline.pytania', {
                url: '/pytania',
                templateUrl: 'app/home/platnosciOnlineEK/pytania/pytania.html',
                controller: 'PlatnosciOnlineEKPytaniaController',
                controllerAs: 'vmPlatOnlEKPyt'
            })

            // ZAPISY NA EMIESZCZANINA
            .state('home.subMain.emieszczanin', {
                url: '/e-mieszczanin',
                templateUrl: 'app/home/zapisyNaEM/zapisyNaEM.html',
                controller: 'ZapisyNaEMController',
                controllerAs: 'vmZapEM'
            })

            // ---

            .state('home.subMain.podszyciePodKlienta', {
                url: '/logowanie-na-klienta',
                templateUrl: 'app/home/podszyciePodKlienta/podszyciePodKlienta.html',
                controller: 'PodszyciePodKlientaController',
                controllerAs: 'vmPod'
            })

            // Głosowania na propozycje rozwoju
            .state('home.subMain.glosowaniaNaPropozycjeRozwoju', {
                url: '/glosowania',
                templateUrl: 'app/home/glosowaniaPropozycjeRozwoju/glosowania.html',
                controller: 'GlosowaniaNaPropozycjeController',
                controllerAs: 'vmGlo',
                resolve: {
                    aktywneGlosowania: ['Restangular', function (Restangular) {
                        return Restangular.all('glosowaniaPropozycje/glosowania').getList({aktywne: true})
                            .then(function (result) {
                                return result;
                            })
                    }],
                    zakonczoneGlosowania: ['Restangular', function (Restangular) {
                        return Restangular.all('glosowaniaPropozycje/glosowania').getList({aktywne: false})
                            .then(function (result) {
                                return result;
                            })
                    }]
                }
            })

            .state('home.subMain.glosowanieNaPropozycjeRozwoju', {
                url: '/glosowanie/:id',
                templateUrl: 'app/home/glosowaniaPropozycjeRozwoju/glosowanie.html',
                controller: 'GlosowanieNaPropozycjeController',
                controllerAs: 'vmGloS',
                params: {
                    id: null
                },
                resolve: {
                    glosowanie: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.one('glosowaniaPropozycje/glosowania', $stateParams.id).get()
                            .then(function (result) {
                                return result;
                            })
                    }],
                    slonie: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('glosowaniaPropozycje/propozycjeGlosowania')
                            .getList({
                                kategoria: 'System Łatwej Obsługi Nieruchomości',
                                glosowanie: $stateParams.id,
                                ordering: 'kolejnosc'
                            })
                            .then(function (result) {
                                return result;
                            })
                    }],
                    zestawienia: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('glosowaniaPropozycje/propozycjeGlosowania')
                            .getList({kategoria: 'Zestawienia', glosowanie: $stateParams.id, ordering: 'kolejnosc'})
                            .then(function (result) {
                                return result;
                            })
                    }],
                    inneModuly: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('glosowaniaPropozycje/propozycjeGlosowania')
                            .getList({kategoria: 'Inne moduły', glosowanie: $stateParams.id, ordering: 'kolejnosc'})
                            .then(function (result) {
                                return result;
                            })
                    }],
                    ekartoteka: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('glosowaniaPropozycje/propozycjeGlosowania')
                            .getList({kategoria: 'e-kartoteka', glosowanie: $stateParams.id, ordering: 'kolejnosc'})
                            .then(function (result) {
                                return result;
                            })
                    }],
                }
            })

            .state('home.subMain.wynikiGlosowania', {
                url: '/wyniki-glosowania/:id',
                templateUrl: 'app/home/glosowaniaPropozycjeRozwoju/wynikiGlosowania.html',
                controller: 'WynikiGlosowaniaController',
                controllerAs: 'vmGloW',
                params: {
                    id: null
                },
                resolve: {
                    glosowanie: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.one('glosowaniaPropozycje/glosowania', $stateParams.id).get()
                            .then(function (result) {
                                return result;
                            })
                    }],
                    slonie: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('glosowaniaPropozycje/propozycjeGlosowania')
                            .getList({kategoria: 'System Łatwej Obsługi Nieruchomości', glosowanie: $stateParams.id})
                            .then(function (result) {
                                return result;
                            })
                    }],
                    zestawienia: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('glosowaniaPropozycje/propozycjeGlosowania')
                            .getList({kategoria: 'Zestawienia', glosowanie: $stateParams.id})
                            .then(function (result) {
                                return result;
                            })
                    }],
                    inneModuly: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('glosowaniaPropozycje/propozycjeGlosowania')
                            .getList({kategoria: 'Inne moduły', glosowanie: $stateParams.id})
                            .then(function (result) {
                                return result;
                            })
                    }],
                    ekartoteka: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('glosowaniaPropozycje/propozycjeGlosowania')
                            .getList({kategoria: 'e-kartoteka', glosowanie: $stateParams.id})
                            .then(function (result) {
                                return result;
                            })
                    }],
                }
            })
            .state('home.subMain.propozycjaGlosowania', {
                url: '/glosowania/propozycja/:id',
                templateUrl: 'app/home/glosowaniaPropozycjeRozwoju/propozycjaGlosowania.html',
                controller: 'PropozycjaGlosowaniaController',
                controllerAs: 'vmGloP',
                params: {
                    id: null
                },
                resolve: {
                    propozycja: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.one('glosowaniaPropozycje/propozycjeGlosowania', $stateParams.id).get()
                            .then(function (result) {
                                return result;
                            })
                    }],
                    zalaczniki: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                        return Restangular.all('glosowaniaPropozycje/zalaczniki/').getList({propozycja: $stateParams.id})
                            .then(function (result) {
                                return result;
                            })
                    }],
                }
            })
            .state('home.subMain.prezentacjaZebranOnline', {
                url: '/prezentacja-zebran-online',
                templateUrl: 'app/home/prezentacjaZebranOnline/prezentacjaZebranOnline.html',
                controller: 'PrezentacjaZebranOnlineController',
                controllerAs: 'vmPZO'
            })
            .state('home.subMain.umowy', {
                url: '/umowy',
                templateUrl: 'app/home/umowy/umowy.html',
                controller: 'UmowyController',
                controllerAs: 'vmUm',
                resolve: {
                    dostep: ['Restangular', 'security', '$q', 'uprawnieniaSubUsera',
                        function (Restangular, security, $q, uprawnieniaSubUsera) {
                            if (security.jestDostepDoDanychKlienta() === true) {
                                if (security.jestSubUserem() === true) {
                                    return uprawnieniaSubUsera.getUprawnienia().then(function (uprawnienia) {
                                        if (uprawnienia[0].Formularze === true) {
                                            return true;
                                        } else {
                                            return $q.reject();
                                        }
                                    });
                                } else {
                                    return true;
                                }
                            } else {
                                return $q.reject();
                            }
                        }],
                    danePodstawowe: ['Restangular', '$state', '$q', function (Restangular, $state, $q) {
                        return Restangular.one('konto/danepodstawowe/').getList().then(function (result) {
                            if (angular.isDefined(result[0])) {
                                return result[0];
                            }
                            return $q.reject();
                        });
                    }]
                }
            })
            .state('home.subMain.umowy.uppdo', {
                url: '/uppdo',
                templateUrl: 'app/home/umowy/uppdo/uppdo.umowy.html',
                controller: 'UmowyUPPDOController',
                controllerAs: 'vmUmUPPDO',
                resolve: {
                    daneSubUsera: ['security', 'uprawnieniaSubUsera', '$q', function (security, uprawnieniaSubUsera, $q) {
                        if (security.jestSubUserem()) {
                            return uprawnieniaSubUsera.getInfo().then(function (result) {
                                return result;
                            });
                        } else {
                            return $q.reject('Dostęp tylko dla kont pracowniczych');
                        }
                    }]
                }
            })
            .state('home.subMain.pobieranieUmowy', {
                url: '/pobierz-umowe/:idUmowy',
                templateUrl: 'app/home/umowy/umowy.pobieranie.html',
                controller: 'UmowyPobieranieController',
                controllerAs: 'vmUmPo',
                params: {
                    idUmowy: null
                },
                resolve: {
                    zabezpieczenie: ['security', '$q', function (security, $q) {
                        if (!security.jestPracownikiemMieszczanin()) {
                            return $q.reject("Permission denied");
                        }
                    }]
                }
            })
            .state('home.potencjalnyKlient', {
                url: '/pk',
                templateUrl: 'app/home/potencjalnyKlient/potencjalnyKlient.html',
                controller: 'PotencjalnyKlientController',
                controllerAs: 'vmPoK',
            })
            .state('home.potencjalnyKlient.zgloszenia', {
                url: '/zgloszenia',
                templateUrl: 'app/home/potencjalnyKlient/zgloszenia.html',
                controller: 'PotencjalnyKlientZgloszeniaController',
                controllerAs: 'vmPoKZ',
            })
            .state('home.potencjalnyKlient.zgloszenia.szczegoly', {
                url: '/:id',
                templateUrl: 'app/home/potencjalnyKlient/zgloszenie.html',
                controller: 'PotencjalnyKlientZgloszeniaSzczegolyController',
                controllerAs: 'vmPoKZ',
                params: {
                    id: null
                },
            })
            // POTENCJALNY KLIENT
            .state('home.pk', {
                url: '/pk',
                abstract: true,
                templateUrl: 'app/home/potencjalnyKlient/potencjalnyKlient.html',
                controller: 'PotKliController',
                controllerAs: 'vmPK',
            })
            .state('home.pk.brakDostepu', {
                url: '/brakDostepu',
                templateUrl: 'app/home/potencjalnyKlient/brakDostepu.html',
                controller: 'PotKliBrakDostepuController',
                controllerAs: 'vmPKBD',
                params: {
                    token: null
                },
                resolve: {
                    token: ['security', '$stateParams', '$q', '$location', 'store', '$state',
                        function (security, $stateParams, $q, $location, store, $state) {
                            if ($stateParams.token !== null && $stateParams.token !== undefined) {
                                return $stateParams.token
                            } else {
                                return null;
                            }
                        }],
                }
            })
            .state('home.pk.zgloszenie', {
                url: '/zgloszenie',
                templateUrl: 'app/home/potencjalnyKlient/zgloszenia.szczegoly.html',
                controller: 'ZgloszeniaKartaPotencjalnegoKlientaController',
                controllerAs: 'vmPKZgl',
                resolve: {
                    zgloszenie: ['security', 'potencjalnyKlient', '$q', '$location', 'store',
                        function (security, potencjalnyKlient, $q, $location, store) {
                            return potencjalnyKlient.login(
                                $location.search().tokenpk,
                                store.get($location.search().tokenpk)
                            ).then(function (res) {
                                return potencjalnyKlient.dajZgloszenie($location.search().tokenpk).then(
                                    function (result) {
                                        return result;
                                    }, function (error) {
                                        $state.go('home.pk.brakDostepu');
                                    }
                                )
                            }, function (error) {
                                $state.go('home.pk.brakDostepu', {token: $location.search().tokenpk});
                            })

                        }]
                }
            })
            .state('home.ankieta', {
                url: '/ankieta/:id',
                templateUrl: 'app/home/ankieta/ankieta.html',
                controller: 'AnkietaController',
                controllerAs: 'vmAnk',
                resolve: {
                    ankieta: ['AnkietyResource', '$q', '$stateParams',
                        function (AnkietyResource, $q, $stateParams) {
                           return AnkietyResource.pobierzAnkiete($stateParams.id)
                           .then(function(ankieta) {
                            if(ankieta) {
                                return ankieta;
                            }
                           }, function(err) {
                                return $q.reject();
                           })
                        }]
                }
            })

            //EXT LOGIN
            .state('extlogin', {
                url: '/extlogin?user&token&idrek',
                controller: 'ExtLoginController'
            })
        //---
        ;

        $urlRouterProvider
            .otherwise('/');
    }

})();
(function() {'use strict'; angular.module('strefaKlienta').constant('malarkey', malarkey).constant('moment', moment).constant('lokalizacjaAPI', '/api').constant('bootstrapKlasa', 'bootstrap-iso-paper')})();

(function() {
  'use strict';

  angular
    .module('strefaKlienta')
    .config(config);

  /** @ngInject */
  function config(RestangularProvider, jwtInterceptorProvider, $httpProvider, lokalizacjaAPI, $compileProvider, $sceDelegateProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|file|blob|ftp):/);
    RestangularProvider.setBaseUrl(lokalizacjaAPI);
    RestangularProvider.setRequestSuffix('/');
    RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response, deferred) {
      var extractedData;
      if (operation === "getList") {
        extractedData = data.results;
        if(angular.isDefined(extractedData)) {
            extractedData.meta = data;
        }
      } else {
        extractedData = data;
      }
      return extractedData;
    });

    jwtInterceptorProvider.tokenGetter = ['store', 'security', function(store, security) {
      security.sprawdzCzyOdswiezycToken();
      return store.get('jwt');
    }];
    $httpProvider.interceptors.push('jwtInterceptor');
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self'
    ]);
  }

})();

angular.module("strefaKlienta").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<wersja-strony-informacja wersja-strony=\"vmMain.wersjaStrony\"></wersja-strony-informacja><div class=\"sell\"><div class=\"loginfo\" ng-if=\"vmMain.logged\">{{vmMain.danePodstawowe.Nazwa}} <a href=\"\" class=\"logout\" ng-click=\"vmMain.logout();\">wyloguj</a></div><div class=\"sellbg\"></div><a ui-sref=\"home.subMain.konto\" class=\"logo\"><img src=\"assets/images/mlogodark.png\"></a></div><div style=\"{{(vmMain.logged) ?\'padding-top:20px;\':\'\'}}\"><div class=\"smallslider\" ng-style=\"{\'background-position\': vmMain.style}\"><div class=\"slogan\"><span ng-if=\"vmMain.state.current.name.indexOf(\'home.subMain.mobilnaekartoteka\') === -1\"><h1></h1></span> <span ng-if=\"vmMain.state.current.name.indexOf(\'home.subMain.mobilnaekartoteka\') !== -1\"><h1></h1></span></div></div></div><ui-view></ui-view><footer></footer><button ng-if=\"vmMain.logged\" id=\"feedbackButton\" style=\"z-index: 10\" ng-click=\"vmMain.zglosSugestie()\">Zgłoś sugestię</button><script type=\"text/ng-template\" id=\"feedbackModal.html\" class=\"bootstrap-iso-paper\"><div class=\"{{vmFb.bootstrapKlasa}}\"> <div class=\"modal-header\"> <h4 class=\"modal-title\"> Oceń strefę klienta </h4> </div> <div class=\"modal-body\"> <div> <h6><span>Chętnie poznamy Twoją opinię na temat nowej strefy klienta.</span></h6> <h6>Jak ją oceniasz (10- jest świetna, 0 - nie podoba mi się)?</h6> </div> <br/> <div class=\"btn-group\" role=\"group\"> <span ng-repeat=\"i in [0,1,2,3,4,5,6,7,8,9,10]\"> <span ng-click=\"vmFb.feedback.ocena=i\" ng-class=\"{\'btn btn-default\': vmFb.feedback.ocena !== $index, \'btn btn-primary\': vmFb.feedback.ocena === $index}\"> {{i}} </span> <br ng-if=\"(i+1)%6 === 0\" class=\"visible-xs visivle-sm\" /> <br ng-if=\"(i+1)%6 === 0\" class=\"visible-xs visivle-sm\" /> </span> </div> <br/> <br/> <div> <div> <h6>Jeśli chcesz napisz nam również swoją sugestię </h6> </div> <br/> <div class=\"clearfix\"></div> <form role=\"form\" style=\"margin-left: 5px; float: none;\"> <label class=\"radio-inline strefaInline\"> <input type=\"radio\" name=\"optradio\" ng-click=\"vmFb.feedback.typ=\'P\'\"> Problem </label> <label class=\"radio-inline strefaInline\"> <input type=\"radio\" name=\"optradio\" ng-click=\"vmFb.feedback.typ=\'S\'\" checked> Propozycja </label> </form> <br/> </div> <div> <textarea id=\"fOpis\" placeholder=\"Tutaj możesz napisać swoją sugestię...\" class=\"form-control\" style=\"resize: vertical\" ng-model=\"vmFb.feedback.tekst\" rows=\"5\"> </textarea> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vmFb.wyslijSugestie()\">Zgłoś sugestię</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"vmFb.cancel()\">Anuluj</button> </div> </div></script><cookie-bar></cookie-bar>");
$templateCache.put("app/main/subMain.html","<klient-menu-bar dostep-do-bety=\"vmSubMain.dostep\"></klient-menu-bar><ui-view></ui-view>");
$templateCache.put("app/services/informacjePopup.html","<div class=\"modal-header\"><h4 class=\"modal-title\" ng-bind-html=\"(vmModal.dane?vmModal.dane[0].naglowek:\'\')\"></h4></div><div class=\"modal-body\"><p ng-bind-html=\"(vmModal.dane?vmModal.dane[0].tresc:\'\')\"></p></div><div class=\"modal-footer\"><div style=\"float:right\"><a class=\"boxed-link\" ng-click=\"vmModal.zamknij()\">Zamknij <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></a></div></div>");
$templateCache.put("app/services/popup.html","<div class=\"modal-header\"><h4 class=\"modal-title\" ng-bind-html=\"(vmModal.dane[0])\"></h4></div><div class=\"modal-body\"><p ng-bind-html=\"(vmModal.dane[1])\"></p></div><div class=\"modal-footer\"><div class=\"bootstrap-iso-paper\" style=\"float:right\"><button style=\"display: inline-block;\" ng-click=\"vmModal.func()\" class=\"btn btn-default btn-sm\" ng-if=\"vmModal.fun!=null\"><span>{{vmModal.params.akceptujTekst ? vmModal.params.akceptujTekst : \'Tak\'}}</span></button> <button style=\"display: inline-block; margin-right: 15px;\" ng-click=\"vmModal.zamknij()\" ng-if=\"!vmModal.params.ukryjAnuluj\" class=\"btn btn-default btn-sm\"><span>{{vmModal.params.anulujTekst ? vmModal.params.anulujTekst : \'Nie\'}}</span></button></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/components/directives/carousel.html","<div ng-carousel=\"\" ng-carousel-name=\"carousel\" ng-carousel-timer=\"5000\" style=\"margin-bottom: 0\"><slidecontainer><slide ng-repeat=\"slide in slides\" style=\"{{slide.bg}}\"><div class=\"slogan\"><h1 ng-class=\"slide.pad\">{{slide.slogan}}<br>{{slide.slogan2}}</h1></div><div class=\"slides\"><a ui-sref=\"{{slide.link}}\"><div class=\"slides button {{slide.pad}}0\" ng-class=\"\">Zobacz</div></a></div></slide></slidecontainer><div class=\"switchprev\" ng-click=\"Carousel.get(\'carousel\').previous()\"></div><div class=\"switchnext\" ng-click=\"Carousel.get(\'carousel\').next()\"></div><div class=\"slider-pointers\" style=\"z-index: 1\"><div ng-repeat=\"slide in slides\" class=\"pointer pt1\" ng-class=\"(Carousel.get(\'carousel\').currentSlide == slide.id)?\'pointerAct\':\'\'\" ng-click=\"(slide.id==0)?Carousel.get(\'carousel\').smartToIndex(0,\'right\'):Carousel.get(\'carousel\').toIndex(slide.id,false)\"></div></div></div>");
$templateCache.put("app/components/directives/cookieBar.html","<div style=\"position: relative; z-index: 1000\"><div style=\"background: #123; position: fixed; bottom: 0; left: 0; right: 0;height: 35px;\" ng-hide=\"consent()\"><p style=\"color: white; text-align: center;padding-top: 5px;\">Serwis wykorzystuje pliki cookies oraz podobne technologie w celach statystycznych, a także w celu dostosowania go do indywidualnych preferencji Klientów oraz osób z niego korzystających, w tym do ulepszenia jego funkcjonalności. <a href=\"https://www.mieszczanin.pl/polityka-prywatnosci\" target=\"_blank\">Więcej informacji</a> <span class=\"cookiebar-button\"><a href=\"\" class=\"cookiebar-button\" ng-click=\"consent(true)\">Ok</a></span></p></div></div>");
$templateCache.put("app/components/directives/dodawaniePlikow-template.html","<style>\n  .drop-box {\n    background: #F8F8F8;\n    border: 5px dashed #DDD;\n    width: 250px;\n    height: 65px;\n    text-align: center;\n    padding-top: 15px;\n    /*margin-right: 20px;*/\n  }\n  .dragover {\n    border: 5px dashed blue;\n  }\n</style><div class=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-allow-dir=\"true\" ngf-capture=\"\'camera\'\" ngf-keep=\"true\" ngf-multiple=\"{{vm.wielokrotneZaznaczanie === undefined ? vm.multiple : vm.wielokrotneZaznaczanie}}\" accept=\"{{vm.formaty}}\" ngf-max-files=\"{{vm.ilePlikow ? vm.ilePlikow : vm.maxFiles}}\" ngf-accept=\"vm.formaty\"><span>Wybierz plik lub upuść tutaj</span></div><div ngf-no-file-drop=\"\">Metoda przeciągnij i upuść nie jest wspierane w tej wersji przeglądarki<div class=\"k-button\" ngf-select=\"\" ng-model=\"vm.files\" ngf-multiple=\"true\" ngf-capture=\"\'camera\'\" accept=\"{{vm.formaty}}\" ngf-accept=\"vm.formaty\" ngf-keep=\"true\">Wybierz plik</div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-striped\" ng-show=\"vm.files.length>0\"><thead><tr><th width=\"70%\">Nazwa</th><th width=\"15%\" class=\"hidden-xs hidden-sm\">Rozmiar</th><th width=\"15%\"></th></tr></thead><tbody><tr ng-repeat=\"item in vm.files\"><td><input ng-model=\"item.nazwaPliku\" ng-init=\"item.nazwaPliku=vm.obetnijRozszerzenie(item.name)\" class=\"form-control ng-pristine ng-valid ng-empty ng-touched\"></td><td nowrap=\"\" class=\"hidden-xs hidden-sm\">{{ item.size/1024 | number: 2}} KB</td><td nowrap=\"\"><a class=\"glyphicon glyphicon-remove\" ng-click=\"vm.usun($index)\"></a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/directives/dodawaniePlikowBezTokena-template.html","<style>\n    .drop-box {\n        background: #F8F8F8;\n        border: 5px dashed #DDD;\n        width: 200px;\n        height: 65px;\n        text-align: center;\n        padding-top: 15px;\n        margin: 10px;\n    }\n\n    .dragover {\n        border: 5px dashed blue;\n    }\n</style><div class=\"{{bootstrapKlasa}}\"><button class=\"btn btn-default\" ng-click=\"dodajDokumenty=true\" ng-show=\"!dodajDokumenty\"><span ng-show=\"!nazwaPrzycisku\">Dodaj dokumenty</span> <span ng-show=\"nazwaPrzycisku\">{{nazwaPrzycisku}}</span></button><div class=\"\" ng-if=\"dodajDokumenty\"><div class=\"col-md-12 col-xs-12\"><div class=\"alert alert-danger\" style=\"padding-top: 4px; padding-bottom: 4px\" role=\"alert\" ng-repeat=\"error in errorMessage\"><a href=\"\" class=\"pull-right\" ng-click=\"errorMessage.splice($index,1)\">x</a> <span class=\"sr-only\">Error:</span> <span class=\"small\">{{error.wiadomosc}}</span></div><div class=\"alert alert-success\" style=\"padding-top: 4px; padding-bottom: 4px\" role=\"alert\" ng-repeat=\"success in successMessage\"><a href=\"\" class=\"pull-right\" ng-click=\"successMessage.splice($index,1)\">x</a> <span class=\"small\">{{success.wiadomosc}}</span></div></div><div class=\"row\" ng-if=\"dodajDokumenty\"><div class=\"col-lg-3 col-xs-12\"><div ngf-drop=\"\" ngf-select=\"\" ng-model=\"files.files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" ngf-capture=\"\'camera\'\" ngf-keep=\"true\" accept=\"{{formaty}}\" ngf-accept=\"formaty\"><span>Upuść tutaj</span></div><div ngf-no-file-drop=\"\">File Drag/Drop is not supported for this browser</div><em style=\"margin-left: 10px;\">lub&nbsp;</em><div class=\"btn btn-default\" ngf-select=\"\" ng-model=\"files.files\" ngf-multiple=\"true\" ngf-capture=\"\'camera\'\" accept=\"{{formaty}}\" ngf-accept=\"formaty\" ngf-keep=\"true\">Wybierz plik</div><button class=\"btn btn-default\" ng-show=\"dozwoloneLinki\" ng-click=\"dodajLink()\">Dodaj link</button></div><div><div class=\"\" style=\"margin-left: 10px;\"><table class=\"table table-striped\" ng-show=\"files.files.length>0\"><thead><tr><th width=\"35%\">Nazwa</th><th width=\"35%\" class=\"hidden-xs hidden-sm\">Plik</th><th width=\"15%\" class=\"hidden-xs hidden-sm\">Rozmiar</th><th width=\"15%\"></th></tr></thead><tbody><tr ng-repeat=\"item in files.files\"><td><input ng-model=\"item.nazwa\" class=\"k-textbox\" ng-init=\"item.nazwa=obetnijRozszerzenie(item.name)\" type=\"text\"></td><td class=\"ukryj_gdy_za_dlugi hidden-xs hidden-sm\">{{ item.name }}</td><td nowrap=\"\" class=\"ukryj_gdy_za_dlugi hidden-xs hidden-sm\">{{ item.size/1024 | number: 2}} KB</td><td><span ng-class=\"plikiOperacje.plik2ikona(item.name)\" class=\"visible-xs visible-sm\"></span></td><td nowrap=\"\"><a ng-click=\"usun($index)\"><strong>x</strong></a></td></tr></tbody></table><div style=\"margin-left: 9px\"><strong ng-show=\"linki.length>0\">Linki:</strong><div class=\"\" ng-repeat=\"link in linki\"><input type=\"text\" class=\"k-textbox\" width=\"100\" style=\"width: 97.3%\" ng-model=\"link.link\"> <span><a class=\"\" ng-click=\"usunLink($index)\">x</a></span></div></div><div ng-show=\"files.files.length>0 || linki.length>0\"><a href=\"\" ng-click=\"wyczyscWszystko()\"><h6>Wyczyść</h6></a></div></div></div></div></div></div>");
$templateCache.put("app/components/directives/dodawaniePlikowZgloszenia.html","<style>\n    .drop-box {\n        background: #F8F8F8;\n        border: 5px dashed #DDD;\n        width: 200px;\n        height: 65px;\n        text-align: center;\n        padding-top: 15px;\n        margin: 10px;\n    }\n\n    .dragover {\n        border: 5px dashed blue;\n    }\n</style><div class=\"{{bootstrapKlasa}}\"><button class=\"btn btn-default\" ng-disabled=\"schowaj\" ng-click=\"dodajDokumenty=true\" ng-show=\"!dodajDokumenty\"><span ng-show=\"!nazwaPrzycisku\">Dodaj dokumenty</span> <span ng-show=\"nazwaPrzycisku\">{{nazwaPrzycisku}}</span></button><div class=\"\" ng-if=\"dodajDokumenty\"><div class=\"col-md-12 col-xs-12\"><div class=\"alert alert-danger\" style=\"padding-top: 4px; padding-bottom: 4px\" role=\"alert\" ng-repeat=\"error in errorMessage\" ng-if=\"pokazPowiadomienia == true\"><a href=\"\" class=\"pull-right\" ng-click=\"errorMessage.splice($index,1)\">x</a> <span class=\"sr-only\">Error:</span> <span class=\"small\">{{error.wiadomosc}}</span></div><div class=\"alert alert-success\" style=\"padding-top: 4px; padding-bottom: 4px\" role=\"alert\" ng-repeat=\"success in successMessage\" ng-if=\"pokazPowiadomienia == true\"><a href=\"\" class=\"pull-right\" ng-click=\"successMessage.splice($index,1)\">x</a> <span class=\"small\">{{success.wiadomosc}}</span></div></div><div class=\"row\" ng-if=\"dodajDokumenty\"><div class=\"col-lg-3 col-xs-12\"><div ngf-drop=\"\" ngf-select=\"\" ng-model=\"files.files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" ngf-capture=\"\'camera\'\" ngf-keep=\"true\" accept=\"{{formaty}}\" ngf-accept=\"formaty\"><span>Upuść tutaj</span></div><div ngf-no-file-drop=\"\">File Drag/Drop is not supported for this browser</div><em style=\"margin-left: 10px;\">lub&nbsp;</em><div class=\"btn btn-default\" ngf-select=\"\" ng-model=\"files.files\" ngf-multiple=\"true\" ngf-capture=\"\'camera\'\" accept=\"{{formaty}}\" ngf-accept=\"formaty\" ngf-keep=\"true\">Wybierz plik</div><button class=\"btn btn-default\" ng-show=\"dozwoloneLinki\" ng-click=\"dodajLink()\">Dodaj link</button></div><div><div class=\"\" style=\"margin-left:15px;\"><table class=\"table table-striped\" ng-show=\"files.files.length>0\" style=\"width: 600px;\"><thead><tr><th width=\"35%\">Nazwa</th><th width=\"35%\" class=\"hidden-xs hidden-sm\">Plik</th><th width=\"15%\" class=\"hidden-xs hidden-sm\">Rozmiar</th><th width=\"10%\"></th></tr></thead><tbody><tr ng-repeat=\"item in files.files\"><td><input ng-model=\"item.nazwaPliku\" class=\"k-textbox\" ng-init=\"item.nazwaPliku=obetnijRozszerzenie(item.name)\" type=\"text\"></td><td class=\"ukryj_gdy_za_dlugi hidden-xs hidden-sm\">{{ item.name }}</td><td nowrap=\"\" class=\"ukryj_gdy_za_dlugi hidden-xs hidden-sm\">{{ item.size/1024 | number: 2}} KB</td><td><span ng-class=\"plikiOperacje.plik2ikona(item.name)\" class=\"visible-xs visible-sm\"></span></td><td nowrap=\"\"><a ng-click=\"usun($index)\"><strong>x</strong></a></td></tr></tbody></table><div style=\"margin-left: 9px\"><strong ng-show=\"linki.length>0\">Linki:</strong><div class=\"\" ng-repeat=\"link in linki\"><input type=\"text\" class=\"k-textbox\" width=\"100\" style=\"width: 97.3%\" ng-model=\"link.link\"> <span><a class=\"\" ng-click=\"usunLink($index)\">x</a></span></div></div><div ng-show=\"files.files.length>0 || linki.length>0\"><a href=\"\" ng-click=\"wyczyscWszystko()\"><h6>Wyczyść</h6></a></div></div></div></div></div></div>");
$templateCache.put("app/components/directives/footer.html","<div class=\"clearfix\"></div><div class=\"footer\"><div class=\"list1\"><img src=\"../../../assets/images/mlogomixed.png\" width=\"250px\"></div><div class=\"list2\" style=\"visibility: hidden;\"><ul><li class=\"listhead\"><a ui-sref=\"home.uslugi.wdrozenie\">Usługi</a></li><li><a ui-sref=\"home.uslugi.wdrozenie\">Wdrożenie</a></li><li><a ui-sref=\"home.uslugi.wsparcie\">Wsparcie<br>powdrożeniowe</a></li><li><a ui-sref=\"home.uslugi.seminaria\">Seminaria</a></li><li><a ui-sref=\"home.uslugi.pozostale\">Pozostałe<br>usługi</a></li></ul></div><div class=\"list3\"><ul><li class=\"listhead\">Dane kontaktowe &nbsp;</li><li>Mieszczanin Informatyka Sp. z o.o.</li><li><b>Pn - Pt. 8:00 - 16:00</b></li><li>ul. Modrzewskiego 42, 41-400 Mysłowice</li><li><b>Telefon</b> <a href=\"tel:323162465\" style=\"margin-left: 20px;\">(32) 316 24 65</a></li><li><b style=\"visibility: hidden;\">Telefon</b> <a href=\"tel:323162466\" style=\"margin-left: 20px;\">(32) 316 24 66</a></li><li><b>e-mail</b> <a href=\"mailto:biuro@mieszczanin.pl\" style=\"margin-left: 25px;\">biuro@mieszczanin.pl</a></li></ul></div><div class=\"clearfix\"></div><div class=\"footermenu2\"><a href=\"https://www.mieszczanin.pl/polityka-prywatnosci\" target=\"_blank\">Polityka prywatności</a></div><p><img class=\"footerlogo\" src=\"assets/images/msygnetw.png\" width=\"15px\" height=\"15px\" alt=\"Mieszczanin - zarządzanie nieruchomościami\"> &copy; {{vm.year}} Mieszczanin</p></div>");
$templateCache.put("app/components/directives/grid-table.html","<div class=\"{{vm.bootstrapKlasa}}\"><div ng-if=\"vm.showLoading\" style=\"position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 20\"><div class=\"horizontal\" style=\"z-index: 20\"><div class=\"vertical\"><img src=\"../assets/images/loadBlue.gif\" align=\"center\" class=\"loadingImage\" width=\"104\" height=\"104\"></div></div></div><div><obsluga-bledow wiadomosci-tablica=\"vm.serverResponses\"></obsluga-bledow></div><form ng-if=\"vm.globalSearch===\'true\'\" name=\"vm.searchForm\" class=\"form-horizontal\" style=\"margin-bottom: -15px; width: 100%;\" novalidate=\"\" ng-submit=\"vm.applyGlobalSearch()\"><fieldset><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Wpisz tekst do wyszukania\" name=\"searchTerm\" ng-model=\"vm.globalSearchTerm\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\"><span>Szukaj</span></button></span></div></div></div></fieldset></form><div class=\"pull-right btn-bottom-margin\"><button class=\"btn btn-primary\" ng-click=\"vm.addElement()\" ng-if=\"vm.allowPost===\'true\'\" title=\"Dodaj element\" ng-disabled=\"vm.disableAddElement\"><span class=\"glyphicon glyphicon-plus\"></span> <span ng-bind=\"vm.addItemText\"></span></button></div><table ng-table-dynamic=\"vm.tableParams with vm.columns\" show-filter=\"{{vm.showFilter}}\" class=\"table table-bordered table-striped\"><tr ng-repeat-start=\"row in $data\" class=\"strefaGridTr\" ng-click=\"vm.rowSelect(row, $index)\" ng-class=\"{\'success\': vm.addSelectedRowClass($index)}\"><td ng-repeat=\"column in $columns\"><span ng-show=\"column.colTemplate && !row.isEditing && column.dataType !==\'command\'\" ng-bind-html=\"vm.wyswietlHTML(column.colTemplate)\" compile-template=\"\"></span> <span ng-show=\"!column.colTemplate && (!row.isEditing || !column.isEditable) && column.dataType !==\'command\'\" ng-class=\"{\'usunWiersz\': row.isDeleting}\">{{row[column.fieldName]}}</span><div ng-show=\"row.isEditing && column.dataType !==\'command\'\"><input ng-if=\"column.dataType === \'text\' && column.isEditable\" type=\"text\" name=\"{{column.fieldName}}\" ng-model=\"row[column.fieldName]\" class=\"editable-input form-control input-sm\" required=\"\"> <input ng-if=\"column.dataType === \'number\' && column.isEditable\" type=\"number\" name=\"{{column.fieldName}}\" ng-model=\"row[column.fieldName]\" class=\"editable-input form-control input-sm\" required=\"\"> <input ng-if=\"column.dataType === \'checkbox\' && column.isEditable\" type=\"checkbox\" name=\"{{column.fieldName}}\" ng-model=\"row[column.fieldName]\" ng-model-options=\"{allowInvalid: true}\" class=\"editable-input form-control input-sm\" required=\"\"></div><div ng-show=\"column.dataType ===\'command\'\" class=\"btn-group\"><div class=\"btn-group\" ng-if=\"row.isEditing\"><button class=\"btn btn-primary btn-sm\" title=\"Zapisz\" ng-click=\"vm.save(row, $event)\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Anuluj\" ng-click=\"vm.cancel(row, $event)\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div class=\"btn-group\" ng-if=\"row.isDeleting\"><button class=\"btn btn-primary btn-sm\" title=\"Zapisz\" ng-click=\"vm.confirmDelete(row, $event)\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Anuluj\" ng-click=\"vm.cancelRemove(row, $event)\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div class=\"btn-group\" ng-if=\"!row.isEditing && !row.isDeleting\"><button class=\"btn btn-default btn-sm\" title=\"Edytuj\" ng-click=\"vm.edit(row, $event)\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Usuń\" ng-click=\"vm.remove(row, $event)\" ng-if=\"vm.allowDelete===\'true\'\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.expanded && vm.rowExpand ===\'true\'\"><td colspan=\"100%\" class=\"podwiersz\"><span ng-bind-html=\"vm.wyswietlHTML(vm.rowExpandTemplate)\" compile-template=\"\"></span></td></tr></table></div><script type=\"text/ng-template\" id=\"myModalContent.html\" class=\"bootstrap-iso-paper\"><div class=\"{{vmModal.bootstrapKlasa}}\"> <!--<div class=\"modal-header\">--> <!--<h3 class=\"modal-title\">Usuń</h3>--> <!--</div>--> <div class=\"modal-body\"> Czy jesteś pewien, że chcesz usunąć obiekt? </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vmModal.ok()\">TAK</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"vmModal.cancel()\">Anuluj</button> </div> </div></script>");
$templateCache.put("app/components/directives/klientMenu.html","<div ng-init=\"vmKlientBar.init()\"><div class=\"adminmenu\" ng-if=\"(vmKlientBar.state.current.name.indexOf(\'home.subMain\') !== -1)\" style=\"z-index:50;\"><ul><li ng-if=\"vmKlientBar.security.jestDostepDoDanychKlienta()\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"home.subMain.konto\" ng-class=\"{\'a1\': (vmKlientBar.state.current.name ===\'home.subMain.konto\') ||vmKlientBar.state.current.name ===\'home.subMain.licencje\' ||vmKlientBar.state.current.name ===\'home.subMain.pobieranie_plyty\' ||vmKlientBar.state.current.name ===\'home.subMain.konsultacje\' ||vmKlientBar.state.current.name ===\'home.subMain.faktury\' ||vmKlientBar.state.current.name ===\'home.subMain.profil\' ||vmKlientBar.state.current.name === \'home.subMain.uslugiPasywne\' ||vmKlientBar.state.current.name === \'home.subMain.panel_zakupowy\' ||vmKlientBar.state.current.name === \'home.subMain.konta_pracownikow\' ||vmKlientBar.state.current.name === \'home.subMain.wykaz_konsultacji\' ||vmKlientBar.state.current.name.indexOf(\'home.subMain.informacje_dedykowane\')!==-1}\">Twoje konto</a><ul><li ng-repeat=\"item in vmKlientBar.menu[\'twoje_konto\']\" ng-if=\"vmKlientBar.dostepy[item.nazwa]==\'undefined\' || vmKlientBar.dostepy[item.nazwa]== true || vmKlientBar.dostepy[item.nazwa] == null\" ui-sref=\"{{item.state}}\"><a>{{item.nazwa}}</a></li></ul></li><li ng-if=\"vmKlientBar.security.jestDostepDoDanychKlienta()\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"home.subMain.dokumentacja\" ng-class=\"{\'a1\': (vmKlientBar.state.current.name.indexOf(\'home.subMain.dokumentacja\')!==-1 ||(vmKlientBar.state.current.name.indexOf(\'home.subMain.regulaminy\')!==-1) ||(vmKlientBar.state.current.name.indexOf(\'home.subMain.co_nowego\')!==-1))}\">Dokumentacja</a><ul><li ng-repeat=\"item in vmKlientBar.menu[\'dokumentacja\']\" ui-sref=\"{{item.state}}\"><a>{{item.nazwa}}</a></li></ul></li><li ng-if=\"vmKlientBar.security.jestPracownikiemMieszczanin() && vmKlientBar.security.getTypUsr() != 6 && vmKlientBar.state.current.name !==\'home.subMain.aktualnosci\'\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"home.subMain.popupEdytor.popupLista\" ng-class=\"{\'a1\': vmKlientBar.state.current.name ===\'home.subMain.popupEdytor.popupLista\'}\">Popup</a><ul><li ng-repeat=\"item in vmKlientBar.menu[\'popupEdytor\']\" ui-sref=\"{{item.state}}\"><a>{{item.nazwa}}</a></li></ul></li><li ng-if=\"vmKlientBar.security.jestPracownikiemMieszczanin() && vmKlientBar.security.getTypUsr() != 6 && vmKlientBar.state.current.name !==\'home.subMain.aktualnosci\'\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"home.subMain.zarzadzaniePlikami\" ng-class=\"{\'a1\': vmKlientBar.state.current.name ===\'home.subMain.zarzadzaniePlikami\'}\">Zarządzanie Plikami</a></li><li ng-if=\"vmKlientBar.security.zalogowanyJakoPracownikMieszczanin() && vmKlientBar.state.current.name !==\'home.subMain.aktualnosci\'\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"home.subMain.generatorDemo\">Generator demo</a><ul><li ng-repeat=\"item in vmKlientBar.menu[\'demo\']\" ui-sref=\"{{item.state}}\"><a>{{item.nazwa}}</a></li></ul></li><li ng-if=\"vmKlientBar.security.jestPracownikiemMieszczanin() && vmKlientBar.state.current.name !==\'home.subMain.aktualnosci\' && vmKlientBar.security.getTypUsr() != 6\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"home.subMain.co_nowego\" ng-class=\"{\'a1\': vmKlientBar.state.current.name ===\'home.subMain.co_nowego\'}\">Co Nowego</a></li><li ng-if=\"vmKlientBar.security.zalogowanyJakoPracownikMieszczanin() && vmKlientBar.state.current.name !==\'home.subMain.aktualnosci\'\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"home.subMain.wol\" ng-class=\"{\'a1\': vmKlientBar.state.current.name ===\'home.subMain.wol\'}\">WOL</a></li><li ng-if=\"vmKlientBar.security.jestPracownikiemMieszczanin() && vmKlientBar.state.current.name !==\'home.subMain.aktualnosci\'\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"home.subMain.podszyciePodKlienta\" ng-class=\"{\'a1\': vmKlientBar.state.current.name ===\'home.subMain.podszyciePodKlienta\'}\">LNK</a></li><li ng-if=\"vmKlientBar.security.jestDostepDoDanychKlienta() && vmKlientBar.dostepy[\'Formularze\']==\'undefined\' || vmKlientBar.dostepy[\'Formularze\']== true || vmKlientBar.dostepy[\'Formularze\'] == null\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"home.subMain.formularze\" ng-class=\"{\'a1\': ((vmKlientBar.state.current.name.indexOf(\'home.subMain.formularze\')!==-1) ||(vmKlientBar.state.current.name.indexOf(\'home.subMain.zamowienie_uslug\')!==-1) ||(vmKlientBar.state.current.name.indexOf(\'home.subMain.zmiana_limitow\')!==-1) ||(vmKlientBar.state.current.name.indexOf(\'home.subMain.zapytaj_informatyka\')!==-1))}\">Formularze</a><ul><li ng-repeat=\"item in vmKlientBar.menu[\'formularze\']\" ui-sref=\"{{item.state}}\"><a>{{item.nazwa}}</a></li></ul></li><li ng-if=\"(vmKlientBar.security.jestDostepDoDanychKlienta() && vmKlientBar.dostepDoBety==true)\" ng-click=\"vmKlientBar.naSkroty=false\"><a ui-sref=\"{{vmKlientBar.security.jestSubUserem() ? \'home.subMain.zgloszenia\' : \'home.subMain.zgloszenia.listaKlienta\'}}\" ng-class=\"{\'a1\': (vmKlientBar.state.current.name.indexOf(\'home.subMain.zgloszenia\')!==-1)}\">Zgłoszenia</a><div class=\"{{vmKlientBar.bootstrapKlasa}}\"><span ng-hide=\"vmKlientBar.liczbaZgloszen.liczbaZgloszen < 1\" class=\"badge badge-important pull-right\" style=\"margin-left: 80px;margin-top: -23px;background-color: crimson\">{{vmKlientBar.liczbaZgloszen.liczbaZgloszen}}</span></div><ul><li ng-repeat=\"item in vmKlientBar.menu[\'zgloszenia\']\" ui-sref=\"{{item.state}}\"><a>{{item.nazwa}}</a></li></ul></li><li ng-if=\"vmKlientBar.security.jestDostepDoDanychKlienta() || vmKlientBar.security.jestPracownikiemMieszczanin()\"><a ui-sref=\"home.subMain.promocje\" ng-class=\"{\'a1\': (vmKlientBar.state.current.name.indexOf(\'home.subMain.promocje\')!==-1)}\">Promocje</a><div class=\"{{vmKlientBar.bootstrapKlasa}}\"><span ng-hide=\"vmKlientBar.security.jestPracownikiemMieszczanin()\" class=\"badge badge-important pull-right\" style=\"margin-left: 80px;margin-top: -23px;background-color: crimson\"><span class=\"fa fa-exclamation\"></span></span></div></li><li ng-click=\"vmKlientBar.naSkroty=false\" ng-if=\"vmKlientBar.security.jestDostepDoDanychKlienta()\"><a ui-sref=\"home.subMain.seminaria\" ng-class=\"{\'a1\': (vmKlientBar.state.current.name.indexOf(\'home.subMain.seminaria\')!==-1 ||(vmKlientBar.state.current.name.indexOf(\'home.subMain.seminariaFZ\')!==-1))}\">Seminaria</a><ul><li ui-sref=\"home.subMain.seminariaArchiwumZapisow\"><a>Archiwum</a></li></ul></li><li ng-click=\"vmKlientBar.naSkroty=false\" ng-if=\"vmKlientBar.security.getTypUsr() == 5\"><a ui-sref=\"home.subMain.seminariaPZ\" ng-class=\"{\'a1\': (vmKlientBar.state.current.name.indexOf(\'home.subMain.seminaria\')!==-1 ||(vmKlientBar.state.current.name.indexOf(\'home.subMain.seminariaPZ\')!==-1))}\">Seminaria</a><ul><li ui-sref=\"home.subMain.seminariaPZ.zapisy\"><a>Zapisy</a></li><li ui-sref=\"home.subMain.seminariaPZ.archiwumZapisow\"><a>Zapisy - archiwum</a></li><li ui-sref=\"home.subMain.seminariaPZ.archiwumSeminariow\"><a>Seminaria - archiwum</a></li><li ui-sref=\"home.subMain.seminariaPZ.dynamicznyTekst\"><a>Tekst na stronie</a></li></ul></li><li ng-click=\"vmKlientBar.naSkroty=false\" ng-if=\"vmKlientBar.security.jestDostepDoDanychKlienta()\"><a ui-sref=\"home.subMain.glosowaniaNaPropozycjeRozwoju\" ng-class=\"{\'a1\': (vmKlientBar.state.current.name.indexOf(\'home.subMain.glosowaniaNaPropozycjeRozwoju\')!==-1 ||(vmKlientBar.state.current.name.indexOf(\'home.subMain.glosowaniaNaPropozycjeRozwoju\')!==-1))}\">Głosowania</a></li><li ng-if=\"vmKlientBar.security.zalogowanyJakoPracownikMieszczanin()\"><a ui-sref=\"home.subMain.cennikEKIEM\" ng-class=\"{\'a1\': vmKlientBar.state.current.name ===\'home.subMain.cennikEKIEM\'}\">Cennik</a></li></ul><div class=\"koszyk-button\" ui-sref=\"home.subMain.zapytanieOfertowe.koszyk\" ng-if=\"vmKlientBar.dostepy[\'Formularze\'] === true && !vmKlientBar.security.jestPracownikiemMieszczanin()\"><i class=\"fa fa-shopping-basket fa-2x\" aria-hidden=\"true\"></i><div class=\"bootstrap-iso-paper\" style=\"margin-top: -15px; margin-right: -15px\" ng-if=\"vmKlientBar.wielkoscKoszyka > 0\"><span class=\"badge badge-important\" style=\"background-color: crimson\">{{vmKlientBar.wielkoscKoszyka}}</span></div></div><div ng-show=\"vmKlientBar.security.jestDostepDoDanychKlienta() && (vmKlientBar.dostepy[\'Aktualizacja\']== true || vmKlientBar.dostepy[\'Licencje\']== true || vmKlientBar.dostepy[\'Wykaz konsultacji\']== true)\" ng-click=\"((vmKlientBar.naSkroty =! vmKlientBar.naSkroty)&&(vmKlientBar.hideNaSkroty = true))\" class=\"short-switch pressable\">Na skróty</div></div><div style=\"{{(!vmKlientBar.hideNaSkroty)?\'display:none\':\'\'}}\" class=\"{{\'quickmenu \' + ((vmKlientBar.state.current.name.indexOf(\'home.subMain\')!==-1)?\'animate-naSkroty\':\'hide\')}}\" ng-show=\"vmKlientBar.naSkroty&& vmKlientBar.security.isLogin() && (vmKlientBar.dostepy[\'Aktualizacja\']== true || vmKlientBar.dostepy[\'Licencje\']== true || vmKlientBar.dostepy[\'Wykaz konsultacji\']== true)\"><h3>Na skróty<div class=\"icon shortcut righticon\"></div></h3><ul class=\"quickmenu\"><li ng-if=\"vmKlientBar.dostepy[\'Aktualizacja\']==\'undefined\' || vmKlientBar.dostepy[\'Aktualizacja\']== true || vmKlientBar.dostepy[\'Aktualizacja\'] == null\"><a ui-sref=\"home.subMain.pobieranie_plyty\" class=\"quickmenu-link\" ng-click=\"vmKlientBar.naSkroty=false\">Pobierz płytę z <b>aktualizacją</b></a></li><li ng-if=\"vmKlientBar.dostepy[\'Licencje\']==\'undefined\' || vmKlientBar.dostepy[\'Licencje\']== true || vmKlientBar.dostepy[\'Licencje\'] == null\"><a ui-sref=\"home.subMain.licencje\" class=\"quickmenu-link\" ng-click=\"vmKlientBar.naSkroty=false\">Pobierz plik z <b>licencją</b></a></li><li ng-if=\"vmKlientBar.dostepy[\'Licencje\']==\'undefined\' || vmKlientBar.dostepy[\'Licencje\']== true || vmKlientBar.dostepy[\'Licencje\'] == null\"><a ui-sref=\"home.subMain.licencje\" class=\"quickmenu-link\" ng-click=\"vmKlientBar.naSkroty=false\">Pobierz <b>certyfikaty</b></a></li><li ng-if=\"vmKlientBar.dostepy[\'Licencje\']==\'undefined\' || vmKlientBar.dostepy[\'Licencje\']== true || vmKlientBar.dostepy[\'Licencje\'] == null\"><a ui-sref=\"home.subMain.licencje\" class=\"quickmenu-link\" ng-click=\"vmKlientBar.naSkroty=false\">Pobierz <b>kod aktywacyjny</b></a></li><li ng-if=\"vmKlientBar.dostepy[\'Wykaz konsultacji\']==\'undefined\' || vmKlientBar.dostepy[\'Wykaz konsultacji\']== true || vmKlientBar.dostepy[\'Wykaz konsultacji\'] == null\"><a ui-sref=\"home.subMain.konsultacje\" class=\"quickmenu-link\" ng-click=\"vmKlientBar.naSkroty=false\">Wyznacz osoby do kontaktu</a></li></ul></div></div>");
$templateCache.put("app/components/directives/mDropdown.html","<div class=\"input-group\"><div class=\"input-group-btn\"><div class=\"\" id=\"main-menu\" data-ng-class=\"{open: vm.open}\" click-out=\"vm.closeThis()\"><button id=\"btn-append-to-body\" type=\"button\" style=\"width: 100px;box-shadow: none; border: 1px solid lightgrey;\" class=\"btn btn-default form-control\" ng-click=\"vm.openDropdown()\" ng-disabled=\"!vm.items.length\">Wybierz <span class=\"caret\"></span></button><div style=\"min-width: {{vm.width}}px\" class=\"dropdown-menu inner\"><div style=\"padding: 15px\" class=\"row\"><div class=\"col-xs-12 bootstrap-iso-paper\"><div class=\"input-group\"><input autofocus=\"\" style=\"width: 100%;\" ng-model=\"vm.search\" tabindex=\"0\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" ng-keypress=\"vm.znajdz($event.keyCode)\" spellcheck=\"false\" placeholder=\"Filtruj\" role=\"textbox\"> <span class=\"input-group-btn\"><button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"vm.znajdz()\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Szukaj</button></span></div></div></div><table ng-if=\"vm.tryb === \'tabela\'\"><tbody><tr data-ng-repeat=\"item in vm.items\" data-ng-click=\"vm.wybierz(item)\"><td ng-repeat=\"wiersz in item.kolumny\">{{wiersz}}</td></tr></tbody></table><ul ng-if=\"vm.tryb !== \'tabela\'\" class=\"m-dropdown-ul\"><li data-ng-repeat=\"item in vm.items\" class=\"m-dropdown-li\" data-ng-click=\"vm.wybierz(item)\"><a><span>{{item.pelnaNazwa}}</span></a></li></ul><div style=\"padding-left: 15px; padding-right: 15px;\" ng-show=\"vm.liczbaPaczek>1\"><ul class=\"pagination pagination-sm\"><li ng-class=\"{disabled : vm.currentPage === 1}\"><a ng-click=\"vm.previousPage()\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></a></li><li ng-repeat=\"page in vm.pagesToPrint\" ng-class=\"{active: vm.currentPage === page}\"><a href=\"\" ng-click=\"vm.setCurrentPage(page)\">{{page}}</a></li><li ng-class=\"{disabled : vm.currentPage === vm.liczbaPaczek}\"><a ng-click=\"vm.nextPage()\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div><input ng-model=\"vm.selected.pelnaNazwa\" class=\"form-control\" disabled=\"\" style=\"padding: 0 10px;border: 1px solid lightgrey;bac\"><div class=\"input-group-btn\" ng-show=\"vm.selected\"><button type=\"button\" style=\"box-shadow: none; border: 1px solid lightgrey;\" class=\"btn btn-default form-control\" ng-click=\"vm.usunZaznaczenie()\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div>");
$templateCache.put("app/components/directives/navbar.html","<div class=\"adminmenu\"><ul><li ng-repeat=\"item in vm.items\"><a ui-sref=\"{{item.state}}\" ng-class=\"{\'a1\': vm.state.current.name === item.state}\">{{item.nazwa}}</a></li></ul></div>");
$templateCache.put("app/components/directives/obslugaBledow.html","<div class=\"{{vm.bootstrapKlasa}}\" id=\"{{vm.id}}\"><div ng-repeat=\"item in vm.wiadomosciTablica\"><div class=\"alert alert-dismissible alert-danger\" ng-if=\"item.typ===\'E\'\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" ng-click=\"vm.wiadomosciTablica.splice($index,1)\">×</button> <strong>{{item.tekst}}</strong></div><div class=\"alert alert-dismissible alert-success\" ng-if=\"item.typ===\'S\'\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" ng-click=\"vm.wiadomosciTablica.splice($index,1)\">×</button> <strong>{{item.tekst}}</strong></div><div class=\"alert alert-dismissible alert-warning\" ng-if=\"item.typ===\'I\'\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" ng-click=\"vm.wiadomosciTablica.splice($index,1)\">×</button> <strong>{{item.tekst}}</strong></div></div></div>");
$templateCache.put("app/components/directives/popup.html","");
$templateCache.put("app/components/directives/pytania.html","<div class=\"pytanie\" style=\"\" ng-repeat=\"item in vm.items\"><span>{{$index + 1}}. {{item.pytanie}}</span><div ng-bind-html=\"item.odpowiedz\"></div></div>");
$templateCache.put("app/components/directives/stringDatepicker.html","<input type=\"date\" ng-model=\"vm.dateDate\" pattern=\"\\d{4}-\\d{2}-\\d{2}\" placeholder=\"yyyy-mm-dd\" required=\"{{vm.required}}\">");
$templateCache.put("app/components/directives/wersjaStronyInformacja.html","<div class=\"wersja-strony\" ng-init=\"vm.init()\" ng-if=\"vm.wersjaStrony\">Zaktualizowano stronę, prosimy o jej odświeżenie (ctrl + f5).</div>");
$templateCache.put("app/components/directives/wyswietlaniePlikow.html","<div ng-repeat=\"plik in vm.pliki\"><a style=\"cursor: pointer\" target=\"_blank\" ng-href=\"{{vm.plikiOperacje.pobierzZwyklyPlik(vm.api, plik.id_dok, plik.IdZal, plik.Nazwa, plik.Sciezka)}}\"><span ng-class=\"vm.plikiOperacje.plik2ikona(plik.Sciezka)\"></span> <strong><small>{{plik.Nazwa}}</small></strong></a></div>");
$templateCache.put("app/home/ankieta/ankieta.html","<div class=\"content\" style=\"width: 100%;\"><h2>Ankieta</h2><div ng-switch=\"vmAnk.stan\"><div ng-switch-when=\"nowa\"><div style=\"font-size: medium;\"><p>Twoja opinia jest dla nas niezwykle ważna. Wypełnij krótką ankietę i pomóż nam udoskonalić proces obsługi zgłoszeń.</p><div style=\"padding-top: 20px; padding-bottom: 20px;\" ng-repeat=\"pytanie in vmAnk.ankieta.odpowiedzi\"><p>{{$index+1}}. {{ pytanie.tresc_pytania }}</p><ocena-gwiazdki ocena=\"pytanie.odpowiedz\" on-change=\"vmAnk.zaznaczonoGwiazdke({zaznaczonaOcena: zaznaczonaOcena})\"></ocena-gwiazdki><p>{{ pytanie.skala ? \"(\" + pytanie.skala + \")\" : \"\"}}</p></div></div><div class=\"{{vmAnk.bootstrapKlasa}}\"><div style=\"padding-top: 20px;\"><button class=\"btn btn-primary\" ng-disabled=\"vmAnk.wysylanie || !vmAnk.moznaWyslac\" ng-click=\"vmAnk.zapisz()\">Wyślij</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmAnk.anuluj()\">Anuluj</button></div></div></div><div ng-switch-when=\"wyslana\"><p style=\"font-size: x-large; text-align: center; margin-top: 40px;\">Dziękujemy za poświęcony czas.</p></div><div ng-switch-when=\"wypelniona\"><p style=\"font-size: x-large; text-align: center; margin-top: 40px;\">Ankieta została już wypełniona, dziękujemy za poświęcony czas.</p></div></div></div>");
$templateCache.put("app/home/aplikacjaMobilnaEK/aplikacjaMobilnaEK.html","<style>\n    html, body {\n        margin: 0;\n        padding: 0;\n    }\n\n    .videogular-container {\n        width: 600px;\n        height: 400px;\n        margin: 0 auto;\n        overflow: hidden;\n    }\n\n</style><div class=\"panefull\" xmlns=\"http://www.w3.org/1999/html\"><aplikacja-mobilna-e-k-navbar on-select=\"vmAppEK.scrollToId(id)\" style=\"margin: 0 auto\"></aplikacja-mobilna-e-k-navbar><div ui-view=\"\"><div class=\"bootstrap-iso-paper\"><div class=\"row\" style=\"margin-top: 40px;\"><div class=\"col-md-9\"><p style=\"line-height: 1.5;text-align: justify;font-size: 14px;\">Witamy na stronie <span style=\"color:crimson\">aplikacji mobilnej e-kartoteka</span>, która będzie dostępna dla Państwa mieszkańców już od <span style=\"color:crimson; white-space: nowrap\">6 grudnia</span>. To intuicyjne i wygodne narzędzie pozwoli mieszkańcom na dostęp do wybranego przez Państwa zakresu informacji o nieruchomości i posiadanych przez nich lokalach z poziomu telefonu. Państwu, jako zarządcom, ułatwi komunikację z mieszkańcami m.in. dzięki powiadomieniom wyświetlanym na telefonach użytkowników. Zakres opcji udostępniony mieszkańcom w <span style=\"color:crimson\">aplikacji mobilnej</span> będzie tożsamy z portalową wersją <span style=\"color:crimson\">e-kartoteki.</span><br><br>W dobie nowoczesnych technologii i dostępu do najważniejszych sfer życia z poziomu telefonu, wyprzedzamy dotychczas dostępne rozwiązania. Jesteśmy przekonani, że <span style=\"color:crimson\">e-kartoteka</span> w wersji <span style=\"color:crimson\">mobilnej</span> w realny sposób przyczyni się do wyróżnienia Państwa oferty na tle innych zarządców.<br><br>Jako pionierzy innowacyjnych rozwiązań informatycznych dla zarządców nieruchomości zapraszamy Państwa do zapoznania się z możliwościami nowoczesnej przestrzeni jaką jest <span style=\"color:crimson\">mobilna e-kartoteka</span>.</p></div><div class=\"col-md-3\"><img src=\"./assets/images/mobilnaek/oaplikacji1.png\" width=\"100%\"></div></div></div><h3>Twoja nieruchomość w twoim telefonie</h3><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-12\"><p style=\"line-height: 1.5;text-align: justify;font-size: 14px;\">Dzięki <span style=\"color:crimson\">aplikacji mobilnej</span> Państwa mieszkańcy będą korzystać z <span style=\"color:crimson\">e-kartoteki</span> z poziomu telefonu. Już teraz sprawdź możliwości nowej <span style=\"color:crimson\">mobilnej</span> przestrzeni, która jest wyjściem zarządców naprzeciw coraz większych oczekiwań mieszkańców.</p><div class=\"content\" style=\"padding-top: 20px;width: 100%\"><div class=\"videogular-container\" style=\"margin: 0 auto;\" ng-if=\"vmAppEK.czyZNapisami === false\"><videogular vg-theme=\"vmAppEK.config.theme.url\"><vg-media vg-src=\"vmAppEK.config.sources\" vg-tracks=\"vmAppEK.config.tracks\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"2000\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play></videogular></div><div class=\"videogular-container\" style=\"margin: 0 auto;\" ng-if=\"vmAppEK.czyZNapisami === true\"><videogular vg-theme=\"vmAppEK.config.theme.url\"><vg-media vg-src=\"vmAppEK.sourceZNapisami\" vg-tracks=\"vmAppEK.config.tracks\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"2000\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play></videogular></div><div style=\"margin-top: 10px;margin-left:180px;\"><a ng-click=\"vmAppEK.czyZNapisami =! vmAppEK.czyZNapisami\">{{(vmAppEK.czyZNapisami === true) ? \'Przejdź do filmu bez napisów\' : \'przejdź do filmu z napisami\'}}</a></div></div></div></div></div><h3>Mobilność</h3><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-12\"><p style=\"line-height: 1.5;text-align: justify;font-size: 14px;\"><span style=\"color:crimson\">Mobilna e-kartoteka</span> to rozwinięcie używanego przez setki tysięcy mieszkańców internetowego portalu <span style=\"color:crimson\">e-kartoteka</span>, który teraz jest dostępny także w wersji <span style=\"color:crimson\">mobilnej</span>. Dzięki temu mieszkańcy będą mieć pełen dostęp do wszystkich najważniejszych informacji związanych z użytkowanym lokalem poprzez wygodną <span style=\"color:crimson\">aplikację</span> w telefonie.<br><br><span style=\"color:crimson\">Mobilna e-kartoteka</span> od <b>6 grudnia</b> będzie dostępna dla dwóch najważniejszych systemów operacyjnych: iOS i Android. Jej pobranie będzie bezpłatne i możliwe poprzez sklepy App Store i Google Play, a instalacja będzie niezwykle prosta i intuicyjna. <a ui-sref=\"home.subMain.mobilnaekartoteka.jakzaczac\">Dowiedz się jak zainstalować <span style=\"color:crimson;white-space: nowrap\">mobilną aplikację e-kartoteka</span></a>.</p></div></div></div><div style=\"width: 100%\"><div style=\"margin-top: 40px;\"><div style=\"width: 240px;display: inline-block;float: left;\"><img src=\"./assets/images/mobilnaek/oaplikacji2.png\" width=\"100%\"></div><div style=\"width: 680px;display: inline-block; float: right\"><h3>Funkcjonalność</h3><p style=\"line-height: 1.5;text-align: justify;font-size: 14px;\">Pobierając już <b>6 grudnia</b> <span style=\"color:crimson\">mobilną aplikację e-kartoteka</span>, Państwa mieszkańcy otrzymają pełen dostęp do rozliczeń użytkowanych lokali w swoim telefonie.<br><br>Pełna funkcjonalność wersji <span style=\"color:crimson\">mobilnej</span>, to dostępność wszystkich wybranych przez Państwa funkcji znanych mieszkańcom z internetowego portalu <span style=\"color:crimson\">e-kartoteka</span>. <span style=\"color:crimson\">Aplikacja mobilna</span> umożliwia kontrolę wysokości opłat, stanu rozrachunków i łatwe wykonanie wszystkich płatności, a także- jeśli Państwa firma korzysta z szerszego zakresu <span style=\"color:crimson\">e-kartoteki</span> - zgłoszenie usterki, zapoznanie się z planowanymi pracami remontowymi czy kontakt z zarządcą. Wszystkie czynności wykonujemy z poziomu telefonu poprzez nowoczesną <span style=\"color:crimson\">aplikację mobilną e-kartoteka</span>.</p></div></div></div><div style=\"\"><h3 style=\"margin-top: 370px;\">Swoboda w zarządzaniu</h3><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-12\"><p style=\"line-height: 1.5;text-align: justify;font-size: 14px;\">W dobie nowoczesnych technologii i dostępu do najważniejszych sfer życia z poziomu telefonu, <span style=\"color:crimson\">mobilna aplikacja</span> to obecnie nie tylko atut, ale wręcz konieczność, wynikająca z oczekiwań mieszkańców. To również przewaga konkurencyjna zarządców wykorzystujących innowacyjne narzędzia <span style=\"color:crimson\">mobilne</span>.<br><br>Poprzez <span style=\"color:crimson\">aplikację mobilną e-kartoteka</span> oddajemy do dyspozycji Państwa mieszkańców pakiet komfortowych rozwiązań, pozwalających na wygodny dostęp do ważnych informacji o posiadanych lokalach w telefonie.<br><br></p><p style=\"line-height: 1.5;text-align: center;font-size: 14px;\"><span style=\"color: crimson;text-align: center\">Więcej informacji znajdziecie państwo w zakładkach:</span> <a ui-sref=\"home.subMain.mobilnaekartoteka.jakzaczac\">jak zacząć</a>, <a ui-sref=\"home.subMain.mobilnaekartoteka.instrukcja\">instrukcja</a>, <a ui-sref=\"home.subMain.mobilnaekartoteka.faq\">najczęstsze pytania</a>.</p></div></div></div></div><div><h3 class=\"\">Zobacz również</h3><a class=\"productlink\" href=\"https://www.mieszczanin.pl/rozwiazania/e-kartoteka\" target=\"_blank\"><h3><div class=\"icon-ek-34\"></div>e-kartoteka</h3><p>Uniwersalne narzędzie do komunikacji z mieszkańcami i najemcami.</p></a></div></div></div>");
$templateCache.put("app/home/aplikacjaMobilnaEK/dlaMieszkanca.aplikacjaMobilnaEK.html","<div style=\"min-height: 400px;\"><h3>Dla mieszkańca</h3><p style=\"padding: 0 10px;line-height: 1.5\"><b>Już niebawem aplikacja mobilna e-kartoteka w Twoim telefonie</b><br><br>Udostępniamy Państwu do pobrania szablony materiałów do wykorzystania w różnych formach przekazu związanych z aplikacją mobilną e-kartoteka:</p><ul style=\"padding-left: 10px;\"><li class=\"bootstrap-iso-paper\" style=\"margin-bottom: 0\">szablon ogłoszenia do umieszczenia na tablicy ogłoszeń w e-kartotece lub na Państwa stronie internetowej: <a href=\"./assets/files/SZABLON_ogloszenia_zarzadcy_do_mieszkancow.docx\" target=\"_blank\">pobierz dokument</a></li><li class=\"bootstrap-iso-paper\" style=\"margin-bottom: 0\">wzór wpisu nowego wątku na forum dyskusyjnym e-kartoteki: <a href=\"./assets/files/WPIS_zarzadcy_forum_mieszkancow.docx\" target=\"_blank\">pobierz dokument</a></li><li class=\"bootstrap-iso-paper\" style=\"margin-bottom: 0\">szablon ogłoszenia do wykorzystania w mediach społecznościowych: <a href=\"./assets/files/SZABLON_komunikat_media_spolecznosciowe_zarzadcy.docx\" target=\"_blank\">pobierz dokument</a></li><li class=\"bootstrap-iso-paper\" style=\"margin-bottom: 0\">link do filmu z podstawowymi informacjami o aplikacji mobilnej: <a href=\"https://www.youtube.com/watch?v=gW6PbEqzMNE\" target=\"_blank\">przejdź do filmu</a></li></ul><p style=\"padding: 0 10px;line-height: 1.5\">Mamy nadzieję, że udostępnione materiały okażą się pomocne. Gdyby mieli Państwo dodatkowe potrzeby w tym zakresie prosimy o ich zasygnalizowanie przez System Zgłoszeń.</p></div>");
$templateCache.put("app/home/aplikacjaMobilnaEK/faq.aplikacjaMobilnaEK.html","<div style=\"min-height: 400px;\"><h3>Najczęściej zadawane pytania</h3><pytania items=\"vmAppEKFAQ.pytania\"></pytania></div>");
$templateCache.put("app/home/aplikacjaMobilnaEK/instrukcja.aplikacjaMobilnaEK.html","<div style=\"min-height: 400px;\"><h3>Instrukcja</h3><div class=\"bootstrap-iso-paper\"><div class=\"row\" style=\"margin-top: 40px;\"><div class=\"col-md-9\"><p style=\"line-height: 1.5;text-align: justify;font-size: 14px;\">Udostępniamy Państwu do pobrania Instrukcję <span style=\"color: crimson\">Użytkownika aplikacji mobilnej e-karoteka</span>. Dokument w formacie pdf zawiera pełne informacje dotyczące:</p><ul><li style=\"margin-bottom: 0\">wymagań technicznych,</li><li style=\"margin-bottom: 0\">procesu instalacji,</li><li style=\"margin-bottom: 0\">konfiguracji,</li><li style=\"margin-bottom: 0\">pełnej funkcjonalności,</li></ul><p style=\"line-height: 1.5;text-align: justify;font-size: 14px;\">które pomogą mieszkańcom w swobodnym rozpoczęciu pracy i korzystaniu z aplikacji. Aby otworzyć lub pobrać instrukcję, <b>kliknij na rysunek obok</b>.</p></div><div class=\"col-md-3\"><a href=\"./assets/files/instrukcja-mobilna-ekartoteka.pdf\" target=\"_blank\"><img src=\"./assets/images/mobilnaek/pobierz.png\" width=\"100%\"></a></div></div></div></div>");
$templateCache.put("app/home/aplikacjaMobilnaEK/jakZaczac.aplikacjaMobilnaEK.html","<h3>Instalacja <span style=\"color: crimson\">aplikacji</span></h3><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-12\"><p style=\"line-height: 1.5;text-align: justify;font-size: 14px;\"><b>Krok 1.</b> Wejdź do dedykowanego dla Twojego smartfonu sklepu internetowego z <span style=\"color: crimson;\">aplikacjami</span> (App Store dla telefonów z systemem iOS lub Google Play dla telefonów z systemem Android)<br><b>Krok 2.</b> W wyszukiwarce sklepu wpisz nazwę aplikacji <span style=\"color: crimson;\">\"e-kartoteka\"</span>.<br><b>Krok 3.</b> Pobierz <span style=\"color: crimson;\">aplikację</span> na swój telefon.</p></div></div></div><h3>Pierwsze logowanie do <span style=\"color: crimson\">aplikacji mobilnej</span></h3><div><p style=\"line-height: 1.5;text-align: justify;font-size: 14px;\"><b>Krok 1.</b> Uruchom <span style=\"color: crimson;\">aplikację mobilną e-kartoteka</span>.</p><div style=\"line-height: 1.5;margin: 20px; padding:30px; text-align:center;border: 2px solid; border-color: lightgrey;border-radius: 2px;\">Aby rozpocząć korzystanie z <span style=\"color: crimson;\">aplikacji mobilnej e-kartoteka</span> niezbędne jest założenie Konta technicznego,<br>które pozwala na dostęp do aplikacji oraz na wygodne przełączanie się między kontami <span style=\"color: crimson;\">e-kartoteki</span>.</div><div style=\"width: 600px;margin: 0 auto;\"><img src=\"./assets/images/mobilnaek/jakzaczac1.png\" width=\"100%\" alt=\"\"></div><h4>Tworzenie konta technicznego</h4><div style=\"line-height: 1.5;text-align: justify;font-size: 14px; padding-left: 10px;\">Wybierz przycisk Utwórz konto techniczne.<br><br><b>Krok 1.</b> W pola Login i Hasło wprowadź dane dostępowe, które służą do logowania do portalu internetowego <span style=\"color: crimson;\">e-kartoteka</span>. Następnie wybierz przycisk <b>Zaloguj</b>.<br><br><b>Krok 2.</b> Wprowadź dane potrzebne do utworzenia Konta Technicznego: e-mail oraz hasło. Dodatkowo do potwierdzenia poprawności wprowadzonego hasła wpisz je ponownie w okno Powtórz hasło. Jednocześnie zaakceptuj Regulamin Konta technicznego oraz klauzulę związaną z ochroną danych osobowych. na koniec wybierz przycisk <b>Utwórz konto techniczne</b>.<br><br><b>Krok 3.</b> Na ekranie pojawi się okno, w które należy wpisać kod weryfikacyjny przesłany na podany adres e-mail. Po wprowadzeniu kodu wybierz przycisk <b>Zweryfikuj adres e-mail</b>. Weryfikacja adresu e-mail jest konieczna, aby można było skorzystać z procedury odzyskania hasła. Można ją przeprowadzić w późniejszym czasie - w tym celu należy skorzystać z odnośnika znajdującego się w wiadomości e-mail. Aby odłożyć weryfikację adresu e-mail należy wybrać przycisk <b>Zweryfikuj później</b>.<br><br><b>Ważna informacja:</b> jeśli chcesz zweryfikować adres e-mail w późniejszym czasie, upewnij się, że wiadomość e-mail do Ciebie dotarła i masz ją w swojej skrzynce poczty elektronicznej.<br><br>Od tego momentu Twoje konto techniczne jest już aktywne. Możesz się zalogować do <span style=\"color: crimson;\">aplikacji</span>.</div><h4>Konfiguracja konta technicznego</h4><div style=\"line-height: 1.5;text-align: justify;font-size: 14px;padding-left: 10px;\">Przy pierwszym zalogowaniu do konta technicznego następuje dwuetapowa konfiguracja.<br><br>Krok1. W pierwszym kroku możesz ustawić czterocyfrowy kod PIN, aby jeszcze wygodniej logować się do <span style=\"color: crimson;\">aplikacji mobilnej e-kartoteka</span>. Jeśli nie jesteś zainteresowany ustawieniem kodu PIN wybierz przycisk POMIŃ. Kod PIN można także ustawić później w <b>aplikacji</b>.<br><br>Krok2. Jeśli masz inne konta <span style=\"color: crimson;\">e-kartoteki</span> możesz je teraz dodać do Twojego Konta technicznego, by wygodniej się między nimi przełączać. Aby kontynuować wprowadź dane w pola Login <span style=\"color: crimson;\">e-kartoteki</span> (kolejnego konta) oraz Hasło, a następnie wybierz przycisk Dodaj Konto.<br><br>Jeśli nie chcesz dodać innego konta wybierz przycisk Przejdź do <span style=\"color: crimson;\">e-kartoteki</span>. Ta operacja może być także wykonana w późniejszym czasie, po zalogowaniu do <span style=\"color: crimson;\">aplikacji</span>.<br><br>Ważna informacja: możesz dodać kolejne konta <span style=\"color: crimson;\">e-kartoteki</span> w czasie późniejszym.</div><h4><span style=\"color: crimson;\">Mobilna e-kartoteka</span> gotowa do użytku</h4><div style=\"line-height: 1.5;text-align: justify;font-size: 14px;padding-left: 10px;\">Po zalogowaniu <span style=\"color: crimson;\">aplikacja mobilna e-kartoteka</span> jest gotowa do użytku. Jej zakres funkcjonalności odpowiada opcjom dostępnym w portalu internetowym <span style=\"color: crimson;\">e-kartoteka</span>. Aby sprawdzić dostępne informacje wybierz na ekranie głównym zakładkę Opcje.</div><br><br><p style=\"line-height: 1.5;text-align: center;font-size: 14px;\" class=\"bootstrap-iso-paper\"><span style=\"color: crimson;text-align: center\">Więcej informacji znajdziecie państwo w zakładkach:</span> <a ui-sref=\"home.subMain.mobilnaekartoteka.instrukcja\">instrukcja</a>, <a ui-sref=\"home.subMain.mobilnaekartoteka.faq\">najczęstsze pytania</a>.</p></div><div><h3 class=\"\">Zobacz również</h3><a class=\"productlink\" href=\"https://www.mieszczanin.pl/rozwiazania/e-kartoteka\" target=\"_blank\"><h3><div class=\"icon-ek-34\"></div>e-kartoteka</h3><p>Uniwersalne narzędzie do komunikacji z mieszkańcami i najemcami.</p></a></div>");
$templateCache.put("app/home/aplikacjaMobilnaEK/pomoc.aplikacjaMobilnaEK.html","<div style=\"min-height: 400px;\"><h3>Pomoc</h3><p style=\"padding: 0 10px;line-height: 1.5\">Wszystkie informacje dotyczące aplikacji zostały dla Państwa możliwie szczegółowo opisane i są zawarte <b>w treści tej strony</b> - są one również na bieżąco uzupełniane i aktualizowane, aby strona ta była głównym i pełnym źródłem informacji o nowej aplikacji.<u>Zanim więc zdecydują się Państwo na bezpośredni kontakt z nami, bardzo prosimy więc o dokładne zapoznanie się z poszczególnymi zakładkami</u>.<br><br>Gdzie znajdę:</p><div style=\"padding: 0 10px;line-height: 1.5;\"><ul class=\"bootstrap-iso-paper\" style=\"padding-top: 0; margin-top: 0;\"><li style=\"margin-bottom: 0\">ogólne <b>informacje o aplikacji</b>, korzyści z użytkowania i film instruktażowy: <a ui-sref=\"home.subMain.mobilnaekartoteka\"><u>o aplikacji</u></a>,</li><li style=\"margin-bottom: 0\">istotne szczegóły związane z <b>rozpoczęciem użytkowania</b> aplikacji przez mieszkańców: <a ui-sref=\"home.subMain.mobilnaekartoteka.jakzaczac\"><u>jak zacząć</u></a>,</li><li style=\"margin-bottom: 0\">pełna <b>instrukcja</b> obsługi aplikacji: <a ui-sref=\"home.subMain.mobilnaekartoteka.instrukcja\"><u>instrukcja</u></a>,</li><li style=\"margin-bottom: 0\">najczęstsze <b>pytania</b> związane z aplikacją: <a ui-sref=\"home.subMain.mobilnaekartoteka.faq\"><u>najczęstsze pytania</u></a>,</li><li style=\"margin-bottom: 0\">informacje, którymi zarządcy będą mogli wesprzeć mieszkańców w sprawach związane z aplikacją: <a ui-sref=\"home.subMain.mobilnaekartoteka.dlamieszkanca\"><u>dla mieszkańca</u></a>.</li></ul></div><p style=\"padding: 0 10px;line-height: 1.5\" class=\"bootstrap-iso-paper\">Jeśli w materiale dostępnym na tej stronie nie znaleźli Państwo niezbędnych informacji, lub potrzebują pomocy w temacie konfiguracji i obsługi usługi e-kartoteka, prosimy o skorzystanie z <b>Systemu Zgłoszeń</b>, poprzez opcję Zrób Zgłoszenie bezpośrednio z naszych programów, lub z zakładki <a ui-sref=\"home.subMain.zgloszenia\"><u>Zgłoszenia</u></a> dostępnej po zalogowaniu się na <b>konto pracownika</b> w Strefie Klienta.</p></div>");
$templateCache.put("app/home/bazaWiedzy/bazaWiedzy.html","<div class=\"panefull\" style=\"min-height: 400px;\"><strefa-grid api=\"{{vmBaza.api}}\" request-params=\"{{vmBaza.requestParams}}\" columns=\"vmBaza.columns\" selected-item=\"vmBaza.selectedItem\" row-expand=\"true\" row-expand-template=\"{{vmBaza.rowTemplate}}\" row-expand-multiple=\"false\" show-filter=\"false\" ctrl=\"vmBaza\"></strefa-grid></div><script type=\"text/x-kendo-template\" id=\"rowTemplate\"><div> Podwiersz {{row.IdKli}} <button class=\"btn btn-danger\" ng-click=\"vm.runExtFunction(\'clickTemplate\', row)\">click</button></div></script>");
$templateCache.put("app/home/demo/demo.html","<div ng-if=\"vmDemo.loaded==true\"><h2>Demo</h2><p style=\"font-size: 18px;text-align: center;\"></p><div style=\"display: table; margin: 50px auto;padding-bottom: 60px;\"><a class=\"boxed-link\" ng-href=\"{{vmDemo.download()}}\" ng-click=\"vmDemo.updateDownloadDate()\" target=\"_blank\" style=\"padding: 10px 20px;font-size: 15px;\" download=\"\"><b>Pobierz demo</b> <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></a></div></div>");
$templateCache.put("app/home/demo/generatorDemo.html","<div><h2>Generator Demo</h2><obsluga-bledow wiadomosci-tablica=\"vmGeneratorDemo.odpowiedziSerwera\"></obsluga-bledow><h4 ng-if=\"vmGeneratorDemo.adres.length>0\">Adres wygenerowanej licencji: <a href=\"{{vmGeneratorDemo.adres}}\">{{vmGeneratorDemo.adres}}</a><div class=\"{{vmGeneratorDemo.bootstrapKlasa}}\"><button style=\"float: right;margin-top:-25px;display: inline-block; margin-right: 240px;\" class=\"btn btn-primary btn-sm\" title=\"Kopiuj\" ngclipboard=\"\" data-clipboard-text=\"{{vmGeneratorDemo.adres}}\"><span>Kopiuj</span></button></div></h4><table style=\"border: 2px solid #f0f0f0; min-width: 500px;\"><tr><th colspan=\"2\" style=\"padding: 10px;\"><b>Wybierz wersję EZN</b></th></tr><tr style=\"text-align: center;\" ng-repeat=\"wersja in vmGeneratorDemo.software\"><td style=\"{{((vmGeneratorDemo.selectedSoftware==wersja.wersja)?\'background-color:#DFF0D8;\':\'\') + \'border: 1px solid #f0f0f0; padding: 10px; width: 50%;cursor:pointer;\'}}\" ng-if=\"vmGeneratorDemo.software.indexOf(wersja)%2==0\" ng-click=\"vmGeneratorDemo.selectedSoftware=wersja.wersja;\"><span><a href=\"\">{{wersja.wersja}}</a></span></td><td style=\"{{((vmGeneratorDemo.selectedSoftware==vmGeneratorDemo.software[vmGeneratorDemo.software.indexOf(wersja)+1].wersja)?\'background-color:#DFF0D8;\':\'\') + \'border: 1px solid #f0f0f0; padding: 10px; width: 50%;cursor:pointer;\'}}\" ng-if=\"vmGeneratorDemo.software.indexOf(wersja)%2==0\" ng-click=\"vmGeneratorDemo.software[vmGeneratorDemo.software.indexOf(wersja)+1].wersja!=null ? vmGeneratorDemo.selectedSoftware=vmGeneratorDemo.software[vmGeneratorDemo.software.indexOf(wersja)+1].wersja : \'\'\"><span><a href=\"\">{{vmGeneratorDemo.software[vmGeneratorDemo.software.indexOf(wersja)+1].wersja}}</a></span></td></tr></table><table style=\"border: 2px solid #f0f0f0; min-width: 500px;margin-top: 10px;\" ng-if=\"vmGeneratorDemo.selectedSoftware>=17\"><tr><th colspan=\"2\" style=\"padding: 10px;\"><b>Wersja ASA</b></th></tr><tr style=\"text-align: center;\"><td style=\"{{((vmGeneratorDemo.selectedAsa==11 || vmGeneratorDemo.selectedAsa==0)?\'background-color:#DFF0D8;\':\'\') + \'border: 1px solid #f0f0f0; padding: 10px; width: 50%;cursor:pointer;\'}}\" ng-click=\"vmGeneratorDemo.selectedAsa=11\">ASA 11</td><td style=\"{{((vmGeneratorDemo.selectedAsa==17 )?\'background-color:#DFF0D8;\':\'\') + \'border: 1px solid #f0f0f0; padding: 10px; width: 50%;cursor:pointer;\'}}\" ng-click=\"vmGeneratorDemo.selectedAsa=17\">ASA 17</td></tr></table><label style=\"width: 90px;\" for=\"nazwaFirmy\">Nazwa firmy:</label> <input style=\"width: 375px;\" ng-model=\"vmGeneratorDemo.company\" id=\"nazwaFirmy\" placeholder=\"nazwaFirmy\" type=\"text\"><h5>Czy chcesz wygenerować demo EZN {{vmGeneratorDemo.selectedSoftware}} dla firmy {{vmGeneratorDemo.company}}?</h5><div style=\"float:left;display: inline-block\"><a class=\"boxed-link\" ng-click=\"vmGeneratorDemo.generateDemo()\" style=\"padding: 10px 20px;font-size: 15px;\"><b>Generuj</b> <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></a></div></div>");
$templateCache.put("app/home/demo/listaDemo.html","<div><h3>Lista wygenerowanych wersji demo</h3><table class=\"minetable\" style=\"border:1px solid lightgrey;margin-top: 20px;width: 100%;\"><tr style=\"padding-top: 15px;border-bottom:2px solid lightgrey;height: 40px;\"><td style=\"width:80px;padding-left:0;text-align: center;padding-top: 15px;\">Firma</td><td style=\"width:100px;padding-left:0;text-align: center;padding-top: 15px;\">Adres</td><td style=\"width:100px;padding-left:0;text-align: center;padding-top: 15px;\">Data utworzenia</td><td style=\"width:130px;padding-left:0;text-align: center;padding-top: 15px;\">Data pobrania</td></tr><tr ng-repeat=\"element in vmListaDemo.lista.slice((vmListaDemo.currTab-1)*vmListaDemo.pagination,(vmListaDemo.currTab*vmListaDemo.pagination))\"><td style=\"text-align: center;padding-top: 15px;padding-left:0;width:30%\">{{element.Firma}}</td><td style=\"text-align: center;padding-left:0;\" width=\"40%\">{{ \'https://strefaklienta.mieszczanin.pl/#/demo?lic=\'+ element.LinkLic }}</td><td style=\"text-align: center;padding-left:0;\" width=\"15%\">{{element.DataUtw | date : \"dd.MM.yyyy\"}}</td><td style=\"text-align: center;padding-left:0;\" width=\"15%\"><span ng-if=\"element.DataPobr!=null\">{{element.DataPobr | date : \"dd.MM.yyyy\"}}</span> <span ng-if=\"element.DataPobr==null\">Nie pobrano</span></td></tr></table><div class=\"bootstrap-iso-paper\" style=\"z-index: 0;\"><ul class=\"pagination ng-table-pagination\"><li class=\"{{(vmListaDemo.currTab <=1)?\'disabled ng-scope\':\'\'}}\"><a ng-click=\"vmListaDemo.prev()\" href=\"\" class=\"ng-scope\">«</a></li><li ng-if=\"vmListaDemo.paginatorBreaker>0\"><a ng-click=\"vmListaDemo.prev()\" href=\"\" class=\"ng-scope\">...</a></li><li ng-repeat=\"tab in vmListaDemo.allTabs\" class=\"{{(vmListaDemo.currTab == tab)?\'active ng-scope\':\'\'}}\"><a ng-click=\"(vmListaDemo.currTab = tab)\" href=\"\" class=\"ng-scope\"><span class=\"ng-scope\">{{tab}}</span></a></li><li ng-if=\"vmListaDemo.paginatorBreaker<(vmListaDemo.allTabs.length/10 )-1\"><a ng-click=\"vmListaDemo.prev()\" href=\"\" class=\"ng-scope\">...</a></li><li class=\"{{(vmListaDemo.currTab >= vmListaDemo.allTabs.length || vmListaDemo.allTabs.length == 0)?\'disabled ng-scope\':\'\'}}\"><a ng-click=\"vmListaDemo.next()\" href=\"\" class=\"ng-scope\">»</a></li></ul></div><br></div>");
$templateCache.put("app/home/cennikEKIEM/akceptacjaRegulaminow.html","<div class=\"row\"><div class=\"col-md-12\"><h3>Regulaminy usług</h3></div><div><input type=\"checkbox\" ng-checked=\"vmEKIEM.ackRegulaminEK && vmEKIEM.ackRegulaminEM && vmEKIEM.ackRegulaminUSLZ\" ng-click=\"vmEKIEM.zaakceptujWszystkieRegulaminy()\" id=\"zaakceptuj-wszystkie\" ng-disabled=\"vmEKIEM.ackRegulaminEK && vmEKIEM.ackRegulaminEM && vmEKIEM.ackRegulaminUSLZ\"> <label class=\"checkboxlabel\" for=\"zaakceptuj-wszystkie\">Zaakceptuj wszystkie zgody*</label></div><div style=\"margin-left: 1rem;\"><div><input type=\"checkbox\" ng-model=\"vmEKIEM.ackRegulaminEK\" id=\"regulamin-ek\" required=\"\"> <label class=\"checkboxlabel\" for=\"regulamin-ek\"><a ng-click=\"vmEKIEM.pobierzRegulamin(\'regulamin-e-kartoteki\')\">Regulamin e-kartoteki*</a></label></div><div><input type=\"checkbox\" ng-model=\"vmEKIEM.ackRegulaminEM\" id=\"regulamin-em\" required=\"\"> <label class=\"checkboxlabel\" for=\"regulamin-em\"><a ng-click=\"vmEKIEM.pobierzRegulamin(\'regulamin-e-mieszczanina\')\">Regulamin systemu e-Mieszczanin*</a></label></div><div><input type=\"checkbox\" ng-model=\"vmEKIEM.ackRegulaminUSLZ\" id=\"regulamin-uslug-zintegrowanych\" required=\"\"> <label class=\"checkboxlabel\" for=\"regulamin-uslug-zintegrowanych\"><a ng-click=\"vmEKIEM.pobierzRegulamin(\'regulamin-uslug-zintegrowanych\')\">Regulamin usług zintegrowanych*</a></label></div></div></div>");
$templateCache.put("app/home/cennikEKIEM/cennik.html","<div><div class=\"row\"><div class=\"col-md-12\" style=\"margin-bottom: 50px\"><h2>Cennik e-kartoteki i systemu e-Mieszczanin</h2></div></div><div class=\"pane23\"><div class=\"col-md-12\" ng-if=\"vmEKIEM.czyZarzadzaLokalami == true || vmEKIEM.posiadaLokale\"><h3 style=\"margin-top: 0\">Informacja o lokalach</h3></div><div ng-if=\"vmEKIEM.posiadaLokale && !vmEKIEM.ukryjWyborZarzadzaniaLokalami\"><div><input type=\"radio\" ng-model=\"vmEKIEM.czyZarzadzaLokalami\" ng-value=\"false\" ng-checked=\"false\" ng-change=\"vmEKIEM.przelaczZarzadzanieLokalami()\" id=\"nie_zarzadza_lokaliami\"> <label class=\"checkboxlabel\" for=\"nie_zarzadza_lokaliami\">Zaznacz jeśli nie zarządzasz lokalami</label></div><div><input type=\"radio\" ng-model=\"vmEKIEM.czyZarzadzaLokalami\" ng-value=\"true\" ng-checked=\"true\" ng-change=\"vmEKIEM.przelaczZarzadzanieLokalami()\" id=\"zarzadza_lokaliami\"> <label class=\"checkboxlabel\" for=\"zarzadza_lokaliami\">Zaznacz jeśli zarządzasz lokalami</label></div></div><div ng-if=\"vmEKIEM.ukryjWyborZarzadzaniaLokalami\" style=\"padding-left: 1.7rem;\"><p>Liczba zarządzanych lokali: {{vmEKIEM.aktualnaLiczbaLokali}} <a class=\"fa fa-question-circle-o\" ng-click=\"vmEKIEM.pokazSzczegolyCeny()\" style=\"font-size: large\"></a></p></div><div style=\"padding-left: 1.7rem\" ng-if=\"vmEKIEM.czyZarzadzaLokalami == true && vmEKIEM.posiadaLokale\"><liczba-lokali-dropdown zaznaczone=\"vmEKIEM.lokale\" slownik-cen-limitow-lokali=\"vmEKIEM.slownikCenLimitowLokali\" on-change=\"vmEKIEM.przelicz()\"></liczba-lokali-dropdown></div><div class=\"contactinfo\" ng-show=\"vmEKIEM.lokale == \'more50k\'\"><h3>* Skontaktuj się z działem handlowym</h3><p>W przypadku liczby zarządzanych lokali większej niż 50.000 prosimy o kontakt z działem handlowym w celu indywidualnego dopasowania oferty.</p></div><div ng-show=\"vmEKIEM.lokale != \'more50k\'\"><ng-include src=\"\'app/home/cennikEKIEM/opcjePodstawoweEK.html\'\" ng-if=\"vmEKIEM.czyZarzadzaLokalami && vmEKIEM.posiadaLokale\"></ng-include><ng-include src=\"\'app/home/cennikEKIEM/cennikEK.html\'\" ng-if=\"vmEKIEM.czyZarzadzaLokalami && vmEKIEM.posiadaLokale\"></ng-include><ng-include src=\"\'app/home/cennikEKIEM/opcjePodstawoweEM.html\'\"></ng-include><ng-include src=\"\'app/home/cennikEKIEM/cennikEM.html\'\"></ng-include><ng-include ng-if=\"vmEKIEM.czySubUser\" src=\"\'app/home/cennikEKIEM/polaKontaktowe.html\'\"></ng-include><ng-include src=\"\'app/home/cennikEKIEM/akceptacjaRegulaminow.html\'\"></ng-include><button ng-click=\"vmEKIEM.wyslijZamowienie()\" ng-disabled=\"vmEKIEM.polaKontaktoweForm.$invalid || vmEKIEM.blokadaWysylki || !vmEKIEM.ackRegulaminEK || !vmEKIEM.ackRegulaminEM || !vmEKIEM.ackRegulaminUSLZ\" value=\"\" class=\"btn-send\" ng-class=\"{\'disabled\': (vmEKIEM.polaKontaktoweForm.$invalid || vmEKIEM.blokadaWysylki || !vmEKIEM.ackRegulaminEK || !vmEKIEM.ackRegulaminEM || !vmEKIEM.ackRegulaminUSLZ) }\" ng-if=\"vmEKIEM.czySubUser\"></button><div ng-if=\"!vmEKIEM.czySubUser && !vmEKIEM.security.zalogowanyJakoPracownikMieszczanin()\" style=\"margin-top: 20px\"><p>W celu przesłania zamówienia e-kartoteki prosimy o zalogowanie się na konto pracownicze.<br></p><p><b>WAŻNE!</b> Konto pracownicze musi mieć nadane, przez administratora, uprawnienia do podglądu zakładki \"Formularze\".<br>Uprawnienia można przydzielić w zakłace Twoje konto</p><p><i class=\"fa fa-long-arrow-right\" aria-hidden=\"true\"></i> Konta pracowników.<br>Uprawnienia pracownikom można nadać <a ui-sref=\"home.subMain.konta_pracownikow\"><u>klikając tutaj</u></a>.</p></div></div></div><div class=\"pane13\"><div class=\"box\" style=\"margin-top: 0\"><div class=\"yourprice\"><h3>Miesięczny abonament Twojej usługi:</h3><h1 class=\"theprice\" style=\"text-transform: none\"><span class=\"label label:default\" ng-hide=\"vmCennik.cena()\">{{ vmEKIEM.lokale != \'more50k\' ? (vmEKIEM.cena | number: 0) + \' zł\' : \'?*\' }}</span></h1><h3>Szczegóły:</h3><p>kwota bazowa: <span style=\"float: right;\">{{ vmEKIEM.cenaBazowa | number: 0 }} zł</span></p><p ng-if=\"vmEKIEM.czyZarzadzaLokalami\">opcje e-kartoteki: <span style=\"float: right;\">{{ vmEKIEM.cenaEk | number: 0 }} zł</span></p><p>opcje e-Mieszczanin: <span style=\"float: right;\">{{ vmEKIEM.cenaEm | number: 0 }} zł</span></p></div></div><div class=\"box\" style=\"margin-top: 10px;\"><p style=\"text-align: start;\">SMS i OCR są rozliczane zgodnie z obowiązującym cennikiem usług dodatkowych. Koszt zależy od wolumenu oraz sposobu wykorzystania i nie jest uwzględniony w powyższym abonamencie.</p></div><div class=\"box\" style=\"margin-top: 10px;\"><p style=\"text-align: start;\">Nazwa indywidualna usługi dostępna jest na zamówienie. W celu ustalenia szczegółów oraz wyceny prosimy o kontakt z działem handlowym.</p></div><div class=\"box\" style=\"margin-top: 10px;\"><p style=\"text-align: start;\"><span style=\"color: crimson;\">Podane kwoty są cenami netto.</span></p></div></div></div>");
$templateCache.put("app/home/cennikEKIEM/cennikEK.html","<div class=\"row\"><div class=\"col-md-12\"><h3><img src=\"../../assets/images/ek34.png\" alt=\"logo e-kartoteki\" width=\"15px\"> Opcje dodatkowe e-kartoteki</h3></div><div ng-repeat=\"opcja in vmEKIEM.opcjeEkLista | orderBy:\'Nazwa\'\"><opcja-ekiem ng-if=\"opcja.Opcja === \'D\' && opcja.UdzProc !== null\" label=\"opcja.Nazwa\" id=\"opcja.IdGrupy\" zaznaczenie=\"opcja.posiadana\" dodatkowa-informacja=\"(opcja.posiadana || vmEKIEM.komunikatyOpcji[opcja.IdGrupy].wyswietlaj === \'zawsze\') && vmEKIEM.komunikatyOpcji[opcja.IdGrupy].informacja\" disabled=\"vmEKIEM.zablokowaneOpcje.has(opcja.IdGrupy)\" on-change=\"vmEKIEM.przelaczPolaczonePola(IdGrupy)\"></opcja-ekiem><div style=\"padding-left: 15px\" ng-if=\"opcja.IdGrupy === 13 && opcja.posiadana === true\"><div><input type=\"radio\" ng-model=\"vmEKIEM.dodatkoweOpcjeEk.daneKsiegowe\" ng-value=\"3\" ng-checked=\"3\" ng-change=\"vmEKIEM.przelaczPolaczonePola()\" id=\"gromadzenie_danych_trzy\"> <label class=\"checkboxlabel\" for=\"gromadzenie_danych_trzy\">Dane z 3 lat</label></div><div><input type=\"radio\" ng-model=\"vmEKIEM.dodatkoweOpcjeEk.daneKsiegowe\" ng-value=\"5\" ng-checked=\"5\" ng-change=\"vmEKIEM.przelaczPolaczonePola()\" id=\"gromadzenie_danych_piec\"> <label class=\"checkboxlabel\" for=\"gromadzenie_danych_piec\">Dane z 5 lat</label></div><div><input type=\"radio\" ng-model=\"vmEKIEM.dodatkoweOpcjeEk.daneKsiegowe\" ng-value=\"\'bez ograniczeń\'\" ng-checked=\"\'bez ograniczeń\'\" ng-change=\"vmEKIEM.przelaczPolaczonePola()\" id=\"gromadzenie_danych_bo\"> <label class=\"checkboxlabel\" for=\"gromadzenie_danych_bo\">Bez ograniczeń</label></div></div></div></div>");
$templateCache.put("app/home/cennikEKIEM/cennikEM.html","<div class=\"row\"><div class=\"col-md-12\"><h3><img src=\"../../assets/images/emieszczanin/emi.png\" alt=\"logo systemu e-Mieszczanin\" width=\"15px\"> Opcje dodatkowe systemu e-Mieszczanin</h3></div><div ng-repeat=\"opcja in vmEKIEM.opcjeEmLista | orderBy:\'Nazwa\'\"><opcja-ekiem ng-if=\"opcja.Opcja === \'D\' && opcja.UdzProc !== null\" label=\"opcja.Nazwa\" id=\"opcja.IdGrupy\" zaznaczenie=\"opcja.posiadana\" dodatkowa-informacja=\"(opcja.posiadana || vmEKIEM.komunikatyOpcji[opcja.IdGrupy].wyswietlaj === \'zawsze\') && vmEKIEM.komunikatyOpcji[opcja.IdGrupy].informacja\" disabled=\"vmEKIEM.zablokowaneOpcje.has(opcja.IdGrupy)\" on-change=\"vmEKIEM.przelaczPolaczonePola(IdGrupy)\"></opcja-ekiem><div ng-if=\"opcja.IdGrupy === 50 && opcja.posiadana\" style=\"padding-left: 20px\"><opcja-ekiem label=\"\'Wysyłanie e-mailem\'\" id=\"\'50_wysylka_mailem\'\" zaznaczenie=\"true\" disabled=\"true\"></opcja-ekiem><input type=\"checkbox\" ng-model=\"vmEKIEM.dodatkoweOpcjeEm.sms\" id=\"czy_wysylka_sms\"> <label class=\"checkboxlabel\" for=\"czy_wysylka_sms\">Wysyłanie SMS</label><div class=\"note\" style=\"margin-bottom: 15px; color: grey\">Realizacja tej funkcjonalności wymaga współpracy z zewnętrznymi usługodawcami.<br>Zobacz listę <a ng-click=\"vmEKIEM.pobierzRegulamin(\'lista-firm-zewnetrznych\')\">firm zewnętrznych.</a></div></div><div ng-if=\"opcja.IdGrupy === 43 && opcja.posiadana\" style=\"padding-left: 20px\"><input type=\"checkbox\" ng-model=\"vmEKIEM.dodatkoweOpcjeEm.ocr\" id=\"czy_ocr\"> <label class=\"checkboxlabel\" for=\"czy_ocr\">OCR</label><div class=\"note\" style=\"margin-bottom: 15px; color: grey\">Realizacja tej funkcjonalności wymaga współpracy z zewnętrznymi usługodawcami.<br>Zobacz listę <a ng-click=\"vmEKIEM.pobierzRegulamin(\'lista-firm-zewnetrznych\')\">firm zewnętrznych.</a></div></div></div></div>");
$templateCache.put("app/home/cennikEKIEM/opcjePodstawoweEK.html","<div class=\"row\"><div class=\"col-md-12\"><h3><img src=\"../../assets/images/ek34.png\" alt=\"logo e-kartoteki\" width=\"15px\"> Opcje podstawowe e-kartoteki</h3></div><div ng-repeat=\"opcja in vmEKIEM.opcjeEkLista | orderBy:\'Nazwa\'\" ng-if=\"opcja.Opcja === \'P\' && opcja.UdzProc === null\"><opcja-ekiem label=\"opcja.Nazwa\" id=\"opcja.IdGrupy\" zaznaczenie=\"true\" disabled=\"true\" on-change=\"vmEKIEM.przelicz()\"></opcja-ekiem></div></div>");
$templateCache.put("app/home/cennikEKIEM/opcjePodstawoweEM.html","<div class=\"row\"><div class=\"col-md-12\"><h3><img src=\"../../assets/images/emieszczanin/emi.png\" alt=\"logo systemu e-Mieszczanin\" width=\"15px\"> Opcje podstawowe systemu e-Mieszczanin</h3></div><div ng-repeat=\"opcja in vmEKIEM.opcjeEmLista | orderBy:\'Nazwa\'\" ng-if=\"opcja.Opcja === \'P\' && opcja.UdzProc === null\"><opcja-ekiem label=\"opcja.Nazwa\" id=\"opcja.IdGrupy\" zaznaczenie=\"true\" disabled=\"true\" on-change=\"vmEKIEM.przelicz()\"></opcja-ekiem></div></div>");
$templateCache.put("app/home/cennikEKIEM/polaKontaktowe.html","<form style=\"float: unset\" name=\"vmEKIEM.polaKontaktoweForm\"><div class=\"row\"><div class=\"col-md-12\"><h3>Dane płatnika</h3></div><div><label for=\"nazwaFirmy\">Nazwa firmy*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.nazwaFirmy\" type=\"text\" required=\"\" id=\"nazwaFirmy\" name=\"nazwaFirmy\"></div><div><label for=\"ulica\">Ulica*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.ulica\" type=\"text\" required=\"\" id=\"ulica\" name=\"ulica\"></div><div><label for=\"nrBudynku\">Nr budynku*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.nrBudynku\" style=\"width: 80px\" type=\"text\" required=\"\" id=\"nrBudynku\" name=\"nrBudynku\"></div><div><label for=\"nrLokalu\">Nr lokalu</label> <input ng-model=\"vmEKIEM.polaKontaktowe.nrLokalu\" style=\"width: 80px\" type=\"text\" id=\"nrLokalu\" name=\"nrLokalu\"></div><div><label for=\"kodPocztowy\">Kod Pocztowy*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.kodPocztowy\" style=\"width: 80px\" type=\"text\" pattern=\"[0-9]{2}-[0-9]{3}\" required=\"\" id=\"kodPocztowy\" name=\"kodPocztowy\"></div><div><label for=\"miejscowosc\">Miejscowość*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.miejscowosc\" type=\"text\" pattern=\"[A-Za-zĄąĘęÓóŚśĆćŻżŹźŁłŃń.\\- ]{1,}\" required=\"\" id=\"miejscowosc\" name=\"miejscowosc\"></div><div><label for=\"nip\">NIP*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.NIP\" type=\"text\" pattern=\"[a-zA-Z0-9-_]+$\" required=\"\" id=\"nip\" name=\"nip\"></div><div><label for=\"regon\">REGON</label> <input ng-model=\"vmEKIEM.polaKontaktowe.REGON\" type=\"text\" pattern=\"[0-9-]{9,}\" id=\"regon\" name=\"regon\"></div><div><p>* Pole wymagane</p></div></div><div class=\"row\"><div class=\"col-md-12\"><h3>Osoba upoważniona do składania zamówień</h3></div><div><label for=\"imie\">Imię*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.imie\" type=\"text\" pattern=\"[A-Za-zĄąĘęÓóŚśĆćŻżŹźŁłŃń ]{3,}\" required=\"\" id=\"imie\" name=\"imie\"></div><div><label for=\"nazwisko\">Nazwisko*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.nazwisko\" type=\"text\" pattern=\"[A-Za-zĄąĘęÓóŚśĆćŻżŹźŁłŃń \',.-]+$\" required=\"\" id=\"nazwisko\" name=\"nazwisko\"></div><div><label for=\"telefonKontaktowy\">Telefon kontaktowy*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.telefonKontaktowy\" type=\"text\" required=\"\" id=\"telefonKontaktowy\" name=\"telefonKontaktowy\"></div><div><label for=\"email\">E-mail*</label> <input ng-model=\"vmEKIEM.polaKontaktowe.email\" type=\"email\" required=\"\" id=\"email\" name=\"email\"></div><div><p>* Pole wymagane</p></div></div></form>");
$templateCache.put("app/home/dokumentacja/dokumentacja.coNowego.html","<div ng-init=\"vmCN.init()\"><div class=\"pane23\"><div class=\"clearfix\"></div><div class=\"box23\"><div><h3><span ng-style=\"(vmCN.program.kod != \'E-KARTOTEKA\') && {\'margin-top\': \'-4px\'} || (vmCN.program.kod == \'E-KARTOTEKA\') && {\'margin-top\': \'4px\'}\" ng-class=\"vmCN.program.klasa\"></span> {{vmCN.program.nazwa}}</h3><div ng-repeat=\"coNowego in vmCN.coNowego[vmCN.program.skrot] | orderBy: \'-data\'\" ng-if=\"vmCN.coNowego[vmCN.program.skrot].length > 0\"><h3>{{coNowego.wersja}}{{coNowego.update_pack}} <span style=\"font-size: 14px;margin-left: 10px;\">{{coNowego.data | date: \'dd.MM.yyyy\'}}</span></h3><div class=\"co-nowego-style\"><div ng-bind-html=\"coNowego.html | trustAsHtml\"></div><div style=\"margin-top: 15px;\" ng-if=\"coNowego.zalaczniki.length > 0\"><p><strong>Załączniki:</strong></p><div ng-repeat=\"zalacznik in coNowego.zalaczniki\" style=\"padding-top: 5px;\"><a ng-click=\"vmCN.getFile(zalacznik)\" target=\"_blank\" style=\"display: inline-block;\"><i class=\"fa fa-file-o\" aria-hidden=\"true\"></i> {{zalacznik.nazwaPliku}}</a></div></div></div></div></div></div></div><div class=\"pane13\"><div class=\"box23\"><div class=\"floatleft productsgroup\"><div ng-repeat-start=\"program in vmCN.programy\" class=\"docitem\" ng-click=\"vmCN.przejdzDoProgramu(program.kod)\"><div ng-class=\"program.klasa\" ng-style=\"program.klasa !== \'icon-ek\' && {\'margin-top\': \'-5px\'} || program.klasa === \'icon-ek\' && {\'margin-top\': \'5px\'}\"></div><span>{{program.nazwa}}</span></div><div ng-repeat-end=\"\"></div></div></div></div></div>");
$templateCache.put("app/home/dokumentacja/dokumentacja.coNowego.pliki.html","<div><h3><span ng-class=\"vmCNP.program.klasa\"></span> {{vmCNP.program.nazwa}}</h3><div class=\"files\"><a ng-href=\"{{vmCNP.plikiFirmowe.coNowego(vmCNP.program.skrot)}}\" class=\"download pdf\" ng-title=\"vmCNP.program.nazwa\"></a> <a ng-href=\"{{vmCNP.plikiFirmowe.coNowego(vmCNP.program.skrot)}}\"><span>- {{vmCNP.program.nazwa}}</span></a><br><span class=\"plikiKomentarz\">Lista nowych opcji dostępnych od tej wersji programu znajduje się w załączniku.</span></div></div>");
$templateCache.put("app/home/dokumentacja/dokumentacja.html","<div ng-init=\"vmDok.init()\"><div class=\"pane23\" style=\"display:inline-block\"><div class=\"box23\"><div><h3><span style=\"margin-top: -4px;\" ng-class=\"vmDok.program.klasa\"></span> {{vmDok.program.nazwa}}</h3><div class=\"clearfix\"></div><div class=\"files\"><div ng-repeat=\"element in vmDok.pliki[vmDok.program.skrot]\" style=\"margin-top: -10px;\"><a ng-click=\"vmDok.getFile(element.file[0])\" target=\"_blank\" class=\"download pdf\" title=\"Dokument w formacie PDF\"></a><div style=\"display: inline-block\"><a ng-click=\"vmDok.getFile(element.file[0])\" target=\"_blank\"><span>- {{element.tytul}}</span></a></div><div class=\"plikiKomentarz\" style=\"word-wrap: break-word;\"><p>{{element.opis}}</p></div><br></div></div></div></div></div><div class=\"pane13\"><div class=\"clearfix\"></div><div class=\"box23\"><div class=\"floatleft productsgroup\"><div ng-repeat-start=\"program in vmDok.programy\" class=\"docitem\" ng-click=\"vmDok.wybierzProgram(program)\"><div ng-class=\"program.klasa\"></div><span>{{program.nazwa}}</span></div><div ng-repeat-end=\"\" class=\"clearfix\"></div></div></div></div></div>");
$templateCache.put("app/home/dokumentacja/dokumentacja.listaPlikow.html","<p ng-repeat=\"item in vmDokLi.listaPlikow\"><a ng-href=\"{{item.sciezka}}\" class=\"download pdf\" title=\"Dokument w formacie PDF\"></a> <a ng-href=\"{{item.sciezka}}\"><span>- {{item.nazwa}}</span></a><br><span class=\"plikiKomentarz\" ng-if=\"item.nazwa===\'Co nowego\'\">Lista zmian we wszystkich wersjach programu</span> <span class=\"plikiKomentarz\" ng-if=\"item.nazwa===\'Wymagania sprzętowe\'\">Przed przystąpieniem do instalacji prosimy upewnić się czy konfiguracja Państwa komputera zapewnia komfortową pracę z naszym oprogramowaniem.</span> <span class=\"plikiKomentarz\" ng-if=\"item.nazwa===\'Klucz sprzętowy\'\">Warunkiem uruchomienia programu jest prawidłowe zainstalowanie klucza sprzętowego - urządzenia zabezpieczającego.</span></p>");
$templateCache.put("app/home/dokumentacja/dokumentacja.pytaniaIOdpowiedzi.html","<div ng-init=\"vmPIO.init()\"><div class=\"pane23\" style=\"display:inline-block\"><div class=\"box23\"><div><h3><span style=\"margin-top: -4px;\" ng-class=\"vmPIO.program.klasa\"></span> {{vmPIO.program.nazwa}}</h3><div class=\"clearfix\"></div><div class=\"files\"><div ng-repeat=\"element in vmPIO.pytaniaIOdpowiedzi[vmPIO.program.skrot]\" style=\"margin-top: -10px;\"><a ng-click=\"vmPIO.getFile(element.file[0])\" target=\"_blank\" class=\"download pdf\" title=\"Dokument w formacie PDF\"></a><div style=\"display: inline-block\"><a ng-click=\"vmPIO.getFile(element.file[0])\" target=\"_blank\"><span>- {{element.tytul}}</span></a></div><div class=\"plikiKomentarz\" style=\"word-wrap: break-word;\"><p>{{element.opis}}</p></div><br></div></div></div></div></div><div class=\"pane13\"><div class=\"clearfix\"></div><div class=\"box23\"><div class=\"floatleft productsgroup\"><div ng-repeat-start=\"program in vmPIO.programy\" class=\"docitem\" ng-click=\"vmPIO.wybierzProgram(program)\"><div ng-class=\"program.klasa\"></div><span>{{program.nazwa}}</span></div><div ng-repeat-end=\"\" class=\"clearfix\"></div></div></div></div></div>");
$templateCache.put("app/home/dokumentacja/dokumentacja.regulaminy.html","<div class=\"pane23\" ng-init=\"vmReg.init();\"><h3 class=\"softname\"><span>Dostępne regulaminy</span></h3><div class=\"clearfix\"></div><div class=\"files\"><div ng-repeat=\"plik in vmReg.pliki\"><a target=\"_blank\" ng-click=\"vmReg.getFile(plik.file[0])\" class=\"download pdf\"></a> <a style=\"display: inline-block;\" target=\"_blank\" ng-click=\"vmReg.getFile(plik.file[0])\"><p>- {{plik.tytul}}</p></a><br><div class=\"plikiKomentarz\"><p>{{plik.opis}}</p></div></div></div></div>");
$templateCache.put("app/home/errors/errors.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/home/formularze/formularze.generowanieLicencji.html","<div class=\"pane23\" ng-init=\"vmGenLic.init()\"><h3>Generowanie Licencji</h3><div class=\"box23\" ng-if=\"vmGenLic.security.jestSubUserem() === true\"><div class=\"description\"><obsluga-bledow wiadomosci-tablica=\"vmGenLic.odpowiedziSerwera\"></obsluga-bledow><form class=\"ekartoteka\" name=\"generowanieLicencji\" method=\"post\" id=\"formLimit\" novalidate=\"\"><label for=\"name\">Osoba kontaktowa</label> <input id=\"name\" type=\"text\" name=\"name\" required=\"\" ng-model=\"vmGenLic.pola.osDoKontaktuNazwa\"><br><label for=\"tel\">Telefon kontaktowy</label> <input id=\"tel\" type=\"text\" name=\"tel\" ng-model=\"vmGenLic.pola.osDoKontaktuTelefon\" required=\"\"><br><label for=\"email\">E-mail</label> <input id=\"email\" type=\"email\" name=\"email\" ng-model=\"vmGenLic.pola.osDoKontaktuEmail\" required=\"\"><br><label for=\"tresc\">Treść</label> <textarea id=\"tresc\" rows=\"6\" cols=\"64\" name=\"comment\" form=\"formLimit\" required=\"\" ng-model=\"vmGenLic.pola.opis\"></textarea><div class=\"panefull\"><br><button ng-click=\"vmGenLic.wyslijZgloszenie()\" ng-disabled=\"generowanieLicencji.$invalid\" value=\"\" class=\"btn-send\"></button></div></form><div class=\"clearfix\"></div></div></div><div class=\"box23\" ng-if=\"vmGenLic.security.jestSubUserem() === false\"><div style=\"min-height: 400px;-webkit-font-smoothing: antialiased;\"><p>W celu przesłania prośby o wygenerowanie pliku licencyjnego do najnowszej wersji prosimy o zalogowanie się na konto pracownicze.<br><br><b>WAŻNE!</b> Konto pracownicze musi mieć nadane, przez administratora, uprawnienia do podglądu zakładek \"Licencje\" oraz \"Aktualizacja\".<br>Uprawnienia można przydzielić w zakłace Twoje konto <i class=\"fa fa-long-arrow-right\" aria-hidden=\"true\"></i> Konta pracowników.<br><br>Uprawnienia pracownikom można nadać <a ui-sref=\"home.subMain.konta_pracownikow\"><u>klikając tutaj</u></a>.</p></div></div></div><div class=\"pane13\"><div class=\"box\"><p>Wysłanie wiadomości rozpocznie procedurę generowania nowego pliku licencji. O dostępności nowego pliku w Strefie Klienta zostaną państwo poinformowani.</p></div></div>");
$templateCache.put("app/home/formularze/formularze.html","<div class=\"pane23\"><div class=\"clearfix\"></div><div class=\"box23\"><div><h3 class=\"softname\"><span>{{vmFR.wybranyPlik.tytul}}</span></h3><div><div><span class=\"plikiKomentarz angular-with-newlines\">{{vmFR.wybranyPlik.opis}}</span></div><br><br><div ng-repeat=\"plik in vmFR.wybranyPlik.file\"><a class=\"download pdf\" target=\"_blank\" ng-if=\"plik.nazwaPliku.indexOf(\'pdf\')!==-1\" ng-click=\"vmFR.getFile(plik)\"></a> <a ng-href=\"{{plik.link}}\" style=\"display: inline-block;\" target=\"_blank\" ng-if=\"plik.nazwaPliku.indexOf(\'pdf\')!==-1\" ng-click=\"vmFR.getFile(plik)\"><p>- Dokument w formacie PDF</p></a><div><a ng-href=\"{{plik.link}}\" target=\"_blank\" class=\"download doc\" ng-if=\"plik.nazwaPliku.indexOf(\'doc\')!==-1 || plik.nazwaPliku.indexOf(\'docx\')!==-1\" ng-click=\"vmFR.getFile(plik)\"></a> <a ng-href=\"{{plik.link}}\" style=\"display: inline-block;\" target=\"_blank\" ng-if=\"plik.nazwaPliku.indexOf(\'doc\')!==-1 || plik.nazwaPliku.indexOf(\'docx\')!==-1\" ng-click=\"vmFR.getFile(plik)\"><p>- Dokument w formacie DOC</p></a></div></div></div></div></div></div><div class=\"pane13\"><div class=\"clearfix\"></div><div class=\"box23\"><div class=\"floatleft\"><ul><li ng-repeat-start=\"formularz in vmFR.pliki | orderBy:\'kolejnosc\'\" class=\"docitem\" ng-click=\"vmFR.wybierzFormularz(formularz)\"><a><span>{{formularz.tytul}}</span></a></li><div ng-repeat-end=\"\" class=\"clearfix\"></div></ul></div></div></div>");
$templateCache.put("app/home/formularze/formularze.pliki.html","<h3 class=\"softname\"><span>{{vmFRP.formularz.nazwa}}</span></h3><div><div><span class=\"plikiKomentarz angular-with-newlines\">{{vmFRP.formularz.komentarz}}</span></div><br><br><div ng-repeat=\"plik in vmFRP.formularz.pliki\" class=\"files\"><a ng-href=\"{{plik.sciezka}}\" ng-class=\"{\'download pdf\': plik.format===\'pdf\', \'download doc\': plik.format ===\'doc\'}\" ng-title=\"vmFRP.formularz.nazwa\"></a> <a ng-href=\"{{plik.sciezka}}\"><span ng-if=\"plik.format===\'pdf\'\">- Dokument w formacie PDF</span> <span ng-if=\"plik.format===\'doc\'\">- Dokument w formacie DOC</span></a><br></div></div>");
$templateCache.put("app/home/formularze/formularze.wycenaAktualizacji.html","<div class=\"pane23\"><div class=\"box23\"><div class=\"description\"><h3>Wycena aktualizacji</h3><obsluga-bledow wiadomosci-tablica=\"vmRekN.odpowiedziSerwera\"></obsluga-bledow><form class=\"ekartoteka\" name=\"wycenaAktualizacji\" method=\"post\" id=\"formLimit\" novalidate=\"\"><label for=\"name\">Osoba kontaktowa *</label> <input id=\"name\" type=\"text\" name=\"name\" required=\"\" ng-model=\"newZgl.osobaKontaktowa\"><br><label for=\"tel\">Telefon kontaktowy</label> <input id=\"tel\" type=\"text\" name=\"tel\" ng-model=\"newZgl.telefon\"><br><label for=\"email\">E-mail</label> <input id=\"email\" type=\"email\" name=\"email\" ng-model=\"newZgl.email\"><br><label for=\"tresc\">Treść</label> <textarea id=\"tresc\" rows=\"6\" cols=\"64\" name=\"comment\" form=\"formLimit\" required=\"\" ng-model=\"newZgl.tresc\" ng-init=\"newZgl.tresc=\'Proszę o kontakt w sprawie wyceny aktualizacji.\'\"></textarea><div class=\"panefull\"><br><button ng-click=\"vmWAkt.wyslijZgloszenie(newZgl)\" ng-disabled=\"wycenaAktualizacji.$invalid\" value=\"\" class=\"btn-send\"></button></div></form><div class=\"clearfix\"></div></div></div></div><div class=\"pane13\"><div class=\"box\"><p>Po wysłaniu wiadomości skontaktuje się z Państwem przedstawiciel Działu Handlowego</p></div></div>");
$templateCache.put("app/home/formularze/formularze.zamowienieUslug.html","<div class=\"pane23\" ng-init=\"vmZU.init()\"><div class=\"box23\"><div class=\"description\"><h3>Zamówienie usług</h3><obsluga-bledow wiadomosci-tablica=\"vmZU.odpowiedziSerwera\"></obsluga-bledow><form class=\"ekartoteka\" name=\"zmianaLimitow\" method=\"post\" id=\"formLimit\" novalidate=\"\"><label for=\"name\">Osoba kontaktowa *</label> <input id=\"name\" type=\"text\" name=\"name\" required=\"\" ng-model=\"vmZU.reklamacja.osobaKontaktowa\"><br><label for=\"tel\">Telefon kontaktowy</label> <input id=\"tel\" type=\"text\" name=\"tel\" ng-model=\"vmZU.reklamacja.telefon\"><br><label for=\"email\">E-mail</label> <input id=\"email\" type=\"email\" name=\"email\" ng-model=\"vmZU.reklamacja.email\"><br><label for=\"tresc\">Treść</label> <textarea id=\"tresc\" rows=\"6\" cols=\"64\" name=\"comment\" form=\"formLimit\" required=\"\" ng-model=\"vmZU.reklamacja.opis\" ng-init=\"vmZU.reklamacja.opis=\'Proszę o kontakt w sprawie zamówienia usług.\'\"></textarea><div class=\"panefull\"><br><button ng-click=\"vmZU.wyslijZgloszenie(newZgl)\" ng-disabled=\"zmianaLimitow.$invalid\" value=\"\" class=\"btn-send\"></button></div></form><div class=\"clearfix\"></div></div></div></div><div class=\"pane13\"><div class=\"box\"><p>Po wysłaniu wiadomości skontaktuje się z Państwem przedstawiciel Działu Handlowego</p></div></div>");
$templateCache.put("app/home/formularze/formularze.zapytajInformatyka.html","<div class=\"pane23\"><div class=\"box23\"><div class=\"description\"><h3>{{vmInf.tytulNaglowka}}</h3><obsluga-bledow wiadomosci-tablica=\"vmInf.odpowiedziSerwera\"></obsluga-bledow><form class=\"ekartoteka\" name=\"noweZgloszenie\" method=\"post\" id=\"formLimit\"><div class=\"clearfix\"></div><div><div><label ng-show=\"vmInf.lokalizacje.length>1\" for=\"lokalizacja\">Lokalizacja</label><select name=\"lokalizacja\" id=\"lokalizacja\" required=\"\" ng-show=\"vmInf.lokalizacje.length>1\" ng-options=\"lok.NazwaLok for lok in vmInf.lokalizacje track by lok.IdLok\" ng-model=\"vmInf.lokalizacja\"></select></div><div><label for=\"program\">Moduł</label><select name=\"\" id=\"program\" ng-options=\"lic.Nazwa for lic in vmInf.licencje | unique:\'Nazwa\'\" ng-model=\"vmInf.licencja\"></select><label for=\"wersja\" class=\"checkbox-inline\"><div class=\"{{vmInf.bootstrapKlasa}}\"><input type=\"checkbox\" ng-model=\"vmInf.wersjaChbox\"></div>Wersja</label><select name=\"\" id=\"wersja\" ng-disabled=\"!vmInf.wersjaChbox\" ng-options=\"lic.WersjaSys for lic in vmInf.licencje | filter:{Kod:vmInf.licencja.Kod}:true\" ng-model=\"vmInf.wersja\"></select><label for=\"raport\"><div class=\"{{vmInf.bootstrapKlasa}}\"><input type=\"checkbox\" ng-model=\"vmInf.raportChbox\"></div>Raport</label> <input type=\"text\" ng-disabled=\"!vmInf.raportChbox\" ng-model=\"vmInf.raport\" id=\"raport\"></div><div class=\"clearfix\"></div><label for=\"osobaKontaktowa\">Osoba kontaktowa</label> <input id=\"osobaKontaktowa\" type=\"text\" required=\"\" ng-model=\"vmInf.osobaKontaktowa\" name=\"osobaKontaktowa\"> <label for=\"email\">e-mail</label> <input id=\"email\" type=\"text\" ng-model=\"vmInf.email\" name=\"email\"> <label for=\"telefon\">Telefon</label> <input id=\"telefon\" type=\"text\" ng-model=\"vmInf.telefon\" name=\"email\"> <label for=\"telefon\">Temat</label> <input id=\"temat\" required=\"\" type=\"text\" ng-model=\"vmInf.temat\" name=\"temat\"><br><label for=\"tresc\">Pytanie</label> <textarea id=\"tresc\" ng-model=\"vmInf.tresc\" rows=\"10\" cols=\"64\" name=\"comment\" form=\"formLimit\"></textarea></div><div class=\"clearfix\"></div><div class=\"panefull\"><br><div class=\"{{vmInf.bootstrapKlasa}}\" ng-hide=\"!vmInf.edytuj && vmInf.przypiszOsobe\"><dodawanie-plikow uploader=\"vmInf.uploader\" nazwa-api=\"{{vmInf.apiPliki}}\" blad=\"vmInf.wyswietl.blad\" id=\"reklamacjePliki\"></dodawanie-plikow></div><button ng-click=\"vmInf.wyslij()\" ng-disabled=\"vmInf.btnWyslijDisabled || noweZgloszenie.$invalid\" value=\"\" class=\"btn-send\"></button></div></form><div class=\"clearfix\"></div></div></div></div><div class=\"pane13\"><div class=\"box\"><p>Po wysłaniu wiadomości skontaktuje się z Państwem przedstawiciel Działu Wdrożeń i Serwisu</p></div></div>");
$templateCache.put("app/home/formularze/formularze.zmianaLimitow.html","<div class=\"pane23\" ng-init=\"vmZmianaLimitow.init()\"><h3>Zmiana limitów</h3><div class=\"box23\" ng-if=\"vmZmianaLimitow.security.jestSubUserem() === true\"><div class=\"description\"><obsluga-bledow wiadomosci-tablica=\"vmZmianaLimitow.odpowiedziSerwera\"></obsluga-bledow><form class=\"ekartoteka\" name=\"zmianaLimitow\" method=\"post\" id=\"formLimit\" novalidate=\"\"><label for=\"name\">Osoba kontaktowa</label> <input id=\"name\" type=\"text\" name=\"name\" required=\"\" ng-model=\"vmZmianaLimitow.pola.osDoKontaktuNazwa\"><br><label for=\"tel\">Telefon kontaktowy</label> <input id=\"tel\" type=\"text\" name=\"tel\" ng-model=\"vmZmianaLimitow.pola.osDoKontaktuTelefon\" required=\"\"><br><label for=\"email\">E-mail</label> <input id=\"email\" type=\"email\" name=\"email\" ng-model=\"vmZmianaLimitow.pola.osDoKontaktuEmail\" required=\"\"><br><label for=\"modul\">Moduł</label><select style=\"width:230px;resize: none\" ng-model=\"vmZmianaLimitow.pola.modul\" ng-options=\"mod.kod as mod.nazwa for mod in vmZmianaLimitow.moduly\" name=\"modul\" id=\"modul\" required=\"\"></select><label for=\"tresc\">Treść</label> <textarea id=\"tresc\" rows=\"6\" cols=\"64\" name=\"comment\" form=\"formLimit\" required=\"\" ng-model=\"vmZmianaLimitow.pola.opis\" ng-init=\"vmZmianaLimitow.pola.opis=\'Proszę o kontakt w sprawie zmiany limitów.\'\"></textarea><br><button ng-click=\"vmZmianaLimitow.wyslijZgloszenie()\" ng-disabled=\"zmianaLimitow.$invalid\" value=\"\" class=\"btn-send\"></button></form><div class=\"clearfix\"></div></div></div><div class=\"box23\" ng-if=\"vmZmianaLimitow.security.jestSubUserem() === false\"><div class=\"\" style=\"min-height: 400px;-webkit-font-smoothing: antialiased;\"><p>W celu przesłania zapytania o zmianę limitów, posiadanych licencji oprogramowania, prosimy o zalogowanie się na konto pracownicze.<br><br></p></div></div></div><div class=\"pane13\"><div class=\"box\"><p>Po wysłaniu wiadomości skontaktuje się z Państwem przedstawiciel Działu Handlowego</p></div></div>");
$templateCache.put("app/home/glosowaniaPropozycjeRozwoju/glosowania.html","<div class=\"content\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0px\"><h2>Głosowania</h2><p ng-if=\"vmGlo.aktywneGlosowania.length > 0\">Już od ponad 30 lat rozwijamy nasze oprogramowanie nie tylko w związku ze zmianami w przepisach, ale także w oparciu o propozycje przekazane nam przez liczne grono naszych klientów. Co pół roku udostępniamy Państwu nowe wersje zawierające zwykle ponad 100 zmian funckjonalnych i technicznych.<br><br>Chcemy zaprosić Państwa do współpracy w wybieraniu, które pomysły pojawią się w kolejnej wersji! W tym celu zachęcamy do przejrzenia przygotowanych przez naszych analityków projektów i oddanie głosu na te zagadnienia, które Państwa zdaniem szczególnie zasługują na wprowadzenie do systemu.</p><p ng-if=\"vmGlo.aktywneGlosowania.length <= 0\">W chwili obecnej nie jest prowadzone głosowanie nad propozycjami rozwoju. Zachęcamy do regularnego odwiedzania naszej strony, gdyż w najbliższym czasie<br>z pewnością pojawią się propozycje, na które będzie można oddać głos.</p></div><obsluga-bledow wiadomosci-tablica=\"vmGlo.odpowiedziSerwera\"></obsluga-bledow><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGlo.aktywneGlosowania.length > 0\"><h3>Trwające głosowania</h3><div><strefa-grid api=\"{{vmGlo.apiGlosowania}}\" request-params=\"{{vmGlo.aktywneGlosowaniaParams}}\" columns=\"vmGlo.columnsGlosowania\" row-click-override=\"vmGlo.przejdzDoGlosowania(\'home.subMain.glosowanieNaPropozycjeRozwoju\', item, index)\" row-expand=\"false\" ctrl=\"vmGlo\"></strefa-grid></div></div><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGlo.zakonczoneGlosowania.length > 0\"><h3>Zakończone głosowania</h3><strefa-grid api=\"{{vmGlo.apiGlosowania}}\" request-params=\"{{vmGlo.zakonczoneGlosowaniaParams}}\" columns=\"vmGlo.columnsGlosowania\" row-click-override=\"vmGlo.przejdzDoGlosowania(\'home.subMain.wynikiGlosowania\', item, index)\" row-expand=\"false\" ctrl=\"vmGlo\"></strefa-grid></div></div><div class=\"pane13\" ng-if=\"vmGlo.aktywneGlosowania.length > 0\"><div class=\"boxT\" style=\"margin-top: 5px;\"><h3 style=\"padding-bottom: 10px\">Informacja</h3><p>Oddając głos na propozycję rozwoju jest on oddawany za <b>cały podmiot</b>.</p></div></div></div>");
$templateCache.put("app/home/glosowaniaPropozycjeRozwoju/glosowanie.html","<div class=\"content\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0px\"><h2>{{vmGloS.glosowanie.tytul}}</h2><p style=\"white-space: pre-line\" ng-bind-html=\"vmGloS.trustAsHTML(vmGloS.glosowanie.opis)\"></p></div><obsluga-bledow wiadomosci-tablica=\"vmGloS.odpowiedziSerwera\"></obsluga-bledow><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGloS.slonie.length > 0\"><h3>System łatwej obsługi nieruchomości</h3><strefa-grid api=\"{{vmGloS.apiPropozycje}}\" request-params=\"{{vmGloS.slonieParams}}\" columns=\"vmGloS.columnsPropozycje\" row-expand=\"false\" row-click-override=\"vmGloS.przejdzDoPropozycji(item, index)\" ctrl=\"vmGloS\"></strefa-grid></div><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGloS.inneModuly.length > 0\"><h3>Inne moduły</h3><strefa-grid api=\"{{vmGloS.apiPropozycje}}\" request-params=\"{{vmGloS.inneModulyParams}}\" columns=\"vmGloS.columnsPropozycje\" row-expand=\"false\" row-click-override=\"vmGloS.przejdzDoPropozycji(item, index)\" ctrl=\"vmGloS\"></strefa-grid></div><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGloS.zestawienia.length > 0\"><h3>Zestawienia</h3><strefa-grid api=\"{{vmGloS.apiPropozycje}}\" request-params=\"{{vmGloS.zestawieniaParams}}\" columns=\"vmGloS.columnsPropozycje\" row-expand=\"false\" row-click-override=\"vmGloS.przejdzDoPropozycji(item, index)\" ctrl=\"vmGloS\"></strefa-grid></div><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGloS.ekartoteka.length > 0\"><h3>e-kartoteka</h3><strefa-grid api=\"{{vmGloS.apiPropozycje}}\" request-params=\"{{vmGloS.ekartotekaParams}}\" columns=\"vmGloS.columnsPropozycje\" row-expand=\"false\" row-click-override=\"vmGloS.przejdzDoPropozycji(item, index)\" ctrl=\"vmGloS\"></strefa-grid></div></div><div class=\"pane13\"><div style=\"margin-top: 50px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; padding: 10px;min-height: 70px; width: 340px; float: right\"><div id=\"szczegoly\" style=\"background-color: white;margin-top: -28px;padding: 10px;z-index: 1;width: 50px;\">Terminy</div><table style=\"width: 100%\"><tr><td style=\"width:40%;\"><span style=\"margin-left: 2px;\">Data rozpoczęcia</span></td><td style=\"width:60%;\"><span>{{vmGloS.glosowanie.data_od | date: \'dd.MM.yyyy\'}}</span></td></tr><tr><td style=\"width:40%; padding-top: 10px;\"><span style=\"margin-left: 2px;\">Data zakończenia</span></td><td style=\"width:60%;\"><span>{{vmGloS.glosowanie.data_do | date: \'dd.MM.yyyy\'}}</span></td></tr></table></div></div></div><script type=\"text/x-kendo-template\" id=\"zobacz\"><div class=\"text-center\" > <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.state.go(\'home.subMain.konto\')\"> <i class=\"fa fa-share\" aria-hidden=\"true\" style=\"display: inline-block; margin: 0; padding: 0\"></i> zobacz </button> </div></script>");
$templateCache.put("app/home/glosowaniaPropozycjeRozwoju/propozycjaGlosowania.html","<div class=\"{{ vmGloP.bootstrapKlasa }}\" ng-init=\"vmGloP.init();\"><div style=\"margin-top: 10px;\" ng-if=\"vmGloP.propozycja.glosowanie_opublikowano === false\"><a ui-sref=\"home.subMain.glosowanieNaPropozycjeRozwoju({id: vmGloP.propozycja.glosowanie})\" style=\"color: grey;text-decoration: none\"><i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i> wstecz</a></div><div style=\"margin-top: 10px;\" ng-if=\"vmGloP.propozycja.glosowanie_opublikowano === true\"><a ui-sref=\"home.subMain.wynikiGlosowania({id: vmGloP.propozycja.glosowanie})\" style=\"color: grey;text-decoration: none\"><i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i> wstecz</a></div><div style=\"padding-top: 30px;\"><p style=\"margin-top: 5px;\"><b>{{vmGloP.propozycja.tytul}}</b></p></div><obsluga-bledow wiadomosci-tablica=\"vmGloP.odpowiedziSerwera\"></obsluga-bledow><div style=\"width: 65%;display: inline-block; float: left\"><div style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; min-height: 100px;\"><div id=\"opis\" style=\"background-color: white;margin-top: -18px;margin-left:10px;padding: 10px;z-index: 1;width: 50px;\">Opis</div><div style=\"padding:10px; width:100%;min-height: 40px\"><div style=\"padding: 20px; line-height: 1.4\"><span style=\"white-space: pre-line;\" ng-bind-html=\"vmGloP.getTrustedHtml(vmGloP.propozycja.opis)\"></span></div><div ng-if=\"vmGloP.pliki.length>0\"><hr><div style=\"line-height: 150%;display: inline-block;margin: 0 5px;padding-bottom: 10px;\" ng-repeat=\"plik in vmGloP.pliki\"><a target=\"_blank\" ng-click=\"vmGloP.getFile(plik)\">{{plik.nazwaPliku}}</a></div></div></div></div><div style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; min-height: 225px;\" ng-if=\"vmGloP.propozycja.glosowanie_opublikowano == false && vmGloP.data_do > vmGloP.dzisiaj\"><div id=\"dodajKomentarz\" style=\"background-color: white;margin-top: -18px;margin-left:10px;padding: 10px;z-index: 1;width: 130px;\">Dodaj Komentarz</div><div ng-if=\"vmGloP.security.jestSubUserem() == false\" style=\"text-align: center\"><h5 style=\"padding-top: 50px\">Dodawanie komentarzy jest możliwe tylko z kont pracowników.</h5></div><div ng-if=\"vmGloP.security.jestSubUserem() == true\"><textarea id=\"text\" lang=\"pl\" style=\"width: 600px;min-height: 150px;resize: none;margin-left:10px;margin-right:10px;margin-bottom:10px;padding: 10px;background: whitesmoke;\" ng-model=\"vmGloP.komentarz\">\n            </textarea><div class=\"row\"><div class=\"col-xs-4 col-sm-offset-8\"><button type=\"button\" class=\"btn\" style=\"background-color: #0a6ebd;color: white;float: right; margin-right: 10px;\" ng-click=\"vmGloP.dodajKomentarz()\" ng-class=\"{\'disabled\': vmGloP.komentarz.length < 3 }\"><span><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i> Wyślij komentarz</span></button></div></div></div></div></div><div style=\"margin-left:20px;width: 32.5%;display: inline-block;float: right\"><div style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; padding: 10px;min-height: 100px;\"><div id=\"szczegoly\" style=\"background-color: white;margin-top: -28px;padding: 10px;z-index: 1;width: 85px;\">Szczegóły</div><table style=\"width: 100%\"><tr><td style=\"width:40%;\"><span style=\"margin-left: 2px;\">Kategoria</span></td><td style=\"width:60%;\"><div style=\"display: inline-block;margin-left: 7px;\">{{ vmGloP.propozycja.kategoria }}</div></td></tr><tr ng-if=\"vmZglKarKli.zgloszenie.modul !== null\"><td style=\"width:40%;padding-top: 18px;\"><span style=\"margin-left: 2px;\">Dot. modułów</span></td><td style=\"width:60%;padding-top: 18px; display: inline;\"><div ng-repeat=\"modul in vmGloP.modulyPropozycji\" class=\"{{ \'letter-icon \' + vmGloP.programy[modul].ikona }}\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"{{vmGloP.programy[modul].nazwa}}\"></div></td></tr></table></div><div style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; padding: 10px;min-height: 100px;\"><div id=\"glosowanie\" style=\"background-color: white;margin-top: -28px;padding: 10px;z-index: 1;width: 95px;\">Głosowanie</div><div ng-if=\"vmGloP.security.jestSubUserem()\"><div ng-if=\"vmGloP.propozycja.oddano_glos == false && vmGloP.data_do >= vmGloP.dzisiaj && vmGloP.propozycja.glosowanie_aktywne == true && vmGloP.propozycja.glosowanie_opublikowano == false\" style=\"text-align: center;padding-top: 5px;\"><a class=\"btn btn-default\" ng-click=\"vmGloP.zaglosuj()\"><i class=\"fa fa-thumbs-o-up\" aria-hidden=\"true\" style=\"font-size: 22px;\"></i><br>Zagłosuj</a></div><div ng-if=\"vmGloP.propozycja.oddano_glos == true\" style=\"text-align: center;padding-top: 5px;\"><i class=\"fa fa-thumbs-o-up\" aria-hidden=\"true\" style=\"font-size: 22px;\"></i><br><br>Dziękujemy za oddanie głosu</div><div ng-if=\"(vmGloP.data_do < vmGloP.dzisiaj || vmGloP.propozycja.glosowanie_opublikowano == true) && vmGloP.propozycja.oddano_glos == false\" style=\"text-align: center;padding-top: 5px;\"><i class=\"fa fa-frown-o\" aria-hidden=\"true\" style=\"font-size: 22px;\"></i><br><br>Głosowanie już zostało zakończone</div><div ng-if=\"vmGloP.propozycja.glosowanie_aktywne == false && vmGloP.data_do > vmGloP.dzisiaj && vmGloP.propozycja.glosowanie_opublikowano == false\" style=\"text-align: center;padding-top: 5px;\"><i class=\"fa fa-hourglass-o\" aria-hidden=\"true\" style=\"font-size: 22px;\"></i><br><br>Głosowanie jeszcze nie zostało uruchomione</div></div><div ng-if=\"!vmGloP.security.jestSubUserem()\" style=\"text-align: center;padding-top: 5px;\"><i class=\"fa fa-frown-o\" aria-hidden=\"true\" style=\"font-size: 22px;\"></i><br><br>Głosowanie jest możliwe tylko z kont pracowników</div></div></div></div>");
$templateCache.put("app/home/glosowaniaPropozycjeRozwoju/wynikiGlosowania.html","<div class=\"content\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0px\"><h2>Wyniki głosowania {{ vmGloW.glosowanie.tytul }}</h2><p ng-bind-html=\"vmGloW.trustAsHTML(vmGloW.glosowanie.komentarz_koncowy)\"></p><div ng-if=\"vmGloW.komentarz_koncowy !== null && vmGloW.komentarz_koncowy.length > 0\"><p ng-bind-html=\"vmGloW.getTrustedHtml(vmGloW.komentarz_koncowy)\"></p></div><div ng-if=\"vmZglKarKli.pliki.length>0\"><hr><div style=\"line-height: 150%;display: inline-block;margin: 0 5px;padding-bottom: 10px;\" ng-repeat=\"plik in vmZglKarKli.pliki\"><a target=\"_blank\" ng-click=\"vmZglKarKli.getfile(plik)\">{{plik.nazwaPliku}}</a></div></div></div><obsluga-bledow wiadomosci-tablica=\"vmGloW.odpowiedziSerwera\"></obsluga-bledow><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGloW.slonie.length > 0\"><h3>System łatwej obsługi nieruchomości</h3><strefa-grid api=\"{{vmGloW.apiPropozycje}}\" request-params=\"{{vmGloW.slonieParams}}\" columns=\"vmGloW.columnsPropozycje\" row-expand=\"false\" row-click-override=\"vmGloW.przejdzDoPropozycji(item, index)\" ctrl=\"vmGloW\"></strefa-grid></div><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGloW.inneModuly.length > 0\"><h3>Inne moduły</h3><strefa-grid api=\"{{vmGloW.apiPropozycje}}\" request-params=\"{{vmGloW.inneModulyParams}}\" columns=\"vmGloW.columnsPropozycje\" row-expand=\"false\" row-click-override=\"vmGloW.przejdzDoPropozycji(item, index)\" ctrl=\"vmGloW\"></strefa-grid></div><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGloW.zestawienia.length > 0\"><h3>Zestawienia</h3><strefa-grid api=\"{{vmGloW.apiPropozycje}}\" request-params=\"{{vmGloW.zestawieniaParams}}\" columns=\"vmGloW.columnsPropozycje\" row-expand=\"false\" row-click-override=\"vmGloW.przejdzDoPropozycji(item, index)\" ctrl=\"vmGloW\"></strefa-grid></div><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmGloW.ekartoteka.length > 0\"><h3>e-kartoteka</h3><strefa-grid api=\"{{vmGloW.apiPropozycje}}\" request-params=\"{{vmGloW.ekartotekaParams}}\" columns=\"vmGloW.columnsPropozycje\" row-expand=\"false\" row-click-override=\"vmGloW.przejdzDoPropozycji(item, index)\" ctrl=\"vmGloW\"></strefa-grid></div></div><div class=\"pane13\"><div style=\"margin-top: 50px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; padding: 10px;min-height: 70px; width: 340px; float: right\"><div id=\"szczegoly\" style=\"background-color: white;margin-top: -28px;padding: 10px;z-index: 1;width: 50px;\">Terminy</div><table style=\"width: 100%\"><tr><td style=\"width:40%;\"><span style=\"margin-left: 2px;\">Data rozpoczęcia</span></td><td style=\"width:60%;\"><span>{{vmGloW.glosowanie.data_od | date: \'dd.MM.yyyy\'}}</span></td></tr><tr><td style=\"width:40%; padding-top: 10px;\"><span style=\"margin-left: 2px;\">Data zakończenia</span></td><td style=\"width:60%;\"><span>{{vmGloW.glosowanie.data_do | date: \'dd.MM.yyyy\'}}</span></td></tr></table></div></div></div><script type=\"text/x-kendo-template\" id=\"zobacz\"><div class=\"text-center\" > <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.state.go(\'home.subMain.konto\')\"> <i class=\"fa fa-share\" aria-hidden=\"true\" style=\"display: inline-block; margin: 0; padding: 0\"></i> zobacz </button> </div></script>");
$templateCache.put("app/home/login/login.html","<div class=\"clearfix\"></div><div class=\"pane23\"><h2>Strefa klienta</h2><div class=\"blad\" ng-if=\"vmLogin.blad != \'\'\">{{vmLogin.blad}}</div><form class=\"loginform\" method=\"post\" id=\"formularz\"><label for=\"login\">Login</label><input id=\"login\" type=\"text\" ng-model=\"vmLogin.uzytkownik\" ng-enter=\"vmLogin.zaloguj()\" name=\"login\"><br><label for=\"haslo\">Hasło</label><input id=\"haslo\" type=\"password\" ng-model=\"vmLogin.haslo\" ng-enter=\"vmLogin.zaloguj()\" name=\"passwd\"><br><button class=\"btn-login\" ng-click=\"vmLogin.zaloguj()\"></button></form><div class=\"loadingbox\" style=\"height:18px;\"><img src=\"assets/images/loading.gif\" class=\"loading\" style=\"display:none;\"></div><div class=\"infobox\"></div></div><div class=\"pane13\"><div class=\"box\"><h3>Zostań naszym klientem</h3><p>Jako nasz klient, po zalogowaniu będziesz mieć dostęp do informacji o <b>zakupionych produktach</b>, dostęp do <b>aktualizacji oprogamowania</b>, możliwość kontaktu z <b>obsługą techniczną</b>.</p></div><div class=\"box\"><h3>Logowanie dla mieszkańców</h3><div><p style=\"margin-bottom: 10px\">Jeśli jesteś mieszkańcem korzystającym z portalu e-kartoteka zaloguj się klikając w poniższą ikonkę</p><a href=\"https://e-kartoteka.pl\"><img src=\"./assets/images/ek-szerokie.png\" style=\"width: 140px;\" alt=\"e-kartoteka\"></a><div><p style=\"padding: 10px 0\">lub pobierz aplikację</p><div><a href=\"https://play.google.com/store/apps/details?id=pl.ekartoteka.app&hl=pl&gl=US&pli=1&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1\"><img alt=\"pobierz z Google Play\" style=\"width: 140px\" src=\"https://play.google.com/intl/en_us/badges/static/images/badges/pl_badge_web_generic.png\"></a> <a href=\"https://apps.apple.com/us/app/e-kartoteka/id1440618758?itsct=apps_box_badge&amp;itscg=30200\" style=\"display: inline-block; overflow: hidden; border-radius: 13px; width: 140px;\"><img src=\"https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/pl-pl?size=250x83&amp;releaseDate=1543968000?h=da95caa7635a39056534500e403a9b2d\" alt=\"Download on the App Store\" style=\"border-radius: 13px; width: 140px;\"></a></div></div></div></div><div class=\"box\"><h3>TeamViewer®</h3><p>Narzędzie do zdalnej komunikacji z pracownikami naszej firmy - <a href=\"https://get.teamviewer.com/6pz6372\" target=\"_blank\" class=\"download\">Pobierz</a></p></div></div>");
$templateCache.put("app/home/mapaStrony/mapaStrony.html","mapa strony");
$templateCache.put("app/home/platnosciOnlineEK/platnosciOnlineEK.html","<div class=\"panefull\" xmlns=\"http://www.w3.org/1999/html\"><navbar items=\"vmPlatOnlEK.states\"></navbar><div ui-view=\"\" class=\"platnosciOnline\"><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-9\"><p class=\"informacja\">Witamy na stronie poświęconej <span class=\"wyroznij\">płatnościom online</span> realizowanym w portalu <span class=\"wyroznij\">e&#8209;kartoteka</span>. To powszechnie znane rozwiązanie jest stosowane w wielu dziedzinach życia (m.in. dokonywaniu zakupów przez Internet czy w opłacaniu rachunków za telefon, media czy za dostęp do platform cyfrowych).</p><p class=\"informacja\">Usługa jest dostępna w portalu <span class=\"wyroznij\">e&#8209;kartoteka</span> od 2018 roku i jest realizowana z wykorzystaniem najpopularniejszych metod płatności przy współpracy z firmą <span class=\"wyroznij\">Autopay S.A.</span> Dostawca usługi na mocy licencji wydanej przez Komisję Nadzoru Finansowego jest Krajową Instytucją Płatniczą, która działalność rozliczeniową i rozrachunkową prowadzi na podstawie zgody wydanej przez Narodowy Bank Polski.</p><p class=\"informacja\">Każde połączenie ze stroną płatności jest odpowiednio zabezpieczone certyfikatem SSL, który chroni dane użytkownika i transakcji.</p><p class=\"informacja\">Zachęcamy do zapoznania się ze szczegółami tej usługi, która z każdym miesiącem znajduje coraz szersze uznanie w gronie użytkowników portalu e&#8209;kartoteka.</p></div><div class=\"col-md-3 text-center\" style=\"padding-top: 50px\"><img src=\"./assets/images/autopay.png\"></div></div></div></div></div>");
$templateCache.put("app/home/podszyciePodKlienta/podszyciePodKlienta.html","<div class=\"content\" ng-init=\"vmPod.init()\" style=\"width: 100%\"><div ng-if=\"vmPod.czyPracownik\" style=\"width: 100%;\"><h2>Logowanie na klienta</h2><div style=\"padding-top: 20px\"><div class=\"{{vmPod.bootstrapKlasa}}\" style=\"max-width: 550px;display: inline-block;float: left\"><m-dropdown refresh=\"true\" items=\"vmPod.kontrachenci\" selected=\"vmPod.kontrachent\" get-data=\"vmPod.odswierzKontrachentow(params)\" on-select=\"vmPod.wybierzKontrachenta(items)\" width=\"450\"></m-dropdown></div><div style=\"float: right;\" class=\"{{vmPod.bootstrapKlasa}}\"><button id=\"btn-append-to-body\" type=\"button\" style=\"width: 100px;\" class=\"btn btn-danger form-control\" ng-click=\"vmPod.zaloguj()\">Zaloguj <i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i></button></div></div></div></div>");
$templateCache.put("app/home/popupEdytor/popupDodaj.html","<obsluga-bledow wiadomosci-tablica=\"vmPopupEdytorCtrl.odpowiedziSerwera\"></obsluga-bledow><form><div class=\"floatleft\" style=\"width:600px\"><p></p><h4>Nagłówek</h4><p></p><input ng-model=\"vmPopupEdytorCtrl.dodaj.naglowek\" style=\"width:500px\" type=\"text\" required=\"\"><br></div><div><p></p><h4>Treść</h4><p></p><textarea ng-model=\"vmPopupEdytorCtrl.dodaj.tresc\" style=\"width:500px; height:300px\" type=\"text\" required=\"\"> </textarea><br><p></p><h4>Data Wyświetlenia</h4><p></p></div><div><input ng-model=\"vmPopupEdytorCtrl.data_start\" style=\"width:150px; text-align:center\" type=\"date\" required=\"\"><br><p></p><h4>Data zakończenia</h4><p></p></div><div><input ng-model=\"vmPopupEdytorCtrl.data_koniec\" style=\"width:150px; text-align:center\" type=\"date\" required=\"\"><br><div><button ng-click=\"vmPopupEdytorCtrl.wyslijPopup()\" value=\"\" class=\"btn-send\"></button></div><div class=\"clearfix\"></div></div></form>");
$templateCache.put("app/home/popupEdytor/popupEdycja.html","<div ng-init=\"vmPopupEdytorCtrl.init()\"><obsluga-bledow wiadomosci-tablica=\"vmPopupEdytorCtrl.odpowiedziSerwera\"></obsluga-bledow><form><div class=\"floatleft\" style=\"width:600px\"><p></p><h4>Nagłówek</h4><p></p><input style=\"width:600px; text-align:left\" type=\"text\" ng-model=\"vmPopupEdytorCtrl.popupDoEdycji.naglowek\" required=\"\"></div><div><p></p><h4>Treść</h4><p></p><textarea rows=\"20\" style=\"width:600px; text-align:left\" type=\"text\" ng-model=\"vmPopupEdytorCtrl.popupDoEdycji.tresc\" required=\"\"></textarea></div><div><p></p><h4>Data wyświetlenia</h4><p></p><input style=\"text-align:left\" type=\"date\" ng-model=\"vmPopupEdytorCtrl.data_start\"></div><div><p></p><h4>Data zakończenia</h4><p></p><input style=\"text-align:left\" type=\"date\" ng-model=\"vmPopupEdytorCtrl.data_koniec\"></div><div><button ng-click=\"vmPopupEdytorCtrl.edytujPopup()\" value=\"\" class=\"btn-send\"></button><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div></form></div>");
$templateCache.put("app/home/popupEdytor/popupEdytor.html","<h2>Popup</h2><ui-view></ui-view>");
$templateCache.put("app/home/popupEdytor/popupLista.html","<div class=\"panefull\" ng-init=\"vmPopupEdytorCtrl.init()\" style=\"padding-bottom: 50px;\"><obsluga-bledow wiadomosci-tablica=\"vmPopupEdytorCtrl.odpowiedziSerwera\"></obsluga-bledow><div><a class=\"boxed-link\" ui-sref=\"home.subMain.popupEdytor.popupDodaj\">Dodaj Popup <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></a></div><br><strefa-grid api=\"{{vmPopupEdytorCtrl.api}}\" request-params=\"{{vmPopupEdytorCtrl.dane}}\" columns=\"vmPopupEdytorCtrl.columns\" selected-item=\"vmPopupEdytorCtrl.wybranyWiersz\" row-expand=\"true\" row-expand-template=\"{{vmPopupEdytorCtrl.rowTemplate}}\" select-first=\"{{vmPopupEdytorCtrl.zaznaczPierwszyWiersz}}\" ctrl=\"vmPopupEdytorCtrl\" error-delete-text=\"Nie udało się usunąć pozycji\" allow-delete=\"true\" global-search=\"{{vmPopupEdytorCtrl.globalSearch}}\" refresh=\"{{vmPopupEdytorCtrl.refreshGrid}}\"></strefa-grid></div><script type=\"text/x-kendo-template\" id=\"rowTemplate\"><div> <uib-tabset> <div class=\"container-fluid default-color\"> <dl class=\"dl-horizontal\"> <dt ng-if=\"row.tresc\">Treść:</dt> <dd ng-bind-html=\"vm.wyswietlHTML(row.tresc)\"></dd> </dl> <br/> </div> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"Operacja\"><div class=\"text-center\"> <div ng-hide=\"row.edycja\"> <a class=\"boxed-link\" ui-sref=\"home.subMain.popupEdytor.popupEdycja({idp:row.id})\" title=\"Edytuj\" >Edytuj </a> <a ng-click=\"vm.confirmDelete(row, $event)\" value=\"\" title=\"Usuń\" class=\"boxed-link\" >Usuń </a> </div> </div></script>");
$templateCache.put("app/home/potencjalnyKlient/brakDostepu.html","<h2>Odnośnik został już użyty lub stracił ważność</h2><div class=\"bootstrap-iso-paper\"><p>Odnośniki do zgłoszeń są aktywne przez 5 dni – jeden odnośnik pozwala na zalogowanie się jednego urządzenia.</p><p>Jeżeli potrzebujesz dostępu z innego urządzenia lub posiadany odnośnik stracił ważność, możesz poprosić o wygenerowanie nowego odnośnika, klikając przycisk poniżej.</p><button class=\"btn\" style=\"float: right\" ng-disabled=\"vmPKBD.wyslano === true\" ng-class=\"{\'btn-success\' : vmPKBD.wyslano === true, \'btn-primary\': vmPKBD.wyslano === false}\" data-ng-click=\"vmPKBD.poprosONowyToken()\"><i class=\"fa fa-check\" aria-hidden=\"true\" ng-if=\"vmPKBD.wyslano === true\"></i> {{ vmPKBD.wyslano === false ? \'Poproś o nowy odnośnik\' : \'wysłano\'}}</button></div>");
$templateCache.put("app/home/potencjalnyKlient/potencjalnyKlient.html","<ui-view></ui-view>");
$templateCache.put("app/home/potencjalnyKlient/zgloszenia.szczegoly.html","<div class=\"{{vmPKZgl.bootstrapKlasa}}\" ng-if=\"vmPKZgl.dostepDoBety.info()==true\" ng-init=\"vmPKZgl.init()\"><div style=\"padding-top: 30px;\"><a>{{\'#\' + vmPKZgl.numerZgloszenia}}</a><p style=\"margin-top: 5px;\"><b>{{vmPKZgl.zgloszenie.tytul}}</b> <span style=\"margin-left: 10px;\"><span class=\"label label-primary\" style=\"font-size: 10px;\">{{vmPKZgl.zgloszenie.status}}</span></span> <span class=\"help-block\" ng-if=\"vmPKZgl.zgloszenie.utworzone_przez_prac_m\">Zgłoszenie utworzone przez pracownika firmy Mieszczanin</span></p></div><obsluga-bledow wiadomosci-tablica=\"vmPKZgl.odpowiedziSerwera\"></obsluga-bledow><div style=\"width: 65%;display: inline-block; float: left\"><div id=\"komentarz\" ng-if=\"vmPKZgl.czyZamkniete === false\" style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; min-height: 225px;\"><div id=\"dodajKomentarz\" style=\"background-color: white;margin-top: -18px;margin-left:10px;padding: 10px;z-index: 1;width: 130px;\">Dodaj Komentarz</div><textarea id=\"text\" lang=\"pl\" style=\"width: 600px;min-height: 150px;resize: none;margin-left:10px;margin-right:10px;margin-bottom:10px;padding: 10px;background: whitesmoke;\" ng-model=\"vmPKZgl.komentarz\">\n            </textarea><div class=\"row\"><div class=\"col-xs-8\" style=\"padding-left: 25px;\"><button class=\"btn btn-default\" ng-disabled=\"schowaj\" ng-click=\"vmPKZgl.dodajDokumenty=true\" ng-show=\"!vmPKZgl.dodajDokumenty\"><span class=\"ng-binding\">Dodaj załączniki</span></button><dodawanie-plikow ng-show=\"vmPKZgl.dodajDokumenty==true\" files=\"vmPKZgl.uploadPliki\"></dodawanie-plikow></div><div class=\"col-xs-4\"><button type=\"button\" class=\"btn\" style=\"background-color: #0a6ebd;color: white;float: right; margin-right: 10px;\" ng-click=\"vmPKZgl.dodajKomentarz(vmPKZgl.uploadPliki)\" ng-class=\"{\'disabled\': vmPKZgl.komentarz.length<=0 || vmPKZgl.czyZamkniete === true }\"><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i> Wyślij komentarz</button></div></div></div><div style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; min-height: 100px;\"><div id=\"opis\" style=\"background-color: white;margin-top: -12px;margin-left:10px;padding: 10px;z-index: 1;width: 50px;\">Opis</div><div style=\"padding:10px; width:100%;min-height: 40px\"><div><p style=\"font-size: large; padding-left: 10px\">{{vmPKZgl.zgloszenie.klientNazwa}} {{vmPKZgl.zgloszenie.dataUtworzenia | date: \'dd.MM.yyyy HH.mm\'}}</p></div><div style=\"padding: 20px; line-height: 1.4\"><span ng-bind-html=\"vmPKZgl.getTrustedHtml(vmPKZgl.zgloszenie.opis)\"></span></div><div ng-if=\"vmPKZgl.pliki.length>0\"><hr><div style=\"line-height: 150%;display: inline-block;margin: 0 5px;padding-bottom: 10px;\" ng-repeat=\"plik in vmPKZgl.pliki\"><a target=\"_blank\" ng-click=\"vmPKZgl.getfile(plik)\">{{plik.nazwaPliku}}</a></div></div></div></div><div style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; min-height: 50px;\"><div id=\"komentarze\" style=\"background-color: white;margin-top: -18px;margin-left:10px;padding: 10px;z-index: 1;width: 90px;\">Aktywność</div><div style=\"margin-top: -1px; min-height: 100px; color:#11335A; padding: 0\"><div class=\"comment\" id=\"{{\'kom\'+komentarz.id}}\" ng-repeat=\"komentarz in vmPKZgl.komentarze | orderBy: \'-dataDodania\'\" ng-mouseenter=\"vmPKZgl.podswKomentarza[vmPKZgl.komentarze.indexOf(komentarz)]=true\" ng-mouseleave=\"vmPKZgl.podswKomentarza[vmPKZgl.komentarze.indexOf(komentarz)]=false\" ng-if=\"!komentarz.flaga\"><div class=\"comment-header\" ng-if=\"!komentarz.informacjaSystemowa\"><i class=\"fa fa-user-circle fa-lg\" aria-hidden=\"true\"></i> <b>{{komentarz.uzytkownikNazwa}}</b> dodał(a) komentarz - {{komentarz.dataDodania | date:\'dd.MM.yyyy HH:mm\'}}</div><div class=\"comment-flag\" ng-if=\"!komentarz.informacjaSystemowa\"><span class=\"label label-default\" style=\"font-size: 10px;\" ng-if=\"komentarz.flaga==true && !komentarz.informacjaSystemowa\">Wewnętrzny</span></div><div class=\"comment-body\" ng-if=\"!komentarz.informacjaSystemowa\"><div style=\"margin: 0!important; padding: 0\"><span ng-bind-html=\"komentarz.tresc | trustAsHtml\"></span></div><div style=\"margin: 0;white-space: normal\" ng-if=\"(vmPKZgl.pliki | filter: {idKomentarza: komentarz.id}).length>0\"><hr style=\"margin: 10px 0 0;padding: 5px;\"><a ng-repeat=\"plik in vmPKZgl.pliki | filter: {idKomentarza: komentarz.id}\" style=\"padding-right: 10px;\" target=\"_blank\" ng-click=\"vmPKZgl.getfile(plik)\">{{plik.nazwaPliku}}</a></div></div><div class=\"system-comment-body\" ng-if=\"komentarz.informacjaSystemowa\"><div style=\"margin: 0!important; padding: 0;white-space: normal;color: grey\">{{komentarz.dataDodania | date:\'dd.MM.yyyy HH:mm\'}}<br><br><span style=\"display: inline-block;padding-right: 5px;\" ng-bind-html=\"komentarz.tresc | trustAsHtml\"></span><br><br>{{vmPKZgl.statusService.dajOpis(komentarz.tresc, vmPKZgl.zgloszenie.typ, vmZglKarKli.zgloszenie.powodZamkniecia)}}</div></div><div style=\"padding-bottom: 10px;\"><div ng-if=\"komentarz.idOferty !== null && vmPKZgl.ofertyLista.length > 0 && (vmPKZgl.oferty[komentarz.idOferty] === null || vmPKZgl.oferty[komentarz.idOferty] === undefined)\" style=\"color: grey\">Oferta aktualnie niedostępna do podglądu.</div><div ng-if=\"komentarz.idOferty !== null && vmPKZgl.oferty[komentarz.idOferty] !== undefined && vmPKZgl.ladowanieOfert === false\" style=\"width: 95%;\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmPKZgl.pokazOferte(vmPKZgl.oferty[komentarz.idOferty])\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Pokaż ofertę</button></div><div ng-if=\"komentarz.idOferty !== null && vmPKZgl.ladowanieOfert === true\"><i class=\"fa fa-spinner fa-spin fa-fw\" aria-hidden=\"true\"></i> Pobieranie oferty</div></div></div></div></div></div></div>");
$templateCache.put("app/home/prezentacjaZebranOnline/prezentacjaZebranOnline.html","<style>\n    html, body {\n        margin: 0;\n        padding: 0;\n    }\n\n    .videogular-container {\n        width: 600px;\n        height: 400px;\n        margin: 0 auto;\n        overflow: hidden;\n    }\n\n</style><div ui-view=\"\"><h3>Prezentacja zebrań online</h3><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"\" style=\"padding-top: 20px;width: 100%\"><div class=\"videogular-container\" style=\"margin: 0 auto;\"><videogular vg-theme=\"vmPZO.config.theme.url\"><vg-media vg-src=\"vmPZO.config.sources\" vg-tracks=\"vmPZO.config.tracks\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"2000\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play></videogular></div></div></div></div></div></div>");
$templateCache.put("app/home/promocje/dodajPromocje.html","<style>\n    .checkbox-grid li {\n        display: inline-block;\n        float: right;\n        width: 50%;\n    }\n</style><div><div class=\"row\"><div class=\"col-sm-6\"><h3>Dodawanie promocji</h3><obsluga-bledow wiadomosci-tablica=\"vmDodPro.odpowiedziSerwera\"></obsluga-bledow><form name=\"dodawaniePromocji\" method=\"post\" id=\"formLimit\" novalidate=\"\"><label for=\"title\">Tytuł</label> <input id=\"title\" type=\"text\" name=\"title\" required=\"\" ng-model=\"vmDodPro.promocja.tytul\" ng-style=\"(vmDodPro.promocja.tytul === null) && {\'border\' : \'solid\',\'border-color\': \'red\', \'border-width\' : \'1px\'}\"><br><label for=\"aktywnaOd\">Aktywna od</label> <input id=\"aktywnaOd\" type=\"date\" name=\"aktywnaOd\" required=\"\" placeholder=\"DD-MM-YYYY\" ng-model=\"vmDodPro.promocja.dataOd\" ng-style=\"(vmDodPro.promocja.aktywnaOd === null) && {\'border\' : \'solid\',\'border-color\': \'red\', \'border-width\' : \'1px\'}\"><br><label for=\"aktywnaDo\">Aktywna do</label> <input id=\"aktywnaDo\" type=\"date\" name=\"aktywnaDo\" required=\"\" placeholder=\"DD-MM-YYYY\" ng-model=\"vmDodPro.promocja.dataDo\" ng-style=\"(vmDodPro.promocja.aktywnaDo === null) && {\'border\' : \'solid\',\'border-color\': \'red\', \'border-width\' : \'1px\'}\"><br><label for=\"segmentacja\">Segmentacja</label><select id=\"segmentacja\" ng-model=\"vmDodPro.promocja.segmentacja\" ng-options=\"grupa.wartosc as grupa.opis for grupa in vmDodPro.segmentacja\"><br></select><br><label for=\"tresc\">Treść</label> <textarea id=\"tresc\" rows=\"6\" cols=\"64\" name=\"comment\" form=\"formLimit\" required=\"\" ng-model=\"vmDodPro.promocja.tresc\" style=\"margin-bottom: 30px\"></textarea></form></div><div><ul class=\"checkbox-grid\"><li ng-repeat=\"opcja in vmDodPro.opcje\"><label class=\"checkboxlabel\" style=\"width: 245px;float: left; padding-top: 12px; display: inline-block;\">{{opcja.opis}}</label><promocje-dropdown wersje=\"vmDodPro.wersje\" opcja=\"opcja\"></promocje-dropdown></li></ul></div></div><div class=\"clearfix\"></div><div class=\"{{vmDodPro.bootstrapKlasa + \' col-sm-12\'}}\" style=\"float: right; margin-right: 120px\"><br><button ng-click=\"vmDodPro.zapiszPromocje()\" class=\"btn btn-default\">{{vmDodPro.promocja.id ===0? \'Dodaj\':\'Zapisz\'}} promocje</button> <button ui-sref=\"home.subMain.promocje\" class=\"btn btn-default\">Anuluj</button></div></div>");
$templateCache.put("app/home/promocje/promocje.html","<div class=\"content\"><div class=\"pane23\"><h2>Promocje</h2><div ng-if=\"vmPro.security.jestPracownikiemMieszczanin()\" style=\"margin-top:20px;float: left;\"><a class=\"boxed-link\" ui-sref=\"home.subMain.dodajPromocje\">Dodaj promocję <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></a></div><div class=\"clearfix\"></div><div id=\"promocja{{promocja.id}}\" style=\"margin: 20px 0 20px; padding: 0 20px 0 20px\" ng-repeat=\"promocja in vmPro.promocje\" ng-if=\"promocja.status !== \'nieaktywna\' || vmPro.security.jestPracownikiemMieszczanin()\" ng-style=\"(promocja.status === \'nieaktywna\') && {\'background-color\': \'lightgrey\', \'border\' : \'solid\', \'border-size\' : \'1px\', \'border-color\' : \'grey\'}\"><div class=\"clearfix\"></div><div class=\"box23\" style=\"margin-bottom: 0px\"><h3 style=\"margin-bottom: 0px\">{{promocja.tytul}}</h3></div><div class=\"clearfix\"></div><div class=\"box23\" style=\"margin-top: 0px; margin-bottom: 0px\"><p style=\"float: right; margin-top: 0px\"><b>promocja aktywna do: {{promocja.dataDo | date : \'dd.MM.yyyy\'}}</b></p></div><div class=\"clearfix\"></div><div class=\"box23\" style=\"margin-top: 0px\"><p style=\"float: right; color: crimson;\"><b><l ng-if=\"vmPro.obliczCzas(promocja.dataDo) !== \'Promocja zakończona.\'\">pozostało:</l>{{vmPro.obliczCzas(promocja.dataDo)}}</b></p></div><div class=\"clearfix\"></div><div class=\"box23\"><p ng-bind-html=\"promocja.tresc\"></p></div><div class=\"clearfix\"></div><div class=\"{{vmPro.bootstrapKlasa + \' button-group\'}}\"><div class=\"box23\"><button class=\"btn btn-default\" ng-if=\"vmPro.security.jestPracownikiemMieszczanin() && promocja.status !== \'nieaktywna\'\" ng-click=\"vmPro.oznaczJakoNieaktywna(promocja)\">Oznacz jako nieaktywna</button> <button class=\"btn btn-default\" ng-if=\"vmPro.security.jestPracownikiemMieszczanin() && promocja.status === \'nieaktywna\' && promocja.edycja !== true\" ng-click=\"vmPro.aktywuj(promocja)\">Aktywuj promocje</button> <button class=\"btn btn-default\" ng-if=\"vmPro.security.jestPracownikiemMieszczanin()\" ng-click=\"vmPro.edytujPromocje(promocja)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> Edytuj</button> <button class=\"btn btn-default\" style=\"float: right;\" ng-if=\"!vmPro.security.jestPracownikiemMieszczanin()\" ng-click=\"vmPro.skorzystajZPromocji(promocja)\">Skorzystaj z promocji</button></div></div><div class=\"clearfix\"></div><div style=\"display: inline-block\" ng-if=\"promocja.edycja\"><label for=\"aktywnaDo\">Aktywna do</label> <input id=\"aktywnaDo\" type=\"date\" name=\"aktywnaDo\" required=\"\" placeholder=\"YYYY-MM-DD\" ng-model=\"vmPro.dataDo\" ng-style=\"(vmPro.dataDo === null) && {\'border\' : \'solid\',\'border-color\': \'red\', \'border-width\' : \'1px\'}\"><br><label for=\"segmentacja\">Widoczna dla</label><select id=\"segmentacja\" ng-model=\"vmPro.grupa\" ng-options=\"grupa.wartosc as grupa.opis for grupa in vmPro.segmentacja\"></select><br><div class=\"{{vmPro.bootstrapKlasa + \' button-group\'}}\"><button class=\"btn btn-default\" style=\"float: right;\" ng-if=\"promocja.edycja === true\" ng-click=\"promocja.edycja = false;\">Anuluj</button> <button class=\"btn btn-default\" style=\"float: right; margin-right: 10px\" ng-if=\"promocja.edycja === true\" ng-click=\"vmPro.zapisz(promocja)\">Zapisz</button></div></div></div><div class=\"box23\" style=\"width: 100%;\" ng-if=\"vmPro.promocje.length === 0\"><h3>W chwili obecnej brak jest aktywnych akcji promocyjnych.<br>Zachęcamy do regularnych odwiedzin w Strefie Klienta!</h3></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 5px;\"><h3 style=\"padding-bottom: 10px\">Jak skorzystać z promocji</h3><p>W celu skorzystania z promocji kliknij w przycisk \"skorzystaj z promocji\". Pracownik Działu Handlowego skontaktuje się z Tobą w krótkim czasie.</p></div></div></div>");
$templateCache.put("app/home/seminaria/archiwumSeminariow.panel.seminaria.html","<div ui-view=\"\" style=\"min-height: 250px;\"><h2 style=\"width: 100%;\">Archiwum seminariów</h2><strefa-grid api=\"{{vmSemA.api}}\" request-params=\"{{vmSemA.seminaria.dane}}\" columns=\"vmSemA.columns\" selected-item=\"vmSemA.wybranyWiersz\" row-expand=\"true\" row-expand-template=\"{{vmSemA.rowTemplate}}\" select-first=\"true\" ctrl=\"vmSemA\" error-delete-text=\"Nie udało się usunąć pozycji\" allow-delete=\"true\" global-search=\"true\" refresh=\"{{vmSemA.odswiezTabele}}\"></strefa-grid></div><script type=\"text/x-kendo-template\" id=\"rowTemplate\"><div> <uib-tabset> <div class=\"container-fluid default-color\" > <dl class=\"dl-horizontal\" style=\"margin-bottom: 0\"> <dt style=\"padding: 0\">Adres szkolenia:</dt> <dd style=\"padding: 0\">{{row.adresSzkolenia}}</dd> <dt style=\"padding: 0\">Data szkolenia:</dt> <dd style=\"padding: 0\">{{row.dataSzkolenia | date: \"dd.MM.yyyy HH:mm\"}}</dd> <dt style=\"padding: 0\">Edycja/rezygnacja do:</dt> <dd style=\"padding: 0\">{{row.rezygnacjaDo | date: \"dd.MM.yyyy HH:mm\"}}</dd> <dt style=\"padding: 0\">Cena na os:</dt> <dd style=\"padding: 0\">{{row.cenaNaOs}} zł netto</dd> <dt style=\"padding: 0\" ng-if=\"row.wartoscPromocji > 0\">Promocja:</dt> <dd style=\"padding: 0\" ng-if=\"row.wartoscPromocji > 0\"> {{row.wartoscPromocji}}% <b>do</b> {{row.dataKoncaPromocji | date: \"dd.MM.yyyy HH:mm\"}} <span style=\"\" class=\"bootstrap-iso-paper\" ng-if=\"row.promocjaAktywna === true\"> <span class=\"label label-primary\">Trwa</span> </span> <span style=\"\" class=\"bootstrap-iso-paper\" ng-if=\"row.promocjaAktywna === false\"> <span class=\"label label-default\">Zakończona</span> </span> </dd> <dt style=\"padding: 0\">Typ szkolenia:</dt> <dd style=\"padding: 0\">{{row.typSzkolenia}}</dd> <dt style=\"padding: 0\">Max uczestników:</dt> <dd style=\"padding: 0\">{{row.maxUczestnikow}}</dd> <dt style=\"padding: 0\">Zakres szkolenia:</dt> <dd style=\"padding: 0\" ng-bind-html=\"vm.wyswietlHTML(row.zakres)\"></dd> <dt style=\"padding: 0\">Emaile uczestników:</dt> <dd style=\"padding: 0\"> <div class=\"input-group\" style=\"margin-top: -6px\"> <input style=\"font-size: 14px;\" type=\"text\" class=\"form-control\" value=\"{{row.adresy_email.join(\'; \')}}\" disabled/> <span class=\"input-group-btn\"> <button class=\"btn btn-default btn-sm\" ngclipboard data-clipboard-text=\"{{row.adresy_email.join(\'; \')}}\"> <span>Kopiuj</span> </button> </span> </div> </dd> </dl> </div> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"Modyfikacja\"><div class=\"text-center\" ng-click=\"row.expanded = true;\"> <button type=\"button\" class=\"btn btn-default btn-sm\" ui-sref=\"home.subMain.seminariaPZ.edycja({id:row.id})\"> <i class=\"fa fa-pencil\" aria-hidden=\"true\" style=\"display: inline-block; margin: 0; padding: 0\"></i> </button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vm.confirmDelete(row, $event)\"> <i class=\"fa fa-trash\" aria-hidden=\"true\"></i> </button> </div></script>");
$templateCache.put("app/home/seminaria/archiwumZapisow.panel.seminaria.html","<div class=\"content\" ui-view=\"\"><h2 style=\"\">Archiwum zapisów na seminaria</h2><fieldset class=\"bootstrap-iso-paper\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"input-group\"><input type=\"text\" class=\"form-control ng-pristine ng-valid ng-touched\" placeholder=\"Wpisz nazwę poszukiwanego seminarium\" name=\"searchNazwaSeminarium\" ng-model=\"vmSemZA.szukajSeminaria\" style=\"\" ng-enter=\"vmSemZA.szukajSeminariow()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\" ng-click=\"vmSemZA.szukajSeminariow()\"><span>Szukaj</span></button></span></div></div></div></fieldset><div ng-repeat=\"szkolenie in vmSemZA.seminaria\"><div style=\"margin-bottom: 40px;\"><h3 style=\"margin:0\"><a>#{{szkolenie.id}}</a> <span>{{szkolenie.temat}}</span></h3><span style=\"float: right\">Data: {{szkolenie.dataSzkolenia | date: \"dd.MM.yyyy\"}}</span> <span class=\"{{vmSemZA.bootstrapKlasa}}\">Uczestnicy: <span class=\"label label-primary\">{{(szkolenie.liczby_zapisanych.wplynelo !== null) ? szkolenie.liczby_zapisanych.wplynelo : 0}}</span> <span class=\"label label-success\">{{(szkolenie.liczby_zapisanych.zaakceptowane !== null) ? szkolenie.liczby_zapisanych.zaakceptowane : 0}}</span> <span class=\"label label-default\">{{(szkolenie.liczby_zapisanych.niezakwalifikowane !== null) ? szkolenie.liczby_zapisanych.niezakwalifikowane : 0}}</span></span></div><div style=\"margin-bottom: 20px;\" class=\"{{vmSemZA.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"home.subMain.seminariaPZ.zapisyNowy({id:szkolenie.id})\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Zapisz klienta</button></div><strefa-grid api=\"{{vmSemZA.apiZapisy}}\" request-params=\"{{vmSemZA.getid(szkolenie.id)}}\" columns=\"vmSemZA.columns\" selected-item=\"szkolenie.zakres\" row-expand=\"true\" row-expand-template=\"{{vmSemZA.rowTemplate}}\" refresh=\"vmSemZA.refresh\" show-filter=\"true\" global-search=\"true\" ctrl=\"vmSemZA\"></strefa-grid><div style=\"margin-bottom: 20px;\" class=\"{{vmSemZA.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vmSemZA.pobierzListeZaakceptowanych(szkolenie.id)\"><i class=\"fa fa-table\" aria-hidden=\"true\"></i> Pobierz wykaz uczestników</button> <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vmSemZA.pobierzListeWszystkichZapisanych(szkolenie.id)\"><i class=\"fa fa-table\" aria-hidden=\"true\"></i> Wykaz zapisanych</button></div></div></div><script type=\"text/x-kendo-template\" id=\"rowTemplate\"><div> <uib-tabset> <div class=\"container-fluid default-color\" > <h5>dane podstawowe</h5> <dl class=\"dl-horizontal\" style=\"margin-bottom: 0\"> <dt style=\"padding: 0\">Kod klienta:</dt> <dd style=\"padding: 0\">{{row.kodKlienta}}</dd> <dt style=\"padding: 0\">Zgłaszający:</dt> <dd style=\"padding: 0\">{{row.nazwaZglaszajacego}}</dd> <dt style=\"padding: 0\">Telefon:</dt> <dd style=\"padding: 0\">{{row.numerKontaktowy}}</dd> <dt style=\"padding: 0\">Email:</dt> <dd style=\"padding: 0\">{{row.adresEmail}}</dd> <dt style=\"padding: 0\">Cena:</dt> <dd style=\"padding: 0\">{{row.cenaCalosc}} zł netto</dd> <dt style=\"padding: 0\">Zwolnienie z VAT</dt> <dd style=\"padding: 0\">{{(row.zwolnienieZVAT == true ) ? \'Tak\' : \'Nie\' }}</dd> </dl> <h5>uczestnicy</h5> <dl class=\"dl-horizontal\" style=\"margin-bottom: 0;width: 400px;\"> <dt ng-repeat-start=\"uczestnik in row.uczestnicy\" style=\"padding: 0;min-width: 200px;\" uib-tooltip=\"{{uczestnik.imie + \' \' + uczestnik.nazwisko}}\" tooltip-placement=\"right\"> {{uczestnik.imie + \' \' + uczestnik.nazwisko}}: </dt> <dd ng-repeat-end=\"\" style=\"padding: 0 0 0 30px;\"> <i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i> {{uczestnik.adresEmail}}<br> <i class=\"fa fa-phone\" aria-hidden=\"true\"></i> {{uczestnik.numerKontaktowy}} </dd> </dl> </div> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"Modyfikacja\"><div class=\"text-center\" ng-click=\"row.expanded = true;\"> <button type=\"button\" class=\"btn btn-default btn-sm\" ui-sref=\"home.subMain.seminariaPZ.zapisyEdycja({id:row.id})\"> <i class=\"fa fa-pencil\" aria-hidden=\"true\" style=\"display: inline-block; margin: 0; padding: 0\"></i> </button> </div></script>");
$templateCache.put("app/home/seminaria/archiwumZapisow.seminaria.html","<div class=\"content\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0px\"><h2>Archiwum zapisów</h2><p ng-if=\"vmSemZA.zapisy.length <= 0\">Nie znaleziono żadnych seminariów na które się państwo zapisali.</p></div><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmSemZA.zapisy.length > 0\"><h3>Seminaria</h3><strefa-grid api=\"{{vmSemZA.apiZapisy}}\" request-params=\"{{vmSemZA.zapisy.dane}}\" columns=\"vmSemZA.columnsZapisy\" selected-item=\"vmSemZA.wybranyWierszZapisy\" row-expand=\"true\" row-expand-template=\"{{vmSemZA.rowTemplateZapisy}}\" select-first=\"false\" ctrl=\"vmSemZA\"></strefa-grid></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 5px;\"><p>Można tutaj zobaczyć listę seminariów na które się państwo zapisali.</p></div></div></div><script type=\"text/x-kendo-template\" id=\"rowTemplateZapisy\"><div> <uib-tabset> <div class=\"container-fluid default-color\" > <dl class=\"dl-horizontal\" style=\"margin-bottom: 0\"> <dt style=\"padding: 0\">Data szkolenia:</dt> <dd style=\"padding: 0\">{{row.daneSzkolenia.dataSzkolenia | date : \"dd.MM.yyyy\"}} <span ng-if=\"row.daneSzkolenia.dataKoncaSzkolenia !== null && !vm.runExtFunction(\'sprawdzCzyJednodniowe\', row.daneSzkolenia)\"> - {{row.daneSzkolenia.dataKoncaSzkolenia | date: \"dd.MM.yyyy\"}}</span></dd> <dt style=\"padding: 0\">Adres szkolenia:</dt> <dd style=\"padding: 0\">{{row.daneSzkolenia.adresSzkolenia}}</dd> <dt style=\"padding: 0\">Cena:</dt> <dd style=\"padding: 0\">{{row.daneSzkolenia.cenaNaOs * row.liczbaOsob | currency : \"\"}} zł netto</dd> <dt style=\"padding: 0\">Po rabacie:</dt> <dd style=\"padding: 0\">{{row.cenaCalosc | currency : \"\"}} zł netto</dd> <dt style=\"padding: 0\">Zgłaszający:</dt> <dd style=\"padding: 0\">{{row.nazwaZglaszajacego}}</dd> <dt style=\"padding: 0\">Liczba osób:</dt> <dd style=\"padding: 0\">{{row.liczbaOsob}}</dd> <dt style=\"padding: 0\">Uczestnicy:</dt> <dd style=\"padding: 0\"> <ul> <li ng-repeat=\"uczestnik in row.uczestnicy\" style=\"margin: 0\"> {{uczestnik.imie + \' \' + uczestnik.nazwisko}} </li> </ul> </dd> <dt style=\"padding: 0\">Zakres szkolenia:</dt> <dd style=\"padding: 0\" ng-bind-html=\"vm.wyswietlHTML(row.daneSzkolenia.zakres)\"></dd> <dt style=\"padding: 0\" ng-if=\"row.daneSzkolenia.pliki_wszyscy.length > 0 || row.daneSzkolenia.pliki_zapisani.length > 0\">Załączniki:</dt> <dd style=\"padding: 0\" ng-if=\"row.daneSzkolenia.pliki_wszyscy.length > 0\"> <div ng-repeat=\"plik in row.daneSzkolenia.pliki_wszyscy\"> <a target=\"_blank\" ng-click=\"vm.getFile(\'/seminaria/pliki/\', plik)\" style=\"margin-top: 20px;\" ng-if=\"element.plik !== null\"> <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}} </a> </div> <div ng-repeat=\"plik in row.daneSzkolenia.pliki_zapisani\"> <a target=\"_blank\" ng-click=\"vm.getFile(\'/seminaria/pliki/\', plik)\" style=\"margin-top: 20px;\" ng-if=\"element.plik !== null\"> <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}} </a> </div> </dd> </dl> </div> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"rozwin\"><div class=\"text-center\" ><a ui-sref=\"home.subMain.seminariaReklamacja({id:row.id})\"> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"row.dni_od_szkolenia <= 5\" ng-click=\"row.expanded = true;vm.runExtFunction(\'dodajReklamacje\', row);\"> Zgłoś reklamację </button></a> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"row.expanded = false;\"> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" style=\"display: inline-block; margin: 0; padding: 0\"></i> szczegóły </button> </div></script>");
$templateCache.put("app/home/seminaria/dynamicznyTekst.panel.seminaria.html","<div class=\"content\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0px\"><h2>Seminaria szkoleniowe</h2><obsluga-bledow wiadomosci-tablica=\"vmSemDT.odpowiedziSerwera\"></obsluga-bledow><p ng-bind-html=\"vmSemDT.dynamicznyTekst.tekst\"></p><div class=\"bootstrap-iso-paper\"><p style=\"margin-bottom: 5px;margin-top: 10px;\"><b>Załączniki:</b></p><ul><li ng-repeat=\"plik in vmSemDT.plikiEdycja\"><a ng-click=\"vmSemDT.getFile(plik)\">{{plik.nazwaPliku}}</a> <a style=\"color: red\" ng-click=\"vmSemDT.usunPlik(plik)\" ng-if=\"vmSemDT.edycja\"><i class=\"fa fa-times red\" aria-hidden=\"true\"></i></a></li></ul><div style=\"margin-bottom: 10px;\"><button style=\"\" class=\"btn btn-primary\" title=\"Edytuj\" ng-if=\"vmSemDT.edycja == false\" ng-click=\"vmSemDT.edytuj()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> <span>Edytuj</span></button> <button class=\"btn btn-default\" ng-disabled=\"schowaj\" ng-click=\"vmSemDT.dodajDokumenty=true\" ng-show=\"!vmSemDT.dodajDokumenty\"><span class=\"ng-binding\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> dodaj Załączniki</span></button></div><dodawanie-plikow ng-show=\"vmSemDT.dodajDokumenty==true\" files=\"pliki\"></dodawanie-plikow></div><div class=\"bootstrap-iso-paper\" ng-if=\"vmSemDT.edycja == true\" style=\"width: 100%\"><textarea class=\"form-control\" style=\"min-width: 500px; min-height: 500px;\" ng-model=\"vmSemDT.dynamicznyTekst.tekst\">\n                </textarea></div><div class=\"bootstrap-iso-paper\" ng-if=\"vmSemDT.edycja == true || vmSemDT.dodajDokumenty == true\"><div style=\"padding-top: 20px;width: 100%\"><button style=\"\" class=\"btn btn-primary\" title=\"Zapisz\" ng-click=\"vmSemDT.zapisz(pliki)\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> <span>Zapisz</span></button> <button style=\"\" class=\"btn btn-default\" title=\"Anuluj\" ng-click=\"vmSemDT.anuluj()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> <span>Anuluj</span></button></div></div></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 5px;\"><h3 style=\"padding-bottom: 10px\">Statusy</h3><p><b>wpłynęło</b> - zgłoszenie oczekuje na potwierdzenie możliwości uczestnictwa<br><b>zaakceptowane</b> - uczestnictwo w szkoleniu zostało potwierdzone<br><b>niezakwalifikowane</b> - z uwagi na przekroczenie liczby miejsc państwa zgłoszenie trafiło na listę rezerwową</p></div></div></div>");
$templateCache.put("app/home/seminaria/edycja.panel.seminaria.html","<div class=\"content\"><div class=\"pane23\"><h2>Seminaria</h2><h3>Edycja seminarium</h3><div class=\"box23\" style=\"margin-bottom: 0; margin-left: 10px;\"><obsluga-bledow wiadomosci-tablica=\"vmSemE.odpowiedziSerwera\"></obsluga-bledow><form name=\"edycjaSeminarium\" novalidate=\"\"><table style=\"width: 400px;margin-top: 20px;\" class=\"bootstrap-iso-paper\"><tr><td style=\"max-width: 100px;\"><label for=\"temat\">Temat</label></td><td><input class=\"form-control\" id=\"temat\" name=\"temat\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.temat\" type=\"text\"> <span ng-show=\"edycjaSeminarium.temat.$touched && vmSemE.seminarium.temat.length < 4\" style=\"color: crimson;\">Temat jest wymagany.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"zakres\">Zakres</label></td><td><textarea class=\"form-control\" id=\"zakres\" name=\"zakres\" rows=\"4\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.zakres\" type=\"text\">\n                        </textarea> <span ng-show=\"edycjaSeminarium.zakres.$touched && vmSemE.seminarium.zakres.length < 4\" style=\"color: crimson;\">Zakres jest wymagany.</span></td></tr><tr><td style=\"max-width: 120px;\"><label for=\"adres\">Adres szkolenia</label></td><td><input class=\"form-control\" id=\"adres\" name=\"adres\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.adresSzkolenia\" type=\"text\"> <span ng-show=\"edycjaSeminarium.adres.$touched && vmSemE.seminarium.adresSzkolenia.length < 4\" style=\"color: crimson;\">Adres szkolenia jest wymagany.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"miejsce\">Miejsce</label></td><td><input class=\"form-control\" id=\"miejsce\" name=\"miejsce\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.miejsce\" placeholder=\"Firma Mieszczanin\" type=\"text\"> <span ng-show=\"edycjaSeminarium.miejsce.$touched && vmSemE.seminarium.miejsce.length < 4\" style=\"color: crimson;\">Miejsce jest wymagane.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"typSzkolenia\">Typ szkolenia</label></td><td><input class=\"form-control\" id=\"typSzkolenia\" name=\"typSzkolenia\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.typSzkolenia\" type=\"text\"></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"maxUczestnikow\">Max uczestników</label></td><td><input class=\"form-control\" id=\"maxUczestnikow\" name=\"maxUczestnikow\" style=\"width:100px;margin-bottom: 10px\" ng-model=\"vmSemE.seminarium.maxUczestnikow\" type=\"number\" min=\"0\"></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"vat\">Webinarium</label></td><td><input style=\"margin-bottom: -10px;\" id=\"vat\" ng-model=\"vmSemE.seminarium.webinarium\" type=\"checkbox\"></td></tr><tr><td colspan=\"2\" style=\"padding-top: 20px;\"><b>Daty:</b></td></tr><tr><td style=\"max-width: 200px;padding-left:20px;\"><label for=\"dataSzkolenia\">Rozpoczęcie szkolenia</label></td><td><input class=\"form-control\" id=\"dataSzkolenia\" name=\"dataSzkolenia\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.dataSzkolenia\" type=\"datetime-local\"></td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"dataKoncaSzkolenia\">Zakończenie szkolenia</label></td><td><input class=\"form-control\" id=\"dataKoncaSzkolenia\" name=\"dataKoncaSzkolenia\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.dataKoncaSzkolenia\" type=\"datetime-local\"></td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"zapisDo\">Zapisy do</label></td><td><input class=\"form-control\" id=\"zapisDo\" name=\"zapisDo\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.zapisDo\" type=\"datetime-local\"></td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"rezygnacjaDo\">Rezygnacja do</label></td><td><input class=\"form-control\" id=\"rezygnacjaDo\" name=\"rezygnacjaDo\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.rezygnacjaDo\" type=\"datetime-local\"></td></tr><tr><td colspan=\"2\" style=\"padding-top: 20px;\"><b>Ceny na osobę:</b></td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"cenaNaOs\">Bez stałej akt.</label></td><td><input class=\"form-control\" id=\"cenaNaOs\" name=\"cenaNaOs\" style=\"width:100px;margin-bottom: 10px;margin-right: 5px; display: inline-block\" ng-model=\"vmSemE.seminarium.cenaNaOs\" ng-change=\"vmSemE.obliczCeny()\" type=\"number\" min=\"0\"> Zł.</td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label>Ze stałą akt.</label></td><td><p ng-if=\"vmSemE.seminarium.cenaNaOs >= 0\">{{vmSemE.seminarium.cenaNaOs - vmSemE.seminarium.cenaNaOs * 0.15}} zł netto</p><div style=\"color: grey;\" ng-if=\"vmSemE.seminarium.cenaNaOs >= 0\">Po odliczeniu 15% rabatu dla klientów ze stałą aktualizacją (bez uwzględnienia promocji).</div></td></tr><tr><td colspan=\"2\" style=\"padding-top: 20px;\"><b>Promocja:</b></td></tr><tr><td style=\"max-width: 102px;padding-left:20px;\"><label for=\"wartoscPromocji\">Wartość prom.</label></td><td><input class=\"form-control\" id=\"wartoscPromocji\" name=\"wartoscPromocji\" style=\"width:100px;margin-bottom: 10px;margin-right: 5px; display: inline-block\" ng-model=\"vmSemE.seminarium.wartoscPromocji\" type=\"number\" min=\"0\"> %</td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"dataKoncaPromocji\">Ważna do</label></td><td><input class=\"form-control\" id=\"dataKoncaPromocji\" name=\"dataKoncaPromocji\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemE.seminarium.dataKoncaPromocji\" type=\"datetime-local\"> <span style=\"color: grey;\">Jeśli data promocji nie jest ustawiona promocja nie będzie pokazywana.</span></td></tr></table><div style=\"max-width:450px;margin-top: 20px;\" class=\"{{vmSemE.bootstrapKlasa}}\"><p><b>Pliki dla wszystkich:</b></p><div style=\"padding-left: 20px;\"><table class=\"minetable\" style=\"margin-bottom: 10px;\"><tr ng-repeat=\"plik in vmSemE.seminarium.pliki_wszyscy\"><td style=\"padding: 10px; min-width: 400px;\"><a target=\"_blank\" ng-click=\"vmSemE.pobierzPlik(plik)\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}}</a></td><td style=\"padding: 10px;\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vmSemE.usunPlik(plik)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></table><button class=\"btn btn-default\" ng-disabled=\"schowaj\" ng-click=\"vmSemE.ukryjPrzyciskDodaj.wszyscy=true\" ng-show=\"!vmSemE.ukryjPrzyciskDodaj.wszyscy\"><span class=\"ng-binding\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> dodaj</span></button><dodawanie-plikow ng-show=\"vmSemE.ukryjPrzyciskDodaj.wszyscy==true\" files=\"pliki\"></dodawanie-plikow></div></div><div style=\"max-width:450px;margin-top: 20px;\" class=\"{{vmSemE.bootstrapKlasa}}\"><p><b>Pliki dla zapisanych:</b></p><div style=\"padding-left: 20px;\"><table class=\"minetable\" style=\"margin-bottom: 10px;\"><tr ng-repeat=\"plik in vmSemE.seminarium.pliki_zapisani\"><td style=\"padding: 10px; min-width: 400px;\"><a target=\"_blank\" ng-click=\"vmSemE.pobierzPlik(plik)\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}}</a></td><td style=\"padding: 10px;\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vmSemE.usunPlik(plik)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></table><button class=\"btn btn-default\" ng-disabled=\"schowaj\" ng-click=\"vmSemE.ukryjPrzyciskDodaj.zapisani=true\" ng-show=\"!vmSemE.ukryjPrzyciskDodaj.zapisani\"><span class=\"ng-binding\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> dodaj</span></button><dodawanie-plikow ng-show=\"vmSemE.ukryjPrzyciskDodaj.zapisani==true\" files=\"pliki_zapisani\"></dodawanie-plikow></div></div><div style=\"margin: 40px 0 20px 0\" class=\"{{vmSemE.bootstrapKlasa}}\"><button ng-click=\"vmSemE.zapiszSeminarium(pliki, pliki_zapisani)\" class=\"btn btn-primary\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Zapisz</button></div></form></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 40px;\"><p>Wartość procentowa rabatu dla klientów ze stałą aktualizacją jest sumą umownego 15% rabatu i rabatu promocji.</p></div></div></div>");
$templateCache.put("app/home/seminaria/formularzZgloszenia.seminaria.html","<div class=\"content\" ng-init=\"vmSemFZ.init()\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0px\"><h2>Seminaria szkoleniowe</h2><h3 style=\"margin-bottom: 0px\">Formularz zgłoszenia</h3><table class=\"\" style=\"border:1px solid lightgrey;margin-top: 20px;\"><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Temat</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.seminaria.temat}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Data</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.seminaria.dataSzkolenia | date: \"dd.MM.yyyy\"}} <span ng-if=\"(vmSemFZ.seminaria.dataSzkolenia | date: \'dd.MM.yyyy\') != (vmSemFZ.seminaria.dataKoncaSzkolenia | date: \'dd.MM.yyyy\')\">- {{vmSemFZ.seminaria.dataKoncaSzkolenia | date: \"dd.MM.yyyy\"}}</span></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Godzina</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.seminaria.dataSzkolenia | date: \"HH:mm\"}} <span ng-if=\"((vmSemFZ.seminaria.dataSzkolenia | date: \'dd.MM.yyyy\') == (vmSemFZ.seminaria.dataKoncaSzkolenia | date: \'dd.MM.yyyy\')) && (vmSemFZ.seminaria.dataKoncaSzkolenia | date : \'HH:mm\') != \'00:00\'\">- {{vmSemFZ.seminaria.dataKoncaSzkolenia | date: \"HH:mm\'\"}}</span></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Adres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.seminaria.adresSzkolenia}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Cena na os.</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.cena}} zł netto</td></tr><tr style=\"padding-top: 15px;height: 65px;\"><td style=\"padding-top: 20px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Zniżka</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><b>Rabat 15 %</b> przysługuje jedynie klientom posiadającym umowę stałej aktualizacji oprogramowania</td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemFZ.seminaria.promocjaAktywna === true\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Promocja</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><b>Rabat {{vmSemFZ.seminaria.wartoscPromocji}}%</b> przysługuje w przypadku rejestracji do dnia <b>{{vmSemFZ.seminaria.dataKoncaPromocji | date: \"dd.MM.yyyy\"}}</b></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Zakres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><span ng-bind-html=\"vmSemFZ.trustAsHTML(vmSemFZ.seminaria.zakres)\"></span></td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemFZ.seminaria.pliki_wszyscy.length > 0\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Załączniki</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><span style=\"padding-top: 5px;\" ng-repeat=\"plik in vmSemFZ.seminaria.pliki_wszyscy\"><a target=\"_blank\" style=\"margin-top: 20px;\" ng-click=\"vmSemFZ.getFile(plik)\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}}</a></span></td></tr></table></div><form name=\"noweZgloszenie\" novalidate=\"\"><div class=\"box23\" style=\"margin-bottom: 0; margin-left: 10px;\"><table style=\"width: 400px;margin-top: 20px;\"><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 120px;\"><label for=\"zwolnienieZVAT\">Zwolnienie z VAT</label></td><td><input style=\"margin-bottom: -10px;\" id=\"zwolnienieZVAT\" name=\"zwolnienieZVAT\" ng-model=\"vmSemFZ.zwolnienieZVAT\" type=\"checkbox\"><div ng-show=\"vmSemFZ.zwolnienieZVAT == true\" style=\"color: grey;\">Oświadczam, że korzystamy ze zwolnienia z VAT na usługi kształcenia zawodowego lub przekwalifikowania zawodowego, finansowane w co najmniej 70% ze środków publicznych.</div></td></tr><tr><td colspan=\"2\"><h4>Zgłaszający</h4></td></tr><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 100px;padding-left: 20px;\"><label for=\"telefon\">Telefon</label></td><td><input class=\"form-control\" id=\"telefon\" name=\"telefon\" style=\"width:350px\" ng-model=\"vmSemFZ.pracownik.Telefon\" type=\"text\"> <span ng-show=\"noweZgloszenie.telefon.$touched && (vmSemFZ.pracownik.Telefon.length < 7 || vmSemFZ.pracownik.Telefon ===null)\" style=\"color: crimson;\">Telefon kontaktowy jest wymagany.</span></td></tr><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 100px;padding-left: 20px;\"><label for=\"email\">Email</label></td><td><input class=\"form-control\" id=\"email\" name=\"email\" style=\"width:350px\" ng-model=\"vmSemFZ.pracownik.email\" type=\"text\"> <span ng-show=\"noweZgloszenie.email.$touched && (vmSemFZ.pracownik.email.length < 5 || vmSemFZ.pracownik.email ===null)\" style=\"color: crimson;\">Email jest wymagany.</span></td></tr></table></div><div class=\"box23\" style=\"margin-bottom: 20px; margin-left: 10px;padding-top: 40px;\"><h4 style=\"margin-bottom: 10px;\">Uczestnicy</h4><table style=\"width: 450px; margin-bottom: 40px;margin-left: 20px;\" class=\"bootstrap-iso-paper\"><tr><td style=\"max-width: 100px;\"><label for=\"liczbaOsob\">Liczba osób</label></td><td><input class=\"form-control\" id=\"liczbaOsob\" name=\"liczbaOsob\" style=\"width:50px\" ng-model=\"vmSemFZ.liczbaOsob\" min=\"{{vmSemFZ.osoby.length}}\" type=\"number\"></td></tr><tr ng-repeat=\"osoba in vmSemFZ.osoby\"><td style=\"max-width: 100px;\"><label>Uczestnik:</label></td><td style=\"padding-bottom: 20px;\"><i class=\"fa fa-address-card\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Imię\" ng-model=\"osoba.imie\" type=\"text\"> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Nazwisko\" ng-model=\"osoba.nazwisko\" type=\"text\"><br><i class=\"fa fa-phone\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Telefon\" ng-model=\"osoba.numerKontaktowy\" type=\"text\"><br><i class=\"fa fa-envelope-o\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Email\" name=\"adresEmail\" ng-model=\"osoba.adresEmail\" type=\"email\" required=\"\"> <span ng-if=\"osoba.adresEmail.length < 1\" style=\"color: crimson;\">Email jest wymagany.</span></td><td style=\"vertical-align: middle\"><div class=\"bootstrap-iso-paper\"><button class=\"btn btn-default btn-sm\" ng-click=\"vmSemFZ.dodajUczestnika()\" ng-if=\"vmSemFZ.osoby.indexOf(osoba) == vmSemFZ.osoby.length-1\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-danger btn-sm\" ng-click=\"vmSemFZ.usunUczestnika(vmSemFZ.osoby.indexOf(osoba))\" ng-if=\"vmSemFZ.osoby.length > 1\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></div></td></tr></table><h4>Podsumowanie</h4><table class=\"\" style=\"border:1px solid lightgrey;margin-top: 20px;margin-left: 20px;\"><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Liczba osób</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.liczbaOsob}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Cena za osobę</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.cena}} zł netto</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Łącznie</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.cena * vmSemFZ.liczbaOsob}} zł netto</td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemFZ.seminaria.promocjaAktywna === true || vmSemFZ.stalka === true\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Suma rabatów ({{vmSemFZ.rabat*100}}%)</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.Math.round(vmSemFZ.cena * vmSemFZ.liczbaOsob * vmSemFZ.rabat *100)/100}} zł netto</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Do zapłaty</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZ.Math.round(((vmSemFZ.cena * vmSemFZ.liczbaOsob) - (vmSemFZ.cena * vmSemFZ.liczbaOsob * vmSemFZ.rabat))*100)/100}} zł netto</td></tr></table><br><br><p>Podając w formularzu dane osobowe swoje lub innych uczestników, będących pracownikami/współpracownikami administratora tych danych, działam w imieniu<br>i z upoważnienia administratora tych danych oraz oświadczam, że są one zgodne z prawdą.</p><br><br><p>Wyrażam zgodę na przetwarzanie ww. danych osobowych w zakresie danych objętych powyższym formularzem rejestracyjnym przez MIESZCZANIN INFORMATYKA Sp. z o.o. z siedzibą<br>w Mysłowicach w celu realizacji działań związanych zapisami na szkolenie, realizacją szkolenia i certyfikacją uczestników po ukończeniu szkolenia.</p><div style=\"margin: 40px 0;\" class=\"{{vmSemFZ.bootstrapKlasa}}\"><button ng-click=\"vmSemFZ.wyslij()\" class=\"btn btn-primary\">Wyślij zgłoszenie</button></div></div></form></div></div>");
$templateCache.put("app/home/seminaria/nowe.panel.seminaria.html","<div class=\"content\" ng-init=\"vmSemN.init()\"><div class=\"pane23\"><h2>Seminaria</h2><h3>Nowe seminarium</h3><p class=\"box23\" style=\"margin-bottom: 0; margin-left: 10px;\"><obsluga-bledow wiadomosci-tablica=\"vmSemN.odpowiedziSerwera\"></obsluga-bledow><form name=\"noweSeminarium\" class=\"bootstrap-iso-paper\" novalidate=\"\"><table style=\"width: 400px;margin-top: 20px;\"><tr><td style=\"max-width: 120px;\"><label for=\"temat\">Temat</label></td><td><input class=\"form-control\" id=\"temat\" name=\"temat\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.temat\" type=\"text\"> <span ng-show=\"noweSeminarium.temat.$touched && vmSemN.pola.temat.length < 4\" style=\"color: crimson;\">Temat jest wymagany.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"zakres\">Zakres</label></td><td><textarea class=\"form-control\" id=\"zakres\" name=\"zakres\" rows=\"4\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.zakres\" type=\"text\">\n                        </textarea> <span ng-show=\"noweSeminarium.zakres.$touched && vmSemN.pola.zakres.length < 4\" style=\"color: crimson;\">Zakres jest wymagany.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"adres\">Adres szkolenia</label></td><td><input class=\"form-control\" id=\"adres\" name=\"adres\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.adresSzkolenia\" type=\"text\"> <span ng-show=\"noweSeminarium.adres.$touched && vmSemN.pola.adresSzkolenia.length < 4\" style=\"color: crimson;\">Adres szkolenia jest wymagany.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"miejsce\">Miejsce</label></td><td><input class=\"form-control\" id=\"miejsce\" name=\"miejsce\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.miejsce\" placeholder=\"Firma Mieszczanin\" type=\"text\"> <span ng-show=\"noweSeminarium.miejsce.$touched && vmSemN.pola.miejsce.length < 4\" style=\"color: crimson;\">Miejsce jest wymagane.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"typSzkolenia\">Typ szkolenia</label></td><td><input class=\"form-control\" id=\"typSzkolenia\" name=\"typSzkolenia\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.typSzkolenia\" type=\"text\"> <span ng-show=\"noweSeminarium.typSzkolenia.$touched && vmSemN.pola.typSzkolenia.length < 2\" style=\"color: crimson;\">Typ szkolenia jest wymagany.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"maxUczestnikow\">Max uczestników</label></td><td><input class=\"form-control\" id=\"maxUczestnikow\" name=\"maxUczestnikow\" style=\"width:100px;margin-bottom: 10px\" ng-model=\"vmSemN.pola.maxUczestnikow\" type=\"number\" min=\"0\"></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"vat\">Webinarium</label></td><td><input style=\"margin-bottom: -10px;\" id=\"vat\" ng-model=\"vmSemN.pola.webinarium\" type=\"checkbox\"></td></tr><tr><td colspan=\"2\" style=\"padding-top: 20px;\"><b>Daty:</b></td></tr><tr><td style=\"max-width: 200px;padding-left:20px;\"><label for=\"dataSzkolenia\">Rozpoczęcie szkolenia</label></td><td><input class=\"form-control\" id=\"dataSzkolenia\" name=\"dataSzkolenia\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.dataSzkolenia\" type=\"datetime-local\"></td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"dataKoncaSzkolenia\">Zakończenie szkolenia</label></td><td><input class=\"form-control\" id=\"dataKoncaSzkolenia\" name=\"dataKoncaSzkolenia\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.dataKoncaSzkolenia\" type=\"datetime-local\"></td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"zapisDo\">Zapisy do</label></td><td><input class=\"form-control\" id=\"zapisDo\" name=\"zapisDo\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.zapisDo\" type=\"datetime-local\"></td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"rezygnacjaDo\">Rezygnacja do</label></td><td><input class=\"form-control\" id=\"rezygnacjaDo\" name=\"rezygnacjaDo\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.rezygnacjaDo\" type=\"datetime-local\"></td></tr><tr><td colspan=\"2\" style=\"padding-top: 20px;\"><b>Ceny na osobę:</b></td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"cenaNaOs\">Bez stałej akt.</label></td><td><input class=\"form-control\" id=\"cenaNaOs\" name=\"cenaNaOs\" style=\"width:80px;margin-bottom: 10px;margin-right: 5px;display: inline-block\" ng-model=\"vmSemN.pola.cenaNaOs\" ng-change=\"vmSemN.obliczCeny()\" type=\"number\" min=\"0\"> zł netto</td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label>Ze stałą akt.</label></td><td><p ng-if=\"vmSemN.pola.cenaNaOs >= 0\">{{vmSemN.pola.cenaNaOs - vmSemN.pola.cenaNaOs*0.15}} zł netto</p><div style=\"color: grey;\" ng-if=\"vmSemN.pola.cenaNaOs >= 0\">Po odliczeniu 15% rabatu dla klientów ze stałą aktualizacją (bez uwzględnienia promocji).</div></td></tr><tr><td colspan=\"2\" style=\"padding-top: 20px;\"><b>Promocja:</b></td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"wartoscPromocji\">Wartość prom.</label></td><td><input class=\"form-control\" id=\"wartoscPromocji\" name=\"wartoscPromocji\" style=\"width:100px;margin-bottom: 10px;margin-right: 5px;display: inline-block\" ng-model=\"vmSemN.pola.wartoscPromocji\" type=\"number\" min=\"0\"> %</td></tr><tr><td style=\"max-width: 100px;padding-left:20px;\"><label for=\"dataKoncaPromocji\">Ważna do</label></td><td><input class=\"form-control\" id=\"dataKoncaPromocji\" name=\"dataKoncaPromocji\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmSemN.pola.dataKoncaPromocji\" type=\"datetime-local\"> <span style=\"color: grey;\">Jeśli data promocji nie jest ustawiona promocja nie będzie pokazywana.</span></td></tr></table><div style=\"max-width:450px;margin-top: 20px;\" class=\"{{vmSemN.bootstrapKlasa}}\"><p><b>Pliki dla wszystkich:</b></p><div style=\"padding-left: 20px;\"><button class=\"btn btn-default\" ng-disabled=\"schowaj\" ng-click=\"dodajDokumenty=true\" ng-show=\"!dodajDokumenty\"><span class=\"ng-binding\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> dodaj</span></button><dodawanie-plikow ng-show=\"dodajDokumenty==true\" files=\"pliki\"></dodawanie-plikow></div></div><div style=\"max-width:450px;margin-top: 20px;\" class=\"{{vmSemN.bootstrapKlasa}}\"><p><b>Pliki dla zapisanych:</b></p><div style=\"padding-left: 20px;\"><button class=\"btn btn-default\" ng-disabled=\"schowaj\" ng-click=\"dodajDokumenty_zapisani=true\" ng-show=\"!dodajDokumenty_zapisani\"><span class=\"ng-binding\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> dodaj</span></button><dodawanie-plikow ng-show=\"dodajDokumenty_zapisani==true\" files=\"pliki_zapisani\"></dodawanie-plikow></div></div><div style=\"margin: 40px 0 20px 0\" class=\"{{vmSemN.bootstrapKlasa}}\"><button ng-click=\"vmSemN.dodajSeminarium(pliki, pliki_zapisani);dodajDokumenty_zapisani=false;dodajDokumenty=false;\" class=\"btn btn-primary\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Utwórz</button></div></form></p></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 40px;\"><p>Wartość procentowa rabatu dla klientów ze stałą aktualizacją jest sumą umownego 15% rabatu i rabatu promocji.</p></div></div>");
$templateCache.put("app/home/seminaria/panel.seminaria.html","<div ui-view=\"\" style=\"min-height: 250px;\"><h2 style=\"width: 100%;\">Seminaria</h2><div style=\"margin-bottom: 20px;\" class=\"{{vmSemP.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"home.subMain.seminariaPZ.nowe\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Utwórz nowe</button></div><strefa-grid api=\"{{vmSemP.api}}\" request-params=\"{{vmSemP.seminaria.dane}}\" columns=\"vmSemP.columns\" selected-item=\"vmSemP.wybranyWiersz\" row-expand=\"true\" row-expand-template=\"{{vmSemP.rowTemplate}}\" select-first=\"true\" ctrl=\"vmSemP\" error-delete-text=\"Nie udało się usunąć pozycji\" allow-delete=\"true\" global-search=\"true\" refresh=\"{{vmSemP.odswiezTabele}}\"></strefa-grid></div><script type=\"text/x-kendo-template\" id=\"rowTemplate\"><div> <uib-tabset> <div class=\"container-fluid default-color\"> <dl class=\"dl-horizontal\" style=\"margin-bottom: 0\"> <dt style=\"padding: 0\">Adres szkolenia:</dt> <dd style=\"padding: 0\">{{row.adresSzkolenia}}</dd> <dt style=\"padding: 0\">Data szkolenia:</dt> <dd style=\"padding: 0\">{{row.dataSzkolenia | date: \"dd.MM.yyyy HH:mm\"}}</dd> <dt style=\"padding: 0\">Edycja/rezygnacja do:</dt> <dd style=\"padding: 0\">{{row.rezygnacjaDo | date: \"dd.MM.yyyy HH:mm\"}}</dd> <dt style=\"padding: 0\">Cena na os:</dt> <dd style=\"padding: 0\">{{row.cenaNaOs}} zł netto</dd> <dt style=\"padding: 0\" ng-if=\"row.wartoscPromocji > 0\">Promocja:</dt> <dd style=\"padding: 0\" ng-if=\"row.wartoscPromocji > 0\"> {{row.wartoscPromocji}}% <b>do</b> {{row.dataKoncaPromocji | date: \"dd.MM.yyyy HH:mm\"}} <span style=\"\" class=\"bootstrap-iso-paper\" ng-if=\"row.promocjaAktywna === true\"> <span class=\"label label-primary\">Trwa</span> </span> <span style=\"\" class=\"bootstrap-iso-paper\" ng-if=\"row.promocjaAktywna === false\"> <span class=\"label label-default\">Zakończona</span> </span> </dd> <dt style=\"padding: 0\">Typ szkolenia:</dt> <dd style=\"padding: 0\">{{row.typSzkolenia}}</dd> <dt style=\"padding: 0\">Max uczestników:</dt> <dd style=\"padding: 0\">{{row.maxUczestnikow}}</dd> <dt style=\"padding: 0\">Zakres szkolenia:</dt> <dd style=\"padding: 0\" ng-bind-html=\"vm.wyswietlHTML(row.zakres)\"></dd> <dt style=\"padding: 0\">Emaile uczestników:</dt> <dd style=\"padding: 0\"> <div class=\"input-group\" style=\"margin-top: -6px\"> <input style=\"font-size: 14px;\" type=\"text\" class=\"form-control\" value=\"{{row.adresy_email.join(\'; \')}}\" disabled/> <span class=\"input-group-btn\"> <button class=\"btn btn-default btn-sm\" ngclipboard data-clipboard-text=\"{{row.adresy_email.join(\'; \')}}\"> <span>Kopiuj</span> </button> </span> </div> </dd> </dl> </div> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"Modyfikacja\"><div class=\"text-center\" ng-click=\"row.expanded = true;\"> <button type=\"button\" class=\"btn btn-default btn-sm\" ui-sref=\"home.subMain.seminariaPZ.edycja({id:row.id})\"> <i class=\"fa fa-pencil\" aria-hidden=\"true\" style=\"display: inline-block; margin: 0; padding: 0\"></i> </button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vm.confirmDelete(row, $event)\"> <i class=\"fa fa-trash\" aria-hidden=\"true\"></i> </button> </div></script>");
$templateCache.put("app/home/seminaria/reklamacja.seminaria.html","<div ng-init=\"vmSemR.init()\"><div style=\"margin-top: 40px;margin-left: 20px;\"><div><div style=\"display: inline-block;float: left\"><i style=\"\" class=\"{{\'fa fa-file-text-o fa-3x\'}}\"></i></div><div style=\"padding-left: 10px;padding-top:10px;display: inline-block;\"><p>Reklamacja dotycząca seminarium</p></div></div><h5 style=\"padding-top: 20px;\">Seminarium:</h5><div style=\"\"><obsluga-bledow wiadomosci-tablica=\"vmSemR.odpowiedziSerwera\"></obsluga-bledow></div><table class=\"\" style=\"border:1px solid lightgrey;margin-top: 20px;\"><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Temat</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemR.zapis.daneSzkolenia.temat}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Data</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemR.zapis.daneSzkolenia.dataSzkolenia | date: \"dd.MM.yyyy\"}} <span ng-if=\"(vmSemR.zapis.daneSzkolenia.dataSzkolenia | date: \'dd.MM.yyyy\') != (vmSemR.seminaria.dataKoncaSzkolenia | date: \'dd.MM.yyyy\')\">- {{vmSemR.zapis.daneSzkolenia.dataKoncaSzkolenia | date: \"dd.MM.yyyy\"}}</span></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Godzina</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemR.zapis.daneSzkolenia.dataSzkolenia | date: \"HH:mm\"}} <span ng-if=\"((vmSemR.zapis.daneSzkolenia.dataSzkolenia | date: \'dd.MM.yyyy\') == (vmSemR.zapis.daneSzkolenia.dataKoncaSzkolenia | date: \'dd.MM.yyyy\')) && (vmSemR.zapis.daneSzkolenia.dataKoncaSzkolenia | date : \'HH:mm\') != \'00:00\'\">- {{vmSemR.zapis.daneSzkolenia.dataKoncaSzkolenia | date: \"HH:mm\'\"}}</span></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Adres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemR.zapis.daneSzkolenia.adresSzkolenia}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Zakres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><span ng-bind-html=\"vmSemR.trustAsHTML(vmSemR.zapis.daneSzkolenia.zakres)\"></span></td></tr></table><h5>Reklamacja:</h5><form name=\"reklamacjaForm\" novalidate=\"\"><table style=\"width: 400px;margin-top: 20px;\"><tr><td style=\"max-width: 100px;\"><label for=\"opis\">Opis</label></td><td><textarea name=\"opis\" ng-model=\"vmSemR.pola.opis\" style=\"width:350px;height: 100px;margin-bottom:10px;resize: none\" id=\"opis\" type=\"text\" required=\"\"></textarea><p ng-show=\"reklamacjaForm.opis.$touched && reklamacjaForm.opis.$invalid\">Opis jest wymagany.</p></td></tr><tr><td style=\"max-width: 100px;\">Osoba do<p>kontaktu <span class=\"{{vmSemR.bootstrapKlasa}}\"><a style=\"text-decoration: none;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Wypełnij tylko jeśli mamy kontaktować się z kimś innym niż zgłaszający\" class=\"glyphicon glyphicon-question-sign\"></a></span></p></td><td ng-if=\"vmSemR.subuser === true\"><p style=\"height: 30px;\"><input style=\"width:20px;margin-top: 20px;cursor: pointer;\" id=\"kontakt\" name=\"kontakt\" ng-model=\"vmSemR.osobaDoKontaktu\" value=\"0\" type=\"radio\"> <label for=\"kontakt\" style=\"height: 30px;cursor: pointer;\">Zgłaszający</label></p><p style=\"height: 30px;\"><input style=\"width:20px;margin-top: 20px;margin-left: -30px;cursor: pointer;\" ng-model=\"vmSemR.osobaDoKontaktu\" value=\"1\" id=\"kontakt2\" name=\"kontakt\" type=\"radio\"> <label for=\"kontakt2\" style=\"height: 30px;cursor: pointer;\">Inna osoba</label></p></td></tr></table><div ng-if=\"vmSemR.osobaDoKontaktu==1\"><div style=\"margin-left: 105px;\"><label style=\"width: 100px;\" for=\"imie\">Imię i Nazwisko</label> <input style=\"width: 220px;margin-bottom: 0;\" ng-model=\"vmSemR.pola.osDoKontaktuNazwa\" id=\"imie\" type=\"text\" name=\"othername\" ng-required=\"vmSemR.osobaDoKontaktu==1 && reklamacjaForm.othername.$touched || reklamacjaForm.othermail.$touched\"></div><div style=\"margin-left: 105px;\"><label style=\"width: 100px;\" for=\"telefon\">Telefon</label> <input style=\"width: 220px;margin-bottom: 0;\" ng-model=\"vmSemR.pola.osDoKontaktuTelefon\" id=\"telefon\" type=\"text\"></div><div style=\"margin-left: 105px;\"><label style=\"width: 100px;\" for=\"email\">e-mail</label> <input style=\"width: 220px;margin-bottom: 0;\" ng-model=\"vmSemR.pola.osDoKontaktuEmail\" id=\"email\" name=\"othermail\" type=\"text\" ng-required=\"vmSemR.osobaDoKontaktu==1 && reklamacjaForm.othername.$touched || reklamacjaForm.othermail.$touched\"></div></div><div style=\"margin: 50px 0;\" class=\"{{vmSemR.bootstrapKlasa}}\"><button ng-click=\"vmSemR.send()\" class=\"btn btn-default\" ng-disabled=\"vmSemR.statusWysylania!==\'nie_wyslano\'\">Wyślij</button> <a ui-sref=\"home.subMain.seminariaArchiwumZapisow\" style=\"margin-left: 10px;\">Anuluj</a></div></form></div></div>");
$templateCache.put("app/home/seminaria/seminaria.html","<div class=\"content\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0px\"><h2>Seminaria szkoleniowe</h2><p ng-bind-html=\"vmSem.dynamicznyTekst.tekst\"></p><div ng-if=\"vmSem.pliki.length > 0\"><p style=\"margin-bottom: 5px;margin-top: 10px;\"><b>Załączniki:</b></p><ol class=\"file-list\"><li ng-repeat=\"plik in vmSem.pliki\" style=\"margin-bottom: 0\"><a ng-click=\"vmSem.getFileDT(plik)\"><i class=\"fa fa-file-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}}</a></li></ol></div></div><obsluga-bledow wiadomosci-tablica=\"vmSem.odpowiedziSerwera\"></obsluga-bledow><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmSem.seminaria.length > 0\"><h3>Aktualnie zaplanowane szkolenia</h3><strefa-grid api=\"{{vmSem.apiSzkolenia}}\" request-params=\"{{vmSem.seminaria.dane}}\" columns=\"vmSem.columnsSzkolenia\" selected-item=\"vmSem.wybranyWierszSzkolenia\" row-expand=\"true\" row-expand-template=\"{{vmSem.rowTemplateSzkolenia}}\" select-first=\"false\" ctrl=\"vmSem\"></strefa-grid></div><div class=\"box23\" style=\"margin-bottom: 0px\" ng-if=\"vmSem.zapisy.length > 0\"><h3>Twoje zgłoszenia</h3><strefa-grid api=\"{{vmSem.apiZapisy}}\" request-params=\"{{vmSem.zapisy.dane}}\" columns=\"vmSem.columnsZapisy\" selected-item=\"vmSem.wybranyWierszZapisy\" row-expand=\"true\" row-expand-template=\"{{vmSem.rowTemplateZapisy}}\" select-first=\"false\" ctrl=\"vmSem\"></strefa-grid></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 5px;\"><h3 style=\"padding-bottom: 10px\">Statusy</h3><p><b>wpłynęło</b> - zgłoszenie oczekuje na potwierdzenie możliwości uczestnictwa<br><b>zaakceptowane</b> - uczestnictwo w szkoleniu zostało potwierdzone<br><b>niezakwalifikowane</b> - z uwaga na przekroczenie liczby miejsc państwa zgłoszenie trafiło na listę rezerwową<br><b>odwołane</b> - szkolenie zostało odwołane przez organizatora</p></div></div></div><script type=\"text/x-kendo-template\" id=\"rowTemplateSzkolenia\"><div> <uib-tabset> <div class=\"container-fluid default-color\"> <dl class=\"dl-horizontal\" style=\"margin-bottom: 0\"> <dt style=\"padding: 0\">Data szkolenia:</dt> <dd style=\"padding: 0\"><span>{{row.dataSzkolenia | date: \"dd.MM.yyyy\"}}</span> <span ng-if=\"(row.dataSzkolenia | date: \'dd.MM.yyyy\') != (row.dataKoncaSzkolenia | date: \'dd.MM.yyyy\')\"> - {{row.dataKoncaSzkolenia | date: \"dd.MM.yyyy\"}}</span> </dd> <dt style=\"padding: 0\">Godzina szkolenia:</dt> <dd style=\"padding: 0\">{{row.dataSzkolenia | date : \"HH:mm\"}}</dd> <dt style=\"padding: 0\" ng-if=\"(row.dataKoncaSzkolenia | date : \'HH:mm\') != \'00:00\'\">Godzina zakończenia: </dt> <dd style=\"padding: 0\" ng-if=\"(row.dataKoncaSzkolenia | date : \'HH:mm\') != \'00:00\'\"> {{row.dataKoncaSzkolenia | date : \"HH:mm\"}} </dd> <dt style=\"padding: 0\">Miejsce szkolenia:</dt> <dd style=\"padding: 0\">{{row.miejsce}}</dd> <dt style=\"padding: 0\">Adres szkolenia:</dt> <dd style=\"padding: 0\">{{row.adresSzkolenia}}</dd> <dt style=\"padding: 0\">Cena na os:</dt> <dd style=\"padding: 0\">{{row.cenaNaOs | currency : \"\"}} zł netto</dd> <dt style=\"padding: 0\" ng-if=\"row.wartoscPromocji > 0\">Promocja:</dt> <dd style=\"padding: 0\" ng-if=\"row.wartoscPromocji > 0\"> {{row.wartoscPromocji}}% <b>do</b> {{row.dataKoncaPromocji | date: \"dd.MM.yyyy HH:mm \"}} <span style=\"\" class=\"bootstrap-iso-paper\" ng-if=\"row.promocjaAktywna === true\"> <span class=\"label label-primary\">Trwa</span> </span> <span style=\"\" class=\"bootstrap-iso-paper\" ng-if=\"row.promocjaAktywna === false\"> <span class=\"label label-default\">Zakończona</span> </span> </dd> <dt style=\"padding: 0\" ng-if=\"row.pliki_wszyscy.length > 0 || (row.pliki_zapisani.length > 0 && row.juz_zapisany===true)\">Załączniki:</dt> <dd style=\"padding: 0\" > <div ng-repeat=\"plik in row.pliki_wszyscy\" ng-if=\"row.pliki_wszyscy.length > 0\"> <a target=\"_blank\" ng-click=\"vm.getFile(\'/seminaria/pliki/\', plik)\" style=\"margin-top: 20px;\" ng-if=\"element.plik !== null\"> <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}} </a> </div> <div ng-repeat=\"plik in row.pliki_zapisani\" ng-if=\"row.pliki_zapisani.length > 0 && row.juz_zapisany===true\"> <a target=\"_blank\" ng-click=\"vm.getFile(\'/seminaria/pliki/\', plik)\" style=\"margin-top: 20px;\" ng-if=\"element.plik !== null\"> <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}} </a> </div> </dd> <dt style=\"padding: 0\">Zakres szkolenia:</dt> <dd style=\"padding: 0\" ng-bind-html=\"vm.wyswietlHTML(row.zakres)\"></dd> </dl> </div> <div class=\"bootstrap-iso-paper\" style=\"width: 100%;margin-top: 20px;\"> <button style=\"float: right;display: inline-block; margin-right: 15px;margin-bottom: 10px;\" ui-sref=\"home.subMain.seminariaFZ({id:row.id})\" class=\"btn btn-primary btn-sm ng-isolate-scope\" title=\"Formularz zgłoszenia\" ng-if=\"row.juz_zapisany===false && vm.czyJestPrzedData(row.zapisDo) == true\"> <i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> <span>Formularz zgłoszenia</span> </button> <span style=\"float: right;display: inline-block; margin-right: 15px;margin-bottom: 10px;\" class=\"bootstrap-iso-paper\" ng-if=\"row.juz_zapisany===true\"> <span class=\"label label-primary\">Zgłoszenie zostało już wysłane</span> </span> <span style=\"float: right;display: inline-block; margin-right: 15px;margin-bottom: 10px;\" class=\"bootstrap-iso-paper\" ng-if=\"row.juz_zapisany===false && vm.czyJestPrzedData(row.zapisDo) == false\"> <span class=\"label label-default\">Zapisy zostały zakończone</span> </span> </div> <div class=\"bootstrap-iso-paper\" style=\"width: 100%;margin-top: 20px;\" ng-if=\"row.juz_zapisany===true || vm.czyJestPrzedData(row.zapisDo) == true\"> <button style=\"float: right;display: inline-block; margin-right: 15px;margin-bottom: 10px;\" ng-click=\"vm.generujRaportZgloszenieNaSzkolenie(row);\" class=\"btn btn-default btn-sm ng-isolate-scope\" title=\"Generuj raport\"> <span ng-if=\"row.generowanie_raportu != true\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> <span>Raport</span></span> <span ng-if=\"row.generowanie_raportu == true\"><i class=\"fa fa-spinner fa-spin fa-fw\" aria-hidden=\"true\"></i> <span>Generowanie raportu</span></span> </button> </div> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"rowTemplateZapisy\"><div> <uib-tabset> <div class=\"container-fluid default-color\"> <dl class=\"dl-horizontal\" style=\"margin-bottom: 0\"> <dt style=\"padding: 0\">Data szkolenia:</dt> <dd style=\"padding: 0\">{{row.daneSzkolenia.dataSzkolenia | date : \"dd.MM.yyyy\"}} <span ng-if=\"row.daneSzkolenia.dataKoncaSzkolenia !== null\"> - {{row.daneSzkolenia.dataKoncaSzkolenia | date: \"dd.MM.yyyy\"}}</span> </dd> <dt style=\"padding: 0\">Godzina szkolenia:</dt> <dd style=\"padding: 0\">{{row.daneSzkolenia.dataSzkolenia | date : \"HH:mm\"}}</dd> <dt style=\"padding: 0\">Rezygnacja do:</dt> <dd style=\"padding: 0\">{{row.daneSzkolenia.rezygnacjaDo | date : \"dd.MM.yyyy HH:mm\"}}</dd> <dt style=\"padding: 0\">Adres szkolenia:</dt> <dd style=\"padding: 0\">{{row.daneSzkolenia.adresSzkolenia}}</dd> <dt style=\"padding: 0\">Cena:</dt> <dd style=\"padding: 0\">{{row.daneSzkolenia.cenaNaOs * row.liczbaOsob | currency : \"\"}} zł netto</dd> <dt style=\"padding: 0\">Po rabacie:</dt> <dd style=\"padding: 0\">{{row.cenaCalosc | currency : \"\"}} zł netto</dd> <dt style=\"padding: 0\">Zgłaszający:</dt> <dd style=\"padding: 0\">{{row.nazwaZglaszajacego}}</dd> <dt style=\"padding: 0\">Liczba osób:</dt> <dd style=\"padding: 0\">{{row.liczba_uczestnikow}}</dd> <dt style=\"padding: 0\">Uczestnicy:</dt> <dd style=\"padding: 0\"> <ul> <li ng-repeat=\"uczestnik in row.uczestnicy\" style=\"margin: 0\" ng-if=\"uczestnik.imie.length > 1\"> {{uczestnik.imie + \' \' + uczestnik.nazwisko}} </li> </ul> </dd> <dt style=\"padding: 0\" ng-if=\"row.daneSzkolenia.pliki_wszyscy.length > 0 || row.daneSzkolenia.pliki_zapisani.length > 0\">Załączniki: </dt> <dd style=\"padding: 0\" > <div ng-repeat=\"plik in row.daneSzkolenia.pliki_wszyscy\" ng-if=\"row.daneSzkolenia.pliki_wszyscy.length > 0 \"> <a target=\"_blank\" ng-click=\"vm.getFile(\'/seminaria/pliki/\', plik)\" style=\"margin-top: 20px;\" ng-if=\"element.plik !== null\"> <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}} </a> </div> <div ng-repeat=\"plik in row.daneSzkolenia.pliki_zapisani\" ng-if=\"row.daneSzkolenia.pliki_zapisani.length > 0 \"> <a target=\"_blank\" ng-click=\"vm.getFile(\'/seminaria/pliki/\', plik)\" style=\"margin-top: 20px;\" ng-if=\"element.plik !== null\"> <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}} </a> </div> </dd> <dt style=\"padding: 0\">Zakres szkolenia:</dt> <dd style=\"padding: 0\" ng-bind-html=\"vm.wyswietlHTML(row.daneSzkolenia.zakres)\"></dd> </dl> </div> <div class=\"bootstrap-iso-paper\" style=\"width: 100%;margin-top: 20px;\"> <div class=\"bootstrap-iso-paper\" style=\"width: 100%\" ng-if=\"row.daneSzkolenia.mozliwaRezygnacja === true\"> <button style=\"float: right;display: inline-block; margin-right: 15px;\" ui-sref=\"home.subMain.zapisyEdycja({id:row.id})\" class=\"btn btn-default btn-sm ng-isolate-scope\" title=\"Edytuj\"> <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> <span>edytuj</span> </button> </div> </div> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"rozwin\"><div class=\"text-center\"> <button id=\"szoklenie{{row.id}}\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"row.expanded = false;\"> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" style=\"display: inline-block; margin: 0; padding: 0\"></i> szczegóły </button> </div></script>");
$templateCache.put("app/home/seminaria/zapisy.panel.seminaria.html","<div class=\"content\" ui-view=\"\"><h2 style=\"\">Zapisy na seminaria</h2><div ng-repeat=\"szkolenie in vmSemZ.seminaria\"><div style=\"margin-bottom: 40px;\"><h3 style=\"margin:0\"><a>#{{szkolenie.id}}</a> <span>{{szkolenie.temat}}</span></h3><span style=\"float: right\">Data: {{szkolenie.dataSzkolenia | date: \"dd.MM.yyyy\"}}</span> <span class=\"{{vmSemZ.bootstrapKlasa}}\">Uczestnicy: <span class=\"label label-primary\">{{(szkolenie.liczby_zapisanych.wplynelo !== null) ? szkolenie.liczby_zapisanych.wplynelo : 0}}</span> <span class=\"label label-success\">{{(szkolenie.liczby_zapisanych.zaakceptowane !== null) ? szkolenie.liczby_zapisanych.zaakceptowane : 0}}</span> <span class=\"label label-default\">{{(szkolenie.liczby_zapisanych.niezakwalifikowane !== null) ? szkolenie.liczby_zapisanych.niezakwalifikowane : 0}}</span></span></div><div></div><div style=\"margin-bottom: 20px;\" class=\"{{vmSemZ.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"home.subMain.seminariaPZ.zapisyNowy({id:szkolenie.id})\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Zapisz klienta</button></div><strefa-grid api=\"{{vmSemZ.apiZapisy}}\" request-params=\"{{vmSemZ.getid(szkolenie.id)}}\" columns=\"vmSemZ.columns\" selected-item=\"szkolenie.zakres\" row-expand=\"true\" row-expand-template=\"{{vmSemZ.rowTemplate}}\" refresh=\"vmSemZ.refresh\" show-filter=\"true\" global-search=\"true\" ctrl=\"vmSemZ\"></strefa-grid><div style=\"margin-bottom: 20px;\" class=\"{{vmSemZ.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vmSemZ.pobierzListeZaakceptowanych(szkolenie.id)\"><i class=\"fa fa-table\" aria-hidden=\"true\"></i> Pobierz wykaz uczestników</button> <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vmSemZ.pobierzListeWszystkichZapisanych(szkolenie.id)\"><i class=\"fa fa-table\" aria-hidden=\"true\"></i> Wykaz zapisanych</button></div></div></div><script type=\"text/x-kendo-template\" id=\"rowTemplate\"><div> <uib-tabset> <div class=\"container-fluid default-color\"> <h5>dane podstawowe</h5> <dl class=\"dl-horizontal\" style=\"margin-bottom: 0\"> <dt style=\"padding: 0\">Kod klienta:</dt> <dd style=\"padding: 0\">{{row.kodKlienta}}</dd> <dt style=\"padding: 0\">Zgłaszający:</dt> <dd style=\"padding: 0\">{{row.nazwaZglaszajacego}}</dd> <dt style=\"padding: 0\">Telefon:</dt> <dd style=\"padding: 0\">{{row.numerKontaktowy}}</dd> <dt style=\"padding: 0\">Email:</dt> <dd style=\"padding: 0\">{{row.adresEmail}}</dd> <dt style=\"padding: 0\">Cena:</dt> <dd style=\"padding: 0\">{{row.cenaCalosc}} zł netto</dd> <dt style=\"padding: 0\">Zwolnienie z VAT</dt> <dd style=\"padding: 0\">{{(row.zwolnienieZVAT == true) ? \'Tak\' : \'Nie\' }}</dd> </dl> <h5>uczestnicy</h5> <dl class=\"dl-horizontal\" style=\"margin-bottom: 0;width: 400px;\"> <dt ng-repeat-start=\"uczestnik in row.uczestnicy\" style=\"padding: 0;min-width: 200px;\" ng-if=\"uczestnik.imie.length > 1\" uib-tooltip=\"{{uczestnik.imie + \' \' + uczestnik.nazwisko}}\" tooltip-placement=\"right\"> {{uczestnik.imie + \' \' + uczestnik.nazwisko}}: </dt> <dd ng-repeat-end=\"\" style=\"padding: 0 0 0 30px;\" ng-if=\"uczestnik.imie.length > 1\"> <i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i> {{uczestnik.adresEmail}}<br> <i class=\"fa fa-phone\" aria-hidden=\"true\"></i> {{uczestnik.numerKontaktowy}} </dd> </dl> <button type=\"button\" class=\"btn btn-sm btn-default\" style=\"display: inline-block\" ng-click=\"vm.runExtFunction(\'przeniesZapis\',row)\"> <i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> Przenieś na inne szkolenie </button> </div> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"Modyfikacja\"><div class=\"text-center\" ng-click=\"row.expanded = true;\"> <button type=\"button\" class=\"btn btn-default btn-sm\" ui-sref=\"home.subMain.seminariaPZ.zapisyEdycja({id:row.id})\"> <i class=\"fa fa-pencil\" aria-hidden=\"true\" style=\"display: inline-block; margin: 0; padding: 0\"></i> </button> <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vm.runExtFunction(\'zmienStatus\',row)\"> <i class=\"fa fa-hourglass\" aria-hidden=\"true\"></i> </button> </div></script>");
$templateCache.put("app/home/seminaria/zapisyEdycja.panel.seminaria.html","<div class=\"content\" ng-init=\"vmSemZE.init()\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0px\"><h2>Zapisy na seminaria</h2><h3>Formularz edycji zgłoszenia</h3><obsluga-bledow wiadomosci-tablica=\"vmSemZE.odpowiedziSerwera\"></obsluga-bledow><table class=\"\" style=\"border:1px solid lightgrey;margin-top: 20px;\"><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Temat</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><a target=\"_blank\" ui-sref=\"home.subMain.seminariaPZ.edycja({id:vmSemZE.seminarium.id})\">{{vmSemZE.seminarium.temat}}</a></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Data</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZE.seminarium.dataSzkolenia | date: \"dd.MM.yyyy HH:mm\"}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Adres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZE.seminarium.adresSzkolenia}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Cena na os.</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZE.cena | currency : \"\"}} zł</td></tr><tr style=\"padding-top: 15px;height: 65px;\"><td style=\"padding-top: 20px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Zniżka</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><b>Rabat 15 %</b> przysługuje jedynie klientom posiadającym umowę stałej aktualizacji oprogramowania</td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemZE.seminarium.promocjaAktywna === true\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Promocja</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><b>Rabat {{vmSemZE.seminarium.wartoscPromocji}}%</b> przysługuje w przypadku rejestracji do dnia <b>{{vmSemZE.seminarium.dataKoncaPromocji | date: \"dd.MM.yyyy\"}}</b></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Zakres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><span ng-bind-html=\"vmSemZE.trustAsHTML(vmSemZE.seminarium.zakres)\"></span></td></tr></table></div><div class=\"box23\" style=\"margin-bottom: 0; margin-left: 10px;\"><form name=\"edycjaZapisu\" novalidate=\"\"><table style=\"width: 400px;margin-top: 20px;\"><tr class=\"{{vmSemZE.bootstrapKlasa}}\"><td style=\"max-width: 120px;\"><label for=\"status\">Status</label></td><td><select id=\"status\" ng-model=\"vmSemZE.zapis.status\" ng-options=\"s for s in [\'wpłynęło\', \'zaakceptowane\', \'niezakwalifikowane\', \'zrezygnowano\', \'odwołane\']\"></select></td></tr><tr class=\"{{vmSemZE.bootstrapKlasa}}\"><td style=\"max-width: 100px;\"><label for=\"vat\">Zwolnienie z VAT</label></td><td><input style=\"margin-bottom: -10px;\" id=\"vat\" ng-model=\"vmSemZE.zapis.zwolnienieZVAT\" type=\"checkbox\"></td></tr><tr><td colspan=\"2\"><h4>Zgłaszający</h4></td></tr><tr class=\"{{vmSemZE.bootstrapKlasa}}\"><td style=\"max-width: 100px;padding-left: 20px;\"><label for=\"telefon\">Telefon</label></td><td><input class=\"form-control\" id=\"telefon\" name=\"telefon\" style=\"width:350px\" ng-model=\"vmSemZE.zapis.numerKontaktowy\" type=\"text\"> <span ng-show=\"edycjaZapisu.telefon.$touched && (vmSemZE.zapis.numerKontaktowy < 7 || vmSemZE.zapis.numerKontaktowy === null)\" style=\"color: crimson;\">Telefon kontaktowy jest wymagany.</span></td></tr><tr class=\"{{vmSemZE.bootstrapKlasa}}\"><td style=\"max-width: 100px;padding-left: 20px;\"><label for=\"email\">Email</label></td><td><input class=\"form-control\" id=\"email\" name=\"email\" style=\"width:350px\" ng-model=\"vmSemZE.zapis.adresEmail\" type=\"text\"> <span ng-show=\"edycjaZapisu.email.$touched && (vmSemZE.zapis.adresEmail.length < 5 || vmSemZE.zapis.adresEmail ===null)\" style=\"color: crimson;\">Email jest wymagany.</span></td></tr></table></form></div><div class=\"box23\" style=\"margin-bottom: 20px; margin-left: 10px;\"><h4 style=\"margin-bottom: 10px; padding-top: 280px;\">Uczestnicy</h4><table style=\"width: 450px; margin-bottom: 40px;margin-left: 20px;\" class=\"{{vmSemZE.bootstrapKlasa}}\"><tr><td style=\"max-width: 100px;\"><label for=\"liczbaOsob\">Liczba osób</label></td><td><input class=\"form-control\" id=\"liczbaOsob\" name=\"liczbaOsob\" style=\"width:50px\" ng-model=\"vmSemZE.liczbaOsob\" min=\"{{vmSemZE.uczestnicy.length}}\" ng-change=\"vmSemZE.przeliczPodsumowanie()\" type=\"number\"></td></tr><tr ng-repeat=\"osoba in vmSemZE.uczestnicy\"><td style=\"max-width: 100px;\"><label>Uczestnik:</label></td><td style=\"padding-bottom: 20px;\"><i class=\"fa fa-address-card\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Imię\" ng-model=\"osoba.imie\" type=\"text\"> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Nazwisko\" ng-model=\"osoba.nazwisko\" type=\"text\"><br><i class=\"fa fa-phone\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Telefon\" ng-model=\"osoba.numerKontaktowy\" type=\"tel\"><br><i class=\"fa fa-envelope-o\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Email\" ng-model=\"osoba.adresEmail\" type=\"email\"></td><td style=\"vertical-align: middle\"><div class=\"{{vmSemZE.bootstrapKlasa}}\"><button class=\"btn btn-default btn-sm\" ng-click=\"vmSemZE.dodajUczestnika()\" ng-if=\"vmSemZE.uczestnicy.indexOf(osoba) == vmSemZE.uczestnicy.length-1\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-danger btn-sm\" ng-click=\"vmSemZE.usunUczestnika(vmSemZE.uczestnicy.indexOf(osoba))\" ng-if=\"vmSemZE.uczestnicy.indexOf(osoba) != vmSemZE.uczestnicy.length\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></div></td></tr></table><div class=\"{{vmSemZE.bootstrapKlasa}}\"><button class=\"btn btn-default\" ng-click=\"vmSemZE.dodajUczestnika()\" ng-if=\"vmSemZE.uczestnicy.length == 0\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Dodaj uczestnika</button></div><h4>Podsumowanie</h4><table class=\"\" style=\"border:1px solid lightgrey;margin-top: 20px;margin-left: 20px;\"><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Liczba osób</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZE.liczbaOsob}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Cena za osobę</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZE.cena | currency : \"\"}} zł</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Łącznie</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZE.cena * vmSemZE.liczbaOsob | currency : \"\"}} zł</td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemZE.seminarium.promocjaAktywna === true || vmSemZE.stalka === true\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Suma rabatów</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZE.sumaRabatow | currency : \"\"}} zł</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Do zapłaty</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZE.sumaKoncowa | currency : \"\"}} zł</td></tr></table><div style=\"margin: 50px 0;\" class=\"{{vmSemZE.bootstrapKlasa}}\"><button ng-click=\"vmSemZE.zapisz()\" class=\"btn btn-primary\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Zapisz</button></div></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 10px;\"><p>Liczba osób może być większa niż ilość wpisanych uczestników.</p></div><div class=\"boxT\" style=\"margin-top: 5px;\"><h3>Mailing</h3><p>Powiadomienie o zmianie statusu na: {{vmSemZE.status}}</p><div style=\"margin-top: 10px;\" class=\"{{vmSemZE.bootstrapKlasa}}\"><button ng-click=\"vmSemZE.wyslijEmail()\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-paper-plane-o\" aria-hidden=\"true\"></i> {{ vmSemZE.zapis.wyslano_powiadomienie == false ? \'Wyślij e-mail\' : \'Wyślij e-mail ponownie\' }}</button></div></div></div></div>");
$templateCache.put("app/home/seminaria/zapisyEdycja.seminaria.html","<div class=\"content\" ng-init=\"vmSemFZE.init()\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0px\"><h2>Zapisy na seminaria</h2><h3>Formularz edycji zgłoszenia</h3><obsluga-bledow wiadomosci-tablica=\"vmSemFZE.odpowiedziSerwera\"></obsluga-bledow><table class=\"\" style=\"border:1px solid lightgrey;margin-top: 20px;\"><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Temat</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><a target=\"_blank\" ui-sref=\"home.subMain.seminariaPZ.edycja({id:vmSemFZE.seminarium.id})\">{{vmSemFZE.seminarium.temat}}</a></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Data</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZE.seminarium.dataSzkolenia | date: \"dd.MM.yyyy\"}} <span ng-if=\"vmSemFZE.seminarium.dataKoncaSzkolenia !== null && !vmSemFZE.sprawdzCzyJednodniowe()\">- {{vmSemFZE.seminarium.dataKoncaSzkolenia | date: \"dd.MM.yyyy\"}}</span></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Godzina</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZE.seminarium.dataSzkolenia | date: \"HH:mm\"}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Adres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZE.seminarium.adresSzkolenia}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Cena na os.</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZE.cena | currency : \"\"}} zł</td></tr><tr style=\"padding-top: 15px;height: 65px;\"><td style=\"padding-top: 20px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Zniżka</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><b>Rabat 15 %</b> przysługuje jedynie klientom posiadającym umowę stałej aktualizacji oprogramowania</td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemFZE.seminarium.promocjaAktywna === true\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Promocja</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><b>Rabat {{vmSemFZE.seminarium.wartoscPromocji}}%</b> przysługuje w przypadku rejestracji do dnia <b>{{vmSemFZE.seminarium.dataKoncaPromocji | date: \"dd.MM.yyyy\"}}</b></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Zakres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><span ng-bind-html=\"vmSemFZE.trustAsHTML(vmSemFZE.seminarium.zakres)\"></span></td></tr></table></div><div class=\"box23\" style=\"margin-bottom: 0; margin-left: 10px;\"><form name=\"edycjaZapisu\" novalidate=\"\"><table style=\"width: 400px;margin-top: 20px;\"><tr class=\"{{vmSemFZE.bootstrapKlasa}}\"><td style=\"max-width: 120px;\"><label for=\"vat\">Zwolnienie z VAT</label></td><td><input style=\"margin-bottom: -10px;\" id=\"vat\" ng-model=\"vmSemFZE.zapis.zwolnienieZVAT\" type=\"checkbox\"><div ng-show=\"vmSemFZE.zapis.zwolnienieZVAT == true\" style=\"color: grey;\">Oświadczam, że korzystamy ze zwolnienia z VAT na usługi kształcenia zawodowego lub przekwalifikowania zawodowego, finansowane w co najmniej 70% ze środków publicznych.</div></td></tr><tr><td colspan=\"2\"><h4>Zgłaszający</h4></td></tr><tr class=\"{{vmSemFZE.bootstrapKlasa}}\"><td style=\"max-width: 100px;padding-left: 20px;\"><label for=\"telefon\">Telefon</label></td><td><input class=\"form-control\" id=\"telefon\" name=\"telefon\" style=\"width:350px\" ng-model=\"vmSemFZE.zapis.numerKontaktowy\" type=\"text\"> <span ng-show=\"edycjaZapisu.telefon.$touched && (vmSemFZE.zapis.numerKontaktowy < 7 || vmSemFZE.zapis.numerKontaktowy === null)\" style=\"color: crimson;\">Telefon kontaktowy jest wymagany.</span></td></tr><tr class=\"{{vmSemFZE.bootstrapKlasa}}\"><td style=\"max-width: 100px;padding-left: 20px;\"><label for=\"email\">Email</label></td><td><input class=\"form-control\" id=\"email\" name=\"email\" style=\"width:350px\" ng-model=\"vmSemFZE.zapis.adresEmail\" type=\"text\"> <span ng-show=\"edycjaZapisu.email.$touched && (vmSemFZE.zapis.adresEmail.length < 5 || vmSemFZE.zapis.adresEmail ===null)\" style=\"color: crimson;\">Email jest wymagany.</span></td></tr></table></form></div><div class=\"box23\" style=\"margin-bottom: 20px; margin-left: 10px;\"><h4 style=\"margin-bottom: 10px; padding-top: 280px;\">Uczestnicy</h4><table style=\"width: 450px; margin-bottom: 40px;margin-left: 20px;\" class=\"{{vmSemFZE.bootstrapKlasa}}\"><tr><td style=\"max-width: 100px;\"><label for=\"liczbaOsob\">Liczba osób</label></td><td><input class=\"form-control\" id=\"liczbaOsob\" name=\"liczbaOsob\" style=\"width:50px\" ng-model=\"vmSemFZE.liczbaOsob\" min=\"{{vmSemFZE.uczestnicy.length}}\" ng-change=\"vmSemFZE.pp()\" type=\"number\"></td></tr><tr ng-repeat=\"osoba in vmSemFZE.uczestnicy\"><td style=\"max-width: 100px;\"><label>Uczestnik:</label></td><td style=\"padding-bottom: 20px;\"><i class=\"fa fa-address-card\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Imię\" ng-model=\"osoba.imie\" type=\"text\"> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Nazwisko\" ng-model=\"osoba.nazwisko\" type=\"text\"><br><i class=\"fa fa-phone\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Telefon\" ng-model=\"osoba.numerKontaktowy\" type=\"tel\"><br><i class=\"fa fa-envelope-o\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Email\" ng-model=\"osoba.adresEmail\" type=\"email\"></td><td style=\"vertical-align: middle\"><div class=\"{{vmSemFZE.bootstrapKlasa}}\"><button class=\"btn btn-default btn-sm\" ng-click=\"vmSemFZE.dodajUczestnika()\" ng-if=\"vmSemFZE.uczestnicy.indexOf(osoba) == vmSemFZE.uczestnicy.length-1\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-danger btn-sm\" ng-click=\"vmSemFZE.usunUczestnika(vmSemFZE.uczestnicy.indexOf(osoba))\" ng-if=\"vmSemFZE.uczestnicy.length > 1\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></div></td></tr></table><div class=\"{{vmSemFZE.bootstrapKlasa}}\"><button class=\"btn btn-default\" ng-click=\"vmSemFZE.dodajUczestnika()\" ng-if=\"vmSemFZE.uczestnicy.length == 0\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Dodaj uczestnika</button></div><h4>Podsumowanie</h4><table class=\"\" style=\"border:1px solid lightgrey;margin-top: 20px;margin-left: 20px;\"><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Liczba osób</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZE.liczbaOsob}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Cena za osobę</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZE.cena | currency : \"\"}} zł</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Łącznie</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZE.cena * vmSemFZE.liczbaOsob | currency : \"\"}} zł</td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemFZE.seminarium.promocjaAktywna === true || vmSemFZE.stalka === true\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Suma rabatów</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZE.sumaRabatow | currency : \"\"}} zł</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Do zapłaty</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemFZE.sumaKoncowa | currency : \"\"}} zł</td></tr></table><div style=\"margin: 50px 0 20px 0;\" class=\"{{vmSemFZE.bootstrapKlasa}}\" ng-if=\"vmSemFZE.seminarium.mozliwaRezygnacja==true\"><button ng-click=\"vmSemFZE.zapisz()\" class=\"btn btn-primary\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Zapisz</button> <button class=\"btn btn-default\" ui-sref=\"home.subMain.seminaria\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Anuluj</button></div></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 5px;\"><p>Uczestników dodanych po okresie trwania promocji będzie obejmować cena bez zniżki promocyjnej.</p></div><div class=\"boxT\" style=\"margin-top: 5px;\"><p>Rezygnacja jest możliwa do dnia: {{vmSemFZE.seminarium.rezygnacjaDo | date: \"dd.MM.yyyy\"}}.<br>{{\"Aby zrezygnować kliknij \"}}<u><a ng-click=\"vmSemFZE.zrezygnuj()\">tutaj</a></u></p></div></div></div>");
$templateCache.put("app/home/seminaria/zapisyNowy.panel.seminaria.html","<div class=\"content\" ng-init=\"vmSemZN.init()\"><div class=\"pane23\"><div class=\"box23\" style=\"margin-bottom: 0\"><h2>Seminaria szkoleniowe</h2><h3 style=\"margin-bottom: 0\">Nowe zgłoszenie</h3><table class=\"\" style=\"border:1px solid lightgrey;margin-top: 20px;\"><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Temat</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZN.seminaria.temat}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Data</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZN.seminaria.dataSzkolenia | date: \"dd.MM.yyyy\"}} <span ng-if=\"vmSemZN.seminaria.dataKoncaSzkolenia !== null && !vmSemZN.sprawdzCzyJednodniowe()\">- {{vmSemZN.seminaria.dataKoncaSzkolenia | date: \"dd.MM.yyyy\"}}</span></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Adres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZN.seminaria.adresSzkolenia}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Cena na os.</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZN.cena}} zł</td></tr><tr style=\"padding-top: 15px;height: 65px;\"><td style=\"padding-top: 20px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Zniżka</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><b>Rabat 15 %</b> przysługuje jedynie klientom posiadającym umowę stałej aktualizacji oprogramowania</td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemZN.seminaria.promocjaAktywna === true\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Promocja</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><b>Rabat {{vmSemZN.seminaria.wartoscPromocji}}%</b> przysługuje w przypadku rejestracji do dnia <b>{{vmSemZN.seminaria.dataKoncaPromocji | date: \"dd.MM.yyyy\"}}</b></td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Zakres</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><span ng-bind-html=\"vmSemZN.trustAsHTML(vmSemZN.seminaria.zakres)\"></span></td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemZN.seminaria.pliki_wszyscy.length > 0\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:100px;\">Załączniki</td><td style=\"width:450px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\"><span style=\"padding-top: 5px;\" ng-repeat=\"plik in vmSemZN.seminaria.pliki_wszyscy\"><a target=\"_blank\" style=\"margin-top: 20px;\" ng-click=\"vmSemZN.getFile(plik.id)\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}}</a></span></td></tr></table></div><div class=\"box23\" style=\"margin-bottom: 0; margin-left: 10px;\"><form name=\"noweZgloszenie\" novalidate=\"\"><table style=\"width: 400px;margin-top: 20px;\"><tr><td colspan=\"2\"><h4>Klient</h4></td></tr><tr class=\"bootstrap-iso-paper\"><td colspan=\"2\" style=\"padding-bottom: 20px;\"><m-dropdown refresh=\"true\" items=\"vmSemZN.klienci\" selected=\"vmSemZN.klient\" get-data=\"vmSemZN.odswierzKlientow(params)\" on-select=\"vmSemZN.wybierzKlienta(items)\" width=\"450\"></m-dropdown></td></tr><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 120px;\"><label for=\"zwolnienieZVAT\">Zwolnienie z VAT</label></td><td><input style=\"margin-bottom: -10px;\" id=\"zwolnienieZVAT\" name=\"zwolnienieZVAT\" ng-model=\"vmSemZN.zwolnienieZVAT\" type=\"checkbox\"><div ng-show=\"vmSemZN.zwolnienieZVAT == true\" style=\"color: grey;\">Oświadczam, że korzystamy ze zwolnienia z VAT na usługi kształcenia zawodowego lub przekwalifikowania zawodowego, finansowane w co najmniej 70% ze środków publicznych.</div></td></tr><tr class=\"{{vmSemZN.bootstrapKlasa}}\"><td style=\"max-width: 120px;\"><label for=\"status\">Status</label></td><td><select id=\"status\" ng-model=\"vmSemZN.status\" ng-options=\"s for s in [\'wpłynęło\', \'zaakceptowane\', \'niezakwalifikowane\', \'zrezygnowano\']\"></select></td></tr><tr><td colspan=\"2\"><h4>Zgłaszający</h4></td></tr><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 100px;padding-left: 20px;\"><label for=\"nazwaZglaszajacego\">Imie i nazwisko</label></td><td><input class=\"form-control\" id=\"nazwaZglaszajacego\" name=\"nazwaZglaszajacego\" style=\"width:350px\" ng-model=\"vmSemZN.nazwaZglaszajacego\" type=\"text\"> <span ng-show=\"noweZgloszenie.nazwaZglaszajacego.$touched && (vmSemZN.nazwaZglaszajacego.length < 4 || vmSemZN.nazwaZglaszajacego === null)\" style=\"color: crimson;\">Telefon kontaktowy jest wymagany.</span></td></tr><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 100px;padding-left: 20px;\"><label for=\"telefon\">Telefon</label></td><td><input class=\"form-control\" id=\"telefon\" name=\"telefon\" style=\"width:350px\" ng-model=\"vmSemZN.pracownik.Telefon\" type=\"text\"> <span ng-show=\"noweZgloszenie.telefon.$touched && (vmSemZN.pracownik.Telefon.length < 7 || vmSemZN.pracownik.Telefon ===null)\" style=\"color: crimson;\">Telefon kontaktowy jest wymagany.</span></td></tr><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 100px;padding-left: 20px;\"><label for=\"email\">Email</label></td><td><input class=\"form-control\" id=\"email\" name=\"email\" style=\"width:350px\" ng-model=\"vmSemZN.pracownik.email\" type=\"text\"> <span ng-show=\"noweZgloszenie.email.$touched && (vmSemZN.pracownik.email.length < 5 || vmSemZN.pracownik.email ===null)\" style=\"color: crimson;\">Email jest wymagany.</span></td></tr></table></form></div><div class=\"box23\" style=\"margin-bottom: 20px; margin-left: 10px;padding-top: 40px;\"><h4 style=\"margin-bottom: 10px; padding-top: 220px;\">Uczestnicy</h4><table style=\"width: 450px; margin-bottom: 40px;margin-left: 20px;\" class=\"bootstrap-iso-paper\"><tr><td style=\"max-width: 100px;\"><label for=\"liczbaOsob\">Liczba osób</label></td><td><input class=\"form-control\" id=\"liczbaOsob\" name=\"liczbaOsob\" style=\"width:50px; float: left\" ng-model=\"vmSemZN.liczbaOsob\" min=\"{{vmSemZN.osoby.length}}\" type=\"number\"></td></tr><tr ng-repeat=\"osoba in vmSemZN.osoby\"><td style=\"max-width: 100px;\"><label>Uczestnik:</label></td><td style=\"padding-bottom: 20px;\"><i class=\"fa fa-address-card\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Imię\" ng-model=\"osoba.imie\" type=\"text\"> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Nazwisko\" ng-model=\"osoba.nazwisko\" type=\"text\"><br><i class=\"fa fa-phone\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Telefon\" ng-model=\"osoba.numerKontaktowy\" type=\"tel\"><br><i class=\"fa fa-envelope-o\" aria-hidden=\"true\" style=\"width: 15px;\"></i> <input class=\"form-control\" style=\"width:100px;display: inline-block;margin: 0\" placeholder=\"Email\" ng-model=\"osoba.adresEmail\" type=\"email\"></td><td style=\"vertical-align: middle\"><div class=\"bootstrap-iso-paper\"><button class=\"btn btn-default btn-sm\" ng-click=\"vmSemZN.dodajUczestnika()\" ng-if=\"vmSemZN.osoby.indexOf(osoba) == vmSemZN.osoby.length-1\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-danger btn-sm\" ng-click=\"vmSemZN.usunUczestnika(vmSemZN.osoby.indexOf(osoba))\" ng-if=\"vmSemZN.osoby.length > 1\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></div></td></tr></table><h4>Podsumowanie</h4><table class=\"\" style=\"border:1px solid lightgrey;margin-top: 20px;margin-left: 20px;\"><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Liczba osób</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZN.liczbaOsob}}</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Cena za osobę</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZN.cena}} zł</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Łącznie</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZN.cena * vmSemZN.liczbaOsob}} zł</td></tr><tr style=\"padding-top: 15px;height: 40px;\" ng-if=\"vmSemZN.seminaria.promocjaAktywna === true || vmSemZN.stalka === true\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Suma rabatów ({{vmSemZN.rabat*100}}%)</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZN.Math.round(vmSemZN.cena * vmSemZN.liczbaOsob * vmSemZN.rabat *100)/100}} zł</td></tr><tr style=\"padding-top: 15px;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;border:1px solid lightgrey;padding-left:0;width:250px;\">Do zapłaty</td><td style=\"width:120px;padding-left:0;border:1px solid lightgrey;text-align: center;padding-top: 15px;\">{{vmSemZN.Math.round(((vmSemZN.cena * vmSemZN.liczbaOsob) - (vmSemZN.cena * vmSemZN.liczbaOsob * vmSemZN.rabat))*100)/100}} zł</td></tr></table><div style=\"margin: 50px 0;\" class=\"{{vmSemZN.bootstrapKlasa}}\"><button ng-click=\"vmSemZN.wyslij()\" class=\"btn btn-primary\">Wyślij zgłoszenie</button></div></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 40px;\"><p>Liczba osób może być większa niż ilość wpisanych uczestników.</p></div></div></div>");
$templateCache.put("app/home/stronaGlowna/stronaGlowna.html","");
$templateCache.put("app/home/umowy/umowy.html","<ui-view><div class=\"container\" style=\"line-height: 1.25\"><div class=\"row\"><div class=\"col-md-12\"><h2>Umowy</h2></div></div><div class=\"pane23\"><div class=\"{{vmUm.bootstrapKlasa}}\" ng-if=\"vmUm.czyAdmin\"><button class=\"btn btn-default btn-sm\" ng-click=\"vmUm.dodajPowiadomienie()\"><i class=\"fa fa-plus\"></i> Dodaj powiadomienie</button></div><prezentacja-powiadomien typy-obiektow=\"[\'UPPDO\']\"></prezentacja-powiadomien><div class=\"notification row\" ng-class=\"{ \'notification-info\':(powiadomienie.typ_powiadomienia === \'INFO\'), \'notification-warning\': (powiadomienie.typ_powiadomienia === \'WARNING\'), \'notification-error\': (powiadomienie.typ_powiadomienia === \'ERROR\')}\" ng-repeat=\"powiadomienie in vmUm.powiadomienia\"><div class=\"notification-header\"><i class=\"fa fa-info-circle\"></i> <b style=\"margin-left: 5px\">Uwaga</b> <span style=\"color: crimson;float: right; display: inline-block; cursor: pointer\" ng-if=\"vmUm.czyAdmin\" ng-click=\"vmUm.usunPowiadomienie(powiadomienie.id)\"><i class=\"fa fa-times\"></i></span></div><div class=\"notofocation-body\">{{powiadomienie.wiadomosc}}</div></div><div ng-repeat=\"umowa in vmUm.umowy\"><h3 style=\"margin-bottom: 0\">{{umowa.nazwa}}</h3><div ng-if=\"vmUm.umowyStatusy[umowa.id] === null\">Ładownie danych...</div><div ng-if=\"vmUm.umowyStatusy[umowa.id] !== null\"><div class=\"row\">Status: <span style=\"{{(vmUm.getStatus(umowa.id) === vmUm.statusy.brak) ? \'color: crimson;\' : \'color: green;\'}}\">{{vmUm.getStatus(umowa.id)}}</span><div class=\"{{vmUm.bootstrapKlasa}}\" style=\"display: inline-block; float:right;\" ng-if=\"vmUm.getStatus(umowa.id) !== vmUm.statusy.brak\"><button class=\"btn btn-default btn-sm\" ng-disabled=\"vmUm.jestSubUserem !== true\" ui-sref=\"{{umowa.formularzUrl}}\"><i class=\"fa fa-refresh\"></i> Aktualizuj umowę</button></div></div><div ng-if=\"vmUm.getStatus(umowa.id) == vmUm.statusy.brak\"><br>{{umowa.infoBrakUmowy}}<br><ul><li ng-repeat=\"zal in umowa.brakUmowyZalaczniki\" style=\"line-height: 1.25\">{{zal.nazwa}} <a target=\"_blank\" ng-repeat=\"ikona in zal.ikony\" href=\"{{ikona.url}}\"><i ng-if=\"ikona.typ === \'pdf\'\" class=\"fa fa-lg fa-file-pdf-o\" aria-hidden=\"true\"></i> <i ng-if=\"ikona.typ === \'docx\'\" class=\"fa fa-lg fa-file-word-o\" aria-hidden=\"true\"></i></a></li></ul></div><div ng-if=\"vmUm.getStatus(umowa.id) === vmUm.statusy.aktualna\" style=\"margin-top: 20px;\" class=\"{{vmUm.bootstrapKlasa}}\"><ng-include src=\"umowa.umowaAktualnaTemplateSrc\"></ng-include></div><div ng-if=\"vmUm.getStatus(umowa.id) === vmUm.statusy.wymagaAktualizacji\" style=\"margin-top: 20px;\" class=\"{{vmUm.bootstrapKlasa}}\"><ng-include src=\"umowa.umowaWymagaAktualizacjiTemplateSrc\"></ng-include></div><div ng-if=\"vmUm.getStatus(umowa.id) === vmUm.statusy.brak\">Uwaga! Zawarcie umowy dozwolone jest wyłącznie z imiennego konta pracownika posiadającego pisemne pełnomocnictwo do zawierania tego typu umów lub upoważnionego do jednoosobowej reprezentacji podmiotu możliwej do weryfikacji w rejestrach (CEIDG/ KRS)!<br><br>Powyższe wymaga utworzenia konta imiennego pracownika (uzupełnione pola: imię, nazwisko) dla osoby upoważnionej do zawierania umów oraz nadania mu uprawnienia „formularze” (lub edycję istniejącego konta, poprzez uzupełnienie pól: imię, nazwisko i nadanie uprawnienia „formularze”)<br><span ng-if=\"vmUm.jestSubUserem === false\">W celu rozpoczęcia procesu zawierania umowy zaloguj się na ww. konto pracownika. Jeśli nie posiadasz konta pracownika utwórz je z zakładki <a ui-sref=\"home.subMain.konta_pracownikow\"><u>Twoje konto <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Konta pracowników</u></a></span></div><div ng-if=\"vmUm.getStatus(umowa.id) === vmUm.statusy.brak\"><br>Jeśli nie posiadasz pełnomocnictwa do zawierania umów, skorzystaj z poniższego szablonu pełnomocnictwa – skan podpisanego dokumentu pełnomocnictwa będzie niezbędny w procesie podpisywania umowy.<ul><li ng-repeat=\"zal in umowa.brakPelnomocnictwaZalaczniki\" style=\"line-height: 1.25\">{{zal.nazwa}} <a target=\"_blank\" ng-repeat=\"ikona in zal.ikony\" href=\"{{ikona.url}}\"><i ng-if=\"ikona.typ === \'pdf\'\" class=\"fa fa-lg fa-file-pdf-o\" aria-hidden=\"true\"></i> <i ng-if=\"ikona.typ === \'docx\'\" class=\"fa fa-lg fa-file-word-o\" aria-hidden=\"true\"></i></a></li></ul></div><div ng-if=\"vmUm.jestSubUserem === true && vmUm.getStatus(umowa.id) === vmUm.statusy.brak\">W celu rozpoczęcia procesu zawierania umowy kliknij w przycisk „Zawrzyj umowę”.<br>Kliknięcie w przycisk nie oznacza automatycznego podpisania umowy – jest ono kilkuetapowe i umożliwia powrót i realizację w terminie późniejszym.<br><br>Przed zawarciem umowy zapoznaj się z <a href=\"https://www.mieszczanin.pl/polityka-prywatnosci\" target=\"_blank\"><u>klauzulą informacyjną o przetwarzaniu danych osobowych</u></a></div><div ng-if=\"vmUm.getStatus(umowa.id) === vmUm.statusy.brak\" style=\"margin-top: 20px;\" class=\"{{vmUm.bootstrapKlasa}}\"><button class=\"btn btn-default\" ng-disabled=\"vmUm.jestSubUserem !== true\" ui-sref=\"{{umowa.formularzUrl}}\"><i class=\"fa fa-external-link\"></i> Zawrzyj umowę</button></div><br><br></div></div></div><div class=\"pane13\"></div></div></ui-view>");
$templateCache.put("app/home/umowy/umowy.pobieranie.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><h2>Pobierz umowę i pełnomocnictwo</h2></div></div><div class=\"row mt20 bootstrap-iso-paper\" ng-if=\"!vmUmPo.brakUmowy\"><div class=\"col-md-12\"><a class=\"btn btn-default\" ng-if=\"vmUmPo.umowa.downloadURL\" href=\"{{vmUmPo.umowa.downloadURL}}\" target=\"_blank\"><i class=\"fa fa-download\"></i> Pobierz Umowę</a></div></div><div class=\"row mt20 bootstrap-iso-paper\" ng-if=\"!vmUmPo.brakUmowy\"><div class=\"col-md-12\"><a class=\"btn btn-default\" ng-if=\"vmUmPo.pelnomocnictwo.downloadURL\" href=\"{{vmUmPo.pelnomocnictwo.downloadURL}}\" target=\"_blank\"><i class=\"fa fa-download\"></i> Pobierz Pełnomocnictwo</a></div></div><div class=\"row mt10\" ng-if=\"vmUmPo.brakUmowy\"><div class=\"col-md-12\">Brak podanej umowy do pobrania, sprawdź url i odświerz stronę.</div></div></div>");
$templateCache.put("app/home/twojeKonto/konto.faktury.html","<div ng-init=\"vmFaktury.init()\"><div><div class=\"panefull\" style=\"padding-top: 20px\"><div class=\"bootstrap-iso-paper\"><button type=\"button\" class=\"btn btn-primary pull-right\" data-ng-click=\"vmFaktury.przejdzNaeFaktury()\" ng-if=\"!vmFaktury.eFaktury\">Przejdź na e-faktury</button> <button type=\"button\" class=\"btn btn-primary pull-right\" data-ng-click=\"vmFaktury.pokazKontaDoPowiadomien = !vmFaktury.pokazKontaDoPowiadomien\" ng-if=\"vmFaktury.eFaktury\">Korzystasz z e-faktur</button></div><div ng-show=\"vmFaktury.pokazKontaDoPowiadomien\"><h3>Konta do powiadomień</h3><obsluga-bledow wiadomosci-tablica=\"vmFaktury.serverPowiadomieniaResponse\" style=\"margin-top: 50px\"></obsluga-bledow><div class=\"bootstrap-iso-paper\"><button type=\"button\" class=\"btn btn-primary pull-right\" data-ng-click=\"vmFaktury.dodajKontodoeFaktury()\">Dodaj nowe konto</button></div><table class=\"minetable\" style=\"border: 1px solid lightgrey; margin-top: 80px; width: 100%\"><tr style=\"padding-top: 15px; border-bottom: 2px solid lightgrey; height: 40px;\"><td style=\"padding-top: 15px; text-align: center; padding-left: 0; width: 80px;\">Adres e-mail</td><td style=\"width: 100px; padding-left: 0; text-align: center; padding-top: 15px;\">Imię</td><td style=\"width: 60px; padding-left: 0; text-align: center; padding-top: 15px;\">Nazwisko</td><td style=\"width: 60px; padding-left: 0; text-align: center\"></td></tr><tr ng-repeat=\"kontoPowiadomien in vmFaktury.kontaeFaktury\"><td style=\"text-align: center; padding-top: 15px\">{{kontoPowiadomien.Adres}}</td><td style=\"text-align: center; padding-top: 15px\">{{kontoPowiadomien.Imie}}</td><td style=\"text-align: center; padding-top: 15px\">{{kontoPowiadomien.Nazwisko}}</td><td style=\"text-align: center; padding-top: 15px\"><div class=\"bootstrap-iso-paper\" style=\"margin-top: -10px\"><button type=\"button\" class=\"btn btn-default btn-sm\" data-ng-click=\"vmFaktury.zmienKontoeFaktur(kontoPowiadomien)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></td></tr></table></div><h3>Faktury</h3><obsluga-bledow wiadomosci-tablica=\"vmFaktury.serverResponse\" style=\"margin-top: 10px\"></obsluga-bledow><table class=\"minetable\" style=\"border: 1px solid lightgrey; margin-top: 20px; width: 100%\"><tr style=\"padding-top: 15px; border-bottom: 2px solid lightgrey; height: 40px;\"><td style=\"padding-top: 15px; text-align: center; padding-left: 0; width: 80px;\">LP</td><td style=\"width: 100px; padding-left: 0; text-align: center; padding-top: 15px;\">Numer</td><td style=\"width: 60px; padding-left: 0; text-align: center; padding-top: 15px;\">Plik</td><td style=\"width: 100px; padding-left: 0; text-align: center; padding-top: 15px;\">Kwota</td><td style=\"width: 90px; padding-left: 0; text-align: center; padding-top: 15px;\">Data wystawienia</td><td style=\"width: 90px; padding-left: 0; text-align: center; padding-top: 15px;\">Termin Płatności</td><td style=\"width: 120px; padding-left: 0; text-align: center; padding-top: 15px;\">Prośba o duplikat</td></tr><tr ng-repeat=\"element in vmFaktury.listaFaktur\"><td style=\"text-align: center; padding-left: 0\">{{ vmFaktury.indexStart + $index + 1 }}</td><td style=\"text-align: center; padding-left: 0\" width=\"180px\">{{element.Symbol}}</td><td style=\"text-align: center; padding-left: 0\"><span><a target=\"_blank\" ng-href=\"{{vmFaktury.pobierzFakture(element)}}\"><img style=\"margin-top: 10px; margin-bottom: -10px\" src=\"assets/images/iconPDF.gif\" border=\"0\" alt=\"\"></a></span></td><td style=\"text-align: center; padding-left: 0\">{{element.Netto + element.Vat | number:2}} zł</td><td style=\"text-align: center; padding-left: 0\" width=\"100px\">{{element.DataWyst | date : \"dd.MM.yyyy\"}}</td><td style=\"text-align: center; padding-left: 0\" width=\"100px\">{{(element.Termin | date : \"dd.MM.yyyy\")}}</td><td style=\"text-align: center; padding-left: 0\" width=\"100px\" class=\"bootstrap-iso-paper\"><button style=\"display: inline-block; margin-top: -6px\" ng-click=\"vmFaktury.poprosODuplikat(element)\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-files-o\" aria-hidden=\"true\"></i> Poproś o duplikat</button></td></tr></table><div ng-class=\"vmFaktury.bootstrapKlasa\"><uib-pagination first-text=\"Pierwsza\" previous-text=\"«\" next-text=\"»\" total-items=\"vmFaktury.listaFaktur.meta.count\" ng-model-options=\"{ getterSetter: true }\" max-size=\"10\" items-per-page=\"20\" ng-model=\"vmFaktury.page\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"vmFaktury.pobierzFaktury()\"></uib-pagination></div><br></div></div></div>");
$templateCache.put("app/home/twojeKonto/konto.html","<div class=\"content\" ng-init=\"vmKonto.init();\"><div class=\"pane23\"><div class=\"clearfix\"></div><div class=\"box23\"></div><div class=\"clearfix\"></div><div class=\"box23\"><h1 ng-bind=\"vmKonto.danePodstawowe.Nazwa\"></h1></div><div class=\"clearfix\"></div><div class=\"box23\"><h4><span ng-if=\"vmKonto.innyKorespondencyjny===true\">Adres główny:<br></span> <span class=\"value\">ul. {{vmKonto.danePodstawowe.Ulica}} {{vmKonto.danePodstawowe.Numer}}<br>{{vmKonto.danePodstawowe.KodPocztowy}} {{vmKonto.danePodstawowe.Miasto}}</span><br><br><div ng-if=\"vmKonto.innyKorespondencyjny===true\"><span>Adres do korespondencji:<br></span> <span class=\"value\">ul. {{vmKonto.danePodstawowe.UlicaKor}} {{vmKonto.danePodstawowe.NumerKor}}<br>{{vmKonto.danePodstawowe.KodPocztowyKor}} {{vmKonto.danePodstawowe.MiastoKor}}</span><br><br></div><span>NIP: {{vmKonto.danePodstawowe.Nip}}</span><br><br><span>Numer klienta: {{vmKonto.danePodstawowe.Kod}}</span></h4></div><div class=\"clearfix\"></div><div class=\"box23\" ng-if=\"vmKonto.opiekun.Handlowy || vmKonto.opiekun.Merytoryczny\"><div ng-if=\"vmKonto.opiekun.Handlowy\">Opiekun handlowy: {{vmKonto.opiekun.Handlowy}}</div><br><div ng-if=\"vmKonto.opiekun.Merytoryczny\">Opiekun merytoryczny: {{vmKonto.opiekun.Merytoryczny}}</div></div><div class=\"box23\"><prezentacja-powiadomien></prezentacja-powiadomien></div></div><div class=\"pane13\"><div class=\"boxT\" ng-show=\"vmKonto.systemy.Wersja!=vmKonto.systemy.WersjaSp\"><h3>Twoja wersja EZN: <span ng-bind=\"vmKonto.systemy.Wersja | number : 2\"></span></h3><h3>Najnowsza wersja: <span class=\"crimson\" ng-bind=\"vmKonto.systemy.WersjaSp | number : 2\"></span></h3></div><div class=\"boxT\" ng-show=\"vmKonto.systemy.Wersja!=vmKonto.systemy.WersjaSp && vmKonto.uprawnienia.Licencje == true\"><h3>Prośba o wygenerowanie licencji<a class=\"golink\" ng-click=\"vmKonto.goGenerowanieLicencji()\"></a></h3></div><div class=\"boxT\"><h3>Zmiana limitów<a class=\"golink\" ui-sref=\"home.subMain.zmiana_limitow\"></a></h3></div><div class=\"boxT\"><h3>Dostęp do serwera FTP <a class=\"golink\" ng-click=\"vmKonto.pokazDostepFtp()\"></a></h3><div ng-if=\"vmKonto.pokazHasla\" ng-repeat=\"ftp in vmKonto.dostepFTP | orderBy: \'tNazwa\'\"><h5>{{ftp.tNazwa}}</h5><dl><dt>{{ftp.tUser}}</dt><dd>{{ftp.tPass}}</dd></dl></div></div><div class=\"boxT\"><h3>Twoje zamówienia<a class=\"golink\" ui-sref=\"home.subMain.zgloszenia.zamowienia\"></a></h3></div></div><div class=\"pane13\" ng-if=\"vmKonto.dostepDoZgloszen\" style=\"float: right;\"><div class=\"boxT\"><h3 style=\"padding-bottom: 10px\">Wprowadzenie do systemu zgłoszeń</h3><table><tr><td><a class=\"fa fa-video-camera\" ui-sref=\"home.subMain.player({film: \'ustawienia\'})\" style=\"padding-right: 10px; font-size: large\"></a></td><td><p><a ui-sref=\"home.subMain.player({film: \'ustawienia\'})\">Jak skonfigurować konta pracowników?</a></p></td></tr><tr></tr><tr><td><a class=\"fa fa-video-camera\" ui-sref=\"home.subMain.player({film: \'zgloszenie\'})\" style=\"padding-right: 10px; font-size: large\"></a></td><td><p><a ui-sref=\"home.subMain.player({film: \'zgloszenie\'})\">Jak dodać zgłoszenie w Strefie Klienta?</a></p></td></tr><td><a class=\"fa fa-video-camera\" ui-sref=\"home.subMain.player({film: \'blad\'})\" style=\"padding-right: 10px; font-size: large\"></a></td><td><p><a ui-sref=\"home.subMain.player({film: \'blad\'})\">Zgłaszanie błędu z programu</a></p></td><tr><td><a class=\"fa fa-file-pdf-o\" href=\"/assets/files/Instrukcja uruchomienia Systemu Zgloszen.pdf\" style=\"padding-right: 10px; font-size: large\"></a></td><td><p><a href=\"/assets/files/Instrukcja uruchomienia Systemu Zgloszen.pdf\">Instrukcja korzystania z systemu zgłoszeń</a></p></td></tr></table></div><div class=\"boxT\"><h3 style=\"color: crimson\">Promocje<a class=\"golink\" ui-sref=\"home.subMain.promocje\"></a></h3></div><div class=\"boxT\"><h3>TeamViewer®</h3><p>Narzędzie do zdalnej komunikacji z pracownikami naszej firmy - <a href=\"https://get.teamviewer.com/6pz6372\" target=\"_blank\" class=\"download\">Pobierz</a></p></div></div></div>");
$templateCache.put("app/home/twojeKonto/konto.informacjeDedykowane.html","<div ng-init=\"vmDed.init();\"><div class=\"pane23\"><div class=\"clearfix\"></div><div class=\"box23\"><h2 class=\"softname\"><span>Informacje dedykowane</span></h2><div class=\"files\"><a ng-click=\"vmDed.getFile()\" style=\"margin: 0 5px;\" ng-class=\"vmDed.dajKlase()\" target=\"_blank\" ng-title=\"vmDed.wybranyPlik.tytul\"></a> <a ng-click=\"vmDed.getFile()\" style=\"display: inline-block;\"><p>- {{vmDed.wybranyPlik.tytul}}</p></a><div class=\"plikiKomentarz angular-with-newlines\"><p>{{vmDed.wybranyPlik.opis}}</p></div></div></div></div><div class=\"pane13\"><div class=\"clearfix\"></div><div class=\"box23\"><div class=\"floatleft\"><div class=\"boxT\"><h3 style=\"color: crimson\">Promocje<a class=\"golink\" ui-sref=\"home.subMain.promocje\"></a></h3></div><ul><li ng-repeat-start=\"informacja in vmDed.pliki | orderBy:\'kolejnosc\'\" class=\"docitem\" ng-click=\"vmDed.wybierzInformacje(informacja)\"><a><span>{{informacja.tytul}}</span></a></li><div ng-repeat-end=\"\" class=\"clearfix\"></div></ul></div></div></div></div>");
$templateCache.put("app/home/twojeKonto/konto.informacjeDedykowane.pliki.html","<div ng-if=\"vmDedP.informacja\"><div class=\"files\"><a ng-href=\"{{vmDedP.informacja.sciezka}}\" ng-class=\"{\'download pdf\': !vmDedP.informacja.format, \'download ars\': vmDedP.informacja.format ===\'ars\', \'download wmv\': vmDedP.informacja.format ===\'wmv\'}\" ng-title=\"vmDedP.informacja.nazwa\"></a> <a ng-href=\"{{vmDedP.informacja.sciezka}}\"><span>- {{vmDedP.informacja.nazwa}}</span></a><br><span class=\"plikiKomentarz angular-with-newlines\">{{vmDedP.informacja.komentarz}}</span></div></div>");
$templateCache.put("app/home/twojeKonto/konto.konsultacje.html","<div class=\"pane23\"><div ng-repeat-start=\"lokalizacja in vmKon.lokalizacje\"><div class=\"box23\"><h3 ng-bind=\"lokalizacja.NazwaLok\"></h3></div><div class=\"clearfix\"></div><div class=\"clearfix\"></div><h4>Aktualny adres e-mail do powiadomień</h4><div class=\"{{vmKon.bootstrapKlasa}}\"><obsluga-bledow wiadomosci-tablica=\"vmKon.odpowiedziSerweraEmail[lokalizacja.IdLok]\" id=\"{{$index}}\"></obsluga-bledow><div class=\"pull-right btn-bottom-margin\"><button ng-click=\"vmKon.dodajAdres(lokalizacja.IdLok)\" ng-disabled=\"vmKon.noweAdresyEmail[lokalizacja.IdLok]\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-plus\"></span> Dodaj adres</button></div><table class=\"table table-bordered table-striped\"><thead ng-show=\"vmKon.adresyEmailDoPowiadomien[lokalizacja.IdLok].length>0\"><th>Adres e-mail</th><th></th></thead><tbody><tr ng-show=\"vmKon.noweAdresyEmail[lokalizacja.IdLok]\" ng-init=\"vmKon.odpowiedziSerweraEmail[lokalizacja.IdLok] = []\" ng-form=\"emailForm\"><td><input type=\"email\" id=\"email{{lokalizacja.IdLok}}\" required=\"\" class=\"editable-input form-control input-sm\" ng-model=\"vmKon.noweAdresyEmail[lokalizacja.IdLok].Email\"></td><td><div class=\"btn-group pull-right\"><button type=\"submit\" class=\"btn btn-primary btn-sm\" title=\"Zapisz\" ng-disabled=\"emailForm.$invalid\" ng-click=\"vmKon.zapiszEmail(lokalizacja.IdLok)\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Anuluj\" ng-click=\"vmKon.anulujNowyEmail(lokalizacja.IdLok)\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></td></tr><tr ng-repeat=\"adres in vmKon.adresyEmailDoPowiadomien[lokalizacja.IdLok]\" ng-show=\"adres.adres\"><td ng-class=\"{\'usunWiersz\': adres.edycja}\"><a ng-href=\"mailto:{{adres}}\">{{adres.adres}}</a></td><td class=\"table-cell-15-width\"><button class=\"btn btn-default btn-sm\" ng-if=\"!adres.edycja\" ng-click=\"adres.edycja=true\" title=\"Usuń adres email\"><span class=\"glyphicon glyphicon-trash\"></span></button><div class=\"btn-group\"><button type=\"submit\" class=\"btn btn-primary btn-sm\" title=\"Zapisz\" ng-if=\"adres.edycja\" ng-click=\"vmKon.potwierdzUsunEmail(lokalizacja.IdLok, adres.adres)\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Anuluj\" ng-if=\"adres.edycja\" ng-click=\"adres.edycja=false\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></td></tr></tbody></table></div></div><div ng-repeat-end=\"\" class=\"odstepLokalizacji\"></div></div>");
$templateCache.put("app/home/twojeKonto/konto.kontaPracownikow.html","<div><div class=\"boxT\" style=\"float: right; display: inline; margin-top: 40px;\"><table><tr><td><a class=\"fa fa-question-circle-o\" ng-click=\"konta_pracownikow.pokazLegende()\" style=\"padding-right: 10px; font-size: large\"></a></td><td><p><a ng-click=\"konta_pracownikow.pokazLegende()\">Co oznaczają symbole uprawnień</a></p></td></tr></table></div><h2 style=\"display: inline-block\">Konta pracowników</h2></div><div ng-init=\"konta_pracownikow.init()\"><obsluga-bledow wiadomosci-tablica=\"konta_pracownikow.odpowiedziSerwera\"></obsluga-bledow><div class=\"{{konta_pracownikow.bootstrapKlasa}}\" style=\"float: right;\"><button class=\"btn btn-primary\" ng-click=\"konta_pracownikow.kontoPracownika()\" title=\"Dodaj pracownika\"><span class=\"glyphicon glyphicon-plus\"></span> <span>Dodaj pracownika</span></button></div><div ng-repeat=\"lokalizacja in konta_pracownikow.lokalizacje\"><h3 style=\"padding-top: 10px\">{{lokalizacja.NazwaLok}}</h3><table class=\"{{konta_pracownikow.bootstrapKlasa+\' minetable\'}}\" style=\"border:1px solid lightgrey;\"><tr style=\"padding-top: 15px;border-bottom:2px solid lightgrey;height: 30px;\"><td style=\"width:46%;height:50px;padding-left:0;text-align: center;padding-top: 15px;\">Imię i Nazwisko</td><td hidden=\"\" style=\"width:6%;padding-left:0;text-align: center;padding-top: 15px;\">Dostęp do konsultacji</td><td style=\"width:6%;padding-left:0;text-align: center;padding-top: 15px;font-size: 20px;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Wykaz konsultacji telefonicznych\"><i class=\"fa fa-phone\" aria-hidden=\"true\"></i></td><td style=\"width:6%;padding-left:0;text-align: center;padding-top: 15px;font-size: 20px;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Licencje\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i></td><td style=\"width:6%;padding-left:0;text-align: center;padding-top: 15px;font-size: 20px;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Faktury\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></td><td style=\"width:6%;padding-left:0;text-align: center;padding-top: 15px;font-size: 20px;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Panel zakupowy\"><i class=\"fa fa-shopping-cart\" aria-hidden=\"true\"></i></td><td style=\"width:6%;padding-left:0;text-align: center;padding-top: 15px;font-size: 20px;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Aktualizacja\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i></td><td style=\"width:6%;padding-left:0;text-align: center;padding-top: 10px;font-size: 20px;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Powiadomienia\"><i class=\"fa fa-bell-o\" aria-hidden=\"true\"></i></td><td style=\"width:6%;padding-left:0;text-align: center;padding-top: 15px;font-size: 20px;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Informacje dedykowane\"><i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i></td><td style=\"width:6%;padding-left:0;text-align: center;padding-top: 15px;font-size: 20px;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Formularze\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></td><td style=\"width:6%;padding-left:0;text-align: center;padding-top: 15px;font-size: 20px;\" tooltip-placement=\"bottom\" data-toggle=\"tooltip\" title=\"Głosowanie\"><i class=\"fa fa-thumbs-o-up\" aria-hidden=\"true\"></i></td><td style=\"width:10%;padding-left:0;text-align: center;padding-top: 15px;\"></td></tr><tr ng-repeat=\"element in konta_pracownikow.pracownicy[lokalizacja.IdLok]\"><td style=\"padding: 10px 0 0 0!important;text-align: center;\"><div style=\"text-align: center;\" ng-if=\"element.nazwisko && element.imie\">{{element.nazwisko + \" \" + element.imie}}</div></td><td style=\"text-align: center;\"><input style=\"top: 0;left:10px;position: relative\" type=\"checkbox\" ng-model=\"element.uprawnienia.WykazKonsultacji\" ng-click=\"konta_pracownikow.zmienUprawnienia(element,\'WykazKonsultacji\')\"></td><td style=\"text-align: center;\"><input style=\"top: 0;left:10px;position: relative\" type=\"checkbox\" ng-model=\"element.uprawnienia.Licencje\" ng-click=\"konta_pracownikow.zmienUprawnienia(element,\'Licencje\')\"></td><td style=\"text-align: center;\"><input style=\"top: 0;left:10px;position: relative\" type=\"checkbox\" ng-model=\"element.uprawnienia.Faktury\" ng-click=\"konta_pracownikow.zmienUprawnienia(element,\'Faktury\')\"></td><td style=\"text-align: center;\"><input style=\"top: 0;left:10px;position: relative\" type=\"checkbox\" ng-model=\"element.uprawnienia.PanelZakupowy\" ng-click=\"konta_pracownikow.zmienUprawnienia(element,\'PanelZakupowy\')\"></td><td style=\"text-align: center;\"><input style=\"top: 0;left:10px;position: relative\" type=\"checkbox\" ng-model=\"element.uprawnienia.Aktualizacja\" ng-click=\"konta_pracownikow.zmienUprawnienia(element,\'Aktualizacja\')\"></td><td style=\"text-align: center;\"><input style=\"top: 0;left:10px;position: relative\" type=\"checkbox\" ng-model=\"element.uprawnienia.Powiadomienia\" ng-click=\"konta_pracownikow.zmienUprawnienia(element,\'Powiadomienia\')\"></td><td style=\"text-align: center;\"><input style=\"top: 0;left:10px;position: relative\" type=\"checkbox\" ng-model=\"element.uprawnienia.InformacjeDedykowane\" ng-click=\"konta_pracownikow.zmienUprawnienia(element,\'InformacjeDedykowane\')\"></td><td style=\"text-align: center;\"><input style=\"top: 0;left:10px;position: relative\" type=\"checkbox\" ng-model=\"element.uprawnienia.Formularze\" ng-click=\"konta_pracownikow.zmienUprawnienia(element,\'Formularze\')\"></td><td style=\"text-align: center;\"><input style=\"top: 0;left:10px;position: relative\" type=\"checkbox\" ng-model=\"element.uprawnienia.GlosowaniaPropozycje\" ng-click=\"konta_pracownikow.zmienUprawnienia(element,\'GlosowaniaPropozycje\')\"></td><td style=\"text-align: center;padding: 0;\"><div class=\"btn-group\" style=\"margin: 0;padding: 0;\"><button class=\"btn btn-default btn-sm\" title=\"Edytuj\" ng-click=\"konta_pracownikow.kontoPracownika(element)\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-default btn-sm\" title=\"Usuń\" ng-click=\"konta_pracownikow.deleteSelected(element)\" ng-disabled=\"element.Ident !== null\"><span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"Użytkownik automatyczny\" tooltip-placement=\"right\" ng-if=\"element.Ident !== null\"></span> <span class=\"glyphicon glyphicon-trash\" ng-if=\"element.Ident === null\"></span></button></div></td></tr></table><div class=\"{{konta_pracownikow.bootstrapKlasa}}\"><uib-pagination first-text=\"{{lokalizacja.IdLok}}\" previous-text=\"«\" next-text=\"»\" total-items=\"konta_pracownikow.pracownicy[lokalizacja.IdLok].meta.count\" ng-model-options=\"{ getterSetter: true }\" max-size=\"10\" items-per-page=\"konta_pracownikow.paginacja.pageSize\" ng-model=\"konta_pracownikow.paginacja.page\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"konta_pracownikow.nextPage(lokalizacja.IdLok)\"></uib-pagination></div></div><div class=\"{{konta_pracownikow.bootstrapKlasa}}\"><h4 style=\"color: grey;\">Informator</h4><hr style=\"border-color: grey;margin-top: -10px\"><li style=\"margin-top: -15px; color: black\">Aby nadać uprawnienie do wskazanej w nagłówku kolumny części Strefy Klienta należy w wierszu z nazwiskiem i imieniem wybranej osoby zaznaczyć oczekiwane elementy</li></div></div>");
$templateCache.put("app/home/twojeKonto/konto.licencje.akceptacjaRegulaminow.html","<div class=\"row\"><div class=\"col-md-12\"><h3>Regulaminy usług</h3></div><div ng-repeat=\"regulamin in vmLicencje.zaakceptowaneRegulaminy\"><div><input type=\"checkbox\" ng-checked=\"true\" id=\"{{\'regulamin_\' + regulamin}}\" ng-disabled=\"true\"> <label class=\"checkboxlabel\" for=\"{{\'regulamin_\' + regulamin}}\"><a ng-click=\"vmLicencje.pobierzRegulamin(regulamin)\">{{ vmLicencje.regulaminy[regulamin].nazwa }}</a></label></div></div></div>");
$templateCache.put("app/home/twojeKonto/konto.licencje.html","<div ng-init=\"vmLicencje.init()\"><div ng-if=\"vmLicencje.subUser.dostepDoLicencji || vmLicencje.security.jestSubUserem() == false\"><div class=\"content\"><div class=\"pane13\" style=\"float: right\"><div class=\"boxT\" ng-show=\"vmKonto.systemy.Wersja!=vmKonto.systemy.WersjaSp\"><h3>Prośba o wycenę aktualizacji<a class=\"golink\" ng-click=\"vmLicencje.goWycenaAktualizacji()\"></a></h3></div><div class=\"boxT\"><h3>Zmiana limitów<a class=\"golink\" ng-click=\"vmLicencje.goZmianaLimitow()\"></a></h3></div><div class=\"boxT\"><h3>Aktualizacja<a class=\"golink\" ui-sref=\"home.subMain.pobieranie_plyty\"></a></h3></div><div class=\"boxT\"><h3>Zamów e-kartotekę<a class=\"golink\" ui-sref=\"home.subMain.cennikEKIEM\"></a></h3></div><div class=\"boxT\"><h3>Zamów e-Mieszczanina<a class=\"golink\" ui-sref=\"home.subMain.cennikEKIEM\"></a></h3></div><div class=\"boxT\"><p>Informacje o sposobie wczytania nowego pliku z licencją oraz o instalacji nowej wersji znajduja się w zakładce <a href=\"\" ui-sref=\"home.subMain.informacje_dedykowane\"><span>Informacje dedykowane</span></a></p></div><div class=\"boxT\"><p><span class=\"{{vmLicencje.bootstrapKlasa}}\"><span class=\"glyphicon glyphicon-warning-sign\"></span></span> <strong>Ważne informacje:</strong> Zgodnie ze specyfikacją sprzętową komputery z systemem Windows XP nie spełniają naszych <a target=\"_blank\" href=\"/assets/files/Wymagania%20sprzetowe%20systemu%20firmy%20Mieszczanin.pdf\">ogólnych wymagań sprzętowych</a> i dlatego firma Mieszczanin nie udziela gwarancji na działanie programów w tym systemie operacyjnym.<br><br>Z uwagi na wprowadzone zmiany technologiczne zachęcamy do dokładnego zapoznania się z <a ng-click=\"vmLicencje.pobierzInstrukcjeAktualizacji()\">instrukcją instalacji</a> oraz o postępowanie zgodnie z zawartymi w niej wskazaniami</p></div><div class=\"boxT\"><p>Szczegóły dotyczące licencji (w tym <span style=\"color: crimson\">kod aktywacyjny</span>) pojawią się po kliknięciu w wybrany wiersz</p></div></div><div class=\"pane23\"><h2>Licencje</h2><div class=\"clearfix\"></div><div class=\"box23\"><div class=\"row\" ng-if=\"vmLicencje.statusyUmow.UmowaEK == true || vmLicencje.statusyUmow.UmowaEM == true\"><div class=\"col-md-12\"><h3>Informacja o lokalach</h3></div><div ng-if=\"vmLicencje.aktualnaLiczbaLokali\"><p>Liczba zarządzanych lokali: {{vmLicencje.aktualnaLiczbaLokali}} <a class=\"fa fa-question-circle-o\" ng-click=\"vmLicencje.pokazSzczegolyCeny()\" style=\"font-size: large\"></a></p></div><div><label>Pakiet lokali:</label><select ng-model=\"vmLicencje.aktualnyPakietLokali\" disabled=\"\" ng-disabled=\"true\"><option value=\"{{vmLicencje.aktualnyPakietLokali}}\" selected=\"true\" disabled=\"\" ng-disabled=\"true\">do {{vmLicencje.aktualnyPakietLokali}}</option></select></div></div><ng-include src=\"\'app/home/twojeKonto/konto.licencje.opcjeEK.html\'\" ng-if=\"vmLicencje.statusyUmow.UmowaEK == true\"></ng-include><ng-include src=\"\'app/home/twojeKonto/konto.licencje.opcjeEM.html\'\" ng-if=\"vmLicencje.statusyUmow.UmowaEM == true\"></ng-include><ng-include src=\"\'app/home/twojeKonto/konto.licencje.akceptacjaRegulaminow.html\'\" ng-if=\"vmLicencje.zaakceptowaneRegulaminy.length > 0\"></ng-include></div><div class=\"box23\" ng-if=\"vmLicencje.aktywneUmowySMSOCR && vmLicencje.aktywneUmowySMSOCR.length > 0\"><div style=\"padding-bottom: 10px;\"><h3>Aktywne Umowy</h3><ul ng-if=\"vmLicencje.aktywneUmowySMSOCR.indexOf(10) !== -1\"><li>Łączne zużycie sms (moduły desktopowe i e-Mieszczanin)</li></ul><div class=\"{{vmLicencje.bootstrapKlasa}}\"><div class=\"row aktywne-umowy\"><div class=\"col-xs-5\" ng-if=\"vmLicencje.aktywneUmowySMSOCR.indexOf(10) !== -1\"><div class=\"wykorzystanie\"><div class=\"naglowek\"><b>Wysłane SMS</b></div><div class=\"tresc\"><p>Bieżący miesiąc: <span class=\"pull-right\">{{vmLicencje.zuzycieSMS.biezacyMiesiac.zuzycie}}</span></p><p>{{vmLicencje.zuzycieSMS.p1.nazwa}}: <span class=\"pull-right\">{{vmLicencje.zuzycieSMS.p1.zuzycie}}</span></p><p>{{vmLicencje.zuzycieSMS.p2.nazwa}}: <span class=\"pull-right\">{{vmLicencje.zuzycieSMS.p2.zuzycie}}</span></p></div></div></div><div class=\"col-xs-5\" ng-if=\"vmLicencje.aktywneUmowySMSOCR.indexOf(17) !== -1\"><div class=\"wykorzystanie\"><div class=\"naglowek\"><b>Wykorzystanie OCR</b></div><div class=\"tresc\"><p>Bieżący miesiąc: <span class=\"pull-right\">{{vmLicencje.zuzycieOCR.biezacyMiesiac.zuzycie}}</span></p><p>{{vmLicencje.zuzycieOCR.p1.nazwa}}: <span class=\"pull-right\">{{vmLicencje.zuzycieOCR.p1.zuzycie}}</span></p><p>{{vmLicencje.zuzycieOCR.p2.nazwa}}: <span class=\"pull-right\">{{vmLicencje.zuzycieOCR.p2.zuzycie}}</span></p></div></div></div></div></div></div></div><div ng-repeat-start=\"lokalizacja in vmLicencje.lokalizacje | orderBy: \'NrLok\'\" class=\"clearfix\"></div><div class=\"box23\" ng-if=\"vmLicencje.subUser.IdLok==lokalizacja.IdLok || vmLicencje.security.jestSubUserem() == false\"><h3 ng-bind=\"lokalizacja.NazwaLok\"></h3><div class=\"pagination\" style=\"margin-bottom:10px;\"><a class=\"prevyear\" ng-href=\"{{vmLicencje.pobierzPlikLicencji(lokalizacja.IdLok)}}\">Pobierz plik licencji<br><span>Data utw. {{lokalizacja.DataGen | date : \"dd.MM.yyyy\"}}</span></a><div class=\"clearfix\"></div></div><a style=\"float:right;\" ng-if=\"vmLicencje.instrukcjaAktualizacji != \'undefined\' && vmLicencje.instrukcjaAktualizacji !== null\" ng-click=\"vmLicencje.pobierzInstrukcjeAktualizacji()\">Instrukcja aktualizacji</a></div><h4 ng-if=\"vmLicencje.subUser.IdLok==lokalizacja.IdLok || vmLicencje.security.jestSubUserem()==false\">Zainstalowana wersja: {{(lokalizacja.aktualnaWersja)?lokalizacja.aktualnaWersja:\'nieznana\'}}</h4><h4 ng-if=\"vmLicencje.subUser.IdLok==lokalizacja.IdLok || vmLicencje.security.jestSubUserem()==false\">Posiadane moduły</h4><table class=\"minetable\" style=\"border:1px solid lightgrey;margin-top: 20px;\" ng-if=\"vmLicencje.subUser.IdLok==lokalizacja.IdLok || vmLicencje.security.jestSubUserem() == false\"><tr style=\"padding-top: 15px;border-bottom:2px solid lightgrey;height: 40px;\"><td style=\"padding-top: 15px;text-align: center;padding-left:0;width:450px;\">Nazwa</td><td style=\"width:100px;padding-left:0;text-align: center;padding-top: 15px;\">Wersja</td></tr><tr class=\"main\" ng-repeat-start=\"element in vmLicencje.licencjeLokalizacji[vmLicencje.lokalizacje.indexOf(lokalizacja)]\" style=\"{{(vmLicencje.selectedId == element.id_sys_lok)?\'background-color: #DFF0D8!important;\':\'\'}}\"><td ng-click=\"vmLicencje.checkClick(element.id_sys_lok)\" style=\"padding-top: 10px;text-align: center;padding-left:0;\">{{element.Nazwa}}</td><td ng-click=\"vmLicencje.checkClick(element.id_sys_lok)\" style=\"padding-top: 10px;text-align: center;padding-left:0;\">{{((element.Wersja ? element.Wersja / 10000 : \' \') | number:2)+ \" \" + (element.UpdPack!=null?element.UpdPack:\'\')}}</td></tr><tr ng-repeat-end=\"\" ng-if=\"vmLicencje.selectedId == element.id_sys_lok\" style=\"background-color: #F5F5F5;\"><td colspan=\"6\" style=\"min-height:100px!important;padding-bottom: 10px!important;\"><p style=\"padding-top: 10px;\"><span>Kod aktywacyjny: &nbsp;&nbsp;</span><span ng-bind=\"element.AktywKod\"></span></p><div class=\"{{vmLicencje.bootstrapKlasa}}\"><button style=\"float: right;margin-top:-25px;display: inline-block; margin-right: 35px;\" class=\"btn btn-primary btn-sm\" title=\"Kopiuj\" ngclipboard=\"\" data-clipboard-text=\"{{element.AktywKod}}\"><span>Kopiuj</span></button></div><p ng-repeat=\"ograniczenie in vmLicencje.ograniczenia\" ng-if=\"ograniczenie.Ograniczenie>0\">{{ograniczenie.Nazwa}}: {{ograniczenie.Ograniczenie}}<br></p><br><br><a ng-show=\"element.CertAuth===1\" target=\"_blank\" ng-href=\"{{vmLicencje.pobierzCertyfikatAuth(element.id_sys_lok,lokalizacja.IdLok)}}\"><img src=\"assets/images/iconPDF.gif\" border=\"0\" alt=\"\"> <strong>Certyfikat autentyczności</strong></a> <a ng-show=\"element.CertProd===1\" target=\"_blank\" ng-href=\"{{vmLicencje.pobierzCertyfikatProd(element.id_sys_lok)}}\"><img src=\"assets/images/iconPDF.gif\" border=\"0\" alt=\"\"> <strong>Certyfikat produktu</strong></a></td></tr></table><p style=\"padding-top: 10px;\" ng-repeat-end=\"\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> <span style=\"color: crimson;\">Kod aktywacyjny</span> można pobrać po kliknięciu na wiersz tabeli z modułem</p><div class=\"clearfix\"></div></div></div></div></div>");
$templateCache.put("app/home/twojeKonto/konto.licencje.opcjeEK.html","<div class=\"row\"><div class=\"col-md-12\"><h3><img src=\"../../assets/images/ek34.png\" alt=\"logo e-kartoteki\" width=\"15px\"> Opcje podstawowe e-kartoteki</h3></div><div><div ng-repeat=\"opcja in vmLicencje.opcjeEkLista | orderBy:\'Nazwa\'\" ng-if=\"opcja.Opcja === \'P\' && opcja.UdzProc === null\"><opcja-ekiem label=\"opcja.Nazwa\" id=\"opcja.IdGrupy\" zaznaczenie=\"true\" disabled=\"true\"></opcja-ekiem></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h3><img src=\"../../assets/images/ek34.png\" alt=\"logo e-kartoteki\" width=\"15px\"> Opcje dodatkowe e-kartoteki</h3></div><div ng-repeat=\"opcja in vmLicencje.opcjeEkLista | orderBy:\'Nazwa\'\"><opcja-ekiem ng-if=\"opcja.Opcja === \'D\' && opcja.UdzProc !== null\" label=\"opcja.Nazwa\" id=\"opcja.IdGrupy\" zaznaczenie=\"opcja.posiadana\" disabled=\"true\"></opcja-ekiem><div style=\"padding-left: 15px\" ng-if=\"opcja.IdGrupy === 13 && opcja.posiadana === true\"><div><input type=\"radio\" ng-model=\"vmLicencje.gromadzenieDanychKsiegowych\" ng-value=\"3\" ng-checked=\"3\" id=\"gromadzenie_danych_trzy\" disabled=\"\"> <label class=\"checkboxlabel\" for=\"gromadzenie_danych_trzy\">Dane z 3 lat</label></div><div><input type=\"radio\" ng-model=\"vmLicencje.gromadzenieDanychKsiegowych\" ng-value=\"5\" ng-checked=\"5\" id=\"gromadzenie_danych_piec\" disabled=\"\"> <label class=\"checkboxlabel\" for=\"gromadzenie_danych_piec\">Dane z 5 lat</label></div><div><input type=\"radio\" ng-model=\"vmLicencje.gromadzenieDanychKsiegowych\" ng-value=\"\'bez ograniczeń\'\" ng-checked=\"\'bez ograniczeń\'\" id=\"gromadzenie_danych_bo\" disabled=\"\"> <label class=\"checkboxlabel\" for=\"gromadzenie_danych_bo\">Bez ograniczeń</label></div></div></div></div>");
$templateCache.put("app/home/twojeKonto/konto.licencje.opcjeEM.html","<div class=\"row\"><div class=\"col-md-12\"><h3><img src=\"../../assets/images/emieszczanin/emi.png\" alt=\"logo systemu e-Mieszczanin\" width=\"15px\"> Opcje podstawowe systemu e-Mieszczanin</h3></div><div ng-repeat=\"opcja in vmLicencje.opcjeEmLista | orderBy:\'Nazwa\'\" ng-if=\"opcja.Opcja === \'P\' && opcja.UdzProc === null\"><opcja-ekiem label=\"opcja.Nazwa\" id=\"opcja.IdGrupy\" zaznaczenie=\"true\" disabled=\"true\"></opcja-ekiem></div></div><div class=\"row\"><div class=\"col-md-12\"><h3><img src=\"../../assets/images/emieszczanin/emi.png\" alt=\"logo systemu e-Mieszczanin\" width=\"15px\"> Opcje dodatkowe systemu e-Mieszczanin</h3></div><div ng-repeat=\"opcja in vmLicencje.opcjeEmLista | orderBy:\'Nazwa\'\"><opcja-ekiem ng-if=\"opcja.Opcja === \'D\' && opcja.UdzProc !== null\" label=\"opcja.Nazwa\" id=\"opcja.IdGrupy\" zaznaczenie=\"opcja.posiadana\" disabled=\"true\"></opcja-ekiem></div></div>");
$templateCache.put("app/home/twojeKonto/konto.lokalizacje.html","<div style=\"min-height: 400px;\"><div class=\"pane23\"><div class=\"clearfix\"></div><div class=\"box23\"></div><div class=\"clearfix\"></div><div class=\"box23\"><h3>Lokalizacja główna</h3><a class=\"boxed-link\" ui-sref=\"home.subMain.oNas.naszaKadra\">Dodaj</a> <a class=\"boxed-link\" ui-sref=\"home.subMain.oNas.naszaKadra\">Edytuj</a> <a class=\"boxed-link\" ui-sref=\"home.subMain.oNas.naszaKadra\">Usuń</a></div><div class=\"box23\" ng-init=\"TwojeKontoController.init()\" style=\"padding-bottom: 50px;\"><table style=\"width:100%;border:1px solid grey;\"><tr><td style=\"width:15%;text-align:center;white-space: nowrap;padding:15px;\"><b>Nazwa</b></td><td style=\"width:15%;white-space: nowrap;text-align:center;padding:15px;\"><b>Imię</b></td><td style=\"width:15%;white-space: nowrap;padding:15px;\"><b>Nazwisko</b></td><td style=\"width:20%;white-space: nowrap;text-align:center;padding:15px;\"><b>e-mail</b></td><td style=\"width:20%;white-space: nowrap;text-align:center;padding:15px;\"><b>Typ</b></td><td style=\"width:15%;white-space: nowrap;text-align:center;padding:15px;\"><b>Status</b></td></tr><tr ng-repeat=\"dana in popupEdytorCtrl.dane | orderBy:\'id\'\"><td style=\"{{\'width:5%;text-align:center;white-space: nowrap;\'+\'padding:20px;\'+(((popupEdytorCtrl.dane.indexOf(dana)%2==0))?\'background-color:#E6EBED\':\'\')}}\">{{dana.id}}</td><td ng-bind-html=\"popupEdytorCtrl.deliberatelyTrustDangerousSnippetNaglowek(dana)\" style=\"{{\'width:30%\'+\'white-space: nowrap\'+\'text-align:center\'+\'white-space: nowrap;\'+\'padding:20px;\'+(((popupEdytorCtrl.dane.indexOf(dana)%2==0))?\'background-color:#E6EBED\':\'\')}}\">{{dana.naglowek}}</td><td ng-bind-html=\"popupEdytorCtrl.deliberatelyTrustDangerousSnippetTresc(dana)\" style=\"{{\'width:50%\'+\'white-space: nowrap;\'+\'padding:20px;\'+(((popupEdytorCtrl.dane.indexOf(dana)%2==0))?\'background-color:#E6EBED\':\'\')}}\">{{dana.tresc}}</td><td style=\"{{\'width:5%;text-align:center;white-space: nowrap;\'+\'padding:15px;\'+(((popupEdytorCtrl.dane.indexOf(dana)%2==0))?\'background-color:#E6EBED\':\'\')}}\">{{dana.data_start}}</td><td style=\"{{\'width:5%;white-space: nowrap;text-align:center;padding:15px;\'+(((popupEdytorCtrl.dane.indexOf(dana)%2==0))?\'background-color:#E6EBED\':\'\')}}\">{{dana.data_koniec}}</td><td style=\"{{\'width:5%;white-space: nowrap;text-align:center;padding:15px;\'+(((popupEdytorCtrl.dane.indexOf(dana)%2==0))?\'background-color:#E6EBED\':\'\')}}\"><div><a class=\"boxed-link\" ui-sref=\"home.subMain.popupEdytor.popupEdycja\">Edytuj <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></a></div></td></tr></table></div><div class=\"clearfix\"></div><div class=\"box23\"><div class=\"clientpulpit\" ng-controller=\"TwojeKontoController\" style=\"z-index:0;\"><span class=\"tabname activetab\" ng-click=\"vmKonto.przelaczPierwsza()\">Informacje</span> <span class=\"tabname activetab\" ng-click=\"vmKonto.przelaczDruga()\">Uprawnienia</span><form class=\"konsultant\" name=\"danePracownika\"><div ng-show=\"vmKonto.prw\"><label>Nazwa</label> <input type=\"text\" name=\"nazwa\"> <label>Imię</label> <input type=\"text\" name=\"imie\"> <label>Nazwisko</label> <input type=\"text\" name=\"nazwisko\"> <label>e-mail</label> <input type=\"text\" name=\"email\"> <label>Typ</label> <input type=\"text\" name=\"typ\"> <label>Status</label> <input type=\"text\" name=\"status\"> <label>Hasło</label> <input type=\"text\" name=\"haslo\"> <label>Powtórz hasło</label> <input type=\"text\" name=\"powtorzhaslo\"></div><div ng-show=\"vmKonto.dr\"><b><label>Nazwa</label> <label>Dostęp</label></b><br><label>Informacje o licencjach</label> <input style=\"float: inherit;\" type=\"checkbox\" name=\"uprawnienia[]\" value=\"licencjeInfo\" ng-model=\"vmKonto.lista[0].val\"><br><label>Zmiana licencji</label> <input style=\"float: inherit;\" type=\"checkbox\" name=\"uprawnienia[]\" value=\"zmianaLicencji\" ng-model=\"vmKonto.lista[1].val\"><br><label>Pobieranie płyty</label> <input style=\"float: inherit;\" type=\"checkbox\" name=\"uprawnienia[]\" value=\"pobieraniePlyty\" ng-model=\"vmKonto.lista[2].val\"><br><label>Dostęp do konsultacji</label> <input style=\"float: inherit;\" type=\"checkbox\" name=\"uprawnienia[]\" value=\"konsultacjeDostep\" ng-model=\"vmKonto.lista[3].val\"></div></form></div></div><div class=\"clearfix\"></div></div><div class=\"pane13\"><div class=\"box13\"><div align=\"right\"><textarea name=\"komentarz\" style=\"padding: 10px; alignment: right\" cols=\"45\" rows=\"10\"></textarea><br><br><a class=\"boxed-link\" ui-sref=\"home.subMain.oNas.naszaKadra\">Importuj konta pracowników z e-kartoteki</a></div></div></div></div>");
$templateCache.put("app/home/twojeKonto/konto.pobierzPlyte.html","<div class=\"panefull\" style=\"min-height: 400px;\" ng-init=\"vmCD.init()\"><div ng-if=\"vmCD.plyta.link!==\'\'\"><h3>Pobierz obraz płyty</h3><div><p><div class=\"icon downloadicon lefticon\"></div><a ng-href=\"{{vmCD.urlPlyty}}\" class=\"intext\">Pobierz plik ISO</a> <span>- Możesz bezpłatnie pobrać obraz płyty w formacie ISO.</span></p></div></div><div ng-if=\"vmCD.plyta.link===\'\'\"><h3>Aktualizacja</h3><obsluga-bledow wiadomosci-tablica=\"vmCD.odpowiedziSerwera\"></obsluga-bledow><p>Szanowni Państwo,<br><br>niestety nie przysługuje Państwu bezpłatna aktualizacja naszego oprogramowania. Prosimy o kontakt z Działem Handlowym w celu zamówienia nowych wersji.</p><div style=\"width: 100%; margin-top: 20px;\" type=\"submit\" class=\"bootstrap-iso-paper\"><button style=\"margin-left: 340px;\" ng-click=\"vmCD.pokazZamowPlyte=!vmCD.pokazZamowPlyte;\" class=\"btn btn-default\">zapytaj o ofertę aktualizacji</button></div><div ng-if=\"vmCD.pokazZamowPlyte==true\" style=\"display: block\" class=\"rollpane\"><form name=\"CDFormZam\" class=\"update\"><label for=\"zamimieinazwisko\">Imię i Nazwisko</label> <input name=\"zamimieinazwisko\" id=\"zamimieinazwisko\" ng-model=\"vmCD.pola.osDoKontaktuNazwa\" required=\"\" type=\"text\"><br><label>Nr. telefonu</label> <input name=\"telefon\" required=\"\" ng-model=\"vmCD.pola.osDoKontaktuTelefon\" type=\"text\"><br><label>E-mail</label> <input name=\"E-mail\" required=\"\" ng-model=\"vmCD.pola.osDoKontaktuEmail\" type=\"text\"><br><label>Treść</label> <textarea name=\"uwagi\" ng-init=\"newZgl.tresc=\'Proszę o kontakt w sprawie oferty aktualizacji.\'\" ng-model=\"vmCD.pola.opis\" cols=\"30\" rows=\"5\"></textarea><br><div class=\"clearfix\"></div><div style=\"width: 960px;display: block;text-align: left;\"><input type=\"Button\" ng-disabled=\"CDFormZam.$invalid\" ng-click=\"vmCD.wyslij()\" class=\"btn-send\"></div></form></div></div><div ng-if=\"vmCD.plyta.link!==\'\'\"><h3>Aktualizacja</h3><p>Jeśli posiadasz już płytę DVD lub obraz płyty możesz przystąpić do aktualizacji swojego oprogramowania.</p><p>Aby dokonać aktualizacji należy:</p><ul><li>Skontaktować się z działem handlowym w celu wygenerowania pliku licencyjnego (będzie on niezbędny przy instalacji nowej wersji).<br><div><p><a ui-sref=\"home.subMain.generowanie_licencji\" class=\"intext\">Prośba o wygenerowanie licencji.</a></p></div></li><li>Postępując zgodnie z informacjami zawartymi w <a class=\"intext\" ng-click=\"vmCD.pobierzInstrukcjeAktualizacji()\">instrukcji aktualizacji</a> zaktualizować programy.</li><li>W strefie klienta w dziale <a ui-sref=\"home.subMain.licencje\"><b>Licencje</b></a> odczytać <b>kod aktywacyjny</b>.</li><li>Aktywować programy za pomocą kodu aktywacyjnego.</li></ul><br></div></div>");
$templateCache.put("app/home/twojeKonto/konto.uslugiPasywne.html","<div ng-init=\"vmUP.init()\"><div ng-if=\"vmUP.security.jestSubUserem() == false\"><div class=\"content\"><div class=\"pane23\"><h2>Usługi pasywne</h2><div><h3 style=\"z-index: 200!important;\">Limity</h3><ul style=\"width: 50%; display: inline-block\"><li><b>{{vmUP.informacje.przestrzen}}GB</b> przestrzeni dyskowej</li><li><b>{{vmUP.informacje.transfer}}GB</b> transferu miesięcznie</li></ul></div><div></div><div><h3>informacje dostępowe</h3><ul><li>adres usługi: <b><a href=\"ftps://backup.mieszczanin.pl\">ftps://backup.mieszczanin.pl</a></b></li><li>login: <b>{{vmUP.uzytkownik.userid}}</b></li></ul><div class=\"{{vmUP.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"vmUP.zmienHaslo()\">Zmień Hasło</button></div></div></div></div><div class=\"pane13\"><div class=\"boxT\"><table><tr><td><a class=\"fa fa-file-pdf-o\" href=\"/assets/files/Regulamin%20uslug%20pasywnych.pdf\" style=\"padding-right: 10px; font-size: large\"></a></td><td><p><a href=\"/assets/files/Regulamin%20uslug%20pasywnych.pdf\">Regulamin usług pasywnych</a></p></td></tr></table></div><div google-chart=\"\" chart=\"vmUP.myChartObject\" ng-if=\"vmUP.informacje.przestrzen!==\'undefined\' && vmUP.informacje.przestrzen!==null\" style=\"height:300px; width:300px; margin:0 auto; margin-top: 50px;\"></div></div></div></div>");
$templateCache.put("app/home/twojeKonto/konto.ustawieniaMailingu.html","ustawienia mailngu");
$templateCache.put("app/home/twojeKonto/konto.wykazKonsultacji.html","<div ng-init=\"konsultacje_wykaz.init();start=false;koniec=false;\"><div class=\"panefull\" style=\"padding-top: 20px;\" ng-if=\"konsultacje_wykaz.dozwoloneLok.length>0 || konsultacje_wykaz.security.jestSubUserem() == false\"><div class=\"bootstrap-iso-paper\"><p class=\"input-group\"><label for=\"dataStart\" style=\"float: left;width: 10px;\">Od</label> <input id=\"dataStart\" class=\"form-control\" style=\"width: 250px;\" type=\"date\" ng-model=\"konsultacje_wykaz.dataStart\"></p></div><div class=\"bootstrap-iso-paper\"><p class=\"input-group\"><label for=\"dataKoniec\" style=\"float: left;width: 10px;\">Do</label> <input id=\"dataKoniec\" class=\"form-control\" style=\"width: 250px;\" type=\"date\" ng-model=\"konsultacje_wykaz.dataKoniec\"></p></div><div class=\"bootstrap-iso-paper\" ng-if=\"konsultacje_wykaz.opcje.length>1\"><label style=\"float: left;width: 50px;\">Rodzaj</label><div class=\"btn-group\" uib-dropdown=\"\" is-open=\"false\" style=\"margin: 0;\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\">{{konsultacje_wykaz.selectedRodzaj}} <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\"><a href=\"\" ng-click=\"konsultacje_wykaz.selectedRodzaj = \'Wszystkie\'\">Wszystkie</a></li><li role=\"menuitem\" ng-repeat=\"element in konsultacje_wykaz.opcje\"><a href=\"\" ng-click=\"konsultacje_wykaz.selectedRodzaj = element\">{{element}}</a></li></ul></div></div><div><button class=\"btn-send\" ng-click=\"konsultacje_wykaz.reloadKonsultacje();start=false;koniec=false;\" value=\"\"></button></div><div ng-repeat=\"lokalizacja in konsultacje_wykaz.lokalizacje | orderBy: \'NrLok\'\" ng-if=\"konsultacje_wykaz.dozwoloneLok.indexOf(lokalizacja.IdLok)>-1 || konsultacje_wykaz.security.jestSubUserem()==false\"><div ng-repeat=\"daneDlaLokalizacji in konsultacje_wykaz.visibleDane\" ng-if=\"lokalizacja.IdLok==daneDlaLokalizacji.id_lok\"><h3>{{lokalizacja.NazwaLok}}</h3><table class=\"minetable\" style=\"border:1px solid lightgrey;margin-top: 20px;width: 100%;\"><tr style=\"padding-top: 15px;border-bottom:2px solid lightgrey;height: 40px;\"><td style=\"width:20%; padding-top: 15px;text-align: center;padding-left:0;\">Pracownik</td><td style=\"width:20%;padding-left:0;text-align: center;padding-top: 15px;\">Konsultant</td><td style=\"width:10%;padding-left:0;text-align: center;padding-top: 15px;\">Moduł</td><td style=\"width:20%;padding-left:0;text-align: center;padding-top: 15px;\">Rodzaj</td><td style=\"width:15%;padding-left:0;text-align: center;padding-top: 15px;\">Rozpoczęcie</td><td style=\"width:15%;padding-left:0;text-align: center;padding-top: 15px;\">Czas trwania</td></tr><tr class=\"main\" ng-repeat-start=\"element in daneDlaLokalizacji.kon.slice( (konsultacje_wykaz.currTab[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)]-1)*10, (konsultacje_wykaz.currTab[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)])*10)\" style=\"{{(element.vis)?\'background-color: #DFF0D8!important;\':\'\'}}\"><td ng-click=\"konsultacje_wykaz.checkClick(element,lokalizacja.IdLok)\" style=\"padding-top: 15px;text-align: center;padding-left:0;\" class=\"bootstrap-iso-paper\"><span ng-if=\"element.konsultacja_archiwalna == false || element.konsultacja_archiwalna == null\">{{element.pracownik}}</span> <span ng-if=\"element.konsultacja_archiwalna == true\" class=\"label label-default\">Konsultacja archiwalna</span></td><td ng-click=\"konsultacje_wykaz.checkClick(element,lokalizacja.IdLok)\" style=\"padding-top: 10px;text-align: center;padding-left:0;\">{{element.konsultant}}</td><td ng-click=\"konsultacje_wykaz.checkClick(element,lokalizacja.IdLok)\" style=\"padding-top: 10px;text-align: center;padding-left:0;\"><div ng-if=\"konsultacje_wykaz.systemy[element.system]\" style=\"margin-left: 10px;margin-bottom: -5px;margin-top: 5px\" class=\"{{konsultacje_wykaz.systemy[element.system].letter + \' letter-icon tooltip\'}}\" tooltips=\"\" tooltip-side=\"right\" tooltip-template=\"{{konsultacje_wykaz.systemy[element.system].nazwa}}\"></div></td><td ng-click=\"konsultacje_wykaz.checkClick(element,lokalizacja.IdLok)\" style=\"padding-top: 10px;text-align: center;padding-left:0;\">{{element.rodzaj_konsultacji}}</td><td ng-click=\"konsultacje_wykaz.checkClick(element,lokalizacja.IdLok)\" style=\"padding-bottom:5px;text-align: center;padding-left:0;\"><span style=\"margin-top: -10px;\">{{element.DataWpis | date: \'dd.MM.yyyy\'}} {{element.PoradaStart.substr(0,5)}}</span></td><td ng-click=\"konsultacje_wykaz.checkClick(element,lokalizacja.IdLok)\" style=\"text-align: center;padding-left:0;\"><span style=\"{{(element.status.indexOf(\'Aktywny\')!==-1)?\'\':\'color:red;\'}}\">{{(element.czas_trwania)}} min.</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"konsultacje_wykaz.selected == element\" style=\"background-color: #F5F5F5;\"><td colspan=\"6\"><p style=\"padding-left: 20px;min-height: 60px;padding-top: 10px;margin-right: 30px;text-align: left;\"><span style=\"float: right; margin-left: 30px;\">Jednostki umowy serwisowej: &nbsp;&nbsp;{{element.JednUmSerw}}</span> <span>Temat: {{element.Temat}}</span></p><p style=\"text-align: center; padding: 0 0 40px;\" ng-if=\"element.konsultacja_archiwalna == true\"><span><b>Konsultacja archiwalna</b></span></p><p style=\"padding-left: 20px;min-height: 60px;padding-top: 10px;margin-right: -50px;margin-bottom: 20px; max-width:900px;text-align: left;\" ng-if=\"element.konsultacja_archiwalna == false || element.konsultacja_archiwalna == null\" ng-bind-html=\'element.TrescMail .replace(element.TrescMail.match(\"<DIV class=footer>(.*)</DIV>\")[0],\"\") .replace(element.TrescMail.match(\"<div class=\\\"footer\\\">(.*)</div>\")[0],\"\") .replace(element.TrescMail.match(\"<DIV class=header>(.*)</DIV>\")[0],\"\") .replace(element.TrescMail.match(\"<TD height=120>(.*)</TD>\")[0],\"\") .replace(element.TrescMail.match(\"Niniejsza(.*).\")[0],\"\") .replace(element.TrescMail.match(\"<P class=text-stopka>(.*)</P>\")[0],\"\") .replace(element.TrescMail.match(\"<BR>(.*)</DIV>\")[0],\"\") .replace(element.TrescMail.match(\"Pozdrawiam(.*),\")[0],\"\") .replace(element.TrescMail.match(\"M.INFORMATYKA(.*)Sp. k.\")[0],\"\") .replace(element.TrescMail.match(\"Łączymy wyrazy szacunku(.*),\")[0],\"\") .substr(0, (element.TrescMail.indexOf(\"<DIV class=stopka>\")!=-1)?element.TrescMail.indexOf(\"<DIV class=stopka>\")-198:element.TrescMail.length)\'></p></td></tr></table><p style=\"float:right; margin-top: 5px;\" ng-repeat=\"jkju in konsultacje_wykaz.jkju\" ng-if=\"jkju.id_lok==lokalizacja.IdLok && jkju.zakladka == konsultacje_wykaz.currTab[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)]-1\"></p><div class=\"bootstrap-iso-paper\"><ul class=\"pagination ng-table-pagination\"><li class=\"{{(konsultacje_wykaz.currTab[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)] <=1)?\'disabled ng-scope\':\'\'}}\"><a ng-click=\"konsultacje_wykaz.prev(konsultacje_wykaz.lokalizacje.indexOf(lokalizacja))\" style=\"padding: 5px 10px;font-size: 12px;line-height: 1.5;\" href=\"\" class=\"ng-scope\">«</a></li><li ng-if=\"konsultacje_wykaz.paginatorBreaker[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)]>0\"><a ng-click=\"konsultacje_wykaz.prevGroup(konsultacje_wykaz.lokalizacje.indexOf(lokalizacja))\" style=\"padding: 5px 10px;font-size: 12px;line-height: 1.5;\" href=\"\" class=\"ng-scope\">...</a></li><li ng-repeat=\"tab in konsultacje_wykaz.allTabs[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)].tab .slice( konsultacje_wykaz.paginatorBreaker[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)]*10, (konsultacje_wykaz.paginatorBreaker[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)]*10)+10)\" class=\"{{(konsultacje_wykaz.currTab[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)] == tab)?\'active ng-scope\':\'\'}}\"><a ng-click=\"(konsultacje_wykaz.currTab[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)] = tab)\" style=\"padding: 5px 10px;font-size: 12px;line-height: 1.5;\" href=\"\" class=\"ng-scope\"><span class=\"ng-scope\">{{tab}}</span></a></li><li ng-if=\"konsultacje_wykaz.paginatorBreaker[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)]< (konsultacje_wykaz.allTabs[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)].tab.length/10 )-1\"><a ng-click=\"konsultacje_wykaz.nextGroup(konsultacje_wykaz.lokalizacje.indexOf(lokalizacja))\" style=\"padding: 5px 10px;font-size: 12px;line-height: 1.5;\" href=\"\" class=\"ng-scope\">...</a></li><li class=\"{{(konsultacje_wykaz.currTab[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)] >= konsultacje_wykaz.allTabs[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)].tab[konsultacje_wykaz.allTabs[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)].tab.length -1 ] || konsultacje_wykaz.allTabs[konsultacje_wykaz.lokalizacje.indexOf(lokalizacja)].tab.length == 0)?\'disabled ng-scope\':\'\'}}\"><a ng-click=\"konsultacje_wykaz.next(konsultacje_wykaz.lokalizacje.indexOf(lokalizacja))\" style=\"padding: 5px 10px;font-size: 12px;line-height: 1.5;\" href=\"\" class=\"ng-scope\">»</a></li></ul></div></div></div><br></div></div>");
$templateCache.put("app/home/twojeKonto/player.html","<style>\n    html, body {\n        margin: 0;\n        padding: 0;\n    }\n\n    .videogular-container {\n        width: 100%;\n        height: 600px;\n        margin: 0 auto;\n        overflow: hidden;\n    }\n\n</style><div class=\"content\" style=\"padding-top: 20px;\"><div class=\"videogular-container\"><videogular vg-theme=\"vmPlayer.config.theme.url\"><vg-media vg-src=\"vmPlayer.config.sources\" vg-tracks=\"vmPlayer.config.tracks\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"2000\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play></videogular></div></div>");
$templateCache.put("app/home/twojeKonto/profil.html","<div style=\"width: 50%;margin:0; float: left\"><h2>Profil użytkownika</h2></div><div class=\"boxT\" style=\"float: right; margin-top: 30px\" ng-if=\"vmProfil.uzytkownikForm.Ident !== null\"><p>Użytkownik automatyczny nie posiada możliwości zmiany hasła.</p></div><div style=\"float: left\"><obsluga-bledow wiadomosci-tablica=\"vmProfil.odpowiedziSerwera\"></obsluga-bledow><h4 ng-if=\"vmProfil.przekierowanie_dodaj !== null || vmProfil.przekierowanie_zobacz !== null\">Uzupełnij informacje o sobie, abyśmy wiedzieli, z kim się kontaktować</h4><form name=\"userForm\" style=\"padding: 20px; margin: 0 auto; width: 600px;\" novalidate=\"\"><div class=\"{{vmProfil.bootstrapKlasa + \' form-group row\'}}\" style=\"border-bottom:1px solid lightgrey;\"><label>Login:</label><div style=\"display: inline-block;\"><p>{{vmProfil.uzytkownikForm.nazwa}}</p></div></div><div class=\"{{vmProfil.bootstrapKlasa + \' form-group row\'}}\" style=\"border-bottom:1px solid lightgrey;\"><label>Imię:</label><div ng-if=\"!vmProfil.edycja\" style=\"display: inline-block;\"><p>{{vmProfil.uzytkownikForm.imie}}</p></div><div ng-if=\"vmProfil.edycja\" style=\"display: inline-block;\"><input class=\"form-control\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"imie\" ng-model=\"vmProfil.uzytkownikForm.imie\"></div></div><div class=\"{{vmProfil.bootstrapKlasa + \' form-group row\'}}\" style=\"border-bottom:1px solid lightgrey;\"><label>Nazwisko:</label><div ng-if=\"!vmProfil.edycja\" style=\"display: inline-block;\"><p>{{vmProfil.uzytkownikForm.nazwisko}}</p></div><div ng-if=\"vmProfil.edycja\" style=\"display: inline-block;\"><input class=\"form-control\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"nazwisko\" ng-model=\"vmProfil.uzytkownikForm.nazwisko\"></div></div><div class=\"{{vmProfil.bootstrapKlasa + \' form-group row\'}}\" style=\"border-bottom:1px solid lightgrey;\"><label>Płeć:</label><div ng-if=\"!vmProfil.edycja\" style=\"display: inline-block;\"><p ng-if=\"vmProfil.uzytkownikForm.CzyMezczyzna==1\">Mężczyzna</p><p ng-if=\"vmProfil.uzytkownikForm.CzyMezczyzna==0\">Kobieta</p><p ng-if=\"vmProfil.uzytkownikForm.CzyMezczyzna==null\"></p></div><div ng-if=\"vmProfil.edycja\" style=\"display: inline-block;\"><select ng-model=\"vmProfil.uzytkownikForm.CzyMezczyzna\" ng-options=\"plec.value as plec.nazwa for plec in [ { nazwa: \'Kobieta\', value: 0 }, { nazwa: \'Mężczyzna\', value: 1 }, { nazwa: \'Nie chcę powiedzieć\', value: null } ]\"></select></div></div><div class=\"{{vmProfil.bootstrapKlasa + \' form-group row\'}}\" style=\"border-bottom:1px solid lightgrey;\"><label>E-mail:</label><div ng-if=\"!vmProfil.edycja\" style=\"display: inline-block;\"><p>{{vmProfil.uzytkownikForm.email}}</p></div><div ng-if=\"vmProfil.edycja\" style=\"display: inline-block;\"><input class=\"form-control\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"email\" ng-model=\"vmProfil.uzytkownikForm.email\"></div></div><div class=\"{{vmProfil.bootstrapKlasa + \' form-group row\'}}\" style=\"border-bottom:1px solid lightgrey;\"><label>Telefon:</label><div ng-if=\"!vmProfil.edycja\" style=\"display: inline-block;\"><p>{{vmProfil.uzytkownikForm.Telefon}}</p></div><div ng-if=\"vmProfil.edycja\" style=\"display: inline-block;\"><input class=\"form-control\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"Telefon\" ng-model=\"vmProfil.uzytkownikForm.Telefon\"></div></div><div class=\"{{vmProfil.bootstrapKlasa + \' form-group row\'}}\" ng-if=\"vmProfil.edycja && vmProfil.uzytkownikForm.Ident === null\"><label>Hasło</label> <input type=\"password\" class=\"form-control\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"haslo\" ng-model=\"vmProfil.uzytkownikForm.haslo\"></div><div class=\"{{vmProfil.bootstrapKlasa + \' form-group row\'}}\" ng-if=\"vmProfil.edycja && vmProfil.uzytkownikForm.Ident === null\"><label>Potwierdź hasło</label> <input type=\"password\" class=\"form-control\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"potwierdzHaslo\" ng-model=\"vmProfil.uzytkownikForm.potwierdzHaslo\"><p class=\"help-block\" ng-if=\"vmProfil.uzytkownikForm.potwierdzHaslo !== vmProfil.uzytkownikForm.haslo\">Hasła muszą być identyczne</p></div><div style=\"margin: 50px 0;\" class=\"{{vmProfil.bootstrapKlasa}}\" ng-show=\"!vmProfil.edycja\"><button class=\"btn btn-default\" ng-click=\"vmProfil.edycja = true;\"><span class=\"glyphicon glyphicon-pencil\"></span>Edytuj</button></div><div style=\"margin: 50px 0;\" class=\"{{vmProfil.bootstrapKlasa}}\" ng-if=\"vmProfil.edycja\"><button ng-click=\"vmProfil.zapiszDane()\" class=\"btn btn-default\">Zapisz</button> <button ng-click=\"vmProfil.anuluj()\" class=\"btn btn-default\">Anuluj</button></div></form></div>");
$templateCache.put("app/home/updatepack/updatepack.html","<div class=\"panefull\"><div><div style=\"margin-left: 20px;margin-bottom: -5px;margin-top: 5px\" ng-if=\"vmUpdatepack.listOfUpdatePackages.length>0\" class=\"{{vmUpdatepack.moduly[vmUpdatepack.listOfUpdatePackages[0].Kod].letter + \' letter-small\'}}\"></div><h2><span ng-if=\"vmUpdatepack.listOfUpdatePackages.length>0\">{{vmUpdatepack.moduly[vmUpdatepack.listOfUpdatePackages[0].Kod].nazwa}}</span> <span ng-if=\"vmUpdatepack.listOfUpdatePackages.length==0 && vmUpdatepack.qs[\'modul\']!=undefined && vmUpdatepack.qs[\'wer\']!=undefined\">Brak informacji o podanym module/wersji</span></h2><div ng-repeat=\"update in vmUpdatepack.listOfUpdatePackages | orderBy: \'-Data\'\" ng-if=\"vmUpdatepack.listOfUpdatePackages.length > 0\"><h3>{{update.Wersja}}</h3><span style=\"float: right;\">{{update.Data | date : \'dd.MM.yyyy\'}}</span><div ng-bind-html=\"vmUpdatepack.trustAsHTML(update.Tekst)\"></div></div><div ng-if=\"vmUpdatepack.none==true\"><h2>{{vmUpdatepack.error}}</h2></div></div></div>");
$templateCache.put("app/home/wol/wol.html","<div ng-if=\"vmWOL.security.jestPracownikiemMieszczanin()==true\"><h2>Wake on Lan</h2><obsluga-bledow wiadomosci-tablica=\"vmWOL.serverResponse\"></obsluga-bledow><div style=\"display: inline-block\"><table style=\"border: 2px solid #f0f0f0; min-width: 500px;\"><tr><th colspan=\"2\" style=\"padding: 10px;\"><b>Wybierz komputer</b></th></tr><tr style=\"text-align: center;\" ng-repeat=\"pc in vmWOL.pcs\"><td style=\"{{((vmWOL.selectedPc==pc.MacAddress) ? \'background-color:#DFF0D8;\' : \'\') + \'border: 1px solid #f0f0f0; padding: 10px; width: 50%;\'}}\" ng-if=\"vmWOL.pcs.indexOf(pc)%2==0\" ng-click=\"vmWOL.selectedPc=pc.MacAddress\"><span><a href=\"\">{{pc.Prac}}</a></span></td><td style=\"{{((vmWOL.selectedPc==vmWOL.pcs[vmWOL.pcs.indexOf(pc)+1].MacAddress)?\'background-color:#DFF0D8;\':\'\') + \'border: 1px solid #f0f0f0; padding: 10px; width: 50%;\'}}\" ng-if=\"vmWOL.pcs.indexOf(pc)%2==0\" ng-click=\"vmWOL.pcs[vmWOL.pcs.indexOf(pc)+1] != null ? vmWOL.selectedPc=vmWOL.pcs[vmWOL.pcs.indexOf(pc)+1].MacAddress : \'\'\"><span><a href=\"\">{{vmWOL.pcs[vmWOL.pcs.indexOf(pc)+1].Prac}}</a></span></td></tr></table><div><label style=\"display: inline-block;max-width: 110px;margin: 0\" for=\"mac2\">Inny adres MAC:</label> <input style=\"display: inline-block;max-width: 180px; margin-left: 10px;\" max=\"\" name=\"mac2\" id=\"mac2\" type=\"text\" class=\"form-control\" ng-model=\"vmWOL.differentMac\" ng-focus=\"vmWOL.selectedPc=\'\'\" placeholder=\"00:0A:E6:3E:FD:E1\"></div><div style=\"float:left;display: inline-block; margin-top: 30px;margin-bottom: 50px;\"><a class=\"boxed-link\" ng-click=\"vmWOL.wyslijWOL()\" style=\"padding: 10px 20px;font-size: 15px;\"><b>Obudź komputer</b> <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></a></div></div><div style=\"display:inline-block;float:right;\"><a class=\"boxed-link\" ng-click=\"vmWOL.allowAddPc()\" style=\"\">Dodaj komputer <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></a></div><div style=\"float:right;margin-top: 40px;display:inline-block;\" ng-if=\"vmWOL.addPc==true\"><form name=\"newPc\"><div style=\"max-width: 350px;display: block;margin-right: -80px;\" class=\"form-group\" ng-class=\"{\'has-error\' : newPc.nazwaprac.$touched && newPc.nazwaprac.$invalid}\"><label style=\"display: inline-block;max-width: 50px;\" for=\"nazwaprac\">Pracownik</label> <input style=\"display: inline-block;max-width: 180px; margin-left: 50px;\" max=\"\" name=\"nazwaprac\" id=\"nazwaprac\" type=\"text\" class=\"form-control\" pattern=\"[A-Z]{3}\" ng-model=\"vmWOL.addPc_Worker\" placeholder=\"AAA\" required=\"\"></div><div style=\"max-width: 350px;display: block;margin-right: -80px;\" class=\"form-group\" ng-class=\"{\'has-error\' : newPc.mac.$touched && newPc.mac.$invalid}\"><label style=\"display: inline-block;max-width: 80px;\" for=\"mac\">Adres MAC</label> <input style=\"display: inline-block;max-width: 180px; margin-left: 20px;\" max=\"\" name=\"mac\" id=\"mac\" type=\"text\" class=\"form-control\" pattern=\"([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})\" ng-model=\"vmWOL.addPc_MAC\" placeholder=\"00:0A:E6:3E:FD:E1\" required=\"\"></div><div style=\"float:right;display: inline-block;\" type=\"submit\"><a class=\"boxed-link\" style=\"padding: 10px 20px;font-size: 15px;\" ng-click=\"vmWOL.addPcToWOL()\"><b>Dodaj</b> <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></a></div></form></div></div>");
$templateCache.put("app/home/zapisyNaEM/zapisyNaEM.html","<div class=\"panefull\" ng-init=\"vmZapEM.init()\"><h2>Platforma e-Mieszczanin</h2><div><div class=\"bootstrap-iso-paper\"><div class=\"row\" style=\"margin-top: 40px;\"><div class=\"col-md-9\"><p style=\"line-height: 1.5;text-align: justify!important;text-justify: inter-word;font-size: 14px;\">Ponieważ wielu z Państwa zapytywało nas ostatnio o możliwości rozbudowy portalu [e-kartoteka] o <b>dwustronną komunikację elektroniczną</b> z mieszkańcami chcieliśmy przekazać więcej informacji w tym zakresie.<br><br>Od prawie dekady możliwa jest integracja portalu e-kartoteka (opcje <b>napisz wiadomość</b> oraz <b>zgłoś usterkę</b>) z naszymi modułami do Technicznej Obsługi Nieruchomości oraz <i>Zarządzania Obiegiem Dokumentów</i>. Dla tych z Państwa, którzy potrzebują narzędzi nowej generacji, pozwalających na komunikację z mieszkańcami bez konieczności nabycia licencji na dodatkowe moduły, mamy dobre wieści.<br><br>Już tej wiosny przedstawimy szerzej nasze <b>nowe rozwiązania</b> pozwalające wygodnie obsługiwać <b>elektroniczną komunikację z mieszkańcami</b>. Narzędzie to jest zintegrowane z portalem e-kartoteka a także z naszymi systemami do rozliczeń z mieszkańcami.<br><br>Z uwagi na znaczące zainteresowanie tego typu systemem wśród naszych klientów zachęcamy, by już dziś dać nam znać jeśli także Państwo chcą poznać bliżej te nowe możliwości.<br><br>Tym sposobem dostaną Państwo bardziej szczegółowe informacje o tym rozwiązaniu jeszcze przed jego oficjalnym zaprezentowaniem szerokiemu gronu naszych użytkowników.</p></div><div class=\"col-md-3 em-box\"><img src=\"./assets/images/emieszczanin/usterki.png\" style=\"margin: 0 auto; width: 92px;\"><h5>ZGŁASZANIE USTEREK</h5></div><div class=\"col-md-3\" style=\"height: 10px;\"></div><div class=\"col-md-3 em-box\"><img src=\"./assets/images/emieszczanin/wiadomosc.png\" style=\"margin: 0 auto; width: 92px;\"><h5>WIADOMOŚCI</h5></div></div></div><h3>Zapisy</h3><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-12\"><obsluga-bledow wiadomosci-tablica=\"vmZapEM.odpowiedziSerwera\"></obsluga-bledow><form name=\"zapisyEM\" novalidate=\"\"><table style=\"width: 400px;margin-top: 20px;\"><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 160px;\"><label for=\"osobakontaktowa\">Osoba kontaktowa*</label></td><td><input class=\"form-control\" id=\"osobakontaktowa\" name=\"osobakontaktowa\" style=\"width:350px\" ng-model=\"vmZapEM.pracownik.imieNazwisko\" type=\"text\"> <span ng-show=\"zapisyEM.osobakontaktowa.$touched &&vmZapEM.pracownik.imieNazwisko.length < 5\" style=\"color: crimson;\">Osoba kontaktowa jest wymagana.</span></td></tr><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 160px;\"><label for=\"telefon-kontaktowy\">Telefon kontaktowy</label></td><td><input class=\"form-control\" id=\"telefon-kontaktowy\" name=\"osoba-kontaktowa\" style=\"width:350px\" ng-model=\"vmZapEM.pracownik.telefon\" type=\"text\"></td></tr><tr class=\"bootstrap-iso-paper\"><td style=\"max-width: 160px;\"><label for=\"email\">E-mail</label></td><td><input class=\"form-control\" id=\"email\" name=\"osoba-kontaktowa\" style=\"width:350px\" ng-model=\"vmZapEM.pracownik.email\" type=\"text\"></td></tr></table></form></div><div class=\"col-md-12\" style=\"padding-top: 20px;\"><button ng-click=\"vmZapEM.zapisz()\" class=\"btn btn-primary\" ng-disabled=\"vmZapEM.pracownik.imieNazwisko.length < 5 || vmZapEM.zapisano\">{{(vmZapEM.zapisano == false) ? \'Zapisz się\' : \'Zgłoszenie już zostało wysłane\'}}</button></div></div></div><h3>Platforma e-Mieszczanin</h3><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-12\"><img src=\"./assets/images/emieszczanin/em-login.png\" style=\"margin: 0 auto;width: 100%\"></div></div></div></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/aktualizacja.modal.html","<div class=\"row\"><div class=\"col-md-12\"><h2>Usługi</h2><obsluga-bledow wiadomosci-tablica=\"vmZOA.odpowiedziSerwera\"></obsluga-bledow></div></div><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-2 text-center\" style=\"padding-top: 8px;\"><b>Lokalizacja</b></div><div class=\"col-md-10\"><select style=\"\" ng-model=\"vmZOA.lokalizacja\" ng-options=\"lok as lok.NazwaLok for lok in vmZOA.lokalizacje\" name=\"lokalizacja\" id=\"lokalizacja\"></select></div></div><div class=\"mt-30\" ng-if=\"vmZOA.lokalizacja === null\"><p class=\"text-center\"><b>Wybierz lokalizację aby wyświetlić dostępne produkty</b></p></div><div ng-if=\"vmZOA.lokalizacja !== null\" class=\"mt-30\"><div class=\"boxed-item p-10 mt-10\" ng-repeat=\"produkt in vmZOA.produkty\" ng-click=\"vmZOA.dodaj(produkt)\"><div class=\"ikona\"><i class=\"{{produkt.ikona}}\" aria-hidden=\"true\"></i></div><div class=\"zawartosc\"><div class=\"naglowek\"><p class=\"text-center\" style=\"font-size: 16px;\">{{produkt.nazwa}}</p></div><div class=\"opis\">{{produkt.opis}}</div></div></div></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/aktualizacja.zapytanieOfertowe.html","<div class=\"row\"><div class=\"col-md-12\"><h2>Aktualizacja</h2><obsluga-bledow wiadomosci-tablica=\"vmZOA.odpowiedziSerwera\"></obsluga-bledow></div></div><div class=\"bootstrap-iso-paper\"><div ng-if=\"vmZOA.lokalizacje.length > 1 && vmZOA.lokalizacja !== undefined\"><div class=\"row\"><div class=\"col-md-2 text-center\" style=\"padding-top: 8px;\"><b>Lokalizacja</b></div><div class=\"col-md-10\"><select style=\"\" ng-model=\"vmZOA.lokalizacja\" ng-options=\"lok as lok.NazwaLok for lok in vmZOA.lokalizacje track by lok.IdLok\" name=\"lokalizacja\" ng-change=\"vmZOA.zmianaLokalizacji()\" id=\"lokalizacja\"></select></div></div><div class=\"mt-30\" ng-if=\"vmZOA.lokalizacja === null\"><p class=\"text-center\"><b>Wybierz lokalizację aby wyświetlić dostępne produkty</b></p></div></div><div class=\"mt-30\" ng-if=\"(vmZOA.ladowanie === true && vmZOA.lokalizacja !== null) || vmZOA.lokalizacje.length < 1\"><p class=\"text-center\"><b>Trwa ładowanie...</b></p></div><div class=\"mt-30\" ng-if=\"vmZOA.lokalizacja !== null\"><div class=\"boxed-item hoverable p-10 mt-10\" ng-repeat=\"produkt in vmZOA.produkty\" ng-click=\"vmZOA.dodaj(produkt)\" ng-if=\"(produkt.id === 23 && vmZOA.wersjaOprogramowania.nowsza) || (produkt.id === 24 && [17, undefined].indexOf(vmZOA.wersjaOprogramowania.asa) === -1)\"><div class=\"ikona\"><i class=\"{{produkt.ikona}}\" aria-hidden=\"true\"></i></div><div class=\"zawartosc\"><div class=\"naglowek\"><p class=\"text-center\" style=\"font-size: 16px;\">{{produkt.nazwa}}</p></div><div class=\"opis\"></div></div></div></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/inneZapytanie.modal.html","<div class=\"{{vmModal.bootstrapKlasa}}\" ng-init=\"vmModal.init()\"><div class=\"modal-header\"><div class=\"flex-row\"><div class=\"ikona\"><div class=\"{{vmModal.produkt.ikona}}\"></div></div><h4 class=\"modal-title flex-g-11\"><span style=\"padding-left: 10px;\">{{vmModal.produkt.nazwa}}</span></h4></div></div><div class=\"row\" ng-if=\"vmModal.lokalizacje.length > 1\"><div class=\"col-md-4 text-center\" style=\"padding-top: 8px;\"><b>Lokalizacja</b></div><div class=\"col-md-8\"><select style=\"\" ng-model=\"vmModal.form.lokalizacja\" ng-options=\"lok as lok.NazwaLok for lok in vmModal.lokalizacje track by lok.IdLok\" name=\"lokalizacja\" ng-change=\"vmModal.zmianaLokalizacji()\" id=\"lokalizacja\"></select></div></div><form style=\"float: none;\" name=\"nowyModulForm\"><div class=\"row\" ng-repeat=\"parametr in vmModal.parametry\"><div class=\"col-md-4 text-center\"><label for=\"{{parametr.nazwa}}\" style=\"text-align: unset\"><b>{{parametr.nazwa}}</b></label></div><div class=\"col-md-8\" style=\"padding-top: 6px;\"><textarea name=\"{{parametr.nazwa}}\" id=\"{{parametr.nazwa}}\" ng-model=\"vmModal.form.parametry[parametr.id].wartosc\" style=\"min-width: 400px; min-height: 200px\" required=\"\">\n                </textarea></div></div></form><div class=\"row mt-10\"><div class=\"col-md-4 text-center\"></div><div class=\"col-md-8\"></div></div><div class=\"modal-footer mt-10\"><button class=\"btn btn-primary\" ng-disabled=\"nowyModulForm.$invalid || vmModal.form.lokalizacja === null\" data-ng-click=\"vmModal.modalOk(vmModal.item)\">Dodaj do koszyka</button> <button type=\"button\" class=\"btn btn-default\" data-ng-click=\"vmModal.modalClose()\">Anuluj</button></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/koszyk.html","<div class=\"row\"><div class=\"col-md-12\"><h2>Koszyk</h2><obsluga-bledow wiadomosci-tablica=\"vmZOK.odpowiedziSerwera\"></obsluga-bledow><div class=\"{{vmZOK.bootstrapKlasa}}\" ng-if=\"vmZOK.brakDanychZglaszajacego\"><div class=\"alert alert-danger\"><i class=\"fa fa-exclamation-circle\" style=\"margin-right: 5px;\"></i> Aby wysłać zamówienie, uzupełnij brakujące dane w profilu: {{vmZOK.brakujaceDaneZglaszajacego.join(\', \')}}. <a ui-sref=\"home.subMain.profil\"><strong>Przejdź do profilu</strong></a></div></div></div></div><div class=\"bootstrap-iso-paper\" ng-if=\"vmZOK.koszyk.produkty.length === 0\">koszyk jest pusty</div><div class=\"bootstrap-iso-paper\" ng-repeat=\"lokalizacja in vmZOK.koszyk.lokalizacje\" ng-if=\"vmZOK.koszyk !== null && vmZOK.koszyk !== undefined\"><h5>Lokalizacja: {{lokalizacja.NazwaLok}}</h5><div class=\"boxed-item p-10 mt-10\" ng-repeat=\"produkt in vmZOK.koszyk.produkty\" ng-if=\"lokalizacja.IdLok === produkt.lokalizacja.IdLok\"><div class=\"ikona\" style=\"margin-right: 20px;\"><div class=\"{{produkt.produkt.ikona}}\"></div></div><div class=\"zawartosc\"><div class=\"naglowek\"><p class=\"\" style=\"font-size: 16px;\">{{produkt.produkt.nazwa}} <span ng-if=\"produkt.kategoria !== \'inne-zapytanie-handlowe\'\">({{vmZOK.kategorie[produkt.kategoria]}})</span></p></div><div class=\"opis\" ng-show=\"vmZOK.getKeys(produkt.parametry).length !== 0\"><span>Parametry:</span><ul><li ng-repeat=\"parametr in produkt.parametry\" ng-if=\"produkt.kategoria !== \'zmiana-limitow\'\" style=\"margin-bottom: 0\">{{parametr.nazwa + \": \"}} {{vmZOK.dajWartosc(parametr.wartosc)}}</li><li ng-repeat=\"parametr in produkt.parametry\" ng-if=\"produkt.kategoria == \'zmiana-limitow\' && parametr.poprzednia_wartosc != parametr.wartosc\" style=\"margin-bottom: 0\">{{parametr.nazwa + \": \"}} {{vmZOK.dajWartosc(parametr.poprzednia_wartosc)}} <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> {{vmZOK.dajWartosc(parametr.wartosc)}}</li></ul></div></div><div class=\"usun\" style=\"color: crimson; cursor: pointer\"><i class=\"fa fa-times\" aria-hidden=\"true\" ng-click=\"vmZOK.usunZKoszyka(produkt)\"></i></div></div></div><div class=\"bootstrap-iso-paper\" ng-if=\"vmZOK.koszyk !== null && vmZOK.koszyk !== undefined && vmZOK.koszyk.produkty.length > 0\"><div class=\"boxed-item p-10 mt-10\"><div class=\"zawartosc\"><div class=\"naglowek\"><h5>Dane kontaktowe</h5><form name=\"daneKontaktowe\"><div class=\"row\"><div class=\"col-md-4 text-center\"><label for=\"imie\" style=\"text-align: unset\"><b>Imię</b></label></div><div class=\"col-md-8\"><input id=\"imie\" type=\"text\" ng-model=\"vmZOK.osDoKontaktu.imie\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4 text-center\"><label for=\"nazwisko\" style=\"text-align: unset\"><b>Nazwisko</b></label></div><div class=\"col-md-8\"><input id=\"nazwisko\" type=\"text\" ng-model=\"vmZOK.osDoKontaktu.nazwisko\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4 text-center\"><label for=\"telefon\" style=\"text-align: unset\"><b>Telefon</b></label></div><div class=\"col-md-8\"><input id=\"telefon\" type=\"text\" ng-model=\"vmZOK.osDoKontaktu.Telefon\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4 text-center\"><label for=\"email\" style=\"text-align: unset\"><b>e-mail</b></label></div><div class=\"col-md-8\"><input id=\"email\" type=\"text\" ng-model=\"vmZOK.osDoKontaktu.email\" required=\"\"></div></div></form></div></div></div><div class=\"row\"><div class=\"col-md-12 mt-10\"><button class=\"btn btn-primary\" style=\"float: right\" data-ng-click=\"vmZOK.wyslij()\" ng-disabled=\"daneKontaktowe.$invalid || vmZOK.brakDanychZglaszajacego\">Wyślij</button></div></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/nowyModul.modal.html","<div class=\"{{vmModal.bootstrapKlasa}}\" ng-init=\"vmModal.init()\"><div class=\"modal-header\"><div class=\"flex-row\"><div class=\"ikona\"><div class=\"{{vmModal.produkt.ikona}}\"></div></div><h4 class=\"modal-title flex-g-11\">{{vmModal.produkt.nazwa}}</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\" style=\"margin: 20px 0;\"><obsluga-bledow wiadomosci-tablica=\"vmModal.bledy\"></obsluga-bledow></div></div><p ng-if=\"vmModal.ladowanie\" style=\"text-align: center\">Ładowanie parametrów...</p><form style=\"width: 100%\" name=\"nowyModulForm\" ng-show=\"!vmModal.ladowanie\"><table class=\"ofertab\" style=\"width: 100%\"><tr ng-if=\"vmModal.lokalizacja.NazwaLok\"><td><label style=\"line-height: 1.5;width: 100%;\"><b>Lokalizacja</b></label></td><td>{{vmModal.lokalizacja.NazwaLok}}</td></tr><tr ng-repeat=\"parametr in vmModal.parametry\"><td><label for=\"{{parametr.prezentowana_nazwa}}\" style=\"line-height: 1.5;width: 100%;\"><b>{{parametr.prezentowana_nazwa}} <span class=\"tt-no-wrap\" uib-tooltip=\"{{parametr.dodatkowe_informacje}}\" tooltip-placement=\"bottom\"><i ng-if=\"parametr.dodatkowe_informacje !== null && parametr.dodatkowe_informacje.length > 0\" class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></span></b></label></td><td ng-if=\"[\'number\', \'text\'].indexOf(parametr.sposob_pilnowania) !== -1\"><input name=\"{{parametr.prezentowana_nazwa}}\" id=\"{{parametr.prezentowana_nazwa}}\" type=\"{{parametr.sposob_pilnowania}}\" ng-model=\"vmModal.form.parametry[parametr.id].wartosc\" required=\"\"></td><td ng-if=\"parametr.sposob_pilnowania === \'checkbox\'\" style=\"padding-top: 6px;\"><input name=\"{{parametr.prezentowana_nazwa}}\" id=\"{{parametr.prezentowana_nazwa}}\" type=\"{{parametr.sposob_pilnowania}}\" ng-model=\"vmModal.form.parametry[parametr.id].wartosc\"></td><td ng-if=\"parametr.sposob_pilnowania === \'date\'\"><string-datepicker nazwa=\"\'data\'\" date=\"vmModal.form.parametry[parametr.id].wartosc\" required=\"true\"></string-datepicker></td><td ng-if=\"parametr.sposob_pilnowania === \'textarea\'\" style=\"padding-top: 6px;\"><textarea name=\"{{parametr.prezentowana_nazwa}}\" id=\"{{parametr.prezentowana_nazwa}}\" type=\"{{parametr.sposob_pilnowania}}\" ng-model=\"vmModal.form.parametry[parametr.id].wartosc\" style=\"min-width: 400px; min-height: 200px\" required=\"\">\n                </textarea></td><td ng-if=\"parametr.sposob_pilnowania === \'select\'\"><select name=\"{{vmModal.form.parametry[parametr.id].wartosc}}\" id=\"{{parametr.prezentowana_nazwa}}\" style=\"\" required=\"\" ng-options=\"wartosc.wartosc as wartosc.wartosc for wartosc in parametr.wartosci\" ng-model=\"vmModal.form.parametry[parametr.id].wartosc\"></select></td></tr></table></form><div class=\"row mt-10\"><div class=\"col-md-4 text-center\"></div><div class=\"col-md-8\"></div></div></div><div class=\"modal-footer mt-10\"><button class=\"btn btn-primary\" ng-disabled=\"nowyModulForm.$invalid\" data-ng-click=\"vmModal.modalOk(vmModal.item)\">Dodaj do koszyka</button> <button type=\"button\" class=\"btn btn-default\" data-ng-click=\"vmModal.modalClose()\">Anuluj</button></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/nowyModul.zapytanieOfertowe.html","<div class=\"row\"><div class=\"col-md-12\"><h2>Nowy moduł</h2><obsluga-bledow wiadomosci-tablica=\"vmZOK.odpowiedziSerwera\"></obsluga-bledow></div></div><div class=\"bootstrap-iso-paper\"><div ng-if=\"vmZONM.lokalizacje.length > 1 && vmZONM.lokalizacja !== undefined\" \"=\"\"><div class=\"row\"><div class=\"col-md-2 text-center\" style=\"padding-top: 8px;\"><b>Lokalizacja</b></div><div class=\"col-md-10\"><select style=\"\" ng-model=\"vmZONM.lokalizacja\" ng-options=\"lok as lok.NazwaLok for lok in vmZONM.lokalizacje track by lok.IdLok\" name=\"lokalizacja\" ng-change=\"vmZONM.zmienLokalizacje()\" id=\"lokalizacja\"></select></div></div><div class=\"mt-30\" ng-if=\"vmZONM.lokalizacja === null\"><p class=\"text-center\"><b>Wybierz lokalizację aby wyświetlić dostępne produkty</b></p></div></div><div class=\"mt-30\" ng-if=\"vmZONM.ladowanie === true\"><p class=\"text-center\"><b>Trwa ładowanie...</b></p></div><div ng-if=\"vmZONM.lokalizacja !== null && vmZONM.ladowanie===false\" class=\"mt-30\"><div class=\"boxed-item hoverable p-10 mt-10\" ng-repeat=\"produkt in vmZONM.produkty\" ng-if=\"vmZONM.posiadaneLicencje.indexOf(produkt.nazwa) === -1\" ng-click=\"vmZONM.dodaj(produkt)\"><div class=\"ikona\"><div class=\"{{produkt.ikona}}\"></div></div><div class=\"zawartosc\"><div class=\"naglowek\"><p class=\"text-center\" style=\"font-size: 16px;\">{{produkt.nazwa}}</p></div><div class=\"opis\"><span ng-bind-html=\"vmZONM.getTrustedHtml(produkt.opis)\"></span></div></div></div></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/pakietyIUslugi.zapytanieOfertowe.html","<div class=\"row\"><div class=\"col-md-12\"><h2>Usługi</h2><obsluga-bledow wiadomosci-tablica=\"vmZOPIU.odpowiedziSerwera\"></obsluga-bledow></div></div><div class=\"bootstrap-iso-paper\"><div ng-if=\"vmZOPIU.lokalizacje.length > 1 && vmZOPIU.lokalizacja !== undefined\"><div class=\"row\"><div class=\"col-md-2 text-center\" style=\"padding-top: 8px;\"><b>Lokalizacja</b></div><div class=\"col-md-10\"><select style=\"\" ng-model=\"vmZOPIU.lokalizacja\" ng-options=\"lok as lok.NazwaLok for lok in vmZOPIU.lokalizacje track by lok.IdLok\" name=\"lokalizacja\" ng-change=\"vmZOPIU.zmianaLokalizacji()\" id=\"lokalizacja\"></select></div></div><div class=\"mt-30\" ng-if=\"vmZOPIU.lokalizacja === null\"><p class=\"text-center\"><b>Wybierz lokalizację aby wyświetlić dostępne produkty</b></p></div></div><div class=\"mt-30\" ng-if=\"vmZOPIU.ladowanie === true\"><p class=\"text-center\"><b>Trwa ładowanie...</b></p></div><div ng-if=\"vmZOPIU.lokalizacja !== null && vmZOPIU.lokalizacja !== undefined\" class=\"mt-30\"><div class=\"boxed-item hoverable p-10 mt-10\" ng-repeat=\"produkt in vmZOPIU.produkty\" ng-click=\"vmZOPIU.dodaj(produkt)\"><div class=\"ikona\"><i class=\"{{produkt.ikona}}\" aria-hidden=\"true\"></i></div><div class=\"zawartosc\"><div class=\"naglowek\"><p class=\"text-center\" style=\"font-size: 16px;\">{{produkt.nazwa}}</p></div><div class=\"opis\"><span ng-bind-html=\"vmZOPIU.getTrustedHtml(produkt.opis)\"></span></div></div></div></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/usunZKoszyka.modal.html","<div class=\"{{vmModal.bootstrapKlasa}}\" ng-init=\"vmModal.init()\"><div class=\"modal-header\"><div class=\"flex-row\"><div class=\"ikona\"><div class=\"fa fa-2x fa-trash\"></div></div><h4 class=\"modal-title flex-g-11\"><span style=\"padding-left: 10px;\">Usuń z koszyka</span></h4></div></div><div class=\"row\"><div class=\"col-md-12\" style=\"text-align: center; padding-top: 20px;\">Czy na pewno chcesz usunąć <i>\"{{vmModal.produkt.produkt.nazwa}}\"</i> z koszyka?</div></div><div class=\"row mt-10\"><div class=\"col-md-4 text-center\"></div><div class=\"col-md-8\"></div></div><div class=\"modal-footer mt-10\"><button class=\"btn btn-primary\" data-ng-click=\"vmModal.modalOk()\">Usuń</button> <button type=\"button\" class=\"btn btn-default\" data-ng-click=\"vmModal.modalClose()\">Anuluj</button></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/zapytanieOfertowe.html","<ui-view><div class=\"row\"><div class=\"col-md-12\"><div class=\"boxT\" style=\"float: right; display: inline; width:160px; text-align: center\"><p><a ui-sref=\"home.subMain.zgloszenia.zamowienia\"><i class=\"fa fa-shopping-basket\" aria-hidden=\"true\" style=\"margin-right: 5px;\"></i>Moje zamówienia</a></p></div><h2>Zapytanie ofertowe / Informacja</h2></div></div><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-6\"><a ui-sref=\"home.subMain.zapytanieOfertowe.nowyModul\"><div class=\"col-md-12 box-item\"><b>Nowy moduł</b></div></a></div><div class=\"col-md-6\"><a ui-sref=\"home.subMain.zapytanieOfertowe.zmianaLimitow\"><div class=\"col-md-12 box-item\"><b>Zmiana limitów</b></div></a></div></div><div class=\"row mt-30\"><div class=\"col-md-6\"><a ui-sref=\"home.subMain.zapytanieOfertowe.aktualizacja\"><div class=\"col-md-12 box-item\"><b>Aktualizacja</b></div></a></div><div class=\"col-md-6\"><a ui-sref=\"home.subMain.zapytanieOfertowe.pakietyIUslugi\"><div class=\"col-md-12 box-item\"><b>Usługi</b></div></a></div></div><div class=\"row mt-30\"><div class=\"col-md-6\"><a ng-click=\"vmZO.otworzInneZapytanie()\"><div class=\"col-md-12 box-item\"><b>Zgłoś inne zapytanie handlowe / Przekaż informację</b></div></a></div></div></div></ui-view>");
$templateCache.put("app/home/zapytanieOfertowe/zapytanieOfertoweOld.html","<div class=\"content\"><div class=\"clientpulpit\"><div class=\"panefull zapytanie\"><h2>Zapytanie ofertowe / Informacja</h2><obsluga-bledow wiadomosci-tablica=\"vmZapOf.odpowiedziSerwera\"></obsluga-bledow><br><form name=\"zapytanieForm\" novalidate=\"\"><p></p><h4>Firma</h4><p></p><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm.nazwaFirmy.$touched && zapytanieForm.nazwaFirmy.$invalid}\"><label>Nazwa firmy *</label> <input type=\"text\" name=\"nazwaFirmy\" ng-model=\"vmZapOf.parametry.nazwaFirmy\" required=\"\"><p style=\"{{(zapytanieForm.nazwaFirmy.$touched && zapytanieForm.nazwaFirmy.$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm.ulica.$touched && zapytanieForm.ulica.$invalid}\"><label>Ulica *</label> <input type=\"text\" name=\"ulica\" ng-model=\"vmZapOf.parametry.ulica\" pattern=\"[ A-Za-zęóąśłżźćńĘÓĄŚŁŻŹĆŃ0-9.-]{2,99}\" required=\"\"><p style=\"{{(zapytanieForm.ulica.$touched && zapytanieForm.ulica.$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm.nrBudynkuILokalu.$touched && zapytanieForm.nrBudynkuILokalu.$invalid}\"><label>Nr budynku / lokalu*</label> <input style=\"width:80px; text-align:center\" type=\"text\" name=\"nrBudynkuILokalu\" ng-model=\"vmZapOf.parametry.nrBudynkuILokalu\" required=\"\"><p style=\"{{(zapytanieForm.nrBudynkuILokalu.$touched && zapytanieForm.nrBudynkuILokalu.$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm.kodPocztowy.$touched && zapytanieForm.kodPocztowy.$invalid}\"><label>Kod Pocztowy *</label> <input style=\"width:80px; text-align:left\" type=\"text\" name=\"kodPocztowy\" pattern=\"[0-9]{2}-[0-9]{3}\" ng-model=\"vmZapOf.parametry.kodPocztowy\" required=\"\"><p style=\"{{(zapytanieForm.kodPocztowy.$touched && zapytanieForm.kodPocztowy.$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Niepoprawny kod pocztowy</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm.miejscowosc.$touched && zapytanieForm.miejscowosc.$invalid}\"><label>Miejscowość *</label> <input type=\"text\" name=\"miejscowosc\" ng-model=\"vmZapOf.parametry.miejscowosc\" pattern=\"[ A-Za-zęóąśłżźćńĘÓĄŚŁŻŹĆŃ]{2,99}\" required=\"\"><p style=\"{{(zapytanieForm.miejscowosc.$touched && zapytanieForm.miejscowosc.$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\"><label>Telefon *</label> <input name=\"telefon\" type=\"text\" pattern=\"[ 0-9-]{9,20}\" ng-model=\"vmZapOf.parametry.telefonFirmowy\" required=\"\"></div><p></p><h4>Informacje o zasobach</h4><p></p><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm.lokale.$touched && zapytanieForm.lokale.$invalid}\"><label style=\"width: 310px;\">Liczba lokali ogółem *</label> <input name=\"lokale\" type=\"text\" pattern=\"[0-9]{1,10}\" style=\"display:inline-block\" class=\"form-control\" ng-model=\"vmZapOf.parametry.lokaliOgolem\" required=\"\"><p style=\"{{(zapytanieForm.lokale.$touched && zapytanieForm.lokale.$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><label style=\"width: 310px;\">Dominujący typ obsługiwanych nieruchomości *</label><select name=\"dominujacy\" ng-model=\"vmZapOf.parametry.dominujacyTyp\" required=\"\"><option value=\"zasobwlasny\">zasób własny</option><option value=\"wspolnotymieszkaniowe\">wspólnoty mieszkaniowe</option><option value=\"wspolwlasnosci\">współwłasności</option><option value=\"inny\">inny</option></select><div ng-if=\"vmZapOf.parametry.dominujacyTyp === \'inny\'\" style=\"display:inline-block;\"><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm.dominujacyInnyTyp.$touched && zapytanieForm.dominujacyInnyTyp.$invalid}\"><label style=\"width: 300px;\">Jaki? *</label> <input name=\"dominujacyInnyTyp\" type=\"text\" pattern=\"[ A-Za-zęóąśłżźćńĘÓĄŚŁŻŹĆŃ0-9^()]{1,99}\" style=\"display: inline-block\" ng-model=\"vmZapOf.parametry.dominujacyInnyTyp\" required=\"\"><p style=\"{{(zapytanieForm.dominujacyInnyTyp.$touched && zapytanieForm.dominujacyInnyTyp.$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div></div><p></p><h4>Dane kontaktowe pracowników</h4><p></p><div ng-repeat=\"pracownik in vmZapOf.pracownicy\"><p ng-if=\"pracownik.id === 0\"><b>Osoba do kontaktu</b></p><p ng-if=\"pracownik.id !== 0\"><b>Pracownik {{$index + 1}}</b> <i class=\"fa fa-trash\" ng-if=\"pracownik.id !== 0\" style=\"color: crimson; cursor: pointer\" ng-click=\"vmZapOf.usunPracownika(pracownik.id)\" aria-label=\"usuń pracownika\"></i></p><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm[pracownik.id+\'_imieINazwisko\'].$touched && zapytanieForm[pracownik.id+\'_imieINazwisko\'].$invalid}\"><label>Imię i nazwisko*</label> <input type=\"text\" name=\"{{pracownik.id+\'_imieINazwisko\'}}\" ng-model=\"pracownik.imieINazwisko\" pattern=\"[A-Za-zęóąśłżźćńĘÓĄŚŁŻŹĆŃ ]{3,99}\" required=\"\"><p style=\"{{(zapytanieForm.imieINazwisko.$touched && zapytanieForm.imieINazwisko.$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\"><label>Stanowisko</label> <input name=\"{{pracownik.id+\'_stanowisko\'}}\" type=\"text\" pattern=\"[ A-Za-zęóąśłżźćńĘÓĄŚŁŻŹĆŃ]{2,}\" ng-model=\"pracownik.stanowisko\"></div><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm[pracownik.id+\'_telefon\'].$touched && zapytanieForm[pracownik.id+\'_telefon\'].$invalid}\"><label>Telefon kontaktowy *</label> <input type=\"text\" name=\"{{pracownik.id+\'_telefon\'}}\" ng-model=\"pracownik.telefon\" pattern=\"[ 0-9-]{9,25}\" required=\"\"><p style=\"{{(zapytanieForm.telefon.$touched && zapytanieForm.telefon.$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : zapytanieForm[pracownik.id+\'_email\'].$dirty && zapytanieForm[pracownik.id+\'_email\'].$invalid}\"><label>E-mail *</label> <input type=\"text\" name=\"{{pracownik.id+\'_email\'}}\" ng-model=\"pracownik.email\" pattern=\"[a-zęóąśłżźćńĘÓĄŚŁŻŹĆŃ0-9._%+-]+@[a-zęóąśłżźćńĘÓĄŚŁŻŹĆŃ0-9.-]+\\.[a-zęóąśłżźćńĘÓĄŚŁŻŹĆŃ]{2,6}$\" required=\"\"><p style=\"{{(zapytanieForm[pracownik.id+\'_email\'].$dirty && zapytanieForm[pracownik.id+\'_email\'].$invalid)?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Niepoprawny adres e-mail</p></div></div><br><br><div class=\"{{vmZapOf.bootstrapKlasa}}\"><button class=\"btn btn-default\" ng-click=\"vmZapOf.dodajPracownika()\"><span class=\"ng-binding\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Dodaj pracownika</span></button></div><br><button ng-if=\"vmZapOf.wyslano == false\" ng-class=\"zapytanieForm.$invalid ? \'disabled\' : \'\'\" ng-disabled=\"zapytanieForm.$invalid\" ng-click=\"vmZapOf.wyslij()\" value=\"\" class=\"btn-send\"></button></form><div class=\"clearfix\"></div><p class=\"space\">Pola oznaczone gwiazdką * są wymagane</p></div></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/zmianaLimitow.modal.html","<div class=\"{{vmModal.bootstrapKlasa}}\" ng-init=\"vmModal.init()\"><div class=\"modal-header\"><div class=\"flex-row\"><div class=\"ikona\"><div class=\"{{vmModal.produkt.produkt.ikona}}\"></div></div><h4 class=\"modal-title flex-g-11\">{{vmModal.produkt.produkt.nazwa}}</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\" style=\"margin: 20px 0;\"><obsluga-bledow wiadomosci-tablica=\"vmModal.bledy\"></obsluga-bledow></div></div><div class=\"row mb-10\" ng-if=\"vmModal.lokalizacja.NazwaLok\"><div class=\"col-md-3\"><b>Lokalizacja</b></div><div class=\"col-md-9\">{{vmModal.lokalizacja.NazwaLok}}</div></div><form style=\"float: none;\" name=\"nowyModulForm\"><table class=\"ofertab\" style=\"width: 100%\"><tr><td></td><td><b>Poprzednia wartość</b></td><td></td><td><b>Nowa wartość</b></td></tr><tr ng-repeat=\"parametr in vmModal.getKeys(vmModal.form.parametry)\"><td><label for=\"{{vmModal.form.parametry[parametr].prezentowana_nazwa}}\" style=\"line-height: 1.5;width: 100%;\"><b>{{vmModal.form.parametry[parametr].prezentowana_nazwa}}</b> <span class=\"tt-no-wrap\" uib-tooltip=\"{{vmModal.form.parametry[parametr].dodatkowe_informacje}}\" tooltip-placement=\"bottom\"><i ng-if=\"vmModal.form.parametry[parametr].dodatkowe_informacje !== null && vmModal.form.parametry[parametr].dodatkowe_informacje.length > 0\" class=\"fa fa-question-circle\" aria-hidden=\"true\"></i></span></label></td><td>{{vmModal.form.parametry[parametr].poprzednia_wartosc}}</td><td><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></td><td ng-if=\"[\'number\', \'text\'].indexOf(vmModal.form.parametry[parametr].sposob_pilnowania) !== -1\"><input ng-change=\"vmModal.sprawdzWartosci()\" name=\"{{vmModal.form.parametry[parametr].prezentowana_nazwa}}\" id=\"{{vmModal.form.parametry[parametr].prezentowana_nazwa}}\" type=\"{{vmModal.form.parametry[parametr].sposob_pilnowania}}\" ng-model=\"vmModal.form.parametry[parametr].wartosc\" required=\"\"></td><td ng-if=\"vmModal.form.parametry[parametr].sposob_pilnowania === \'checkbox\'\"><input ng-change=\"vmModal.sprawdzWartosci()\" name=\"{{vmModal.form.parametry[parametr].prezentowana_nazwa}}\" id=\"{{vmModal.form.parametry[parametr].prezentowana_nazwa}}\" type=\"{{vmModal.form.parametry[parametr].sposob_pilnowania}}\" ng-model=\"vmModal.form.parametry[parametr].wartosc\"></td><td ng-if=\"vmModal.form.parametry[parametr].sposob_pilnowania === \'date\'\"><string-datepicker nazwa=\"\'data\'\" date=\"vmModal.form.parametry[parametr].wartosc\" required=\"true\"></string-datepicker></td><td ng-if=\"vmModal.form.parametry[parametr].sposob_pilnowania === \'select\'\"><select name=\"{{vmModal.form.parametry[parametr].wartosc}}\" id=\"{{vmModal.form.parametry[parametr].prezentowana_nazwa}}\" ng-change=\"vmModal.sprawdzWartosci()\" style=\"\" required=\"\" ng-options=\"wartosc.wartosc as wartosc.wartosc for wartosc in vmModal.form.parametry[parametr].wartosci\" ng-model=\"vmModal.form.parametry[parametr].wartosc\"></select></td></tr></table></form><div class=\"row mt-10\"><div class=\"col-md-4 text-center\"></div><div class=\"col-md-8\"></div></div></div><div class=\"modal-footer mt-10\"><button class=\"btn btn-primary\" ng-disabled=\"nowyModulForm.$invalid || vmModal.brakZmiany === true\" data-ng-click=\"vmModal.modalOk(vmModal.item)\">Dodaj do koszyka</button> <button type=\"button\" class=\"btn btn-default\" data-ng-click=\"vmModal.modalClose()\">Anuluj</button></div></div>");
$templateCache.put("app/home/zapytanieOfertowe/zmianaLimitow.zapytanieOfertowe.html","<div class=\"row\"><div class=\"col-md-12\"><h2>Zmiana limitów</h2><obsluga-bledow wiadomosci-tablica=\"vmZOZL.odpowiedziSerwera\"></obsluga-bledow></div></div><div class=\"bootstrap-iso-paper\"><div ng-if=\"vmZOZL.lokalizacje.length > 1\"><div class=\"row\"><div class=\"col-md-2 text-center\" style=\"padding-top: 8px;\"><b>Lokalizacja</b></div><div class=\"col-md-10\" ng-if=\"vmZOZL.lokalizacja !== undefined\"><select style=\"\" ng-model=\"vmZOZL.lokalizacja\" ng-options=\"lok as lok.NazwaLok for lok in vmZOZL.lokalizacje track by lok.IdLok\" ng-change=\"vmZOZL.odswiezLicencje()\" name=\"lokalizacja\" id=\"lokalizacja\"></select></div></div><div class=\"mt-30\" ng-if=\"vmZOZL.lokalizacja === null\"><p class=\"text-center\"><b>Wybierz lokalizację aby wyświetlić dostępne produkty</b></p></div></div><div class=\"mt-30\" ng-if=\"vmZOZL.ladowanie === true\"><p class=\"text-center\"><b>Trwa ładowanie...</b></p></div><div ng-if=\"vmZOZL.lokalizacja !== null && vmZOZL.ladowanie === false\" class=\"mt-30\"><div class=\"boxed-item hoverable p-10 mt-10\" ng-repeat=\"produkt in vmZOZL.licencjeLokalizacji\" ng-if=\"vmZOZL.nazwyWidocznychProduktow.indexOf(produkt.nazwa) !== -1\" ng-click=\"vmZOZL.dodaj(produkt)\"><div class=\"ikona\"><div class=\"{{vmZOZL.produkty[produkt.nazwa].ikona}}\"></div></div><div class=\"zawartosc\"><div class=\"naglowek\"><p class=\"text-center\" style=\"font-size: 16px;\">{{produkt.nazwa}}</p></div><div class=\"opis\">Aktualne limity:<ul><li ng-repeat=\"ograniczenie in produkt.ograniczenia\" ng-if=\"vmZOZL.getKeys(vmZOZL.nazwyWidocznychParametrow[produkt.nazwa]).indexOf(ograniczenie.nazwa) !== -1\" style=\"margin-bottom: 0\">{{vmZOZL.nazwyWidocznychParametrow[produkt.nazwa][ograniczenie.nazwa]}}: {{ograniczenie.ograniczenie}}</li></ul></div></div></div></div></div>");
$templateCache.put("app/home/zarzadzaniePlikami/dodaj.zarzadzaniePlikami.html","<div class=\"content\"><div class=\"pane23\"><h2>Dodawanie pliku</h2><div class=\"box23\" style=\"margin-bottom: 0; margin-left: 10px;\"><obsluga-bledow wiadomosci-tablica=\"vmZaPD.odpowiedziSerwera\"></obsluga-bledow><form name=\"dodawaniePliku\" novalidate=\"\"><table style=\"width: 400px;margin-top: 20px;\" class=\"bootstrap-iso-paper\"><tr><td style=\"max-width: 100px;\"><label for=\"nazwa\">Nazwa</label></td><td><input class=\"form-control\" id=\"nazwa\" name=\"nazwa\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmZaPD.plik.tytul\" type=\"text\" required=\"\"> <span ng-show=\"dodawaniePliku.nazwa.$touched && vmZaPD.plik.tytul.length < 4\" style=\"color: crimson;\">Nazwa jest wymagana.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"kategoria\">Kategoria</label></td><td><select type=\"text\" id=\"kategoria\" style=\"min-width: 350px;\" ng-model=\"vmZaPD.plik.kategoria\" ng-options=\"item.id as item.nazwa for item in vmZaPD.kategorie\" required=\"\"></select></td></tr><tr><td style=\"max-width: 120px;\"><label for=\"kolejnosc\">Kolejność</label></td><td><input style=\"min-width: 350px;\" type=\"number\" min=\"0\" max=\"1000\" step=\"1\" id=\"kolejnosc\" ng-model=\"vmZaPD.plik.kolejnosc\" required=\"\"></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"opis\">Opis</label></td><td><textarea rows=\"4\" style=\"min-width: 350px;\" type=\"text\" id=\"opis\" ng-model=\"vmZaPD.plik.opis\"></textarea> <span ng-show=\"dodawaniePliku.opis.$touched && vmZaPD.plik.opis.length < 4\" style=\"color: crimson;\">Opis jest wymagany.</span></td></tr></table><div style=\"max-width:450px;margin-top: 20px;\" class=\"{{vmZaPD.bootstrapKlasa}}\"><p><b>Powiazany plik:</b></p><div style=\"padding-left: 20px;\"><button class=\"btn btn-default\" ng-click=\"vmZaPD.pokaz_upload_pliku=!vmZaPD.pokaz_upload_pliku\" style=\"display: inline-block\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Dodaj plik</button><dodawanie-plikow ng-show=\"vmZaPD.pokaz_upload_pliku==true\" files=\"pliki\"></dodawanie-plikow></div></div><div style=\"margin: 40px 0 20px 0\" class=\"{{vmZaPD.bootstrapKlasa}}\"><button class=\"btn btn-primary\" ng-click=\"vmZaPD.zapisz(pliki)\" ng-disabled=\"dodawaniePliku.$invalid || vmZaPD.plik.tytul.length < 4\"><span class=\"ng-binding\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Zapisz</span></button> <button class=\"btn btn-default\" ui-sref=\"home.subMain.zarzadzaniePlikami\"><span class=\"ng-binding\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Anuluj</span></button></div></form></div></div></div>");
$templateCache.put("app/home/zarzadzaniePlikami/edycja.zarzadzaniePlikami.html","<div class=\"content\"><div class=\"pane23\"><h2>Edycja pliku</h2><div class=\"box23\" style=\"margin-bottom: 0; margin-left: 10px;\"><obsluga-bledow wiadomosci-tablica=\"vmZaPE.odpowiedziSerwera\"></obsluga-bledow><form name=\"edycjaPliku\" novalidate=\"\"><table style=\"width: 400px;margin-top: 20px;\" class=\"bootstrap-iso-paper\"><tr><td style=\"max-width: 100px;\"><label for=\"nazwa\">Nazwa</label></td><td><input class=\"form-control\" id=\"nazwa\" name=\"nazwa\" style=\"width:350px;margin-bottom: 10px;\" ng-model=\"vmZaPE.plik.tytul\" type=\"text\"> <span ng-show=\"edycjaPliku.nazwa.$touched && vmZaPE.plik.tytul.length < 4\" style=\"color: crimson;\">Nazwa jest wymagana.</span></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"kategoria\">Kategoria</label></td><td><select type=\"text\" id=\"kategoria\" style=\"min-width: 350px;\" ng-model=\"vmZaPE.plik.kategoria\" ng-options=\"item.id as item.nazwa for item in vmZaPE.kategorie\" required=\"\"></select></td></tr><tr><td style=\"max-width: 120px;\"><label for=\"kolejnosc\">Kolejność</label></td><td><input style=\"min-width: 350px;\" type=\"number\" min=\"0\" max=\"1000\" step=\"1\" id=\"kolejnosc\" ng-model=\"vmZaPE.plik.kolejnosc\" required=\"\"></td></tr><tr><td style=\"max-width: 100px;\"><label for=\"opis\">Opis</label></td><td><textarea rows=\"4\" style=\"min-width: 350px;\" type=\"text\" id=\"opis\" ng-model=\"vmZaPE.plik.opis\"></textarea> <span ng-show=\"edycjaPliku.opis.$touched && vmZaPE.plik.opis.length < 4\" style=\"color: crimson;\">Opis jest wymagany.</span></td></tr></table><div style=\"max-width:450px;margin-top: 20px;\" class=\"{{vmZaPE.bootstrapKlasa}}\"><p><b>Powiazane pliki:</b></p><div style=\"padding-left: 20px;\"><table class=\"minetable\" style=\"margin-bottom: 10px;\"><tr ng-repeat=\"plik in vmZaPE.plik.file\"><td style=\"padding: 10px; min-width: 400px;\"><a target=\"_blank\" ng-click=\"vmZaPE.getFile(plik)\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{plik.nazwaPliku}}</a></td><td style=\"padding: 10px;min-width: 46px;\"><button type=\"button\" class=\"btn btn-danger btn-sm\" style=\"display: inline-block\" ng-click=\"vmZaPE.usunPowiazanyPlik(plik.id)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></table><div style=\"padding-bottom: 10px;\"><button class=\"btn btn-sm btn-default\" ng-click=\"vmZaPE.pokaz_upload_pliku=!vmZaPE.pokaz_upload_pliku\" style=\"display: inline-block;\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Dodaj plik</button></div><dodawanie-plikow ng-show=\"vmZaPE.pokaz_upload_pliku==true\" files=\"pliki\"></dodawanie-plikow></div></div><div style=\"margin: 40px 0 20px 0\" class=\"{{vmZaPE.bootstrapKlasa}}\"><button class=\"btn btn-primary\" ng-click=\"vmZaPE.zapisz(pliki)\"><span class=\"ng-binding\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Zapisz</span></button> <button class=\"btn btn-default\" ui-sref=\"home.subMain.zarzadzaniePlikami\"><span class=\"ng-binding\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Anuluj</span></button></div></form></div></div><div class=\"pane13\"><div class=\"boxT\" style=\"margin-top: 10px;\"><p>Kliknięcie przycisku usuń w tabelce sprawi że aktualny załącznik zostanie usunięty.<br>Aby usunąć plik całkowicie, bez możliwości przyszłej aktualizacji kliknij <a style=\"color: #0a6ebd\" ng-click=\"vmZaPE.usunPlik()\"><u>tutaj</u></a>.</p></div></div></div>");
$templateCache.put("app/home/zarzadzaniePlikami/zarzPlikDodaj.html","<h2>Dodaj Plik</h2><div class=\"clearfix\"></div><div><form name=\"zarzPlikDodaj\"><div class=\"floatleft\" style=\"width:600px\"><p></p><h4>Nazwa</h4><p></p><input style=\"width:600px; text-align:left\" type=\"text\" ng-model=\"vmZarzPlik.plikDoDodania.Nazwa\" required=\"\"></div><div class=\"floatleft\" style=\"width:600px\"><p></p><h4>Kategoria</h4><p></p><select style=\"width:600px; text-align:left\" type=\"text\" ng-model=\"vmZarzPlik.plikDoDodania.Kategoria\" ng-options=\"item.id as item.nazwa for item in vmZarzPlik.kategorie\" required=\"\"></select></div><div class=\"floatleft\" style=\"width:600px\"><p></p><h4>Kolejność</h4><p></p><input style=\"width:600px; text-align:left\" type=\"number\" min=\"0\" max=\"1000\" step=\"1\" ng-model=\"vmZarzPlik.plikDoDodania.Kolejnosc\" required=\"\"></div><div class=\"floatleft\" style=\"width:600px;margin-bottom: 50px;\"><p></p><h4>Opis</h4><p></p><textarea rows=\"20\" style=\"width:600px; text-align:left\" type=\"text\" ng-model=\"vmZarzPlik.plikDoDodania.Opis\">\n\n            </textarea></div><div style=\"width:600px;margin-top: 20px\"><p></p><h4>Dodaj pliki</h4><p></p><dodawanie-plikow-bez-tokena uploader=\"vmZarzPlik.uploader\" nazwa-api=\"{{vmZarzPlik.apiPliki}}\" blad=\"error\" id=\"zarzadzaniePlikamiPliki\"></dodawanie-plikow-bez-tokena></div><div style=\"padding-top: 50px;\"><button ng-click=\"vmZarzPlik.dodajPlik()\" value=\"\" class=\"btn-send\" ng-disabled=\"zarzPlikDodaj.$invalid\"></button><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div></form></div>");
$templateCache.put("app/home/zarzadzaniePlikami/zarzPlikEdycja.html","<h2>Edytuj Plik</h2><div class=\"clearfix\"></div><div ng-init=\"vmZarzPlik.init()\"><form name=\"zarzPlikEdytuj\"><div class=\"floatleft\" style=\"width:600px\"><p></p><h4>Nazwa</h4><p></p><input style=\"width:600px; text-align:left\" type=\"text\" ng-model=\"vmZarzPlik.plikDoEdycji.Nazwa\" required=\"\"></div><div class=\"floatleft\" style=\"width:600px\"><p></p><h4>Kategoria</h4><p></p><select style=\"width:600px; text-align:left\" type=\"text\" ng-model=\"vmZarzPlik.plikDoEdycji.Kategoria\" ng-options=\"item.id as item.nazwa for item in vmZarzPlik.kategorie\" required=\"\"></select></div><div class=\"floatleft\" style=\"width:600px\"><p></p><h4>Kolejność</h4><p></p><input style=\"width:600px; text-align:left\" type=\"number\" min=\"0\" max=\"1000\" step=\"1\" ng-model=\"vmZarzPlik.plikDoEdycji.Kolejnosc\" required=\"\"></div><div class=\"floatleft\" style=\"width:600px;margin-bottom: 50px;\"><p></p><h4>Opis</h4><p></p><textarea rows=\"20\" style=\"width:600px; text-align:left\" type=\"text\" ng-model=\"vmZarzPlik.plikDoEdycji.Opis\"></textarea></div><div style=\"width:600px;\"><p></p><h4>Lista powiązanych plików:</h4><p></p><ol><li ng-repeat=\"element in vmZarzPlik.specFiles\"><a href=\"{{element.link}}\">{{element.nazwa}}</a> <a style=\"color:red;\" ng-click=\"vmZarzPlik.deleteFile(element.id,element.id_dok,element.nazwa)\">X</a></li></ol></div><div style=\"width:600px;\"><p></p><h4>Dodaj pliki</h4><p></p><dodawanie-plikow-bez-tokena uploader=\"vmZarzPlik.uploader\" nazwa-api=\"{{vmZarzPlik.apiPliki}}\" blad=\"error\" id=\"zarzadzaniePlikamiPliki\"></dodawanie-plikow-bez-tokena></div><div style=\"padding-top: 50px;\"><button ng-click=\"vmZarzPlik.updatePlik()\" value=\"\" class=\"btn-send\" ng-disabled=\"zarzPlikEdytuj.$invalid\"></button><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div></form></div>");
$templateCache.put("app/home/zarzadzaniePlikami/zarzadzaniePlikami.html","<div class=\"content\" ui-view=\"\" ng-init=\"vmZarzPlik.init()\"><h2 style=\"\">Zarządzanie plikami</h2><div style=\"margin-bottom: 20px;\" class=\"bootstrap-iso-paper\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"home.subMain.zarzadzaniePlikami.dodaj\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Dodaj plik</button></div><strefa-grid api=\"{{vmZarzPlik.api}}\" request-params=\"{{vmZarzPlik.getFilter()}}\" columns=\"vmZarzPlik.columns\" selected-item=\"vmZarzPlik.wybranyWiersz\" row-expand=\"true\" row-expand-template=\"{{vmZarzPlik.rowTemplate}}\" show-filter=\"true\" global-search=\"true\" ctrl=\"vmZarzPlik\"></strefa-grid></div><script type=\"text/x-kendo-template\" id=\"rowTemplate\"><div> <uib-tabset> <div class=\"container-fluid default-color\" > <p> {{ row.opis }}</p> </div> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"Modyfikacja\"><div class=\"text-center\" ng-click=\"row.expanded = true;\"> <button type=\"button\" class=\"btn btn-default btn-sm\" ui-sref=\"home.subMain.zarzadzaniePlikami.edycja({id:row.id})\"> <i class=\"fa fa-reply fa-flip-horizontal\" aria-hidden=\"true\"></i> Przejdź do pliku </button> </div></script>");
$templateCache.put("app/home/zgloszenia/blokada.html","<div style=\"width: 100%; margin-bottom: 70px;\"><h2>Zgłoszenia</h2><div style=\"width: 80%; margin: auto; text-align: center\" class=\"{{vmBK.bootstrapKlasa}} boxT\"><h5 ng-if=\"vmBK.blokada === \'UPPDO\'\">Dostęp do systemu zgłoszeń nie jest możliwy, z uwagi na brak <b>Umowy Powierzenia Przetwarzania Danych Osobowych</b>.<br><br>Prosimy o zawarcie umowy (zakładka <a ui-sref=\"home.subMain.umowy\" class=\"intext\">Twoje konto/ umowy</a>) lub o kontakt telefoniczny z Zespołem Administracyjnym.</h5><h5 style=\"text-align: center\" ng-if=\"vmBK.blokada === \'Faktury\'\">Ze względu na nieuregulowane płatności system zgłoszeń nie jest dostępny.<br><br>Prosimy o kontakt z Zespołem Obsługi Klienta.</h5></div></div>");
$templateCache.put("app/home/zgloszenia/dodajKomentarz.html","<div class=\"modal-header\" style=\"background: whitesmoke;border-bottom: 1px solid lightgrey\"><h4 class=\"modal-title\">Dodaj komentarz</h4></div><div class=\"modal-body\"><div ng-if=\"vmModal.security.jestPracownikiemMieszczanin()\" style=\"padding-bottom: 20px;\"><h4 style=\"margin-bottom: 10px; margin-top: 0;\">Typ komentarza</h4><div class=\"{{vmModal.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.flaga=false\"><i ng-if=\"vmModal.flaga==false\" class=\"fa fa-check\" aria-hidden=\"true\"></i> Zewnętrzny</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.flaga = true\"><i ng-if=\"vmModal.flaga==true\" class=\"fa fa-check\" aria-hidden=\"true\"></i> Wewnętrzny</button></div></div><h4 style=\"margin-top: 0;\">Treść komentarza</h4><textarea ng-model=\"vmModal.komentarz\" style=\"width:550px;height: 150px;resize: none;margin-bottom: 10px;\"></textarea></div><div class=\"modal-footer\" style=\"background: whitesmoke;border-top: 1px solid lightgrey\"><div style=\"float:right;margin-top: -10px;margin-bottom: -10px;\" class=\"{{vmModal.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.dodaj()\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Dodaj</button> <button type=\"button\" class=\"btn\" style=\"background-color: crimson; color: white\" ng-click=\"vmModal.zamknij()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Anuluj</button></div></div>");
$templateCache.put("app/home/zgloszenia/edytujZgloszenie.html","<div class=\"modal-header\" style=\"background: whitesmoke;border-bottom: 1px solid lightgrey\"><h4 class=\"modal-title\">Edytuj zgłoszenie</h4></div><div class=\"modal-body\"><table style=\"margin-left: 20px;\"><tr><td style=\"min-width: 100px;text-align: right\">Status</td><td style=\"padding-left: 10px;\"><select style=\"padding-left: 10px;\" ng-model=\"vmModal.zgloszenie.status\" ng-options=\"status for status in vmModal.statusy\" name=\"status\" id=\"status\"></select></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Tytuł</td><td style=\"padding-left: 10px;\"><input type=\"text\" style=\"width:550px;\" ng-model=\"vmModal.zgloszenie.tytul\"></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Treść</td><td style=\"padding-left: 10px;\"><textarea ng-model=\"vmModal.zgloszenie.opis\" style=\"width:550px;height: 100px;resize: none\"></textarea></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Typ</td><td style=\"padding-left: 10px;\"><select style=\"padding-left: 10px;\" ng-init=\"vmModal.zgloszenie.typ = vmModal.typy[vmModal.typy.indexOf(vmModal.zgloszenie.typ)]\" ng-model=\"vmModal.zgloszenie.typ\" ng-options=\"typ for typ in vmModal.typy\" name=\"status\" id=\"typ\"></select></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Moduł</td><td style=\"padding-left: 10px;\"><select style=\"padding-left: 10px;\" ng-model=\"vmModal.zgloszenie.modul\" ng-options=\"modul.kod as modul.nazwa for modul in vmModal.moduly\" name=\"modul\" id=\"modul\"></select></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Wersja EZN</td><td style=\"padding-left: 10px;\"><select style=\"padding-left: 10px;\" ng-model=\"vmModal.zgloszenie.wersjaEZN\" ng-options=\"wersja for wersja in vmModal.wersje\" name=\"status\" id=\"wersjaEZN\"></select></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Konsultant:</td><td style=\"padding-left: 10px;\"><select style=\"padding-left: 10px;\" ng-init=\"vmModal.konsultant = vmModal.pracownicy[0]\" ng-model=\"vmModal.konsultant\" ng-options=\"konsultant as konsultant.Kod for konsultant in vmModal.pracownicy\" name=\"konsultant\" id=\"konsultant\"></select></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Komponent</td><td style=\"padding-left: 10px;\"><input type=\"text\" style=\"width:550px;\" ng-model=\"vmModal.zgloszenie.komponent\"></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Sposób finansowania</td><td style=\"padding-left: 10px;\"><input type=\"text\" style=\"width:550px;\" ng-model=\"vmModal.zgloszenie.sposobFinansowania\"></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Wiadomość w ZOD</td><td style=\"padding-left: 10px;\"><input type=\"text\" style=\"width:550px;\" ng-model=\"vmModal.zgloszenie.nazwaWiadomosciWZOD\"></td></tr><tr><td style=\"min-width: 100px;text-align: right\">Wiadomość w Trac</td><td style=\"padding-left: 10px;\"><input type=\"text\" style=\"width:550px;\" ng-model=\"vmModal.zgloszenie.zgloszenieWTrac\"></td></tr></table></div><div class=\"modal-footer\" style=\"background: whitesmoke;border-top: 1px solid lightgrey\"><div style=\"float:right\" class=\"{{vmModal.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.dodaj()\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Zmień</button> <button type=\"button\" class=\"btn\" style=\"background-color: crimson; color: white\" ng-click=\"vmModal.zamknij()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Anuluj</button></div></div>");
$templateCache.put("app/home/zgloszenia/przekazZgloszenie.html","<div class=\"modal-header\" style=\"background: whitesmoke;border-bottom: 1px solid lightgrey\"><h4 class=\"modal-title\">Przekaż zgłoszenie</h4></div><div class=\"modal-body\"><div><table><tr><td style=\"min-width: 100px;text-align: right\">Konsultant:</td><td style=\"padding-left: 10px;\"><select style=\"padding-left: 10px;\" ng-init=\"vmModal.konsultant = vmModal.pracownicy[0]\" ng-model=\"vmModal.konsultant\" ng-options=\"konsultant as konsultant.Kod for konsultant in vmModal.pracownicy\" name=\"konsultant\" id=\"konsultant\"></select></td></tr></table></div></div><div class=\"modal-footer\" style=\"background: whitesmoke;border-top: 1px solid lightgrey\"><div style=\"float:right;margin-top: -10px;margin-bottom: -10px;\" class=\"{{vmModal.bootstrapKlasa}}\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.dodaj()\"><i class=\"fa fa-share\" aria-hidden=\"true\"></i> Przekaż</button> <button type=\"button\" class=\"btn\" style=\"background-color: crimson; color: white\" ng-click=\"vmModal.zamknij()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Anuluj</button></div></div>");
$templateCache.put("app/home/zgloszenia/usunKomentarz.html","<div class=\"modal-header\"><h4 class=\"modal-title\">Czy na pewno chcesz usunąć ten komentarz?</h4></div><div class=\"modal-body\">{{vmModal.komentarz}}</div><div class=\"modal-footer\"><div style=\"float:right\" class=\"{{vmModal.bootstrapKlasa}}\"><button type=\"button\" class=\"btn\" style=\"background-color: crimson; color: white\" ng-click=\"vmModal.dodaj()\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i> Usuń</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.zamknij()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Nie usuwaj</button></div></div>");
$templateCache.put("app/home/zgloszenia/zgloszenia.html","<ui-view><div ng-if=\"vmZgloszenia.czySubUser\" ng-init=\"vmZgloszenia.init()\"><div style=\"width: 100%; margin-bottom: 70px;\"><h2>Zgłoszenia</h2><div style=\"margin-left: 10px;\" class=\"{{vmZgloszenia.bootstrapKlasa}}\" ng-if=\"vmZgloszenia.blokada\"><h4 style=\"text-align: center\">Ze względu na nieuregulowane płatności system zgłoszeń nie jest dostępny.<br>Prosimy o kontakt z Zespołem Obsługi Klienta pod numerem telefonu ...</h4></div><div style=\"margin-left: 10px;\" class=\"{{vmZgloszenia.bootstrapKlasa}}\" ng-if=\"!vmZgloszenia.blokada\"><p style=\"float: left;color: black;\">Wybierz jedną z dostępnych opcji</p><p style=\"float: right;margin-right: 50px;\"><a ui-sref=\"home.subMain.zgloszenia.listaKlienta\" style=\"color:#113355;\">lub zobacz zgłoszenia</a> <span ng-hide=\"vmZgloszenia.serwisZgloszen.liczbaZgloszen < 1\" class=\"badge\" style=\"margin-left: 5px;margin-top: -3px;background-color: #00a2eb\">{{vmZgloszenia.serwisZgloszen.liczbaZgloszen}}</span></p></div></div><div style=\"\" class=\"panefull\" ng-if=\"!vmZgloszenia.blokada\"><div style=\";margin-left: 18px;\"><a ng-click=\"vmZgloszenia.przejdzDoTworzeniaZgloszenia(\'Zaproponuj zmianę\')\"><div style=\"display: inline-block;float: left\"><i style=\"\" class=\"fa fa-lightbulb-o fa-3x\"></i></div><div style=\"padding-left: 52px;\"><div style=\"display: inline-block;\"><p>Zaproponuj zmianę</p></div><div style=\"margin: 0\" class=\"plikiKomentarz\"><p>Jeżeli masz pomysł na rozwój systemów, powiedz nam o tym</p></div></div></a></div><div style=\"margin-top: 20px;margin-left: 10px;\"><a ng-click=\"vmZgloszenia.przejdzDoTworzeniaZgloszenia(\'Zgłoś problem\')\"><div style=\"display: inline-block;float: left\"><i style=\"\" class=\"fa fa-bug fa-3x\"></i></div><div style=\"padding-left: 60px;\"><div style=\"display: inline-block;\"><p>Zgłoś problem</p></div><div style=\"margin: 0\" class=\"plikiKomentarz\"><p>Jeżeli coś nie działa tak, jak powinno</p></div></div></a></div><div style=\"margin-top: 20px;margin-left: 10px;\"><a ng-click=\"vmZgloszenia.przejdzDoTworzeniaZgloszenia(\'Zgłoś potrzebę Konsultacji\')\"><div style=\"display: inline-block;float: left\"><i style=\"\" class=\"fa fa-headphones fa-3x\"></i></div><div style=\"padding-left: 60px;\"><div style=\"display: inline-block;\"><p>Zgłoś potrzebę konsultacji</p></div><div style=\"margin: 0\" class=\"plikiKomentarz\"><p>Jeżeli chcesz skorzystać z pomocy naszych konsultantów</p></div></div></a></div><div style=\"margin-top: 20px;margin-left: 12px;\"><a ng-click=\"vmZgloszenia.przejdzDoTworzeniaZgloszenia(\'Złóż zamówienie\')\"><div style=\"display: inline-block;float: left\"><i style=\"\" class=\"fa fa-file-text-o fa-3x\"></i></div><div style=\"padding-left: 58px;\"><div style=\"display: inline-block;\"><p>Złóż zamówienie / Przekaż informację</p></div><div style=\"margin: 0\" class=\"plikiKomentarz\"><p>Jeżeli coś jeszcze możemy dla Ciebie zrobić</p></div></div></a></div><div style=\"margin-top: 20px;margin-left: 12px; float: left;\"><a ng-click=\"vmZgloszenia.przejdzDoTworzeniaZgloszenia(\'Pomoc techniczna\')\"><div style=\"display: inline-block;float: left\"><i style=\"\" class=\"fa fa-wrench fa-3x\"></i></div><div style=\"padding-left: 58px;\"><div style=\"display: inline-block;\"><p>Zgłoś potrzebę pomocy technicznej</p></div><div style=\"margin: 0\" class=\"plikiKomentarz\"><p>Jeśli potrzebujesz pomocy serwisanta przy instalacji lub aktualizacji</p></div></div></a></div><div class=\"boxT\" style=\"float: right; margin-top: 30px\"><table><tr></tr><td><a class=\"fa fa-video-camera\" ui-sref=\"home.subMain.player({film: \'zgloszenie\'})\" style=\"padding-right: 10px; font-size: large\"></a></td><td><p><a ui-sref=\"home.subMain.player({film: \'zgloszenie\'})\">Jak dodać zgłoszenie w Strefie Klienta?</a></p></td></table></div></div></div></ui-view>");
$templateCache.put("app/home/zgloszenia/zgloszenia.kartaZgloszeniaKlienta.html","<div class=\"{{vmZglKarKli.bootstrapKlasa}}\" ng-if=\"vmZglKarKli.dostepDoBety.info()==true\" ng-init=\"vmZglKarKli.init()\"><div style=\"padding-top: 30px;\"><i ng-if=\"vmZglKarKli.zgloszenie.chronione\" class=\"fa fa-shield\" style=\"font-size: 18px; color:crimson; margin-top: 2px; margin-right: 10px;\" uib-tooltip=\"Zgłoszenie widzi tylko osoba zgłaszająca\" tooltip-placement=\"right\" aria-hidden=\"true\"></i><a>{{\'#\' + vmZglKarKli.numerZgloszenia}}</a><p style=\"margin-top: 5px;\"><b>{{vmZglKarKli.zgloszenie.tytul}}</b> <span style=\"margin-left: 10px; cursor: pointer;\" ng-if=\"vmZglKarKli.zgloszenie.poczekalnia\" ng-click=\"vmZglKarKli.pokazInfoPoczekalni()\"><span class=\"label label-warning\" style=\"font-size: 10px;\">Poczekalnia <i aria-hidden=\"true\" class=\"fa fa-info-circle\"></i></span></span> <span style=\"margin-left: 10px;\"><span style=\"font-size: 10px;\" ng-class=\"{\'label-danger\':vmZglKarKli.zgloszenie.status === \'Oczekuje na klienta\', \'label-grey\': vmZglKarKli.zgloszenie.status === \'Zamknięte\', \'label-success\': [\'Zamknięte\',\'Oczekuje na klienta\'].indexOf(vmZglKarKli.zgloszenie.status) === -1 }\" class=\"label\">{{vmZglKarKli.zgloszenie.status}}</span></span> <span class=\"help-block\" ng-if=\"vmZglKarKli.zgloszenie.utworzone_przez_prac_m\">Zgłoszenie utworzone przez pracownika firmy Mieszczanin</span></p></div><obsluga-bledow wiadomosci-tablica=\"vmZglKarKli.odpowiedziSerwera\"></obsluga-bledow><div style=\"width: 65%;display: inline-block; float: left\"><div id=\"komentarz\" style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; min-height: 225px;\" ng-if=\"[\'Odrzucone\', \'Zmieniona kategoria\'].indexOf(vmZglKarKli.zgloszenie.status)===-1\"><div id=\"dodajKomentarz\" style=\"background-color: white;margin-top: -18px;margin-left:10px;padding: 10px;z-index: 1;width: 130px;\">Dodaj Komentarz</div><div ng-if=\"!vmZglKarKli.czySubUser\" style=\"text-align: center\"><h5 style=\"padding-top: 50px\">Dodawanie komentarzy jest możliwe tylko z kont pracowników.</h5></div><div ng-if=\"vmZglKarKli.czySubUser && vmZglKarKli.czyZamkniete === false && vmZglKarKli.zgloszenie.bezMozliwosciPrzywrocenia===false\" style=\"text-align: center\"><h5 style=\"padding: 40px 20px 0px 20px\">Zgłoszenie zostało zamknięte. Jeżli uważasz, że coś jeszcze jest do poprawy, możesz je przywrócić. Pamiętaj o wpisaniu w komentarzu szczegółowych informacji o przyczynie przywrócenia.</h5></div><div ng-if=\"vmZglKarKli.czySubUser && (vmZglKarKli.czyZamkniete === true || vmZglKarKli.zgloszenie.bezMozliwosciPrzywrocenia===true)\" style=\"text-align: center\"><h5 style=\"padding: 10px 10px 0px 10px;\">Zgodnie z zapisami łączących nas regulaminów (Ogólne Warunki Sprzedaży, Warunki Gwarancji, Regulamin Usług Serwisowych) minął czas na zgłoszenie uwag do wykonanej usługi. Proszę utworzyć nowe zgłoszenie.</h5></div><div ng-if=\"vmZglKarKli.czySubUser\"><textarea id=\"text\" lang=\"pl\" style=\"width: 600px;min-height: 150px;resize: none;margin-left:10px;margin-right:10px;margin-bottom:10px;padding: 10px;background: whitesmoke;\" ng-model=\"vmZglKarKli.komentarz\" ng-if=\"vmZglKarKli.czyZamkniete === null\">\n            </textarea><div class=\"row\"><div class=\"col-xs-8\" style=\"padding-left: 25px;\" ng-if=\"(vmZglKarKli.czyZamkniete === false && vmZglKarKli.zgloszenie.bezMozliwosciPrzywrocenia === false) || vmZglKarKli.czyZamkniete === null\"><button class=\"btn btn-default\" ng-disabled=\"schowaj\" ng-click=\"vmZglKarKli.dodajDokumenty=true\" ng-show=\"!vmZglKarKli.dodajDokumenty\"><span class=\"ng-binding\">Dodaj załączniki</span></button><dodawanie-plikow ng-show=\"vmZglKarKli.dodajDokumenty==true\" files=\"vmZglKarKli.uploadPliki\"></dodawanie-plikow></div><div class=\"col-xs-4\"><button type=\"button\" class=\"btn\" style=\"background-color: #0a6ebd;color: white;float: right; margin-right: 10px;\" ng-click=\"vmZglKarKli.dodajKomentarz(vmZglKarKli.uploadPliki)\" ng-if=\"(vmZglKarKli.czyZamkniete === false && vmZglKarKli.zgloszenie.bezMozliwosciPrzywrocenia === false) || vmZglKarKli.czyZamkniete === null\" ng-class=\"{\'disabled\': vmZglKarKli.komentarz.length<=0 && vmZglKarKli.czyZamkniete === null }\"><span ng-if=\"vmZglKarKli.czyZamkniete === false && vmZglKarKli.zgloszenie.bezMozliwosciPrzywrocenia === false\">Przywróć zgłoszenie</span> <span ng-if=\"vmZglKarKli.czyZamkniete === null\"><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i> Wyślij komentarz</span></button></div></div></div></div><div style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; min-height: 100px;\"><div id=\"opis\" style=\"background-color: white;margin-top: -12px;margin-left:10px;padding: 10px;z-index: 1;width: 50px;\">Opis</div><div style=\"padding:10px; width:100%;min-height: 40px\"><div><p style=\"font-size: large; padding-left: 10px\">{{vmZglKarKli.zgloszenie.klientNazwa}} {{vmZglKarKli.zgloszenie.dataUtworzenia | date: \'dd.MM.yyyy HH.mm\'}}</p></div><div style=\"padding: 20px; line-height: 1.4\"><span ng-bind-html=\"vmZglKarKli.getTrustedHtml(vmZglKarKli.zgloszenie.opis)\"></span></div><div ng-if=\"vmZglKarKli.pliki.length>0\"><hr><div style=\"line-height: 150%;display: inline-block;margin: 0 5px;padding-bottom: 10px;\" ng-repeat=\"plik in vmZglKarKli.pliki\"><a target=\"_blank\" ng-click=\"vmZglKarKli.getfile(plik)\">{{plik.nazwaPliku}}</a></div></div></div></div><div style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; min-height: 50px;\"><div id=\"komentarze\" style=\"background-color: white;margin-top: -18px;margin-left:10px;padding: 10px;z-index: 1;width: 90px;\">Aktywność</div><div style=\"margin-top: -1px; min-height: 100px; color:#11335A; padding: 0\"><div class=\"comment\" id=\"{{\'kom\'+komentarz.id}}\" ng-repeat=\"komentarz in vmZglKarKli.komentarze | orderBy: \'-dataDodania\'\" ng-mouseenter=\"vmZglKarKli.podswKomentarza[vmZglKarKli.komentarze.indexOf(komentarz)]=true\" ng-mouseleave=\"vmZglKarKli.podswKomentarza[vmZglKarKli.komentarze.indexOf(komentarz)]=false\" ng-if=\"!komentarz.flaga || vmZglKarKli.security.jestPracownikiemMieszczanin()\"><div class=\"comment-header\" ng-if=\"!komentarz.informacjaSystemowa\"><i class=\"fa fa-user-circle fa-lg\" aria-hidden=\"true\"></i> <b>{{komentarz.uzytkownikNazwa}}</b> dodał(a) komentarz - {{komentarz.dataDodania | date:\'dd.MM.yyyy HH:mm\'}}</div><div class=\"comment-flag\" ng-if=\"!komentarz.informacjaSystemowa\"><span class=\"label label-default\" style=\"font-size: 10px;\" ng-if=\"komentarz.flaga==true && !komentarz.informacjaSystemowa\">Wewnętrzny</span></div><div class=\"comment-body\" ng-if=\"!komentarz.informacjaSystemowa\"><div style=\"margin: 0!important; padding: 0\"><span ng-bind-html=\"komentarz.tresc | trustAsHtml\"></span></div><div style=\"margin: 0;white-space: normal\" ng-if=\"(vmZglKarKli.pliki | filter: {idKomentarza: komentarz.id}).length>0\"><hr style=\"margin: 10px 0 0;padding: 5px;\"><a ng-repeat=\"plik in vmZglKarKli.pliki | filter: {idKomentarza: komentarz.id}\" style=\"padding-right: 10px;\" target=\"_blank\" ng-click=\"vmZglKarKli.getfile(plik)\">{{plik.nazwaPliku}}</a></div></div><div class=\"system-comment-body\" ng-if=\"komentarz.informacjaSystemowa\"><div style=\"margin: 0!important; padding: 0;white-space: normal;color: grey\">{{komentarz.dataDodania | date:\'dd.MM.yyyy HH:mm\'}}<br><br><span style=\"display: inline-block;padding-right: 5px;\" ng-bind-html=\"komentarz.tresc | trustAsHtml\"></span><br><br>{{vmZglKarKli.statusService.dajOpis(komentarz.tresc, vmZglKarKli.zgloszenie.typ, vmZglKarKli.zgloszenie.powodZamkniecia)}}</div></div><div style=\"padding-bottom: 10px;\"><div ng-if=\"komentarz.idOferty !== null && vmZglKarKli.ofertyLista.length > 0 && (vmZglKarKli.oferty[komentarz.idOferty] === null || vmZglKarKli.oferty[komentarz.idOferty] === undefined)\" style=\"color: grey\">Oferta aktualnie niedostępna do podglądu.</div><div ng-if=\"komentarz.idOferty !== null && vmZglKarKli.oferty[komentarz.idOferty] !== undefined && vmZglKarKli.ladowanieOfert === false\" style=\"width: 95%;\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmZglKarKli.pokazOferte(vmZglKarKli.oferty[komentarz.idOferty])\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Pokaż ofertę</button></div><div ng-if=\"komentarz.idOferty !== null && vmZglKarKli.ladowanieOfert === true\"><i class=\"fa fa-spinner fa-spin fa-fw\" aria-hidden=\"true\"></i> Pobieranie oferty</div></div></div></div></div></div><div style=\"margin-left:20px;width: 32.5%;display: inline-block;float: right\"><div style=\"margin-top: 20px;border: 1px solid lightgrey; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; padding: 10px;min-height: 100px;\"><div id=\"szczegoly\" style=\"background-color: white;margin-top: -28px;padding: 10px;z-index: 1;width: 85px;\">Szczegóły</div><table style=\"width: 100%\"><tr><td style=\"width:30%;\"><span style=\"margin-left: 2px;\">Typ:</span></td><td style=\"width:70%;\"><div style=\"width: 20px;display: inline-block;padding-left:2px;text-align: center\"><i class=\"{{\'fa \'+vmZglKarKli.ikonaTypu[vmZglKarKli.zgloszenie.typ].toString()+ \' fa-lg\'}}\"></i></div><div style=\"display: inline-block;margin-left: 7px;\">{{(vmZglKarKli.zgloszenie.typ === \'Zamówienie\') ? vmZglKarKli.zgloszenie.typ + \' / Informacja\' : vmZglKarKli.zgloszenie.typ}}</div></td></tr><tr ng-if=\"vmZglKarKli.zgloszenie.modul !== null\"><td style=\"width:30%;padding-top: 18px;\"><span style=\"margin-left: 2px;\">Moduł:</span></td><td style=\"width:70%;padding-top: 18px; display: inline;\"><div style=\"margin-top: -3px;float: left\" class=\"{{vmZglKarKli.zgloszenie.modul.ikona}}\"></div><span>{{vmZglKarKli.zgloszenie.modul.nazwa}}</span></td></tr><tr ng-if=\"vmZglKarKli.zgloszenie.wersjaEZN !== null\"><td style=\"width:30%;padding-top: 18px;\"><span style=\"margin-left: 2px;\">Wersja:</span></td><td style=\"width:70%;padding-top: 18px;\"><span>{{vmZglKarKli.zgloszenie.wersjaEZN}}{{vmZglKarKli.zgloszenie.wersjaUpdPack}}</span></td></tr><tr ng-if=\"vmZglKarKli.zgloszenie.nazwaLokalizacji.length>0\"><td style=\"width:30%;padding-top: 18px;padding-bottom: 5px;\"><span style=\"margin-left: 2px;\">Lokalizacja:</span></td><td style=\"width:70%;padding-top: 18px;padding-bottom: 5px;\">{{vmZglKarKli.zgloszenie.nazwaLokalizacji.substr(0, 30)}}</td></tr></table></div><div style=\"margin-top: 20px;border: 1px solid #dc143c; border-bottom:2px solid lightgrey;border-right:2px solid lightgrey; padding: 10px 0 10px 10px;min-height: 100px;\" ng-if=\"vmZglKarKli.zgloszenie.ankieta_hashid\"><div id=\"szczegoly\" style=\"color: #dc143c;background-color: white;margin-top: -28px;padding: 10px;z-index: 1;width: 70px;\">Ankieta</div><p style=\"text-align: left;\">Twoja opinia jest dla nas niezwykle ważna.<br><a ui-sref=\"home.ankieta({id: vmZglKarKli.zgloszenie.ankieta_hashid})\">Wypełnij anonimową ankietę (🕰️ 10 sekund)</a><br>i pomóż udoskonalić proces obsługi zgłoszeń.</p></div></div></div>");
$templateCache.put("app/home/zgloszenia/zgloszenia.listaKlienta.html","<div ng-if=\"vmZglLisKli.dostepDoBety.info()==true\"><div class=\"boxT\" style=\"float: right; display: inline\"><table><tr><td><a class=\"fa fa-file-pdf-o\" href=\"/assets/files/Instrukcja uruchomienia Systemu Zgloszen.pdf\" style=\"padding-right: 10px; font-size: large\"></a></td><td><p><a href=\"/assets/files/Instrukcja uruchomienia Systemu Zgloszen.pdf\">Instrukcja korzystania z systemu zgłoszeń</a></p></td></tr></table></div><h2>Zgłoszenia</h2><div ng-class=\"vmZglLisKli.bootstrapKlasa\"><div style=\"display: inline-block;\"><select style=\"padding-left: 10px;\" ng-model=\"vmZglLisKli.filtry.modul\" ng-options=\"modul.Kod as modul.Nazwa for modul in vmZglLisKli.licencje | unique: \'Kod\'\" ng-change=\"vmZglLisKli.filtruj()\" name=\"modul\" id=\"modul\"><option value=\"\" disabled=\"\" selected=\"\" hidden=\"\">--Moduł--</option></select><select style=\"width: 120px;padding-left: 10px; padding-right: 10px;\" ng-model=\"vmZglLisKli.filtry.status\" ng-options=\"status for status in [\'Wszystkie\', \'Otwarte\'].concat(vmZglLisKli.statusy)\" ng-change=\"vmZglLisKli.filtruj()\" name=\"status\" id=\"status\"><option value=\"\" disabled=\"\" selected=\"\" hidden=\"\">--Status--</option></select><select class=\"mineoption\" style=\"width: 180px;padding-left: 10px; padding-right: 10px;\" ng-model=\"vmZglLisKli.filtry.typ\" ng-options=\"typ for typ in [\'Wszystkie\'].concat(vmZglLisKli.typy)\" ng-change=\"vmZglLisKli.filtruj()\" name=\"typ\" id=\"typ\"><option value=\"\" disabled=\"\" selected=\"\" hidden=\"\">--Typ--</option></select></div><div style=\"display: inline-block;\"><div class=\"input-group\" style=\"margin-bottom: -10px; width: 400px;\"><input type=\"text\" class=\"form-control\" ng-model=\"vmZglLisKli.filtry.pasekWyszukiwania\" ng-keypress=\"$event.keyCode == 13 ? vmZglLisKli.filtruj() : null\" style=\"padding-left:10px;border-top: 1px solid lightgrey;border-left: 1px solid lightgrey;border-bottom-left-radius: 3px;border-top-left-radius: 3px;\" placeholder=\"szukaj\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\" style=\"box-shadow: none; border: 1px solid lightgrey;border-left: none;\" ng-click=\"vmZglLisKli.filtruj()\"><i class=\"fa fa-search fa-lg\" aria-hidden=\"true\"></i></button></span></div></div></div><div><div style=\"padding-top: 30px;\"><div style=\"margin-top: 20px;\" ng-repeat=\"lokalizacja in vmZglLisKli.lokalizacje\"><h3 style=\"margin-top: -4px; font-size: 20px!important; color: #113355\">{{lokalizacja.NazwaLok}}</h3><div class=\"{{vmZglLisKli.bootstrapKlasa}}\"><table class=\"tab-auto\" style=\"width: 100%\"><tr><th width=\"94px\">Numer<order-zgloszenia pole=\"\'id\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglLisKli.sortowanie\" on-select=\"vmZglLisKli.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"230px\">Opis<order-zgloszenia pole=\"\'opis\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglLisKli.sortowanie\" on-select=\"vmZglLisKli.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"160px\">Zgłaszający<order-zgloszenia pole=\"\'klientNazwa\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglLisKli.sortowanie\" on-select=\"vmZglLisKli.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th style=\"width:100px!important;\">Moduł<order-zgloszenia pole=\"\'modul\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglLisKli.sortowanie\" on-select=\"vmZglLisKli.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"113px\">Utworzone<order-zgloszenia pole=\"\'dataUtworzenia\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglLisKli.sortowanie\" on-select=\"vmZglLisKli.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"113px\">Zmienione<order-zgloszenia pole=\"\'dataZmiany\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglLisKli.sortowanie\" on-select=\"vmZglLisKli.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"74px\">Typ<order-zgloszenia pole=\"\'typ\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglLisKli.sortowanie\" on-select=\"vmZglLisKli.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"69px\">Status<order-zgloszenia pole=\"\'status\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglLisKli.sortowanie\" on-select=\"vmZglLisKli.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th></tr><tr ng-repeat=\"zgloszenie in vmZglLisKli.zgloszeniaPrzefiltrowane[lokalizacja.IdLok]\" style=\"cursor: pointer\"><td ng-click=\"vmZglLisKli.otworzZgloszenie(zgloszenie.id)\"><a ng-click=\"vmZglLisKli.otworzZgloszenie(zgloszenie.id)\">{{\'#\' + zgloszenie.id}}</a></td><td ng-click=\"vmZglLisKli.otworzZgloszenie(zgloszenie.id)\">{{zgloszenie.tytul}}</td><td ng-click=\"vmZglLisKli.otworzZgloszenie(zgloszenie.id)\"><span ng-if=\"zgloszenie.klientNazwa !== \'null null\'\">{{zgloszenie.klientNazwa}}</span></td><td ng-click=\"vmZglLisKli.otworzZgloszenie(zgloszenie.id)\"><div ng-style=\"(vmZglLisKli.isFirefox) && {\'margin-top\': \'-15px\'}\" ng-if=\"zgloszenie.modul !== null\"><div uib-tooltip=\"{{vmZglLisKli.programy[zgloszenie.modul.toUpperCase()].nazwa}}\" tooltip-placement=\"right\" style=\"margin-top: -3px; position: absolute; margin-left: -10px;\" class=\"{{vmZglLisKli.programy[zgloszenie.modul.toUpperCase()].ikona }}\"></div></div></td><td ng-click=\"vmZglLisKli.otworzZgloszenie(zgloszenie.id)\">{{zgloszenie.dataUtworzenia | date:\'dd.MM.yyyy\'}}</td><td ng-click=\"vmZglLisKli.otworzZgloszenie(zgloszenie.id)\">{{(zgloszenie.dataZmiany != null) ? (zgloszenie.dataZmiany | date:\'dd.MM.yyyy\') : \'---\'}}</td><td ng-click=\"vmZglLisKli.otworzZgloszenie(zgloszenie.id)\"><div uib-tooltip=\"{{(zgloszenie.typ === \'Zamówienie\') ? zgloszenie.typ + \' / Informacja\' : zgloszenie.typ}}\" tooltip-placement=\"right\" style=\"margin-top: 3px;\"><i style=\"\" class=\"{{\'fa \'+vmZglLisKli.ikonaTypu[zgloszenie.typ].toString()+ \' fa-lg\'}}\"></i></div></td><td><span class=\"label label-success\" ng-click=\"vmZglLisKli.pokazInfoPoczekalni(zgloszenie)\" ng-class=\"{ \'label label-warning\': zgloszenie.poczekalnia === true, \'label label-danger\':zgloszenie.status === \'Oczekuje na klienta\', \'label label-grey\': zgloszenie.status === \'Zamknięte\' }\">{{zgloszenie.poczekalnia !== true ? zgloszenie.status : \'Poczekalnia\'}} <i style=\"\" class=\"fa fa-info-circle\" ng-if=\"zgloszenie.poczekalnia === true\"></i></span></td></tr></table><uib-pagination first-text=\"{{lokalizacja.IdLok}}\" previous-text=\"«\" next-text=\"»\" total-items=\"vmZglLisKli.zgloszeniaPrzefiltrowane[lokalizacja.IdLok].meta.count\" ng-model-options=\"{ getterSetter: true }\" max-size=\"10\" items-per-page=\"vmZglLisKli.filtryTab[lokalizacja.IdLok].pageSize\" ng-model=\"vmZglLisKli.filtryTab[lokalizacja.IdLok].page\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"vmZglLisKli.filterOne(lokalizacja.IdLok, vmZglLisKli.filtryTab[lokalizacja.IdLok].ordering)\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/home/zgloszenia/zgloszenia.nowe_zgloszenie.html","<div ng-init=\"vmZglNowe.init()\"><div class=\"{{vmZglNowe.bootstrapKlasa}}\" style=\"margin-top: 30px; width: 100%;\" ng-if=\"vmZglNowe.loaded==false && vmZglNowe.dostepDoBety.info()==true\"><div style=\"margin-bottom: 25px;\"><i class=\"{{\'fa \' + vmZglNowe.ikonaTypu[vmZglNowe.typ]}}\" style=\"font-size: 24px; vertical-align: middle; margin-right: 10px; color: #135;\"></i> <span style=\"font-size: 20px; vertical-align: middle; color: #135; font-family: heading;\">{{vmZglNowe.typ}}</span></div><obsluga-bledow wiadomosci-tablica=\"vmZglNowe.odpowiedziSerwera\"></obsluga-bledow><div ng-if=\"vmZglNowe.brakDanychZglaszajacego\" class=\"alert alert-danger\"><i class=\"fa fa-exclamation-circle\" style=\"margin-right: 5px;\"></i> Aby wysłać zgłoszenie, uzupełnij brakujące dane w profilu: {{vmZglNowe.brakujaceDaneZglaszajacego.join(\', \')}}. <a ui-sref=\"home.subMain.profil\"><strong>Przejdź do profilu</strong></a></div><form name=\"vmZglNowe.noweZgloszenie\" class=\"full-width-form\" novalidate=\"\"><div><div style=\"width: 62%; display: inline-block; float: left;\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><i class=\"fa fa-pencil\" style=\"margin-right: 6px;\"></i>Opis zgłoszenia</div><div class=\"panel-body\"><div class=\"form-group\" ng-class=\"{\'has-error\': vmZglNowe.noweZgloszenie.tytul.$touched && vmZglNowe.noweZgloszenie.tytul.$invalid}\"><label for=\"tytul\">Tytuł <span style=\"color: red;\">*</span> <a style=\"text-decoration: none; margin-left: 3px;\" tooltip-placement=\"right\" data-toggle=\"tooltip\" title=\"Tytuł powinien w skrócie opisywać problem\" class=\"glyphicon glyphicon-question-sign\"></a></label> <input name=\"tytul\" id=\"tytul\" type=\"text\" class=\"form-control\" ng-model=\"vmZglNowe.pola.tytul\" required=\"\" style=\"display: block; width: 100%;\"><p style=\"{{(vmZglNowe.noweZgloszenie.tytul.$touched && vmZglNowe.noweZgloszenie.tytul.$invalid) ? \'display:inline-block!important\' : \'display:none\'}}\" class=\"help-block\">Tytuł jest wymagany.</p></div><div class=\"form-group\" style=\"margin-bottom: 5px;\" ng-class=\"{\'has-error\': vmZglNowe.noweZgloszenie.opis.$touched && vmZglNowe.noweZgloszenie.opis.$invalid}\"><label for=\"opis\">Opis <span style=\"color: red;\">*</span></label> <textarea name=\"opis\" id=\"opis\" class=\"form-control\" style=\"height: 150px; resize: vertical;\" ng-model=\"vmZglNowe.pola.opis\" required=\"\" ng-minlength=\"30\" ng-model-options=\"{allowInvalid: true}\"></textarea> <span class=\"help-block\" style=\"margin-bottom: 0; font-size: 12px;\">Minimalna liczba znaków: 30. Obecnie: {{vmZglNowe.pola.opis.length || 0}}</span><p style=\"{{(vmZglNowe.noweZgloszenie.opis.$touched && vmZglNowe.noweZgloszenie.opis.$error.required) ? \'display:inline-block!important\' : \'display:none\'}}\" class=\"help-block\">Opis jest wymagany.</p></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><i class=\"fa fa-desktop\" style=\"margin-right: 6px;\"></i>Lokalizacja i oprogramowanie</div><div class=\"panel-body\"><div class=\"form-group\" ng-class=\"{\'has-error\': vmZglNowe.noweZgloszenie.lokalizacja.$touched && vmZglNowe.noweZgloszenie.lokalizacja.$invalid}\"><label for=\"lokalizacja\">Lokalizacja <span style=\"color: red;\">*</span></label><select id=\"lokalizacja\" name=\"lokalizacja\" class=\"form-control\" ng-model=\"vmZglNowe.lokalizacja\" ng-options=\"lok as lok.NazwaLok for lok in vmZglNowe.lokalizacje\" required=\"\" ng-change=\"vmZglNowe.updateWersje()\"></select><p style=\"{{(vmZglNowe.noweZgloszenie.lokalizacja.$touched && vmZglNowe.noweZgloszenie.lokalizacja.$invalid) ? \'display:inline-block!important\' : \'display:none\'}}\" class=\"help-block\">Lokalizacja jest wymagana.</p></div><div class=\"form-group\" ng-if=\"\'Pomoc techniczna\'.indexOf(vmZglNowe.typ)===-1\" ng-class=\"{\'has-error\': vmZglNowe.noweZgloszenie.modul.$touched && vmZglNowe.noweZgloszenie.modul.$invalid}\"><label for=\"modul\">Moduł <span style=\"color: red;\">*</span></label><select id=\"modul\" name=\"modul\" class=\"form-control\" ng-model=\"vmZglNowe.pola.modul\" ng-options=\"lic.Kod as lic.Nazwa for lic in vmZglNowe.licencje | unique:\'Nazwa\'\" ng-required=\"[\'Złóż zamówienie\', \'Pomoc techniczna\'].indexOf(vmZglNowe.typ)==-1\" ng-change=\"vmZglNowe.onModulChange()\"></select><p style=\"{{(vmZglNowe.noweZgloszenie.modul.$touched && vmZglNowe.noweZgloszenie.modul.$invalid) ? \'display:inline-block!important\' : \'display:none\'}}\" class=\"help-block\">Moduł jest wymagany.</p></div><div class=\"form-group\" ng-if=\"[\'Złóż zamówienie\', \'Pomoc techniczna\'].indexOf(vmZglNowe.typ)===-1 && vmZglNowe.pola.modul && vmZglNowe.modulyWebowe.indexOf(vmZglNowe.pola.modul) === -1\"><label for=\"wersja\">Wersja EZN <span style=\"color: red;\">*</span></label><select id=\"wersja\" name=\"wersja\" class=\"form-control\" ng-model=\"vmZglNowe.pola.wersjaEZN\" ng-options=\"wersja for wersja in vmZglNowe.wersje\" required=\"\" ng-change=\"vmZglNowe.updateUpdPacki()\"></select></div><div class=\"form-group\" ng-if=\"[\'Złóż zamówienie\', \'Pomoc techniczna\'].indexOf(vmZglNowe.typ)===-1 && vmZglNowe.pola.modul && vmZglNowe.modulyWebowe.indexOf(vmZglNowe.pola.modul) === -1 && vmZglNowe.pola.wersjaEZN\"><label for=\"wersjaUpdPack\">Wersja UpdPack</label><select id=\"wersjaUpdPack\" name=\"wersjaUpdPack\" class=\"form-control\" ng-model=\"vmZglNowe.wersjaUpdPack\" ng-options=\"wersja.UpdPack for wersja in vmZglNowe.updPacki\"></select></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><i class=\"fa fa-paperclip\" style=\"margin-right: 6px;\"></i>Załączniki</div><div class=\"panel-body\"><button class=\"btn btn-default btn-sm\" ng-disabled=\"schowaj\" ng-click=\"dodajDokumenty=true\" ng-show=\"!dodajDokumenty\"><i class=\"fa fa-plus\" style=\"margin-right: 4px;\"></i>Dodaj załączniki</button><dodawanie-plikow ng-show=\"dodajDokumenty==true\" files=\"pliki\"></dodawanie-plikow></div></div></div><div style=\"width: 35%; display: inline-block; float: right;\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><i class=\"fa fa-list-ul\" style=\"margin-right: 6px;\"></i>Dodatkowe informacje</div><div class=\"panel-body\"><div class=\"checkbox\" ng-if=\"vmZglNowe.typ != \'Złóż zamówienie\'\" style=\"margin-top: 0;\"><label for=\"dotDanychOsobowych\" style=\"cursor: pointer;\"><input style=\"margin-right: 5px;\" id=\"dotDanychOsobowych\" name=\"dotDanychOsobowych\" ng-model=\"vmZglNowe.pola.dotDanychOsobowych\" type=\"checkbox\"> Dotyczy naruszenia ochrony danych osobowych</label></div><div class=\"checkbox\" ng-if=\"[\'Pomoc techniczna\', \'Zgłoś problem\'].indexOf(vmZglNowe.typ) !== -1\"><label for=\"dotyczyKonwersjiBazyDanych\" style=\"cursor: pointer;\"><input style=\"margin-right: 5px;\" id=\"dotyczyKonwersjiBazyDanych\" name=\"dotyczyKonwersjiBazyDanych\" ng-model=\"vmZglNowe.pola.dotyczyKonwersjiBazyDanych\" type=\"checkbox\"> Dotyczy konwersji bazy danych</label></div><div class=\"checkbox\" ng-if=\"vmZglNowe.pola.modul==\'e-kartoteka\'\"><label for=\"dotAplMobilna\" style=\"cursor: pointer;\"><input style=\"margin-right: 5px;\" id=\"dotAplMobilna\" name=\"dotAplMobilna\" ng-model=\"vmZglNowe.pola.dotAplMobilna\" type=\"checkbox\"> Dotyczy aplikacji mobilnej</label></div><div class=\"checkbox\" ng-if=\"[\'Złóż zamówienie\', \'Pomoc techniczna\'].indexOf(vmZglNowe.typ)===-1\"><label for=\"wydruk\" style=\"cursor: pointer;\"><input style=\"margin-right: 5px;\" id=\"wydruk\" name=\"wydruk\" ng-model=\"vmZglNowe.dotyczyWydruku\" value=\"0\" type=\"checkbox\"> Dotyczy wydruku</label></div><div class=\"form-group\" ng-if=\"vmZglNowe.dotyczyWydruku && vmZglNowe.typ!=\'Złóż zamówienie\'\" style=\"margin-left: 22px;\"><label for=\"symbolWydruku\">Symbol wydruku</label> <input id=\"symbolWydruku\" type=\"text\" class=\"form-control\" ng-model=\"vmZglNowe.pola.symbolWydruku\" style=\"display: block; width: 100%;\"></div><div class=\"checkbox\" ng-if=\"vmZglNowe.typ !== \'Złóż zamówienie\'\"><label for=\"chronione\" style=\"cursor: pointer;\"><input style=\"margin-right: 5px;\" id=\"chronione\" name=\"chronione\" ng-model=\"vmZglNowe.pola.chronione\" value=\"0\" type=\"checkbox\" ng-change=\"vmZglNowe.przelaczZgloszenieChronione()\"> Zgłoszenie chronione <a style=\"text-decoration: none; margin-left: 3px;\" tooltip-placement=\"right\" data-toggle=\"tooltip\" title=\"Dostęp do zgłoszenia ma tylko osoba wypełniająca\" class=\"glyphicon glyphicon-question-sign\"></a></label></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><i class=\"fa fa-phone\" style=\"margin-right: 6px;\"></i>Kontakt</div><div class=\"panel-body\"><div class=\"form-group\" ng-if=\"!vmZglNowe.pola.chronione\" style=\"margin-bottom: 10px;\"><label>Osoba do kontaktu <a style=\"text-decoration: none; margin-left: 3px;\" tooltip-placement=\"right\" data-toggle=\"tooltip\" title=\"Wypełnij tylko jeśli mamy kontaktować się z kimś innym niż zgłaszający\" class=\"glyphicon glyphicon-question-sign\"></a></label><div class=\"radio\" style=\"margin-top: 5px;\"><label for=\"kontakt\" style=\"cursor: pointer;\"><input id=\"kontakt\" name=\"kontakt\" type=\"radio\" ng-model=\"vmZglNowe.osobaDoKontaktu\" value=\"0\"> Zgłaszający</label></div><div class=\"radio\"><label for=\"kontakt2\" style=\"cursor: pointer;\"><input id=\"kontakt2\" name=\"kontakt\" type=\"radio\" ng-model=\"vmZglNowe.osobaDoKontaktu\" value=\"1\"> Inna osoba</label></div></div><div ng-if=\"vmZglNowe.osobaDoKontaktu==0\" style=\"margin-left: 20px; padding-left: 10px; border-left: 2px solid #e0e0e0; margin-bottom: 15px;\"><div class=\"form-group\"><label>Imię i Nazwisko</label><p class=\"form-control-static\">{{vmZglNowe.pola.klientNazwa}}</p></div><div class=\"form-group\"><label>Telefon</label><p class=\"form-control-static\">{{vmZglNowe.pola.klientTelefon}}</p></div><div class=\"form-group\" style=\"margin-bottom: 0;\"><label>e-mail</label><p class=\"form-control-static\">{{vmZglNowe.pola.klientEmail}}</p></div></div><div ng-if=\"vmZglNowe.osobaDoKontaktu==1\" style=\"margin-left: 20px; padding-left: 10px; border-left: 2px solid #e0e0e0; margin-bottom: 15px;\"><div class=\"form-group\" ng-class=\"{\'has-error\': vmZglNowe.noweZgloszenie.othername.$touched && vmZglNowe.noweZgloszenie.othername.$invalid}\"><label for=\"imie\">Imię i Nazwisko <span style=\"color: red;\">*</span></label> <input id=\"imie\" name=\"othername\" type=\"text\" class=\"form-control\" ng-model=\"vmZglNowe.pola.osDoKontaktuNazwa\" ng-required=\"vmZglNowe.osobaDoKontaktu==1\" style=\"display: block; width: 100%;\"><p style=\"{{(vmZglNowe.noweZgloszenie.othername.$touched && vmZglNowe.noweZgloszenie.othername.$invalid) ? \'display:inline-block!important\' : \'display:none\'}}\" class=\"help-block\">Imię i nazwisko jest wymagane.</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': vmZglNowe.noweZgloszenie.otherphone.$touched && vmZglNowe.noweZgloszenie.otherphone.$invalid}\"><label for=\"telefon\">Telefon <span style=\"color: red;\">*</span></label> <input id=\"telefon\" name=\"otherphone\" type=\"tel\" class=\"form-control\" ng-model=\"vmZglNowe.pola.osDoKontaktuTelefon\" ng-required=\"vmZglNowe.osobaDoKontaktu==1\" style=\"display: block; width: 100%;\"><p style=\"{{(vmZglNowe.noweZgloszenie.otherphone.$touched && vmZglNowe.noweZgloszenie.otherphone.$invalid) ? \'display:inline-block!important\' : \'display:none\'}}\" class=\"help-block\">Telefon jest wymagany.</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': vmZglNowe.noweZgloszenie.othermail.$touched && vmZglNowe.noweZgloszenie.othermail.$invalid}\"><label for=\"email\">e-mail <span style=\"color: red;\">*</span></label> <input id=\"email\" name=\"othermail\" type=\"email\" class=\"form-control\" ng-pattern=\"vmZglNowe.walidacjaEmail\" ng-model=\"vmZglNowe.pola.osDoKontaktuEmail\" ng-required=\"vmZglNowe.osobaDoKontaktu==1\" style=\"display: block; width: 100%;\"><p style=\"{{(vmZglNowe.noweZgloszenie.othermail.$touched && vmZglNowe.noweZgloszenie.othermail.$invalid) ? \'display:inline-block!important\' : \'display:none\'}}\" class=\"help-block\">Adres e-mail jest wymagany.</p></div></div><div class=\"form-group\" style=\"margin-bottom: 0;\"><label for=\"godziny_dostepu\">Najdogodniejsze dni i godziny dostępu</label> <input id=\"godziny_dostepu\" name=\"godziny_dostepu\" type=\"text\" class=\"form-control\" ng-model=\"vmZglNowe.pola.godziny_dostepu\" style=\"display: block; width: 100%;\"></div></div></div></div></div><div style=\"clear: both;\"></div><div ng-if=\"vmZglNowe.typ === \'Zgłoś problem\' && vmZglNowe.najnowszyUpdPack && (!vmZglNowe.wersjaUpdPack || vmZglNowe.wersjaUpdPack.UpdPack !== vmZglNowe.najnowszyUpdPack.UpdPack)\" class=\"alert alert-warning\"><i class=\"fa fa-info-circle\" style=\"margin-right: 5px;\"></i> Prosimy o pobranie najnowszej dostępnej wersji i weryfikacji czy problem nadal występuje</div><div style=\"margin-bottom: 40px;\"><button ng-click=\"vmZglNowe.send(pliki)\" class=\"btn\" style=\"background-color: #0a6ebd; color: white;\" ng-disabled=\"vmZglNowe.statusWysylania!==\'nie_wyslano\' || vmZglNowe.lokalizacja===\'\' || vmZglNowe.brakDanychZglaszajacego || vmZglNowe.noweZgloszenie.$invalid\"><i class=\"fa fa-check\" style=\"margin-right: 5px;\"></i>Utwórz zgłoszenie</button> <a ui-sref=\"home.subMain.zgloszenia\" class=\"btn btn-default\" style=\"margin-left: 10px;\">Anuluj</a></div></form></div></div>");
$templateCache.put("app/home/zgloszenia/zgloszenia.zamowienia.html","<div><div class=\"boxT\" style=\"float: right; display: inline\"><table><tr><td><a class=\"fa fa-file-pdf-o\" href=\"/assets/files/Instrukcja uruchomienia Systemu Zgloszen.pdf\" style=\"padding-right: 10px; font-size: large\"></a></td><td><p><a href=\"/assets/files/Instrukcja uruchomienia Systemu Zgloszen.pdf\">Instrukcja korzystania z systemu zgłoszeń</a></p></td></tr></table></div><h2>Zamówienia</h2><div ng-class=\"vmZglZ.bootstrapKlasa\"><div style=\"display: inline-block;\"><select style=\"padding-left: 10px;\" ng-model=\"vmZglZ.filtry.modul\" ng-options=\"modul.Kod as modul.Nazwa for modul in vmZglZ.licencje | unique: \'Kod\'\" ng-change=\"vmZglZ.filtruj()\" name=\"modul\" id=\"modul\"><option value=\"\" disabled=\"\" selected=\"\" hidden=\"\">--Moduł--</option></select><select style=\"width: 120px;padding-left: 10px; padding-right: 10px;\" ng-model=\"vmZglZ.filtry.status\" ng-options=\"status for status in [\'Wszystkie\', \'Otwarte\'].concat(vmZglZ.statusy)\" ng-change=\"vmZglZ.filtruj()\" name=\"status\" id=\"status\"><option value=\"\" disabled=\"\" selected=\"\" hidden=\"\">--Status--</option></select></div><div style=\"display: inline-block;\"><div class=\"input-group\" style=\"margin-bottom: -10px; width: 580px;\"><input type=\"text\" class=\"form-control\" ng-model=\"vmZglZ.filtry.pasekWyszukiwania\" ng-keypress=\"$event.keyCode == 13 ? vmZglZ.filtruj() : null\" style=\"padding-left:10px;border-top: 1px solid lightgrey;border-left: 1px solid lightgrey;border-bottom-left-radius: 3px;border-top-left-radius: 3px;\" placeholder=\"szukaj\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\" style=\"box-shadow: none; border: 1px solid lightgrey;border-left: none;\" ng-click=\"vmZglZ.filtruj()\"><i class=\"fa fa-search fa-lg\" aria-hidden=\"true\"></i></button></span></div></div></div><div><div style=\"padding-top: 30px;\"><div style=\"margin-top: 20px;\" ng-repeat=\"lokalizacja in vmZglZ.lokalizacje\"><h3 style=\"margin-top: -4px; font-size: 20px!important; color: #113355\">{{lokalizacja.NazwaLok}}</h3><div class=\"{{vmZglZ.bootstrapKlasa}}\"><table class=\"tab-auto\" style=\"width: 100%\"><tr><th width=\"94px\">Numer<order-zgloszenia pole=\"\'id\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglZ.sortowanie\" on-select=\"vmZglZ.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"230px\">Opis<order-zgloszenia pole=\"\'opis\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglZ.sortowanie\" on-select=\"vmZglZ.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"160px\">Zgłaszający<order-zgloszenia pole=\"\'klientNazwa\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglZ.sortowanie\" on-select=\"vmZglZ.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th style=\"width:100px!important;\">Moduł<order-zgloszenia pole=\"\'modul\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglZ.sortowanie\" on-select=\"vmZglZ.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"113px\">Utworzone<order-zgloszenia pole=\"\'dataUtworzenia\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglZ.sortowanie\" on-select=\"vmZglZ.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"113px\">Zmienione<order-zgloszenia pole=\"\'dataZmiany\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglZ.sortowanie\" on-select=\"vmZglZ.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"74px\">Typ<order-zgloszenia pole=\"\'typ\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglZ.sortowanie\" on-select=\"vmZglZ.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th><th width=\"69px\">Status<order-zgloszenia pole=\"\'status\'\" id-lok=\"lokalizacja.IdLok\" sortowanie=\"vmZglZ.sortowanie\" on-select=\"vmZglZ.zmienSortowanie(IdLok, pole)\"></order-zgloszenia></th></tr><tr ng-repeat=\"zgloszenie in vmZglZ.zgloszeniaPrzefiltrowane[lokalizacja.IdLok]\" style=\"cursor: pointer\" ng-click=\"vmZglZ.otworzZgloszenie(zgloszenie.id)\"><td><a ng-click=\"vmZglZ.otworzZgloszenie(zgloszenie.id)\">{{\'#\'+zgloszenie.id}}</a></td><td>{{zgloszenie.tytul}}</td><td><span ng-if=\"zgloszenie.klientNazwa !== \'null null\'\">{{zgloszenie.klientNazwa}}</span></td><td><div ng-style=\"(vmZglZ.isFirefox) && {\'margin-top\': \'-15px\'}\" ng-if=\"zgloszenie.modul !== null\"><div uib-tooltip=\"{{vmZglZ.programy[zgloszenie.modul.toUpperCase()].nazwa}}\" tooltip-placement=\"right\" style=\"margin-top: -3px; position: absolute; margin-left: -10px;\" class=\"{{vmZglZ.programy[zgloszenie.modul.toUpperCase()].ikona }}\"></div></div></td><td>{{zgloszenie.dataUtworzenia | date:\'dd.MM.yyyy\'}}</td><td>{{(zgloszenie.dataZmiany!=null)?(zgloszenie.dataZmiany | date:\'dd.MM.yyyy\'):\'---\'}}</td><td><div uib-tooltip=\"{{(zgloszenie.typ === \'Zamówienie\') ? zgloszenie.typ + \' / Informacja\' : zgloszenie.typ}}\" tooltip-placement=\"right\" style=\"margin-top: 3px;\"><i style=\"\" class=\"{{\'fa \'+vmZglZ.ikonaTypu[zgloszenie.typ].toString()+ \' fa-lg\'}}\"></i></div></td><td><span class=\"label label-primary\" ng-class=\"{ \'label label-danger\':zgloszenie.status === \'Oczekuje na klienta\', \'label label-grey\': zgloszenie.status === \'Zamknięte\' }\">{{zgloszenie.status}}</span></td></tr></table><uib-pagination first-text=\"{{lokalizacja.IdLok}}\" previous-text=\"«\" next-text=\"»\" total-items=\"vmZglZ.zgloszeniaPrzefiltrowane[lokalizacja.IdLok].meta.count\" ng-model-options=\"{ getterSetter: true }\" max-size=\"10\" items-per-page=\"vmZglZ.filtryTab[lokalizacja.IdLok].pageSize\" ng-model=\"vmZglZ.filtryTab[lokalizacja.IdLok].page\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"vmZglZ.filterOne(lokalizacja.IdLok)\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/home/zgloszenia_stare/zgloszenia.html","<h2>Zgłoszenia wewnętrzne</h2><ui-view></ui-view>");
$templateCache.put("app/home/zgloszenia_stare/zgloszenia.nowe.html","<div class=\"pane23\"><div class=\"box23\"><div class=\"description\"><h3>{{vmRekN.tytulNaglowka}}</h3><obsluga-bledow wiadomosci-tablica=\"vmRekN.odpowiedziSerwera\"></obsluga-bledow><form class=\"ekartoteka\" name=\"noweZgloszenie\" method=\"post\" id=\"formLimit\"><div ng-show=\"vmRekN.przypiszOsobe\"><label for=\"tematP\">Temat</label> <span id=\"tematP\">{{vmRekN.zgloszenie.Temat}}</span><div class=\"clearfix\"></div><label for=\"wybranyProgram\">Moduł</label> <span id=\"wybranyProgram\">{{vmRekN.zgloszenie.Modul}}&nbsp;{{vmRekN.zgloszenie.Program}}</span><div class=\"clearfix\"></div><label for=\"raportProgram\" ng-if=\"vmRekN.zgloszenie.Raport\">Raport</label> <span id=\"raportProgram\" ng-if=\"vmRekN.zgloszenie.Raport\">{{vmRekN.zgloszenie.Raport}}</span><div class=\"clearfix\"></div><label for=\"pracownik\">Osoba prowadząca</label><select name=\"pracownik\" id=\"pracownik\" required=\"\" ng-options=\"prac.Imie + \' \' + prac.Nazwisko for prac in vmRekN.pracownicy | orderBy:\'Imie\' | orderBy:\'Nazwisko\' track by prac.IdPrac\" ng-model=\"vmRekN.pracownik\"></select></div><div class=\"clearfix\"></div><div class=\"{{vmRekN.bootstrapKlasa}}\" ng-show=\"vmRekN.przypiszOsobe\"><div class=\"checkbox\"><label class=\"checkbox-inline\"><input id=\"edytuj\" ng-model=\"vmRekN.edytuj\" type=\"checkbox\">Edytuj zgłoszenie</label></div></div><div class=\"clearfix\"></div><div ng-hide=\"!vmRekN.edytuj && vmRekN.przypiszOsobe\"><div ng-hide=\"vmRekN.edytuj\"><label ng-show=\"vmRekN.lokalizacje.length>1\" for=\"lokalizacja\">Lokalizacja</label><select name=\"lokalizacja\" id=\"lokalizacja\" required=\"\" ng-show=\"vmRekN.lokalizacje.length>1\" ng-options=\"lok.NazwaLok for lok in vmRekN.lokalizacje track by lok.IdLok\" ng-model=\"vmRekN.lokalizacja\"></select></div><div class=\"clearfix\"></div><label for=\"rodzaj\">Rodzaj zgłoszenia</label><select name=\"rodzaj\" id=\"rodzaj\" required=\"\" ng-options=\"rodz.nazwa for rodz in vmRekN.rodzaje track by rodz.id\" ng-model=\"vmRekN.rodzaj\"></select><div ng-hide=\"(vmRekN.edytuj)|| vmRekN.rodzaj.id === 2\"><label for=\"program\">Moduł</label><select name=\"\" id=\"program\" ng-options=\"lic.Nazwa for lic in vmRekN.licencje | unique:\'Nazwa\' | orderBy : \'Nazwa\'\" ng-model=\"vmRekN.licencja\"></select><div ng-show=\"vmRekN.licencja.Kod !== \'PRW\'\"><label for=\"wersja\" class=\"checkbox-inline\"><div class=\"{{vmRekN.bootstrapKlasa}}\"><input type=\"checkbox\" ng-model=\"vmRekN.wersjaChbox\"></div>Wersja</label><select name=\"\" id=\"wersja\" ng-disabled=\"!vmRekN.wersjaChbox\" ng-options=\"lic.WersjaSys for lic in vmRekN.licencje | filter:{Kod:vmRekN.licencja.Kod}:true\" ng-model=\"vmRekN.wersja\"></select></div><label for=\"raport\"><div class=\"{{vmRekN.bootstrapKlasa}}\"><input type=\"checkbox\" ng-model=\"vmRekN.raportChbox\"></div>Raport</label> <input type=\"text\" ng-disabled=\"!vmRekN.raportChbox\" ng-model=\"vmRekN.raport\" id=\"raport\"></div><div class=\"clearfix\"></div><label for=\"pracownik\">Osoba prowadząca</label><select name=\"prac\" id=\"prac\" ng-required=\"vm.przypiszOsobe\" ng-options=\"prac.Imie + \' \' + prac.Nazwisko for prac in vmRekN.pracownicy | orderBy:\'Imie\' | orderBy:\'Nazwisko\' track by prac.IdPrac\" ng-model=\"vmRekN.pracownik\"></select><div class=\"clearfix\"></div><label for=\"osobaKontaktowa\">Osoba kontaktowa</label> <input id=\"osobaKontaktowa\" type=\"text\" ng-model=\"vmRekN.osobaKontaktowa\" name=\"osobaKontaktowa\"> <label for=\"email\">e-mail</label> <input id=\"email\" type=\"text\" ng-model=\"vmRekN.email\" name=\"email\"> <label for=\"telefon\">Telefon</label> <input id=\"telefon\" type=\"text\" ng-model=\"vmRekN.telefon\" name=\"email\"> <label for=\"telefon\">Temat</label> <input id=\"temat\" required=\"\" type=\"text\" ng-model=\"vmRekN.temat\" name=\"temat\"><br><label for=\"tresc\">Opis</label> <textarea id=\"tresc\" ng-model=\"vmRekN.tresc\" rows=\"10\" cols=\"64\" name=\"comment\" form=\"formLimit\"></textarea></div><div class=\"clearfix\"></div><div class=\"panefull\"><br><div class=\"{{vmRekN.bootstrapKlasa}}\" ng-hide=\"!vmRekN.edytuj && vmRekN.przypiszOsobe\"><dodawanie-plikow uploader=\"vmRekN.uploader\" nazwa-api=\"{{vmRekN.apiPliki}}\" blad=\"vmRekN.wyswietl.blad\" id=\"reklamacjePliki\"></dodawanie-plikow></div><button ng-click=\"vmRekN.wyslij()\" ng-disabled=\"vmRekN.btnWyslijDisabled\" value=\"\" class=\"btn-send\"></button></div></form><div class=\"clearfix\"></div></div></div></div><div class=\"pane13\"><div class=\"box\"><p>Dodając zgłoszenie możesz ustawić moduł oraz wersję, jak również zaznaczyć opcję raport i wpisać nazwę raportu, którego dotyczy zgłoszenie</p></div></div>");
$templateCache.put("app/home/zgloszenia_stare/zgloszenia.reklamacje.html","<div class=\"pagination\"><a ng-if=\"main.security.jestPracownikiemMieszczanin() && main.security.jestDostepDoDanychKlienta()\" ui-sref=\"home.subMain.zgloszenia.nowaReklamacja\" href=\"\" class=\"prevyear\">Nowe zgłoszenie &gt;</a><div class=\"clearfix\"></div></div><div class=\"panefull\"><obsluga-bledow wiadomosci-tablica=\"vmRek.odpowiedziSerwera\"></obsluga-bledow><strefa-grid api=\"{{vmRek.api}}\" request-params=\"{{vmRek.requestParams}}\" columns=\"vmRek.columns\" selected-item=\"vmRek.wybranyWiersz\" row-expand=\"true\" row-expand-template=\"{{vmRek.rowTemplate}}\" select-first=\"{{vmRek.zaznaczPierwszyWiersz}}\" ctrl=\"vmRek\" show-filter=\"{{vmRek.showFilter}}\" global-search=\"{{vmRek.globalSearch}}\" refresh=\"{{vmRek.refreshGrid}}\"></strefa-grid></div><script type=\"text/x-kendo-template\" id=\"rowTemplate\"><div > <uib-tabset> <uib-tab heading=\"Szczegóły\"> <div class=\"container-fluid default-color\"> <dl class=\"dl-horizontal\"> <dt ng-if=\"row.Temat\">Temat:</dt> <dd ng-if=\"row.Temat\">{{row.Temat}}</dd> <!--ng-click=\"vm.ctrl.pokazWiadomosc(row.IdWiad)\"--> <dt ng-if=\"row.IdWiad\">Numer wiadomości:</dt> <dd ng-if=\"row.IdWiad\"> <a href=\"\" ng-show=\"vm.ctrl.jestZOD\" ng-click=\"vm.ctrl.pokazWiadomosc(row.IdWiad)\"> <span ng-bind=\"vm.ctrl.numerWiadomosciFormat(row.NumerWiad)\"></span> </a> <span ng-show=\"!vm.ctrl.jestZOD\" ng-bind=\"vm.ctrl.numerWiadomosciFormat(row.NumerWiad)\"></span> </dd> <dt ng-if=\"row.OsobaProwadzaca\">Osoba prowadząca</dt> <dd ng-if=\"row.OsobaProwadzaca\">{{row.OsobaProwadzaca}}</dd> <dt ng-if=\"row.Zglaszajacy\">Osoba kontaktowa:</dt> <dd ng-if=\"row.Zglaszajacy\">{{row.Zglaszajacy}}</dd> <dt ng-if=\"row.Email\">E-mail:</dt> <dd ng-if=\"row.Email\">{{row.Email}}</dd> <dt ng-if=\"row.Telefon\">Telefon:</dt> <dd ng-if=\"row.Telefon\">{{row.Telefon}}</dd> <dt ng-if=\"row.Opis\">Opis:</dt> <dd ng-if=\"row.Opis\"><div class=\"angular-with-newlines\" style=\"text-align: justify\" ng-bind=\"row.Opis\"></div></dd> </dl> <br/> </div> </uib-tab> <uib-tab heading=\"Historia\"> <div class=\"container-fluid default-color\"> <reklamacje-historia id-rek=\"{{row.IdRek}}\"></reklamacje-historia> </div> </uib-tab> <uib-tab heading=\"Pliki ({{row.liczbaPlikow}})\" ng-init=\"row.liczbaPlikow=0\"> <div class=\"container-fluid default-color\"> <wyswietlanie-plikow api=\"{{vm.ctrl.apiPliki}}\" id=\"{{row.IdRek}}\" liczba-plikow=\"row.liczbaPlikow\"> </wyswietlanie-plikow> </div> </uib-tab> </uib-tabset> </div></script><script type=\"text/x-kendo-template\" id=\"OsobaProwadzacaColTemplate\"><div class=\"text-center\"> <div ng-hide=\"row.strefaPrzypnijWiadomosc\"> <button ng-show=\"row.OsobaProwadzaca && !row.strefaZalatwWiadomosc && !row.Status !== 4\" title=\"Zmień status, dodaj komentarz\" ng-click=\"vm.runExtFunction(\'zmienStatus\', [row, $event])\" class=\"btn btn-primary\"> <span class=\"glyphicon glyphicon-comment\"></span> </button> <!--<button ng-show=\"row.OsobaProwadzaca && !row.strefaZalatwWiadomosc && !row.Status !== 4\"--> <!--title=\"Załatw wiadomość\"--> <!--ng-click=\"vm.ctrl.zalatwWiadomosc(row, $event)\"--> <!--class=\"btn btn-success\">--> <!--<span class=\"glyphicon glyphicon-check\"></span>--> <!--<span class=\"glyphicon glyphicon-envelope\" style=\"font-size: 0.6em;\"></span>--> <!--</button>--> <div ng-show=\"row.strefaZalatwWiadomosc\"> <small><em>Czy chcesz załatwić wiadomość?</em></small> <div class=\"btn-group pull-right\"> <button type=\"submit\" class=\"btn btn-primary btn-sm\" title=\"Zapisz\" ng-click=\"vm.ctrl.zapiszZalatwWiadomosc(row, $event)\"> <span class=\"glyphicon glyphicon-ok\"></span> </button> <button class=\"btn btn-default btn-sm\" title=\"Anuluj\" ng-click=\"vm.ctrl.anulujZalatwWiadomosc(row, $event)\"> <span class=\"glyphicon glyphicon-remove\"></span> </button> </div> </div> <button class=\"btn btn-primary\" title=\"Przypisz osobę prowadzącą\" ng-click=\"vm.runExtFunction(\'przypiszPracownika\', [row, $event])\" ng-show=\"!row.OsobaProwadzaca && !row.IdWiad\"> <span class=\"glyphicon glyphicon-user\"></span> </button> <button class=\"btn btn-primary\" ng-click=\"vm.ctrl.strefaPrzypnijWiadomosc(row, $event)\" ng-show=\"!row.OsobaProwadzaca && !row.IdWiad\" title=\"Przypnij do wiadomości\" > <span class=\"glyphicon glyphicon-envelope\"></span> </button> </div> <div ng-if=\"row.strefaPrzypnijWiadomosc\" ng-form=\"row.przypiszWiadomoscForm\"> <input type=\"text\" ng-click=\"vm.ctrl.przypnijWiadomoscInputClick($event)\" ng-model=\"row.NumerWiadomosci\" placeholder=\"Numer wiadomości\" class=\"editable-input form-control input-sm\" required /> <div class=\"pull-right\"> <button class=\"btn btn-primary btn-sm\" title=\"Zapisz\" ng-disabled=\"row.przypiszWiadomoscForm.$invalid\" ng-click=\"vm.ctrl.zapiszPrzypnijWiadomosc(row, $event)\"> <span class=\"glyphicon glyphicon-ok\"></span> </button> <button class=\"btn btn-default btn-sm\" title=\"Anuluj\" ng-click=\"vm.ctrl.anulujStrefaPrzypnijWiadomosc(row, $event)\"> <span class=\"glyphicon glyphicon-remove\"></span> </button> </div> </div> </div></script>");
$templateCache.put("app/home/zgloszenia_stare/zgloszenia.zmien.html","<div class=\"pane23\"><div class=\"box23\"><div class=\"description\"><h3>{{vmRekZ.tytulNaglowka}}</h3><obsluga-bledow wiadomosci-tablica=\"vmRekZ.odpowiedziSerwera\"></obsluga-bledow><form class=\"ekartoteka\" name=\"zmienStatus\" method=\"post\" id=\"formLimit\"><div class=\"clearfix\"></div><label for=\"tematP\">Temat</label> <span id=\"tematP\">{{vmRekZ.zgloszenie.Temat}}</span><div class=\"clearfix\"></div><label for=\"status\">Status zgłoszenia</label><select name=\"status\" id=\"status\" required=\"\" ng-options=\"status.title for status in vmRekZ.statusy track by status.id\" ng-model=\"vmRekZ.zgloszenie.Status\"></select><br><label for=\"tresc\">Opis</label> <textarea id=\"tresc\" ng-model=\"vmRekZ.zgloszenie.Tresc\" rows=\"10\" cols=\"64\" name=\"comment\" form=\"formLimit\"></textarea><div class=\"clearfix\"></div><div class=\"panefull\"><br><button ng-click=\"vmRekZ.zmienStatus()\" ng-disabled=\"vmRekZ.btnWyslijDisabled\" value=\"\" class=\"btn-send\"></button></div></form><div class=\"clearfix\"></div></div></div></div><div class=\"pane13\"><div class=\"box\"><p>Zmieniając status zgłoszenia możesz dopisać dowolny opis. Załatwienie zgłoszenia automatycznie zamyka zgłoszenie.</p></div></div>");
$templateCache.put("app/components/directives/aplikacjaMobilnaEK/navbar.aplikacjaMobilnaEK.html","<div style=\"{{(vm.stick == true) ? \'position:fixed; top:82px;width:100%;z-index:999\': \'\'}}\"><div class=\"adminmenu\"><ul><li><a ui-sref=\"home.subMain.mobilnaekartoteka\" ng-class=\"{\'a1\': vm.state.current.name === \'home.subMain.mobilnaekartoteka\'}\">O aplikacji</a></li><li><a ui-sref=\"home.subMain.mobilnaekartoteka.jakzaczac\" ng-class=\"{\'a1\': vm.state.current.name === \'home.subMain.mobilnaekartoteka.jakzaczac\'}\">Jak zacząć</a></li><li><a ui-sref=\"home.subMain.mobilnaekartoteka.instrukcja\" ng-class=\"{\'a1\': vm.state.current.name === \'home.subMain.mobilnaekartoteka.instrukcja\'}\">Instrukcja</a></li><li><a ui-sref=\"home.subMain.mobilnaekartoteka.faq\" ng-class=\"{\'a1\': vm.state.current.name === \'home.subMain.mobilnaekartoteka.faq\'}\">Najczęstsze pytania</a></li><li><a ui-sref=\"home.subMain.mobilnaekartoteka.dlamieszkanca\" ng-class=\"{\'a1\': vm.state.current.name === \'home.subMain.mobilnaekartoteka.dlamieszkanca\'}\">Dla mieszkańca</a></li><li><a ui-sref=\"home.subMain.mobilnaekartoteka.pomoc\" ng-class=\"{\'a1\': vm.state.current.name === \'home.subMain.mobilnaekartoteka.pomoc\'}\">pomoc</a></li><li style=\"float: right\"><a ui-sref=\"home.subMain.emieszczanin\">Platforma e-mieszczanin</a></li></ul></div></div>");
$templateCache.put("app/components/directives/cennikEKIEM/liczbaLokaliDropdown.html","<label>Dostępne pakiety:</label><select ng-disabled=\"vm.disabled\" ng-model=\"vm.zaznaczone\" ng-change=\"vm.onChange({lokale: vm.zaznaczone})\" ng-options=\"liczba.wartosc as liczba.nazwa for liczba in vm.liczbyLokali | orderBy: \'kolejnosc\'\"></select>");
$templateCache.put("app/components/directives/cennikEKIEM/opcja.html","<div><input type=\"checkbox\" ng-model=\"vm.zaznaczenie\" ng-change=\"vm.onChange({IdGrupy: vm.id})\" id=\"{{\'opcja_\' + vm.id}}\" ng-disabled=\"vm.disabled\"> <label class=\"checkboxlabel\" for=\"{{\'opcja_\' + vm.id}}\">{{ vm.label }}</label><div class=\"note\" ng-if=\"vm.dodatkowaInformacja\" style=\"margin-bottom: 15px;\">{{ vm.dodatkowaInformacja }}</div></div>");
$templateCache.put("app/components/directives/cennikEKIEM/szczegolyLiczbyLokali.modal.html","<div class=\"{{vm.bootstrapKlasa}}\" ng-init=\"vm.init()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Szczegóły liczby lokali</h4></div><div class=\"col-xs-12\" style=\"margin: 20px 0\"><table class=\"table table-striped\"><thead><tr><th><b>Lokalizacja</b></th><th><b>Uwzględnione do wyceny</b></th></tr></thead><tbody><tr ng-repeat=\"lokalizacja in vm.lokalizacje\"><td>{{lokalizacja.NazwaLok}}</td><td>{{lokalizacja.do_wyceny}} <span ng-if=\"lokalizacja.LiczbaLokKth == 0 && lokalizacja.NieWliczanaDoCeny == 0\">(wartość stała dla bazy bez lokali)</span></td></tr><tr><td><b>Razem</b></td><td><b>{{vm.sumaDoWyceny}}</b></td></tr></tbody></table></div><div class=\"modal-footer\"><hr><button type=\"button\" class=\"btn btn-default\" data-ng-click=\"vm.modalClose()\">Zamknij</button></div></div>");
$templateCache.put("app/components/directives/kontaPracownikow/konto.kontaPracownikow.nowe.html","<div class=\"{{vmModal.bootstrapKlasa}}\" ng-init=\"vmModal.init()\"><div class=\"modal-header\"><h4 class=\"modal-title\" ng-if=\"vmModal.konto == null\">Dodaj pracownika</h4><h4 class=\"modal-title\" ng-if=\"vmModal.konto != null\">Edytuj pracownika</h4></div><div class=\"col-xs-12\" style=\"margin: 20px 0;\"><obsluga-bledow wiadomosci-tablica=\"vmModal.bledy\"></obsluga-bledow><form name=\"formSubUser\" novalidate=\"\"><table class=\"subuser-modal-table\"><tr><td>Login</td><td><div style=\"display: inline-block\"><div class=\"input-group\" style=\"margin-bottom: -15px; width: 300px;\"><input type=\"text\" class=\"form-control\" ng-style=\"( formSubUser.nazwa.$invalid) && {\'border-color\': \'red\'}\" name=\"nazwa\" ng-model=\"vmModal.subUser.login\" style=\"padding-left:10px;border-top: 1px solid lightgrey;border-left: 1px solid lightgrey;border-bottom-left-radius: 3px;border-top-left-radius: 3px;\" ng-disabled=\"vmModal.subUser.Ident!== null && vmModal.subUser.Ident>-1\" required=\"\"><div class=\"input-group-btn\"><div class=\"btn\" disabled=\"\" type=\"submit\" style=\"cursor: default; background-color: rgb(238,238,238); color: black; box-shadow: none; user-select: text; border: 1px solid lightgrey;border-left: none;text-transform: lowercase\" ng-style=\"( formSubUser.nazwa.$invalid) && {\'border-color\': \'red\'}\">{{\'@\'+vmModal.uzytkownik.Skrot.toLowerCase()}}</div></div></div></div><div class=\"form-group\" ng-class=\"{\'has-error\' : formSubUser.nazwa.$invalid}\"><p style=\"{{((formSubUser.nazwa.$invalid) ?\'display: block!important;\':\'display:none;\')+\' color:darkgrey!important; padding-top:10px;\'}}\" class=\"help-bl\">Pole wymagane</p></div></td></tr><tr><td>Lokalizacja</td><td><select class=\"form-control\" ng-model=\"vmModal.subUser.IdLok\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"IdLok\" ng-options=\"lok.IdLok as lok.NazwaLok for lok in vmModal.lokalizacje\" ng-disabled=\"vmModal.subUser.Ident !== null && vmModal.subUser.Ident>-1\" required=\"\"></select><p style=\"{{(formSubUser.IdLok.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></td></tr><tr><td>Imię</td><td><input type=\"text\" class=\"form-control\" ng-style=\"(formSubUser.imie.$invalid) && {\'border-color\': \'red\'}\" ng-model=\"vmModal.subUser.imie\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"imie\" required=\"\"><p style=\"{{(formSubUser.imie.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></td></tr><tr><td>Nazwisko</td><td><input type=\"text\" ng-style=\"(formSubUser.nazwisko.$invalid) && {\'border-color\': \'red\'}\" class=\"form-control\" ng-model=\"vmModal.subUser.nazwisko\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"nazwisko\" required=\"\"><p style=\"{{(formSubUser.nazwisko.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></td></tr><tr><td>email</td><td><input type=\"email\" class=\"form-control\" ng-model=\"vmModal.subUser.email\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$\" name=\"email\" ng-style=\"(formSubUser.email.$invalid) && {\'border-color\': \'red\'}\" required=\"\"><p style=\"{{(formSubUser.email.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane, email musi być poprawny</p></td></tr><tr><td>Telefon</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vmModal.subUser.Telefon\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"telefon\"></td></tr><tr><td>Płeć</td><td><select class=\"form-control\" ng-model=\"vmModal.subUser.CzyMezczyzna\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"plec\" ng-options=\"plec.val as plec.nazwa for plec in [{nazwa:\'Mężczyzna\',val:1},{nazwa:\'Kobieta\',val:0}, {nazwa:\'\',val:null}]\"></select></td></tr><tr ng-if=\"vmModal.subUser.Ident === null || angular.isDefined(vmModal.subUser.Ident)\"><td>Hasło{{angular.isDefined(vmModal.subUser.Ident)}}</td><td><input type=\"password\" class=\"form-control\" ng-style=\"(formSubUser.haslo2.$touched && formSubUser.haslo.$touched && vmModal.subUser.haslo !== vmModal.subUser.haslo2) && {\'border-color\': \'red\'}\" ng-model=\"vmModal.subUser.haslo\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" ng-required=\"vmModal.subUserHaslo\" name=\"haslo\"><p style=\"{{(formSubUser.haslo.$touched && formSubUser.haslo.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></td></tr><tr ng-if=\"vmModal.subUser.Ident === null || angular.isDefined(vmModal.subUser.Ident)\"><td>Potwierdź hasło</td><td><input type=\"password\" class=\"form-control\" ng-style=\"(formSubUser.haslo.$touched && vmModal.subUser.haslo !== vmModal.subUser.haslo2) && {\'border-color\': \'red\'}\" ng-model=\"vmModal.subUser.haslo2\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" ng-required=\"vmModal.subUserHaslo\" name=\"haslo2\"><p style=\"{{(formSubUser.haslo.$touched && formSubUser.haslo.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p><p style=\"{{(formSubUser.haslo.$touched && vmModal.subUser.haslo !== vmModal.subUser.haslo2) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Hasła muszą być identyczne</p></td></tr></table></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" data-ng-click=\"vmModal.modalOk(vmModal.item)\" ng-disabled=\"formSubUser.$invalid\">Zapisz</button> <button type=\"button\" class=\"btn btn-default\" data-ng-click=\"vmModal.modalClose()\">Anuluj</button></div></div>");
$templateCache.put("app/components/directives/kontaPracownikow/legendaUprawnien.html","<div class=\"{{vmModal.bootstrapKlasa}}\"><div class=\"modal-header\"><h4 class=\"modal-title\">Legenda uprawnień</h4></div><div class=\"col-xs-12\" style=\"margin: 30px 0;\"><table class=\"subuser-modal-table\"><tr><td style=\"width: 25px; font-size: 20px;\"><i class=\"fa fa-phone\" aria-hidden=\"true\"></i></td><td>Wykaz konsultacji telefonicznych</td></tr><tr><td style=\"width: 25px; font-size: 20px;\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i></td><td>Licencje</td></tr><tr><td style=\"width: 25px; font-size: 20px;\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></td><td>Faktury</td></tr><tr><td style=\"width: 25px; font-size: 20px;\"><i class=\"fa fa-shopping-cart\" aria-hidden=\"true\"></i></td><td>Panel zakupowy</td></tr><tr><td style=\"width: 25px; font-size: 20px;\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i></td><td>Aktualizacja</td></tr><tr><td style=\"width: 25px; font-size: 20px;\"><i class=\"fa fa-bell-o\" aria-hidden=\"true\"></i></td><td>Powiadomienia</td></tr><tr><td style=\"width: 25px; font-size: 20px;\"><i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i></td><td>Informacje dedykowane</td></tr><tr><td style=\"width: 25px; font-size: 20px;\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></td><td>Formularze</td></tr><tr><td style=\"width: 25px; font-size: 20px;\"><i class=\"fa fa-thumbs-o-up\" aria-hidden=\"true\"></i></td><td>Głosowanie</td></tr></table></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-ng-click=\"vmModal.modalClose()\">Zamknij</button></div></div>");
$templateCache.put("app/components/directives/kontoPowiadomien/konto.kontoPowiadomien.html","<div class=\"{{vmModal.bootstrapKlasa}}\" ng-init=\"vmModal.init()\"><div class=\"modal-header\"><h4 class=\"modal-title\" ng-if=\"vmModal.start\">Przejdź na e-faktury</h4><h4 class=\"modal-title\" ng-if=\"!vmModal.start\">{{ vmModal.naglowek }}</h4></div><div class=\"col-xs-12\" style=\"margin: 20px 0;\" ng-if=\"vmModal.start\"><p>E-faktura to usługa polegająca na dostarczaniu elektronicznego obrazu faktur, zamiast tradycyjnych faktur papierowych wysyłanych pocztą. Po przejściu na e-fakturę firma Mieszczanin nie będzie wysyłała faktur drogą pocztową.</p><p>Potwierdzam zmianę formy przesyłania faktur z papierowej na elektroniczną i jednocześnie podaję konto do powiadomień (z wskazaniem imienia i nazwiska osoby korzystającej z danego adresu e-mail) o nowych dokumentach sprzedaży wystawionych przez MIESZCZANIN INFORMATYKA Sp. z o.o.\"</p></div><div class=\"modal-header\" ng-if=\"vmModal.start\"><h4 class=\"modal-title\" ng-if=\"vmModal.kontoPowiadomien == null\">Dodaj nowe konto powiadomień</h4></div><div class=\"col-xs-12\" style=\"padding-left: 10px; padding-top: 10px; padding-bottom: 10px;\"><obsluga-bledow wiadomosci-tablica=\"vmModal.bledy\"></obsluga-bledow><form name=\"formKontoPowiadomien\" novalidate=\"\"><table class=\"subuser-modal-table\"><tr><td>email</td><td style=\"padding-left:10px;\"><input type=\"email\" class=\"form-control\" ng-model=\"vmModal.kontoPowiadomien.Adres\" style=\"padding-left:10px;width:400px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$\" name=\"email\" ng-style=\"(formKontoPowiadomien.email.$invalid) && {\'border-color\': \'red\'}\" required=\"\"><p style=\"{{(formSubUser.email.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane, email musi być poprawny</p></td></tr><tr><td>Imię</td><td style=\"padding-left:10px;\"><input type=\"text\" class=\"form-control\" ng-style=\"(formKontoPowiadomien.imie.$invalid) && {\'border-color\': \'red\'}\" ng-model=\"vmModal.kontoPowiadomien.Imie\" style=\"padding-left:10px;width:400px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"imie\" required=\"\"><p style=\"{{(formSubUser.imie.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></td></tr><tr><td>Nazwisko</td><td style=\"padding-left:10px;\"><input type=\"text\" ng-style=\"(formKontoPowiadomien.nazwisko.$invalid) && {\'border-color\': \'red\'}\" class=\"form-control\" ng-model=\"vmModal.kontoPowiadomien.Nazwisko\" style=\"padding-left:10px;width:400px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" name=\"nazwisko\" required=\"\"><p style=\"{{(formSubUser.nazwisko.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></td></tr></table></form></div><div class=\"modal-footer\"><button class=\"btn btn-danger\" style=\"float: left\" data-ng-click=\"vmModal.usunKontoPowiadomien(vmModal.kontoPowiadomien)\" ng-if=\"!vmModal.start && vmModal.kontoPowiadomien.IdMail && vmModal.liczbaMaili > 1\">Usuń</button> <button class=\"btn btn-primary\" data-ng-click=\"vmModal.modalOk(vmModal.kontoPowiadomien)\" ng-disabled=\"formKontoPowiadomien.$invalid\" ng-if=\"vmModal.start\">Potwierdzam przejście na e-faktury</button> <button class=\"btn btn-primary\" data-ng-click=\"vmModal.modalOk(vmModal.kontoPowiadomien)\" ng-disabled=\"formKontoPowiadomien.$invalid\" ng-if=\"!vmModal.start\">Zapisz</button> <button type=\"button\" class=\"btn btn-default\" data-ng-click=\"vmModal.modalClose()\">Anuluj</button></div></div>");
$templateCache.put("app/components/directives/ocenaGwiazdki/ocenaGwiazdki.html","<div class=\"ocena-gwiazdki\" ng-mouseleave=\"vm.hover = 0\"><div class=\"gwiazdka\" ng-repeat=\"ocena in vm.oceny\"><i class=\"fa fa-star\" ng-class=\"{\'zaznaczona\': (vm.ocena >= ocena), \'najechana\': (vm.hover>=ocena && vm.hover != 0)}\" ng-click=\"vm.zaznacz(ocena)\" ng-mouseenter=\"vm.hover = ocena\"></i></div></div>");
$templateCache.put("app/components/directives/pdfPrezentacja/pdfPrezentacja.html","<div class=\"portlet light\"><div class=\"portlet-title\"><div class=\"caption\"></div><div class=\"tools\"><a href=\"\" class=\"fullscreen\" data-original-title=\"\" title=\"\"></a></div><div class=\"actions\" style=\"text-align: center;margin-bottom: 10px;\"><a href=\"\" class=\"btn btn-default\" ng-click=\"vm.prevPage()\" ng-disabled=\"!vm.plik.currentPage || vm.plik.currentPage === 1\"><i class=\"fa fa-arrow-left\"></i> <span class=\"hidden-xs\">Poprzednia strona</span></a> <a href=\"\" class=\"btn btn-default\" ng-click=\"vm.nextPage()\" ng-disabled=\"!vm.plik.currentPage || vm.plik.currentPage === vm.plik.totalPages\"><span class=\"hidden-xs\">Następna strona</span> <i class=\"fa fa-arrow-right\"></i></a> <a href=\"\" class=\"btn btn-default\" style=\"float: right\" ng-click=\"vm.pobierz()\"><i class=\"fa fa-download\"></i> <span class=\"hidden-xs\">Pobierz</span></a></div><div class=\"portlet-body\"><uib-progressbar max=\"100\" value=\"plik.progress\" ng-show=\"plik.progress && plik.fileLokalizacja\"></uib-progressbar><view-pdf src=\"vm.lokalizacjaAPI + vm.downloadUrl + vm.plik.id + \'/file/\'\" scale=\"4\" id=\"viewer\" style=\"width: 100%;\" on-page-load=\"vm.pageLoaded(page,total)\" load-progress=\"vm.pageLoadProgress(state, loaded, total)\"></view-pdf></div></div></div>");
$templateCache.put("app/components/directives/pobieraniePlikow/pobieraniePlikow.html","<div class=\"portlet light\" ng-init=\"vmModal.init()\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{vmModal.item.nazwaPliku}} <i style=\"float: right;cursor: pointer;padding-top: 5px;\" data-ng-click=\"vmModal.modalClose()\" class=\"fa fa-times\" aria-hidden=\"true\"></i></h4></div><div class=\"modal-body portlet-body\" style=\"text-align: center;margin-top: 10px;\"><a ng-href=\"{{vmModal.imgURL}}\" style=\"cursor: zoom-in\"><img ng-src=\"{{vmModal.imgURL}}\" style=\"max-width: 500px;\"></a></div><div class=\"modal-footer\"><div style=\"float: right;\" class=\"{{vmModal.bootstrapKlasa}}\"><button class=\"btn btn-default\" ng-click=\"vmModal.download()\"><span class=\"glyphicon glyphicon-download-alt\" aria-hidden=\"true\" style=\"font-size: 20px;margin-right: 10px;\"></span>Pobierz</button></div></div></div>");
$templateCache.put("app/components/directives/powiadomienia/nowePowiadomienie.modal.html","<div class=\"{{vmModal.bootstrapKlasa}}\"><div class=\"modal-header\"><h4 class=\"modal-title\">Dodaj powadomienie</h4></div><div class=\"modal-body\"><div class=\"row mt-10\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>Tytuł</b></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"vmModal.tytul\" required=\"\"></div></div><div class=\"row mt-10\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>Treść</b></div><div class=\"col-md-10\"><textarea id=\"tresc\" rows=\"6\" cols=\"64\" required=\"\" ng-model=\"vmModal.wiadomosc\" style=\"margin-bottom: 30px\"></textarea></div></div></div><div class=\"modal-footer mt-10\"><div style=\"display: inline-block\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"vmModal.wiadomosc.length <= 0 || vmModal.tytul.length <=0\" ng-click=\"vmModal.dodajWiadomosc()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Dodaj</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.zamknijModal()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Zamknij</button></div></div></div>");
$templateCache.put("app/components/directives/powiadomienia/prezentacjaPowiadomien.html","<div class=\"notification row\" ng-repeat=\"powiadomienie in vm.powiadomienia\" ng-class=\"{ \'notification-info\':(powiadomienie.typ_powiadomienia === \'INFO\'), \'notification-warning\': (powiadomienie.typ_powiadomienia === \'WARNING\'), \'notification-error\': (powiadomienie.typ_powiadomienia === \'ERROR\')}\"><div class=\"notification-header\"><i class=\"fa fa-info-circle\"></i> <b style=\"margin-left: 5px\">{{ powiadomienie.tytul }}</b> <span style=\"color: crimson;float: right; display: inline-block; cursor: pointer\" ng-if=\"vm.czyAdmin\" ng-click=\"vm.usunPowiadomienie(powiadomienie.id)\"><i class=\"fa fa-times\"></i></span></div><div class=\"notofocation-body\">{{powiadomienie.wiadomosc}}</div></div>");
$templateCache.put("app/components/directives/promocje/promocje.dropdown.html","<select style=\"max-width: 90px;\" ng-change=\"vm.select()\" ng-model=\"vm.zaznaczone\" ng-options=\"opcja.wartosc as opcja.tekst disable when opcja.disabled for opcja in vm.opcjeSelect\"></select><select style=\"max-width: 65px;\" ng-change=\"vm.selectWersja()\" ng-if=\"vm.zaznaczone === 11 && vm.opcja.ezn\" ng-model=\"vm.wersja\" ng-options=\"wersja.Wersja as wersja.Wersja for wersja in vm.wersje\"></select>");
$templateCache.put("app/components/directives/promocje/promocje.skorzystaj.html","<div class=\"{{vmModal.bootstrapKlasa}}\" style=\"border: none!important;\"><div class=\"col-xs-12\" style=\"margin: 0 0;padding: 0\"><div><div class=\"alert alert-dismissible alert-danger\" ng-if=\"vmModal.typ===\'E\'\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" ng-click=\"vmModal.modalOk()\">×</button> <strong>{{vmModal.tresc}}</strong></div><div class=\"alert alert-dismissible alert-success\" ng-if=\"vmModal.typ===\'S\'\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" ng-click=\"vmModal.modalOk()\">×</button> <strong>{{vmModal.tresc}}</strong></div><div class=\"alert alert-dismissible alert-warning\" ng-if=\"vmModal.typ===\'I\'\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" ng-click=\"vmModal.modalOk()\">×</button> <strong>{{vmModal.tresc}}</strong></div></div></div></div>");
$templateCache.put("app/components/directives/szkolenia/przeniesZapisPopup.html","<div class=\"modal-header\"><h4 class=\"modal-title\">Przenieś zapis na inne szkolenie</h4></div><div class=\"modal-body\"><p>Dostępne szkolenia:</p><select ng-options=\"szkolenie as (\'#\' + szkolenie.id + \' \' + szkolenie.temat) for szkolenie in vmModal.dostepneSzkolenia\" ng-model=\"vmModal.wybraneSzkolenie\"></select><div ng-if=\"vmModal.wybraneSzkolenie !== null\"><p>Czy na pewno chcesz zmienić szkolenie klienta<u>{{vmModal.zapis.nazwaKlienta}}</u>?</p><p><b>Z</b> {{\'#\' + vmModal.zapis.daneSzkolenia.id + \' \' + vmModal.zapis.daneSzkolenia.temat}} <b>Na</b> {{\'#\' + vmModal.wybraneSzkolenie.id + \' \' + vmModal.wybraneSzkolenie.temat}}</p></div></div><div class=\"modal-footer\"><div class=\"bootstrap-iso-paper\" style=\"float:right\"><button style=\"display: inline-block;\" ng-disabled=\"vmModal.wybraneSzkolenie === null\" ng-click=\"vmModal.zapisz()\" class=\"btn btn-primary btn-sm\"><span>Zapisz</span></button> <button style=\"display: inline-block; margin-right: 15px;\" ng-click=\"vmModal.zamknij()\" class=\"btn btn-default btn-sm\"><span>Anuluj</span></button></div></div>");
$templateCache.put("app/components/directives/szkolenia/zmienStatusPopup.html","<div class=\"modal-header\"><h4 class=\"modal-title\">Zmiana statusu</h4></div><div class=\"modal-body\"><p>Status:</p><select ng-options=\"status for status in vmModal.statusy\" ng-model=\"vmModal.wybranyStatus\"></select><div class=\"{{vmModal.bootstrapKlasa}}\"><p>Zmiana statusu zapisu klienta<u>{{vmModal.zapis.nazwaKlienta}}</u></p><p><b>Z</b> <span class=\"label\" ng-class=\"{\'label-default\': (vmModal.zapis.status == \'niezakwalifikowane\' || vmModal.zapis.status == \'odwołane\'), \'label-danger\': vmModal.zapis.status == \'zrezygnowano\', \'label-success\': vmModal.zapis.status == \'zaakceptowane\', \'label-primary\': vmModal.zapis.status == \'wpłynęło\'}\">{{vmModal.zapis.status}}</span> <b>Na</b> <span class=\"label\" ng-class=\"{\'label-default\': (vmModal.wybranyStatus == \'niezakwalifikowane\' || vmModal.wybranyStatus == \'odwołane\'), \'label-danger\': vmModal.wybranyStatus == \'zrezygnowano\', \'label-success\': vmModal.wybranyStatus == \'zaakceptowane\', \'label-primary\': vmModal.wybranyStatus == \'wpłynęło\'}\">{{vmModal.wybranyStatus}}</span></p></div></div><div class=\"modal-footer\"><div class=\"bootstrap-iso-paper\" style=\"float: left\"><div><input id=\"powiadomicMailem\" type=\"checkbox\" ng-model=\"vmModal.wyslacPowiadomienie\"> <label for=\"powiadomicMailem\" class=\"checkboxlabel\">Powiadomić e-mailowo</label></div></div><div class=\"bootstrap-iso-paper\" style=\"float:right\"><button style=\"display: inline-block;\" ng-disabled=\"vmModal.wybranyStatus === null\" ng-click=\"vmModal.zapisz()\" class=\"btn btn-primary btn-sm\"><span>Zmień</span></button> <button style=\"display: inline-block; margin-right: 15px;\" ng-click=\"vmModal.zamknij()\" class=\"btn btn-default btn-sm\"><span>Anuluj</span></button></div></div>");
$templateCache.put("app/components/directives/uslugiPasywne/konto.uslugiPasywne.zmienHaslo.html","<div class=\"{{vmModal.bootstrapKlasa}}\" ng-init=\"vmModal.init()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Zmiana hasła dostępu do usług pasywnych.</h4></div><div class=\"col-xs-12\" style=\"margin: 20px 0;\"><obsluga-bledow wiadomosci-tablica=\"vmModal.bledy\"></obsluga-bledow><form name=\"formZmianaHasla\" novalidate=\"\"><table class=\"subuser-modal-table\"><tr><td>Hasło</td><td><input type=\"password\" class=\"form-control\" ng-model=\"vmModal.haslo\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" ng-required=\"vmModal.haslo\" name=\"haslo\"><p style=\"{{(formZmianaHasla.haslo.$touched && vmModal.haslo.length<8) ?\'display: inline-block!important;color:crimson\':\'display:none\'}}\" class=\"help-block\">Hasła musi mieć przynajmniej 8 znaków</p></td></tr><tr><td>Potwierdź hasło</td><td><input type=\"password\" class=\"form-control\" ng-style=\"(formZmianaHasla.powt_haslo.$touched && vmModal.subUser.haslo !== vmModal.subUser.powt_haslo) && {\'border-color\': \'red\'}\" ng-model=\"vmModal.powt_haslo\" style=\"padding-left:10px;width:300px;border: 1px solid lightgrey;border-radius: 3px;display: inline-block;\" ng-required=\"vmModal.powt_haslo\" name=\"powt_haslo\"><p style=\"{{(formZmianaHasla.haslo.$touched && vmModal.haslo !== vmModal.powt_haslo) ?\'display: inline-block!important;color:crimson\':\'display:none\' }}\" class=\"help-block\">Hasła muszą być identyczne</p></td></tr></table></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" data-ng-click=\"vmModal.modalOk(vmModal.item)\" ng-disabled=\"vmModal.haslo.length<8 || vmModal.haslo !== vmModal.powt_haslo\">Zapisz</button> <button type=\"button\" class=\"btn btn-default\" data-ng-click=\"vmModal.modalClose()\">Anuluj</button></div></div>");
$templateCache.put("app/components/directives/zapytanieOfertowe/ofertaPrezentacja.html","<ul class=\"list-group m-status-list\"><li class=\"list-group-item\" style=\"cursor: default;\" ng-repeat=\"produkt in vm.koszyk.produkty\"><div class=\"ikona\" style=\"display: inline-block;\"><div class=\"{{produkt.produkt.ikona}}\"></div></div><span class=\"text-uppercase font-blue-sharp\">{{produkt.produkt.nazwa}}</span><span>({{vm.kategorieDict[produkt.produkt.kategoria]}})</span> <span class=\"usun\" style=\"color: crimson; cursor: pointer; float: right\" ng-if=\"vm.params.remove\"><i class=\"fa fa-times\" aria-hidden=\"true\" ng-click=\"vm.usunZKoszyka(produkt)\"></i></span><div><b>Parametry:</b></div><div ng-repeat=\"parametr in produkt.parametry\"><span ng-if=\"produkt.produkt.kategoria === \'zmiana-limitow\' && parametr.poprzednia_wartosc != parametr.wartosc\">{{parametr.parametr.prezentowana_nazwa + \': \' + vm.dajWartosc(parametr.poprzednia_wartosc)}} <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> {{parametr.wartosc}}</span> <span ng-if=\"produkt.produkt.kategoria !== \'zmiana-limitow\'\">{{parametr.parametr.prezentowana_nazwa + \': \' + vm.dajWartosc(parametr.wartosc)}}</span></div><table class=\"table\" style=\"margin-bottom: 0\"><tr><th class=\"header\">{{(parametr.model_platnosci) ? \"Abonament podstawowy\" : \"Cena podstawowa\"}}</th><th>{{(parametr.model_platnosci) ? \"Abonament\" : \"Cena\"}} po rabacie</th></tr><tr><td>{{produkt.cena_podstawowa}}zł</td><td>{{produkt.cena_po_rabacie}}zł</td></tr></table><div ng-if=\"produkt.komentarz !== null && produkt.komentarz.length > 0\"><b>Informacja:</b><br>{{produkt.komentarz}}</div></li></ul><div ng-if=\"vm.koszyk.produkty.length > 0\"><h5>Podsumowanie</h5><table class=\"table\"><tr><th></th><th>Cena podstawowa</th><th>Łącznie rabat</th><th>Cena</th></tr><tr ng-if=\"vm.koszyk.cena_podstawowa > 0\"><td><b>Razem</b></td><td>{{vm.koszyk.cena_podstawowa}}zł</td><td>{{vm.koszyk.rabat}}zł</td><td>{{vm.koszyk.cena_po_rabacie}}zł</td></tr><tr ng-if=\"vm.koszyk.cena_podstawowa_abonamet > 0\"><td><b>Razem abonament</b></td><td>{{vm.koszyk.cena_podstawowa_abonamet}}zł</td><td>{{vm.koszyk.rabat_abonament}}zł</td><td>{{vm.koszyk.cena_po_rabacie_abonament}}zł</td></tr></table><p><b>Powyższe ceny są cenami netto.</b></p></div><div><p>Akceptacja oferty spowoduje przekazanie zamówienia do realizacji oraz wystawienie faktury VAT.</p><p>Akceptując ofertę oświadczają Państwo, że zapoznali się z treścią <a ng-click=\"vm.pobierzPlik(\'ogolne-warunki-sprzedazy\')\">Ogólnych warunków sprzedaży</a>, <a ng-click=\"vm.pobierzPlik(\'warunki-gwarancji\')\">Warunków gwarancji</a>, <a ng-click=\"vm.pobierzPlik(\'regulamin-uslug-serwisowych\')\">Regulaminu usług serwisowych</a>, <a ng-click=\"vm.pobierzPlik(\'regulamin-stalej-aktualizacji\')\">Regulaminu stałej aktualizacji</a>, <a ng-click=\"vm.pobierzPlik(\'regulamin-uslug-zintegrowanych\')\">Regulaminu usług zintegrowanych</a> oraz <a ng-click=\"vm.pobierzPlik(\'klauzula-przetwazania-danych-osobowych\')\">Klauzulą informacyjną dotyczącą przetwarzania danych osobowych</a> i że zostały one Państwu udostępnione w taki sposób, że mogą je Państwo bez problemu przechowywać i odtwarzać, dlatego akceptują je Państwo bez zastrzeżeń jako integralną część umowy sprzedaży oraz umowy o korzystanie z zamawianych programów komputerowych (licencji).</p></div>");
$templateCache.put("app/components/directives/zapytanieOfertowe/podgladOferty.modal.html","<div class=\"{{vmModal.bootstrapKlasa}}\" ng-init=\"vmModal.init()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Podgląd oferty</h4></div><div class=\"modal-body\"><div class=\"col-xs-12\" style=\"margin: 20px 0;\"><obsluga-bledow wiadomosci-tablica=\"vmModal.bledy\"></obsluga-bledow></div><pdf-prezentacja ng-if=\"vmModal.oferta.pdf\" plik=\"vmModal.oferta.pdf\" download-url=\"\'/zapytanie-ofertowe/ofertaPDF/\'\"></pdf-prezentacja><oferta-prezentacja koszyk=\"vmModal.oferta\"></oferta-prezentacja></div><div class=\"row mt-10\"><div class=\"col-md-4 text-center\"></div><div class=\"col-md-8\"></div></div><div class=\"notification row notification-warning\" style=\"margin: 0 20px;\" ng-if=\"!vmModal.security.isLogin()\"><div class=\"col-md-12\"><div class=\"notification-header\"><i class=\"fa fa-info-circle\"></i> <b style=\"margin-left: 5px\">Uwaga</b></div><div class=\"notofocation-body\">Aby móc zaakceptować ofertę należy potwierdzić informacje firmy klikając <a ng-click=\"vmModal.uzupelnijDanePotKli()\">tutaj</a></div></div></div><div class=\"modal-footer mt-10\"><div ng-if=\"vmModal.oferta.status === \'Wysłana\' && vmModal.akceptacjaOferty === true\" style=\"display: inline-block\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"vmModal.zapisywanie || (!vmModal.security.isLogin() && !vmModal.potKli.potwierdzono_dane)\" ng-click=\"vmModal.zaakceptujOferte()\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Akceptuj</button> <button type=\"button\" class=\"btn btn-danger\" ng-disabled=\"vmModal.zapisywanie || (!vmModal.security.isLogin() && !vmModal.potKli.potwierdzono_dane)\" ng-click=\"vmModal.odrzucOferte()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Odrzuć</button></div><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.modalClose()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Zamknij</button></div></div>");
$templateCache.put("app/components/directives/zapytanieOfertowe/uzupelnienieInformacji.modal.html","<div><div class=\"{{vmModal.bootstrapKlasa + \' modal-header\'}}\"><h4 class=\"modal-title\">Uzupełnienie informacji</h4></div><div class=\"modal-body\"><form name=\"uzupelnienieDanych\" ng-show=\"vmModal.klient !== null\"><h5>Dane firmy</h5><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.nazwa_firmy.$touched && uzupelnienieDanych.nazwa_firmy.$invalid}\"><label style=\"width: 150px;\">Nazwa firmy*</label> <input name=\"nazwa_firmy\" type=\"text\" class=\"form-control\" ng-model=\"vmModal.klient.nazwa_firmy\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.nazwa_firmy.$touched && uzupelnienieDanych.nazwa_firmy.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.nip.$touched && uzupelnienieDanych.nip.$invalid}\"><label style=\"width: 150px;\">NIP*</label> <input name=\"nip\" type=\"text\" class=\"form-control\" pattern=\"[0-9]{10}\" ng-model=\"vmModal.klient.nip\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.nip.$touched && uzupelnienieDanych.nip.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><h5>Adres siedziby</h5><div><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.ulica.$touched && uzupelnienieDanych.ulica.$invalid}\"><label style=\"width: 150px;\">Ulica*</label> <input name=\"ulica\" type=\"text\" class=\"form-control\" ng-model=\"vmModal.klient.ulica\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.ulica.$touched && uzupelnienieDanych.ulica.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.nr_budynku.$touched && uzupelnienieDanych.nr_budynku.$invalid}\"><label style=\"width: 150px;\">Nr budynku / lokalu*</label> <input name=\"ulica\" type=\"text\" class=\"form-control\" ng-model=\"vmModal.klient.nr_budynku\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.nr_budynku.$touched && uzupelnienieDanych.nr_budynku.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.kod_pocztowy.$touched && uzupelnienieDanych.kod_pocztowy.$invalid}\"><label style=\"width: 150px;\">Kod pocztowy*</label> <input name=\"kod_pocztowy\" type=\"text\" class=\"form-control\" pattern=\"[0-9]{2}-[0-9]{3}\" ng-model=\"vmModal.klient.kod_pocztowy\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.kod_pocztowy.$touched && uzupelnienieDanych.kod_pocztowy.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.miejscowosc.$touched && uzupelnienieDanych.miejscowosc.$invalid}\"><label style=\"width: 150px;\">Miejscowość*</label> <input name=\"miejscowosc\" type=\"text\" class=\"form-control\" ng-model=\"vmModal.klient.miejscowosc\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.miejscowosc.$touched && uzupelnienieDanych.miejscowosc.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div></div><h5>Adres korespondencyjny</h5><div class=\"row\"><div class=\"col-md-12\" style=\"margin-top: 20px;\"><label for=\"adres_kor_taki_jak_siedziby\" style=\"line-height: 1; display: inline-block;\">Taki sam jak adres siedziby</label> <input type=\"checkbox\" name=\"adres_kor_taki_jak_siedziby\" id=\"adres_kor_taki_jak_siedziby\" style=\"display: inline-block; margin:7px 10px 0 0;\" ng-model=\"vmModal.klient.adres_kor_taki_jak_siedziby\"></div></div><div class=\"row mt-10\"><div class=\"col-md-4 text-center\"></div><div class=\"col-md-8\"></div></div><div ng-if=\"vmModal.klient.adres_kor_taki_jak_siedziby === false\"><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.kor_ulica.$touched && uzupelnienieDanych.kor_ulica.$invalid}\"><label style=\"width: 150px;\">Ulica*</label> <input name=\"kor_ulica\" type=\"text\" class=\"form-control\" ng-model=\"vmModal.klient.kor_ulica\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.kor_ulica.$touched && uzupelnienieDanych.kor_ulica.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.kor_nr_budynku.$touched && uzupelnienieDanych.kor_nr_budynku.$invalid}\"><label style=\"width: 150px;\">Nr budynku / lokalu*</label> <input name=\"kor_nr_budynku\" type=\"text\" class=\"form-control\" ng-model=\"vmModal.klient.kor_nr_budynku\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.kor_nr_budynku.$touched && uzupelnienieDanych.kor_nr_budynku.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.kor_kod_pocztowy.$touched && uzupelnienieDanych.kor_kod_pocztowy.$invalid}\"><label style=\"width: 150px;\">Kod pocztowy*</label> <input name=\"kor_kod_pocztowy\" type=\"text\" class=\"form-control\" pattern=\"[0-9]{2}-[0-9]{3}\" ng-model=\"vmModal.klient.kor_kod_pocztowy\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.kor_kod_pocztowy.$touched && uzupelnienieDanych.kor_kod_pocztowy.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.kor_miejscowosc.$touched && uzupelnienieDanych.kor_miejscowosc.$invalid}\"><label style=\"width: 150px;\">Miejscowość*</label> <input name=\"kor_miejscowosc\" type=\"text\" class=\"form-control\" ng-model=\"vmModal.klient.kor_miejscowosc\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.kor_miejscowosc.$touched && uzupelnienieDanych.kor_miejscowosc.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div></div><h5 style=\"margin-top: 40px;\">Adres e-mail do kontaktów handlowych</h5><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.email_kontakt_handlowy.$touched && uzupelnienieDanych.email_kontakt_handlowy.$invalid}\"><label style=\"width: 150px;\">e-mail</label> <input name=\"email_kontakt_handlowy\" type=\"email\" class=\"form-control\" ng-model=\"vmModal.klient.email_kontakt_handlowy\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.email_kontakt_handlowy.$touched && uzupelnienieDanych.email_kontakt_handlowy.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div><h5>Adres e-mail do powiadomień systemowych</h5><div class=\"form-group\" ng-class=\"{\'has-error\' : uzupelnienieDanych.email_powiadomienia_systemowe.$touched && uzupelnienieDanych.email_powiadomienia_systemowe.$invalid}\"><label style=\"width: 150px;\">e-mail</label> <input name=\"email_powiadomienia_systemowe\" type=\"email\" class=\"form-control\" ng-model=\"vmModal.klient.email_powiadomienia_systemowe\" style=\"display: inline-block\" required=\"\"><p style=\"{{(uzupelnienieDanych.email_powiadomienia_systemowe.$touched && uzupelnienieDanych.email_powiadomienia_systemowe.$invalid) ?\'display: inline-block!important\':\'display:none\' }}\" class=\"help-block\">Pole wymagane</p></div></form><div ng-if=\"vmModal.klient === null\">Ładowanie...</div></div><div class=\"{{vmModal.bootstrapKlasa}}\"><div class=\"row mt-10\"><div class=\"col-md-4 text-center\"></div><div class=\"col-md-8\"></div></div><div class=\"modal-footer mt-10\"><div><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"vmModal.zapisywanie || uzupelnienieDanych.$invalid\" ng-click=\"vmModal.zapisz()\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Zapisz</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.anuluj()\">Anuluj</button></div></div></div></div>");
$templateCache.put("app/components/directives/zgloszenia/orderZgloszenia.html","<i style=\"{{(vm.sortowanie[vm.idLok].pole!=vm.pole) ? \'color: darkgrey;cursor:pointer;\': \'cursor:pointer;\' }}\" aria-hidden=\"true\" class=\"fa\" ng-class=\"{\'fa-sort\': (vm.sortowanie[vm.idLok].pole!=vm.pole), \'fa-sort-asc\': (vm.sortowanie[vm.idLok].pole == vm.pole && vm.sortowanie[vm.idLok].order === \'\'), \'fa-sort-desc\': (vm.sortowanie[vm.idLok].pole == vm.pole && vm.sortowanie[vm.idLok].order === \'-\') }\" ng-click=\"vm.select(vm.idLok, \'id\')\"></i>");
$templateCache.put("app/components/directives/zgloszenia/reklamacjeHistoria.html","<div><strefa-grid api=\"{{vmReklHist.api}}\" request-params=\"{{vmReklHist.requestParams}}\" columns=\"vmReklHist.columns\" row-expand=\"false\" show-filter=\"false\" ctrl=\"vmReklHist\"></strefa-grid></div>");
$templateCache.put("app/home/platnosciOnlineEK/dlaczegoWarto/dlaczegoWarto.html","<div><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-9\"><p class=\"informacja\">Zachęcamy do zapoznania się <span class=\"wyroznij\">zaletami</span> korzystania przez mieszkańców z tej formy płatności:</p><ul><li class=\"itemList\"><span class=\"wyroznij\">wygoda</span> - najszybsza i najprostsza forma płatności za rachunki, należność regulowana za pomocą kilku kliknięć,</li><li class=\"itemList\"><span class=\"wyroznij\">poprawność</span> - płatność realizowana w kwocie pełnej wysokości zobowiązania bez możliwości jego edytowania (brak ryzyka niedopłaty!),</li><li class=\"itemList\">nowoczesny <span class=\"wyroznij\">wizerunek</span> - płatność online oczekiwanym standardem dla coraz szerszego grona mieszkańców,</li><li class=\"itemList\">pełne <span class=\"wyroznij\">bezpieczeństwo</span> - dzięki zastosowaniu odpowiednich zabezpieczeń oraz współpracy z liderem dostawców rozwiązań płatniczych,</li></ul><p class=\"informacja\">Zachęcamy do zapoznania się z zawierającą więcej szczegółów <span class=\"wyroznij\">broszurą</span> przygotowaną przez Autopay S.A.</p></div><div class=\"col-md-3\"><a href=\"./assets/files/Korzyści dla Zarządcy z propagowania płatności on-line wśród mieszkańców.pdf\" target=\"_blank\"><img src=\"./assets/images/platnosciOnlineEK/broszuraPlatnosciOnlineEK.png\" width=\"100%\"></a></div></div></div></div>");
$templateCache.put("app/home/platnosciOnlineEK/instrukcja/instrukcja.html","<div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-12\"><p class=\"information\">Zachęcamy do zapoznania się z procesem realizacji przykładowej płatności online w portalu e&#8209;kartoteka.</p><div class=\"content\" style=\"padding-top: 20px;width: 100%\"><div class=\"videogular-container\" style=\"margin: 0 auto;\"><videogular vg-theme=\"vmPlatOnlEKInst.config.theme.url\" vg-player-ready=\"vmPlatOnlEKInst.vgPlayerReady($API)\"><vg-media vg-src=\"vmPlatOnlEKInst.config.sources\" vg-tracks=\"vmPlatOnlEKInst.config.tracks\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"2000\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play></videogular></div><div class=\"videogular-akcje\"><a ng-click=\"vmPlatOnlEKInst.changeSource(!vmPlatOnlEKInst.lektorWlaczony)\">Przejdź do filmu {{vmPlatOnlEKInst.lektorWlaczony ? \'bez lektora\' : \'z lektorem\'}}</a></div></div></div></div></div>");
$templateCache.put("app/home/platnosciOnlineEK/pytania/pytania.html","<div><pytania items=\"vmPlatOnlEKPyt.pytania\"></pytania></div>");
$templateCache.put("app/home/platnosciOnlineEK/visa/visa.html","<div><div class=\"bootstrap-iso-paper\"><div class=\"row\"><div class=\"col-md-9\"><p class=\"informacja\">Wraz z firmą <span class=\"wyroznij\">VISA</span> przygotowujemy kolejne możliwości wygodnych płatności online. Więcej szczegółów przekażemy wkrótce.</p></div><div class=\"col-md-3\"><img src=\"./assets/images/platnosciOnlineEK/VisaLogo.svg\" width=\"100%\"></div></div></div></div>");
$templateCache.put("app/home/umowy/uppdo/akceptacjaUmowy.html","<div class=\"{{vmUmUPPDO.bootstrapKlasa}}\"><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-md-12\"><iframe id=\"umowa-preview\" src=\"\" type=\"application/pdf\" style=\"width:100%; height: 600px; overflow: auto;\"></iframe></div></div><div class=\"row\"><div class=\"col-md-12\"><input type=\"checkbox\" name=\"potwierdzam\" id=\"potwierdzam\" style=\"display: inline-block\" ng-model=\"vmUmUPPDO.form.akceptacjaUmowy\"> <label for=\"potwierdzam\" style=\"min-width: 500px; line-height: 1; display: inline-block; margin-top: -5px\">Mam świadomość, że klikając w poniższy przycisk zawieram w imieniu Zleceniodawcy powyższą umowę powierzenia przetwarzania danych osobowych ze skutkiem natychmiastowym.</label></div></div><button class=\"btn btn-default\" style=\"margin-bottom: 20px; float: right\" ng-disabled=\"vmUmUPPDO.form.akceptacjaUmowy===false || vmUmUPPDO.wysylanie===true\" ng-click=\"vmUmUPPDO.wyslij()\"><i class=\"fa fa-arrow-right\"></i> {{vmUmUPPDO.wysylanie === false ? \'Zawieram umowę\' : \'Wysyłanie umowy\'}}</button></div>");
$templateCache.put("app/home/umowy/uppdo/daneUzytkownikaForm.html","<div class=\"{{vmUmUPPDO.bootstrapKlasa}}\" style=\"line-height: 1.25\"><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>Imie</b></div><div class=\"col-md-10\">{{vmUmUPPDO.daneSubUsera.imie}}</div></div><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>nazwisko</b></div><div class=\"col-md-10\">{{vmUmUPPDO.daneSubUsera.nazwisko}}</div></div><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>e-mail</b></div><div class=\"col-md-10\">{{vmUmUPPDO.daneSubUsera.email}}</div></div><p>Jeśli dane się nie zgadzają popraw je w ustawieniach <a ui-sref=\"home.subMain.profil\">profilu</a></p><div class=\"row\"><div class=\"col-md-12\"><input type=\"checkbox\" name=\"klauzula1\" id=\"klauzula1\" style=\"display: inline-block\" ng-model=\"vmUmUPPDO.form.klauzulaPDO\"> <label for=\"klauzula1\" style=\"width: 90%; line-height: 1.25; display: inline-block; margin-top: -5px\">Zapoznałem(-am) się z treścią klauzuli informacyjnej o przetwarzaniu danych osobowych, w tym z informacją o celu i sposobach przetwarzania danych osobowych oraz prawie dostępu do treści swoich danych i prawie ich poprawiania.</label></div></div><button class=\"btn btn-default\" style=\"float: right\" ng-disabled=\"!vmUmUPPDO.form.klauzulaPDO\" ng-click=\"vmUmUPPDO.zmienZakladke(2)\"><i class=\"fa fa-arrow-right\"></i> Przejdź dalej</button></div>");
$templateCache.put("app/home/umowy/uppdo/osobaKontaktowa.html","<div class=\"{{vmUmUPPDO.bootstrapKlasa}}\"><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-md-12\"><b>Dane kontaktowe do spraw ochrony danych osobowych</b></div></div><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-md-12\"><input type=\"checkbox\" name=\"typKontaktu\" id=\"typKontaktu\" ng-model=\"vmUmUPPDO.iodDane.widoczny\"> <label for=\"typKontaktu\" style=\"min-width: 500px; line-height: 1; display: inline-block; margin-top: -5px\">Powołany przez zleceniodawcę Inspektor Ochrony Danych</label></div></div><div ng-if=\"vmUmUPPDO.iodDane.widoczny === true\"><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>Imie</b></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"vmUmUPPDO.iodDane.imie\"></div></div><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>Nazwisko</b></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"vmUmUPPDO.iodDane.nazwisko\"></div></div><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>e-mail</b></div><div class=\"col-md-10\"><input type=\"email\" ng-model=\"vmUmUPPDO.iodDane.email\"></div></div></div><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-md-12\"><input type=\"checkbox\" id=\"typKontaktu2\" style=\"display: inline-block\" ng-model=\"vmUmUPPDO.osobaUprawnionaDane.widoczny\"> <label for=\"typKontaktu2\" style=\"min-width: 500px; line-height: 1; display: inline-block; margin-top: -5px\">Upoważniony do kontaktów w sprawie ochrony danych osobowych przedstawiciel Zleceniodawcy</label></div></div><div ng-if=\"vmUmUPPDO.osobaUprawnionaDane.widoczny === true\"><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>Imie</b></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"vmUmUPPDO.osobaUprawnionaDane.imie\"></div></div><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>Nazwisko</b></div><div class=\"col-md-10\"><input type=\"text\" ng-model=\"vmUmUPPDO.osobaUprawnionaDane.nazwisko\"></div></div><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>e-mail</b></div><div class=\"col-md-10\"><input type=\"email\" ng-model=\"vmUmUPPDO.osobaUprawnionaDane.email\"></div></div></div><button class=\"btn btn-default\" style=\"margin-bottom: 20px; float: right\" ng-disabled=\"(!vmUmUPPDO.osobaUprawnionaDane.widoczny && !vmUmUPPDO.iodDane.widoczny) || (vmUmUPPDO.osobaUprawnionaDane.widoczny && (vmUmUPPDO.osobaUprawnionaDane.imie.length < 2 || vmUmUPPDO.osobaUprawnionaDane.nazwisko.length < 2 || !vmUmUPPDO.validateEmail(vmUmUPPDO.osobaUprawnionaDane.email) ) )|| (vmUmUPPDO.iodDane.widoczny && (vmUmUPPDO.iodDane.imie.length < 2 || vmUmUPPDO.iodDane.nazwisko.length < 2 || !vmUmUPPDO.validateEmail(vmUmUPPDO.iodDane.email) ) )\" ng-click=\"vmUmUPPDO.zmienZakladke(4)\"><i class=\"fa fa-arrow-right\"></i> Przejdź dalej</button></div>");
$templateCache.put("app/home/umowy/uppdo/pelnomocnictwoForm.html","<div class=\"{{vmUmUPPDO.bootstrapKlasa}}\" style=\"line-height: 1.25\"><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-md-12\"><b>Dane osoby upoważnionej do reprezentacji podmiotu</b></div></div><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>Imie</b></div><div class=\"col-md-10\">{{vmUmUPPDO.daneSubUsera.imie}}</div></div><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-2\"><b>Nazwisko</b></div><div class=\"col-md-10\">{{vmUmUPPDO.daneSubUsera.nazwisko}}</div></div><br><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-md-12\"><input type=\"radio\" name=\"pelnomocnik\" id=\"pelnomocnik\" value=\"wlasciciel\" ng-value=\"\'wlasciciel\'\" style=\"display: inline-block\" ng-model=\"vmUmUPPDO.form.pelnomocnik\"> <label for=\"pelnomocnik\" style=\"width: 90%; line-height: 1; display: inline-block; margin-top: -5px\">Oświadczam, że jestem reprezentantem podmiotu uprawnionym do jednoosobowej jego reprezentacji (możliwym do weryfikacji w rejestrach KRS/CEIDG)</label></div></div><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-md-12\"><input type=\"radio\" name=\"pelnomocnik\" id=\"pelnomocnik2\" value=\"pelnomocnik\" ng-value=\"\'pelnomocnik\'\" style=\"display: inline-block\" ng-model=\"vmUmUPPDO.form.pelnomocnik\"> <label for=\"pelnomocnik2\" style=\"width: 90%; line-height: 1; display: inline-block; margin-top: -5px\">Oświadczam, że posiadam pisemne pełnomocnictwo do zawierania umów powierzenia przetwarzania danych osobowych (imię i nazwisko Pełnomocnika na pełnomocnictwie musi odpowiadać powyższym danym imiennym).</label></div></div><div class=\"row\" style=\"margin-bottom: 20px;\" ng-if=\"vmUmUPPDO.form.pelnomocnik === \'pelnomocnik\'\"><div class=\"col-md-12\" style=\"padding-bottom: 20px\">Załącz skan pełnomocnictwa do zawierania umów powierzenia przetwarzania danych osobowych. Przed załączeniem sprawdź, czy pełnomocnictwo zawiera niezbędne podpisy oraz zweryfikuj czy jesteś zalogowany na konto pracownicze zgodne z udzielonym pełnomocnictwem.</div><div class=\"col-md-12\"><dodawanie-plikow-pdf files=\"vmUmUPPDO.pliki\"></dodawanie-plikow-pdf></div><div class=\"col-md-12\" style=\"padding-bottom: 20px; color: darkorange\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> Plik musi być w formacie PDF</div></div><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-md-12\"><input type=\"checkbox\" name=\"poprawnoscDanych\" id=\"poprawnoscDanych\" style=\"display: inline-block\" ng-model=\"vmUmUPPDO.form.poprawnoscDanych\"> <label for=\"poprawnoscDanych\" style=\"width: 90%; line-height: 1.25; display: inline-block; margin-top: -5px\">Potwierdzam poprawność i kompletność powyższych danych</label></div></div><button class=\"btn btn-default\" style=\"margin-bottom: 20px; float: right\" ng-disabled=\"((vmUmUPPDO.form.pelnomocnik===\'pelnomocnik\' && vmUmUPPDO.pliki.length < 1 ) || vmUmUPPDO.form.poprawnoscDanych === false) || vmUmUPPDO.form.pelnomocnik === null\" ng-click=\"vmUmUPPDO.zmienZakladke(3)\"><i class=\"fa fa-arrow-right\"></i> Przejdź dalej</button></div>");
$templateCache.put("app/home/umowy/uppdo/umowaAktualna.html","<div class=\"\"><div class=\"row\"><div class=\"col-md-6\">Data podpisania umowy</div><div class=\"col-md-6\">{{vmUm.umowy[0].dane.umowa.DataStart | date: \'dd-MM-yyyy\'}}</div></div><div id=\"pelnomocnik\" class=\"mt20\" ng-if=\"vmUm.umowy[0].dane.daneKontaktowe.PelnomocnikImie !== null && vmUm.umowy[0].dane.daneKontaktowe.PelnomocnikNazwisko\"><div class=\"row\"><div class=\"col-md-12\"><b>Pełnomocnik</b></div></div><div class=\"row\"><div class=\"col-md-6\">Imie i Nazwisko</div><div class=\"col-md-6\">{{vmUm.umowy[0].dane.daneKontaktowe.PelnomocnikImie + \" \" + vmUm.umowy[0].dane.daneKontaktowe.PelnomocnikNazwisko}}</div></div></div><div id=\"osobaDoKontaktu\" class=\"mt20\" ng-if=\"vmUm.umowy[0].dane.daneKontaktowe.OsDoKontaktuImie !== null && vmUm.umowy[0].dane.daneKontaktowe.OsDoKontaktuImie !== undefined\"><div class=\"row\"><div class=\"col-md-12\"><b>Osoba do kontaktu w sprawach ODO</b></div></div><div class=\"row\"><div class=\"col-md-6\">Imie i Nazwisko</div><div class=\"col-md-6\">{{vmUm.umowy[0].dane.daneKontaktowe.OsDoKontaktuImie + \" \" + vmUm.umowy[0].dane.daneKontaktowe.OsDoKontaktuNazwisko}}</div></div><div class=\"row\"><div class=\"col-md-6\">Email</div><div class=\"col-md-6\">{{vmUm.umowy[0].dane.daneKontaktowe.OsDoKontaktuEmail}}</div></div></div><div id=\"IOD\" class=\"mt20\" ng-if=\"vmUm.umowy[0].dane.daneKontaktowe.IODImie !== null && vmUm.umowy[0].dane.daneKontaktowe.IODImie !== undefined\"><div class=\"row\"><div class=\"col-md-12\"><b>Inspektor Ochrony Danych (jeśli Twoja firma powołała osobę na to stanowisko)</b></div></div><div class=\"row\"><div class=\"col-md-6\">Imie i Nazwisko</div><div class=\"col-md-6\">{{vmUm.umowy[0].dane.daneKontaktowe.IODImie + \" \" + vmUm.umowy[0].dane.daneKontaktowe.IODNazwisko}}</div></div><div class=\"row\"><div class=\"col-md-6\">Email</div><div class=\"col-md-6\">{{vmUm.umowy[0].dane.daneKontaktowe.IODEmail}}</div></div></div><div id=\"zawierajacy\" class=\"mt20\" ng-if=\"vmUm.umowy[0].dane.daneKontaktowe.WypelniajacyImie !== null && vmUm.umowy[0].dane.daneKontaktowe.WypelniajacyImie !== undefined\"><div class=\"row\"><div class=\"col-md-12\"><b>Umowa zawarta z konta</b></div></div><div class=\"row\"><div class=\"col-md-6\">Imie i Nazwisko</div><div class=\"col-md-6\">{{vmUm.umowy[0].dane.daneKontaktowe.WypelniajacyImie + \" \" + vmUm.umowy[0].dane.daneKontaktowe.WypelniajacyNazwisko}}</div></div><div class=\"row\"><div class=\"col-md-6\">Login</div><div class=\"col-md-6\">{{vmUm.umowy[0].dane.daneKontaktowe.WypelniajacyLogin}}</div></div></div></div><div class=\"row mt20\"><div class=\"col-md-12\"><a class=\"btn btn-default\" ng-if=\"vmUm.umowy[0].downloadURL !== null && vmUm.umowy[0].PDFInfo !== null\" href=\"{{vmUm.umowy[0].downloadURL}}\"><i class=\"fa fa-download\"></i> Pobierz Umowę</a></div></div><div class=\"row mt10\"><div class=\"col-md-12\"><a class=\"btn btn-default\" ng-if=\"vmUm.umowy[0].downloadUpowaznienieURL !== null\" href=\"{{vmUm.umowy[0].downloadUpowaznienieURL}}\"><i class=\"fa fa-download\"></i> Pobierz Pełnomocnictwo</a></div></div>");
$templateCache.put("app/home/umowy/uppdo/umowaWymagaAktualizacji.html","<div ng-if=\"vmUm.getStatus(umowa.id) === vmUm.statusy.wymagaAktualizacji\"><div><br><p>Aktualizacja umowy powierzenia przetwarzania danych osobowych jest sugerowana każdorazowo, gdy widoczny jest status <b>umowa wymaga aktualizacji</b>. Aktualizacja umowy możliwa jest również w przypadku zmiany po Państwa stronie danych kontaktowych do IOD lub osób odpowiedzialnych za realizację postanowień umowy.</p></div><div><p ng-repeat=\"zal in umowa.brakUmowyZalaczniki\">{{zal.nazwa}} <a target=\"_blank\" ng-repeat=\"ikona in zal.ikony\" href=\"{{ikona.url}}\"><i ng-if=\"ikona.typ === \'pdf\'\" class=\"fa fa-lg fa-file-pdf-o\" aria-hidden=\"true\"></i> <i ng-if=\"ikona.typ === \'docx\'\" class=\"fa fa-lg fa-file-word-o\" aria-hidden=\"true\"></i></a></p></div><div><p>Aktualizacja umowy wymaga zalogowania na <b>imienne konto pracownika</b> – w przypadku zalogowania na konto administracyjne <b>przycisk jest nieaktywny</b>. Jeśli nie posiadasz konta pracownika, utwórz je z zakładki: <i>Twoje konto> Konta pracowników</i>.</p><br><p>Przypominamy, że zawarcie (aktualizacja) umowy powierzenia dozwolone jest wyłącznie z imiennego konta pracownika upoważnionego do jednoosobowej reprezentacji podmiotu zgodnej z danymi w publicznych rejestrach (odpowiednio CEiDG/KRS) lub posiadającego pisemne pełnomocnictwo do zawierania tego typu umów w imieniu podmiotu.</p></div><div><span style=\"line-height: 23px;\">W celu rozpoczęcia aktualizacji umowy w zależności od sytuacji należy:</span><ul class=\"tight\"><li>zalogować się na istniejące i prawidłowo skonfigurowane konto pracownika upoważnionego do zawarcia umowy,</li><li>w przypadku braku ww. konta utworzyć i prawidłowo skonfigurować (z poziomu konta administracyjnego) imienne konto upoważnionego pracownika (uzupełnione pola: „imię”, „nazwisko” zgodnie z danymi osoby upoważnionej oraz nadanie uprawnienia „formularze”),</li><li>w przypadku niepełnej konfiguracji ww. konta zmodyfikować (z poziomu konta administracyjnego) już utworzone imienne konto pracownika (uzupełnione pola: „imię”, „nazwisko” zgodnie z danymi osoby upoważnionej oraz nadanie uprawnienia „formularze”).</li></ul></div><div><p>Jeśli nie posiadasz pełnomocnictwa do zawierania umów, skorzystaj z poniższego szablonu pełnomocnictwa – skan podpisanego dokumentu pełnomocnictwa będzie niezbędny w procesie podpisywania umowy.</p><p ng-repeat=\"zal in umowa.brakPelnomocnictwaZalaczniki\">{{zal.nazwa}} <a target=\"_blank\" ng-repeat=\"ikona in zal.ikony\" href=\"{{ikona.url}}\"><i ng-if=\"ikona.typ === \'pdf\'\" class=\"fa fa-lg fa-file-pdf-o\" aria-hidden=\"true\"></i> <i ng-if=\"ikona.typ === \'docx\'\" class=\"fa fa-lg fa-file-word-o\" aria-hidden=\"true\"></i></a></p></div></div>");
$templateCache.put("app/home/umowy/uppdo/uppdo.umowy.html","<div class=\"row\"><div class=\"col-md-12\"><h2>Umowa powierzenia przetwarzania danych osobowych</h2></div></div><div class=\"row\"><div class=\"{{vmUmUPPDO.bootstrapKlasa}}\"><ul class=\"breadcrumb\" style=\"margin-left: 0\"><li class=\"breadcrumb-item\" style=\"margin-bottom: 0\" ng-class=\"vmUmUPPDO.zakladka === 1 ? \'bolded\' : \'\'\" ng-click=\"vmUmUPPDO.zmienZakladkeBreadcrumbs(1)\" ng-style=\"(vmUmUPPDO.najwyzszaZakladka >= 1 && vmUmUPPDO.zakladka != 1) && {\'text-decoration\': \'underline\'}\">Dane osoby upoważnionej do zawarcia umowy</li><li class=\"breadcrumb-item\" style=\"margin-bottom: 0\" ng-class=\"vmUmUPPDO.zakladka === 2 ? \'bolded\' : \'\'\" ng-click=\"vmUmUPPDO.zmienZakladkeBreadcrumbs(2)\" ng-style=\"(vmUmUPPDO.najwyzszaZakladka >= 2 && vmUmUPPDO.zakladka != 2) && {\'text-decoration\': \'underline\'}\">Reprezentacja podmiotu</li><li class=\"breadcrumb-item\" style=\"margin-bottom: 0\" ng-class=\"vmUmUPPDO.zakladka === 3 ? \'bolded\' : \'\'\" ng-click=\"vmUmUPPDO.zmienZakladkeBreadcrumbs(3)\" ng-style=\"(vmUmUPPDO.najwyzszaZakladka >= 3 && vmUmUPPDO.zakladka != 3) && {\'text-decoration\': \'underline\'}\">Dane kontaktowe do spraw ochrony danych osobowych</li><li class=\"breadcrumb-item\" style=\"margin-bottom: 0\" ng-class=\"vmUmUPPDO.zakladka === 4 ? \'bolded\' : \'\'\" ng-style=\"(vmUmUPPDO.najwyzszaZakladka >= 4 && vmUmUPPDO.zakladka != 4) && {\'text-decoration\': \'underline\'}\" ng-click=\"vmUmUPPDO.zmienZakladkeBreadcrumbs(4)\">Akceptacja treści umowy</li></ul></div></div><ng-include src=\"\'app/home/umowy/uppdo/daneUzytkownikaForm.html\'\" ng-show=\"vmUmUPPDO.schowajZakladki === false && vmUmUPPDO.zakladka === 1\"></ng-include><ng-include src=\"\'app/home/umowy/uppdo/pelnomocnictwoForm.html\'\" ng-show=\"vmUmUPPDO.schowajZakladki === false && vmUmUPPDO.zakladka === 2\"></ng-include><ng-include src=\"\'app/home/umowy/uppdo/osobaKontaktowa.html\'\" ng-show=\"vmUmUPPDO.schowajZakladki === false && vmUmUPPDO.zakladka === 3\"></ng-include><ng-include src=\"\'app/home/umowy/uppdo/akceptacjaUmowy.html\'\" ng-show=\"vmUmUPPDO.schowajZakladki === false && vmUmUPPDO.zakladka === 4\"></ng-include>");
$templateCache.put("app/components/directives/konto/faktury/duplikatModal.html","<div ng-init=\"vmModal.init()\"><div class=\"modal-header\"><h4 class=\"modal-title\">Prośba o duplikat faktury {{vmModal.numerFaktury}}</h4></div><div class=\"modal-body\" style=\"height: 180px\"><obsluga-bledow wiadomosci-tablica=\"vmModal.odpowiedziSerwera\"></obsluga-bledow><div ng-if=\"vmModal.jestDostep == false\"><p>W celu przesłania prośby o duplikat faktury prosimy o zalogowanie się na konto pracownicze.<br><br><b>WAŻNE!</b> Konto pracownicze musi mieć nadane, przez administratora, uprawnienia do podglądu zakładki \"Faktury\".<br>Uprawnienia można przydzielić w zakłace Twoje konto <i class=\"fa fa-long-arrow-right\" aria-hidden=\"true\"></i> Konta pracowników.<br><br>Uprawnienia pracownikom można nadać <a ui-sref=\"home.subMain.konta_pracownikow\"><u>klikając tutaj</u></a>.</p></div><form name=\"form_copyRequest\" method=\"post\" ng-if=\"vmModal.jestDostep == true\"><div class=\"form-group\" ng-class=\"{\'has-error\' : form_copyRequest.contact.$invalid}\"><label for=\"person\">Imię i nazwisko</label> <input id=\"person\" name=\"contact\" type=\"text\" class=\"form-control\" ng-model=\"vmModal.klient\" required=\"\" style=\"display: inline-block\"><p style=\"{{(form_copyRequest.contact.$invalid) ?\'display: inline-block!important; color: red; font-size: 8px\':\'display:none\' }}\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : form_copyRequest.email.$invalid}\"><label for=\"email\">e-mail</label> <input name=\"email\" id=\"email\" type=\"email\" class=\"form-control\" ng-model=\"vmModal.pola.osDoKontaktuEmail\" required=\"\" style=\"display: inline-block\"><p style=\"{{(form_copyRequest.email.$invalid) ?\'display: inline-block!important; color: red; font-size: 8px\':\'display:none\' }}\">Pole wymagane</p></div><div class=\"form-group\" ng-class=\"{\'has-error\' : (form_copyRequest.phone.$invalid)}\"><label for=\"phone\">Telefon</label> <input name=\"phone\" id=\"phone\" type=\"text\" class=\"form-control\" pattern=\"[ 0-9-]{9,25}\" ng-model=\"vmModal.pola.osDoKontaktuTelefon\" required=\"\" style=\"display: inline-block\"><p style=\"{{(form_copyRequest.phone.$invalid) ?\'display: inline-block!important; color: red; font-size: 8px\':\'display:none\' }}\">Pole wymagane</p></div></form></div><div class=\"modal-footer bootstrap-iso-paper\"><button style=\"display: inline-block;\" ng-click=\"vmModal.modalOk()\" ng-disabled=\"form_copyRequest.$invalid\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-check\" aria-hidden=\"true\" ng-if=\"form_copyRequest.$valid\"></i> <span ng-if=\"vmModal.jestDostep\">Wyślij</span> <span ng-if=\"vmModal.jestDostep == false\">Przejdź do uprawnień</span></button> <button style=\"display: inline-block;\" ng-click=\"vmModal.modalClose()\" class=\"btn btn-default btn-sm\">Anuluj</button></div></div>");}]);